import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AblyTokenOutput = {
  __typename?: 'AblyTokenOutput';
  capability: Scalars['String']['output'];
  clientId?: Maybe<Scalars['String']['output']>;
  keyName: Scalars['String']['output'];
  mac: Scalars['String']['output'];
  nonce: Scalars['String']['output'];
  timestamp: Scalars['Float']['output'];
  ttl?: Maybe<Scalars['Float']['output']>;
};

export type AboutSectionBlock = LandingBlock & {
  __typename?: 'AboutSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  /** Locale → [String]; paragraphs */
  paragraphs?: Maybe<Scalars['JSON']['output']>;
  /** Locale → text */
  title?: Maybe<Scalars['JSON']['output']>;
};

export type ActivePeriod = {
  __typename?: 'ActivePeriod';
  isActivePeriod: Scalars['Boolean']['output'];
  totalMonths?: Maybe<Scalars['Float']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type ActiveSession = {
  __typename?: 'ActiveSession';
  createdAt: Scalars['DateTime']['output'];
  deviceInfo?: Maybe<Scalars['String']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isCurrent: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
};

export type AdditionalQuestion = {
  __typename?: 'AdditionalQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  askEachAthlete?: Maybe<Scalars['Boolean']['output']>;
  askOnlyOnce?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fieldOptions?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isHide?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<License>;
  order?: Maybe<Scalars['Int']['output']>;
  question?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategories?: Maybe<Array<CategorySetting>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Album = {
  __typename?: 'Album';
  albumCustomEvent?: Maybe<Scalars['String']['output']>;
  albumTags?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isAlbumPublic?: Maybe<Scalars['Boolean']['output']>;
  isSpecificTournament?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  media?: Maybe<Array<Media>>;
  platform?: Maybe<Platform>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  thumbnailFile?: Maybe<StorageFile>;
  thumbnailFileId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Albums = {
  __typename?: 'Albums';
  albums: Array<Album>;
  total: Scalars['Int']['output'];
};

/** Americano bye order for odd teams (RANDOM or WEAKEST_FIRST) */
export enum AmericanoByeOrder {
  Random = 'RANDOM',
  WeakestFirst = 'WEAKEST_FIRST'
}

/** Americano match pairing strategy (RANDOM or PROTECT_SEEDS) */
export enum AmericanoMatchStrategy {
  ProtectSeeds = 'PROTECT_SEEDS',
  Random = 'RANDOM'
}

export type AnnouncementComment = {
  __typename?: 'AnnouncementComment';
  announcement: TournamentAnnouncement;
  comment: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type AnnouncementLike = {
  __typename?: 'AnnouncementLike';
  announcement: TournamentAnnouncement;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  user?: Maybe<User>;
};

export type ApiKeyInfo = {
  __typename?: 'ApiKeyInfo';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  name: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Possible approval statuses for PurchasedLicense */
export enum ApprovalStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  ProofDeclined = 'PROOF_DECLINED',
  Validating = 'VALIDATING',
  WaitingForProof = 'WAITING_FOR_PROOF'
}

export type ApproveProposedResultInput = {
  id: Scalars['Int']['input'];
};

export type Athlete = {
  __typename?: 'Athlete';
  athlete?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AthleteAchievement = {
  __typename?: 'AthleteAchievement';
  activeFrom: Scalars['DateTime']['output'];
  activeTo: Scalars['DateTime']['output'];
  createdAt: Scalars['DateTime']['output'];
  entry: TournamentRegistration;
  external_id: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  league: League;
  place: Scalars['String']['output'];
  points: Scalars['Float']['output'];
  tournament: Tournament;
  tournamentCategory: TournamentCategory;
  updatedAt: Scalars['DateTime']['output'];
};

export type AthleteAchievementsByYear = {
  __typename?: 'AthleteAchievementsByYear';
  data: Array<AthleteAchievement>;
  year: Scalars['String']['output'];
};

export enum AthleteAnswerType {
  ClubReference = 'CLUB_REFERENCE',
  Date = 'DATE',
  Enum = 'ENUM',
  Number = 'NUMBER',
  Text = 'TEXT',
  UserReference = 'USER_REFERENCE'
}

export type AthleteQuestion = {
  __typename?: 'AthleteQuestion';
  allowedValues?: Maybe<Array<Scalars['String']['output']>>;
  answerType: AthleteAnswerType;
  autoField?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayOrder: Scalars['Int']['output'];
  icon: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  labelKey: Scalars['String']['output'];
  scope: AthleteQuestionScope;
  source: AthleteQuestionSource;
  sportAllowedValues?: Maybe<Scalars['JSON']['output']>;
  sports?: Maybe<Array<Sport>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type AthleteQuestionAnswer = {
  __typename?: 'AthleteQuestionAnswer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  question: AthleteQuestion;
  sport?: Maybe<Sport>;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  value?: Maybe<Scalars['String']['output']>;
};

export enum AthleteQuestionScope {
  Generic = 'GENERIC',
  Sport = 'SPORT'
}

export enum AthleteQuestionSource {
  Auto = 'AUTO',
  UserInput = 'USER_INPUT'
}

/** Selected wording for the `athlete` term. */
export enum AthleteTerm {
  Athlete = 'ATHLETE',
  Player = 'PLAYER'
}

export type AthleteTournamentStats = {
  __typename?: 'AthleteTournamentStats';
  activeTournamentNames?: Maybe<Array<TournamentName>>;
  activeTournaments?: Maybe<Scalars['Int']['output']>;
  allTournamentNames?: Maybe<Array<TournamentName>>;
  allTournaments?: Maybe<Scalars['Int']['output']>;
  leagues?: Maybe<Scalars['Int']['output']>;
  matches?: Maybe<MatchStats>;
  pastTournamentNames?: Maybe<Array<TournamentName>>;
  pastTournaments?: Maybe<Scalars['Int']['output']>;
  upcomingTournamentNames?: Maybe<Array<TournamentName>>;
  upcomingTournaments?: Maybe<Scalars['Int']['output']>;
  userWonTournaments?: Maybe<Scalars['Int']['output']>;
};

export enum AuditActionType {
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Delete = 'DELETE',
  SignIn = 'SIGN_IN',
  SignOut = 'SIGN_OUT',
  Unarchive = 'UNARCHIVE',
  Update = 'UPDATE'
}

export enum AuditEntityType {
  ApiKey = 'API_KEY',
  Banner = 'BANNER',
  Federation = 'FEDERATION',
  League = 'LEAGUE',
  License = 'LICENSE',
  Operator = 'OPERATOR',
  Organization = 'ORGANIZATION',
  OrganizationPlatformMember = 'ORGANIZATION_PLATFORM_MEMBER',
  Partner = 'PARTNER',
  PlatformDocument = 'PLATFORM_DOCUMENT',
  PurchasedLicense = 'PURCHASED_LICENSE',
  Tournament = 'TOURNAMENT',
  User = 'USER'
}

export type AuditLog = {
  __typename?: 'AuditLog';
  actionType: AuditActionType;
  actor?: Maybe<User>;
  actorEmail?: Maybe<Scalars['String']['output']>;
  actorId: Scalars['Int']['output'];
  actorName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entityId?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  entityType: AuditEntityType;
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  newValues?: Maybe<Scalars['JSON']['output']>;
  platformId?: Maybe<Scalars['Int']['output']>;
  previousValues?: Maybe<Scalars['JSON']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
};

export type AuditLogFilterInput = {
  actionType?: InputMaybe<AuditActionType>;
  actorId?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  entityType?: InputMaybe<AuditEntityType>;
  /** Deprecated — use `platformPublicId` instead. Numeric ids will be removed once the dashboard cuts over to REST. */
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AuditLogResult = {
  __typename?: 'AuditLogResult';
  items: Array<AuditLog>;
  total: Scalars['Int']['output'];
};

export type AuthMethod = {
  __typename?: 'AuthMethod';
  id: Scalars['Int']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: AuthMethodName;
  platform?: Maybe<Array<Platform>>;
};

export enum AuthMethodName {
  Apple = 'APPLE',
  Email = 'EMAIL',
  Eparaksts = 'EPARAKSTS',
  Google = 'GOOGLE',
  Phone = 'PHONE',
  Wechat = 'WECHAT',
  Wpr = 'WPR'
}

export type AutoPairTournamentRegistrationsInput = {
  categoryId: Scalars['Int']['input'];
  isPairRanking?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartner: Scalars['Boolean']['input'];
  status: Scalars['String']['input'];
  tournament: Scalars['Int']['input'];
  type: Scalars['String']['input'];
};

/** A federation the calling user has anything to do with — picker-shape projection of Federation. */
export type AvailableFederation = {
  __typename?: 'AvailableFederation';
  about?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  geographicScope?: Maybe<GeographicScope>;
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<OrganizationType>;
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  website?: Maybe<Scalars['String']['output']>;
};

/** A platform the calling user has anything to do with — picker-shape projection of Platform. */
export type AvailablePlatform = {
  __typename?: 'AvailablePlatform';
  country?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customFee?: Maybe<Array<PlatformFee>>;
  darkEmblem?: Maybe<Scalars['String']['output']>;
  darkLogo?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lightEmblem?: Maybe<Scalars['String']['output']>;
  lightLogo?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Federation>;
  partnerEntryFee?: Maybe<Scalars['Float']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  platformLink?: Maybe<Scalars['String']['output']>;
  platformSetting?: Maybe<PlatformSetting>;
  platformType?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Array<PlateformSport>>;
  status?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedEntryFee?: Maybe<Scalars['Float']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  uploadFile?: Maybe<Scalars['String']['output']>;
};

export type Banner = {
  __typename?: 'Banner';
  buttonLink?: Maybe<Scalars['String']['output']>;
  buttonText?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  headLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  images?: Maybe<Scalars['String']['output']>;
  imagesFile?: Maybe<StorageFile>;
  imagesFileId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sports?: Maybe<Array<Sport>>;
  status?: Maybe<Scalars['String']['output']>;
  subHeadLine?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BannerBlock = LandingBlock & {
  __typename?: 'BannerBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type BannerHeroBlock = LandingBlock & {
  __typename?: 'BannerHeroBlock';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  buttons?: Maybe<Array<BannerHeroButton>>;
  /** Locale → { title, description } */
  content?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BannerHeroButton = {
  __typename?: 'BannerHeroButton';
  href: Scalars['String']['output'];
  /** Locale → label text */
  label: Scalars['JSON']['output'];
  /** "primary" | "secondary" */
  variant?: Maybe<Scalars['String']['output']>;
};

export type BannerNew = {
  __typename?: 'BannerNew';
  buttonLink: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  headLine: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageFiles?: Maybe<Array<StorageFileOutput>>;
  legacyImages: Array<Scalars['String']['output']>;
  primaryColor: Scalars['String']['output'];
  roles: Array<BannerRole>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sports?: Maybe<Array<Sport>>;
  status: BannerStatus;
  subHeadLine?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BannerPublic = {
  __typename?: 'BannerPublic';
  buttonLink: Scalars['String']['output'];
  buttonText: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  headLine: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  imageFiles?: Maybe<Array<StorageFileOutput>>;
  legacyImages: Array<Scalars['String']['output']>;
  primaryColor: Scalars['String']['output'];
  roles: Array<BannerRole>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sports?: Maybe<Array<Sport>>;
  status: BannerStatus;
  subHeadLine?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum BannerRole {
  Athlete = 'ATHLETE',
  ClubManager = 'CLUB_MANAGER',
  ClubOwner = 'CLUB_OWNER',
  FederationMember = 'FEDERATION_MEMBER',
  Guest = 'GUEST',
  Other = 'OTHER',
  Referee = 'REFEREE',
  SportFan = 'SPORT_FAN',
  TournamentOrganizer = 'TOURNAMENT_ORGANIZER'
}

export enum BannerStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Format like swiss, americano, mexicano, etc. */
export enum BlockType {
  Americano = 'AMERICANO',
  Knockout = 'KNOCKOUT',
  Mexicano = 'MEXICANO',
  RoundRobin = 'ROUND_ROBIN',
  Swiss = 'SWISS',
  WinnersCourt = 'WINNERS_COURT'
}

export type BoardMember = {
  __typename?: 'BoardMember';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFile>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  role: OrganizationMemberRole;
  surname: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type BookingForm = {
  __typename?: 'BookingForm';
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notifications?: Maybe<Array<Notification>>;
  pageUrl: Scalars['String']['output'];
  platform?: Maybe<Platform>;
  platformId: Scalars['Int']['output'];
  topic?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type BulkAssignLicenseDataInput = {
  activeFrom: Scalars['String']['input'];
  activeTo: Scalars['String']['input'];
  athleteFullName?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  licenseId?: InputMaybe<Scalars['String']['input']>;
  licenseName?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type BulkAssignLicenseResponse = {
  __typename?: 'BulkAssignLicenseResponse';
  message: Scalars['String']['output'];
  skipped?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type BulkAssignLicensesInput = {
  createUserIfNotFound: Scalars['Boolean']['input'];
  data: Array<BulkAssignLicenseDataInput>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
};

export type BulkBannerUpdateLegacyItem = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type BulkFormatOopResult = {
  __typename?: 'BulkFormatOopResult';
  errors: Array<BulkOopBlockError>;
  lastMatchEndTime?: Maybe<Scalars['String']['output']>;
  scheduledMatches: Scalars['Int']['output'];
};

export type BulkOopBlockError = {
  __typename?: 'BulkOopBlockError';
  blockId: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type BulkRemoveLicenseInput = {
  licenseIds: Array<Scalars['Int']['input']>;
};

export type BulkUpdateLicenseInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  isAllowedToPurchaseOnTournated?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  licenseIds: Array<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CatalogLicenseStatus>;
};

export type BulletListBlock = PostBlock & {
  __typename?: 'BulletListBlock';
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  items: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** How to assign byes */
export enum ByePolicy {
  Highest = 'HIGHEST',
  Lowest = 'LOWEST',
  Middle = 'MIDDLE',
  Random = 'RANDOM'
}

export type CalculatePaymentInput = {
  openId?: InputMaybe<Scalars['String']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CalloutBlock = PostBlock & {
  __typename?: 'CalloutBlock';
  body: Scalars['String']['output'];
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  variant: CalloutVariant;
};

export enum CalloutVariant {
  Info = 'INFO',
  Success = 'SUCCESS',
  Tip = 'TIP',
  Warning = 'WARNING'
}

/** Status of License */
export enum CatalogLicenseStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type Category = {
  __typename?: 'Category';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageLimit?: Maybe<Scalars['Float']['output']>;
  ageLimitType?: Maybe<Scalars['String']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  categoryRules?: Maybe<Array<CategoryRule>>;
  countAllTournament?: Maybe<Scalars['Boolean']['output']>;
  countries?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fixedPoints?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isDisplayBirthYear?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isTeamRanking?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Array<License>>;
  maxTournaments?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onlyThirdPartyRanking?: Maybe<Scalars['Boolean']['output']>;
  penalty?: Maybe<Scalars['Boolean']['output']>;
  penaltyRule?: Maybe<Scalars['String']['output']>;
  selectStage?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['String']['output']>;
  specificTournament?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  timePeriod?: Maybe<Scalars['String']['output']>;
  tournamentCatgories?: Maybe<Array<RankingTournamentCategory>>;
  tournaments?: Maybe<Array<CategoryTournament>>;
  type?: Maybe<Scalars['String']['output']>;
  uniqueCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryPaymentInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  alreayExist?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  leagueTitle?: InputMaybe<Scalars['String']['input']>;
  licenseTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onSiteAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  purchasedLicenseId?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  yearsToAdd?: InputMaybe<Scalars['Int']['input']>;
};

export type CategoryPaymentResult = {
  __typename?: 'CategoryPaymentResult';
  appliedVAT: Scalars['Float']['output'];
  categoryId: Scalars['Int']['output'];
  discount: Scalars['Float']['output'];
  discountIds?: Maybe<Array<Scalars['String']['output']>>;
  discountObjects?: Maybe<Array<DiscountDetail>>;
  discountPartner: Scalars['Float']['output'];
  discountPercent: Scalars['Float']['output'];
  discountedOnlineFee: Scalars['Float']['output'];
  discountedOnsiteFee: Scalars['Float']['output'];
  isOnSiteOnly?: Maybe<Scalars['Boolean']['output']>;
  onSiteAmountAndAdditionalFee: Scalars['Float']['output'];
  onSiteAppliedVAT?: Maybe<Scalars['Float']['output']>;
  onSiteDiscount: Scalars['Float']['output'];
  onSitePartnerDiscountedAmount: Scalars['Float']['output'];
  onsiteDiscountPartner: Scalars['Float']['output'];
  originalAmount: Scalars['Float']['output'];
  originalOnsiteAmount: Scalars['Float']['output'];
  parnterDiscoutedRegAmount: Scalars['Float']['output'];
  partnerDiscountObjects?: Maybe<Array<DiscountDetail>>;
  partnerDiscountPercent: Scalars['Float']['output'];
  partnerFee: Scalars['Float']['output'];
  partnerPartnerFee: Scalars['Float']['output'];
  partnerServiceFee: Scalars['Float']['output'];
  paymentMethod?: Maybe<Scalars['String']['output']>;
  player1: PlayerFeeBreakdown;
  player2?: Maybe<PlayerFeeBreakdown>;
  promo?: Maybe<Scalars['String']['output']>;
  registrationRequestId: Scalars['Int']['output'];
  stripeFee?: Maybe<Scalars['Float']['output']>;
  teamMembersData?: Maybe<Array<TeamMemberFeeBreakdown>>;
  totalPayment: Scalars['Float']['output'];
  totalPlatformFee: Scalars['Float']['output'];
  totalRegistrationAmount: Scalars['Float']['output'];
  tournatedServiceFee: Scalars['Float']['output'];
  tournatedServiceFeeBeforeUSPAWPRFee: Scalars['Float']['output'];
  tournatedServiceFeeVAT21Per: Scalars['Float']['output'];
  vatFeeValue: Scalars['Float']['output'];
};

export type CategoryRule = {
  __typename?: 'CategoryRule';
  category?: Maybe<Category>;
  coefficient?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  enableMaxPointTotal?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  licenseSubtypes?: Maybe<Scalars['String']['output']>;
  maxPointTotal?: Maybe<Scalars['Float']['output']>;
  numberOfTournaments?: Maybe<Scalars['Int']['output']>;
  placeMultipliers?: Maybe<Array<PlaceMultiplier>>;
  placeMultipliersJson?: Maybe<Scalars['String']['output']>;
  sector?: Maybe<Scalars['String']['output']>;
  subRuleCategories?: Maybe<Array<TournamentCategory>>;
  thirdPartyLicense?: Maybe<ThirdPartyLicense>;
  tournamentCategories?: Maybe<Array<TournamentCategory>>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategorySetting = {
  __typename?: 'CategorySetting';
  addMatchWonPoints?: Maybe<Scalars['Float']['output']>;
  addPointsScore?: Maybe<Scalars['Float']['output']>;
  addSetWonPoints?: Maybe<Scalars['Float']['output']>;
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  category?: Maybe<TournamentCategory>;
  categorySettingsGroup?: Maybe<CategorySettingsGroup>;
  color?: Maybe<Scalars['String']['output']>;
  considerOnlyPaidRequestsInLimits?: Maybe<Scalars['Boolean']['output']>;
  considerRequestsInLimits?: Maybe<Scalars['Boolean']['output']>;
  consolation?: Maybe<Scalars['Boolean']['output']>;
  count?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  defaultTeamMatches?: Maybe<Array<DefaultTeamMatch>>;
  extraTime?: Maybe<Scalars['Float']['output']>;
  fee?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Float']['output'];
  isAllowPlayerScoreSubmission?: Maybe<Scalars['Boolean']['output']>;
  isAllowRosterSubmission?: Maybe<Scalars['Boolean']['output']>;
  isAllowScoreSubmission?: Maybe<Scalars['Boolean']['output']>;
  isDisplayBirthYear?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isDisplayPoints?: Maybe<Scalars['Boolean']['output']>;
  isDisplayRank?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  isPlayerScoreAutoConfirm?: Maybe<Scalars['Boolean']['output']>;
  isRegistered?: Maybe<Scalars['Boolean']['output']>;
  isRosterAutoConfirm?: Maybe<Scalars['Boolean']['output']>;
  isScoreAutoConfirm?: Maybe<Scalars['Boolean']['output']>;
  isVATAmount?: Maybe<Scalars['Boolean']['output']>;
  mde?: Maybe<Scalars['Float']['output']>;
  mds?: Maybe<Scalars['Float']['output']>;
  mdwc?: Maybe<Scalars['Float']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  moveToSingle?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['String']['output']>;
  onsiteFee?: Maybe<Scalars['Int']['output']>;
  pairing?: Maybe<Scalars['String']['output']>;
  partnersCount?: Maybe<Scalars['Float']['output']>;
  paymentCalculations?: Maybe<Array<PaymentCalculation>>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  penaltyPoints?: Maybe<Scalars['Float']['output']>;
  pointsForLoss?: Maybe<Scalars['Float']['output']>;
  pointsForTie?: Maybe<Scalars['Float']['output']>;
  pointsForWin?: Maybe<Scalars['Float']['output']>;
  qe?: Maybe<Scalars['Float']['output']>;
  qs?: Maybe<Scalars['Float']['output']>;
  qwc?: Maybe<Scalars['Float']['output']>;
  registrationLimit?: Maybe<Scalars['Float']['output']>;
  registrationRequests?: Maybe<Array<TournamentRegistration>>;
  rounds?: Maybe<Scalars['Int']['output']>;
  service?: Maybe<Scalars['Int']['output']>;
  singleCategory?: Maybe<CategorySetting>;
  sortBy: Scalars['String']['output'];
  sortOrder: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  timeAfterMove?: Maybe<Scalars['Float']['output']>;
  timePerMove?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  vatAmount?: Maybe<Scalars['Float']['output']>;
};

export type CategorySettingsGroup = {
  __typename?: 'CategorySettingsGroup';
  categorySetting?: Maybe<Array<CategorySetting>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type CategoryTournament = {
  __typename?: 'CategoryTournament';
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChangePasswordInput = {
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  signOutOtherSessions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChangePasswordResult = {
  __typename?: 'ChangePasswordResult';
  signInMethods: MySignInMethodsResult;
  signedOutSessions: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type ChatChannelOutput = {
  __typename?: 'ChatChannelOutput';
  /** Category id for category rooms */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** Category name for category rooms */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Ably room id (also the channel base name) */
  id: Scalars['String']['output'];
  /** Optional room avatar/cover image */
  image?: Maybe<Scalars['String']['output']>;
  /** Room kind: "main" | "category" */
  kind: Scalars['String']['output'];
  /** When the last message landed */
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** Last message author's display name */
  lastMessageAuthor?: Maybe<Scalars['String']['output']>;
  /** Short snippet of the last message */
  lastMessageText?: Maybe<Scalars['String']['output']>;
  /** Human-readable room name */
  name: Scalars['String']['output'];
  /** For DM rooms: the other user id */
  peerId?: Maybe<Scalars['String']['output']>;
  /** Set when the caller is "removed" or "blocked" — room is locked (no access) */
  restricted?: Maybe<Scalars['String']['output']>;
};

export type ChatDiscoverableTournamentOutput = {
  __typename?: 'ChatDiscoverableTournamentOutput';
  image?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  title: Scalars['String']['output'];
  tournamentId: Scalars['Int']['output'];
};

export enum ChatDmEmails {
  Always = 'ALWAYS',
  Away = 'AWAY',
  Off = 'OFF'
}

export type ChatInboxOutput = {
  __typename?: 'ChatInboxOutput';
  /** Standalone DMs not tied to a tournament (user-to-user, future) */
  directs: Array<ChatChannelOutput>;
  groups: Array<TournamentChatGroup>;
};

export type ChatMemberStateOutput = {
  __typename?: 'ChatMemberStateOutput';
  blocked: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  removed: Scalars['Boolean']['output'];
  selfLeft: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type ChatRosterEntryOutput = {
  __typename?: 'ChatRosterEntryOutput';
  /** Platform user id (the Ably clientId) */
  id: Scalars['String']['output'];
  /** Avatar url */
  image?: Maybe<Scalars['String']['output']>;
  /** Display name */
  name: Scalars['String']['output'];
};

export type ChatThreadCategoryOutput = {
  __typename?: 'ChatThreadCategoryOutput';
  name: Scalars['String']['output'];
  /** Co-players in this entry, excluding the participant (doubles partner etc.) */
  partners: Array<Scalars['String']['output']>;
  /** Payment status, if any */
  paymentStatus?: Maybe<Scalars['String']['output']>;
  /** Registration status (e.g. confirm) */
  status: Scalars['String']['output'];
  /** Team name, for team categories */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Doubles registration made without a partner */
  withoutPartner: Scalars['Boolean']['output'];
};

export type ChatThreadInfoOutput = {
  __typename?: 'ChatThreadInfoOutput';
  avatar?: Maybe<Scalars['String']['output']>;
  /** Categories the participant is confirmed in */
  categories: Array<ChatThreadCategoryOutput>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  participantId: Scalars['String']['output'];
};

export type ChatUnreadEntryOutput = {
  __typename?: 'ChatUnreadEntryOutput';
  mentioned: Scalars['Boolean']['output'];
  muted: Scalars['Boolean']['output'];
  roomId: Scalars['String']['output'];
  unread: Scalars['Int']['output'];
};

export type CheckoutSessionResult = {
  __typename?: 'CheckoutSessionResult';
  id: Scalars['ID']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentParams?: Maybe<Scalars['JSON']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Club = {
  __typename?: 'Club';
  address?: Maybe<Scalars['String']['output']>;
  /** Tournament location coordinates with latitude and longitude */
  addressCoordinates?: Maybe<Scalars['JSON']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clubMainAdministrator?: Maybe<User>;
  clubName?: Maybe<Scalars['String']['output']>;
  clubServices?: Maybe<Array<ClubService>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Federation>;
  federations?: Maybe<Array<Federation>>;
  howToFindUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  isAdminVerificationRequired?: Maybe<Scalars['Boolean']['output']>;
  isAthleteClub?: Maybe<Scalars['Boolean']['output']>;
  isEnableEmail?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFile>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<ClubMember>>;
  membersStats?: Maybe<ClubMemberStats>;
  news?: Maybe<Array<ClubNews>>;
  /** @deprecated Use `platforms` instead. Returns the first accessible platform. */
  platform?: Maybe<Platform>;
  platforms?: Maybe<Array<Platform>>;
  sports?: Maybe<Array<Sport>>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  tikTok?: Maybe<Scalars['String']['output']>;
  tournamentCount?: Maybe<Scalars['Int']['output']>;
  tournaments?: Maybe<Array<Tournament>>;
  tournamentsCount?: Maybe<Scalars['Int']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Monolith_ClubType>;
  updatedAt: Scalars['DateTime']['output'];
  venueCount?: Maybe<Scalars['Int']['output']>;
  venues?: Maybe<Array<TournamentVenue>>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ClubAdministrator = {
  __typename?: 'ClubAdministrator';
  administrator?: Maybe<User>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubCoach = {
  __typename?: 'ClubCoach';
  club?: Maybe<Club>;
  coach?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubListInput = {
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  membersFrom?: InputMaybe<Scalars['Int']['input']>;
  membersTo?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ClubListOrderBy>;
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentsCountFrom?: InputMaybe<Scalars['Int']['input']>;
  tournamentsCountTo?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<Monolith_ClubType>>;
};

export enum ClubListOrderBy {
  MembersCountAsc = 'MEMBERS_COUNT_ASC',
  MembersCountDesc = 'MEMBERS_COUNT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TournamentsCountAsc = 'TOURNAMENTS_COUNT_ASC',
  TournamentsCountDesc = 'TOURNAMENTS_COUNT_DESC'
}

export type ClubListResult = {
  __typename?: 'ClubListResult';
  clubs: Array<Club>;
  total: Scalars['Int']['output'];
};

export type ClubMember = {
  __typename?: 'ClubMember';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export enum ClubMemberApprovalStatus {
  Confirm = 'CONFIRM',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type ClubMemberListFilterInput = {
  clubId: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 0-based page index. page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClubMemberApprovalStatus>;
};

export type ClubMemberResult = {
  __typename?: 'ClubMemberResult';
  clubMembers: Array<ClubMember>;
  total: Scalars['Int']['output'];
};

export type ClubMemberStats = {
  __typename?: 'ClubMemberStats';
  approved: Scalars['Int']['output'];
  declined: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ClubNews = {
  __typename?: 'ClubNews';
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubResult = {
  __typename?: 'ClubResult';
  club: Array<Club>;
  total: Scalars['Int']['output'];
};

export type ClubService = {
  __typename?: 'ClubService';
  club?: Maybe<Club>;
  clubServiceResource?: Maybe<Array<ClubServiceResource>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  services?: Maybe<ResourceService>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ClubServiceResource = {
  __typename?: 'ClubServiceResource';
  club?: Maybe<Club>;
  clubService?: Maybe<ClubService>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  services?: Maybe<ResourceService>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Specific competition label (e.g. "National Adult Championship"). Optional. Prefixes are client-agnostic: WORLD_*, CONTINENTAL_* (e.g. European), REGIONAL_* (multi-country, e.g. Baltic), NATIONAL_* (single country). FE picks localized labels per client/country. */
export enum CompetitionLevel {
  AmateurSportCompetition = 'AMATEUR_SPORT_COMPETITION',
  ContinentalAdultChampionship = 'CONTINENTAL_ADULT_CHAMPIONSHIP',
  ContinentalChampionshipQualification = 'CONTINENTAL_CHAMPIONSHIP_QUALIFICATION',
  ContinentalCup = 'CONTINENTAL_CUP',
  ContinentalJuniorChampionship = 'CONTINENTAL_JUNIOR_CHAMPIONSHIP',
  ContinentalYouthChampionship = 'CONTINENTAL_YOUTH_CHAMPIONSHIP',
  InternationalCompetition = 'INTERNATIONAL_COMPETITION',
  NationalAdultChampionship = 'NATIONAL_ADULT_CHAMPIONSHIP',
  NationalCup = 'NATIONAL_CUP',
  NationalJuniorChampionship = 'NATIONAL_JUNIOR_CHAMPIONSHIP',
  NationalOlympiad = 'NATIONAL_OLYMPIAD',
  NationalStudentChampionship = 'NATIONAL_STUDENT_CHAMPIONSHIP',
  NationalUniversiade = 'NATIONAL_UNIVERSIADE',
  NationalUniversityChampionship = 'NATIONAL_UNIVERSITY_CHAMPIONSHIP',
  NationalYouthChampionship = 'NATIONAL_YOUTH_CHAMPIONSHIP',
  OlympicGamesQualification = 'OLYMPIC_GAMES_QUALIFICATION',
  Other = 'OTHER',
  OtherCountryLevel = 'OTHER_COUNTRY_LEVEL',
  RegionalLevel = 'REGIONAL_LEVEL',
  SeniorVeteranCompetition = 'SENIOR_VETERAN_COMPETITION',
  WorldAdultChampionship = 'WORLD_ADULT_CHAMPIONSHIP',
  WorldChampionshipQualification = 'WORLD_CHAMPIONSHIP_QUALIFICATION',
  WorldCup = 'WORLD_CUP',
  WorldCupQualification = 'WORLD_CUP_QUALIFICATION',
  WorldJuniorChampionship = 'WORLD_JUNIOR_CHAMPIONSHIP',
  WorldYouthChampionship = 'WORLD_YOUTH_CHAMPIONSHIP'
}

/** The type of competition for a tournament */
export enum CompetitionType {
  Camp = 'CAMP',
  Clinic = 'CLINIC',
  LeagueStage = 'LEAGUE_STAGE',
  Other = 'OTHER',
  Tournament = 'TOURNAMENT'
}

export type ContactSectionBlock = LandingBlock & {
  __typename?: 'ContactSectionBlock';
  /** Locale → text */
  description?: Maybe<Scalars['JSON']['output']>;
  /** Optional contact email for the section */
  forwardToEmail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /** Locale → text; required for block to show */
  title?: Maybe<Scalars['JSON']['output']>;
  /** Locale → [String]; topic dropdown options */
  topicOptions?: Maybe<Scalars['JSON']['output']>;
};

export type CountSportFishingEntriesMetric = {
  __typename?: 'CountSportFishingEntriesMetric';
  confirmed?: Maybe<Scalars['Int']['output']>;
  pending?: Maybe<Scalars['Int']['output']>;
  rejected?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Court = {
  __typename?: 'Court';
  allowAttachingMediaContent?: Maybe<Scalars['Boolean']['output']>;
  allowParticipantsToAddResults?: Maybe<Scalars['Boolean']['output']>;
  attachmentsStatus?: Maybe<Scalars['String']['output']>;
  autoConfirmSubmittedResults?: Maybe<Scalars['Boolean']['output']>;
  bestResultsLimit?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  generalLimit?: Maybe<Scalars['Float']['output']>;
  hideOtherParticipantResults?: Maybe<Scalars['Boolean']['output']>;
  hideResultsType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  individualMetricLimit?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  liveStreamingLink?: Maybe<Scalars['String']['output']>;
  liveStreamings?: Maybe<Array<LiveStreaming>>;
  metricContext?: Maybe<Array<SportFishingMetricContext>>;
  metrics?: Maybe<Array<SportFishingMatric>>;
  name?: Maybe<Scalars['String']['output']>;
  requiredMediaToUploadResult?: Maybe<Scalars['Boolean']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submissionType?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  venue?: Maybe<TournamentVenue>;
};

export type CreateAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAmericanoBlockInput = {
  byeCountsAsWins?: InputMaybe<Scalars['Boolean']['input']>;
  byeOrder?: InputMaybe<AmericanoByeOrder>;
  byePointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  fixedNumber?: InputMaybe<Scalars['Int']['input']>;
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  matchStrategy?: InputMaybe<AmericanoMatchStrategy>;
  pairingMode: Scalars['String']['input'];
  participantRangeFrom?: InputMaybe<Scalars['Int']['input']>;
  participantRangeTo?: InputMaybe<Scalars['Int']['input']>;
  pointsForDraw?: InputMaybe<Scalars['Float']['input']>;
  pointsForLoss?: InputMaybe<Scalars['Float']['input']>;
  pointsForWin?: InputMaybe<Scalars['Float']['input']>;
  seededPlayerCount?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  shuffleMatches?: InputMaybe<Scalars['Boolean']['input']>;
  sortingRules?: InputMaybe<Array<Scalars['String']['input']>>;
  teamFormationStrategy?: InputMaybe<TeamFormationStrategy>;
  title: Scalars['String']['input'];
  totalRounds: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};

export type CreateAnnouncementCommentInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAuthMethodInput = {
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name: AuthMethodName;
};

export type CreateBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  imageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status: Scalars['String']['input'];
  subHeadLine: Scalars['String']['input'];
};

export type CreateBannerInputNew = {
  buttonLink: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  headLine: Scalars['String']['input'];
  imageFileIds: Array<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor: Scalars['String']['input'];
  roles: Array<BannerRole>;
  sports: Array<Scalars['Int']['input']>;
  status: BannerStatus;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBulkFormatOopInput = {
  blocks: Array<Scalars['Int']['input']>;
  courts: Array<Scalars['Int']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  matchDurationMinutes: Scalars['Int']['input'];
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  rounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamRanking?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryRuleInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  enableMaxPointTotal?: InputMaybe<Scalars['Boolean']['input']>;
  licenseSubtypes?: InputMaybe<Scalars['String']['input']>;
  maxPointTotal?: InputMaybe<Scalars['Int']['input']>;
  numberOfTournaments?: InputMaybe<Scalars['Int']['input']>;
  placeMultipliers?: InputMaybe<Array<PlaceMultiplierInput>>;
  sector?: InputMaybe<Scalars['String']['input']>;
  subRuleCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateCategorySettingInput = {
  addMatchWonPoints?: InputMaybe<Scalars['Int']['input']>;
  addPointsScore?: InputMaybe<Scalars['Int']['input']>;
  addSetWonPoints?: InputMaybe<Scalars['Int']['input']>;
  category: Scalars['Int']['input'];
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  considerOnlyPaidRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  considerRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  isAllowPlayerScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowRosterSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isPlayerScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isRosterAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method: Scalars['String']['input'];
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  penaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  pointsForLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsForTie?: InputMaybe<Scalars['Int']['input']>;
  pointsForWin?: InputMaybe<Scalars['Int']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateCategorySettingsGroupInput = {
  categorySetting?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCategoryTournamentInput = {
  category: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
};

export type CreateClubAdministratorInput = {
  administrator: Scalars['Int']['input'];
  club: Scalars['Int']['input'];
};

export type CreateClubCoachInput = {
  club: Scalars['Int']['input'];
  coach: Scalars['Int']['input'];
};

export type CreateClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator: Scalars['Int']['input'];
  clubName: Scalars['String']['input'];
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Monolith_ClubType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubMemberInput = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['Int']['input'];
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubNewsInput = {
  club: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
};

export type CreateClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClubsServiceInput = {
  club: Scalars['Int']['input'];
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreamingLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredMediaToUploadResult?: InputMaybe<Scalars['Boolean']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};

export type CreateDefaultTeamMatchInput = {
  category: Scalars['Float']['input'];
  gender: Scalars['String']['input'];
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateDisciplineInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform: Scalars['Int']['input'];
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDisplaySettingInput = {
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstMatchLosersToConsolationDraw?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDrawScoreInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateFactSheetInput = {
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateFederationInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Opaque public id of an existing federation (e.g. fed_abc123) to attach the new platform to. */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<OrganizationType>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFederationLeagueInput = {
  federation: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateFederationNewsInput = {
  federation: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
  platform: Scalars['Int']['input'];
};

export type CreateFormatOopInput = {
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  matchDurationMinutes?: InputMaybe<Scalars['Int']['input']>;
  matchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group: Scalars['Int']['input'];
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory: Scalars['Int']['input'];
};

export type CreateGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
  tournamentCategory: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  tempScore?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateImageInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateLandingInput = {
  landingAbbr?: InputMaybe<Scalars['String']['input']>;
  landingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  landingCountry?: InputMaybe<Scalars['String']['input']>;
  landingCustomPlatform?: InputMaybe<Scalars['String']['input']>;
  landingHeadline?: InputMaybe<Scalars['String']['input']>;
  landingHeroLayout?: InputMaybe<Scalars['String']['input']>;
  landingLang?: InputMaybe<Scalars['String']['input']>;
  landingLayout?: InputMaybe<Scalars['String']['input']>;
  landingLocations?: InputMaybe<Scalars['String']['input']>;
  landingLogo?: InputMaybe<Scalars['String']['input']>;
  landingLogoDark?: InputMaybe<Scalars['String']['input']>;
  landingOrganizations?: InputMaybe<Scalars['String']['input']>;
  landingPrimary?: InputMaybe<Scalars['String']['input']>;
  landingPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSubtitle?: InputMaybe<Scalars['String']['input']>;
  landingSupportedSports?: InputMaybe<Scalars['String']['input']>;
  landingTeamPages?: InputMaybe<Scalars['String']['input']>;
  landingTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLandingMemberInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  show_on_pages?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLandingPotmInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last_updated?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLandingRoadmapInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  item1?: InputMaybe<Scalars['String']['input']>;
  item2?: InputMaybe<Scalars['String']['input']>;
  item3?: InputMaybe<Scalars['String']['input']>;
  item4?: InputMaybe<Scalars['String']['input']>;
  item5?: InputMaybe<Scalars['String']['input']>;
  item6?: InputMaybe<Scalars['String']['input']>;
  item7?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLandingSliderInput = {
  button?: InputMaybe<Scalars['String']['input']>;
  date_added?: InputMaybe<Scalars['String']['input']>;
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateLeagueCategoryInput = {
  category: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  allowUnregisteredPlayers?: InputMaybe<Scalars['Boolean']['input']>;
  bannerCover?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_full_name?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  globalCategoryLimitPerPlayer?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isCustomFeeEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  requireTournamentApproval?: InputMaybe<Scalars['Boolean']['input']>;
  socialLinks?: InputMaybe<Array<LeagueSocialLinkInput>>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tourType?: InputMaybe<TourType>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<LeagueGeoScope>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLeagueMemberInput = {
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  member: Scalars['Int']['input'];
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateLeagueMemberRoleInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueMember?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueNewsInput = {
  league: Scalars['Int']['input'];
  news: Scalars['Int']['input'];
};

export type CreateLeagueOwnerInput = {
  federation: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLeagueTournamentCategoryInput = {
  category: Scalars['Int']['input'];
  league: Scalars['Int']['input'];
};

export type CreateLeagueTournamentInput = {
  league: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
};

export type CreateLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  alternateTitle?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  englishTitle?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  fee: Scalars['Float']['input'];
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  isAllowedToPurchaseOnTournated?: InputMaybe<Scalars['Boolean']['input']>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isPlatformGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isSendNotificationsToManager?: InputMaybe<Scalars['Boolean']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  licenseManager?: InputMaybe<Scalars['Int']['input']>;
  /** Optional override address for manager notifications. When set, EMAIL-channel notifications for this license route here instead of the license manager's account email. */
  managerContactEmail?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated — use `platformPublicId` instead. Numeric ids will be removed once the dashboard cuts over to REST. */
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  type?: LicenseType;
};

export type CreateLicenseLeagueInput = {
  league: Scalars['Int']['input'];
  license: Scalars['Int']['input'];
};

export type CreateLicensePaymentInput = {
  alreayExist?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  leagueTitle?: InputMaybe<Scalars['String']['input']>;
  licenseId?: InputMaybe<Scalars['Int']['input']>;
  licenseTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  purchasedLicenseId?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  yearsToAdd?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLicenseQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLiveStandingInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  highlightFrom?: InputMaybe<Scalars['Float']['input']>;
  highlightTo?: InputMaybe<Scalars['Float']['input']>;
  isDisplayPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayTeam?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  losingPoints?: InputMaybe<Scalars['Int']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  matchesPlayed?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerEntry?: InputMaybe<Scalars['Int']['input']>;
  pointDifference?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  setsLost?: InputMaybe<Scalars['Int']['input']>;
  setsWon?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winningPoints?: InputMaybe<Scalars['Int']['input']>;
  wins?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateLiveStreamingInput = {
  companyKey?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  creationDate?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  externalEventID?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  match?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeKey?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  thumbnailURL?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StreamingPlatform>;
};

export type CreateMatchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatchProgressionInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<EntryType>;
  isByePossible?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MatchProgressionType>;
};

export type CreateMatchScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatchesEntryInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  formatBlock?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  initialSeed?: InputMaybe<Scalars['Int']['input']>;
  isFormedPair?: InputMaybe<Scalars['Boolean']['input']>;
  pairingMode?: InputMaybe<Scalars['String']['input']>;
  partnerRegistration?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromPartner?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromRegistration?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMatchesScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  groupEntry?: InputMaybe<Scalars['Int']['input']>;
  groupEntryPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateMediaInput = {
  album?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  photoCaption?: InputMaybe<Scalars['String']['input']>;
  photoLink?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateNewsInput = {
  author: Scalars['Int']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  postText: Scalars['String']['input'];
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOnboardingInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateOrganizationPlatformInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateOrganizationPlatformMemberInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerNewInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric federation id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  imageFileId: Scalars['String']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePartnerSearchRequestInput = {
  requesterId: Scalars['Int']['input'];
  status: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type CreatePlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType: Scalars['String']['input'];
  price?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlateformSportInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePlatformCoachInput = {
  category: Scalars['String']['input'];
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  displayOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  /** Owning federation/organization public id (fed_…); backend defaults to platform data-owner if omitted */
  federation?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole: Scalars['String']['input'];
};

export type CreatePlatformDocumentInput = {
  displayOn: Array<PlatformDocumentDisplayOn>;
  documentFileId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlatformFeeInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  feeMode: FeeMode;
  feeType: FeeType;
  id?: InputMaybe<Scalars['Int']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMonetization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to numeric league id */
  leaguePublicId?: InputMaybe<Scalars['String']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  rangeEnd: Scalars['Float']['input'];
  rangeStart: Scalars['Float']['input'];
  serviceType: ServiceType;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinPercentageFee?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  authMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country: Scalars['String']['input'];
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Root-level documents. Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  documents?: InputMaybe<Array<DocumentInput>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  /** Document folders (with nested documents). Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  folders?: InputMaybe<Array<DocumentFolderInput>>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  groupedPlatformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasOwnApp?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileAppSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  navigation?: InputMaybe<Array<Scalars['JSON']['input']>>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  ownAppLinks?: InputMaybe<OwnAppLinksInput>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType: Scalars['String']['input'];
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  promoteTournatedApp?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  sendGridEmail?: InputMaybe<Scalars['String']['input']>;
  sendGridName?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName: Scalars['String']['input'];
  signeeRole: Scalars['String']['input'];
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePlatformPageInput = {
  blocks?: InputMaybe<Array<Scalars['JSON']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  slug: PageSlug;
};

export type CreatePlatformSettingInput = {
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  isEmailDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mapProvider?: InputMaybe<MapProvider>;
  notificationFromEmail?: InputMaybe<Scalars['String']['input']>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  platform: Scalars['Int']['input'];
  replaceDefaultBrandName?: InputMaybe<Scalars['Boolean']['input']>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
};

export type CreatePostCategoryInput = {
  /** Category name */
  name: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  /** Category slug */
  slug: Scalars['String']['input'];
};

export type CreatePostInput = {
  authorId?: InputMaybe<Scalars['Int']['input']>;
  /** Block payloads. Each must include a `__typename` matching one of the PostBlock variants. */
  blocks?: Array<Scalars['JSON']['input']>;
  categoryIds?: Array<Scalars['Int']['input']>;
  clubIds?: Array<Scalars['Int']['input']>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  keywords?: Array<Scalars['String']['input']>;
  /** BCP-47 code; combined with slug for uniqueness. */
  language?: Scalars['String']['input'];
  leagueIds?: Array<Scalars['Int']['input']>;
  /** Manually-added entity mentions. Merged with auto-extracted URL mentions, deduped on (type, entityId). */
  manualMentions?: Array<PostMentionInput>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  /** Federations. */
  organizerIds?: Array<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** When PUBLISHED. Defaults to now() on first publish if omitted. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug: Scalars['String']['input'];
  status?: PostStatus;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournamentIds?: Array<Scalars['Int']['input']>;
};

export type CreatePurchasedLicenseInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  approvalStatus?: InputMaybe<ApprovalStatus>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license: Scalars['Int']['input'];
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  proofFileUrl?: InputMaybe<Scalars['String']['input']>;
  proofUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
};

export type CreateRankingCategoryPointInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  bracketTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRankingCategoryPointTypeInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingCategoryPoint?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRankingPointCategoryInput = {
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRankingPointInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRankingTournamentCategoryInput = {
  rankingCategory: Scalars['Int']['input'];
  tournamentCategory: Scalars['Int']['input'];
};

export type CreateRegistrationPaymentInput = {
  VATFee: Scalars['Float']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  entryFee?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  openId?: InputMaybe<Scalars['String']['input']>;
  platformProcessingFee: Scalars['Float']['input'];
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  registrationRequestIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  totalPartnerServiceFee: Scalars['Float']['input'];
  totalTournatedServiceFee: Scalars['Float']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateResourceServiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoleInput = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateRoundInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  matches?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSponsorInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportFishingMetricContextInput = {
  metricId?: InputMaybe<Scalars['Int']['input']>;
  stageId?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateStatInput = {
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['input'];
};

export type CreateStripeSessionInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  productId?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  successUrl?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSubscriptionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Payment_Method>;
  paymentStatus?: InputMaybe<Payment_Status>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateSwissBlockInput = {
  acceleration?: InputMaybe<Scalars['Boolean']['input']>;
  byeCountsAsWins?: InputMaybe<Scalars['Boolean']['input']>;
  byePointsAwarded?: InputMaybe<Scalars['Float']['input']>;
  byeSelection?: InputMaybe<ByePolicy>;
  constraintAvoidRematch?: InputMaybe<Scalars['Boolean']['input']>;
  constraintAvoidRepeatedByes?: InputMaybe<Scalars['Boolean']['input']>;
  constraintAvoidSameTeam?: InputMaybe<Scalars['Boolean']['input']>;
  constraintBalanceColors?: InputMaybe<Scalars['Boolean']['input']>;
  fixedNumber?: InputMaybe<Scalars['Int']['input']>;
  floatSelection?: InputMaybe<OddPoolFloatStrategy>;
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  mergeThreshold?: InputMaybe<Scalars['Float']['input']>;
  participantRangeFrom?: InputMaybe<Scalars['Int']['input']>;
  participantRangeTo?: InputMaybe<Scalars['Int']['input']>;
  pointsForDraw?: InputMaybe<Scalars['Float']['input']>;
  pointsForLoss?: InputMaybe<Scalars['Float']['input']>;
  pointsForWin?: InputMaybe<Scalars['Float']['input']>;
  poolGrouping: PoolGrouping;
  poolPairingMethod: PoolPairingMethod;
  round1ByeSelection?: InputMaybe<ByePolicy>;
  seedingStrategy: SeedingStrategy;
  segment?: InputMaybe<Segment>;
  shuffleMatches?: InputMaybe<Scalars['Boolean']['input']>;
  sortingRules: Array<SortingRule>;
  title: Scalars['String']['input'];
  totalRounds: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type: BlockType;
};

export type CreateTeamMemberInput = {
  importBy?: InputMaybe<Scalars['Int']['input']>;
  member?: InputMaybe<Scalars['Int']['input']>;
  memberNr?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTemplateInput = {
  template?: InputMaybe<Scalars['Upload']['input']>;
};

export type CreateThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentAdditionalRefereeInput = {
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentAnnouncementInput = {
  author: Scalars['Int']['input'];
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  emailNotification?: Scalars['Boolean']['input'];
  isPublic?: Scalars['Boolean']['input'];
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  pushNotification?: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
  tournament: Scalars['Int']['input'];
  viewUrl?: Scalars['String']['input'];
};

export type CreateTournamentCategoryGroupInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CreateTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  externalLicense_RequiredMatchMode?: InputMaybe<RequiredLicenseMatchMode>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Float']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAdvancedTeamEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerCount?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelectionMendatory?: InputMaybe<Scalars['Boolean']['input']>;
  isTieBreakEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isU10Required?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['String']['input'];
  requiredUSPALicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skillLevel?: InputMaybe<SkillLevel>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type: Scalars['String']['input'];
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRatingType?: InputMaybe<Wpr_Rating_Type>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentCategoryLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentDiscountInput = {
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryDiscounts?: InputMaybe<Array<Scalars['JSON']['input']>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountExpireTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountPer?: InputMaybe<Scalars['Float']['input']>;
  discountStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountType?: InputMaybe<DiscountType>;
  isLimitCount?: InputMaybe<Scalars['Boolean']['input']>;
  isVTRD?: InputMaybe<Scalars['Boolean']['input']>;
  licences?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberOfCategories?: InputMaybe<Scalars['Int']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  totalCounts?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  usedCounts?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  approvedOrRejectedBy?: InputMaybe<Scalars['Float']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  competitionLevel?: InputMaybe<CompetitionLevel>;
  competitionType?: InputMaybe<CompetitionType>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Optional custom URL used in place of the default hotel booking link shown near the tournament location */
  customHotelsLink?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customMatricesType?: InputMaybe<Array<CustomMatricesType>>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  drawType?: InputMaybe<Array<DrawType>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enabledPushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<Array<GroupType>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isCPCRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMatricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDrawsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isListAndResultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMaxwillRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPairingsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  leagueType?: InputMaybe<LeagueType>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultType?: InputMaybe<Array<ListAndResultType>>;
  liveScoreAccessCode?: InputMaybe<Scalars['Float']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  pairingsBlockType?: InputMaybe<Array<BlockType>>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentQrCode?: InputMaybe<Scalars['Upload']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Region>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showPairingsAndStandings?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate: Scalars['DateTime']['input'];
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<TournamentTier>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroup?: InputMaybe<Scalars['Float']['input']>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  venues?: InputMaybe<Array<UpdateTournamentVenueInput>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateTournamentOrganizerInput = {
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsManInput = {
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRankingsWomanInput = {
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRefereeInput = {
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isAddedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartner?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentIntent?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentRegistrationQuestionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTournamentTeamMemberInput = {
  amountPaid?: InputMaybe<Scalars['Float']['input']>;
  blitzElo?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['Int']['input'];
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  fideTitle?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rapidElo?: InputMaybe<Scalars['String']['input']>;
  registrationRequest: Scalars['Int']['input'];
  registrationRequestType?: InputMaybe<Scalars['Int']['input']>;
  standardElo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  tournament: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRatingConfidence?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRatingConfidenceLevel?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprSocialRatingConfidence?: InputMaybe<Scalars['String']['input']>;
  wprSocialRatingConfidenceLevel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTournamentVenueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateTransactionHistoryInput = {
  amount: Scalars['Float']['input'];
  amountReceived?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizer?: InputMaybe<Scalars['Int']['input']>;
  paidAmount: Scalars['Float']['input'];
  partnerFee: Scalars['Float']['input'];
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee: Scalars['Float']['input'];
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee: Scalars['Float']['input'];
  transactionType?: InputMaybe<TransactionType>;
  user: Scalars['Int']['input'];
};

export type CreateUserCoachInput = {
  coaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  user: Scalars['Int']['input'];
};

export type CreateUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  avatarFileId?: InputMaybe<Scalars['String']['input']>;
  avatarLink?: InputMaybe<Scalars['String']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cpcPoints?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  educationEndDate?: InputMaybe<Scalars['String']['input']>;
  educationStartDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  externalMembershipNumber?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  fivb?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  itf_points?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  lastPasswordResetBy?: InputMaybe<Scalars['Float']['input']>;
  lastResetPassword?: InputMaybe<Scalars['String']['input']>;
  lastSelectedLeague?: InputMaybe<Scalars['Float']['input']>;
  lastSelectedTournament?: InputMaybe<Scalars['Float']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressSameAsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  legalCity?: InputMaybe<Scalars['String']['input']>;
  legalCountry?: InputMaybe<Scalars['String']['input']>;
  legalPostalCode?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  maxwillPoints?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  mobileOtp?: InputMaybe<Scalars['String']['input']>;
  mobileOtpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_armenian?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<OrganizationType>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<Scalars['Int']['input']>>;
  player?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  representingCountry?: InputMaybe<Scalars['String']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  signedupWith?: InputMaybe<Scalars['String']['input']>;
  signupPlatform?: InputMaybe<Scalars['Float']['input']>;
  signupSource?: InputMaybe<Signup_Source>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_armenian?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderName?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uciId?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_id_2?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wechatId?: InputMaybe<Scalars['String']['input']>;
  wechatIdQrCode?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprPlayerId?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserParentInput = {
  parent: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
};

export type CreateUserPlanInput = {
  plan?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateUserSettingInput = {
  dateFormatPreference?: DateFormatPreference;
  dmEmails?: InputMaybe<ChatDmEmails>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  mentionEmails?: InputMaybe<Scalars['Boolean']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  quietHoursStart?: InputMaybe<Scalars['Int']['input']>;
  timeFormatPreference?: TimeFormatPreference;
  user: Scalars['Int']['input'];
};

export type CreateUserSportInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  customClub?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  platformCoach?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UserSportStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type CtaBlock = PostBlock & {
  __typename?: 'CtaBlock';
  buttons: Array<CtaButton>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type CtaButton = {
  __typename?: 'CtaButton';
  href: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** FE-defined visual style — e.g. "primary", "secondary", "ghost". */
  variant?: Maybe<Scalars['String']['output']>;
};

export type Currency = {
  __typename?: 'Currency';
  createdAt: Scalars['DateTime']['output'];
  currencyExchangeRateFrom?: Maybe<CurrencyExchangeRate>;
  currencyExchangeRateTo?: Maybe<CurrencyExchangeRate>;
  id: Scalars['ID']['output'];
  isBase?: Maybe<Scalars['Boolean']['output']>;
  isoCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  symbol?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type CurrencyExchangeRate = {
  __typename?: 'CurrencyExchangeRate';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  rate?: Maybe<Scalars['Float']['output']>;
  rateDate?: Maybe<Scalars['DateTime']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum CustomMatricesType {
  UnitAndTimeBase = 'UNIT_AND_TIME_BASE'
}

export type CustomScheduleItem = {
  __typename?: 'CustomScheduleItem';
  date: Scalars['String']['output'];
  time: Scalars['String']['output'];
};

export type CustomScheduleItemInput = {
  date: Scalars['String']['input'];
  time: Scalars['String']['input'];
};

export enum DateFormatPreference {
  American = 'AMERICAN',
  European = 'EUROPEAN',
  Iso = 'ISO'
}

export enum DateRangeMatchStatus {
  Period = 'PERIOD',
  Week = 'WEEK'
}

/** Days of the week for cron scheduling */
export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type DefaultTeamMatch = {
  __typename?: 'DefaultTeamMatch';
  category?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  gender: Scalars['String']['output'];
  id?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DeleteOutput = {
  __typename?: 'DeleteOutput';
  id: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Discipline = {
  __typename?: 'Discipline';
  createdAt: Scalars['DateTime']['output'];
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Platform>>;
  resultType?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sport?: Maybe<Sport>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DiscountDetail = {
  __typename?: 'DiscountDetail';
  amount: Scalars['Float']['output'];
  code?: Maybe<Scalars['String']['output']>;
  percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

/** The type of discount applied to a tournament */
export enum DiscountType {
  CategoryDiscount = 'CATEGORY_DISCOUNT',
  EarlyBirdDiscount = 'EARLY_BIRD_DISCOUNT',
  LicenceDiscount = 'LICENCE_DISCOUNT',
  PromoCode = 'PROMO_CODE'
}

export type DisplaySetting = {
  __typename?: 'DisplaySetting';
  id: Scalars['Float']['output'];
  isDisplayAthleteChessTitle?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  sport?: Maybe<Sport>;
};

export type DividerBlock = PostBlock & {
  __typename?: 'DividerBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type Document = {
  __typename?: 'Document';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['ID']['output']>;
  fileSize?: Maybe<Scalars['Float']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['Int']['output'];
  isPrivate: Scalars['Boolean']['output'];
  sortingPosition: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentFolder = {
  __typename?: 'DocumentFolder';
  createdAt: Scalars['DateTime']['output'];
  documents?: Maybe<Array<Document>>;
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  sortingPosition: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type DocumentFolderInput = {
  documents?: InputMaybe<Array<DocumentInput>>;
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type DocumentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  fileId: Scalars['ID']['input'];
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentsSectionBlock = LandingBlock & {
  __typename?: 'DocumentsSectionBlock';
  documentEntities?: Maybe<Array<PublicDocumentEntity>>;
  id?: Maybe<Scalars['String']['output']>;
};

export type DoublesH2HMatchHistoryInput = {
  doubles1: H2HDoubles;
  doubles2: H2HDoubles;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Sport ids to scope the H2H to. Required — H2H stats only make sense within a single sport context. */
  sportIds: Array<Scalars['Int']['input']>;
  /** Optional calendar year to scope the history to. Omit for all-time. */
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type Draw = {
  __typename?: 'Draw';
  algo?: Maybe<Scalars['String']['output']>;
  consolationDrawEntries?: Maybe<Scalars['String']['output']>;
  consolationMainDraw?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  drawEntries?: Maybe<Array<DrawEntry>>;
  drawImage?: Maybe<Scalars['String']['output']>;
  drawImageFile?: Maybe<StorageFile>;
  drawImageFileId?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<MatchesEntry>>;
  fileName?: Maybe<Scalars['String']['output']>;
  genDraw?: Maybe<Scalars['String']['output']>;
  /** Group ids when generating draw from groups */
  groupIds?: Maybe<Scalars['JSON']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  is24DoubleEliminator?: Maybe<Scalars['Boolean']['output']>;
  isDisplayParticipantsClub?: Maybe<Scalars['Boolean']['output']>;
  isDistributeClubMembers?: Maybe<Scalars['Boolean']['output']>;
  isFirstMatchLosersToConsolationDraw?: Maybe<Scalars['Boolean']['output']>;
  liveStanding?: Maybe<LiveStanding>;
  mainDraw?: Maybe<Draw>;
  matches?: Maybe<Array<Match>>;
  place?: Maybe<Scalars['String']['output']>;
  qualWinners?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type DrawEntry = {
  __typename?: 'DrawEntry';
  bracketType?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  dateBackup?: Maybe<Scalars['String']['output']>;
  draw?: Maybe<Draw>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<TournamentRegistration>;
  entry1group?: Maybe<Scalars['String']['output']>;
  entry1groupId?: Maybe<Group>;
  entry1pig?: Maybe<Scalars['Float']['output']>;
  entry2?: Maybe<TournamentRegistration>;
  entry2group?: Maybe<Scalars['String']['output']>;
  entry2groupId?: Maybe<Group>;
  entry2pig?: Maybe<Scalars['Float']['output']>;
  firstScoreSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  mainMatch?: Maybe<DrawEntry>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team1?: Maybe<MatchesEntry>;
  team1Entry?: Maybe<Array<TournamentTeamMember>>;
  team2?: Maybe<MatchesEntry>;
  team2Entry?: Maybe<Array<TournamentTeamMember>>;
  teamMatchType?: Maybe<Scalars['String']['output']>;
  teamWinner?: Maybe<Array<TournamentTeamMember>>;
  tempWinner?: Maybe<MatchesEntry>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<TournamentRegistration>;
};

export type DrawScore = {
  __typename?: 'DrawScore';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export enum DrawType {
  DoubleElimination = 'DOUBLE_ELIMINATION',
  DoubleEliminationAdvanced = 'DOUBLE_ELIMINATION_ADVANCED',
  PlayEachPlace = 'PLAY_EACH_PLACE',
  SingleElimination = 'SINGLE_ELIMINATION'
}

export type DynamicBannersBlock = LandingBlock & {
  __typename?: 'DynamicBannersBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type EntryOrderInput = {
  id: Scalars['Int']['input'];
  order: Scalars['Int']['input'];
};

export enum EntryType {
  Entry1 = 'ENTRY1',
  Entry2 = 'ENTRY2'
}

export type FactSheet = {
  __typename?: 'FactSheet';
  createdAt: Scalars['DateTime']['output'];
  fieldTitle?: Maybe<Scalars['String']['output']>;
  fieldType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  options?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FaqItem = {
  __typename?: 'FaqItem';
  /** Locale → text */
  answer: Scalars['JSON']['output'];
  /** Locale → text */
  question: Scalars['JSON']['output'];
};

export type FaqSectionBlock = LandingBlock & {
  __typename?: 'FaqSectionBlock';
  /** Locale → text */
  description?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<FaqItem>>;
  /** Locale → text */
  title?: Maybe<Scalars['JSON']['output']>;
};

export type FeaturedLeaguesBlock = LandingBlock & {
  __typename?: 'FeaturedLeaguesBlock';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<LocalizedText>;
};

export type FeaturedTournamentsBlock = LandingBlock & {
  __typename?: 'FeaturedTournamentsBlock';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<LocalizedText>;
};

export type FeaturedTournamentsSectionBlock = LandingBlock & {
  __typename?: 'FeaturedTournamentsSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type Federation = {
  __typename?: 'Federation';
  about?: Maybe<Scalars['String']['output']>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAddress?: Maybe<Scalars['String']['output']>;
  bankCity?: Maybe<Scalars['String']['output']>;
  bankCompanyRegistrationNumber?: Maybe<Scalars['String']['output']>;
  bankCountry?: Maybe<Scalars['String']['output']>;
  bankEnabled?: Maybe<Scalars['Boolean']['output']>;
  bankIban?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  bankPostalCode?: Maybe<Scalars['String']['output']>;
  bankVatNumber?: Maybe<Scalars['String']['output']>;
  boardMembers?: Maybe<Array<BoardMember>>;
  clubMembers?: Maybe<Array<FederationClubMember>>;
  clubs?: Maybe<Array<Club>>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  documentFolders?: Maybe<Array<DocumentFolder>>;
  documents?: Maybe<Array<Document>>;
  /** Set when organizationTypes includes an education-related type */
  educationalInstitutionNumber?: Maybe<Scalars['String']['output']>;
  enableApplicationForms?: Maybe<Scalars['Boolean']['output']>;
  enableCertificates?: Maybe<Scalars['Boolean']['output']>;
  enableLicenses?: Maybe<Scalars['Boolean']['output']>;
  enableRankings?: Maybe<Scalars['Boolean']['output']>;
  geographicScope?: Maybe<GeographicScope>;
  id: Scalars['Float']['output'];
  isCurrentUserSigner?: Maybe<Scalars['Boolean']['output']>;
  leagues?: Maybe<Array<LeagueOwner>>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  legalCompanyName?: Maybe<Scalars['String']['output']>;
  legalCountry?: Maybe<Scalars['String']['output']>;
  legalEmail?: Maybe<Scalars['String']['output']>;
  legalEntityType?: Maybe<LegalEntityType>;
  legalName?: Maybe<Scalars['String']['output']>;
  legalPhone?: Maybe<Scalars['String']['output']>;
  legalSurname?: Maybe<Scalars['String']['output']>;
  licenses?: Maybe<Array<License>>;
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFileOutput>;
  mainManagerContactEmail?: Maybe<Scalars['String']['output']>;
  mainManagerContactPhone?: Maybe<Scalars['String']['output']>;
  news?: Maybe<Array<FederationNews>>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * Legacy singular federation type — first element of organizationTypes.
   * @deprecated Use organizationTypes; this returns the first element.
   */
  organizationType?: Maybe<OrganizationType>;
  /** Federation types — one or more roles. */
  organizationTypes: Array<OrganizationType>;
  personalIdentificationNumber?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<OrganizationPlatform>>;
  /** Public id, e.g. fed_… */
  publicId: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  signerEmail?: Maybe<Scalars['String']['output']>;
  signerName?: Maybe<Scalars['String']['output']>;
  signerRole?: Maybe<Scalars['String']['output']>;
  signerSurname?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Array<Sport>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type FederationClubMember = {
  __typename?: 'FederationClubMember';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  clubId?: Maybe<Scalars['Int']['output']>;
  contactEmail: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  contactPhone?: Maybe<Scalars['String']['output']>;
  contactRole: OrganizationMemberRole;
  contactSurname: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  registrationNumber?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type FederationLeague = {
  __typename?: 'FederationLeague';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FederationNews = {
  __typename?: 'FederationNews';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FederationResult = {
  __typename?: 'FederationResult';
  federations: Array<Federation>;
  total: Scalars['Int']['output'];
};

export type FederationSummary = {
  __typename?: 'FederationSummary';
  activePeriod: ActivePeriod;
  federationName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalMonths: Scalars['Int']['output'];
  totalPaid: Scalars['Float']['output'];
};

/** Possible mode of a fee (per player or per entry) */
export enum FeeMode {
  PerEntry = 'PER_ENTRY',
  PerPlayer = 'PER_PLAYER'
}

/** Possible type of a fee */
export enum FeeType {
  Fixed = 'FIXED',
  Percentage = 'PERCENTAGE'
}

export type FinalTotalsOutput = {
  __typename?: 'FinalTotalsOutput';
  afterDiscountTotalLicenseFee: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  grandTotalAmount: Scalars['Float']['output'];
  promoDiscountTotalAmount: Scalars['Float']['output'];
  stripeFee: Scalars['Float']['output'];
  totalLicenseFee: Scalars['Float']['output'];
  totalPlatformFee: Scalars['Float']['output'];
  totalPlatformFeeForPayout?: Maybe<Scalars['Float']['output']>;
  totalVatAmount: Scalars['Float']['output'];
  totalVatAmountForPayout?: Maybe<Scalars['Float']['output']>;
};

export type FindUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  avatarFileId?: InputMaybe<Scalars['String']['input']>;
  avatarLink?: InputMaybe<Scalars['String']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cpcPoints?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  educationEndDate?: InputMaybe<Scalars['String']['input']>;
  educationStartDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  externalMembershipNumber?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  fivb?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  itf_points?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  lastPasswordResetBy?: InputMaybe<Scalars['Float']['input']>;
  lastResetPassword?: InputMaybe<Scalars['String']['input']>;
  lastSelectedLeague?: InputMaybe<Scalars['Float']['input']>;
  lastSelectedTournament?: InputMaybe<Scalars['Float']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressSameAsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  legalCity?: InputMaybe<Scalars['String']['input']>;
  legalCountry?: InputMaybe<Scalars['String']['input']>;
  legalPostalCode?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  maxwillPoints?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  mobileOtp?: InputMaybe<Scalars['String']['input']>;
  mobileOtpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_armenian?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<OrganizationType>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<Scalars['Int']['input']>>;
  player?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  /** Opaque user publicId (`usr_…`). Accepted as an alternative to the legacy numeric `id`. */
  publicId?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  representingCountry?: InputMaybe<Scalars['String']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  signedupWith?: InputMaybe<Scalars['String']['input']>;
  signupPlatform?: InputMaybe<Scalars['Float']['input']>;
  signupSource?: InputMaybe<Signup_Source>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_armenian?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderName?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uciId?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_id_2?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wechatId?: InputMaybe<Scalars['String']['input']>;
  wechatIdQrCode?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprPlayerId?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type FormatBlock = {
  __typename?: 'FormatBlock';
  acceleration?: Maybe<Scalars['Boolean']['output']>;
  byeCountsAsWins: Scalars['Boolean']['output'];
  byeOrder?: Maybe<AmericanoByeOrder>;
  byePointsAwarded: Scalars['Float']['output'];
  byeSelection?: Maybe<Scalars['String']['output']>;
  constraintAvoidRematch: Scalars['Boolean']['output'];
  constraintAvoidRepeatedByes: Scalars['Boolean']['output'];
  constraintAvoidSameTeam?: Maybe<Scalars['Boolean']['output']>;
  constraintBalanceColors?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fixedNumber?: Maybe<Scalars['Float']['output']>;
  floatSelection?: Maybe<OddPoolFloatStrategy>;
  id: Scalars['Float']['output'];
  isAllowScoreSubmission?: Maybe<Scalars['Boolean']['output']>;
  isVisible: Scalars['Boolean']['output'];
  matchStrategy?: Maybe<AmericanoMatchStrategy>;
  matches?: Maybe<Array<Match>>;
  mergeThreshold?: Maybe<Scalars['Float']['output']>;
  pairingMode?: Maybe<PairingMode>;
  participantRangeFrom?: Maybe<Scalars['Float']['output']>;
  participantRangeTo?: Maybe<Scalars['Float']['output']>;
  participants?: Maybe<Array<ParticipantInfo>>;
  pointsForDraw: Scalars['Float']['output'];
  pointsForLoss: Scalars['Float']['output'];
  pointsForWin: Scalars['Float']['output'];
  poolGrouping: Scalars['String']['output'];
  poolPairingMethod: Scalars['String']['output'];
  prioritiseSimilarStrength: Scalars['Boolean']['output'];
  round1ByeSelection?: Maybe<Scalars['String']['output']>;
  rounds: Array<FormatRound>;
  roundsCompleted: Scalars['Float']['output'];
  seededPlayerCount?: Maybe<Scalars['Int']['output']>;
  seedingStrategy: Scalars['String']['output'];
  segment?: Maybe<Segment>;
  shuffleMatches?: Maybe<Scalars['Boolean']['output']>;
  sortingRules: Array<SortingRule>;
  sport?: Maybe<Scalars['Int']['output']>;
  status: Scalars['String']['output'];
  teamFormationStrategy?: Maybe<TeamFormationStrategy>;
  title: Scalars['String']['output'];
  totalRounds: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FormatRound = {
  __typename?: 'FormatRound';
  completedMatches: Scalars['Int']['output'];
  createdAt: Scalars['DateTime']['output'];
  formatBlock: FormatBlock;
  id: Scalars['Int']['output'];
  isLocked: Scalars['Boolean']['output'];
  isVisible: Scalars['Boolean']['output'];
  liveStandings?: Maybe<Array<LiveStanding>>;
  matches: Array<Match>;
  roundName: Scalars['String']['output'];
  roundNumber: Scalars['Int']['output'];
  totalMatches: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FormatStandingOutput = {
  __typename?: 'FormatStandingOutput';
  deDetails?: Maybe<Array<StandingDeDetails>>;
  dupr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  initialSeed?: Maybe<Scalars['Int']['output']>;
  liveStandingEntryId: Scalars['Int']['output'];
  matchesPlayed: Scalars['Int']['output'];
  pointDifference: Scalars['Int']['output'];
  points: Scalars['Int']['output'];
  pointsLost?: Maybe<Scalars['Int']['output']>;
  pointsWon?: Maybe<Scalars['Int']['output']>;
  position: Scalars['Int']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  setsLost?: Maybe<Scalars['Int']['output']>;
  setsWon?: Maybe<Scalars['Int']['output']>;
  teamId?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<StandingUser>>;
  wins: Scalars['Int']['output'];
  wpr?: Maybe<Scalars['Float']['output']>;
  wprConfidenceLevel?: Maybe<Scalars['String']['output']>;
};

export type FormatStandingsResponse = {
  __typename?: 'FormatStandingsResponse';
  id: Scalars['Int']['output'];
  liveStandingId: Scalars['Int']['output'];
  roundsCompleted: Scalars['Int']['output'];
  sortingRules: Array<SortingRule>;
  standings: Array<FormatStandingOutput>;
  totalMatches: Scalars['Int']['output'];
  totalRounds: Scalars['Int']['output'];
  tournamentCategory?: Maybe<CategorySetting>;
};

export type GallerySectionBlock = LandingBlock & {
  __typename?: 'GallerySectionBlock';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<LocalizedText>;
};

export type GeneralReturnType = {
  __typename?: 'GeneralReturnType';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type GenerateApiKeyResponse = {
  __typename?: 'GenerateApiKeyResponse';
  apiKey: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  keyId: Scalars['String']['output'];
  prefix: Scalars['String']['output'];
};

export enum GeographicScope {
  International = 'INTERNATIONAL',
  Local = 'LOCAL',
  National = 'NATIONAL'
}

export type Group = {
  __typename?: 'Group';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  displayMatches?: Maybe<Scalars['Boolean']['output']>;
  displayPlayOrder?: Maybe<Scalars['Boolean']['output']>;
  entries?: Maybe<Array<MatchesEntry>>;
  external_id?: Maybe<Scalars['Float']['output']>;
  groupType?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isDoubleRoundRobin?: Maybe<Scalars['Boolean']['output']>;
  matches?: Maybe<Array<Match>>;
  name?: Maybe<Scalars['String']['output']>;
  participantsAddScore?: Maybe<Scalars['Boolean']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GroupEntry = {
  __typename?: 'GroupEntry';
  external_id?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Group>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  place?: Maybe<Scalars['Float']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  score?: Maybe<Array<MatchScore>>;
  tournamentCategory?: Maybe<CategorySetting>;
};

export type GroupMatch = {
  __typename?: 'GroupMatch';
  conflict?: Maybe<Scalars['Boolean']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  dateBackup?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<GroupEntry>;
  entry1partner?: Maybe<GroupEntry>;
  entry2?: Maybe<GroupEntry>;
  entry2partner?: Maybe<GroupEntry>;
  external_id?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  mainMatch?: Maybe<GroupMatch>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  rounds?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Array<MatchScore>>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team1?: Maybe<MatchesEntry>;
  team1Entry?: Maybe<Array<TournamentTeamMember>>;
  team1partner?: Maybe<MatchesEntry>;
  team2?: Maybe<MatchesEntry>;
  team2Entry?: Maybe<Array<TournamentTeamMember>>;
  team2partner?: Maybe<MatchesEntry>;
  teamMatchType?: Maybe<Scalars['String']['output']>;
  teamScore?: Maybe<Scalars['String']['output']>;
  teamWinner?: Maybe<Array<TournamentTeamMember>>;
  tempScore?: Maybe<Scalars['String']['output']>;
  tempWinner?: Maybe<MatchesEntry>;
  tempWinnerPartner?: Maybe<MatchesEntry>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<GroupEntry>;
  winnerPartner?: Maybe<GroupEntry>;
};

export type GroupResult = {
  __typename?: 'GroupResult';
  groups: Array<Group>;
  total: Scalars['Int']['output'];
};

export enum GroupType {
  Kings = 'KINGS',
  Standard = 'STANDARD'
}

export type H2HCategoryInfo = {
  __typename?: 'H2HCategoryInfo';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type H2HCurrentRanking = {
  __typename?: 'H2HCurrentRanking';
  duprRating?: Maybe<Scalars['String']['output']>;
  fivb?: Maybe<Scalars['String']['output']>;
  gtwPoints?: Maybe<Scalars['Float']['output']>;
  itfPoints?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['String']['output']>;
  wprStatusRating?: Maybe<Scalars['String']['output']>;
};

export type H2HCurrentStreak = {
  __typename?: 'H2HCurrentStreak';
  count: Scalars['Int']['output'];
  type: H2HStreakType;
};

export type H2HDoubles = {
  player1Id: Scalars['Int']['input'];
  player2Id: Scalars['Int']['input'];
};

export type H2HMatchItem = {
  __typename?: 'H2HMatchItem';
  category?: Maybe<H2HCategoryInfo>;
  id: Scalars['Int']['output'];
  playedAt?: Maybe<Scalars['DateTime']['output']>;
  player1Partner?: Maybe<H2HMiniUser>;
  player2Partner?: Maybe<H2HMiniUser>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<H2HTournamentInfo>;
  winnerId?: Maybe<Scalars['Int']['output']>;
};

/** Singles or doubles scope for player head-to-head queries. */
export enum H2HMatchType {
  Doubles = 'DOUBLES',
  Singles = 'SINGLES'
}

export type H2HMiniUser = {
  __typename?: 'H2HMiniUser';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type H2HMoneyValue = {
  __typename?: 'H2HMoneyValue';
  amount?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
};

/** Whether a current streak is a winning or losing streak. */
export enum H2HStreakType {
  Loss = 'LOSS',
  Win = 'WIN'
}

export type H2HTournamentInfo = {
  __typename?: 'H2HTournamentInfo';
  country?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type HealthCheckType = {
  __typename?: 'HealthCheckType';
  environment: Scalars['String']['output'];
  status: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
  uptime: Scalars['Float']['output'];
  version: Scalars['String']['output'];
};

export enum HeroCardTabs {
  Athlete = 'ATHLETE',
  Class = 'CLASS',
  ClubEvents = 'CLUB_EVENTS',
  ClubVenue = 'CLUB_VENUE',
  Coach = 'COACH',
  /** @deprecated Use COURTS_FACILITIES instead */
  Court = 'COURT',
  CourtsFacilities = 'COURTS_FACILITIES',
  /** @deprecated Use CLUB_EVENTS instead */
  Event = 'EVENT',
  /** @deprecated Use COURTS_FACILITIES instead */
  Facility = 'FACILITY',
  Gallery = 'GALLERY',
  GoverningBody = 'GOVERNING_BODY',
  Leaderboard = 'LEADERBOARD',
  Leagues = 'LEAGUES',
  News = 'NEWS',
  Organization = 'ORGANIZATION',
  OrgAthlete = 'ORG_ATHLETE',
  Ranking = 'RANKING',
  SportAgency = 'SPORT_AGENCY',
  Tour = 'TOUR',
  Tournaments = 'TOURNAMENTS',
  TournamentManager = 'TOURNAMENT_MANAGER',
  TourLeague = 'TOUR_LEAGUE'
}

export type HeroSectionBlock = LandingBlock & {
  __typename?: 'HeroSectionBlock';
  backgroundImage?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<LocalizedText>;
  tabs?: Maybe<HeroSectionTabsConfig>;
  title?: Maybe<LocalizedText>;
};

export type HeroSectionTabsConfig = {
  __typename?: 'HeroSectionTabsConfig';
  book?: Maybe<Array<HeroCardTabs>>;
  compete?: Maybe<Array<HeroCardTabs>>;
  discover?: Maybe<Array<HeroCardTabs>>;
  solutions?: Maybe<Array<HeroCardTabs>>;
};

export type HeroWithNewsBlock = LandingBlock & {
  __typename?: 'HeroWithNewsBlock';
  id?: Maybe<Scalars['String']['output']>;
  variant: HeroWithNewsVariant;
};

export enum HeroWithNewsVariant {
  Basic = 'BASIC',
  Complex = 'COMPLEX'
}

export type Image = {
  __typename?: 'Image';
  id: Scalars['Float']['output'];
  image: Scalars['String']['output'];
  tournament: Tournament;
};

export type ImageSwiperBlock = PostBlock & {
  __typename?: 'ImageSwiperBlock';
  id?: Maybe<Scalars['String']['output']>;
  images: Array<SwiperImage>;
};

export type ImpersonationTokenOutput = {
  __typename?: 'ImpersonationTokenOutput';
  accessToken: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  impersonatorId: Scalars['Int']['output'];
  targetUserId: Scalars['Int']['output'];
};

export type ImportMessage = {
  __typename?: 'ImportMessage';
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ImportedMember = {
  __typename?: 'ImportedMember';
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  duprid?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  ipin?: Maybe<Scalars['String']['output']>;
  memberNr?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  wprid?: Maybe<Scalars['String']['output']>;
};

export type InstagramFeedBlock = LandingBlock & {
  __typename?: 'InstagramFeedBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type InterestedSectionBlock = LandingBlock & {
  __typename?: 'InterestedSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type InterestedTournament = {
  __typename?: 'InterestedTournament';
  /** Personalisation score; higher is a better match. FE should rely on order, not absolute value. */
  score: Scalars['Float']['output'];
  /** Per-signal breakdown of the score. Selected only when needed (analytics / debug UIs). */
  scoreBreakdown?: Maybe<InterestedTournamentScoreBreakdown>;
  tournament: PublicTournament;
};

export type InterestedTournamentScoreBreakdown = {
  __typename?: 'InterestedTournamentScoreBreakdown';
  /** +30 if any league on the tournament is covered by the user’s active license. */
  activeLicenseLeague: Scalars['Float']['output'];
  /** +40 if any tournament venue matches the current location. */
  currentLocationMatch: Scalars['Float']['output'];
  /** 0..-20, penalty for tournaments more than 6 months out. */
  farFutureDecay: Scalars['Float']['output'];
  /** +60 if any tournament venue matches user.nation. */
  nationMatch: Scalars['Float']['output'];
  /** +40 if any category on the tournament matches a category the user has played. */
  pastCategoryMatch: Scalars['Float']['output'];
  /** +20 if any league on the tournament was played by the user before. */
  pastLeagueMatch: Scalars['Float']['output'];
  /** +20 if the platform was played on by the user before. */
  pastPlatformMatch: Scalars['Float']['output'];
  /** Popularity bucket 10/15/20 from confirmed entry counts; 0 for past tournaments. */
  popularity: Scalars['Float']['output'];
  /** -30 if the entry deadline has already passed. */
  registrationClosed: Scalars['Float']['output'];
  /** 0..30, decays linearly as the entry deadline approaches; 0 once it passes. */
  registrationUrgency: Scalars['Float']['output'];
  /** +20 if any league sport is one the user has ever played. */
  sportEverPlayed: Scalars['Float']['output'];
  /** +60 if any league sport matches user.sportIds. */
  sportPreferred: Scalars['Float']['output'];
  /** Tiered recency boost for any league sport the user played recently: +60 if within last 1 month, +45 within 3 months, +30 within 6 months, +15 within 12 months, otherwise 0. */
  sportRecent: Scalars['Float']['output'];
  /** +30 if any league sport is the user’s top sport. */
  sportTop: Scalars['Float']['output'];
  /** 0..20, decays as the start date approaches; 0 once it passes. */
  startUrgency: Scalars['Float']['output'];
  /** Sum of all components — equals InterestedTournament.score. */
  total: Scalars['Float']['output'];
};

export type InterestedTournamentsInput = {
  competitionType?: InputMaybe<CompetitionType>;
  /** Hard-filter tournaments by venue country codes. When omitted, the authenticated user's nation drives a soft boost instead of a filter. */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** ISO alpha-2 country code of the user's current physical location (typically geolocated client-side). Soft-boosts tournaments whose venue is in this country. Stacks with the nation match so a user traveling inside their home country gets both boosts. */
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  isRegistrationOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingOrInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  limit?: Scalars['Int']['input'];
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Hard-filter tournaments by these sport IDs. When omitted, the authenticated user's active user_sports drive a soft boost instead of a filter. */
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InterestedTournamentsResult = {
  __typename?: 'InterestedTournamentsResult';
  hasMore: Scalars['Boolean']['output'];
  /** False when the user has an empty profile (no sports, no nation, no licenses, no history). When false, ranking falls back to generic freshness/urgency only. */
  isPersonalized: Scalars['Boolean']['output'];
  items: Array<InterestedTournament>;
  total: Scalars['Int']['output'];
};

export type InviteScorerInput = {
  email: Scalars['String']['input'];
  /** Required when expiryPreset = CUSTOM. Ignored otherwise. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  expiryPreset?: ScorerInviteExpiryPreset;
  /** Deprecated — all invites are SCORER. Kept for DB compatibility. */
  role?: InputMaybe<TournamentScorerInviteRole>;
  tournamentId: Scalars['Int']['input'];
};

export type JoinCommunityBannerBlock = LandingBlock & {
  __typename?: 'JoinCommunityBannerBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type Landing = {
  __typename?: 'Landing';
  id: Scalars['Int']['output'];
  landingAbbr?: Maybe<Scalars['String']['output']>;
  landingBaseUrl?: Maybe<Scalars['String']['output']>;
  landingCountry?: Maybe<Scalars['String']['output']>;
  landingCustomPlatform?: Maybe<Scalars['String']['output']>;
  landingHeadline?: Maybe<Scalars['String']['output']>;
  landingHeroLayout?: Maybe<Scalars['String']['output']>;
  landingLang?: Maybe<Scalars['String']['output']>;
  landingLayout?: Maybe<Scalars['String']['output']>;
  landingLocations?: Maybe<Scalars['String']['output']>;
  landingLogo?: Maybe<Scalars['String']['output']>;
  landingLogoDark?: Maybe<Scalars['String']['output']>;
  landingOrganizations?: Maybe<Scalars['String']['output']>;
  landingPrimary?: Maybe<Scalars['String']['output']>;
  landingPrimaryColor?: Maybe<Scalars['String']['output']>;
  landingSecondaryColor?: Maybe<Scalars['String']['output']>;
  landingSubtitle?: Maybe<Scalars['String']['output']>;
  landingSupportedSports?: Maybe<Scalars['String']['output']>;
  landingTeamPages?: Maybe<Scalars['String']['output']>;
  landingTitle?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
};

export type LandingBlock = {
  id?: Maybe<Scalars['String']['output']>;
};

export type LandingMember = {
  __typename?: 'LandingMember';
  avatar?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  highlight?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  lang?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  role?: Maybe<Scalars['String']['output']>;
  show_on_pages?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Float']['output']>;
};

export type LandingPotm = {
  __typename?: 'LandingPotm';
  age?: Maybe<Scalars['Float']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fullname?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_updated?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
  placement?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  platform_code?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
};

export type LandingRoadmap = {
  __typename?: 'LandingRoadmap';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  item1?: Maybe<Scalars['String']['output']>;
  item2?: Maybe<Scalars['String']['output']>;
  item3?: Maybe<Scalars['String']['output']>;
  item4?: Maybe<Scalars['String']['output']>;
  item5?: Maybe<Scalars['String']['output']>;
  item6?: Maybe<Scalars['String']['output']>;
  item7?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LandingSlider = {
  __typename?: 'LandingSlider';
  button?: Maybe<Scalars['String']['output']>;
  date_added?: Maybe<Scalars['String']['output']>;
  date_from?: Maybe<Scalars['String']['output']>;
  date_to?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  platform_code?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sorting?: Maybe<Scalars['Float']['output']>;
};

export type League = {
  __typename?: 'League';
  abbreviation?: Maybe<Scalars['String']['output']>;
  abbreviationLogo?: Maybe<Scalars['String']['output']>;
  abbreviationLogoFile?: Maybe<StorageFile>;
  abbreviationLogoFileId?: Maybe<Scalars['String']['output']>;
  album?: Maybe<Album>;
  allowUnregisteredPlayers?: Maybe<Scalars['Boolean']['output']>;
  athlete?: Maybe<Array<Athlete>>;
  bannerCover?: Maybe<Scalars['String']['output']>;
  bannerCoverFile?: Maybe<StorageFile>;
  bannerCoverFileId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  country_full_name?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFee?: Maybe<Array<PlatformFee>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  discipline?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  enableOnlinePayments?: Maybe<Scalars['Boolean']['output']>;
  enableRankings?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  factSheet?: Maybe<Array<FactSheet>>;
  federation?: Maybe<Federation>;
  globalCategoryLimitPerPlayer?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  instagram?: Maybe<Scalars['String']['output']>;
  isCustomFeeEnable?: Maybe<Scalars['Boolean']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isTournatedFeeVatEnable?: Maybe<Scalars['Boolean']['output']>;
  leagueCategory?: Maybe<Array<LeagueCategory>>;
  leagueRanking?: Maybe<Array<LeagueRanking>>;
  license?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming_sporfie_key?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFile>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<LeagueMember>>;
  news?: Maybe<Array<LeagueNews>>;
  owner?: Maybe<LeagueOwner>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `platforms` instead. Returns the first accessible platform. */
  platform?: Maybe<Platform>;
  platforms?: Maybe<Array<Platform>>;
  priority?: Maybe<Scalars['String']['output']>;
  /** Public id, e.g. lge_… */
  publicId: Scalars['String']['output'];
  requireTournamentApproval?: Maybe<Scalars['Boolean']['output']>;
  socialLinks?: Maybe<Array<LeagueSocialLink>>;
  sports?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tourType?: Maybe<TourType>;
  tournamentCategoryGroups?: Maybe<TournamentCategoryGroup>;
  tournaments?: Maybe<Array<LeagueTournament>>;
  tournamentsCount?: Maybe<Scalars['Int']['output']>;
  tournatedFeeVat?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<LeagueGeoScope>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type LeagueCategory = {
  __typename?: 'LeagueCategory';
  category?: Maybe<Category>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueDocument = {
  __typename?: 'LeagueDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  documentFile?: Maybe<StorageFile>;
  documentFileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isLeaguePage?: Maybe<Scalars['Boolean']['output']>;
  isRankings?: Maybe<Scalars['Boolean']['output']>;
  isTournamentCalendar?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  name?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LeagueGeoScope {
  International = 'INTERNATIONAL',
  Local = 'LOCAL',
  National = 'NATIONAL'
}

export type LeagueLivescoreEnabledPayload = {
  __typename?: 'LeagueLivescoreEnabledPayload';
  enabled: Scalars['Boolean']['output'];
  leagueId: Scalars['Int']['output'];
};

export type LeagueMember = {
  __typename?: 'LeagueMember';
  createdAt: Scalars['DateTime']['output'];
  displayMember?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isLeagueManager?: Maybe<Scalars['Boolean']['output']>;
  isOrganization?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  leagueManagerCount?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<User>;
  organizationEmail?: Maybe<Scalars['String']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationPhone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Array<LeagueMemberRole>>;
  tournamentCount?: Maybe<Scalars['Float']['output']>;
  tournamentOrganizerCount?: Maybe<Scalars['Int']['output']>;
  tournamentRefereeCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueMemberRole = {
  __typename?: 'LeagueMemberRole';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  leagueMember?: Maybe<LeagueMember>;
  role?: Maybe<Role>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type LeagueMemberStats = {
  __typename?: 'LeagueMemberStats';
  manager: Scalars['Float']['output'];
  organizer: Scalars['Float']['output'];
  referee: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type LeagueMembersResult = {
  __typename?: 'LeagueMembersResult';
  members: Array<LeagueMember>;
  total: Scalars['Int']['output'];
};

export type LeagueNews = {
  __typename?: 'LeagueNews';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  news?: Maybe<News>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueOwner = {
  __typename?: 'LeagueOwner';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueRanking = {
  __typename?: 'LeagueRanking';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  place?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rankingCategory?: Maybe<LeagueCategory>;
  team?: Maybe<Team>;
  thirdPartyPoints?: Maybe<Scalars['String']['output']>;
  tournaments?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type LeagueRankingResult = {
  __typename?: 'LeagueRankingResult';
  rankings: Array<LeagueRanking>;
  top3: Array<LeagueRanking>;
  total: Scalars['Int']['output'];
};

export type LeagueRankingsCron = {
  __typename?: 'LeagueRankingsCron';
  createdAt: Scalars['DateTime']['output'];
  customSchedule?: Maybe<Array<CustomScheduleItem>>;
  dayOfWeek?: Maybe<DayOfWeek>;
  id: Scalars['Int']['output'];
  leagueId?: Maybe<Scalars['Int']['output']>;
  rankingCategoryIds: Array<Scalars['Int']['output']>;
  refreshRate?: Maybe<RefreshRate>;
  time?: Maybe<Scalars['String']['output']>;
  updateEvery?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueResult = {
  __typename?: 'LeagueResult';
  league: Array<League>;
  total: Scalars['Int']['output'];
};

export type LeagueSocialLink = {
  __typename?: 'LeagueSocialLink';
  /** Social-media platform this link points to. */
  socialMediaType: SocialMediaType;
  /** Full URL of the league profile on the platform. */
  url: Scalars['String']['output'];
};

export type LeagueSocialLinkInput = {
  /** Social-media platform this link points to. */
  socialMediaType: SocialMediaType;
  /** Full URL of the league profile on the platform. */
  url: Scalars['String']['input'];
};

export type LeagueTournament = {
  __typename?: 'LeagueTournament';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LeagueTournamentCategory = {
  __typename?: 'LeagueTournamentCategory';
  category?: Maybe<TournamentCategory>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum LeagueType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export enum LegalEntityType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL'
}

export type License = {
  __typename?: 'License';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  alternateTitle?: Maybe<Scalars['String']['output']>;
  availablePaymentTypes?: Maybe<Array<Scalars['String']['output']>>;
  bankTransfer?: Maybe<LicenseBankTransferSettings>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  cantBuy?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  englishTitle?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  federation?: Maybe<Federation>;
  fee?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isAllowedToPurchaseOnTournated?: Maybe<Scalars['Boolean']['output']>;
  isApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isAutoRenew?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPartnerFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPlatformFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingStripeFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingTournatedFee?: Maybe<Scalars['Boolean']['output']>;
  isPlatformGlobal?: Maybe<Scalars['Boolean']['output']>;
  isSendNotificationsToManager?: Maybe<Scalars['Boolean']['output']>;
  issuedCount?: Maybe<Scalars['Int']['output']>;
  leagues?: Maybe<Array<LicenseLeague>>;
  licenseManager?: Maybe<User>;
  /** Override address for manager notifications. */
  managerContactEmail?: Maybe<Scalars['String']['output']>;
  nationality?: Maybe<Scalars['String']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use platforms instead — license belongs to a federation, platform reach is derived via federation→platforms. */
  platform?: Maybe<Platform>;
  platforms?: Maybe<Array<Platform>>;
  /** Public id, e.g. lic_…. */
  publicId: Scalars['String']['output'];
  sports?: Maybe<Array<Sport>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  type: LicenseType;
  updatedAt: Scalars['DateTime']['output'];
};

export type LicenseBankTransferSettings = {
  __typename?: 'LicenseBankTransferSettings';
  proofUploadTtlHours: Scalars['Int']['output'];
};

/** Possible duration values for License */
export enum LicenseDuration {
  OneMonth = 'ONE_MONTH',
  OneTime = 'ONE_TIME',
  SpecificPeriod = 'SPECIFIC_PERIOD',
  ThreeMonths = 'THREE_MONTHS',
  TwelveMonths = 'TWELVE_MONTHS',
  UntilEndOfCurrentYear = 'UNTIL_END_OF_CURRENT_YEAR'
}

export type LicenseIdTitleDto = {
  __typename?: 'LicenseIdTitleDto';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

export type LicenseLeague = {
  __typename?: 'LicenseLeague';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LicenseListInput = {
  duration?: InputMaybe<LicenseDuration>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  issuedCountFrom?: InputMaybe<Scalars['Int']['input']>;
  issuedCountTo?: InputMaybe<Scalars['Int']['input']>;
  issuedFrom?: InputMaybe<Scalars['DateTime']['input']>;
  issuedTo?: InputMaybe<Scalars['DateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<LicenseListOrderBy>;
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  priceFrom?: InputMaybe<Scalars['Float']['input']>;
  priceTo?: InputMaybe<Scalars['Float']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CatalogLicenseStatus>;
  type?: InputMaybe<LicenseType>;
};

export enum LicenseListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  FeeAsc = 'FEE_ASC',
  FeeDesc = 'FEE_DESC',
  IssuedCountAsc = 'ISSUED_COUNT_ASC',
  IssuedCountDesc = 'ISSUED_COUNT_DESC',
  PriceAsc = 'PRICE_ASC',
  PriceDesc = 'PRICE_DESC',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type LicensePaymentData = {
  __typename?: 'LicensePaymentData';
  additionalQuestionData?: Maybe<Scalars['String']['output']>;
  bankTransferDetails?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['Int']['output']>;
};

/** Possible statuses of a payment */
export enum LicensePaymentStatus {
  Authorized = 'AUTHORIZED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Disputed = 'DISPUTED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartiallyRefunded = 'PARTIALLY_REFUNDED',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type LicensePaymentUserPartner = {
  __typename?: 'LicensePaymentUserPartner';
  avatar?: Maybe<Scalars['String']['output']>;
  clubId?: Maybe<Scalars['Int']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  duprId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  wprUserId?: Maybe<Scalars['String']['output']>;
};

export type LicenseQuestion = {
  __typename?: 'LicenseQuestion';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  file?: Maybe<Scalars['String']['output']>;
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  purchasedLicense?: Maybe<PurchasedLicense>;
  question?: Maybe<AdditionalQuestion>;
  updatedAt: Scalars['DateTime']['output'];
};

export type LicenseResult = {
  __typename?: 'LicenseResult';
  licenses: Array<License>;
  total: Scalars['Int']['output'];
};

/** Possible statuses of PurchasedLicense */
export enum LicenseStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Upcoming = 'UPCOMING'
}

export enum LicenseType {
  ApplicationForm = 'APPLICATION_FORM',
  Certificate = 'CERTIFICATE',
  License = 'LICENSE'
}

export type ListAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export enum ListAndResultType {
  Custom = 'CUSTOM',
  UnitOrDeciplineBase = 'UNIT_OR_DECIPLINE_BASE'
}

export type ListAnnouncementLikeInput = {
  announcement?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type ListAuthMethodInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<AuthMethodName>;
};

export type ListBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  imageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type ListBannersNewInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<BannerStatus>;
};

export type ListCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamRanking?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type ListCategorySettingInput = {
  activeLicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  addMatchWonPoints?: InputMaybe<Scalars['Int']['input']>;
  addPointsScore?: InputMaybe<Scalars['Int']['input']>;
  addSetWonPoints?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  categoryType?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  considerOnlyPaidRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  considerRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  isAllowPlayerScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowRosterSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isPlayerScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isRosterAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  missingLicenses?: InputMaybe<Array<MissingLicensesType>>;
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  penaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  pointsForLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsForTie?: InputMaybe<Scalars['Int']['input']>;
  pointsForWin?: InputMaybe<Scalars['Int']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type ListCategorySettingsGroupInput = {
  categorySetting?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator?: InputMaybe<Scalars['Int']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Monolith_ClubType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListClubMembers = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type ListClubServiceInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type ListClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreamingLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredMediaToUploadResult?: InputMaybe<Scalars['Boolean']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListDefaultTeamMatchInput = {
  category?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListDisciplineInput = {
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstMatchLosersToConsolationDraw?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListFactSheetInput = {
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListFederationInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federationEmail?: InputMaybe<Scalars['String']['input']>;
  /** Opaque public id of an existing federation (e.g. fed_abc123) to attach the new platform to. */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationType?: InputMaybe<OrganizationType>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sportId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  tournatedPlatformId?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListFederationNewsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  entries?: InputMaybe<Array<Scalars['Int']['input']>>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  tempScore?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Float']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  allowUnregisteredPlayers?: InputMaybe<Scalars['Boolean']['input']>;
  bannerCover?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_full_name?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  globalCategoryLimitPerPlayer?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  isCustomFeeEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (lge_...) — alternative to numeric league */
  leaguePublicId?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  requireTournamentApproval?: InputMaybe<Scalars['Boolean']['input']>;
  socialLinks?: InputMaybe<Array<LeagueSocialLinkInput>>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tourType?: InputMaybe<TourType>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<LeagueGeoScope>;
  userId?: InputMaybe<Scalars['Float']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type ListLeagueMemberInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  member?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type ListLeagueNewsInput = {
  league?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  alternateTitle?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  englishTitle?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isAllowedToPurchaseOnTournated?: InputMaybe<Scalars['Boolean']['input']>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isPlatformGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isSendNotificationsToManager?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  licenseManager?: InputMaybe<Scalars['Int']['input']>;
  /** Optional override address for manager notifications. When set, EMAIL-channel notifications for this license route here instead of the license manager's account email. */
  managerContactEmail?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  /** Deprecated — use `platformPublicId` instead. Numeric ids will be removed once the dashboard cuts over to REST. */
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<LicenseType>;
};

export type ListLicenseQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  losingPoints?: InputMaybe<Scalars['Int']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  matchesPlayed?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerEntry?: InputMaybe<Scalars['Int']['input']>;
  pointDifference?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  setsLost?: InputMaybe<Scalars['Int']['input']>;
  setsWon?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winningPoints?: InputMaybe<Scalars['Int']['input']>;
  wins?: InputMaybe<Scalars['Int']['input']>;
};

export type ListLiveStandingsInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  highlightFrom?: InputMaybe<Scalars['Float']['input']>;
  highlightTo?: InputMaybe<Scalars['Float']['input']>;
  isDisplayPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayTeam?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListLiveStreaming = {
  __typename?: 'ListLiveStreaming';
  creationDate?: Maybe<Scalars['Float']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  externalEventID?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  location?: Maybe<LiveStreamingLocation>;
  name?: Maybe<Scalars['String']['output']>;
  scheduledEndTime?: Maybe<Scalars['Float']['output']>;
  scheduledStartTime?: Maybe<Scalars['Float']['output']>;
  sporfieCourtName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  type?: Maybe<StreamingPlatform>;
};

export type ListLiveStreamingInput = {
  companyKey?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  creationDate?: InputMaybe<Scalars['Float']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  externalEventID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  match?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeKey?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  removeFromDBOnly?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledEndTime?: InputMaybe<Scalars['Float']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['Float']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<LiveStreamingEventState>;
  thumbnailURL?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StreamingPlatform>;
};

export type ListMatchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Float']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Float']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Float']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListMatchProgressionInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<EntryType>;
  isByePossible?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MatchProgressionType>;
};

export type ListMatchesEntryInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  formatBlock?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  initialSeed?: InputMaybe<Scalars['Int']['input']>;
  isFormedPair?: InputMaybe<Scalars['Boolean']['input']>;
  pairingMode?: InputMaybe<Scalars['String']['input']>;
  partnerRegistration?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromPartner?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromRegistration?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListMatchesInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListNewsInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  postCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  postText?: InputMaybe<Scalars['String']['input']>;
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type ListOrganizationPlatformMembersInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type ListOrganizationPlatformsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationSort?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
};

export type ListPairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerNewInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric federation id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerPublicInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type ListPartnerSearchRequestInput = {
  requesterId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type ListPlatformDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalender?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListPlatformDocumentsNewInput = {
  displayOn?: InputMaybe<PlatformDocumentDisplayOn>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type ListPlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  authMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Root-level documents. Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  documents?: InputMaybe<Array<DocumentInput>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  /** Document folders (with nested documents). Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  folders?: InputMaybe<Array<DocumentFolderInput>>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  groupedPlatformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasOwnApp?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileAppSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  navigation?: InputMaybe<Array<Scalars['JSON']['input']>>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  ownAppLinks?: InputMaybe<OwnAppLinksInput>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  promoteTournatedApp?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  sendGridEmail?: InputMaybe<Scalars['String']['input']>;
  sendGridName?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName?: InputMaybe<Scalars['String']['input']>;
  signeeRole?: InputMaybe<Scalars['String']['input']>;
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type ListPlatformSettingInput = {
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEmailDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationFromEmail?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  replaceDefaultBrandName?: InputMaybe<Scalars['Boolean']['input']>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
};

export type ListPostCategoryInput = {
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};

export type ListPublicOrganizationsInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  /** Max featured leagues returned per organisation (default 3, max 20). Leagues are sorted by tournament count desc — most active first. */
  leaguesLimit?: InputMaybe<Scalars['Int']['input']>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sportId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ListPurchasedLicensesInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activePeriodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activePeriodTo?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  approvalStatus?: InputMaybe<ApprovalStatus>;
  approvalStatusArray?: InputMaybe<Array<Scalars['String']['input']>>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Int']['input']>;
  licenseStatus?: InputMaybe<Scalars['String']['input']>;
  licenseStatusArray?: InputMaybe<Array<Scalars['String']['input']>>;
  licenseTypeArray?: InputMaybe<Array<LicenseType>>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  periodFilter?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  priceRangeEnd?: InputMaybe<Scalars['Float']['input']>;
  priceRangeStart?: InputMaybe<Scalars['Float']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  proofFileUrl?: InputMaybe<Scalars['String']['input']>;
  proofUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  typeArray?: InputMaybe<Array<Scalars['String']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
  validUsers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListRankingCatgoryPointsInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  bracketTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type ListRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListRankingPointsInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListResourceServiceInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListSponsorInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type ListSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListTMatchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchRounds?: InputMaybe<Array<Scalars['String']['input']>>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentCategory?: InputMaybe<Scalars['Float']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTeamInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  members?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  registerFrom?: InputMaybe<Scalars['String']['input']>;
  registerTo?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ListTeamMemberInput = {
  importBy?: InputMaybe<Scalars['Int']['input']>;
  member?: InputMaybe<Scalars['Int']['input']>;
  memberNr?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type ListThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentAnnouncementInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  existingMedia?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  viewUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentCategoryGroupInput = {
  league?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ListTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryType?: InputMaybe<Array<Scalars['String']['input']>>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  externalLicense_RequiredMatchMode?: InputMaybe<RequiredLicenseMatchMode>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAdvancedTeamEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerCount?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelectionMendatory?: InputMaybe<Scalars['Boolean']['input']>;
  isTieBreakEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isU10Required?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  requiredUSPALicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skillLevel?: InputMaybe<SkillLevel>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRatingType?: InputMaybe<Wpr_Rating_Type>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentDiscountInput = {
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryDiscounts?: InputMaybe<Array<Scalars['JSON']['input']>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountExpireTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountPer?: InputMaybe<Scalars['Float']['input']>;
  discountStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountType?: InputMaybe<DiscountType>;
  isLimitCount?: InputMaybe<Scalars['Boolean']['input']>;
  isVTRD?: InputMaybe<Scalars['Boolean']['input']>;
  licences?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberOfCategories?: InputMaybe<Scalars['Int']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  totalCounts?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  usedCounts?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  approvedOrRejectedBy?: InputMaybe<Scalars['Float']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  competitionLevel?: InputMaybe<CompetitionLevel>;
  competitionType?: InputMaybe<CompetitionType>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Optional custom URL used in place of the default hotel booking link shown near the tournament location */
  customHotelsLink?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customMatricesType?: InputMaybe<Array<CustomMatricesType>>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  drawType?: InputMaybe<Array<DrawType>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enabledPushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<Array<GroupType>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isCPCRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMatricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDrawsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isListAndResultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMaxwillRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPairingsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  leagueType?: InputMaybe<LeagueType>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultType?: InputMaybe<Array<ListAndResultType>>;
  liveScoreAccessCode?: InputMaybe<Scalars['Float']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  overRideShowOOP?: InputMaybe<Scalars['Boolean']['input']>;
  pairingsBlockType?: InputMaybe<Array<BlockType>>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentQrCode?: InputMaybe<Scalars['Upload']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Region>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  shouldReturnCompletedTournaments?: InputMaybe<Scalars['Boolean']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showPairingsAndStandings?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<TournamentTier>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroup?: InputMaybe<Scalars['Float']['input']>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  venues?: InputMaybe<Array<UpdateTournamentVenueInput>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ListTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to the numeric league filter */
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isAddedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartner?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentIntent?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type ListTournamentTeamMembersInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTournamentVenueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type ListTransactionHistory = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountReceived?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizer?: InputMaybe<Scalars['Int']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserParentInput = {
  parent?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUserSettingInput = {
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  dmEmails?: InputMaybe<ChatDmEmails>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  mentionEmails?: InputMaybe<Scalars['Boolean']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  quietHoursStart?: InputMaybe<Scalars['Int']['input']>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type ListUsersInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  ageFrom?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  avatarFileId?: InputMaybe<Scalars['String']['input']>;
  avatarLink?: InputMaybe<Scalars['String']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['Float']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cpcPoints?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  educationEndDate?: InputMaybe<Scalars['String']['input']>;
  educationStartDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailContains?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  entriesFrom?: InputMaybe<Scalars['Float']['input']>;
  entriesTo?: InputMaybe<Scalars['Float']['input']>;
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  externalMembershipNumber?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  fivb?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  itf_points?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastPasswordResetBy?: InputMaybe<Scalars['Float']['input']>;
  lastResetPassword?: InputMaybe<Scalars['String']['input']>;
  lastSelectedLeague?: InputMaybe<Scalars['Float']['input']>;
  lastSelectedTournament?: InputMaybe<Scalars['Float']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressSameAsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  legalCity?: InputMaybe<Scalars['String']['input']>;
  legalCountry?: InputMaybe<Scalars['String']['input']>;
  legalPostalCode?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  maxwillPoints?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  mobileOtp?: InputMaybe<Scalars['String']['input']>;
  mobileOtpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_armenian?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<OrganizationType>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platforms?: InputMaybe<Array<Scalars['Int']['input']>>;
  player?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  registrationTimeFrom?: InputMaybe<Scalars['String']['input']>;
  registrationTimeTo?: InputMaybe<Scalars['String']['input']>;
  representingCountry?: InputMaybe<Scalars['String']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  signedupWith?: InputMaybe<Scalars['String']['input']>;
  signupPlatform?: InputMaybe<Scalars['Float']['input']>;
  signupSource?: InputMaybe<Signup_Source>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_armenian?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  thirdPartyFilter?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderName?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
  /** Exact Tournated-tag filter, e.g. `W6MR9P`. 6 uppercase Crockford base32 chars. */
  tournatedTag?: InputMaybe<Scalars['String']['input']>;
  uciId?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_id_2?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wechatId?: InputMaybe<Scalars['String']['input']>;
  wechatIdQrCode?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprPlayerId?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type ListUsersLicenseInput = {
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type LiveStanding = {
  __typename?: 'LiveStanding';
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  formatRound?: Maybe<FormatRound>;
  highlightFrom?: Maybe<Scalars['Float']['output']>;
  highlightTo?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isDisplayPlayer?: Maybe<Scalars['Boolean']['output']>;
  isDisplayTeam?: Maybe<Scalars['Boolean']['output']>;
  isPublished?: Maybe<Scalars['Boolean']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  playerStandings?: Maybe<Array<LiveStandingsEntry>>;
  segment?: Maybe<Scalars['String']['output']>;
  sorting?: Maybe<Scalars['String']['output']>;
  standingFor: LiveStandingFor;
  standings?: Maybe<Array<LiveStandingsEntry>>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Origin of a LiveStanding row — legacy group, or which engine FormatBlock type */
export enum LiveStandingFor {
  Americano = 'AMERICANO',
  Group = 'GROUP',
  Mexicano = 'MEXICANO',
  Swiss = 'SWISS'
}

export type LiveStandingsEntry = {
  __typename?: 'LiveStandingsEntry';
  country?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<MatchesEntry>;
  group?: Maybe<Group>;
  groupPlace?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  liveStanding?: Maybe<LiveStanding>;
  losingPoints?: Maybe<Scalars['Float']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  matchesPlayed?: Maybe<Scalars['Float']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  place?: Maybe<Scalars['Float']['output']>;
  playerEntry?: Maybe<TournamentTeamMember>;
  pointDifference?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  pointsRatio?: Maybe<Scalars['Float']['output']>;
  setRatio?: Maybe<Scalars['Float']['output']>;
  setsLost?: Maybe<Scalars['Float']['output']>;
  setsWon?: Maybe<Scalars['Float']['output']>;
  sorting?: Maybe<Scalars['String']['output']>;
  team?: Maybe<MatchesEntry>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  winningPoints?: Maybe<Scalars['Float']['output']>;
  wins?: Maybe<Scalars['Float']['output']>;
};

export type LiveStreaming = {
  __typename?: 'LiveStreaming';
  companyKey?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  externalEventID?: Maybe<Scalars['String']['output']>;
  /** Example field (placeholder) */
  id: Scalars['Int']['output'];
  link?: Maybe<Scalars['String']['output']>;
  match?: Maybe<Match>;
  name?: Maybe<Scalars['String']['output']>;
  sporfieCourtName?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  thumbnailURL?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<StreamingPlatform>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Event state */
export enum LiveStreamingEventState {
  Current = 'CURRENT',
  Future = 'FUTURE',
  Past = 'PAST'
}

export type LiveStreamingLocation = {
  __typename?: 'LiveStreamingLocation';
  geoLoc?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type LivescoreEntitlementStatus = {
  __typename?: 'LivescoreEntitlementStatus';
  allowed: Scalars['Boolean']['output'];
  reason?: Maybe<Scalars['String']['output']>;
};

export type LivescoreGrant = {
  __typename?: 'LivescoreGrant';
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  grantedBy?: Maybe<User>;
  grantedByUserId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedBy?: Maybe<User>;
  revokedByUserId?: Maybe<Scalars['Int']['output']>;
  startsAt: Scalars['DateTime']['output'];
  subjectId: Scalars['Int']['output'];
  subjectType: LivescoreGrantSubject;
  updatedAt: Scalars['DateTime']['output'];
};

/** Tier at which a livescore grant applies. TOURNAMENT covers a single event; LEAGUE (a.k.a. tour) covers every tournament under a league; ORGANIZER covers every tournament organized by a LeagueMember; PLATFORM covers every tournament under a white-label platform. */
export enum LivescoreGrantSubject {
  League = 'LEAGUE',
  Organizer = 'ORGANIZER',
  Platform = 'PLATFORM',
  Tournament = 'TOURNAMENT'
}

/** DISABLED hides the feature entirely. ENABLED exposes the viewer link + invites. */
export enum LivescoreMode {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type LivescoreTabData = {
  __typename?: 'LivescoreTabData';
  enableLiveScoring: Scalars['Boolean']['output'];
  livescoreKeyVersion: Scalars['Int']['output'];
  livescoreMode: LivescoreMode;
  livescoreViewerToken?: Maybe<Scalars['String']['output']>;
  livescoreViewerTokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  pendingProposedResultsCount: Scalars['Int']['output'];
  platformId?: Maybe<Scalars['Int']['output']>;
  platformTitle?: Maybe<Scalars['String']['output']>;
  tournamentEndDate?: Maybe<Scalars['DateTime']['output']>;
  tournamentId: Scalars['Int']['output'];
  tournamentTitle: Scalars['String']['output'];
};

export type LivescoreViewerContext = {
  __typename?: 'LivescoreViewerContext';
  tournament: Tournament;
};

export type LivescoreViewerContextInput = {
  token: Scalars['String']['input'];
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  de?: Maybe<Scalars['String']['output']>;
  el?: Maybe<Scalars['String']['output']>;
  en?: Maybe<Scalars['String']['output']>;
  es?: Maybe<Scalars['String']['output']>;
  et?: Maybe<Scalars['String']['output']>;
  fr?: Maybe<Scalars['String']['output']>;
  hi?: Maybe<Scalars['String']['output']>;
  hr?: Maybe<Scalars['String']['output']>;
  hy?: Maybe<Scalars['String']['output']>;
  it?: Maybe<Scalars['String']['output']>;
  ja?: Maybe<Scalars['String']['output']>;
  ka?: Maybe<Scalars['String']['output']>;
  ko?: Maybe<Scalars['String']['output']>;
  lt?: Maybe<Scalars['String']['output']>;
  lv?: Maybe<Scalars['String']['output']>;
  pl?: Maybe<Scalars['String']['output']>;
  pt?: Maybe<Scalars['String']['output']>;
  ru?: Maybe<Scalars['String']['output']>;
  ua?: Maybe<Scalars['String']['output']>;
  zh?: Maybe<Scalars['String']['output']>;
};

export type LocalizedTextInput = {
  de?: InputMaybe<Scalars['String']['input']>;
  el?: InputMaybe<Scalars['String']['input']>;
  en?: InputMaybe<Scalars['String']['input']>;
  es?: InputMaybe<Scalars['String']['input']>;
  et?: InputMaybe<Scalars['String']['input']>;
  fr?: InputMaybe<Scalars['String']['input']>;
  hi?: InputMaybe<Scalars['String']['input']>;
  hr?: InputMaybe<Scalars['String']['input']>;
  hy?: InputMaybe<Scalars['String']['input']>;
  it?: InputMaybe<Scalars['String']['input']>;
  ja?: InputMaybe<Scalars['String']['input']>;
  ka?: InputMaybe<Scalars['String']['input']>;
  ko?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lv?: InputMaybe<Scalars['String']['input']>;
  pl?: InputMaybe<Scalars['String']['input']>;
  pt?: InputMaybe<Scalars['String']['input']>;
  ru?: InputMaybe<Scalars['String']['input']>;
  ua?: InputMaybe<Scalars['String']['input']>;
  zh?: InputMaybe<Scalars['String']['input']>;
};

export type LocalizedValue = {
  __typename?: 'LocalizedValue';
  locale: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LocationInput = {
  geoLoc?: InputMaybe<Scalars['JSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A front-end app a user can be granted access to (client / manager / dashboard). Shared by the login flow and superAdmin impersonation. */
export enum LoginApp {
  Client = 'CLIENT',
  Dashboard = 'DASHBOARD',
  Manager = 'MANAGER'
}

export type LoginUserInput = {
  /** email of the user */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Login type: email or mobile */
  loginType?: InputMaybe<Scalars['String']['input']>;
  /** mobile number for mobile login */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** OTP for mobile login */
  otp?: InputMaybe<Scalars['String']['input']>;
  /** password of the user */
  password?: InputMaybe<Scalars['String']['input']>;
  /** platform id for login */
  platformId?: InputMaybe<Scalars['Float']['input']>;
  /** extends session expiry from 7 days to 30 days when true */
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** id of the user */
  userId?: InputMaybe<Scalars['Float']['input']>;
};

export type Maintenance = {
  __typename?: 'Maintenance';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  isUnderMaintenance?: Maybe<Scalars['Boolean']['output']>;
  maintenanceStartTime?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Map/geocoding provider for address lookups */
export enum MapProvider {
  Azure = 'AZURE',
  Google = 'GOOGLE'
}

export type Match = {
  __typename?: 'Match';
  adjustedScore?: Maybe<Scalars['String']['output']>;
  approvedByInviteJti?: Maybe<Scalars['String']['output']>;
  approvedByUserId?: Maybe<Scalars['Float']['output']>;
  bracketType?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  confirmationToken?: Maybe<Scalars['String']['output']>;
  conflict?: Maybe<Scalars['Boolean']['output']>;
  court?: Maybe<Court>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  dateBackup?: Maybe<Scalars['String']['output']>;
  dateRangeMatchStatus?: Maybe<DateRangeMatchStatus>;
  draw?: Maybe<Draw>;
  duration?: Maybe<Scalars['Float']['output']>;
  entry1?: Maybe<MatchesEntry>;
  entry1group?: Maybe<Scalars['String']['output']>;
  entry1groupId?: Maybe<Group>;
  entry1partner?: Maybe<MatchesEntry>;
  entry1pig?: Maybe<Scalars['Float']['output']>;
  entry2?: Maybe<MatchesEntry>;
  entry2group?: Maybe<Scalars['String']['output']>;
  entry2groupId?: Maybe<Group>;
  entry2partner?: Maybe<MatchesEntry>;
  entry2pig?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  firstScoreSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  formatRound?: Maybe<FormatRound>;
  gender?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Group>;
  groupEntry1?: Maybe<GroupEntry>;
  groupEntry2?: Maybe<GroupEntry>;
  groupWinner?: Maybe<GroupEntry>;
  groupWinnerPartner?: Maybe<GroupEntry>;
  hideInOOP?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isBye?: Maybe<Scalars['Boolean']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isDisqualified?: Maybe<Scalars['Boolean']['output']>;
  isDoubleRoundRobin?: Maybe<Scalars['Boolean']['output']>;
  isMatchInProgress?: Maybe<Scalars['Boolean']['output']>;
  isMatchTie?: Maybe<Scalars['Boolean']['output']>;
  isScoreConfirmed?: Maybe<Scalars['Boolean']['output']>;
  isWalkover?: Maybe<Scalars['Boolean']['output']>;
  liveStreamings?: Maybe<Array<LiveStreaming>>;
  mainMatch?: Maybe<Match>;
  matchFor?: Maybe<Scalars['String']['output']>;
  matchIndex?: Maybe<Scalars['Float']['output']>;
  matchProgression?: Maybe<Array<MatchProgression>>;
  matchStatus?: Maybe<Scalars['String']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nextMatch?: Maybe<Match>;
  notifications?: Maybe<Array<Notification>>;
  oldId?: Maybe<Scalars['Float']['output']>;
  oopType: MatchOopType;
  participant1?: Maybe<ParticipantInfo>;
  participant2?: Maybe<ParticipantInfo>;
  pendingProposedResult?: Maybe<ProposedResult>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  pointsLoss?: Maybe<Scalars['Float']['output']>;
  pointsWon?: Maybe<Scalars['Float']['output']>;
  previousMatch?: Maybe<Match>;
  result?: Maybe<MatchResult>;
  round?: Maybe<Scalars['String']['output']>;
  roundNumber?: Maybe<Scalars['Float']['output']>;
  rounds?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreActions?: Maybe<Array<MatchScoreAction>>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  team1Entry?: Maybe<Array<TournamentTeamMember>>;
  team2Entry?: Maybe<Array<TournamentTeamMember>>;
  teamMatchType?: Maybe<Scalars['String']['output']>;
  teamMembers?: Maybe<Array<TournamentTeamMember>>;
  teamScore?: Maybe<Scalars['String']['output']>;
  teamWinner?: Maybe<Array<TournamentTeamMember>>;
  time?: Maybe<Scalars['String']['output']>;
  tokenExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  tournamentRegistration?: Maybe<TournamentRegistration>;
  updatedAt: Scalars['DateTime']['output'];
  venues?: Maybe<Array<TournamentVenue>>;
  weekNumber?: Maybe<Scalars['Float']['output']>;
  winner?: Maybe<MatchesEntry>;
  winnerPartner?: Maybe<MatchesEntry>;
};

export type MatchCalendarDay = {
  __typename?: 'MatchCalendarDay';
  date: Scalars['DateTime']['output'];
  matchCount: Scalars['Int']['output'];
  singleMatch?: Maybe<MatchCalendarMatch>;
};

export type MatchCalendarDayInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  date: Scalars['DateTime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** User publicIds (`usr_…`) — NOT TournamentTeamMember ids. Same semantics as `MatchListInput.participantIds`. */
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<MatchListStatus>>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  tournamentId: Scalars['Int']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
};

export type MatchCalendarDayResult = {
  __typename?: 'MatchCalendarDayResult';
  date: Scalars['DateTime']['output'];
  matchCount: Scalars['Int']['output'];
  matches: Array<MatchCalendarMatch>;
};

export type MatchCalendarInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  from: Scalars['DateTime']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** User publicIds (`usr_…`) — NOT TournamentTeamMember ids. Server joins through `tournament_team_member` to find matches where any participant matches. Ids that do not belong to a registered participant of this tournament naturally drop out (no row → no match), so the filter is robust against stale client state. */
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<MatchListStatus>>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['DateTime']['input'];
  tournamentId: Scalars['Int']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
};

export type MatchCalendarMatch = {
  __typename?: 'MatchCalendarMatch';
  court?: Maybe<Court>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  finalScore?: Maybe<MatchFinalScore>;
  id: Scalars['Int']['output'];
  matchType?: Maybe<MatchType>;
  score?: Maybe<Scalars['String']['output']>;
  sets?: Maybe<Array<MatchSetScore>>;
  status?: Maybe<MatchStatus>;
  team?: Maybe<Team>;
  team1?: Maybe<Team>;
  team1Entry: Array<TournamentTeamMember>;
  team2?: Maybe<Team>;
  team2Entry: Array<TournamentTeamMember>;
  time?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<CategorySetting>;
  winnerSide?: Maybe<Scalars['Int']['output']>;
};

export type MatchCalendarResult = {
  __typename?: 'MatchCalendarResult';
  days: Array<MatchCalendarDay>;
  nearestFutureDate?: Maybe<Scalars['DateTime']['output']>;
  nearestPastDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MatchFinalScore = {
  __typename?: 'MatchFinalScore';
  side1: Scalars['Int']['output'];
  side2: Scalars['Int']['output'];
};

export type MatchListInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<MatchListOrderBy>;
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  /** User publicIds (`usr_…`) — NOT TournamentTeamMember ids. Server joins through `tournament_team_member` to find matches where any participant matches. Ids that do not belong to a registered participant of this tournament naturally drop out (no row → no match). */
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<MatchListStatus>>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  tournamentId: Scalars['Int']['input'];
};

export enum MatchListOrderBy {
  CategoryAsc = 'CATEGORY_ASC',
  CategoryDesc = 'CATEGORY_DESC',
  CourtAsc = 'COURT_ASC',
  CourtDesc = 'COURT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  TimeAsc = 'TIME_ASC',
  TimeDesc = 'TIME_DESC'
}

export type MatchListResult = {
  __typename?: 'MatchListResult';
  matches: Array<MatchCalendarMatch>;
  total: Scalars['Int']['output'];
};

export type MatchListStats = {
  __typename?: 'MatchListStats';
  allCount: Scalars['Int']['output'];
  completedCount: Scalars['Int']['output'];
  inProgressCount: Scalars['Int']['output'];
  upcomingCount: Scalars['Int']['output'];
};

/** Coarse lifecycle bucket used by match list/calendar filters. */
export enum MatchListStatus {
  Completed = 'COMPLETED',
  UpcomingInProgress = 'UPCOMING_IN_PROGRESS'
}

export type MatchNotificationInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  extraData?: InputMaybe<Scalars['JSONObject']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  looserId?: InputMaybe<Scalars['Int']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  participants?: InputMaybe<Array<Scalars['Int']['input']>>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  qualWinner?: InputMaybe<Scalars['Boolean']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  template?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export enum MatchOopType {
  DateRange = 'DATE_RANGE',
  SpecificTime = 'SPECIFIC_TIME'
}

export type MatchPartial = {
  __typename?: 'MatchPartial';
  court?: Maybe<Scalars['String']['output']>;
  courtName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  entry1Id?: Maybe<Scalars['Int']['output']>;
  entry2Id?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
  tournamentCity?: Maybe<Scalars['String']['output']>;
  tournamentStartDate?: Maybe<Scalars['String']['output']>;
  tournamentTitle?: Maybe<Scalars['String']['output']>;
  user1?: Maybe<Scalars['String']['output']>;
  user1Avatar?: Maybe<Scalars['String']['output']>;
  user1Id?: Maybe<Scalars['Int']['output']>;
  user1Name?: Maybe<Scalars['String']['output']>;
  user1Surname?: Maybe<Scalars['String']['output']>;
  user2?: Maybe<Scalars['String']['output']>;
  user2Avatar?: Maybe<Scalars['String']['output']>;
  user2Country?: Maybe<Scalars['String']['output']>;
  user2Id?: Maybe<Scalars['Int']['output']>;
  user2Name?: Maybe<Scalars['String']['output']>;
  user2Nation?: Maybe<Scalars['String']['output']>;
  user2Surname?: Maybe<Scalars['String']['output']>;
};

export type MatchPartialV2 = {
  __typename?: 'MatchPartialV2';
  categoryname?: Maybe<Scalars['String']['output']>;
  court?: Maybe<Court>;
  courtname?: Maybe<Scalars['String']['output']>;
  createdat?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  entry1id?: Maybe<Scalars['Int']['output']>;
  entry2id?: Maybe<Scalars['Int']['output']>;
  groupname?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Scalars['String']['output']>;
  tournamentcity?: Maybe<Scalars['String']['output']>;
  tournamentenddate?: Maybe<Scalars['DateTime']['output']>;
  tournamentid?: Maybe<Scalars['Int']['output']>;
  tournamentlogo?: Maybe<Scalars['String']['output']>;
  tournamentstartdate?: Maybe<Scalars['DateTime']['output']>;
  tournamenttitle?: Maybe<Scalars['String']['output']>;
  user1?: Maybe<Scalars['String']['output']>;
  user1avatar?: Maybe<Scalars['String']['output']>;
  user1id?: Maybe<Scalars['Int']['output']>;
  user1name?: Maybe<Scalars['String']['output']>;
  user1surname?: Maybe<Scalars['String']['output']>;
  user2?: Maybe<Scalars['String']['output']>;
  user2avatar?: Maybe<Scalars['String']['output']>;
  user2country?: Maybe<Scalars['String']['output']>;
  user2id?: Maybe<Scalars['Int']['output']>;
  user2name?: Maybe<Scalars['String']['output']>;
  user2nation?: Maybe<Scalars['String']['output']>;
  user2surname?: Maybe<Scalars['String']['output']>;
  winnerid?: Maybe<Scalars['Int']['output']>;
};

export type MatchProgression = {
  __typename?: 'MatchProgression';
  createdAt: Scalars['DateTime']['output'];
  draw?: Maybe<Draw>;
  entryType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isByePossible?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Match>;
  nextMatch?: Maybe<Match>;
  previousMatch?: Maybe<Match>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum MatchProgressionType {
  Loser = 'LOSER',
  Winner = 'WINNER'
}

export type MatchResult = {
  __typename?: 'MatchResult';
  score?: Maybe<Scalars['String']['output']>;
  score1?: Maybe<Scalars['Float']['output']>;
  score2?: Maybe<Scalars['Float']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status: MatchStatus;
  winner?: Maybe<Winner>;
};

export type MatchScore = {
  __typename?: 'MatchScore';
  blockRound?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<GroupEntry>;
  entryPartner?: Maybe<GroupEntry>;
  formatMatch?: Maybe<Match>;
  group?: Maybe<Group>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<GroupMatch>;
  matchesEntry?: Maybe<MatchesEntry>;
  opponentScore?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  roundFormat?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MatchScoreAction = {
  __typename?: 'MatchScoreAction';
  id: Scalars['Float']['output'];
  match?: Maybe<Match>;
  performedAt: Scalars['DateTime']['output'];
  performedBy?: Maybe<User>;
  score?: Maybe<Scalars['String']['output']>;
  type: MatchScoreActionType;
};

export type MatchScoreActionInput = {
  performedById?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  type: MatchScoreActionType;
};

/** Types of actions performed on a match score */
export enum MatchScoreActionType {
  Confirmed = 'CONFIRMED',
  Edited = 'EDITED',
  Rejected = 'REJECTED',
  Submitted = 'SUBMITTED',
  Withdrawn = 'WITHDRAWN'
}

export type MatchSetScore = {
  __typename?: 'MatchSetScore';
  set: Scalars['Int']['output'];
  side1?: Maybe<Scalars['Int']['output']>;
  side1Tiebreak?: Maybe<Scalars['Int']['output']>;
  side2?: Maybe<Scalars['Int']['output']>;
  side2Tiebreak?: Maybe<Scalars['Int']['output']>;
};

export type MatchStats = {
  __typename?: 'MatchStats';
  lost?: Maybe<Scalars['Int']['output']>;
  matches?: Maybe<Array<MatchPartial>>;
  total?: Maybe<Scalars['Int']['output']>;
  won?: Maybe<Scalars['Int']['output']>;
};

export type MatchStatsInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courtIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** User publicIds (`usr_…`) — NOT TournamentTeamMember ids. Same semantics as `MatchListInput.participantIds`. */
  participantIds?: InputMaybe<Array<Scalars['String']['input']>>;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  timeEnd?: InputMaybe<Scalars['String']['input']>;
  timeStart?: InputMaybe<Scalars['String']['input']>;
  tournamentId: Scalars['Int']['input'];
};

/** Status of the match */
export enum MatchStatus {
  Completed = 'completed',
  InProgress = 'inProgress',
  Upcoming = 'upcoming'
}

export enum MatchType {
  Single = 'SINGLE',
  Team = 'TEAM'
}

/** The different matches conflicts that can be found */
export enum MatchesConflicts {
  Court = 'COURT',
  Match = 'MATCH',
  Rest = 'REST'
}

export type MatchesEntry = {
  __typename?: 'MatchesEntry';
  draw?: Maybe<Draw>;
  entryType: Scalars['String']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  formatBlock?: Maybe<FormatBlock>;
  group?: Maybe<Group>;
  id: Scalars['Float']['output'];
  initialSeed?: Maybe<Scalars['Float']['output']>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  isFormedPair?: Maybe<Scalars['Boolean']['output']>;
  oldId?: Maybe<Scalars['Float']['output']>;
  pairingMode?: Maybe<Scalars['String']['output']>;
  partnerRegistration?: Maybe<TournamentRegistration>;
  place?: Maybe<Scalars['Float']['output']>;
  playerIndexFromPartner?: Maybe<Scalars['Float']['output']>;
  playerIndexFromRegistration?: Maybe<Scalars['Float']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  tournamentCategory?: Maybe<CategorySetting>;
};

export type MatchesScore = {
  __typename?: 'MatchesScore';
  createdAt: Scalars['DateTime']['output'];
  group?: Maybe<Group>;
  groupEntry?: Maybe<GroupEntry>;
  groupEntryPartner?: Maybe<GroupEntry>;
  id: Scalars['Float']['output'];
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<GroupMatch>;
  round?: Maybe<Scalars['Float']['output']>;
  roundFormat?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Media = {
  __typename?: 'Media';
  album?: Maybe<Album>;
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  photoCaption?: Maybe<Scalars['String']['output']>;
  photoLink?: Maybe<Scalars['String']['output']>;
  sort?: Maybe<Scalars['Float']['output']>;
  storageFile?: Maybe<StorageFile>;
  storageFileId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type MergeTournamentRegistrationsInput = {
  categoryId: Scalars['Int']['input'];
  isForRanking?: InputMaybe<Scalars['Boolean']['input']>;
  tournamentId: Scalars['Int']['input'];
  users?: InputMaybe<Array<Array<UserRegistrationInput>>>;
};

export type MissingLicenses = {
  __typename?: 'MissingLicenses';
  name?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type MissingLicensesType = {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type MobileAppBannerBlock = LandingBlock & {
  __typename?: 'MobileAppBannerBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type MobileVersion = {
  __typename?: 'MobileVersion';
  androidForceUpdate: Scalars['Boolean']['output'];
  androidReleaseNotes?: Maybe<Scalars['String']['output']>;
  androidVersion: Scalars['String']['output'];
  iOSForceUpdate: Scalars['Boolean']['output'];
  id: Scalars['Float']['output'];
  iosReleaseNotes?: Maybe<Scalars['String']['output']>;
  iosVersion: Scalars['String']['output'];
};

export type ModifiedFedaration = {
  __typename?: 'ModifiedFedaration';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ModifiedSport = {
  __typename?: 'ModifiedSport';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Type of club */
export enum Monolith_ClubType {
  Community = 'COMMUNITY',
  EducationalInstitution = 'EDUCATIONAL_INSTITUTION',
  Municipality = 'MUNICIPALITY'
}

export type Mutation = {
  __typename?: 'Mutation';
  ablyChatToken: AblyTokenOutput;
  addDrawEntry: Match;
  addDrawEntry1: DrawEntry;
  addDrawScore: Match;
  addDrawScore1: DrawEntry;
  addFriend: User;
  addGroupMember: Group;
  addMember: League;
  adminLogin: User;
  adminOTPVerification: User;
  approveProposedResult: ProposedResult;
  approveTournamentRegistrations: Array<TournamentRegistration>;
  assignAccessCodeToAllPlatforms: Scalars['Boolean']['output'];
  /** Assign slugs to all sports that do not have slugs */
  assignSlugsToSports: Scalars['JSONObject']['output'];
  attachTournamentRegistrationProofOfPayment: PaymentIntent;
  autoPairTournamentRegistrations: Scalars['String']['output'];
  bulkAssignLicensesFromCSV: BulkAssignLicenseResponse;
  bulkRemoveLicenses: Array<License>;
  bulkUpdateLicenses: Array<License>;
  changePassword: ChangePasswordResult;
  changeRegistrationStatus: Array<TournamentRegistration>;
  changeResultPublishStatus: Array<SportFishingResult>;
  chatAnnounceJoin: Scalars['Boolean']['output'];
  chatBlockUser: Scalars['Boolean']['output'];
  chatJoinTournament: Scalars['Boolean']['output'];
  chatLeaveRoom: Scalars['Boolean']['output'];
  chatMarkRead: Scalars['Boolean']['output'];
  chatModerateMember: Scalars['Boolean']['output'];
  chatRecordMessage: Scalars['Boolean']['output'];
  chatRejoinRoom: Scalars['Boolean']['output'];
  chatSetMuted: Scalars['Boolean']['output'];
  chatUnblockUser: Scalars['Boolean']['output'];
  checkValidations: Scalars['JSON']['output'];
  checkValidations2: Scalars['JSON']['output'];
  checkValidationsToBeDepriciated: Scalars['JSON']['output'];
  cloneTournament: Tournament;
  copyLatinPassportNames: Array<User>;
  copyLeagueCategory: Array<LeagueCategory>;
  copyRankingCategoryPoints: Array<RankingCategoryPoint>;
  copyRankingPoint: Array<RankingPoint>;
  copyTournamentCategories: Array<TournamentCategory>;
  copyTournamentRanking: TournamentRanking;
  copyTournamentRegistration: Array<TournamentRegistration>;
  createAdditionalQuestion: AdditionalQuestion;
  createAlbum: Album;
  createAmericanoBlock: FormatBlock;
  createAnnouncementComment: AnnouncementComment;
  createAthlete: Athlete;
  createAuthMethod: AuthMethod;
  /** @deprecated Use createBannerNew instead. */
  createBanner: Banner;
  createBannerNew: BannerNew;
  createBulkOrderOfPlayForFormatBlocks: BulkFormatOopResult;
  createBulkPlatformFee: Array<PlatformFee>;
  createCategory: Category;
  createCategoryRule: CategoryRule;
  createCategorySetting: CategorySetting;
  createCategorySettingsGroup: CategorySettingsGroup;
  createCategoryTournament: CategoryTournament;
  createCheckoutSession: Scalars['JSONObject']['output'];
  createClub: Club;
  createClubAdministrator: ClubAdministrator;
  createClubCoach: ClubCoach;
  createClubMember: ClubMember;
  createClubNews: ClubNews;
  createClubServiceResource: ClubServiceResource;
  createClubsFromCsv: Scalars['JSON']['output'];
  createClubsService: ClubService;
  createCourt: Court;
  createDefaultTeamMatch: DefaultTeamMatch;
  createDiscipline: Discipline;
  createDisplaySetting: DisplaySetting;
  createDraw: Draw;
  createDrawEntry: DrawEntry;
  createDrawFromGroups: Draw;
  createDrawFromGroupsWithLiveStandings: Draw;
  createDrawScore: DrawScore;
  createEmptyGroup: Array<Group>;
  createFactSheet: FactSheet;
  createFederationByAdmin: Federation;
  createFederationLeague: FederationLeague;
  createFederationNews: FederationNews;
  createFederationsFromCSV: Array<Federation>;
  createGroup: Array<Group>;
  createGroupAndcategoriesFromCSV: Scalars['JSON']['output'];
  createGroupEntry: Array<GroupEntry>;
  createGroupEntryFromCSV: Array<GroupEntry>;
  createGroupFromCSV: Array<Group>;
  createGroupMatch: Array<GroupMatch>;
  createGroupMatchesFromCSV: Array<GroupMatch>;
  createImage: Image;
  createKingFormatGroups: Array<Group>;
  createLanding: Landing;
  createLandingFromCSV: Array<Landing>;
  createLandingMember: LandingMember;
  createLandingMemberFromCSV: Array<LandingMember>;
  createLandingPotm: LandingPotm;
  createLandingPotmFromCSV: Array<LandingPotm>;
  createLandingRoadmap: LandingRoadmap;
  createLandingRoadmapFromCSV: Array<LandingRoadmap>;
  createLandingSlider: LandingSlider;
  createLandingSliderFromCSV: Array<LandingSlider>;
  createLeague: League;
  createLeagueCategory: LeagueCategory;
  createLeagueDocument: Array<LeagueDocument>;
  createLeagueMember: LeagueMember;
  createLeagueMemberRole: LeagueMemberRole;
  createLeagueNews: LeagueNews;
  createLeagueOwner: LeagueOwner;
  createLeagueRanking: Array<LeagueRanking>;
  createLeagueRankingForChess: Array<Scalars['JSONObject']['output']>;
  createLeagueRankingFromCSV: Array<LeagueRanking>;
  createLeagueTournament: LeagueTournament;
  createLeagueTournamentCategory: LeagueTournamentCategory;
  createLeaguesFromCSV: Array<League>;
  createLeaguesFromJSON: Array<League>;
  createLicense: License;
  createLicenseLeague: LicenseLeague;
  createLicensePayment: Scalars['JSONObject']['output'];
  createLicenseQuestion: LicenseQuestion;
  createLiveStanding: Array<LiveStanding>;
  createLiveStandingsEntry: LiveStandingsEntry;
  createLiveStreaming: LiveStreaming;
  createLocations: SportFishingResultEntry;
  createMaintenance: Maintenance;
  createMatch: Match;
  createMatchProgression: MatchProgression;
  createMatchScore: Array<Match>;
  createMatchScore1: Array<MatchScore>;
  createMatchesEntry: Array<MatchesEntry>;
  createMatchesScore: MatchesScore;
  createMedia: Media;
  createMediaFromCSV: Array<Media>;
  createMobileVersion: MobileVersion;
  createNews: News;
  createNewsFromJSON: Array<News>;
  createNotificationSubscription: Scalars['JSON']['output'];
  createOnboarding: Onboarding;
  createOneVenuePerTournament: Scalars['Boolean']['output'];
  createOrderOfPlay: Array<Match>;
  createOrderOfPlay1: Array<GroupMatch>;
  createOrderOfPlayDraws: Array<Match>;
  createOrderOfPlayDraws1: Array<DrawEntry>;
  createOrderOfPlayForAllGroups: Array<Match>;
  createOrderOfPlayForAllGroups1: Array<GroupMatch>;
  createOrderOfPlayForKingsFormat: Array<Match>;
  createOrderOfPlayForKingsFormat1: Array<GroupMatch>;
  createOrderofPlayForPairings: Array<Match>;
  createOrganizationPlatform: OrganizationPlatform;
  createOrganizationPlatformMember: OrganizationPlatformMember;
  createPairing: Pairing;
  createPairingEntry: PairingEntry;
  createPartner: Partner;
  createPartnerNew: PartnerNew;
  createPartnerRequest: Scalars['JSONObject']['output'];
  createPartnerSearch: PartnerSearch;
  createPartnerSearchRequest: PartnerSearchRequest;
  createPartnersFromCSV: Array<Partner>;
  createPlan: Plan;
  createPlateformSport: PlateformSport;
  createPlatform: Platform;
  createPlatformCoach: PlatformCoach;
  createPlatformCoachFromCSV: Array<PlatformCoach>;
  createPlatformDocument: PlatformDocumentNew;
  createPlatformFee: PlatformFee;
  createPlatformPage: PlatformPage;
  createPlatformSetting: PlatformSetting;
  createPlatformsFromCSV: Array<Platform>;
  createPost: Post;
  createPostCategory: PostCategory;
  createProPlan: Scalars['JSON']['output'];
  createPurchasedLicense: ResponseType;
  createPurchasedLicensesFromCSV: Array<PurchasedLicense>;
  createRankingCategoryPoint: Array<RankingCategoryPoint>;
  createRankingCategoryPointType: RankingCategoryPointType;
  createRankingPoint: RankingPoint;
  createRankingPointCategory: RankingPointCategory;
  createRankingPointRule: RankingPointRule;
  createRankingPointsFromCSV: Array<RankingPoint>;
  createRankingTournamentCategory: RankingTournamentCategory;
  createRecords: Scalars['JSON']['output'];
  createRecordsForDoubles: Scalars['JSON']['output'];
  createRecordsForSingle: Scalars['JSON']['output'];
  createRegistrationRequest: TournamentRegistration;
  createResourceService: ResourceService;
  createRole: Role;
  createRound: Round;
  createSponsor: Sponsor;
  createSport: Sport;
  createSportFishingEntriesMatric: SportFishingEntriesMatric;
  createSportFishingEntriesMatricsFromCSV: Array<Scalars['String']['output']>;
  createSportFishingEntriesMetricFromCSV: Array<SportFishingEntriesMatric>;
  createSportFishingMatric: SportFishingMatric;
  createSportFishingMetricContext: SportFishingMetricContext;
  createSportFishingMetricFromCSV: Array<SportFishingMatric>;
  createSportFishingResult: SportFishingResult;
  createSportFishingResultEntry: SportFishingResultEntry;
  createSportFishingResultForManualEntries: SportFishingResult;
  createSportFishingResultFromCSV: Array<SportFishingResult>;
  createStat: Stat;
  createStripePayment: Scalars['JSONObject']['output'];
  createStripeSession: Scalars['JSONObject']['output'];
  createSubscription: Subscription;
  createSwissBlock: FormatBlock;
  createTeamDrawEntry: Match;
  createTeamDrawEntry1: DrawEntry;
  createTeamGroupMatch: GroupMatch;
  createTeamMatchScore: Array<Match>;
  createTeamMatchScore1: Array<MatchScore>;
  createTeamMember: TeamMember;
  createTeamRegistrationRequest: TournamentRegistration;
  createTemplate: Template;
  createThirdPartyLicense: ThirdPartyLicense;
  createTournament: Tournament;
  createTournamentAdditionalReferee: TournamentAdditionalReferee;
  createTournamentAnnouncement: TournamentAnnouncement;
  createTournamentCategoriesFromCSV: Array<TournamentCategory>;
  createTournamentCategory: TournamentCategory;
  createTournamentCategoryGroup: TournamentCategoryGroup;
  createTournamentCategoryLicense: TournamentCategoryLicense;
  createTournamentDiscount: TournamentDiscount;
  createTournamentDocument: TournamentDocument;
  createTournamentFactSheet: TournamentFactSheet;
  createTournamentFactSheets: Array<TournamentFactSheet>;
  createTournamentOrganizer: TournamentOrganizer;
  createTournamentRanking: TournamentRanking;
  createTournamentRankingEntryFromCSV: Array<TournamentRankingsEntry>;
  createTournamentRankingFromCSV: Array<TournamentRanking>;
  createTournamentRankingsEntry: TournamentRankingsEntry;
  createTournamentRankingsMan: TournamentRankingsMan;
  createTournamentRankingsWoman: TournamentRankingsWoman;
  createTournamentReferee: TournamentReferee;
  createTournamentRegistration: TournamentRegistration;
  createTournamentRegistrationPayment: Scalars['JSONObject']['output'];
  createTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  createTournamentRegistrations: Array<TournamentRegistration>;
  createTournamentRegistrationsFromCSVAsync: Array<TournamentRegistration>;
  createTournamentTeamMember: TournamentTeamMember;
  createTournamentVenue: TournamentVenue;
  createTournamentsFromCSV: Array<Tournament>;
  createTournamentsFromCSVAsync: Array<Tournament>;
  createTournamentsFromJSON: Array<Tournament>;
  createTransactionHistory: TransactionHistory;
  createUserCoach: UserCoach;
  createUserLicense: UserLicense;
  createUserParent: UserParent;
  createUserPlan: UserPlan;
  createUserPurchasedLicense: ResponseType;
  createUserSetting: UserSetting;
  createUserSport: UserSport;
  createUsersFromCSV: Array<User>;
  createUsersFromCSV2: Scalars['String']['output'];
  createUsersFromJSON: Array<User>;
  deleteAthleteQuestionAnswer: Scalars['Boolean']['output'];
  deleteBannerNew: DeleteOutput;
  deleteFormatBlock: Scalars['Int']['output'];
  deleteFormatMatch: Match;
  deleteLastUnlockedFormatRound: Scalars['Int']['output'];
  deletePartnerNew: DeleteOutput;
  deletePlatformDocument: DeleteOutput;
  deletePost: Scalars['Boolean']['output'];
  deleteRequest: TournamentTeamMember;
  deleteSportFishingEntriesMatricMedia: SportFishingEntriesMatric;
  deleteTournamentCategoryGroup: TournamentCategoryGroup;
  deleteTournamentMatches: Array<Match>;
  deleteTournamentMatches1: Array<Scalars['JSONObject']['output']>;
  deleteTournamentTeamMatches: Array<Scalars['JSONObject']['output']>;
  endLiveStreaming: LiveStreaming;
  extendLicense: PurchasedLicense;
  extendSubscription: Scalars['JSON']['output'];
  findAllUserSubscriptions: Scalars['JSON']['output'];
  findDrawEntryWinner: Scalars['JSONObject']['output'];
  findDrawEntryWinner1: Scalars['JSONObject']['output'];
  findStats: Scalars['JSONObject']['output'];
  finishDashboardV3Tour: User;
  forgetPassword: GeneralReturnType;
  forgotResetPassword: User;
  forwardByes: Array<DrawEntry>;
  generateApiKey: GenerateApiKeyResponse;
  generateRound1Pairings: FormatBlock;
  generateRoundPairings: FormatBlock;
  getOTPThroughToken: Scalars['JSONObject']['output'];
  hideUnhideAllDraws: Array<Draw>;
  hideUnhideAllGroups: Array<Group>;
  hideUnhideAllLiveStandings: Scalars['Boolean']['output'];
  impersonateUser: ImpersonationTokenOutput;
  initDefaultPlatformSettings: Array<PlatformSetting>;
  initiateAuthV2: UserAuth;
  inviteScorer: ScorerInviteWithLink;
  likeAnnouncement: GeneralReturnType;
  logOut: UserLogout;
  login: User;
  logoutUser: UserLogout;
  masterUpdateRegistrationSegment: Array<TournamentRegistration>;
  mergeTournamentRegistrations: Scalars['String']['output'];
  moveMatchOrder: Scalars['Boolean']['output'];
  moveStandingOrder: Scalars['Boolean']['output'];
  prepareMatchResults: Scalars['JSON']['output'];
  /** Re-runs the skill-level + tournament-tier classifier on every tournament_category and tournament. Super-admin only. Use after improving classifier rules. */
  reclassifyAllCategories: ReclassifyResultOutput;
  recoverSingleGroup: Group;
  refreshLiveStanding: LiveStanding;
  refreshTeamMembersInRegistration: GeneralReturnType;
  /** Regenerates a new unique 6-digit livescore access code for a tournament */
  regenerateLiveScoreCode: Tournament;
  regeneratePlatformAccessCode: Platform;
  rejectProposedResult: ProposedResult;
  rejectTournamentRegistrations: Array<TournamentRegistration>;
  removeAdditionalQuestion: AdditionalQuestion;
  removeAlbum: Album;
  removeAnnouncementComment: AnnouncementComment;
  removeAthlete: Athlete;
  removeAuthMethod: GeneralReturnType;
  /** @deprecated Use deleteBannerNew instead. */
  removeBanner: Banner;
  removeCache: Scalars['JSON']['output'];
  removeCategoriesFromTournamentCategoryGroup: TournamentCategoryGroup;
  removeCategory: Category;
  removeCategoryRule: CategoryRule;
  removeCategorySetting: CategorySetting;
  removeCategorySettingsGroup: Scalars['Boolean']['output'];
  removeCategoryTournament: CategoryTournament;
  removeClub: Club;
  removeClubAdministrator: ClubAdministrator;
  removeClubCoach: ClubCoach;
  removeClubMember: ClubMember;
  removeClubNews: ClubNews;
  removeClubServiceResource: ClubServiceResource;
  removeClubsService: ClubService;
  removeCourt: Court;
  removeDefaultTeamMatch: DefaultTeamMatch;
  removeDiscipline: Discipline;
  removeDisplaySetting: DisplaySetting;
  removeDraw: Draw;
  removeDrawEntry: Array<DrawEntry>;
  removeDrawMatch: Array<DrawEntry>;
  removeDrawMatchScore: Array<Match>;
  removeDrawMatchScore1: Array<DrawEntry>;
  removeDrawScore: DrawScore;
  removeFactSheet: FactSheet;
  removeFederation: Federation;
  removeFederationLeague: FederationLeague;
  removeFederationNews: FederationNews;
  removeFriend: User;
  removeGroup: Group;
  removeGroupEntry1: Array<GroupEntry>;
  removeGroupMatch: GroupMatch;
  removeImage: Image;
  removeLanding: Landing;
  removeLandingMember: LandingMember;
  removeLandingPotm: LandingPotm;
  removeLandingRoadmap: LandingRoadmap;
  removeLandingSlider: LandingSlider;
  removeLeague: League;
  removeLeagueCategory: Array<LeagueCategory>;
  removeLeagueDocument: LeagueDocument;
  removeLeagueMember: LeagueMember;
  removeLeagueMemberRole: LeagueMemberRole;
  removeLeagueNews: LeagueNews;
  removeLeagueOwner: LeagueOwner;
  removeLeagueRanking: LeagueRanking;
  removeLeagueRankings: Array<LeagueRanking>;
  removeLeagueTournament: LeagueTournament;
  removeLeagueTournamentCategory: LeagueTournamentCategory;
  removeLicense: License;
  removeLicenseLeague: LicenseLeague;
  removeLicenseQuestion: LicenseQuestion;
  removeLiveStanding: LiveStanding;
  removeLiveStandingsEntry: Scalars['Boolean']['output'];
  removeLiveStreaming: LiveStreaming;
  removeMaintenance: Scalars['Boolean']['output'];
  removeMatch: Match;
  removeMatchProgression: MatchProgression;
  removeMatchScore: MatchScore;
  removeMatchesEntry: Array<MatchesEntry>;
  removeMatchesScore: MatchesScore;
  removeMedia: Media;
  removeMediaList: Array<Media>;
  removeMobileVersion: Scalars['Boolean']['output'];
  removeMultipleDraws: Array<Draw>;
  removeMultipleGroups: Array<Group>;
  removeMultipleStandings: Array<LiveStanding>;
  removeMultipleTournamentRankings: TournamentRanking;
  removeMultipleTournamentRankingsEntries: Array<TournamentRankingsEntry>;
  removeNews: News;
  removeNotificationSubscription: Scalars['JSON']['output'];
  removeOnboarding: Onboarding;
  removeOrganizationPlatform: Scalars['JSON']['output'];
  removeOrganizationPlatformMember: OrganizationPlatformMember;
  removePairing: Pairing;
  removePairingEntry: PairingEntry;
  removePartner: Partner;
  removePartnerSearch: PartnerSearch;
  removePartnerSearchRequest: PartnerSearchRequest;
  removePlan: Plan;
  removePlateformSport: PlateformSport;
  removePlatform: Platform;
  removePlatformCoach: PlatformCoach;
  removePlatformFee: PlatformFee;
  removePlatformPage: PlatformPage;
  removePlatformSetting: GeneralReturnType;
  removePostCategory: PostCategory;
  removePurchasedLicense: PurchasedLicense;
  removeRankingCategoryPoint: RankingCategoryPoint;
  removeRankingCategoryPointType: RankingCategoryPointType;
  removeRankingPoint: RankingPoint;
  removeRankingPointCategory: RankingPointCategory;
  removeRankingPointRule: RankingPointRule;
  removeRankingPoints: Scalars['JSONObject']['output'];
  removeRankingTournamentCategory: RankingTournamentCategory;
  removeResourceService: ResourceService;
  removeRole: Role;
  removeRound: Round;
  removeSingleGroup: Group;
  removeSponsor: Sponsor;
  removeSport: Sport;
  removeSportFishingEntriesMatric: SportFishingEntriesMatric;
  removeSportFishingEntriesMatricBulk: Array<SportFishingEntriesMatric>;
  removeSportFishingMatric: SportFishingMatric;
  removeSportFishingResult: SportFishingResult;
  removeSportFishingResultEntry: SportFishingResultEntry;
  removeStat: Stat;
  removeSubscription: Subscription;
  removeTeamMatch: Scalars['Boolean']['output'];
  removeTeamMember: TeamMember;
  removeTemplate: Template;
  removeThirdPartyLicense: ThirdPartyLicense;
  removeTournament: Tournament;
  removeTournamentAdditionalReferee: TournamentAdditionalReferee;
  removeTournamentAnnouncement: Scalars['Boolean']['output'];
  removeTournamentCategory: Array<TournamentCategory>;
  removeTournamentCategoryGroup: TournamentCategoryGroup;
  removeTournamentCategoryLicense: TournamentCategoryLicense;
  removeTournamentDiscount: TournamentDiscount;
  removeTournamentDocument: TournamentDocument;
  removeTournamentDraw: Draw;
  removeTournamentFactSheet: TournamentFactSheet;
  removeTournamentRanking: TournamentRanking;
  removeTournamentRankingsEntry: TournamentRankingsEntry;
  removeTournamentRankingsMan: TournamentRankingsMan;
  removeTournamentRankingsWoman: TournamentRankingsWoman;
  removeTournamentReferee: TournamentReferee;
  removeTournamentRegistration: TournamentRegistration;
  removeTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  removeTournamentRegulation: Tournament;
  removeTournamentTeamMember: TournamentTeamMember;
  removeTournamentVenue: TournamentVenue;
  removeTransactionHistory: TransactionHistory;
  removeUser: User;
  removeUserAccount: User;
  removeUserCoach: UserCoach;
  removeUserLicense: UserLicense;
  removeUserParent: UserParent;
  removeUserPlan: UserPlan;
  removeUserSetting: GeneralReturnType;
  removeUserSport: UserSport;
  renewUserLicense: ResponseType;
  reorderLiveStandingsEntries: Scalars['Boolean']['output'];
  requestPasswordResetOtp: RequestPasswordResetOtpResult;
  resendScorerInvite: ScorerInviteWithLink;
  resetLeagueRankingsCronCategories: LeagueRankingsCron;
  resetPasswordWithToken: ResetPasswordWithTokenResult;
  restoreClub: Club;
  restoreLeague: League;
  restoreTournament: Tournament;
  revokeApiKey: Scalars['Boolean']['output'];
  revokeScorerInvite: TournamentScorerInvite;
  rotateLivescoreViewerToken: Tournament;
  scorerInviteHeartbeat: Scalars['Boolean']['output'];
  sendEmailtest: Scalars['JSONObject']['output'];
  sendMobileOTP: Scalars['String']['output'];
  sendNotification: Scalars['String']['output'];
  setLeagueLivescoreEnabled: LeagueLivescoreEnabledPayload;
  setLeagueRankingsCronCategories: LeagueRankingsCron;
  setOrganizerLivescoreEnabled: OrganizerLivescoreEnabledPayload;
  setPlatformLivescoreEnabled: PlatformLivescoreEnabledPayload;
  setTournamentLivescoreEnabled: Tournament;
  setTournamentLivescoreMode: Tournament;
  signOutOtherSessions: Scalars['Int']['output'];
  signOutSession: Scalars['Boolean']['output'];
  signUp: User;
  socialAuthCheck: SocialAuthCheckResult;
  socialAuthLink: Scalars['Boolean']['output'];
  socialAuthLogin: User;
  socialAuthRegister: SocialAuthRegisterResult;
  socialLogin: User;
  softDeleteClub: Club;
  softDeleteLeague: League;
  softDeleteTournament: Tournament;
  submitBookingForm: BookingForm;
  submitFormatMatchResult: Match;
  submitProposedResult: SubmitProposedResultPayload;
  submitResults: SportFishingResultEntry;
  subscriptionFilters: SubscriptionFilters;
  swapDrawMatches: Array<DrawEntry>;
  swapGroupEntries: Array<Scalars['JSON']['output']>;
  swapGroupMatches: Array<GroupMatch>;
  swapLiveStandingsOrder: Scalars['Boolean']['output'];
  swapMatchEntriesForDraws: Array<Match>;
  swapMatches: Array<Match>;
  syncWPRData: Scalars['Boolean']['output'];
  syncWPRDataAllUsers: Scalars['JSONObject']['output'];
  syncWPRDataBulk: Array<Scalars['JSONObject']['output']>;
  syncWprProfileByIdOnly: Scalars['Boolean']['output'];
  toggleFormatRoundLock: FormatRound;
  toggleNotificationSubscription: Scalars['JSON']['output'];
  tournamentLogin: User;
  tournamentRegistrationAndPayment: CheckoutSessionResult;
  triggerLeagueRankingsCron: Scalars['JSONObject']['output'];
  triggerUnderagePlayersUpload: Scalars['Boolean']['output'];
  unlikeAnnouncement: GeneralReturnType;
  unlinkSocialAuth: UnlinkSocialAuthResult;
  updateAdditionalQuestion: AdditionalQuestion;
  updateAlbum: Album;
  updateAnnouncementComment: AnnouncementComment;
  updateAthlete: Athlete;
  updateAuthMethod: AuthMethod;
  /** @deprecated Use updateBannerNew instead. */
  updateBanner: Banner;
  updateBannerNew: BannerNew;
  /** @deprecated Use updateBulkBannerNew instead. */
  updateBulkBanner: Array<Banner>;
  updateBulkBannerNew: Array<BannerNew>;
  updateBulkPartnersNew: Array<PartnerNew>;
  updateBulkPlatformDocuments: Array<PlatformDocumentNew>;
  updateBulkPlatformFee: Array<PlatformFee>;
  updateCategory: Category;
  updateCategoryRule: CategoryRule;
  updateCategorySetting: CategorySetting;
  updateCategorySettings: Array<CategorySetting>;
  updateCategorySettingsGroup: CategorySettingsGroup;
  updateCategoryTournament: CategoryTournament;
  updateClub: Club;
  updateClubAdministrator: ClubAdministrator;
  updateClubCoach: ClubCoach;
  /** @deprecated Use REST PATCH /api/dashboard/v1/clubs/:clubId/members/:memberId/status */
  updateClubMember: ClubMember;
  updateClubNews: ClubNews;
  updateClubServiceResource: ClubServiceResource;
  updateClubsService: ClubService;
  updateCourt: Court;
  updateCourtSorting: Array<Court>;
  updateCustomMatricsSorting: Array<SportFishingMatric>;
  updateDUPRRating: Array<TournamentRegistration>;
  updateDefaultTeamMatch: DefaultTeamMatch;
  updateDiscipline: Discipline;
  updateDisciplineSorting: Array<Discipline>;
  updateDisplaySetting: DisplaySetting;
  updateDraw: Draw;
  updateDrawEntry: Array<Match>;
  updateDrawEntry1: Array<DrawEntry>;
  updateDrawMatchAction: Match;
  updateDrawScore: DrawScore;
  updateFactSheet: FactSheet;
  updateFactSheetSorting: Array<FactSheet>;
  updateFederationLeague: FederationLeague;
  updateFederationNews: FederationNews;
  updateFormatBlock: FormatBlock;
  updateFormatRoundVisibility: FormatRound;
  updateGroup: Group;
  updateGroupEntry: GroupEntry;
  updateGroupMatch: GroupMatch;
  updateGroupPositions: Array<Scalars['JSONObject']['output']>;
  updateImage: Image;
  updateLanding: Landing;
  updateLandingMember: LandingMember;
  updateLandingPotm: LandingPotm;
  updateLandingRoadmap: LandingRoadmap;
  updateLandingSlider: LandingSlider;
  updateLeageCustomFees: League;
  updateLeague: League;
  updateLeagueCategory: Array<LeagueCategory>;
  updateLeagueDocument: LeagueDocument;
  updateLeagueDocumentSorting: Array<LeagueDocument>;
  updateLeagueMember: LeagueMember;
  updateLeagueMemberRole: LeagueMemberRole;
  updateLeagueNews: LeagueNews;
  updateLeagueRanking: LeagueRanking;
  updateLeagueRankingPoints: Array<LeagueRanking>;
  updateLeagueRankings: Array<LeagueRanking>;
  updateLeagueTournament: LeagueTournament;
  updateLeagueTournamentCategory: LeagueTournamentCategory;
  updateLicense: License;
  updateLicenseLeague: LicenseLeague;
  updateLicenseQuestion: LicenseQuestion;
  updateLiveStanding: LiveStanding;
  updateLiveStandingPublishStatus: Scalars['Boolean']['output'];
  updateLiveStandingsEntry: LiveStandingsEntry;
  updateLiveStreaming: LiveStreaming;
  updateMaintenance: Maintenance;
  updateMatch: Match;
  updateMatchAction: Match;
  updateMatchProgression: MatchProgression;
  updateMatchScore: MatchScore;
  updateMatchesEntry: MatchesEntry;
  updateMatchesScore: MatchesScore;
  updateMedia: Media;
  updateMobileVersion: MobileVersion;
  updateMultipleCourts: Array<Court>;
  updateMultipleDrawMatches: Array<Scalars['JSONObject']['output']>;
  updateMultipleDrawMatches1: Array<Scalars['JSONObject']['output']>;
  updateMultipleGroupMatches: Array<Match>;
  updateMultipleGroupMatches1: Array<MatchScore>;
  updateMultipleGroups: Array<Group>;
  updateMultipleMatches: Array<Match>;
  updateMultipleRankingCategoryPoints: Array<RankingCategoryPoint>;
  updateNews: News;
  updateNotificationSubscription: Scalars['JSON']['output'];
  updateOnboarding: Onboarding;
  updateOrganizationPlatform: OrganizationPlatform;
  updateOrganizationPlatformMember: OrganizationPlatformMember;
  updatePairing: Pairing;
  updatePairingEntry: PairingEntry;
  updatePairingScore: PairingEntry;
  updatePartner: Partner;
  updatePartnerNew: PartnerNew;
  updatePartnerSearch: PartnerSearch;
  updatePartnerSorting: Array<Partner>;
  updatePlan: Plan;
  updatePlateformSport: PlateformSport;
  updatePlatform: Platform;
  updatePlatformCoach: PlatformCoach;
  updatePlatformDocument: PlatformDocumentNew;
  updatePlatformFee: PlatformFee;
  updatePlatformPage: PlatformPage;
  updatePlatformSetting: PlatformSetting;
  updatePost: Post;
  updatePostCategory: PostCategory;
  updatePurchasedLicense: PurchasedLicense;
  updateRankingCategoryPointType: RankingCategoryPointType;
  updateRankingCategoryPoints: Array<RankingCategoryPoint>;
  updateRankingPoint: Array<RankingCategoryPoint>;
  updateRankingPointCategory: RankingPointCategory;
  updateRankingPointRule: RankingPointRule;
  updateRankingTournamentCategory: RankingTournamentCategory;
  updateRegistrationRequest: TournamentRegistration;
  updateRegistrationSegment: Array<TournamentRegistration>;
  updateRegistrationsRankings: Array<TournamentRegistration>;
  updateResourceService: ResourceService;
  updateRole: Role;
  updateRound: Round;
  updateSimpleRankingPoint: RankingPoint;
  updateSponsor: Sponsor;
  updateSponsorSorting: Array<Sponsor>;
  updateSport: Sport;
  updateSportFishingEntriesMatric: SportFishingEntriesMatric;
  updateSportFishingEntriesMatricBulk: Array<SportFishingEntriesMatric>;
  updateSportFishingMatric: SportFishingMatric;
  updateSportFishingResult: SportFishingResult;
  updateSportFishingResultEntry: SportFishingResultEntry;
  updateSportSorting: Array<Sport>;
  updateSubscription: Subscription;
  updateTeamMember: TeamMember;
  updateTemplate: Template;
  updateThirdPartyLicense: ThirdPartyLicense;
  updateTournament: Tournament;
  updateTournamentAdditionalReferee: TournamentAdditionalReferee;
  updateTournamentAnnouncement: TournamentAnnouncement;
  updateTournamentCategories: Array<TournamentCategory>;
  updateTournamentCategory: TournamentCategory;
  updateTournamentCategoryGroup: TournamentCategoryGroup;
  updateTournamentCategoryLicense: TournamentCategoryLicense;
  updateTournamentCategorySorting: Array<TournamentCategory>;
  updateTournamentDiscount: TournamentDiscount;
  updateTournamentDocument: TournamentDocument;
  updateTournamentFactSheet: TournamentFactSheet;
  updateTournamentMatches: Array<Scalars['JSONObject']['output']>;
  updateTournamentOrganizer: TournamentOrganizer;
  updateTournamentRanking: TournamentRanking;
  updateTournamentRankingsEntry: TournamentRankingsEntry;
  updateTournamentRankingsMan: TournamentRankingsMan;
  updateTournamentRankingsWoman: TournamentRankingsWoman;
  updateTournamentReferee: TournamentReferee;
  updateTournamentRegistration: TournamentRegistration;
  updateTournamentRegistrationQuestion: TournamentRegistrationQuestion;
  updateTournamentRegistrations: Array<TournamentRegistration>;
  updateTournamentTeamMember: TournamentTeamMember;
  updateTournamentTeamMemberDUPR: TournamentRegistration;
  updateTournamentVenue: TournamentVenue;
  updateTournamentsCountry: Array<Tournament>;
  updateTournamentsFromCSVAsync: Array<Tournament>;
  updateTransactionHistory: TransactionHistory;
  updateTransactionHistoryByPaymentIntent: TransactionHistory;
  updateUser: User;
  updateUserCoach: UserCoach;
  updateUserGender: UsersResult;
  /** @deprecated Use `mergeUsers` instead. This mutation lacks federation-scope authorization and is not transactional; it will be removed once all clients are migrated. */
  updateUserInRequests: Array<TournamentTeamMember>;
  updateUserLicense: UserLicense;
  updateUserParent: UserParent;
  updateUserPassword: User;
  updateUserPasswordByAdmin: User;
  updateUserPasswordWeb: User;
  updateUserPlan: UserPlan;
  updateUserPlatform: Array<User>;
  updateUserSetting: UserSetting;
  updateUserSport: UserSport;
  updateUsersPlatform: User;
  uploadTeamMembersCSV: UploadTeamMembersResponse;
  uploadUnderagePlayers: Scalars['Boolean']['output'];
  upsertAthleteQuestionAnswer: AthleteQuestionAnswer;
  upsertPlatformPage: PlatformPage;
  userLogin: UserLoginResult;
  validateUserOnInviteAccept: Scalars['JSON']['output'];
  verifyMobileNumber: User;
  verifyPasswordResetOtp: VerifyPasswordResetOtpResult;
  verifyUserLoginOtp: UserLoginResult;
  withdrawRegistrations: TournamentRegistration;
};


export type MutationAblyChatTokenArgs = {
  tournamentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationAddDrawEntryArgs = {
  updateMatchInput: UpdateMatchInput;
};


export type MutationAddDrawEntry1Args = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationAddDrawScoreArgs = {
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  updateMatchInput: UpdateMatchInput;
};


export type MutationAddDrawScore1Args = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationAddFriendArgs = {
  friendId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationAddGroupMemberArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationAddMemberArgs = {
  updateLeagueInput: UpdateLeagueInput;
};


export type MutationAdminLoginArgs = {
  query: LoginUserInput;
};


export type MutationAdminOtpVerificationArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


export type MutationApproveProposedResultArgs = {
  input: ApproveProposedResultInput;
};


export type MutationApproveTournamentRegistrationsArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationAttachTournamentRegistrationProofOfPaymentArgs = {
  proofOfPayment?: InputMaybe<Scalars['Upload']['input']>;
  proofOfPaymentUrl?: InputMaybe<Scalars['String']['input']>;
  tournamentRegistrationId: Scalars['Int']['input'];
};


export type MutationAutoPairTournamentRegistrationsArgs = {
  filter: AutoPairTournamentRegistrationsInput;
};


export type MutationBulkAssignLicensesFromCsvArgs = {
  bulkAssignLicensesInput: BulkAssignLicensesInput;
};


export type MutationBulkRemoveLicensesArgs = {
  input: BulkRemoveLicenseInput;
};


export type MutationBulkUpdateLicensesArgs = {
  input: BulkUpdateLicenseInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeRegistrationStatusArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};


export type MutationChangeResultPublishStatusArgs = {
  updateSportFishingResultInput: UpdateSportFishingResultInput;
};


export type MutationChatAnnounceJoinArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationChatBlockUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationChatJoinTournamentArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationChatLeaveRoomArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationChatMarkReadArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationChatModerateMemberArgs = {
  action: Scalars['String']['input'];
  roomId: Scalars['String']['input'];
  targetUserId: Scalars['Int']['input'];
};


export type MutationChatRecordMessageArgs = {
  authorName?: InputMaybe<Scalars['String']['input']>;
  mentionedUserIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  preview?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
};


export type MutationChatRejoinRoomArgs = {
  roomId: Scalars['String']['input'];
};


export type MutationChatSetMutedArgs = {
  muted: Scalars['Boolean']['input'];
  roomId: Scalars['String']['input'];
};


export type MutationChatUnblockUserArgs = {
  userId: Scalars['Int']['input'];
};


export type MutationCheckValidationsArgs = {
  category: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};


export type MutationCheckValidations2Args = {
  category: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
};


export type MutationCheckValidationsToBeDepriciatedArgs = {
  category: Scalars['Int']['input'];
  checkForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excludeRegistrationId?: InputMaybe<Scalars['Int']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isPartneredRequestConnection?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  primaryWprPlayerIdOrEmail?: InputMaybe<Scalars['String']['input']>;
  searchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
  tournament: Scalars['Int']['input'];
  wprPlayerIdOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCloneTournamentArgs = {
  endDate: Scalars['String']['input'];
  entryDeadline: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  title: Scalars['String']['input'];
  tournamentId: Scalars['Float']['input'];
  withdrawlDeadline: Scalars['String']['input'];
};


export type MutationCopyLeagueCategoryArgs = {
  catIds: Array<Scalars['Int']['input']>;
  leagueId: Scalars['Int']['input'];
};


export type MutationCopyRankingCategoryPointsArgs = {
  createRankingCategoryPointInput: CreateRankingCategoryPointInput;
};


export type MutationCopyRankingPointArgs = {
  createRankingPointInput: CreateRankingPointInput;
};


export type MutationCopyTournamentCategoriesArgs = {
  ids: Array<Scalars['Int']['input']>;
  leagueId: Scalars['Int']['input'];
};


export type MutationCopyTournamentRankingArgs = {
  createTournamentRankingInput: CreateTournamentRankingInput;
};


export type MutationCopyTournamentRegistrationArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateAdditionalQuestionArgs = {
  createAdditionalQuestionInput: CreateAdditionalQuestionInput;
};


export type MutationCreateAlbumArgs = {
  createAlbumInput: CreateAlbumInput;
};


export type MutationCreateAmericanoBlockArgs = {
  input: CreateAmericanoBlockInput;
};


export type MutationCreateAnnouncementCommentArgs = {
  createAnnouncementCommentInput: CreateAnnouncementCommentInput;
};


export type MutationCreateAthleteArgs = {
  createAthleteInput: CreateAthleteInput;
};


export type MutationCreateAuthMethodArgs = {
  createAuthMethodInput: CreateAuthMethodInput;
};


export type MutationCreateBannerArgs = {
  createBannerInput: CreateBannerInput;
};


export type MutationCreateBannerNewArgs = {
  createBannerInput: CreateBannerInputNew;
};


export type MutationCreateBulkOrderOfPlayForFormatBlocksArgs = {
  input: CreateBulkFormatOopInput;
};


export type MutationCreateBulkPlatformFeeArgs = {
  createPlatformFeeInput: Array<CreatePlatformFeeInput>;
};


export type MutationCreateCategoryArgs = {
  createCategoryInput: CreateCategoryInput;
};


export type MutationCreateCategoryRuleArgs = {
  createCategoryRuleInput: CreateCategoryRuleInput;
};


export type MutationCreateCategorySettingArgs = {
  createCategorySettingInput: CreateCategorySettingInput;
};


export type MutationCreateCategorySettingsGroupArgs = {
  createCategorySettingsGroupInput: CreateCategorySettingsGroupInput;
};


export type MutationCreateCategoryTournamentArgs = {
  createCategoryTournamentInput: CreateCategoryTournamentInput;
};


export type MutationCreateCheckoutSessionArgs = {
  createRegistrationPaymentInput: CreateRegistrationPaymentInput;
  paymentProvider: PaymentProvider;
};


export type MutationCreateClubArgs = {
  createClubInput: CreateClubInput;
  createClubServiceResourceInput?: InputMaybe<Array<CreateClubServiceResourceInput>>;
};


export type MutationCreateClubAdministratorArgs = {
  createClubAdministratorInput: CreateClubAdministratorInput;
};


export type MutationCreateClubCoachArgs = {
  createClubCoachInput: CreateClubCoachInput;
};


export type MutationCreateClubMemberArgs = {
  createClubMemberInput: CreateClubMemberInput;
};


export type MutationCreateClubNewsArgs = {
  createClubNewsInput: CreateClubNewsInput;
};


export type MutationCreateClubServiceResourceArgs = {
  createClubServiceResourceInput: CreateClubServiceResourceInput;
};


export type MutationCreateClubsServiceArgs = {
  createClubsServiceInput: CreateClubsServiceInput;
};


export type MutationCreateCourtArgs = {
  createCourtInput: CreateCourtInput;
};


export type MutationCreateDefaultTeamMatchArgs = {
  createDefaultTeamMatchInput: CreateDefaultTeamMatchInput;
};


export type MutationCreateDisciplineArgs = {
  createDisciplineInput: CreateDisciplineInput;
};


export type MutationCreateDisplaySettingArgs = {
  createDisplaySettingInput: CreateDisplaySettingInput;
};


export type MutationCreateDrawArgs = {
  createDrawInput: CreateDrawInput;
};


export type MutationCreateDrawEntryArgs = {
  createDrawEntryInput: CreateDrawEntryInput;
};


export type MutationCreateDrawFromGroupsArgs = {
  createDrawInput: CreateDrawInput;
  drawId?: InputMaybe<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
};


export type MutationCreateDrawFromGroupsWithLiveStandingsArgs = {
  createDrawInput: CreateDrawInput;
  drawId?: InputMaybe<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  places?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationCreateDrawScoreArgs = {
  createDrawScoreInput: CreateDrawScoreInput;
};


export type MutationCreateEmptyGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationCreateFactSheetArgs = {
  createFactSheetInput: CreateFactSheetInput;
};


export type MutationCreateFederationByAdminArgs = {
  createCustomEntryFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createCustomLicenseFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createFederationInput: CreateFederationInput;
};


export type MutationCreateFederationLeagueArgs = {
  createFederationLeagueInput: CreateFederationLeagueInput;
};


export type MutationCreateFederationNewsArgs = {
  createFederationNewsInput: CreateFederationNewsInput;
};


export type MutationCreateGroupArgs = {
  createGroupInput: CreateGroupInput;
};


export type MutationCreateGroupAndcategoriesFromCsvArgs = {
  csvPath?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateGroupEntryArgs = {
  createGroupEntryInput: CreateGroupEntryInput;
};


export type MutationCreateGroupMatchArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateImageArgs = {
  createImageInput: CreateImageInput;
};


export type MutationCreateKingFormatGroupsArgs = {
  filter: ListGroupInput;
};


export type MutationCreateLandingArgs = {
  createLandingInput: CreateLandingInput;
};


export type MutationCreateLandingMemberArgs = {
  createLandingMemberInput: CreateLandingMemberInput;
};


export type MutationCreateLandingPotmArgs = {
  createLandingPotmInput: CreateLandingPotmInput;
};


export type MutationCreateLandingRoadmapArgs = {
  createLandingRoadmapInput: CreateLandingRoadmapInput;
};


export type MutationCreateLandingSliderArgs = {
  createLandingSliderInput: CreateLandingSliderInput;
};


export type MutationCreateLeagueArgs = {
  createFactSheetInput?: InputMaybe<Array<CreateFactSheetInput>>;
  createLeagueInput: CreateLeagueInput;
  customFee?: InputMaybe<Array<CreatePlatformFeeInput>>;
};


export type MutationCreateLeagueCategoryArgs = {
  createLeagueCategoryInput: CreateLeagueCategoryInput;
};


export type MutationCreateLeagueDocumentArgs = {
  createLeagueDocumentInput?: InputMaybe<Array<CreateLeagueDocumentInput>>;
};


export type MutationCreateLeagueMemberArgs = {
  createLeagueMemberInput: CreateLeagueMemberInput;
};


export type MutationCreateLeagueMemberRoleArgs = {
  createLeagueMemberRoleInput: CreateLeagueMemberRoleInput;
};


export type MutationCreateLeagueNewsArgs = {
  createLeagueNewsInput: CreateLeagueNewsInput;
};


export type MutationCreateLeagueOwnerArgs = {
  createLeagueOwnerInput: CreateLeagueOwnerInput;
};


export type MutationCreateLeagueRankingArgs = {
  createLeagueRankingInput: CreateLeagueRankingInput;
};


export type MutationCreateLeagueRankingForChessArgs = {
  createLeagueRankingInput: CreateLeagueRankingInput;
};


export type MutationCreateLeagueTournamentArgs = {
  createLeagueTournamentInput: CreateLeagueTournamentInput;
};


export type MutationCreateLeagueTournamentCategoryArgs = {
  createLeagueTournamentCategoryInput: CreateLeagueTournamentCategoryInput;
};


export type MutationCreateLeaguesFromJsonArgs = {
  createLeagueInput: CreateLeagueInput;
};


export type MutationCreateLicenseArgs = {
  createLicenseInput: CreateLicenseInput;
};


export type MutationCreateLicenseLeagueArgs = {
  createLicenseLeagueInput: CreateLicenseLeagueInput;
};


export type MutationCreateLicensePaymentArgs = {
  createLicensePaymentInput: CreateLicensePaymentInput;
};


export type MutationCreateLicenseQuestionArgs = {
  createLicenseQuestionInput: CreateLicenseQuestionInput;
};


export type MutationCreateLiveStandingArgs = {
  createLiveStandingInput: CreateLiveStandingInput;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateLiveStandingsEntryArgs = {
  createLiveStandingsEntryInput: CreateLiveStandingsEntryInput;
};


export type MutationCreateLiveStreamingArgs = {
  createLiveStreamingInput: CreateLiveStreamingInput;
};


export type MutationCreateLocationsArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
  locations?: InputMaybe<Scalars['Int']['input']>;
  setPositions?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMaintenanceArgs = {
  isUnderMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateMatchArgs = {
  createMatchInput: CreateMatchInput;
  isDrawMatch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMatchProgressionArgs = {
  createMatchProgressionInput: CreateMatchProgressionInput;
};


export type MutationCreateMatchScoreArgs = {
  createMatchInput: CreateMatchInput;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateMatchScore1Args = {
  createMatchScoreInput: CreateMatchScoreInput;
};


export type MutationCreateMatchesEntryArgs = {
  createMatchesEntryInput: CreateMatchesEntryInput;
};


export type MutationCreateMatchesScoreArgs = {
  createMatchesScoreInput: CreateMatchesScoreInput;
};


export type MutationCreateMediaArgs = {
  createMediaInput: CreateMediaInput;
};


export type MutationCreateMobileVersionArgs = {
  androidForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  androidReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  androidVersion: Scalars['String']['input'];
  iOSForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  iosReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  iosVersion: Scalars['String']['input'];
};


export type MutationCreateNewsArgs = {
  createNewsInput: CreateNewsInput;
};


export type MutationCreateNotificationSubscriptionArgs = {
  deviceType: Scalars['String']['input'];
  fcmToken: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationCreateOnboardingArgs = {
  createOnboardingInput: CreateOnboardingInput;
};


export type MutationCreateOneVenuePerTournamentArgs = {
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type MutationCreateOrderOfPlayArgs = {
  createMatchInput: CreateMatchInput;
  tournament: Scalars['Int']['input'];
};


export type MutationCreateOrderOfPlay1Args = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrderOfPlayDrawsArgs = {
  tournament: Scalars['Int']['input'];
  updateMatchInput: UpdateMatchInput;
};


export type MutationCreateOrderOfPlayDraws1Args = {
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationCreateOrderOfPlayForAllGroupsArgs = {
  createMatchInput: CreateMatchInput;
  tournament: Scalars['Int']['input'];
};


export type MutationCreateOrderOfPlayForAllGroups1Args = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrderOfPlayForKingsFormatArgs = {
  createMatchInput: CreateMatchInput;
  tournament: Scalars['Int']['input'];
};


export type MutationCreateOrderOfPlayForKingsFormat1Args = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateOrderofPlayForPairingsArgs = {
  createFormatOopInput: CreateFormatOopInput;
};


export type MutationCreateOrganizationPlatformArgs = {
  createOrganizationPlatformInput: CreateOrganizationPlatformInput;
};


export type MutationCreateOrganizationPlatformMemberArgs = {
  createOrganizationPlatformMemberInput: CreateOrganizationPlatformMemberInput;
  createUserInput?: InputMaybe<CreateUserInput>;
};


export type MutationCreatePairingArgs = {
  createPairingInput: CreatePairingInput;
};


export type MutationCreatePairingEntryArgs = {
  createPairingEntryInput: CreatePairingEntryInput;
};


export type MutationCreatePartnerArgs = {
  createPartnerInput: CreatePartnerInput;
};


export type MutationCreatePartnerNewArgs = {
  input: CreatePartnerNewInput;
};


export type MutationCreatePartnerRequestArgs = {
  createPartnerSearchInput: CreatePartnerSearchInput;
  partnerId: Scalars['Int']['input'];
};


export type MutationCreatePartnerSearchArgs = {
  createPartnerSearchInput: CreatePartnerSearchInput;
};


export type MutationCreatePartnerSearchRequestArgs = {
  createPartnerSearchRequestInput: CreatePartnerSearchRequestInput;
};


export type MutationCreatePlanArgs = {
  createPlanInput: CreatePlanInput;
};


export type MutationCreatePlateformSportArgs = {
  createPlateformSportInput: CreatePlateformSportInput;
};


export type MutationCreatePlatformArgs = {
  createCustomEntryFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createCustomLicenseFeeInput?: InputMaybe<Array<CreatePlatformFeeInput>>;
  createFederationInput?: InputMaybe<CreateFederationInput>;
  createOrganizationPlatformInput?: InputMaybe<CreateOrganizationPlatformInput>;
  createPlatformInput: CreatePlatformInput;
};


export type MutationCreatePlatformCoachArgs = {
  createPlatformCoachInput: CreatePlatformCoachInput;
  createUserInput?: InputMaybe<CreateUserInput>;
};


export type MutationCreatePlatformDocumentArgs = {
  input: CreatePlatformDocumentInput;
};


export type MutationCreatePlatformFeeArgs = {
  createPlatformFeeInput: CreatePlatformFeeInput;
};


export type MutationCreatePlatformPageArgs = {
  createPlatformPageInput: CreatePlatformPageInput;
};


export type MutationCreatePlatformSettingArgs = {
  createPlatformSettingInput: CreatePlatformSettingInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreatePostCategoryArgs = {
  createPostCategoryInput: CreatePostCategoryInput;
};


export type MutationCreateProPlanArgs = {
  createBasicPlanInput: CreateSubscriptionInput;
  months: Scalars['Int']['input'];
};


export type MutationCreatePurchasedLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationCreateRankingCategoryPointArgs = {
  createRankingCategoryPointInput: Array<CreateRankingCategoryPointInput>;
};


export type MutationCreateRankingCategoryPointTypeArgs = {
  createRankingCategoryPointTypeInput: CreateRankingCategoryPointTypeInput;
};


export type MutationCreateRankingPointArgs = {
  createRankingPointInput: CreateRankingPointInput;
};


export type MutationCreateRankingPointCategoryArgs = {
  createRankingPointCategoryInput: CreateRankingPointCategoryInput;
};


export type MutationCreateRankingPointRuleArgs = {
  createRankingPointRuleInput: CreateRankingPointRuleInput;
};


export type MutationCreateRankingTournamentCategoryArgs = {
  createRankingTournamentCategoryInput: CreateRankingTournamentCategoryInput;
};


export type MutationCreateRecordsArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRecordsForDoublesArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRecordsForSingleArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
};


export type MutationCreateRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  updateRankings?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateResourceServiceArgs = {
  createResourceServiceInput: CreateResourceServiceInput;
};


export type MutationCreateRoleArgs = {
  createRoleInput: CreateRoleInput;
};


export type MutationCreateRoundArgs = {
  createRoundInput: CreateRoundInput;
};


export type MutationCreateSponsorArgs = {
  createSponsorInput: CreateSponsorInput;
};


export type MutationCreateSportArgs = {
  createSportInput: CreateSportInput;
};


export type MutationCreateSportFishingEntriesMatricArgs = {
  createSportFishingEntriesMatricInput: CreateSportFishingEntriesMatricInput;
};


export type MutationCreateSportFishingMatricArgs = {
  createSportFishingMatricInput: CreateSportFishingMatricInput;
};


export type MutationCreateSportFishingMetricContextArgs = {
  input: CreateSportFishingMetricContextInput;
};


export type MutationCreateSportFishingResultArgs = {
  createSportFishingResultInput: CreateSportFishingResultInput;
};


export type MutationCreateSportFishingResultEntryArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
};


export type MutationCreateSportFishingResultForManualEntriesArgs = {
  createSportFishingResultInput: CreateSportFishingResultInput;
  entryId: Scalars['Int']['input'];
  sportFishingResult: Scalars['Int']['input'];
};


export type MutationCreateStatArgs = {
  createStatInput: CreateStatInput;
};


export type MutationCreateStripePaymentArgs = {
  amount: Scalars['Float']['input'];
  connectedAccountId: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type MutationCreateStripeSessionArgs = {
  createStripeSessionInput: CreateStripeSessionInput;
};


export type MutationCreateSubscriptionArgs = {
  createSubscriptionInput: CreateSubscriptionInput;
};


export type MutationCreateSwissBlockArgs = {
  input: CreateSwissBlockInput;
};


export type MutationCreateTeamDrawEntryArgs = {
  createMatchInput: CreateMatchInput;
  tournament: Scalars['Int']['input'];
};


export type MutationCreateTeamDrawEntry1Args = {
  createDrawEntryInput: CreateDrawEntryInput;
};


export type MutationCreateTeamGroupMatchArgs = {
  createGroupMatchInput: CreateGroupMatchInput;
};


export type MutationCreateTeamMatchScoreArgs = {
  createMatchInput: CreateMatchInput;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateTeamMatchScore1Args = {
  createMatchScoreInput: CreateMatchScoreInput;
};


export type MutationCreateTeamMemberArgs = {
  createTeamMemberInput: CreateTeamMemberInput;
};


export type MutationCreateTeamRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationCreateTemplateArgs = {
  createTemplateInput: CreateTemplateInput;
};


export type MutationCreateThirdPartyLicenseArgs = {
  createThirdPartyLicenseInput: CreateThirdPartyLicenseInput;
};


export type MutationCreateTournamentArgs = {
  createTournamentInput: CreateTournamentInput;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTournamentAdditionalRefereeArgs = {
  createTournamentAdditionalRefereeInput: CreateTournamentAdditionalRefereeInput;
};


export type MutationCreateTournamentAnnouncementArgs = {
  input: CreateTournamentAnnouncementInput;
};


export type MutationCreateTournamentCategoryArgs = {
  createTournamentCategoryInput: CreateTournamentCategoryInput;
};


export type MutationCreateTournamentCategoryGroupArgs = {
  createTournamentCategoryGroupInput: CreateTournamentCategoryGroupInput;
};


export type MutationCreateTournamentCategoryLicenseArgs = {
  createTournamentCategoryLicenseInput: CreateTournamentCategoryLicenseInput;
};


export type MutationCreateTournamentDiscountArgs = {
  createTournamentDiscountInput: CreateTournamentDiscountInput;
};


export type MutationCreateTournamentDocumentArgs = {
  createTournamentDocumentInput: CreateTournamentDocumentInput;
};


export type MutationCreateTournamentFactSheetArgs = {
  createTournamentFactSheetInput: CreateTournamentFactSheetInput;
};


export type MutationCreateTournamentFactSheetsArgs = {
  createTournamentFactSheetInput?: InputMaybe<Array<CreateTournamentFactSheetInput>>;
};


export type MutationCreateTournamentOrganizerArgs = {
  createTournamentOrganizerInput: CreateTournamentOrganizerInput;
};


export type MutationCreateTournamentRankingArgs = {
  createTournamentRankingInput: CreateTournamentRankingInput;
};


export type MutationCreateTournamentRankingsEntryArgs = {
  createTournamentRankingsEntryInput: CreateTournamentRankingsEntryInput;
};


export type MutationCreateTournamentRankingsManArgs = {
  createTournamentRankingsManInput: CreateTournamentRankingsManInput;
};


export type MutationCreateTournamentRankingsWomanArgs = {
  createTournamentRankingsWomanInput: CreateTournamentRankingsWomanInput;
};


export type MutationCreateTournamentRefereeArgs = {
  createTournamentRefereeInput: CreateTournamentRefereeInput;
};


export type MutationCreateTournamentRegistrationArgs = {
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};


export type MutationCreateTournamentRegistrationPaymentArgs = {
  createRegistrationPaymentInput: CreateRegistrationPaymentInput;
};


export type MutationCreateTournamentRegistrationQuestionArgs = {
  createTournamentRegistrationQuestionInput: CreateTournamentRegistrationQuestionInput;
};


export type MutationCreateTournamentRegistrationsArgs = {
  createTournamentRegistrationInputs?: InputMaybe<Array<CreateTournamentRegistrationInput>>;
  discountsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTournamentTeamMemberArgs = {
  createTournamentTeamMemberInput: CreateTournamentTeamMemberInput;
};


export type MutationCreateTournamentVenueArgs = {
  createTournamentVenueInput: CreateTournamentVenueInput;
};


export type MutationCreateTransactionHistoryArgs = {
  createTransactionHistoryInput: CreateTransactionHistoryInput;
};


export type MutationCreateUserCoachArgs = {
  createUserCoachInput: CreateUserCoachInput;
};


export type MutationCreateUserLicenseArgs = {
  createUserLicenseInput: CreateUserLicenseInput;
};


export type MutationCreateUserParentArgs = {
  createUserParentInput: CreateUserParentInput;
};


export type MutationCreateUserPlanArgs = {
  createUserPlanInput: CreateUserPlanInput;
};


export type MutationCreateUserPurchasedLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationCreateUserSettingArgs = {
  createUserSettingInput: CreateUserSettingInput;
};


export type MutationCreateUserSportArgs = {
  createUserSportInput: CreateUserSportInput;
};


export type MutationDeleteAthleteQuestionAnswerArgs = {
  athleteQuestionId: Scalars['Int']['input'];
  sportId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type MutationDeleteBannerNewArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteFormatBlockArgs = {
  blockId: Scalars['Int']['input'];
};


export type MutationDeleteFormatMatchArgs = {
  matchId: Scalars['Int']['input'];
};


export type MutationDeleteLastUnlockedFormatRoundArgs = {
  blockId: Scalars['Int']['input'];
  roundNumber: Scalars['Int']['input'];
};


export type MutationDeletePartnerNewArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePlatformDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeletePostArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteRequestArgs = {
  id: Array<Scalars['Int']['input']>;
};


export type MutationDeleteSportFishingEntriesMatricMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationDeleteTournamentMatchesArgs = {
  drawIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  matchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament: Scalars['Int']['input'];
};


export type MutationDeleteTournamentMatches1Args = {
  drawIds: Array<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  matchIds: Array<Scalars['Int']['input']>;
};


export type MutationDeleteTournamentTeamMatchesArgs = {
  drawIds: Array<Scalars['Int']['input']>;
  groupIds: Array<Scalars['Int']['input']>;
  matchIds: Array<Scalars['Int']['input']>;
};


export type MutationEndLiveStreamingArgs = {
  filter?: InputMaybe<ListLiveStreamingInput>;
};


export type MutationExtendLicenseArgs = {
  id: Scalars['Int']['input'];
  yearsToAdd: Scalars['Int']['input'];
};


export type MutationExtendSubscriptionArgs = {
  amount: Scalars['Float']['input'];
  currency: Scalars['String']['input'];
  federationId: Scalars['Int']['input'];
  months: Scalars['Int']['input'];
  plan: Scalars['String']['input'];
  planName: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
};


export type MutationFindAllUserSubscriptionsArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationFindDrawEntryWinnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationFindDrawEntryWinner1Args = {
  id: Scalars['Int']['input'];
};


export type MutationFindStatsArgs = {
  createStatInput: CreateStatInput;
};


export type MutationForgetPasswordArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  isManagerOrDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationForgotResetPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type MutationForwardByesArgs = {
  entryIds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
};


export type MutationGenerateApiKeyArgs = {
  name: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
};


export type MutationGenerateRound1PairingsArgs = {
  blockId: Scalars['Int']['input'];
};


export type MutationGenerateRoundPairingsArgs = {
  blockId: Scalars['Int']['input'];
  generateAll?: InputMaybe<Scalars['Boolean']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationHideUnhideAllDrawsArgs = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationHideUnhideAllGroupsArgs = {
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationHideUnhideAllLiveStandingsArgs = {
  isPublished: Scalars['Boolean']['input'];
  tournament: Scalars['Int']['input'];
};


export type MutationImpersonateUserArgs = {
  app?: InputMaybe<LoginApp>;
  targetUserId?: InputMaybe<Scalars['Int']['input']>;
  targetUserPublicId?: InputMaybe<Scalars['String']['input']>;
  ttlMinutes?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationInitiateAuthV2Args = {
  email?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationInviteScorerArgs = {
  input: InviteScorerInput;
};


export type MutationLikeAnnouncementArgs = {
  filter: ListAnnouncementLikeInput;
};


export type MutationLogOutArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
};


export type MutationLoginArgs = {
  query: LoginUserInput;
};


export type MutationLogoutUserArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationMasterUpdateRegistrationSegmentArgs = {
  categoryId: Scalars['Float']['input'];
  segment?: InputMaybe<Array<RegistrationSegment>>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationMergeTournamentRegistrationsArgs = {
  filter: MergeTournamentRegistrationsInput;
};


export type MutationMoveMatchOrderArgs = {
  matchId: Scalars['Int']['input'];
  roundId: Scalars['Int']['input'];
  toIndex: Scalars['Int']['input'];
};


export type MutationMoveStandingOrderArgs = {
  liveStandingId: Scalars['Int']['input'];
  standingId: Scalars['Int']['input'];
  toPlace: Scalars['Int']['input'];
};


export type MutationPrepareMatchResultsArgs = {
  tournamentId: Scalars['Int']['input'];
  uploadToITF?: Scalars['Boolean']['input'];
};


export type MutationRecoverSingleGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRefreshLiveStandingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRefreshTeamMembersInRegistrationArgs = {
  registrationRequestId: Scalars['Int']['input'];
  teamId: Scalars['Int']['input'];
  teamMemberIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament: Scalars['Int']['input'];
};


export type MutationRegenerateLiveScoreCodeArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationRegeneratePlatformAccessCodeArgs = {
  platformId: Scalars['Int']['input'];
};


export type MutationRejectProposedResultArgs = {
  input: RejectProposedResultInput;
};


export type MutationRejectTournamentRegistrationsArgs = {
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationRemoveAdditionalQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAlbumArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAnnouncementCommentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAthleteArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveAuthMethodArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveBannerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCacheArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveCategoriesFromTournamentCategoryGroupArgs = {
  removeTournamentCategoriesInput: RemoveTournamentCategoriesInput;
};


export type MutationRemoveCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategorySettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategorySettingsGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCategoryTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubServiceResourceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveClubsServiceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveCourtArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDefaultTeamMatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDisciplineArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDisplaySettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveDrawMatchArgs = {
  drawId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveDrawMatchScoreArgs = {
  drawId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveDrawMatchScore1Args = {
  drawId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  winnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveDrawScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFederationNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveFriendArgs = {
  friendId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationRemoveGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveGroupEntry1Args = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<Scalars['Int']['input']>;
  isKingFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveGroupMatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveImageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingPotmArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingRoadmapArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLandingSliderArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueCategoryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveLeagueDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueMemberRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueOwnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueRankingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueRankingsArgs = {
  date: Scalars['String']['input'];
  league: Scalars['Int']['input'];
  rankingCategory: Scalars['Int']['input'];
};


export type MutationRemoveLeagueTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLeagueTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLicenseArgs = {
  id: Scalars['Int']['input'];
  input: RemoveLicenseInput;
};


export type MutationRemoveLicenseLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLicenseQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLiveStandingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveLiveStandingsEntryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveLiveStreamingArgs = {
  filter?: InputMaybe<ListLiveStreamingInput>;
};


export type MutationRemoveMaintenanceArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveMatchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMatchProgressionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMatchScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMatchesEntryArgs = {
  groupId?: InputMaybe<Scalars['Int']['input']>;
  ids: Array<Scalars['Int']['input']>;
  isKingFormat?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveMatchesScoreArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMediaArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveMediaListArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMobileVersionArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveMultipleDrawsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleStandingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleTournamentRankingsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveMultipleTournamentRankingsEntriesArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveNewsArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveNotificationSubscriptionArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationRemoveOnboardingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOrganizationPlatformArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveOrganizationPlatformMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePairingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePairingEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerSearchArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePartnerSearchRequestArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlateformSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformFeeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformPageArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePlatformSettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePostCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemovePurchasedLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingCategoryPointArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveRankingCategoryPointTypeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointRuleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRankingPointsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveRankingTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveResourceServiceArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRoleArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveRoundArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSingleGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSponsorArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingEntriesMatricArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingEntriesMatricBulkArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveSportFishingMatricArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingResultArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSportFishingResultEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveStatArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveSubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTeamMatchArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveThirdPartyLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentArgs = {
  id: Scalars['Float']['input'];
  isDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRemoveTournamentAdditionalRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentAnnouncementArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentCategoryArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentCategoryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDiscountArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentDrawArgs = {
  tournament: Scalars['Int']['input'];
};


export type MutationRemoveTournamentFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsManArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRankingsWomanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRegistrationArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type MutationRemoveTournamentRegistrationQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentRegulationArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationRemoveTournamentTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTournamentVenueArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveTransactionHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveUserAccountArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRemoveUserCoachArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserParentArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserPlanArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserSettingArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRemoveUserSportArgs = {
  id: Scalars['Int']['input'];
};


export type MutationRenewUserLicenseArgs = {
  createPurchasedLicenseInput: CreatePurchasedLicenseInput;
};


export type MutationReorderLiveStandingsEntriesArgs = {
  reorderInput: ReorderLiveStandingsEntriesInput;
};


export type MutationRequestPasswordResetOtpArgs = {
  input: RequestPasswordResetOtpInput;
};


export type MutationResendScorerInviteArgs = {
  inviteId: Scalars['Int']['input'];
};


export type MutationResetLeagueRankingsCronCategoriesArgs = {
  leagueId: Scalars['Int']['input'];
};


export type MutationResetPasswordWithTokenArgs = {
  input: ResetPasswordWithTokenInput;
};


export type MutationRestoreClubArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRestoreLeagueArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRestoreTournamentArgs = {
  id: Scalars['Float']['input'];
};


export type MutationRevokeApiKeyArgs = {
  keyId: Scalars['String']['input'];
};


export type MutationRevokeScorerInviteArgs = {
  input: RevokeScorerInviteInput;
};


export type MutationRotateLivescoreViewerTokenArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type MutationScorerInviteHeartbeatArgs = {
  input: ScorerInviteHeartbeatInput;
};


export type MutationSendMobileOtpArgs = {
  isForSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  mobile: Scalars['String']['input'];
};


export type MutationSendNotificationArgs = {
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSetLeagueLivescoreEnabledArgs = {
  input: SetLeagueLivescoreEnabledInput;
};


export type MutationSetLeagueRankingsCronCategoriesArgs = {
  customSchedule?: InputMaybe<Array<CustomScheduleItemInput>>;
  leagueId: Scalars['Int']['input'];
  rankingCategoryIds: Array<Scalars['Int']['input']>;
  refreshRate: RefreshRate;
  time?: InputMaybe<Scalars['String']['input']>;
  updateEvery?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetOrganizerLivescoreEnabledArgs = {
  input: SetOrganizerLivescoreEnabledInput;
};


export type MutationSetPlatformLivescoreEnabledArgs = {
  input: SetPlatformLivescoreEnabledInput;
};


export type MutationSetTournamentLivescoreEnabledArgs = {
  input: SetTournamentLivescoreEnabledInput;
};


export type MutationSetTournamentLivescoreModeArgs = {
  input: SetTournamentLivescoreModeInput;
};


export type MutationSignOutSessionArgs = {
  sessionId: Scalars['String']['input'];
};


export type MutationSignUpArgs = {
  createUserInput: CreateUserInput;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSocialAuthCheckArgs = {
  input: SocialAuthCheckInput;
};


export type MutationSocialAuthLinkArgs = {
  input: SocialAuthLinkInput;
};


export type MutationSocialAuthLoginArgs = {
  input: SocialAuthLoginInput;
};


export type MutationSocialAuthRegisterArgs = {
  input: SocialAuthRegisterInput;
};


export type MutationSocialLoginArgs = {
  forceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateUserInput;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSoftDeleteClubArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSoftDeleteLeagueArgs = {
  id: Scalars['Float']['input'];
};


export type MutationSoftDeleteTournamentArgs = {
  id: Scalars['Float']['input'];
  password: Scalars['String']['input'];
};


export type MutationSubmitBookingFormArgs = {
  input: SubmitBookingFormInput;
};


export type MutationSubmitFormatMatchResultArgs = {
  input: SubmitFormatMatchResultInput;
};


export type MutationSubmitProposedResultArgs = {
  input: SubmitProposedResultInput;
};


export type MutationSubmitResultsArgs = {
  createSportFishingResultEntryInput: CreateSportFishingResultEntryInput;
};


export type MutationSubscriptionFiltersArgs = {
  connectedAccountId: Scalars['String']['input'];
};


export type MutationSwapDrawMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationSwapGroupEntriesArgs = {
  entry1: Scalars['Int']['input'];
  entry2: Scalars['Int']['input'];
  group1Id?: InputMaybe<Scalars['Int']['input']>;
  group2Id?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSwapGroupMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationSwapLiveStandingsOrderArgs = {
  liveStandingId: Scalars['Int']['input'];
  standingId1: Scalars['Int']['input'];
  standingId2: Scalars['Int']['input'];
};


export type MutationSwapMatchEntriesForDrawsArgs = {
  swapMatchEntriesInput: SwapMatchEntriesInput;
};


export type MutationSwapMatchesArgs = {
  match1: Scalars['Int']['input'];
  match2: Scalars['Int']['input'];
};


export type MutationSyncWprDataArgs = {
  userId: Scalars['Int']['input'];
  wprId: Scalars['String']['input'];
};


export type MutationSyncWprDataBulkArgs = {
  input: UpdateUserInput;
};


export type MutationSyncWprProfileByIdOnlyArgs = {
  wprPlayerId: Scalars['String']['input'];
};


export type MutationToggleFormatRoundLockArgs = {
  blockId: Scalars['Int']['input'];
  isLocked: Scalars['Boolean']['input'];
  roundNumber: Scalars['Int']['input'];
};


export type MutationToggleNotificationSubscriptionArgs = {
  status: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationTournamentLoginArgs = {
  query: LoginUserInput;
};


export type MutationTournamentRegistrationAndPaymentArgs = {
  discountsIds?: InputMaybe<Array<Scalars['String']['input']>>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  paymentDone?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethod: Scalars['String']['input'];
  platformId: Scalars['Float']['input'];
  proofOfPayment?: InputMaybe<Scalars['String']['input']>;
  redirectURL: Scalars['String']['input'];
  tournamentId: Scalars['Float']['input'];
  webCreateTournamentRegistrationInputs: Array<WebCreateTournamentRegistrationInput>;
};


export type MutationUnlikeAnnouncementArgs = {
  filter: ListAnnouncementLikeInput;
};


export type MutationUnlinkSocialAuthArgs = {
  provider: SocialAuthProvider;
};


export type MutationUpdateAdditionalQuestionArgs = {
  updateAdditionalQuestionInput: UpdateAdditionalQuestionInput;
};


export type MutationUpdateAlbumArgs = {
  updateAlbumInput: UpdateAlbumInput;
};


export type MutationUpdateAnnouncementCommentArgs = {
  updateAnnouncementCommentInput: UpdateAnnouncementCommentInput;
};


export type MutationUpdateAthleteArgs = {
  updateAthleteInput: UpdateAthleteInput;
};


export type MutationUpdateAuthMethodArgs = {
  updateAuthMethodInput: UpdateAuthMethodInput;
};


export type MutationUpdateBannerArgs = {
  updateBannerInput: UpdateBannerInput;
};


export type MutationUpdateBannerNewArgs = {
  updateBannerInput: UpdateBannerInputNew;
};


export type MutationUpdateBulkBannerArgs = {
  updateBulkBannerInput: UpdateBulkBannerLegacyInput;
};


export type MutationUpdateBulkBannerNewArgs = {
  updateBulkBannerInput: UpdateBulkBannerInputNew;
};


export type MutationUpdateBulkPartnersNewArgs = {
  input: UpdateBulkPartnerNewInput;
};


export type MutationUpdateBulkPlatformDocumentsArgs = {
  input: UpdateBulkPlatformDocumentsInput;
};


export type MutationUpdateBulkPlatformFeeArgs = {
  updatePlatformFeeInput: Array<UpdatePlatformFeeInput>;
};


export type MutationUpdateCategoryArgs = {
  updateCategoryInput: UpdateCategoryInput;
};


export type MutationUpdateCategoryRuleArgs = {
  updateCategoryRuleInput: UpdateCategoryRuleInput;
};


export type MutationUpdateCategorySettingArgs = {
  updateCategorySettingInput: UpdateCategorySettingInput;
};


export type MutationUpdateCategorySettingsArgs = {
  categryIds: Array<Scalars['Int']['input']>;
  updateCategorySettingInput: UpdateCategorySettingInput;
};


export type MutationUpdateCategorySettingsGroupArgs = {
  updateCategorySettingsGroupInput: UpdateCategorySettingsGroupInput;
};


export type MutationUpdateCategoryTournamentArgs = {
  updateCategoryTournamentInput: UpdateCategoryTournamentInput;
};


export type MutationUpdateClubArgs = {
  updateClubInput: UpdateClubInput;
};


export type MutationUpdateClubAdministratorArgs = {
  updateClubAdministratorInput: UpdateClubAdministratorInput;
};


export type MutationUpdateClubCoachArgs = {
  updateClubCoachInput: UpdateClubCoachInput;
};


export type MutationUpdateClubMemberArgs = {
  updateClubMemberInput: UpdateClubMemberInput;
};


export type MutationUpdateClubNewsArgs = {
  updateClubNewsInput: UpdateClubNewsInput;
};


export type MutationUpdateClubServiceResourceArgs = {
  updateClubServiceResourceInput: UpdateClubServiceResourceInput;
};


export type MutationUpdateClubsServiceArgs = {
  updateClubsServiceInput: UpdateClubsServiceInput;
};


export type MutationUpdateCourtArgs = {
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateCourtSortingArgs = {
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateCustomMatricsSortingArgs = {
  updateInput: UpdateSportFishingMatricInput;
};


export type MutationUpdateDuprRatingArgs = {
  categoryId: Scalars['Float']['input'];
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateDefaultTeamMatchArgs = {
  updateDefaultTeamMatchInput: UpdateDefaultTeamMatchInput;
};


export type MutationUpdateDisciplineArgs = {
  updateDisciplineInput: UpdateDisciplineInput;
};


export type MutationUpdateDisciplineSortingArgs = {
  updateDisciplineInput: UpdateDisciplineInput;
};


export type MutationUpdateDisplaySettingArgs = {
  updateDisplaySettingInput: UpdateDisplaySettingInput;
};


export type MutationUpdateDrawArgs = {
  updateDrawInput: UpdateDrawInput;
};


export type MutationUpdateDrawEntryArgs = {
  updateMatchInput: UpdateMatchInput;
};


export type MutationUpdateDrawEntry1Args = {
  entryIdToUpdate?: InputMaybe<Scalars['Int']['input']>;
  updateDrawEntryInput: UpdateDrawEntryInput;
};


export type MutationUpdateDrawMatchActionArgs = {
  actionType: MatchScoreActionType;
  token?: InputMaybe<Scalars['String']['input']>;
  updateMatchInput: UpdateMatchInput;
};


export type MutationUpdateDrawScoreArgs = {
  updateDrawScoreInput: UpdateDrawScoreInput;
};


export type MutationUpdateFactSheetArgs = {
  updateFactSheetInput: UpdateFactSheetInput;
};


export type MutationUpdateFactSheetSortingArgs = {
  updateFactSheetInput: UpdateFactSheetInput;
};


export type MutationUpdateFederationLeagueArgs = {
  updateFederationLeagueInput: UpdateFederationLeagueInput;
};


export type MutationUpdateFederationNewsArgs = {
  updateFederationNewsInput: UpdateFederationNewsInput;
};


export type MutationUpdateFormatBlockArgs = {
  blockId: Scalars['Int']['input'];
  input: UpdateFormatBlockInput;
};


export type MutationUpdateFormatRoundVisibilityArgs = {
  blockId: Scalars['Int']['input'];
  isVisible: Scalars['Boolean']['input'];
  roundNumber: Scalars['Int']['input'];
};


export type MutationUpdateGroupArgs = {
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateGroupEntryArgs = {
  updateGroupEntryInput: UpdateGroupEntryInput;
};


export type MutationUpdateGroupMatchArgs = {
  updateGroupMatchInput: UpdateGroupMatchInput;
};


export type MutationUpdateGroupPositionsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateImageArgs = {
  updateImageInput: UpdateImageInput;
};


export type MutationUpdateLandingArgs = {
  updateLandingInput: UpdateLandingInput;
};


export type MutationUpdateLandingMemberArgs = {
  updateLandingMemberInput: UpdateLandingMemberInput;
};


export type MutationUpdateLandingPotmArgs = {
  updateLandingPotmInput: UpdateLandingPotmInput;
};


export type MutationUpdateLandingRoadmapArgs = {
  updateLandingRoadmapInput: UpdateLandingRoadmapInput;
};


export type MutationUpdateLandingSliderArgs = {
  updateLandingSliderInput: UpdateLandingSliderInput;
};


export type MutationUpdateLeageCustomFeesArgs = {
  customFee: Array<UpdatePlatformFeeInput>;
  id: Scalars['Int']['input'];
  isCustomFeeEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpdateLeagueArgs = {
  updateLeagueInput: UpdateLeagueInput;
};


export type MutationUpdateLeagueCategoryArgs = {
  updateLeagueCategoryInput: UpdateLeagueCategoryInput;
};


export type MutationUpdateLeagueDocumentArgs = {
  updateLeagueDocumentInput: UpdateLeagueDocumentInput;
};


export type MutationUpdateLeagueDocumentSortingArgs = {
  updateLeagueDocumentInput: UpdateLeagueDocumentInput;
};


export type MutationUpdateLeagueMemberArgs = {
  updateLeagueMemberInput: UpdateLeagueMemberInput;
};


export type MutationUpdateLeagueMemberRoleArgs = {
  updateLeagueMemberRoleInput: UpdateLeagueMemberRoleInput;
};


export type MutationUpdateLeagueNewsArgs = {
  updateLeagueNewsInput: UpdateLeagueNewsInput;
};


export type MutationUpdateLeagueRankingArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueRankingPointsArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueRankingsArgs = {
  updateLeagueRankingInput: UpdateLeagueRankingInput;
};


export type MutationUpdateLeagueTournamentArgs = {
  updateLeagueTournamentInput: UpdateLeagueTournamentInput;
};


export type MutationUpdateLeagueTournamentCategoryArgs = {
  updateLeagueTournamentCategoryInput: UpdateLeagueTournamentCategoryInput;
};


export type MutationUpdateLicenseArgs = {
  updateLicenseInput: UpdateLicenseInput;
};


export type MutationUpdateLicenseLeagueArgs = {
  updateLicenseLeagueInput: UpdateLicenseLeagueInput;
};


export type MutationUpdateLicenseQuestionArgs = {
  updateLicenseQuestionInput: UpdateLicenseQuestionInput;
};


export type MutationUpdateLiveStandingArgs = {
  updateLiveStandingInput: UpdateLiveStandingInput;
};


export type MutationUpdateLiveStandingPublishStatusArgs = {
  id: Scalars['Int']['input'];
  isPublished: Scalars['Boolean']['input'];
};


export type MutationUpdateLiveStandingsEntryArgs = {
  updateLiveStandingsEntryInput: UpdateLiveStandingsEntryInput;
};


export type MutationUpdateLiveStreamingArgs = {
  updateLiveStreamingInput: UpdateLiveStreamingInput;
};


export type MutationUpdateMaintenanceArgs = {
  id: Scalars['Float']['input'];
  isUnderMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  maintenanceStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchArgs = {
  updateMatchInput: UpdateMatchInput;
};


export type MutationUpdateMatchActionArgs = {
  actionType: MatchScoreActionType;
  matchId: Scalars['Int']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMatchProgressionArgs = {
  updateMatchProgressionInput: UpdateMatchProgressionInput;
};


export type MutationUpdateMatchScoreArgs = {
  updateMatchScoreInput: UpdateMatchScoreInput;
};


export type MutationUpdateMatchesEntryArgs = {
  updateMatchesEntryInput: UpdateMatchesEntryInput;
};


export type MutationUpdateMatchesScoreArgs = {
  updateMatchesScoreInput: UpdateMatchesScoreInput;
};


export type MutationUpdateMediaArgs = {
  updateMediaInput: UpdateMediaInput;
};


export type MutationUpdateMobileVersionArgs = {
  androidForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  androidReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  androidVersion?: InputMaybe<Scalars['String']['input']>;
  iOSForceUpdate?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Float']['input'];
  iosReleaseNotes?: InputMaybe<Scalars['String']['input']>;
  iosVersion?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateMultipleCourtsArgs = {
  courtIds: Array<Scalars['Int']['input']>;
  updateCourtInput: UpdateCourtInput;
};


export type MutationUpdateMultipleDrawMatchesArgs = {
  tournament: Scalars['Int']['input'];
  updateDrawMatchInput: Array<UpdateMatchInput>;
};


export type MutationUpdateMultipleDrawMatches1Args = {
  updateDrawMatchInput: Array<UpdateDrawEntryInput>;
};


export type MutationUpdateMultipleGroupMatchesArgs = {
  tournament: Scalars['Int']['input'];
  updateGroupMatchInput: Array<UpdateMatchInput>;
};


export type MutationUpdateMultipleGroupMatches1Args = {
  updateGroupMatchInput: Array<CreateMatchScoreInput>;
};


export type MutationUpdateMultipleGroupsArgs = {
  ids: Array<Scalars['Int']['input']>;
  updateGroupInput: UpdateGroupInput;
};


export type MutationUpdateMultipleMatchesArgs = {
  updateMatchInput: Array<UpdateMatchInput>;
};


export type MutationUpdateMultipleRankingCategoryPointsArgs = {
  ids: Array<Scalars['Int']['input']>;
  updateRankingCategoryPointsInput: UpdateRankingCategoryPointInput;
};


export type MutationUpdateNewsArgs = {
  updateNewsInput: UpdateNewsInput;
};


export type MutationUpdateNotificationSubscriptionArgs = {
  deviceType?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateOnboardingArgs = {
  updateOnboardingInput: UpdateOnboardingInput;
};


export type MutationUpdateOrganizationPlatformArgs = {
  updateOrganizationPlatformInput: UpdateOrganizationPlatformInput;
};


export type MutationUpdateOrganizationPlatformMemberArgs = {
  updateOrganizationPlatformMemberInput: UpdateOrganizationPlatformMemberInput;
};


export type MutationUpdatePairingArgs = {
  updatePairingInput: UpdatePairingInput;
};


export type MutationUpdatePairingEntryArgs = {
  updatePairingEntryInput: UpdatePairingEntryInput;
};


export type MutationUpdatePairingScoreArgs = {
  roundId?: InputMaybe<Scalars['Int']['input']>;
  updatePairingEntryInputs: Array<UpdatePairingEntryInput>;
};


export type MutationUpdatePartnerArgs = {
  updatePartnerInput: UpdatePartnerInput;
};


export type MutationUpdatePartnerNewArgs = {
  input: UpdatePartnerNewInput;
};


export type MutationUpdatePartnerSearchArgs = {
  updatePartnerSearchInput: UpdatePartnerSearchInput;
};


export type MutationUpdatePartnerSortingArgs = {
  updatePartnerInput: UpdatePartnerInput;
};


export type MutationUpdatePlanArgs = {
  updatePlanInput: UpdatePlanInput;
};


export type MutationUpdatePlateformSportArgs = {
  updatePlateformSportInput: UpdatePlateformSportInput;
};


export type MutationUpdatePlatformArgs = {
  isAlreadyCreated?: InputMaybe<Scalars['Boolean']['input']>;
  overrideLeagueFees?: InputMaybe<Scalars['Boolean']['input']>;
  overrideOrganizationsFees?: InputMaybe<Scalars['Boolean']['input']>;
  updateCustomEntryFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updateCustomLicenseFeeInput?: InputMaybe<Array<UpdatePlatformFeeInput>>;
  updatePlatformInput: UpdatePlatformInput;
};


export type MutationUpdatePlatformCoachArgs = {
  updatePlatformCoachInput: UpdatePlatformCoachInput;
};


export type MutationUpdatePlatformDocumentArgs = {
  input: UpdatePlatformDocumentInput;
};


export type MutationUpdatePlatformFeeArgs = {
  updatePlatformFeeInput: UpdatePlatformFeeInput;
};


export type MutationUpdatePlatformPageArgs = {
  updatePlatformPageInput: UpdatePlatformPageInput;
};


export type MutationUpdatePlatformSettingArgs = {
  updatePlatformSettingInput: UpdatePlatformSettingInput;
};


export type MutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type MutationUpdatePostCategoryArgs = {
  updatePostCategoryInput: UpdatePostCategoryInput;
};


export type MutationUpdatePurchasedLicenseArgs = {
  updatePurchasedLicenseInput: UpdatePurchasedLicenseInput;
};


export type MutationUpdateRankingCategoryPointTypeArgs = {
  updateRankingCategoryPointTypeInput: UpdateRankingCategoryPointTypeInput;
};


export type MutationUpdateRankingCategoryPointsArgs = {
  updateRankingCategoryPointsInput: Array<UpdateRankingCategoryPointInput>;
};


export type MutationUpdateRankingPointArgs = {
  updateRankingCategoryPointInput: UpdateRankingCategoryPointInput;
};


export type MutationUpdateRankingPointCategoryArgs = {
  updateRankingPointCategoryInput: UpdateRankingPointCategoryInput;
};


export type MutationUpdateRankingPointRuleArgs = {
  updateRankingPointRuleInput: UpdateRankingPointRuleInput;
};


export type MutationUpdateRankingTournamentCategoryArgs = {
  updateRankingTournamentCategoryInput: UpdateRankingTournamentCategoryInput;
};


export type MutationUpdateRegistrationRequestArgs = {
  createTournamentRegistrationInput: CreateTournamentRegistrationInput;
  id: Scalars['Float']['input'];
};


export type MutationUpdateRegistrationSegmentArgs = {
  categoryId: Scalars['Float']['input'];
  onlySeed?: InputMaybe<Scalars['Boolean']['input']>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateRegistrationsRankingsArgs = {
  categoryId: Scalars['Float']['input'];
  ids: Array<Scalars['Int']['input']>;
  tournamentId: Scalars['Float']['input'];
};


export type MutationUpdateResourceServiceArgs = {
  updateResourceServiceInput: UpdateResourceServiceInput;
};


export type MutationUpdateRoleArgs = {
  updateRoleInput: UpdateRoleInput;
};


export type MutationUpdateRoundArgs = {
  updateRoundInput: UpdateRoundInput;
};


export type MutationUpdateSimpleRankingPointArgs = {
  updateRankingPointInput: UpdateRankingPointInput;
};


export type MutationUpdateSponsorArgs = {
  updateSponsorInput: UpdateSponsorInput;
};


export type MutationUpdateSponsorSortingArgs = {
  updateSponsorInput: UpdateSponsorInput;
};


export type MutationUpdateSportArgs = {
  updateSportInput: UpdateSportInput;
};


export type MutationUpdateSportFishingEntriesMatricArgs = {
  updateSportFishingEntriesMatricInput: UpdateSportFishingEntriesMatricInput;
};


export type MutationUpdateSportFishingEntriesMatricBulkArgs = {
  inputs: Array<UpdateSportFishingEntriesMatricInput>;
};


export type MutationUpdateSportFishingMatricArgs = {
  updateSportFishingMatricInput: UpdateSportFishingMatricInput;
};


export type MutationUpdateSportFishingResultArgs = {
  updateSportFishingResultInput: UpdateSportFishingResultInput;
};


export type MutationUpdateSportFishingResultEntryArgs = {
  updateSportFishingResultEntryInput: UpdateSportFishingResultEntryInput;
};


export type MutationUpdateSportSortingArgs = {
  updateSportInput: UpdateSportInput;
};


export type MutationUpdateSubscriptionArgs = {
  updateSubscriptionInput: UpdateSubscriptionInput;
};


export type MutationUpdateTeamMemberArgs = {
  updateTeamMemberInput: UpdateTeamMemberInput;
};


export type MutationUpdateTemplateArgs = {
  updateTemplateInput: UpdateTemplateInput;
};


export type MutationUpdateThirdPartyLicenseArgs = {
  updateThirdPartyLicenseInput: UpdateThirdPartyLicenseInput;
};


export type MutationUpdateTournamentArgs = {
  updateTournamentInput: UpdateTournamentInput;
};


export type MutationUpdateTournamentAdditionalRefereeArgs = {
  updateTournamentAdditionalRefereeInput: UpdateTournamentAdditionalRefereeInput;
};


export type MutationUpdateTournamentAnnouncementArgs = {
  input: UpdateTournamentAnnouncementInput;
};


export type MutationUpdateTournamentCategoriesArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentCategoryArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
  updateTournamentCategoryGroupInput: UpdateTournamentCategoryGroupInput;
};


export type MutationUpdateTournamentCategoryLicenseArgs = {
  updateTournamentCategoryLicenseInput: UpdateTournamentCategoryLicenseInput;
};


export type MutationUpdateTournamentCategorySortingArgs = {
  updateTournamentCategoryInput: UpdateTournamentCategoryInput;
};


export type MutationUpdateTournamentDiscountArgs = {
  updateTournamentDiscountInput: UpdateTournamentDiscountInput;
};


export type MutationUpdateTournamentDocumentArgs = {
  updateTournamentDocumentInput: UpdateTournamentDocumentInput;
};


export type MutationUpdateTournamentFactSheetArgs = {
  updateTournamentFactSheetInput: UpdateTournamentFactSheetInput;
};


export type MutationUpdateTournamentMatchesArgs = {
  updateDrawMatchInput: Array<UpdateDrawEntryInput>;
  updateGroupMatchInput: Array<UpdateGroupMatchInput>;
};


export type MutationUpdateTournamentOrganizerArgs = {
  updateTournamentOrganizerInput: UpdateTournamentOrganizerInput;
};


export type MutationUpdateTournamentRankingArgs = {
  updateTournamentRankingInput: UpdateTournamentRankingInput;
};


export type MutationUpdateTournamentRankingsEntryArgs = {
  updateTournamentRankingsEntryInput: UpdateTournamentRankingsEntryInput;
};


export type MutationUpdateTournamentRankingsManArgs = {
  updateTournamentRankingsManInput: UpdateTournamentRankingsManInput;
};


export type MutationUpdateTournamentRankingsWomanArgs = {
  updateTournamentRankingsWomanInput: UpdateTournamentRankingsWomanInput;
};


export type MutationUpdateTournamentRefereeArgs = {
  updateTournamentRefereeInput: UpdateTournamentRefereeInput;
};


export type MutationUpdateTournamentRegistrationArgs = {
  updateTournamentRegistrationInput: UpdateTournamentRegistrationInput;
};


export type MutationUpdateTournamentRegistrationQuestionArgs = {
  updateTournamentRegistrationQuestionInput: UpdateTournamentRegistrationQuestionInput;
};


export type MutationUpdateTournamentRegistrationsArgs = {
  categryId: Scalars['Int']['input'];
  registrationIds: Array<Scalars['Int']['input']>;
};


export type MutationUpdateTournamentTeamMemberArgs = {
  updateTournamentTeamMemberInput: UpdateTournamentTeamMemberInput;
};


export type MutationUpdateTournamentTeamMemberDuprArgs = {
  id: Scalars['Int']['input'];
};


export type MutationUpdateTournamentVenueArgs = {
  updateTournamentVenueInput: UpdateTournamentVenueInput;
};


export type MutationUpdateTournamentsCountryArgs = {
  updateTournamentInput?: InputMaybe<UpdateTournamentInput>;
};


export type MutationUpdateTransactionHistoryArgs = {
  updateTransactionHistoryInput: UpdateTransactionHistoryInput;
};


export type MutationUpdateTransactionHistoryByPaymentIntentArgs = {
  updateTransactionHistoryByPaymentIntentInput: UpdateTransactionHistoryByPaymentIntentInput;
};


export type MutationUpdateUserArgs = {
  isDashboardOrManager?: InputMaybe<Scalars['Boolean']['input']>;
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserCoachArgs = {
  updateUserCoachInput: UpdateUserCoachInput;
};


export type MutationUpdateUserGenderArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserInRequestsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  originalEmail?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationUpdateUserLicenseArgs = {
  updateUserLicenseInput: UpdateUserLicenseInput;
};


export type MutationUpdateUserParentArgs = {
  updateUserParentInput: UpdateUserParentInput;
};


export type MutationUpdateUserPasswordArgs = {
  updateUserpassword: UpdateUserInput;
};


export type MutationUpdateUserPasswordByAdminArgs = {
  input: UpdateUserPasswordByAdminInput;
};


export type MutationUpdateUserPasswordWebArgs = {
  isLogoutFromAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
  updateUserInput: UpdateUserInput;
};


export type MutationUpdateUserPlanArgs = {
  updateUserPlanInput: UpdateUserPlanInput;
};


export type MutationUpdateUserSettingArgs = {
  updateUserSettingInput: UpdateUserSettingInput;
};


export type MutationUpdateUserSportArgs = {
  updateUserSportInput: UpdateUserSportInput;
};


export type MutationUpdateUsersPlatformArgs = {
  platformId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type MutationUploadTeamMembersCsvArgs = {
  input: UploadTeamMembersInput;
};


export type MutationUpsertAthleteQuestionAnswerArgs = {
  input: UpsertAthleteQuestionAnswerInput;
  userId: Scalars['Int']['input'];
};


export type MutationUpsertPlatformPageArgs = {
  updatePlatformPageInput: UpdatePlatformPageInput;
};


export type MutationUserLoginArgs = {
  appleId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationValidateUserOnInviteAcceptArgs = {
  category: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  isPartneredRequestConnection?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryWprPlayerIdOrEmail?: InputMaybe<Scalars['String']['input']>;
  searchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
  tournament: Scalars['Int']['input'];
  wprPlayerIdOrEmail?: InputMaybe<Scalars['String']['input']>;
};


export type MutationVerifyMobileNumberArgs = {
  isForSignUp?: InputMaybe<Scalars['Boolean']['input']>;
  mobile: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};


export type MutationVerifyPasswordResetOtpArgs = {
  input: VerifyPasswordResetOtpInput;
};


export type MutationVerifyUserLoginOtpArgs = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationWithdrawRegistrationsArgs = {
  updateTournamentRegistrationInput: UpdateTournamentRegistrationInput;
};

export type MyActivitySectionBlock = LandingBlock & {
  __typename?: 'MyActivitySectionBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type MySignInMethodsResult = {
  __typename?: 'MySignInMethodsResult';
  hasPassword: Scalars['Boolean']['output'];
  providers: Array<SocialAuthProvider>;
  totalCount: Scalars['Float']['output'];
};

export type MyTeam = {
  __typename?: 'MyTeam';
  accessCode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  invitedMembers?: Maybe<Array<Scalars['String']['output']>>;
  isCaptain: Scalars['Boolean']['output'];
  joinedFrom?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<PublicTeamMember>>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PublicTeamPlatform>;
  sport?: Maybe<PublicTeamSport>;
  status?: Maybe<Scalars['String']['output']>;
  tiktokLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type MyTeamListResult = {
  __typename?: 'MyTeamListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<MyTeam>;
  total: Scalars['Int']['output'];
};

export type MyTeamsInput = {
  limit?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type News = {
  __typename?: 'News';
  author?: Maybe<User>;
  category?: Maybe<Scalars['String']['output']>;
  clubNews?: Maybe<Array<ClubNews>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  date?: Maybe<Scalars['DateTime']['output']>;
  federationNews?: Maybe<Array<FederationNews>>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageFile?: Maybe<StorageFile>;
  imageFileId?: Maybe<Scalars['String']['output']>;
  isDisplayLanding?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  leagueNews?: Maybe<Array<LeagueNews>>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  postCategory?: Maybe<Array<PostCategory>>;
  postText?: Maybe<Scalars['String']['output']>;
  ptiority?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  youtubeVideoLink?: Maybe<Scalars['String']['output']>;
};

export type NewsResult = {
  __typename?: 'NewsResult';
  news: Array<News>;
  total: Scalars['Int']['output'];
};

export type NewsSectionBlock = LandingBlock & {
  __typename?: 'NewsSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  bookingForm?: Maybe<BookingForm>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deviceToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailProvider?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  match?: Maybe<Match>;
  media?: Maybe<Array<Scalars['String']['output']>>;
  phone?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  subject?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** Float strategy for odd-sized pools in Swiss (LOWEST = standard, HIGHEST = top floats down) */
export enum OddPoolFloatStrategy {
  Highest = 'HIGHEST',
  Lowest = 'LOWEST'
}

export type Onboarding = {
  __typename?: 'Onboarding';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type OrderedListBlock = PostBlock & {
  __typename?: 'OrderedListBlock';
  id?: Maybe<Scalars['String']['output']>;
  items: Array<OrderedListItem>;
};

export type OrderedListItem = {
  __typename?: 'OrderedListItem';
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type OrganizationFederationPublicDto = {
  __typename?: 'OrganizationFederationPublicDto';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrganizationMemberRole {
  AthleteRepresentative = 'ATHLETE_REPRESENTATIVE',
  BoardMember = 'BOARD_MEMBER',
  ChiefExecutiveOfficer = 'CHIEF_EXECUTIVE_OFFICER',
  ClubRepresentative = 'CLUB_REPRESENTATIVE',
  CoachingManager = 'COACHING_MANAGER',
  CommitteeChair = 'COMMITTEE_CHAIR',
  CommitteeMember = 'COMMITTEE_MEMBER',
  CompetitionManager = 'COMPETITION_MANAGER',
  ExecutiveDirector = 'EXECUTIVE_DIRECTOR',
  GeneralAssemblyMember = 'GENERAL_ASSEMBLY_MEMBER',
  OfficiatingManager = 'OFFICIATING_MANAGER',
  OperationsManager = 'OPERATIONS_MANAGER',
  President = 'PRESIDENT',
  SecretaryGeneral = 'SECRETARY_GENERAL',
  TechnicalDirector = 'TECHNICAL_DIRECTOR',
  Treasurer = 'TREASURER',
  VicePresident = 'VICE_PRESIDENT',
  VotingMember = 'VOTING_MEMBER'
}

export type OrganizationPlatform = {
  __typename?: 'OrganizationPlatform';
  createdAt: Scalars['DateTime']['output'];
  customFee?: Maybe<Array<PlatformFee>>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isTournatedFeeVatEnable?: Maybe<Scalars['Boolean']['output']>;
  platform?: Maybe<Platform>;
  platformMembers?: Maybe<Array<OrganizationPlatformMember>>;
  tournatedFeeVat?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationPlatformMember = {
  __typename?: 'OrganizationPlatformMember';
  addedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  organizationPlatform?: Maybe<OrganizationPlatform>;
  platform?: Maybe<Platform>;
  role?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type OrganizationSubscription = {
  __typename?: 'OrganizationSubscription';
  createdAt: Scalars['DateTime']['output'];
  customFee?: Maybe<Array<PlatformFee>>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isTournatedFeeVatEnable?: Maybe<Scalars['Boolean']['output']>;
  isValidSubscription: Scalars['Boolean']['output'];
  platform?: Maybe<Platform>;
  platformMembers?: Maybe<Array<OrganizationPlatformMember>>;
  tournatedFeeVat?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export enum OrganizationType {
  ClubChainOwner = 'CLUB_CHAIN_OWNER',
  ClubOwner = 'CLUB_OWNER',
  Community = 'COMMUNITY',
  EducationalInstitution = 'EDUCATIONAL_INSTITUTION',
  GovernmentAuthority = 'GOVERNMENT_AUTHORITY',
  InternationalGoverningBody = 'INTERNATIONAL_GOVERNING_BODY',
  Municipality = 'MUNICIPALITY',
  NationalGoverningBody = 'NATIONAL_GOVERNING_BODY',
  PrivateEntity = 'PRIVATE_ENTITY',
  RegionalGoverningBody = 'REGIONAL_GOVERNING_BODY',
  School = 'SCHOOL',
  SportsClub = 'SPORTS_CLUB',
  SportsMinistry = 'SPORTS_MINISTRY',
  UmbrellaSportsBody = 'UMBRELLA_SPORTS_BODY',
  Union = 'UNION'
}

export type OrganizerLeagueUsersResult = {
  __typename?: 'OrganizerLeagueUsersResult';
  total: Scalars['Int']['output'];
  users: Array<UserDetail>;
};

export type OrganizerLivescoreEnabledPayload = {
  __typename?: 'OrganizerLivescoreEnabledPayload';
  enabled: Scalars['Boolean']['output'];
  organizerId: Scalars['Int']['output'];
};

export type OtherPlayerLicenseCalculationOutput = {
  __typename?: 'OtherPlayerLicenseCalculationOutput';
  afterDiscountLicenseFee: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  licenseFee: Scalars['Float']['output'];
  licenseId: Scalars['Float']['output'];
  platformFee: Scalars['Float']['output'];
  promoDiscountAmount: Scalars['Float']['output'];
  stripeFee: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  vatAmount: Scalars['Float']['output'];
};

export type OwnAppLinks = {
  __typename?: 'OwnAppLinks';
  android?: Maybe<Scalars['String']['output']>;
  ios?: Maybe<Scalars['String']['output']>;
};

export type OwnAppLinksInput = {
  android?: InputMaybe<Scalars['String']['input']>;
  ios?: InputMaybe<Scalars['String']['input']>;
};

/** Possible options for payment method */
export enum Payment_Method {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Online = 'ONLINE',
  Stripe = 'STRIPE'
}

/** Possible options for payment status */
export enum Payment_Status {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Successful = 'SUCCESSFUL'
}

export type PLatformStats = {
  __typename?: 'PLatformStats';
  leagueCount: Scalars['Int']['output'];
  tournamentCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

export enum PageSlug {
  About = 'ABOUT',
  Contact = 'CONTACT',
  Home = 'HOME'
}

export type PaginatedPartnersResult = {
  __typename?: 'PaginatedPartnersResult';
  data: Array<LicensePaymentUserPartner>;
  limit: Scalars['Int']['output'];
  page: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type Pairing = {
  __typename?: 'Pairing';
  algo?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  hide?: Maybe<Scalars['Boolean']['output']>;
  hideStandings?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  pairingEntries?: Maybe<Array<PairingEntry>>;
  place?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PairingEntry = {
  __typename?: 'PairingEntry';
  createdAt: Scalars['DateTime']['output'];
  date?: Maybe<Scalars['DateTime']['output']>;
  entry1?: Maybe<TournamentRegistration>;
  entry2?: Maybe<TournamentRegistration>;
  id: Scalars['Float']['output'];
  matchStatus?: Maybe<Scalars['String']['output']>;
  pairing?: Maybe<Pairing>;
  pts?: Maybe<Scalars['Float']['output']>;
  round?: Maybe<Scalars['Float']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  scoreType?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
  winner?: Maybe<TournamentRegistration>;
};

/** Americano/Mexicano pairing mode (FIXED, ROTATING, or SINGLES) */
export enum PairingMode {
  Fixed = 'FIXED',
  Rotating = 'ROTATING',
  Singles = 'SINGLES'
}

export type ParticipantInfo = {
  __typename?: 'ParticipantInfo';
  badge?: Maybe<Scalars['String']['output']>;
  dupr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  points: Scalars['Float']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  /** Team name (for doubles/teams) */
  teamName?: Maybe<Scalars['String']['output']>;
  /** Users in team - always an array (1 for singles, 2+ for doubles/teams) */
  users: Array<UserInfo>;
  wpr?: Maybe<Scalars['Float']['output']>;
  wprConfidenceLevel?: Maybe<Scalars['String']['output']>;
};

export type ParticipantsMetadata = {
  __typename?: 'ParticipantsMetadata';
  average?: Maybe<Scalars['Int']['output']>;
  averageAgeByCountry?: Maybe<Scalars['JSON']['output']>;
  men: Scalars['Int']['output'];
  menPercentage: Scalars['String']['output'];
  oldest?: Maybe<Scalars['Int']['output']>;
  other: Scalars['Int']['output'];
  otherPercentage: Scalars['String']['output'];
  participantsCountByCountry?: Maybe<Scalars['JSON']['output']>;
  total: Scalars['Int']['output'];
  uniqueCountriesCount?: Maybe<Scalars['Int']['output']>;
  women: Scalars['Int']['output'];
  womenPercentage: Scalars['String']['output'];
  youngest?: Maybe<Scalars['Int']['output']>;
};

export type Partner = {
  __typename?: 'Partner';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  ageRestriction?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  federation?: Maybe<Federation>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  league?: Maybe<League>;
  license?: Maybe<Scalars['String']['output']>;
  licenseRequired?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  priority?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sponsorText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentsSum?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerNew = {
  __typename?: 'PartnerNew';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  id: Scalars['Float']['output'];
  imageFile?: Maybe<StorageFileOutput>;
  legacyImage?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sponsorText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerPublic = {
  __typename?: 'PartnerPublic';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Float']['output'];
  imageFile?: Maybe<StorageFileOutput>;
  legacyImage?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sponsorText?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type PartnerSearch = {
  __typename?: 'PartnerSearch';
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  duprRating?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  partner?: Maybe<User>;
  partnerInformation?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  selfInformation?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type PartnerSearchRequest = {
  __typename?: 'PartnerSearchRequest';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  requester: User;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type PartnerSearchsResult = {
  __typename?: 'PartnerSearchsResult';
  partnerSearches: Array<PartnerSearch>;
  total: Scalars['Int']['output'];
  uniqueTotal: Scalars['Int']['output'];
};

export type PartnersSectionBlock = LandingBlock & {
  __typename?: 'PartnersSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
  sectionLabel?: Maybe<SectionLabel>;
};

export type PaymentCalculation = {
  __typename?: 'PaymentCalculation';
  additionalQuestionAmount?: Maybe<Scalars['Float']['output']>;
  amountCalculatedOn?: Maybe<Scalars['DateTime']['output']>;
  appliedVAT?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  onSiteEntryFee?: Maybe<Scalars['Float']['output']>;
  onlineEntryFee?: Maybe<Scalars['Float']['output']>;
  payForMyself?: Maybe<Scalars['Boolean']['output']>;
  paymentCalculationType?: Maybe<PaymentCalculationType>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentType?: Maybe<PaymentType>;
  promoCode?: Maybe<Scalars['String']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  secondPartnerFee?: Maybe<Scalars['Float']['output']>;
  serviceFeeCalculationType?: Maybe<ServiceFeeCalculationType>;
  totalCalculatedUserDiscount?: Maybe<Scalars['Float']['output']>;
  totalCalculatedUserFee?: Maybe<Scalars['Float']['output']>;
  totalOnSitePayable?: Maybe<Scalars['Float']['output']>;
  totalOnlinePayable?: Maybe<Scalars['Float']['output']>;
  totalPartnerFee?: Maybe<Scalars['Float']['output']>;
  totalPaymentProcessorFee?: Maybe<Scalars['Float']['output']>;
  totalTournatedFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userDiscounts?: Maybe<Array<UserDiscount>>;
  userFees?: Maybe<Array<UserFee>>;
  vatAppliedOnTournatedFee?: Maybe<Scalars['Float']['output']>;
  vatFeeValue?: Maybe<Scalars['Float']['output']>;
};

/** Entry Payment calculation mode */
export enum PaymentCalculationType {
  PerAthlete = 'PER_ATHLETE',
  PerCrew = 'PER_CREW',
  PerPair = 'PER_PAIR',
  PerTeam = 'PER_TEAM'
}

export type PaymentDiscount = {
  __typename?: 'PaymentDiscount';
  categories?: Maybe<Array<TournamentCategory>>;
  /** Tournament location coordinates with latitude and longitude */
  categoryDiscounts?: Maybe<Array<Scalars['JSON']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountExpireTime?: Maybe<Scalars['DateTime']['output']>;
  discountPer?: Maybe<Scalars['Float']['output']>;
  discountStartTime?: Maybe<Scalars['DateTime']['output']>;
  discountType?: Maybe<PaymentDiscountType>;
  id: Scalars['ID']['output'];
  isLimitCount?: Maybe<Scalars['Boolean']['output']>;
  isVTRD?: Maybe<Scalars['Boolean']['output']>;
  licences?: Maybe<Array<License>>;
  numberOfCategories?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  totalCounts?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  usedCounts?: Maybe<Scalars['Float']['output']>;
  userDiscount?: Maybe<Array<UserDiscount>>;
};

/** Payment Discount Type */
export enum PaymentDiscountType {
  CategoryDiscount = 'CATEGORY_DISCOUNT',
  EarlyBirdDiscount = 'EARLY_BIRD_DISCOUNT',
  LicenceDiscount = 'LICENCE_DISCOUNT',
  PromoCode = 'PROMO_CODE'
}

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  licensePaymentStatus?: Maybe<PaymentIntentStatus>;
  message?: Maybe<Scalars['String']['output']>;
  paymentCalculation?: Maybe<Array<PaymentCalculation>>;
  paymentDone: Scalars['Boolean']['output'];
  paymentMethod?: Maybe<PaymentMethod>;
  paymentStatus?: Maybe<PaymentIntentStatus>;
  paymentTransactions?: Maybe<Array<PaymentTransaction>>;
  proofOfPayment?: Maybe<Scalars['String']['output']>;
  registrationRequests?: Maybe<Array<TournamentRegistration>>;
  requestInitiatedBy?: Maybe<User>;
  totalAmounts?: Maybe<Scalars['Float']['output']>;
  totalAmountsOfLicenses?: Maybe<Scalars['Float']['output']>;
  totalPaidAmounts?: Maybe<Scalars['Float']['output']>;
  totalPaidRegistrationRequests?: Maybe<Scalars['Float']['output']>;
  totalPendingAmounts?: Maybe<Scalars['Float']['output']>;
  totalPendingRegistrationRequests?: Maybe<Scalars['Float']['output']>;
  totalRegistrationRequests?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Payment Intent Status */
export enum PaymentIntentStatus {
  Cancelled = 'CANCELLED',
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
}

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  methodName?: Maybe<Scalars['String']['output']>;
  methodType?: Maybe<Scalars['String']['output']>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentMethodSetting?: Maybe<PaymentMethodSetting>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodSetting = {
  __typename?: 'PaymentMethodSetting';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  paymentInstructions?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<PaymentMethod>;
  privateAccessKey?: Maybe<Scalars['String']['output']>;
  privateSecretKey?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Payment provider options for checkout sessions */
export enum PaymentProvider {
  Stripe = 'STRIPE',
  WechatPay = 'WECHAT_PAY'
}

/** Possible statuses of a payment */
export enum PaymentStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Pending = 'PENDING'
}

export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  PaymentTransactionType: Scalars['String']['output'];
  amountReceived?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  currencyExchangeRate?: Maybe<CurrencyExchangeRate>;
  id: Scalars['ID']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  licensePaymentData?: Maybe<LicensePaymentData>;
  organization?: Maybe<Federation>;
  organizer?: Maybe<User>;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentProcessorIntentId?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  paymentTraceId?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  productType: Scalars['String']['output'];
  secondPartnerFee?: Maybe<Scalars['Float']['output']>;
  stripeAccountName?: Maybe<Scalars['String']['output']>;
  stripeDescription?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  totalAppliedVAT?: Maybe<Scalars['Float']['output']>;
  totalConvertedAmount?: Maybe<Scalars['Float']['output']>;
  totalOriginalAmount?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentRegistrations?: Maybe<Array<TournamentRegistration>>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  transferPayments?: Maybe<Array<TransferPayment>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

/** Payment Category Type */
export enum PaymentType {
  Doubles = 'DOUBLES',
  Single = 'SINGLE',
  Team = 'TEAM'
}

export type PendingUnderageDetails = {
  __typename?: 'PendingUnderageDetails';
  matches: Array<UnderageWtnPlayerMatch>;
  players: Array<UnderageWtnPlayer>;
  totalPendingMatches: Scalars['Int']['output'];
  totalPendingPlayers: Scalars['Int']['output'];
};

export type PlaceMultiplier = {
  __typename?: 'PlaceMultiplier';
  multiplier: Scalars['Float']['output'];
  placeFrom: Scalars['Int']['output'];
  placeTo: Scalars['Int']['output'];
};

export type PlaceMultiplierInput = {
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  placeFrom?: InputMaybe<Scalars['Int']['input']>;
  placeTo?: InputMaybe<Scalars['Int']['input']>;
};

export type Plan = {
  __typename?: 'Plan';
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  monthlyDiscount?: Maybe<Scalars['String']['output']>;
  planType?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  yearlyDiscount?: Maybe<Scalars['String']['output']>;
};

export type PlateformSport = {
  __typename?: 'PlateformSport';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Platform = {
  __typename?: 'Platform';
  abbreviation?: Maybe<Scalars['String']['output']>;
  accessCode?: Maybe<Scalars['String']['output']>;
  albums?: Maybe<Album>;
  alreadyDomain?: Maybe<Scalars['Boolean']['output']>;
  authMethods?: Maybe<Array<AuthMethod>>;
  club?: Maybe<Array<Club>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  coverPhotoFile?: Maybe<StorageFile>;
  coverPhotoFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customFee?: Maybe<Array<PlatformFee>>;
  darkEmblem?: Maybe<Scalars['String']['output']>;
  darkLogo?: Maybe<Scalars['String']['output']>;
  darkLogoFile?: Maybe<StorageFile>;
  darkLogoFileId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<Discipline>>;
  discordLink?: Maybe<Scalars['String']['output']>;
  documentFolders?: Maybe<Array<DocumentFolder>>;
  documents?: Maybe<Array<Document>>;
  domain?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  faviconFile?: Maybe<StorageFile>;
  faviconFileId?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  graphicsForSmm?: Maybe<Scalars['Boolean']['output']>;
  groupedPlatformIds?: Maybe<Array<Scalars['Int']['output']>>;
  hasOwnApp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  isChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEnableMaintenance?: Maybe<Scalars['Boolean']['output']>;
  isEnablePrice?: Maybe<Scalars['Boolean']['output']>;
  isMobileAppSupported?: Maybe<Scalars['Boolean']['output']>;
  isTournatedFeeVatEnable?: Maybe<Scalars['Boolean']['output']>;
  isVatFeeApplicable?: Maybe<Scalars['Boolean']['output']>;
  landingBlocks: Array<LandingBlock>;
  landingLink?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  licenseMemberships?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Array<License>>;
  lightEmblem?: Maybe<Scalars['String']['output']>;
  lightLogo?: Maybe<Scalars['String']['output']>;
  lightLogoFile?: Maybe<StorageFile>;
  lightLogoFileId?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  liveScoring?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming_sporfie_key?: Maybe<Scalars['String']['output']>;
  maintenanceDescription?: Maybe<Scalars['String']['output']>;
  maintenanceTitle?: Maybe<Scalars['String']['output']>;
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  navigation?: Maybe<Array<Scalars['JSON']['output']>>;
  needIntegration?: Maybe<Scalars['Boolean']['output']>;
  needLanding?: Maybe<Scalars['Boolean']['output']>;
  onlineBookingCourts?: Maybe<Scalars['Boolean']['output']>;
  onlinePayment?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<OrganizationPlatform>>;
  ownAppLinks?: Maybe<OwnAppLinks>;
  owner?: Maybe<Federation>;
  pages?: Maybe<Array<PlatformPage>>;
  partnerEntryFee?: Maybe<Scalars['Float']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  platformLink?: Maybe<Scalars['String']['output']>;
  platformSetting?: Maybe<PlatformSetting>;
  platformType?: Maybe<Scalars['String']['output']>;
  postCategories?: Maybe<Array<PostCategory>>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  promoteTournatedApp?: Maybe<Scalars['Boolean']['output']>;
  /** Public id, e.g. plt_… */
  publicId: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  sendGridEmail?: Maybe<Scalars['String']['output']>;
  sendGridName?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  signeeFullName?: Maybe<Scalars['String']['output']>;
  signeeRole?: Maybe<Scalars['String']['output']>;
  smm?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Array<PlateformSport>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  subDomain?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  template?: Maybe<Template>;
  /** Per-platform terminology overrides (term → selected option key). `null` means default wording across all terms. */
  terminology?: Maybe<PlatformTerminology>;
  thirdPartyLicenses?: Maybe<Array<ThirdPartyLicense>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedEntryFee?: Maybe<Scalars['Float']['output']>;
  tournatedFeeVat?: Maybe<Scalars['Float']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadFile?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
  vatFee?: Maybe<Scalars['Float']['output']>;
  yourRequest?: Maybe<Scalars['String']['output']>;
};


export type PlatformLandingBlocksArgs = {
  slug?: PageSlug;
};

export type PlatformCoach = {
  __typename?: 'PlatformCoach';
  category?: Maybe<Scalars['String']['output']>;
  clubs?: Maybe<Array<Club>>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
  displayOnLandingPage?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  students?: Maybe<Array<UserCoach>>;
  user?: Maybe<User>;
  userRole?: Maybe<Scalars['String']['output']>;
};

export type PlatformCoachListFilterInput = {
  clubId?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to coaches whose owning federation is any of these ids */
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<PlatformCoachListOrderBy>;
  page?: Scalars['Int']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** Restrict to these platform ids */
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  statuses?: InputMaybe<Array<PlatformCoachStatus>>;
  studentsMax?: InputMaybe<Scalars['Int']['input']>;
  studentsMin?: InputMaybe<Scalars['Int']['input']>;
};

export enum PlatformCoachListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type PlatformCoachFilterInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubId?: InputMaybe<Scalars['Int']['input']>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organisationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<PlatformCoachSortField>;
  sortOrder?: InputMaybe<PlatformCoachSortOrder>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  studentsMax?: InputMaybe<Scalars['Int']['input']>;
  studentsMin?: InputMaybe<Scalars['Int']['input']>;
};

export enum PlatformCoachSortField {
  City = 'CITY',
  CreatedAt = 'CREATED_AT',
  Name = 'NAME',
  Sport = 'SPORT',
  Surname = 'SURNAME'
}

export enum PlatformCoachSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PlatformCoachResult = {
  __typename?: 'PlatformCoachResult';
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  platformCoaches: Array<PlatformCoach>;
  total: Scalars['Int']['output'];
};

export enum PlatformCoachStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type PlatformDocument = {
  __typename?: 'PlatformDocument';
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  createdAt: Scalars['DateTime']['output'];
  displayOn?: Maybe<PlatformDocumentDisplayOn>;
  document?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  documentFile?: Maybe<StorageFile>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  documentFileId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  id: Scalars['Float']['output'];
  isLeaguePage?: Maybe<Scalars['Boolean']['output']>;
  isRankings?: Maybe<Scalars['Boolean']['output']>;
  isTournamentCalender?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  platform?: Maybe<Platform>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use GraphQL types PlatformDocumentNew (dashboard & manager) or PlatformDocumentPublic (public website). */
  updatedAt: Scalars['DateTime']['output'];
};

export enum PlatformDocumentDisplayOn {
  LeaguePage = 'LEAGUE_PAGE',
  Rankings = 'RANKINGS',
  TournamentsCalendar = 'TOURNAMENTS_CALENDAR'
}

export type PlatformDocumentNew = {
  __typename?: 'PlatformDocumentNew';
  createdAt: Scalars['DateTime']['output'];
  displayOn: Array<PlatformDocumentDisplayOn>;
  documentFile?: Maybe<StorageFileOutput>;
  id: Scalars['Int']['output'];
  legacyDocumentUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortingPositions: Array<PlatformDocumentSortingPosition>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformDocumentPublic = {
  __typename?: 'PlatformDocumentPublic';
  createdAt: Scalars['DateTime']['output'];
  displayOn: Array<PlatformDocumentDisplayOn>;
  documentFile: StorageFileOutput;
  id: Scalars['Int']['output'];
  legacyDocumentUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortingPositions: Array<PlatformDocumentSortingPosition>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformDocumentSortingPosition = {
  __typename?: 'PlatformDocumentSortingPosition';
  displayOn: PlatformDocumentDisplayOn;
  position: Scalars['Int']['output'];
};

export type PlatformDocumentSortingPositionInput = {
  displayOn: PlatformDocumentDisplayOn;
  position: Scalars['Int']['input'];
};

export type PlatformFee = {
  __typename?: 'PlatformFee';
  currency?: Maybe<Scalars['String']['output']>;
  feeMode: Scalars['String']['output'];
  feeType: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isMonetization?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  organizationPlatform: OrganizationPlatform;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  partnerMaxFee?: Maybe<Scalars['Float']['output']>;
  partnerMaxPercentageFee?: Maybe<Scalars['Float']['output']>;
  partnerMinFee?: Maybe<Scalars['Float']['output']>;
  partnerMinPercentageFee?: Maybe<Scalars['Float']['output']>;
  platform: Platform;
  rangeEnd: Scalars['Float']['output'];
  rangeStart: Scalars['Float']['output'];
  serviceType: Scalars['String']['output'];
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  tournatedMaxFee?: Maybe<Scalars['Float']['output']>;
  tournatedMaxPercentageFee?: Maybe<Scalars['Float']['output']>;
  tournatedMinFee?: Maybe<Scalars['Float']['output']>;
  tournatedMinPercentageFee?: Maybe<Scalars['Float']['output']>;
};

export type PlatformLivescoreEnabledPayload = {
  __typename?: 'PlatformLivescoreEnabledPayload';
  enabled: Scalars['Boolean']['output'];
  platformId: Scalars['Int']['output'];
};

export type PlatformPage = {
  __typename?: 'PlatformPage';
  blocks: Array<Scalars['JSON']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  slug: PageSlug;
  updatedAt: Scalars['DateTime']['output'];
};

export type PlatformSetting = {
  __typename?: 'PlatformSetting';
  dateFormatPreference?: Maybe<DateFormatPreference>;
  id: Scalars['Int']['output'];
  isEmailDisabled?: Maybe<Scalars['Boolean']['output']>;
  mapProvider?: Maybe<MapProvider>;
  notificationFromEmail?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  platform: Platform;
  replaceDefaultBrandName?: Maybe<Scalars['Boolean']['output']>;
  timeFormatPreference?: Maybe<TimeFormatPreference>;
};

/** Per-platform terminology configuration — maps each customizable term to the selected option key. A `null` map (or an absent inner key) falls back to the platform-agnostic default wording. */
export type PlatformTerminology = {
  __typename?: 'PlatformTerminology';
  /** Selected wording for the `athlete` term; `null` falls back to the default. */
  athlete?: Maybe<AthleteTerm>;
  /** Selected wording for the `tournament` term; `null` falls back to the default. */
  tournament?: Maybe<TournamentTerm>;
  /** Selected wording for the `venue` term; `null` falls back to the default. */
  venue?: Maybe<VenueTerm>;
};

export type PlatformWithSubscription = {
  __typename?: 'PlatformWithSubscription';
  abbreviation?: Maybe<Scalars['String']['output']>;
  accessCode?: Maybe<Scalars['String']['output']>;
  albums?: Maybe<Album>;
  alreadyDomain?: Maybe<Scalars['Boolean']['output']>;
  authMethods?: Maybe<Array<AuthMethod>>;
  club?: Maybe<Array<Club>>;
  coaches?: Maybe<Array<PlatformCoach>>;
  companyEmail?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  coverPhotoFile?: Maybe<StorageFile>;
  coverPhotoFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customFee?: Maybe<Array<PlatformFee>>;
  darkEmblem?: Maybe<Scalars['String']['output']>;
  darkLogo?: Maybe<Scalars['String']['output']>;
  darkLogoFile?: Maybe<StorageFile>;
  darkLogoFileId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  disciplines?: Maybe<Array<Discipline>>;
  discordLink?: Maybe<Scalars['String']['output']>;
  documentFolders?: Maybe<Array<DocumentFolder>>;
  documents?: Maybe<Array<Document>>;
  domain?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  faviconFile?: Maybe<StorageFile>;
  faviconFileId?: Maybe<Scalars['String']['output']>;
  fullAddress?: Maybe<Scalars['String']['output']>;
  graphicsForSmm?: Maybe<Scalars['Boolean']['output']>;
  groupedPlatformIds?: Maybe<Array<Scalars['Int']['output']>>;
  hasOwnApp?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  isChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  isEnableMaintenance?: Maybe<Scalars['Boolean']['output']>;
  isEnablePrice?: Maybe<Scalars['Boolean']['output']>;
  isMobileAppSupported?: Maybe<Scalars['Boolean']['output']>;
  isTournatedFeeVatEnable?: Maybe<Scalars['Boolean']['output']>;
  isValidSubscription: Scalars['Boolean']['output'];
  isVatFeeApplicable?: Maybe<Scalars['Boolean']['output']>;
  landingBlocks: Array<LandingBlock>;
  landingLink?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  licenseMemberships?: Maybe<Scalars['Boolean']['output']>;
  licenses?: Maybe<Array<License>>;
  lightEmblem?: Maybe<Scalars['String']['output']>;
  lightLogo?: Maybe<Scalars['String']['output']>;
  lightLogoFile?: Maybe<StorageFile>;
  lightLogoFileId?: Maybe<Scalars['String']['output']>;
  linkedinLink?: Maybe<Scalars['String']['output']>;
  liveScoring?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming?: Maybe<Scalars['Boolean']['output']>;
  liveStreaming_sporfie_key?: Maybe<Scalars['String']['output']>;
  maintenanceDescription?: Maybe<Scalars['String']['output']>;
  maintenanceTitle?: Maybe<Scalars['String']['output']>;
  mobileApp?: Maybe<Scalars['Boolean']['output']>;
  navigation?: Maybe<Array<Scalars['JSON']['output']>>;
  needIntegration?: Maybe<Scalars['Boolean']['output']>;
  needLanding?: Maybe<Scalars['Boolean']['output']>;
  onlineBookingCourts?: Maybe<Scalars['Boolean']['output']>;
  onlinePayment?: Maybe<Scalars['Boolean']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Array<OrganizationPlatform>>;
  ownAppLinks?: Maybe<OwnAppLinks>;
  owner?: Maybe<Federation>;
  pages?: Maybe<Array<PlatformPage>>;
  partnerEntryFee?: Maybe<Scalars['Float']['output']>;
  partnerLicenseFee?: Maybe<Scalars['Float']['output']>;
  passcode?: Maybe<Scalars['String']['output']>;
  platformLink?: Maybe<Scalars['String']['output']>;
  platformManagers?: Maybe<Array<OrganizationPlatformMember>>;
  platformSetting?: Maybe<PlatformSetting>;
  platformType?: Maybe<Scalars['String']['output']>;
  postCategories?: Maybe<Array<PostCategory>>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  promoteTournatedApp?: Maybe<Scalars['Boolean']['output']>;
  /** Public id, e.g. plt_… */
  publicId: Scalars['String']['output'];
  registrationNumber?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  sendGridEmail?: Maybe<Scalars['String']['output']>;
  sendGridName?: Maybe<Scalars['String']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  signeeFullName?: Maybe<Scalars['String']['output']>;
  signeeRole?: Maybe<Scalars['String']['output']>;
  smm?: Maybe<Scalars['Boolean']['output']>;
  sports?: Maybe<Array<PlateformSport>>;
  status?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  subDomain?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  teams?: Maybe<Array<Team>>;
  template?: Maybe<Template>;
  /** Per-platform terminology overrides (term → selected option key). `null` means default wording across all terms. */
  terminology?: Maybe<PlatformTerminology>;
  thirdPartyLicenses?: Maybe<Array<ThirdPartyLicense>>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournatedEntryFee?: Maybe<Scalars['Float']['output']>;
  tournatedFeeVat?: Maybe<Scalars['Float']['output']>;
  tournatedLicenseFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadFile?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
  vatFee?: Maybe<Scalars['Float']['output']>;
  yourRequest?: Maybe<Scalars['String']['output']>;
};


export type PlatformWithSubscriptionLandingBlocksArgs = {
  slug?: PageSlug;
};

export type PlatformsOrganizationResult = {
  __typename?: 'PlatformsOrganizationResult';
  organizations: Array<OrganizationPlatform>;
  total: Scalars['Int']['output'];
};

export type PlatformsResult = {
  __typename?: 'PlatformsResult';
  platforms: Array<Platform>;
  total: Scalars['Int']['output'];
};

export type PlayerFeeBreakdown = {
  __typename?: 'PlayerFeeBreakdown';
  discountedOnlineFee: Scalars['Float']['output'];
  discountedOnsiteFee: Scalars['Float']['output'];
  onlineFee: Scalars['Float']['output'];
  onsiteFee: Scalars['Float']['output'];
  userId: Scalars['Int']['output'];
};

export type PlayerH2HMatchHistory = {
  __typename?: 'PlayerH2HMatchHistory';
  hasMore: Scalars['Boolean']['output'];
  items: Array<H2HMatchItem>;
  total: Scalars['Int']['output'];
};

export type PlayerH2HMatchHistoryInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchType: H2HMatchType;
  page?: InputMaybe<Scalars['Int']['input']>;
  player1Id: Scalars['Int']['input'];
  player2Id: Scalars['Int']['input'];
  /** Sport ids to scope the H2H to. Required — H2H stats only make sense within a single sport context. */
  sportIds: Array<Scalars['Int']['input']>;
};

export type PlayerH2HStats = {
  __typename?: 'PlayerH2HStats';
  /** Calendar years where this player has at least one decided match. Sorted newest first. UI can use this to render year-filter tabs only for years that actually have data. */
  availableYears: Array<Scalars['Int']['output']>;
  /** Career average match duration in minutes. Ignores the `year` argument. */
  avgMatchDurationMinutes?: Maybe<Scalars['Float']['output']>;
  /** Average match duration in minutes scoped to the `year` argument (defaults to current year). */
  avgMatchDurationYearMinutes?: Maybe<Scalars['Float']['output']>;
  /** Lowest opponent `rank` the player has beaten (lower number = stronger opponent). Null when no opponent ranks are available. */
  bestWinByOpponentRank?: Maybe<Scalars['Int']['output']>;
  careerLosses: Scalars['Int']['output'];
  /** Career prize money (forward-compat shape). Currently null pending DEV ticket for prize-money tracking. */
  careerPrizeMoney?: Maybe<H2HMoneyValue>;
  careerTitles: Scalars['Int']['output'];
  careerWinRate: Scalars['Float']['output'];
  careerWins: Scalars['Int']['output'];
  currentRanking?: Maybe<H2HCurrentRanking>;
  currentStreak?: Maybe<H2HCurrentStreak>;
  /** Doubles only. Career count of distinct partners the player has played with. */
  doublesUniquePartners?: Maybe<Scalars['Int']['output']>;
  /** Doubles only. Count of distinct partners the player has played with in the `year` argument (defaults to current year). */
  doublesUniquePartnersYear?: Maybe<Scalars['Int']['output']>;
  finalsReachedCareer: Scalars['Int']['output'];
  finalsReachedYear: Scalars['Int']['output'];
  /** Last up to 10 completed matches as W/L characters, most recent first. */
  recentFormLast10: Scalars['String']['output'];
  tournamentsPlayedCareer: Scalars['Int']['output'];
  tournamentsPlayedYear: Scalars['Int']['output'];
  /** Calendar year that the year-scoped fields below cover. Defaults to the current year; override via the `year` argument. */
  year: Scalars['Int']['output'];
  yearLosses: Scalars['Int']['output'];
  yearTitles: Scalars['Int']['output'];
  yearWins: Scalars['Int']['output'];
};

export type PlayerH2HSummary = {
  __typename?: 'PlayerH2HSummary';
  /** Calendar years where these two players actually met. Sorted newest first. Use to render year-filter tabs only for years that have data. */
  availableYears: Array<Scalars['Int']['output']>;
  /** Count of distinct opponents both players have faced. */
  commonOpponents: Scalars['Int']['output'];
  lastMeeting?: Maybe<H2HMatchItem>;
  player1Wins: Scalars['Int']['output'];
  player2Wins: Scalars['Int']['output'];
  totalMatches: Scalars['Int']['output'];
};

/** How to group players into pools */
export enum PoolGrouping {
  Exact = 'EXACT',
  Floating = 'FLOATING',
  MergeAdjacent = 'MERGE_ADJACENT',
  Range = 'RANGE',
  Round1Single = 'ROUND1_SINGLE'
}

/** How to pair players within pools */
export enum PoolPairingMethod {
  Random = 'RANDOM',
  Seeded = 'SEEDED',
  TopVsBottom = 'TOP_VS_BOTTOM'
}

export type Post = {
  __typename?: 'Post';
  author?: Maybe<User>;
  /** Ordered array of block payloads. Each block carries a `__typename` discriminator matching one of the PostBlock union variants. */
  blocks: Array<Scalars['JSON']['output']>;
  categories?: Maybe<Array<PostCategory>>;
  /** Clubs / venues this post is attached to. */
  clubs?: Maybe<Array<Club>>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords: Array<Scalars['String']['output']>;
  /** BCP-47 language code (e.g. "en", "lv"). Combined with `slug` forms the unique key — same slug can co-exist across languages. */
  language: Scalars['String']['output'];
  /** Leagues / tours this post is attached to. */
  leagues?: Maybe<Array<League>>;
  mentions: Array<PostMention>;
  /** SEO meta description — falls back to `excerpt`. */
  metaDescription?: Maybe<Scalars['String']['output']>;
  /** SEO meta title — falls back to `title` on FE. */
  metaTitle?: Maybe<Scalars['String']['output']>;
  /** Open Graph image — falls back to `coverImage`. */
  ogImage?: Maybe<Scalars['String']['output']>;
  /** Organizers (federations) this post is attached to. */
  organizers?: Maybe<Array<Federation>>;
  platform?: Maybe<Platform>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Estimated reading time in minutes (rounded up, min 1). Computed at query time. */
  readingTimeMinutes: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: PostStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  /** Tournaments this post is attached to. */
  tournaments?: Maybe<Array<Tournament>>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Discriminated union of all renderable post block kinds. */
export type PostBlock = {
  id?: Maybe<Scalars['String']['output']>;
};

export type PostCategory = {
  __typename?: 'PostCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  news?: Maybe<Array<News>>;
  platform?: Maybe<Platform>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PostMention = {
  __typename?: 'PostMention';
  athlete?: Maybe<User>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  /** ID of the mentioned entity. Resolve via the type-matched nested field. */
  entityId: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  league?: Maybe<League>;
  mentionType: PostMentionType;
  organizer?: Maybe<Federation>;
  /** Platform whose host the URL pointed at. NULL for manual mentions or when host is unrecognised. */
  platformId?: Maybe<Scalars['Int']['output']>;
  source: PostMentionSource;
  team?: Maybe<Team>;
  tournament?: Maybe<Tournament>;
};

export type PostMentionInput = {
  entityId: Scalars['Int']['input'];
  type: PostMentionType;
};

/** AUTO_FROM_URL = extracted from a URL in block text. MANUAL = added by an admin via the input. */
export enum PostMentionSource {
  AutoFromUrl = 'AUTO_FROM_URL',
  Manual = 'MANUAL'
}

/** Entity type a mention points to. Drives which resolver field on PostMention will be populated. */
export enum PostMentionType {
  Athlete = 'ATHLETE',
  Club = 'CLUB',
  League = 'LEAGUE',
  Organizer = 'ORGANIZER',
  Team = 'TEAM',
  Tournament = 'TOURNAMENT'
}

/** Editorial state. Only PUBLISHED rows surface on public queries. */
export enum PostStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type PostsSectionBlock = LandingBlock & {
  __typename?: 'PostsSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
};

export type PoweredBannerBlock = LandingBlock & {
  __typename?: 'PoweredBannerBlock';
  id?: Maybe<Scalars['String']['output']>;
  partners?: Maybe<Array<PoweredBannerPartner>>;
};

export type PoweredBannerPartner = {
  __typename?: 'PoweredBannerPartner';
  link?: Maybe<Scalars['String']['output']>;
  logo: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Shown as translated label below partner name */
  type?: Maybe<PoweredBannerPartnerType>;
};

export enum PoweredBannerPartnerType {
  NationalFederation = 'NATIONAL_FEDERATION',
  OlympicCommittee = 'OLYMPIC_COMMITTEE',
  RegionalFederation = 'REGIONAL_FEDERATION',
  SportsFederationsCouncil = 'SPORTS_FEDERATIONS_COUNCIL',
  SportsPlatform = 'SPORTS_PLATFORM',
  Tour = 'TOUR'
}

/** Possible types of products */
export enum Products {
  License = 'LICENSE',
  Registration = 'REGISTRATION'
}

export type ProposedResult = {
  __typename?: 'ProposedResult';
  approvedAt?: Maybe<Scalars['DateTime']['output']>;
  approvedBy?: Maybe<User>;
  approvedByUserId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  match?: Maybe<Match>;
  matchId: Scalars['Int']['output'];
  /** Match result payload as proposed by the scorer. */
  payload: Scalars['JSONObject']['output'];
  rejectionReason?: Maybe<Scalars['String']['output']>;
  status: ProposedResultStatus;
  submittedAt: Scalars['DateTime']['output'];
  submittedByEmail?: Maybe<Scalars['String']['output']>;
  submittedByJti: Scalars['String']['output'];
  tournament?: Maybe<Tournament>;
  tournamentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** PENDING = SCORER submitted, organizer action required. APPROVED = organizer approved or SCORER_ADMIN auto-approved. REJECTED = organizer rejected. */
export enum ProposedResultStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type PublicAthleteItem = {
  __typename?: 'PublicAthleteItem';
  favoriteSport?: Maybe<PublicSportRef>;
  lastTournamentAt?: Maybe<Scalars['DateTime']['output']>;
  licensesCount: Scalars['Int']['output'];
  purchasedLicenses: Array<PublicLicense>;
  tournamentsPlayed: Scalars['Int']['output'];
  tournamentsPlayedByPlatform: Array<PublicPlatformBreakdownEntry>;
  tournamentsPlayedBySport: Array<PublicSportBreakdownEntry>;
  user: PublicAthleteProfile;
};

export type PublicAthleteProfile = {
  __typename?: 'PublicAthleteProfile';
  age?: Maybe<Scalars['Int']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use sportClubs for per-sport clubs. Legacy single-club field from pre-multi-sport era; still populated from user.userClubIdId. */
  club?: Maybe<PublicClubRef>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  middle_name_passport?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  /** Per-sport club rows sourced from user_sport. One entry per sport the athlete has registered for, even if the club is the same across multiple sports. Includes rows with status INACTIVE (isActive: false) so the FE can grey them out rather than the backend silently dropping them. */
  sportClubs: Array<PublicAthleteSportClub>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  trust?: Maybe<PublicAthleteTrust>;
};

export type PublicAthleteSportClub = {
  __typename?: 'PublicAthleteSportClub';
  /** Null when athlete uses a custom / off-platform club — see customClub. */
  club?: Maybe<PublicClubRef>;
  /** Free-text fallback from user_sport.customClub when the club is not on the platform. */
  customClub?: Maybe<Scalars['String']['output']>;
  /** Whether user_sport.status is ACTIVE. */
  isActive: Scalars['Boolean']['output'];
  sport?: Maybe<PublicSportRef>;
};

export type PublicAthleteTrust = {
  __typename?: 'PublicAthleteTrust';
  breakdown: PublicAthleteTrustBreakdown;
  score: Scalars['Int']['output'];
};

export type PublicAthleteTrustBreakdown = {
  __typename?: 'PublicAthleteTrustBreakdown';
  accountAgeDays?: Maybe<Scalars['Int']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  hasAvatar: Scalars['Boolean']['output'];
  hasCitizenship: Scalars['Boolean']['output'];
  hasPassportNames: Scalars['Boolean']['output'];
  identityVerified: Scalars['Boolean']['output'];
  phoneVerified: Scalars['Boolean']['output'];
  playedAtLeastOneTournament: Scalars['Boolean']['output'];
  profileComplete: Scalars['Boolean']['output'];
};

export enum PublicAthleteType {
  Active = 'ACTIVE',
  Licensed = 'LICENSED'
}

export type PublicAthletesExcludeInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicAthletesFilterInput = {
  activePeriodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activePeriodTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<PublicAthletesExcludeInput>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  lastActiveDaysAgo?: InputMaybe<Scalars['Int']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  licenseStatuses?: InputMaybe<Array<PublicLicenseStatus>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: PublicAthleteType;
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicAthletesInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PublicAthletesFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicAthletesOrderBy;
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
};

export enum PublicAthletesOrderBy {
  Alphabetical = 'ALPHABETICAL',
  AlphabeticalAsc = 'ALPHABETICAL_ASC',
  AlphabeticalDesc = 'ALPHABETICAL_DESC',
  MostActive = 'MOST_ACTIVE'
}

export type PublicAthletesResult = {
  __typename?: 'PublicAthletesResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicAthleteItem>;
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PublicClubRef = {
  __typename?: 'PublicClubRef';
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicCourtRef = {
  __typename?: 'PublicCourtRef';
  courtNumber?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicDocument = PublicDocumentEntity & {
  __typename?: 'PublicDocument';
  /** MIME type, e.g. application/pdf */
  contentType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Public download URL; null for non-public files */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** File size in bytes */
  fileSize?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicDocumentEntity = {
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicDocumentFolder = PublicDocumentEntity & {
  __typename?: 'PublicDocumentFolder';
  documents?: Maybe<Array<PublicDocument>>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicDrawRef = {
  __typename?: 'PublicDrawRef';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicEntry = {
  __typename?: 'PublicEntry';
  id: Scalars['Int']['output'];
  team?: Maybe<PublicTeamRef>;
  users?: Maybe<Array<PublicEntryUser>>;
};

export type PublicEntryUser = {
  __typename?: 'PublicEntryUser';
  user?: Maybe<PublicUser>;
};

export type PublicFileUrl = {
  __typename?: 'PublicFileUrl';
  id: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type PublicGroupRef = {
  __typename?: 'PublicGroupRef';
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicLeagueRef = {
  __typename?: 'PublicLeagueRef';
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PublicPlatformRef>;
  sport?: Maybe<PublicSportRef>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicLicense = {
  __typename?: 'PublicLicense';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  league?: Maybe<PublicLeagueRef>;
  licenseId?: Maybe<Scalars['Int']['output']>;
  licenseType?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PublicLicenseStatus>;
};

export enum PublicLicenseStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Upcoming = 'UPCOMING'
}

export type PublicMatch = {
  __typename?: 'PublicMatch';
  court?: Maybe<PublicCourtRef>;
  date?: Maybe<Scalars['String']['output']>;
  draw?: Maybe<PublicDrawRef>;
  duration?: Maybe<Scalars['Int']['output']>;
  entry1?: Maybe<PublicEntry>;
  entry1partner?: Maybe<PublicEntry>;
  entry2?: Maybe<PublicEntry>;
  entry2partner?: Maybe<PublicEntry>;
  group?: Maybe<PublicGroupRef>;
  id: Scalars['Int']['output'];
  mainMatch?: Maybe<Scalars['JSON']['output']>;
  matchType?: Maybe<Scalars['String']['output']>;
  round?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team1Entry?: Maybe<PublicEntry>;
  team2Entry?: Maybe<PublicEntry>;
  teamMatchType?: Maybe<Scalars['String']['output']>;
  teamScore?: Maybe<Scalars['String']['output']>;
  teamWinner?: Maybe<Scalars['JSON']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  winner?: Maybe<Scalars['JSON']['output']>;
  winnerId?: Maybe<Scalars['Int']['output']>;
};

export type PublicNewsAuthor = {
  __typename?: 'PublicNewsAuthor';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PublicNewsFederation = {
  __typename?: 'PublicNewsFederation';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
};

export type PublicNewsItem = {
  __typename?: 'PublicNewsItem';
  author?: Maybe<PublicNewsAuthor>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  federation?: Maybe<PublicNewsFederation>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  metaDesc?: Maybe<Scalars['String']['output']>;
  metaTags?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PublicNewsPlatform>;
  postCategories?: Maybe<Array<PublicNewsPostCategory>>;
  postText?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  youtubeVideoLink?: Maybe<Scalars['String']['output']>;
};

export type PublicNewsListExcludeInput = {
  authorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  postCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicNewsListFilterInput = {
  authorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  exclude?: InputMaybe<PublicNewsListExcludeInput>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  postCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicNewsListInput = {
  filter?: InputMaybe<PublicNewsListFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicNewsListOrderBy;
  page?: Scalars['Int']['input'];
};

export enum PublicNewsListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type PublicNewsListResult = {
  __typename?: 'PublicNewsListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicNewsItem>;
  total: Scalars['Int']['output'];
};

export type PublicNewsPlatform = {
  __typename?: 'PublicNewsPlatform';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicNewsPostCategory = {
  __typename?: 'PublicNewsPostCategory';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicOrganization = {
  __typename?: 'PublicOrganization';
  about?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  leagues?: Maybe<Array<PublicOrganizationLeague>>;
  leaguesCount: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  organizationType?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<PublicOrganizationPlatform>>;
  sports?: Maybe<Array<PublicOrganizationSport>>;
  status?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicOrganizationLeague = {
  __typename?: 'PublicOrganizationLeague';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<PublicOrganizationSport>;
  title?: Maybe<Scalars['String']['output']>;
  tournamentsCount: Scalars['Int']['output'];
};

export type PublicOrganizationPlatform = {
  __typename?: 'PublicOrganizationPlatform';
  id?: Maybe<Scalars['Int']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicOrganizationSport = {
  __typename?: 'PublicOrganizationSport';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PublicOrganizationsResult = {
  __typename?: 'PublicOrganizationsResult';
  organizations: Array<PublicOrganization>;
  total: Scalars['Int']['output'];
};

export type PublicOrganizer = {
  __typename?: 'PublicOrganizer';
  id?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<PublicUser>;
};

export type PublicPlatformBreakdownEntry = {
  __typename?: 'PublicPlatformBreakdownEntry';
  count: Scalars['Int']['output'];
  platform?: Maybe<PublicPlatformRef>;
};

export type PublicPlatformRef = {
  __typename?: 'PublicPlatformRef';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicPostItem = {
  __typename?: 'PublicPostItem';
  author?: Maybe<User>;
  categories?: Maybe<Array<PostCategory>>;
  coverImage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  excerpt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keywords: Array<Scalars['String']['output']>;
  language: Scalars['String']['output'];
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  ogImage?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Estimated reading time in minutes (rounded up, min 1). Computed at query time. */
  readingTimeMinutes: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  status: PostStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PublicPostListExcludeInput = {
  authorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicPostListFilterInput = {
  authorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** publishedAt >= dateFrom */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** publishedAt <= dateTo */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  exclude?: InputMaybe<PublicPostListExcludeInput>;
  /** Token-split free-text search across title + subtitle + excerpt. Each whitespace-separated token must match somewhere. */
  keyword?: InputMaybe<Scalars['String']['input']>;
  /** Match the post against any of these admin-curated keyword tags (case-insensitive overlap on the post.keywords[] column). */
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** BCP-47 language code, e.g. "en", "lv". Case-insensitive. */
  language?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Posts mentioning this athlete (User id). */
  mentionsAthleteId?: InputMaybe<Scalars['Int']['input']>;
  mentionsClubId?: InputMaybe<Scalars['Int']['input']>;
  mentionsLeagueId?: InputMaybe<Scalars['Int']['input']>;
  mentionsOrganizerId?: InputMaybe<Scalars['Int']['input']>;
  mentionsTeamId?: InputMaybe<Scalars['Int']['input']>;
  mentionsTournamentId?: InputMaybe<Scalars['Int']['input']>;
  organizerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicPostListInput = {
  filter?: InputMaybe<PublicPostListFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicPostListOrderBy;
  page?: Scalars['Int']['input'];
};

export enum PublicPostListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type PublicPostListResult = {
  __typename?: 'PublicPostListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicPostItem>;
  total: Scalars['Int']['output'];
};

export type PublicSmartSearchAthlete = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchAthlete';
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  /** Up to 3 sports this athlete competes in (derived from tournament participation). */
  sports: Array<PublicSmartSearchSport>;
};

export type PublicSmartSearchCoach = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchCoach';
  avatar?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Pre-composed "Name Surname" — FE does not concatenate. */
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  /** Up to 3 sports this coach is associated with across all platforms. */
  sports: Array<PublicSmartSearchSport>;
  studentsCount: Scalars['Int']['output'];
};

export type PublicSmartSearchCount = {
  __typename?: 'PublicSmartSearchCount';
  total: Scalars['Int']['output'];
  type: PublicSmartSearchType;
};

/** Common shape for every public smart-search hit. id + rankScore + matchedOn are guaranteed across types. */
export type PublicSmartSearchEntity = {
  id: Scalars['ID']['output'];
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
};

export type PublicSmartSearchExcludeInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicSmartSearchFilterInput = {
  /** ISO alpha-2 country codes (case-insensitive). */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<PublicSmartSearchExcludeInput>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicSmartSearchInput = {
  filter?: InputMaybe<PublicSmartSearchFilterInput>;
  /** Required search keyword. Server returns an empty result when trimmed length < 2 — clients do not need to guard. */
  keyword: Scalars['String']['input'];
  /** Total items returned across all types. Server fetches enough from each bucket to fill this cap, then sorts strictly by rankScore — so the top of the list is always the most relevant matches regardless of type. */
  limit?: Scalars['Int']['input'];
  /** 0-indexed page. Only meaningful when `types` has exactly one entry (per-bucket pagination). */
  page?: Scalars['Int']['input'];
  /** Scope to these platforms. null/empty = global (Tournated root). Matches the convention used by every other public list query. */
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Restrict to these entity buckets. null = all enabled types on this platform. When exactly one value is supplied, page+limit paginate within that bucket (per-tab view). */
  types?: InputMaybe<Array<PublicSmartSearchType>>;
};

export type PublicSmartSearchItem = PublicSmartSearchAthlete | PublicSmartSearchCoach | PublicSmartSearchOrganizer | PublicSmartSearchTour | PublicSmartSearchTournament | PublicSmartSearchVenue;

export type PublicSmartSearchOrganizer = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchOrganizer';
  id: Scalars['ID']['output'];
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  toursCount: Scalars['Int']['output'];
};

export type PublicSmartSearchResult = {
  __typename?: 'PublicSmartSearchResult';
  /** Per-bucket totals for the keyword on this platform — drives tab badges. */
  countsByType: Array<PublicSmartSearchCount>;
  /** Buckets that have at least one row on this platform (irrespective of keyword). FE uses this to decide which tabs to render. */
  enabledTypes: Array<PublicSmartSearchType>;
  hasMore: Scalars['Boolean']['output'];
  /** Mixed, ranked items. Order is global (cross-type rankScore-driven). */
  items: Array<PublicSmartSearchItem>;
  /** Echo of the input keyword — useful for analytics + debugging. */
  keyword: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PublicSmartSearchSport = {
  __typename?: 'PublicSmartSearchSport';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicSmartSearchTour = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchTour';
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  sport?: Maybe<PublicSmartSearchSport>;
  title?: Maybe<Scalars['String']['output']>;
  tourLogo?: Maybe<Scalars['String']['output']>;
  tournamentsCount: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PublicSmartSearchTournament = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchTournament';
  /** Up to 3 category names for chip rendering. Pre-truncated server-side. */
  categoriesPreview: Array<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  /** Tournament vs camp / clinic / league_stage / other. FE renders this as a competition-type label chip. */
  competitionType?: Maybe<CompetitionType>;
  country?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  /** Sport flows from the league this tournament belongs to. */
  sport?: Maybe<PublicSmartSearchSport>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Public discovery entity buckets. Plural form because the value selects a *collection* of results, not a single entity. */
export enum PublicSmartSearchType {
  Athletes = 'ATHLETES',
  Coaches = 'COACHES',
  Organizers = 'ORGANIZERS',
  Tournaments = 'TOURNAMENTS',
  Tours = 'TOURS',
  Venues = 'VENUES'
}

export type PublicSmartSearchVenue = PublicSmartSearchEntity & {
  __typename?: 'PublicSmartSearchVenue';
  city?: Maybe<Scalars['String']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  /** Which field matched the keyword (e.g. "title", "name", "city"). For analytics + optional UI hint. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /** Normalized 0–1 relevance score, comparable across entity types. FE does not re-rank. */
  rankScore: Scalars['Float']['output'];
  /** Up to 3 sports the venue offers, pre-truncated server-side. */
  sports: Array<PublicSmartSearchSport>;
};

export type PublicSportBreakdownEntry = {
  __typename?: 'PublicSportBreakdownEntry';
  count: Scalars['Int']['output'];
  sport?: Maybe<PublicSportRef>;
};

export type PublicSportRef = {
  __typename?: 'PublicSportRef';
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicTeam = {
  __typename?: 'PublicTeam';
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  joinedFrom?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<PublicTeamMember>>;
  platform?: Maybe<PublicTeamPlatform>;
  sport?: Maybe<PublicTeamSport>;
  status?: Maybe<Scalars['String']['output']>;
  tiktokLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicTeamListResult = {
  __typename?: 'PublicTeamListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicTeam>;
  total: Scalars['Int']['output'];
};

export type PublicTeamMember = {
  __typename?: 'PublicTeamMember';
  id: Scalars['Int']['output'];
  member?: Maybe<PublicTeamMemberUser>;
  memberNr?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type PublicTeamMemberUser = {
  __typename?: 'PublicTeamMemberUser';
  avatar?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PublicTeamPlatform = {
  __typename?: 'PublicTeamPlatform';
  id: Scalars['Int']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicTeamRef = {
  __typename?: 'PublicTeamRef';
  id?: Maybe<Scalars['Int']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicTeamSport = {
  __typename?: 'PublicTeamSport';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicTourListExcludeInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PublicTourListFilterInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<PublicTourListExcludeInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PublicTourListInput = {
  filter?: InputMaybe<PublicTourListFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicTourListOrderBy;
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
};

export type PublicTourListItem = {
  __typename?: 'PublicTourListItem';
  categoriesCount: Scalars['Int']['output'];
  country?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['Int']['output']>;
  organizationLogo?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  sportIcon?: Maybe<Scalars['String']['output']>;
  sportSlug?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tourLogo?: Maybe<Scalars['String']['output']>;
  tournamentsCount: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export enum PublicTourListOrderBy {
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  TournamentsCountAsc = 'TOURNAMENTS_COUNT_ASC',
  TournamentsCountDesc = 'TOURNAMENTS_COUNT_DESC'
}

export type PublicTourListResult = {
  __typename?: 'PublicTourListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicTourListItem>;
  total: Scalars['Int']['output'];
};

export type PublicTournament = {
  __typename?: 'PublicTournament';
  Album?: Maybe<Array<Album>>;
  activeTournaments?: Maybe<Scalars['Float']['output']>;
  additionalQuestion?: Maybe<Array<AdditionalQuestion>>;
  additionalQuestion2?: Maybe<Scalars['String']['output']>;
  additionalReferee?: Maybe<Array<TournamentAdditionalReferee>>;
  address?: Maybe<Scalars['String']['output']>;
  /** Tournament location coordinates with latitude and longitude */
  addressCoordinates?: Maybe<Scalars['JSON']['output']>;
  allTournaments?: Maybe<Scalars['Float']['output']>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  approvedEntries?: Maybe<Scalars['Boolean']['output']>;
  approvedOrRejectedBy?: Maybe<User>;
  athletes?: Maybe<Scalars['Float']['output']>;
  autoConfirmEntries?: Maybe<Scalars['Boolean']['output']>;
  categorySettingsGroups?: Maybe<Array<CategorySettingsGroup>>;
  city?: Maybe<Scalars['String']['output']>;
  closeRegistration?: Maybe<Scalars['Boolean']['output']>;
  club?: Maybe<Club>;
  competitionLevel?: Maybe<CompetitionLevel>;
  competitionType: CompetitionType;
  contactUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courts?: Maybe<Array<Court>>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  coverPhotoFile?: Maybe<StorageFile>;
  coverPhotoFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Optional custom URL used in place of the default hotel booking link shown near the tournament location */
  customHotelsLink?: Maybe<Scalars['String']['output']>;
  customInfoImage?: Maybe<Scalars['String']['output']>;
  customInfoImageFile?: Maybe<StorageFile>;
  customInfoImageFileId?: Maybe<Scalars['String']['output']>;
  customInfoMessage?: Maybe<Scalars['String']['output']>;
  customMatricesType: Array<CustomMatricesType>;
  customSuccessMessage?: Maybe<Scalars['String']['output']>;
  /** Tournament dates to hide from schedule */
  datesToHide?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<TournamentDiscount>>;
  documents?: Maybe<Array<TournamentDocument>>;
  drawType: Array<DrawType>;
  draws?: Maybe<Array<Draw>>;
  enableLiveScoring?: Maybe<Scalars['Boolean']['output']>;
  enableLiveStream?: Maybe<Scalars['Boolean']['output']>;
  enablePracticeCourtsBooking?: Maybe<Scalars['Boolean']['output']>;
  enableTransferBooking?: Maybe<Scalars['Boolean']['output']>;
  enabledPushNotification?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  entryDeadline?: Maybe<Scalars['DateTime']['output']>;
  entryFee?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facts?: Maybe<Array<TournamentFactSheet>>;
  fideRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  groupType: Array<GroupType>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Float']['output'];
  isCPCRequired?: Maybe<Scalars['Boolean']['output']>;
  isCustomMatricesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDrawsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDuprRatingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDuprRequired?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isGroupsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHideEntries?: Maybe<Scalars['Boolean']['output']>;
  isHideFromCalendar?: Maybe<Scalars['Boolean']['output']>;
  isListAndResultEnabled?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPartnerFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPlatformFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingStripeFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingTournatedFee?: Maybe<Scalars['Boolean']['output']>;
  isMaxwillRequired?: Maybe<Scalars['Boolean']['output']>;
  isOrganizerRegEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPairingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayForMyselfEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprEntriesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprRequired?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<LeagueTournament>;
  leagueType: LeagueType;
  license?: Maybe<Scalars['String']['output']>;
  listAndResultShowIndividualTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowPointsTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowTeamsTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultType: Array<ListAndResultType>;
  listStatus?: Maybe<Scalars['String']['output']>;
  liveStandings?: Maybe<Array<LiveStanding>>;
  liveStreaming_sporfie_key?: Maybe<Scalars['String']['output']>;
  liveStreamings?: Maybe<Array<LiveStreaming>>;
  livescoreKeyVersion: Scalars['Int']['output'];
  livescoreMode: Scalars['String']['output'];
  livescoreViewerToken?: Maybe<Scalars['String']['output']>;
  livescoreViewerTokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  localRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  loggedInUser?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFile>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  makePrivate?: Maybe<Scalars['Boolean']['output']>;
  matchesCount?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Array<Notification>>;
  notificationsAddress?: Maybe<Scalars['String']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  onsiteEntryFee?: Maybe<Scalars['Float']['output']>;
  organizer?: Maybe<LeagueMember>;
  overRideShowOOP?: Maybe<Scalars['Boolean']['output']>;
  pairings?: Maybe<Array<Pairing>>;
  pairingsBlockType: Array<BlockType>;
  partnerSearch?: Maybe<Scalars['Boolean']['output']>;
  passedTournaments?: Maybe<Scalars['Float']['output']>;
  paymentDiscounts?: Maybe<Array<PaymentDiscount>>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentQrCode?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  poster?: Maybe<Scalars['String']['output']>;
  /** Public id, e.g. trn_8k3pq2r4n9v7t6mh. Use in URLs, webhooks, and external integrations. */
  publicId: Scalars['String']['output'];
  rankingsReleaseDate?: Maybe<Scalars['String']['output']>;
  referee?: Maybe<TournamentReferee>;
  region?: Maybe<Region>;
  registerLink?: Maybe<Scalars['String']['output']>;
  registeredUsersInTournament?: Maybe<Scalars['Boolean']['output']>;
  registrationRequestCount?: Maybe<Scalars['Float']['output']>;
  registrationRequests?: Maybe<Array<TournamentRegistration>>;
  registrationStartDate?: Maybe<Scalars['DateTime']['output']>;
  regulations?: Maybe<Scalars['String']['output']>;
  resourceTitle?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  showOOP?: Maybe<Scalars['Boolean']['output']>;
  showPairingsAndStandings?: Maybe<Scalars['Boolean']['output']>;
  showTournamentChessManagerCalendar?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['String']['output'];
  sortRequestBy: Scalars['String']['output'];
  sports?: Maybe<Array<Sport>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  tier: TournamentTier;
  timeControl?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tour?: Maybe<Scalars['String']['output']>;
  tournamentAddress?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<Array<CategorySetting>>;
  tournamentCategoryGroup?: Maybe<TournamentCategoryGroup>;
  tournamentDirector?: Maybe<Scalars['String']['output']>;
  tournamentRankings?: Maybe<Array<TournamentRanking>>;
  type?: Maybe<Scalars['String']['output']>;
  upcomingTournaments?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  venues?: Maybe<Array<TournamentVenue>>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  withdrawlDeadline?: Maybe<Scalars['DateTime']['output']>;
};

export type PublicTournamentListExcludeInput = {
  categoryGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  competitionType?: InputMaybe<CompetitionType>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicTournamentListFilterInput = {
  categoryGroupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  competitionType?: InputMaybe<CompetitionType>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Lower bound of the date-range filter. Combined with dateRangeTo (any subset works). Default mode OVERLAP — matches tournaments running at any point in the window. See dateRangeMode for CONTAINED semantics. */
  dateRangeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** How dateRangeFrom/dateRangeTo match. OVERLAP (default) = tournaments running at any point in the window. CONTAINED = tournaments whose whole schedule fits inside the window. */
  dateRangeMode?: InputMaybe<TournamentDateRangeMode>;
  /** Upper bound of the date-range filter. See dateRangeFrom. */
  dateRangeTo?: InputMaybe<Scalars['DateTime']['input']>;
  exclude?: InputMaybe<PublicTournamentListExcludeInput>;
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only tournaments currently accepting registrations: registrationStartDate <= now (or null) AND entryDeadline is set and >= now. */
  isRegistrationOpen?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingOrInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  leagueTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Temporal buckets — pass any combination. Empty / omitted means no temporal filter. Each value: UPCOMING (starts in the future), IN_PROGRESS (running now), COMPLETED (already finished). Takes precedence over the legacy isUpcomingOrInProgress / isCompleted booleans. */
  statusBuckets?: InputMaybe<Array<PublicTournamentStatusBucket>>;
};

export type PublicTournamentListInput = {
  filter?: InputMaybe<PublicTournamentListFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicTournamentListOrderBy;
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
};

export enum PublicTournamentListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EndDateAsc = 'END_DATE_ASC',
  EndDateDesc = 'END_DATE_DESC',
  EntriesCountAsc = 'ENTRIES_COUNT_ASC',
  EntriesCountDesc = 'ENTRIES_COUNT_DESC',
  MostRelevant = 'MOST_RELEVANT',
  StartDateAsc = 'START_DATE_ASC',
  StartDateDesc = 'START_DATE_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type PublicTournamentListResult = {
  __typename?: 'PublicTournamentListResult';
  completedCount: Scalars['Int']['output'];
  hasMore: Scalars['Boolean']['output'];
  inProgressCount: Scalars['Int']['output'];
  items: Array<PublicTournament>;
  total: Scalars['Int']['output'];
  upcomingCount: Scalars['Int']['output'];
};

/** Temporal bucket for tournaments. Computed against now() from startDate / endDate. */
export enum PublicTournamentStatusBucket {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING'
}

export type PublicUser = {
  __typename?: 'PublicUser';
  avatar?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  gtw_points?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  itf_points?: Maybe<Scalars['Float']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  middle_name_passport?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  otherPoints?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  representingCountry?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['Float']['output']>;
  wprPlayerId?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['Float']['output']>;
  wprStatusRating?: Maybe<Scalars['Float']['output']>;
  wprUserId?: Maybe<Scalars['String']['output']>;
};

export type PublicUserMatchesFilterInput = {
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tab?: InputMaybe<UserMatchesTab>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type PublicUserMatchesInput = {
  filter: PublicUserMatchesFilterInput;
  limit?: Scalars['Int']['input'];
  orderBy?: UserMatchesOrderBy;
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
};

export type PublicUserMatchesResult = {
  __typename?: 'PublicUserMatchesResult';
  total: Scalars['Int']['output'];
  tournaments: Array<PublicUserMatchesTournament>;
};

export type PublicUserMatchesTournament = {
  __typename?: 'PublicUserMatchesTournament';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  matches?: Maybe<Array<PublicMatch>>;
  organizer?: Maybe<PublicOrganizer>;
  startDate?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  venues?: Maybe<Array<PublicVenue>>;
};

export type PublicUserOutput = {
  __typename?: 'PublicUserOutput';
  avatar?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<StorageFile>;
  avatarFileId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  /** Internal numeric identifier. Prefer `publicId` for external integrations — kept for backward compatibility. */
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  /** Stable, opaque public id, e.g. `usr_8k3pq2r4n9v7t6mh`. */
  publicId: Scalars['String']['output'];
  representingCountry?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  /** Human-facing Tournated ID, e.g. `483920`. Renderable in user-visible chips. */
  tournatedTag: Scalars['String']['output'];
};

export type PublicUserTeamsInput = {
  limit?: Scalars['Int']['input'];
  /** 0-indexed page number (first page = 0) */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['Int']['input'];
};

export type PublicVenue = {
  __typename?: 'PublicVenue';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PublicVenueItem = {
  __typename?: 'PublicVenueItem';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  howToFindUs?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  instagramLink?: Maybe<Scalars['String']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<PublicVenuePlatform>;
  sports?: Maybe<Array<PublicVenueSport>>;
  tikTok?: Maybe<Scalars['String']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PublicVenuePlatform = {
  __typename?: 'PublicVenuePlatform';
  id: Scalars['Int']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PublicVenueSport = {
  __typename?: 'PublicVenueSport';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

export type PublicVenuesListExcludeInput = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicVenuesListFilterInput = {
  /** ISO alpha-2 country codes */
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude?: InputMaybe<PublicVenuesListExcludeInput>;
  /** Case-insensitive search on venue name and city */
  keyword?: InputMaybe<Scalars['String']['input']>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type PublicVenuesListInput = {
  filter?: InputMaybe<PublicVenuesListFilterInput>;
  limit?: Scalars['Int']['input'];
  orderBy?: PublicVenuesListOrderBy;
  page?: Scalars['Int']['input'];
};

export enum PublicVenuesListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type PublicVenuesListResult = {
  __typename?: 'PublicVenuesListResult';
  hasMore: Scalars['Boolean']['output'];
  items: Array<PublicVenueItem>;
  total: Scalars['Int']['output'];
};

export type PurchaseLicenseCheckoutSessionResult = {
  __typename?: 'PurchaseLicenseCheckoutSessionResult';
  id: Scalars['ID']['output'];
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PurchasedLicense = {
  __typename?: 'PurchasedLicense';
  activePeriod: Scalars['String']['output'];
  addedBy?: Maybe<User>;
  additionalQuestions?: Maybe<Array<LicenseQuestion>>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  bankTransferDetails?: Maybe<Scalars['JSONObject']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  existingInLicensePaymentDataId?: Maybe<Scalars['Int']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isBulkPurchase?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  license?: Maybe<License>;
  licenseStatus: LicenseStatus;
  noOfLicense?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  paidForLicenses?: Maybe<Array<License>>;
  paidForUserLicenses?: Maybe<Array<PurchasedLicensePaidForUser>>;
  paidForUsers?: Maybe<Array<User>>;
  paidTotal?: Maybe<Scalars['Float']['output']>;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<PurchasedLicensePayment>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentIntentRelationId?: Maybe<Scalars['String']['output']>;
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Platform>>;
  promo?: Maybe<Scalars['String']['output']>;
  proof?: Maybe<PurchasedLicenseProof>;
  proofFileUrl?: Maybe<Scalars['String']['output']>;
  proofUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Public id, e.g. plc_… */
  publicId: Scalars['String']['output'];
  purchasedInLicensePaymentDataId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApprovalStatus>;
  stripeFee?: Maybe<Scalars['Float']['output']>;
  totalBasePrice?: Maybe<Scalars['Float']['output']>;
  totalGross?: Maybe<Scalars['Float']['output']>;
  totalNet?: Maybe<Scalars['Float']['output']>;
  totalPartnerFee?: Maybe<Scalars['Float']['output']>;
  totalStripeFee?: Maybe<Scalars['Float']['output']>;
  totalTournatedFee?: Maybe<Scalars['Float']['output']>;
  totalVatAmount?: Maybe<Scalars['Float']['output']>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
};

export type PurchasedLicensePaidForUser = {
  __typename?: 'PurchasedLicensePaidForUser';
  license: License;
  user: User;
};

export type PurchasedLicensePayment = {
  __typename?: 'PurchasedLicensePayment';
  type: Scalars['String']['output'];
};

export type PurchasedLicenseProof = {
  __typename?: 'PurchasedLicenseProof';
  fileUrl?: Maybe<Scalars['String']['output']>;
  isUploaded: Scalars['Boolean']['output'];
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PurchasedLicenseResult = {
  __typename?: 'PurchasedLicenseResult';
  purchasedLicenses: Array<PurchasedLicense>;
  total: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  AllPlacesForSporfie: Array<LiveStreaming>;
  CsvGenerationForPickleballGroups: Scalars['String']['output'];
  CsvGenerationForPickleballOOP: Scalars['String']['output'];
  CsvGenerationForPickleballOOPFansPlay: Scalars['String']['output'];
  PdfGeneration: Scalars['String']['output'];
  PdfGenerationForDraw: Scalars['String']['output'];
  PdfGenerationForGrid: Scalars['String']['output'];
  PdfGenerationForGroup: Scalars['String']['output'];
  PdfGenerationForPickleball: Scalars['String']['output'];
  PdfGenerationForScoreCard: Scalars['String']['output'];
  TournamentAdditionalReferee: TournamentAdditionalReferee;
  activePlayersOfOrganization: Scalars['JSON']['output'];
  additionalQuestion: AdditionalQuestion;
  additionalQuestions: Array<AdditionalQuestion>;
  album: Album;
  allClubNews: Array<ClubNews>;
  allDashboardStats: Scalars['JSONObject']['output'];
  allDashboardStatsV2: Scalars['JSONObject']['output'];
  allDraws: Array<Draw>;
  allFederationNews: Array<FederationNews>;
  allGroupMatches: GroupResult;
  allGroups: GroupResult;
  allGroupsStandings: GroupResult;
  allLeagueMembers: LeagueMembersResult;
  allLeagueNews: Array<LeagueNews>;
  allLeagues: Array<League>;
  allLeaguesForManager: Array<League>;
  allLeaguesForManagerOld: Array<League>;
  allLeaguesNames: Array<League>;
  allLeaguesWithCount: Scalars['JSON']['output'];
  allNews: NewsResult;
  allOrganizationPlatforms: Scalars['JSON']['output'];
  /** @deprecated Use `GET /api/dashboard/v1/platforms/search` for paginated + searchable results. */
  allPlatformsNames: Array<Platform>;
  allStatsData: Scalars['JSONObject']['output'];
  allStatsGraphData: Scalars['JSONObject']['output'];
  allStatsTransactionData: Scalars['JSONObject']['output'];
  allTournamentCategories: Array<Scalars['JSONObject']['output']>;
  allTournamentCategoriesList: Array<Scalars['JSONObject']['output']>;
  allTournamentCategoriesUpdated: Array<CategorySetting>;
  allTournamentNames: Scalars['JSON']['output'];
  allTournamentWithMatches: Scalars['JSON']['output'];
  allTournaments: Array<Tournament>;
  allTournamentsList: Scalars['JSON']['output'];
  allTransactionHistory: TransactionHistoryCount;
  allstats: Array<Stat>;
  alltournament: TournamentsResult;
  announcementComment: AnnouncementComment;
  athlete: Athlete;
  athleteAchievements: Array<AthleteAchievementsByYear>;
  athleteQuestionAnswers: Array<ResolvedAthleteQuestionAnswer>;
  athleteQuestions: Array<AthleteQuestion>;
  athleteTournamentStats: AthleteTournamentStats;
  athletes: Array<Athlete>;
  auditLogDetail: AuditLog;
  auditLogs: AuditLogResult;
  authMethod?: Maybe<AuthMethod>;
  authMethods: Array<AuthMethod>;
  /** Single federation from the calling user's available set. Throws ForbiddenException when the federation is not in scope. */
  availableFederationById: AvailableFederation;
  /** Batch lookup of federations in the calling user's available set. Throws ForbiddenException if any id is outside scope. */
  availableFederationsByIds: Array<AvailableFederation>;
  availableLandingBlocks: Array<LandingBlock>;
  /** Single platform from the calling user's available set. Throws ForbiddenException when the platform is not in scope. */
  availablePlatformById: AvailablePlatform;
  /** Batch lookup of platforms in the calling user's available set. Throws ForbiddenException if any id is outside scope. */
  availablePlatformsByIds: Array<AvailablePlatform>;
  /** Block-type catalog for the CMS block-picker. Returns one entry per concrete PostBlock variant — only the __typename is populated. */
  availablePostBlocks: Array<PostBlock>;
  /** @deprecated Use bannerNew instead. */
  banner: Banner;
  bannerNew: BannerNew;
  /** @deprecated Use bannersNew instead. */
  banners: Array<Banner>;
  bannersNew: Array<BannerNew>;
  bannersPublic: Array<BannerPublic>;
  breakDownRankingOfOrganization: Scalars['JSON']['output'];
  calculateDrawPoints: Scalars['JSONObject']['output'];
  calculateEntryPoints: Scalars['JSONObject']['output'];
  calculateGroupScore: Array<Scalars['JSONObject']['output']>;
  calculateLeaguePoints: Array<Scalars['JSONObject']['output']>;
  calculateLiveStandingPoints: Scalars['JSONObject']['output'];
  calculateLiveStandingsPoints: Scalars['JSONObject']['output'];
  calculatePayments: Scalars['JSONObject']['output'];
  calculateTeamTotaltResult: Scalars['JSON']['output'];
  calculateTotaltFishingResult: Array<Scalars['JSONObject']['output']>;
  captainTeams: Array<Team>;
  categories: Array<Category>;
  category: Category;
  categoryRule: CategoryRule;
  categoryRules: Array<CategoryRule>;
  categorySetting: CategorySetting;
  categorySettings: Array<CategorySetting>;
  categorySettingsGroup: CategorySettingsGroup;
  categorySettingsGroups: Array<CategorySettingsGroup>;
  categoryTournament: CategoryTournament;
  categoryTournaments: Array<CategoryTournament>;
  chatDirectChannel: ChatChannelOutput;
  chatDiscoverableTournaments: Array<ChatDiscoverableTournamentOutput>;
  chatInbox: ChatInboxOutput;
  chatOrganizerThreadInfo: ChatThreadInfoOutput;
  chatPlatformEnabled: Scalars['Boolean']['output'];
  chatRoomMemberStates: Array<ChatMemberStateOutput>;
  chatUnread: Array<ChatUnreadEntryOutput>;
  checkDuprId: Scalars['Boolean']['output'];
  checkSubscription: Scalars['JSON']['output'];
  checkUserAsParentOrCoach: Scalars['JSONObject']['output'];
  checkUserRole: Scalars['JSONObject']['output'];
  club: Club;
  clubAdministrator: ClubAdministrator;
  clubAdministrators: Array<ClubAdministrator>;
  /** @deprecated Use REST GET /api/dashboard/v1/clubs/:id */
  clubById?: Maybe<Club>;
  clubByMemberAndSportId: Array<ClubMember>;
  clubCoach: ClubCoach;
  clubCoaches: Array<ClubCoach>;
  clubDetails: Scalars['JSON']['output'];
  /** @deprecated Use REST GET /api/dashboard/v1/clubs */
  clubList: ClubListResult;
  clubMember: ClubMember;
  /** @deprecated Use REST GET /api/dashboard/v1/clubs/:id/members */
  clubMemberList: ClubMemberResult;
  clubMembers: ClubMemberResult;
  /** @deprecated Use REST GET /api/dashboard/v1/clubs/:id/members-stats */
  clubMembersStats: ClubMemberStats;
  clubNews: ClubNews;
  clubServiceResource: ClubServiceResource;
  clubServiceResources: Array<ClubServiceResource>;
  clubs: Scalars['JSON']['output'];
  clubsByIds: Array<Club>;
  clubsBySportIds: ClubResult;
  clubsServices: Array<ClubService>;
  court: Court;
  courts: Array<Court>;
  createMatchesOnWpr: Scalars['JSONObject']['output'];
  currentSubscriptionDetails: Scalars['JSON']['output'];
  dashboardPurchasedLicenses: PurchasedLicenseResult;
  defaultTeamMatch: DefaultTeamMatch;
  defaultTeamMatches: Array<DefaultTeamMatch>;
  deletedTournaments: Scalars['JSON']['output'];
  discipline: Discipline;
  disciplines: Array<Discipline>;
  displaySetting: DisplaySetting;
  displaySettings: Array<DisplaySetting>;
  doublesH2HMatchHistory: PlayerH2HMatchHistory;
  doublesH2HStats: PlayerH2HStats;
  doublesH2HSummary: PlayerH2HSummary;
  draw: Draw;
  drawEntries: Array<DrawEntry>;
  drawEntry: DrawEntry;
  drawScore: DrawScore;
  draws: Array<Scalars['JSONObject']['output']>;
  drawsDetail: Scalars['JSONObject']['output'];
  eligibleTeamMembers: Array<TeamMember>;
  exportLeagueRankingsCsvUrl: Scalars['String']['output'];
  exportParticipantsList: Scalars['String']['output'];
  exportTournamentTeamsCsv: Scalars['String']['output'];
  factSheet: FactSheet;
  factSheets: Array<FactSheet>;
  featuredLeagues: Scalars['JSON']['output'];
  featuredTournaments: Array<Tournament>;
  federation: Federation;
  /** @deprecated Dashboard reads have moved to REST: use GET /api/dashboard/v1/federations/:id (full detail) or GET /api/dashboard/v1/federations (list). */
  federationById?: Maybe<Federation>;
  federationDataCount: Scalars['JSON']['output'];
  federationDetails: Scalars['JSON']['output'];
  federationLeague: FederationLeague;
  federationLeagues: Array<FederationLeague>;
  federationNews: FederationNews;
  federationWithPlatforms: Federation;
  federations: FederationResult;
  federationsByIds: Array<Federation>;
  fetchAchievementsByTeamId: LeagueRankingResult;
  fetchAlbumByTeamId: Array<Album>;
  fetchClubsBySports: Scalars['JSON']['output'];
  fetchGroupEntry: GroupEntry;
  fetchLeaguesByTeamId: Array<League>;
  fetchMatchesEntry: MatchesEntry;
  fetchNewsByTeamId: Array<News>;
  fetchOnboardingDetails: Scalars['JSONObject']['output'];
  fetchPartnersByTeam: Array<Partner>;
  fetchRankingPointsByTeamId: Array<RankingPoint>;
  fetchSponsorsByTeam: Array<Sponsor>;
  fetchTournamentsByDate: TournamentsResult;
  fetchTournamentsByTeamId: Array<Tournament>;
  fetchUserPlan: Scalars['JSON']['output'];
  fetchUserRole: Scalars['JSON']['output'];
  findAllAlbum: Albums;
  findAllOwnerNews: NewsResult;
  findAllTeamMembers: Array<TeamMember>;
  findAllTournamentCategoryGroup: Array<TournamentCategoryGroup>;
  findAllUserClubWithClubMemberCounts: Array<UserClubWithCountAndStatus>;
  findAndUpdateGroupMatchesScore: Array<GroupMatch>;
  findCaptainTeam: Team;
  findFederation: Federation;
  findGroupMatchesWithRounds: Scalars['JSONObject']['output'];
  findPlatformAthletes: TournamentTeamMembersResult;
  findTournamentCategoryGroup: TournamentCategoryGroup;
  findTournamentsByDate: Scalars['JSON']['output'];
  findUserRequests: TournamentTeamMembersResult;
  findUserTournamentRole: Scalars['JSON']['output'];
  formatBlock?: Maybe<FormatBlock>;
  formatBlockStandings: FormatStandingsResponse;
  formatBlocks: Array<FormatBlock>;
  getAllStripeProducts: Array<Scalars['JSONObject']['output']>;
  getClubCoachMetaData: ClubCoach;
  getClubMetaData: Club;
  getCurrentRankings: Scalars['JSON']['output'];
  getFederationMetadata: Federation;
  getLeagueMemberStats: LeagueMemberStats;
  getLeagueMetaData: League;
  getLicensedAthletes: Array<SanitizedUser>;
  getNewsMetadata: News;
  getPlatformCoachMetaData: Scalars['JSONObject']['output'];
  getPlatformMetadata: Platform;
  getPlatformStats: PLatformStats;
  getPlayerFideRanking: Scalars['JSON']['output'];
  getPlayerIDByName: Scalars['JSON']['output'];
  getPlayerRankingsByPlayerID: Scalars['JSON']['output'];
  getPlayerRankingsByTennisId: Scalars['JSON']['output'];
  getPlayerResults: Scalars['JSON']['output'];
  getPlayerResultsByPlayerId: Scalars['JSON']['output'];
  getProfile: User;
  getRatingByDUPRId: Scalars['JSON']['output'];
  getStripeConnectedAccounts: Scalars['JSONObject']['output'];
  getStripePlan: Scalars['JSONObject']['output'];
  getStripeProduct: Scalars['JSONObject']['output'];
  getTeamMetaData: Team;
  getThirdPartyUserDetails?: Maybe<Scalars['JSONObject']['output']>;
  getTournamentMetaData: Tournament;
  getUserCount: Scalars['JSON']['output'];
  getUserFCMToken: Array<SnsSubscription>;
  getUserMatches: Array<MatchPartialV2>;
  getUserMetaData: User;
  getUserPartners: Scalars['JSONObject']['output'];
  getUserStats: Scalars['JSON']['output'];
  group: Group;
  groupEntries: Array<GroupEntry>;
  groupEntry: GroupEntry;
  groupMatch: GroupMatch;
  groupMatches: Array<Match>;
  groupMatches1: Array<GroupMatch>;
  groupTeamMatch: Match;
  groupTeamMatch1: GroupMatch;
  groups: Array<Group>;
  groupsAndDraws: Scalars['JSONObject']['output'];
  hasUserLikedAnnouncement: GeneralReturnType;
  health: HealthCheckType;
  highlightsData: Scalars['JSONObject']['output'];
  homePageLeagueRanking: Array<LeagueRanking>;
  image: Image;
  incompleteOOPMatches: Array<Scalars['JSON']['output']>;
  interestedTournaments: InterestedTournamentsResult;
  landing: Landing;
  landingMember: LandingMember;
  landingMembers: Array<LandingMember>;
  landingPotm: LandingPotm;
  landingPotms: Array<LandingPotm>;
  landingRoadmap: LandingRoadmap;
  landingRoadmaps: Array<LandingRoadmap>;
  landingSlider: LandingSlider;
  landingSliders: Array<LandingSlider>;
  landings: Array<Landing>;
  latestLeagueRanking: Array<LeagueRanking>;
  league: League;
  leagueAthletes: Array<Scalars['JSON']['output']>;
  leagueCategories: Array<LeagueCategory>;
  leagueCategory: LeagueCategory;
  leagueDocument: LeagueDocument;
  leagueDocuments: Array<LeagueDocument>;
  leagueForRankings: Array<League>;
  leagueGeneralTournaments: Array<Tournament>;
  leagueLatestWinners: Array<TournamentRankingsEntry>;
  leagueMember: LeagueMember;
  leagueMemberRole: LeagueMemberRole;
  leagueMemberRoles: Array<LeagueMemberRole>;
  leagueMembers: Array<LeagueMember>;
  leagueNews: LeagueNews;
  leagueOwner: LeagueOwner;
  leaguePageLeagueRanking: Array<LeagueRanking>;
  leagueRanking: LeagueRanking;
  leagueRankings: Array<LeagueRanking>;
  leagueRankingsCronCategories?: Maybe<LeagueRankingsCron>;
  leagueRankingsCustom: LeagueRankingResult;
  leagueRankingsDate: Array<LeagueRanking>;
  leagueRankingsHistory: LeagueRankingResult;
  leagueRankingsUniqueDates: Array<Scalars['String']['output']>;
  leagueRoles: Array<Role>;
  leagueStats: Scalars['JSON']['output'];
  leagueTournament: LeagueTournament;
  leagueTournamentCategories: Array<LeagueTournamentCategory>;
  leagueTournamentCategory: LeagueTournamentCategory;
  leagueTournaments: Scalars['JSON']['output'];
  leagues: Array<League>;
  leaguesForDashboard: Array<League>;
  leaguesSortedByActiveTournaments: Array<League>;
  leaguesWithCount: LeagueResult;
  license: License;
  /** @deprecated Use GET /api/dashboard/v1/licenses/:id */
  licenseById: License;
  licenseLeague: LicenseLeague;
  licenseLeagues: Array<LicenseLeague>;
  /** @deprecated Use GET /api/dashboard/v1/licenses */
  licenseList: LicenseResult;
  licenseQuestion: LicenseQuestion;
  licenseQuestions: Array<LicenseQuestion>;
  licenseStats: Scalars['JSONObject']['output'];
  licensedUsers: PurchasedLicenseResult;
  licenses: Array<License>;
  licensesByIds: Array<License>;
  listApiKeys: Array<ApiKeyInfo>;
  liveStanding: LiveStanding;
  liveStandings: Array<LiveStanding>;
  liveStandingsEntries: Array<LiveStandingsEntry>;
  liveStandingsEntry: LiveStandingsEntry;
  liveStreaming: ListLiveStreaming;
  liveStreamings: Array<ListLiveStreaming>;
  livescoreEntitlement: LivescoreEntitlementStatus;
  livescoreGrants: Array<LivescoreGrant>;
  livescoreTabData: LivescoreTabData;
  livescoreViewerContext: LivescoreViewerContext;
  maintenance?: Maybe<Maintenance>;
  maintenances: Array<Maintenance>;
  match: Match;
  matchCalendar: MatchCalendarResult;
  matchCalendarDay: MatchCalendarDayResult;
  matchDetails: Match;
  matchList: MatchListResult;
  matchProgression: MatchProgression;
  matchProgressions: Array<MatchProgression>;
  matchScore: MatchScore;
  matchStats: MatchListStats;
  matches: Array<Match>;
  matchesEntries: Array<MatchesEntry>;
  matchesEntry: MatchesEntry;
  matchesOfOrganization: Scalars['JSON']['output'];
  matchesScore: MatchesScore;
  media: Media;
  memberClubs: ClubResult;
  mobileVersion?: Maybe<MobileVersion>;
  mobileVersions: Array<MobileVersion>;
  myActiveSessions: Array<ActiveSession>;
  myCareer: Scalars['JSON']['output'];
  mySignInMethods: MySignInMethodsResult;
  myTeams: MyTeamListResult;
  news: News;
  onboarding: Onboarding;
  organizationFedrations: Array<OrganizationFederationPublicDto>;
  organizationPlatform: OrganizationPlatform;
  organizationPlatformByFields: OrganizationSubscription;
  organizationPlatformMember: OrganizationPlatformMember;
  organizationPlatformMembers: Array<OrganizationPlatformMember>;
  organizationPlatforms: Array<OrganizationPlatform>;
  organizerChat: ChatChannelOutput;
  organizerLeagueMembers: OrganizerLeagueUsersResult;
  /** PadelLevels-compatible CSV: by `updatedAt` window (`days`) or full tournament (`tournamentId` ignores `days`). Admin preview; production feed uses REST. */
  padelLevelsMatchesExportCsv: Scalars['String']['output'];
  padelLevelsMatchesExportUrl: Scalars['String']['output'];
  pairing: Scalars['JSONObject']['output'];
  pairingEntries: Array<PairingEntry>;
  pairingEntry: PairingEntry;
  pairingResults: Scalars['JSONObject']['output'];
  pairings: Array<Pairing>;
  participantsMetaData: ParticipantsMetadata;
  partner: Partner;
  partnerConnectionRequest: GeneralReturnType;
  partnerNew: PartnerNew;
  partnerSearch: PartnerSearch;
  partnerSearchRequest: PartnerSearchRequest;
  partnerSearchRequests: Array<PartnerSearchRequest>;
  partnerSearches: PartnerSearchsResult;
  partners: Array<Partner>;
  partnersNew: Array<PartnerNew>;
  partnersPublic: Array<PartnerPublic>;
  pdfGenerationForPairing: Scalars['String']['output'];
  pendingProposedResults: Array<ProposedResult>;
  pendingUnderagePlayersDetails: PendingUnderageDetails;
  ping: HealthCheckType;
  plan: Plan;
  plans: Array<Plan>;
  plateformSport: PlateformSport;
  plateformSports: Array<PlateformSport>;
  platform: PlatformWithSubscription;
  platformById: Platform;
  platformClubs: Platform;
  platformCoach: PlatformCoach;
  platformCoaches: PlatformCoachResult;
  /** @deprecated Use platform documents v2: queries platformDocumentsNew / platformDocumentNew (dashboard, JWT) or platformDocumentsPublic (public); mutations createPlatformDocumentNew, updatePlatformDocumentNew, updateBulkPlatformDocumentNew, deletePlatformDocumentNew. */
  platformDocument: PlatformDocument;
  platformDocumentNew: PlatformDocumentNew;
  /** @deprecated Use platform documents v2: queries platformDocumentsNew / platformDocumentNew (dashboard, JWT) or platformDocumentsPublic (public); mutations createPlatformDocumentNew, updatePlatformDocumentNew, updateBulkPlatformDocumentNew, deletePlatformDocumentNew. */
  platformDocuments: Array<PlatformDocument>;
  platformDocumentsNew: Array<PlatformDocumentNew>;
  platformDocumentsPublic: Array<PlatformDocumentPublic>;
  platformFee: PlatformFee;
  platformLeagueCategories: Array<League>;
  platformPage: PlatformPage;
  platformPages: Array<PlatformPage>;
  platformPartners: Array<Partner>;
  platformSetting: PlatformSetting;
  platformSettings: Array<PlatformSetting>;
  platformSpecificUsers: UsersResult;
  platformSponsors: Array<Sponsor>;
  platformUsers: Scalars['JSON']['output'];
  platforms: PlatformsResult;
  platformsByIds: Array<Platform>;
  platformsFedrations: PlatformsOrganizationResult;
  playerH2HMatchHistory: PlayerH2HMatchHistory;
  playerH2HStats: PlayerH2HStats;
  playerH2HSummary: PlayerH2HSummary;
  postCategories: Array<PostCategory>;
  postCategory: PostCategory;
  publicAthletes: PublicAthletesResult;
  publicFeaturedTournaments: PublicTournamentListResult;
  publicFeaturedTours: PublicTourListResult;
  publicFileUrls: Array<PublicFileUrl>;
  publicNewsList: PublicNewsListResult;
  publicOrganizationsList: PublicOrganizationsResult;
  /** Full post incl. blocks for the detail page. Returns null when not found, draft, archived, or scheduled-for-future. `language` defaults to "en". */
  publicPostBySlug?: Maybe<Post>;
  /** Block-based posts (separate from news). Filters mirror publicNewsList plus mention-based discovery (mentionsAthleteId etc.) and admin-curated keywords[] tags. */
  publicPostList: PublicPostListResult;
  /** Cross-entity public discovery search — one round-trip across tournaments, tours, venues, organizers, coaches and athletes with server-side ranking. Public, no auth. */
  publicSmartSearch: PublicSmartSearchResult;
  publicTeam: PublicTeam;
  publicTournamentList: PublicTournamentListResult;
  publicToursList: PublicTourListResult;
  /** PII-free single-user lookup. No JWT required — used by public profile pages and shared links. */
  publicUserById: PublicUserOutput;
  publicUserMatches: PublicUserMatchesResult;
  publicUserTeams: PublicTeamListResult;
  publicVenuesList: PublicVenuesListResult;
  purchasedLicense: PurchasedLicense;
  purchasedLicenseByUser: Array<PurchasedLicense>;
  purchasedLicenses: Array<PurchasedLicense>;
  purchasedLicensesByIds: Array<PurchasedLicense>;
  rankingCategoryPoint: RankingCategoryPoint;
  rankingCategoryPointType: RankingCategoryPointType;
  rankingCategoryPointTypes: Array<RankingCategoryPointType>;
  rankingCategoryPoints: Array<RankingCategoryPoint>;
  rankingOfOrganization: Scalars['JSON']['output'];
  rankingPoint: RankingPoint;
  rankingPointCategories: Array<RankingPointCategory>;
  rankingPointCategory: RankingPointCategory;
  rankingPointRule: RankingPointRule;
  rankingPointRules: Array<RankingPointRule>;
  rankingPoints: Array<RankingPoint>;
  rankingTournamentCategories: Array<RankingTournamentCategory>;
  rankingTournamentCategory: RankingTournamentCategory;
  registrationCount: Scalars['JSON']['output'];
  registrationsCountByDate: Scalars['JSON']['output'];
  resourceService: ResourceService;
  resourceServices: Array<ResourceService>;
  role: Role;
  roles: Array<Role>;
  round: Round;
  rounds: Array<Round>;
  scorerInviteContext: ScorerInviteContext;
  scorerInvites: Array<TournamentScorerInvite>;
  searchCoachByEmail: PlatformCoach;
  searchFederationByTitle: Array<Federation>;
  searchLeagues: Array<Scalars['JSON']['output']>;
  searchLeaguesByTitle: Array<League>;
  searchTournamentsByTitle: Array<Tournament>;
  sendInviteToLicensedAthlete: GeneralReturnType;
  sendInviteToSignupAndTeamUp: GeneralReturnType;
  sendNotificationToParticipant: GeneralReturnType;
  sponsor: Sponsor;
  sponsors: Array<Sponsor>;
  sport: Sport;
  sportFishingEntriesMatric: SportFishingEntriesMatric;
  sportFishingEntriesMatrics: Array<SportFishingEntriesMatric>;
  sportFishingEntriesMatricsCount: CountSportFishingEntriesMetric;
  sportFishingEntriesMatricsForManager: Array<Scalars['JSON']['output']>;
  sportFishingMatric: SportFishingMatric;
  sportFishingMatrics: Array<Scalars['JSON']['output']>;
  sportFishingMetricContext: SportFishingMetricContext;
  sportFishingMetricContexts: Array<SportFishingMetricContext>;
  sportFishingResult: SportFishingResult;
  sportFishingResultEntries: Array<SportFishingResultEntry>;
  sportFishingResultEntry: SportFishingResultEntry;
  sportFishingResults: Array<Scalars['JSONObject']['output']>;
  sportFishingResultsForManager: Array<Scalars['JSONObject']['output']>;
  sportFishingResultsForSingleEntry: Scalars['JSONObject']['output'];
  sportList: SportListResult;
  sports: Array<Sport>;
  sportsWithTournamentCount: Array<SportWithTournamentCount>;
  stat: Stat;
  stats: TournamentList;
  statsForOrganization: Scalars['JSONObject']['output'];
  storeWPRUser: Scalars['JSONObject']['output'];
  subscription: Subscription;
  subscriptions: SubscriptionsResult;
  team: Team;
  teamDetails: Scalars['JSON']['output'];
  teamMember: TeamMember;
  teams: TeamResult;
  teamsBySportIdAndUserId: Array<TeamMember>;
  template: Template;
  templates: Array<Template>;
  thirdPartyLicense: ThirdPartyLicense;
  thirdPartyLicenses: Array<ThirdPartyLicense>;
  thirdPartyLicensesBySportId: Array<ThirdPartyLicense>;
  tournament: Tournament;
  tournamentAchievementsByTeamId: Array<TournamentRankingsEntry>;
  tournamentAllMatches: Scalars['JSONObject']['output'];
  tournamentAllMatches1: Scalars['JSONObject']['output'];
  tournamentAnnouncement: TournamentAnnouncement;
  tournamentAnnouncements: Array<TournamentAnnouncement>;
  tournamentById: Tournament;
  tournamentCategories: Array<TournamentCategory>;
  tournamentCategoriesWithPartnersCount: Array<Scalars['JSONObject']['output']>;
  tournamentCategoriesWithPartnersCountUpdated: Array<CategorySetting>;
  tournamentCategory: TournamentCategory;
  tournamentCategoryLicense: TournamentCategoryLicense;
  tournamentCategoryLicenses: Array<TournamentCategoryLicense>;
  tournamentCategoryList: TournamentCategoryListResult;
  tournamentChat: TournamentChatOutput;
  tournamentChatActivity: TournamentChatActivityOutput;
  tournamentCountries: Array<Tournament>;
  tournamentDetailById: Tournament;
  tournamentDiscount: TournamentDiscount;
  tournamentDiscounts: Array<TournamentDiscount>;
  tournamentDocument: TournamentDocument;
  tournamentDocuments: Array<TournamentDocument>;
  tournamentDrawCategories: Array<Scalars['JSONObject']['output']>;
  tournamentDrawsMatches: Array<Scalars['JSONObject']['output']>;
  tournamentFactSheet: TournamentFactSheet;
  tournamentFactSheets: Array<TournamentFactSheet>;
  tournamentGroupCategories: Array<Scalars['JSONObject']['output']>;
  tournamentListStats: TournamentListStats;
  tournamentMatches: Array<Scalars['JSONObject']['output']>;
  tournamentMatchesDates: Array<Scalars['JSONObject']['output']>;
  tournamentMatchesDates1: Array<Scalars['JSONObject']['output']>;
  tournamentOrganizer: TournamentOrganizer;
  tournamentParticipantList: TournamentParticipantListResult;
  tournamentParticipants: Array<TournamentParticipant>;
  tournamentRanking: TournamentRanking;
  tournamentRankings: TournamentRankingsResult;
  tournamentRankingsEntries: Array<TournamentRankingsEntry>;
  tournamentRankingsEntry: TournamentRankingsEntry;
  tournamentRankingsMan: TournamentRankingsMan;
  tournamentRankingsMen: Array<TournamentRankingsMan>;
  tournamentRankingsWoman: TournamentRankingsWoman;
  tournamentRankingsWomen: Array<TournamentRankingsWoman>;
  tournamentReferee: TournamentReferee;
  tournamentRegistration: TournamentRegistration;
  tournamentRegistrationParticipants: Array<TournamentRegistrationParticipant>;
  tournamentRegistrationPaymentDetails: TournamentRegistrationPaymentDetails;
  tournamentRegistrationQuestion: TournamentRegistrationQuestion;
  tournamentRegistrationQuestions: Array<TournamentRegistrationQuestion>;
  tournamentRegistrations: Array<TournamentRegistration>;
  tournamentRegistrationsForWeb: UserTournamentRegistrationsResult;
  tournamentStats: Array<Tournament>;
  tournamentTeamList: TournamentTeamListResult;
  tournamentTeamMember: TournamentTeamMember;
  tournamentTeamMembers: TournamentTeamMembersResult;
  tournamentTeamMembersWithCount: TournamentTeamMembersResult;
  tournamentTopFivePlayers: Array<Scalars['JSONObject']['output']>;
  tournamentVenue: TournamentVenue;
  tournamentVenues: Array<TournamentVenue>;
  tournamentVenuesForClubAdmin: TournamentVenueListResult;
  tournamentsByUserId: Scalars['JSON']['output'];
  transactionHistory: TransactionHistory;
  transactionHistoryByUser: Array<TransactionHistory>;
  updateTournamentsPlatformId: Array<Tournament>;
  updateTransactionHistoryCurrency: Scalars['String']['output'];
  user: UserDetailedInfo;
  userAchievements: Scalars['JSON']['output'];
  userAllLeagues: LeagueResult;
  userAllMatches: Array<Scalars['JSONObject']['output']>;
  userAllTournaments: Scalars['JSON']['output'];
  userById: User;
  userCoach: UserCoach;
  userCoaches: Array<UserCoach>;
  userCoachesByUserIdAndSportId: Array<UserCoach>;
  userEntriesTeamLicensesCount: Scalars['JSON']['output'];
  userLatestResults: Array<TournamentTeamMember>;
  userLeaguePoints: Array<Scalars['JSONObject']['output']>;
  userLicense: UserLicense;
  userLicenses: Array<UserLicense>;
  userManagerRole: Scalars['String']['output'];
  userMatches: PublicUserMatchesResult;
  userParents: Array<UserParent>;
  userPartnerSearchCategories: Array<Scalars['JSONObject']['output']>;
  userPartnerSearches: Array<Scalars['JSONObject']['output']>;
  userPartnerSearchesUpdated: Array<PartnerSearch>;
  userPlan: UserPlan;
  userProfile: Scalars['JSON']['output'];
  userRole: Scalars['String']['output'];
  userRoles: Array<Role>;
  userSetting: UserSetting;
  userSettings: Array<UserSetting>;
  userSport: UserSport;
  userSports: Array<UserSport>;
  userThirdPartyLicenses: Scalars['JSON']['output'];
  userTournamentCategories: Scalars['JSONObject']['output'];
  userTournamentCategoriesOld: Scalars['JSONObject']['output'];
  userTournamentMatches: Scalars['JSONObject']['output'];
  userTournamentMatches1: Scalars['JSONObject']['output'];
  userTournamentRegistrations: Array<TournamentRegistration>;
  userTournaments: Array<Tournament>;
  userTournamentsResult: TournamentsResult;
  users: UsersResult;
  usersByIds: Array<User>;
  usersCount: Scalars['JSON']['output'];
  validLicensesForUsers: Array<License>;
  validTeamMembers: Array<Scalars['JSONObject']['output']>;
  /** Returns the tournament for the given 6-digit livescore access code, or null if invalid */
  validateLiveScoreCode?: Maybe<Tournament>;
  validateUserU10License: Scalars['JSON']['output'];
  verifyPlatformAccessCode: Scalars['Boolean']['output'];
  videoMetadata?: Maybe<VideoMetadata>;
};


export type QueryAllPlacesForSporfieArgs = {
  filter?: InputMaybe<ListLiveStreamingInput>;
};


export type QueryCsvGenerationForPickleballGroupsArgs = {
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCsvGenerationForPickleballOopArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCsvGenerationForPickleballOopFansPlayArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationArgs = {
  id: Scalars['String']['input'];
};


export type QueryPdfGenerationForDrawArgs = {
  drawId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForGridArgs = {
  id: Scalars['String']['input'];
};


export type QueryPdfGenerationForGroupArgs = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  pdfFormat?: InputMaybe<Scalars['String']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForPickleballArgs = {
  id: Scalars['String']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPdfGenerationForScoreCardArgs = {
  id: Scalars['String']['input'];
};


export type QueryTournamentAdditionalRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryActivePlayersOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryAdditionalQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAdditionalQuestionsArgs = {
  filter?: InputMaybe<ListAdditionalQuestionInput>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAlbumArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAllDashboardStatsArgs = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDashboardStatsV2Args = {
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllDrawsArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryAllFederationNewsArgs = {
  filter?: InputMaybe<ListFederationNewsInput>;
};


export type QueryAllGroupMatchesArgs = {
  filter?: InputMaybe<ListGroupInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllGroupsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllGroupsStandingsArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  queryName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLeagueMembersArgs = {
  filter?: InputMaybe<ListLeagueMemberInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLeagueNewsArgs = {
  filter?: InputMaybe<ListLeagueNewsInput>;
};


export type QueryAllLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryAllLeaguesForManagerArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortByTournament?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLeaguesForManagerOldArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sortByTournament?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllLeaguesNamesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllLeaguesWithCountArgs = {
  federationId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAllNewsArgs = {
  filter?: InputMaybe<ListNewsInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllOrganizationPlatformsArgs = {
  filter?: InputMaybe<ListOrganizationPlatformsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStatsDataArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllStatsGraphDataArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllStatsTransactionDataArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTournamentCategoriesArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentCategoriesListArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentCategoriesUpdatedArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentNamesArgs = {
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  isDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  manualSorting?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  startFrom?: InputMaybe<Scalars['String']['input']>;
  startTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTournamentWithMatchesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTournamentsListArgs = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  categoryGroup?: InputMaybe<Array<Scalars['Int']['input']>>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isLast7or30Days?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerOrDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAllTransactionHistoryArgs = {
  filter?: InputMaybe<ListTransactionHistory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  paymentTypes?: InputMaybe<Array<TransactionType>>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryAlltournamentArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  isManagerOrDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryAnnouncementCommentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAthleteArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAthleteAchievementsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAthleteQuestionAnswersArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryAthleteQuestionsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryAthleteTournamentStatsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  isThisYear?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId: Scalars['Int']['input'];
};


export type QueryAthletesArgs = {
  filter?: InputMaybe<ListAthleteInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuditLogDetailArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAuditLogsArgs = {
  filter?: InputMaybe<AuditLogFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAuthMethodArgs = {
  filter: ListAuthMethodInput;
};


export type QueryAuthMethodsArgs = {
  filter?: InputMaybe<ListAuthMethodInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAvailableFederationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailableFederationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryAvailablePlatformByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryAvailablePlatformsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryBannerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBannerNewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryBannersArgs = {
  filter?: InputMaybe<ListBannerInput>;
};


export type QueryBannersNewArgs = {
  filter: ListBannersNewInput;
};


export type QueryBannersPublicArgs = {
  filter: ListBannersNewInput;
};


export type QueryBreakDownRankingOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryCalculateDrawPointsArgs = {
  categoryId: Scalars['Int']['input'];
  categorySettingId: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  leagueId: Scalars['Int']['input'];
};


export type QueryCalculateEntryPointsArgs = {
  categoryId: Scalars['Int']['input'];
  leagueId: Scalars['Int']['input'];
  tournament: Scalars['Int']['input'];
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
};


export type QueryCalculateGroupScoreArgs = {
  filter?: InputMaybe<ListGroupInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculateLeaguePointsArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
};


export type QueryCalculateLiveStandingPointsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCalculateLiveStandingsPointsArgs = {
  categoryId: Scalars['Int']['input'];
  categorySettingId: Scalars['Int']['input'];
  createTournamentRankingInput: CreateTournamentRankingInput;
  leagueId: Scalars['Int']['input'];
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCalculatePaymentsArgs = {
  calculatePaymentInput: CalculatePaymentInput;
  categoryPaymentInput: Array<CategoryPaymentInput>;
};


export type QueryCalculateTeamTotaltResultArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculateTotaltFishingResultArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCaptainTeamsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoriesArgs = {
  filter?: InputMaybe<ListCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategoryRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategorySettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategorySettingsArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategorySettingsGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCategorySettingsGroupsArgs = {
  filter?: InputMaybe<ListCategorySettingsGroupInput>;
};


export type QueryCategoryTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryChatDirectChannelArgs = {
  peerUserId: Scalars['Int']['input'];
};


export type QueryChatDiscoverableTournamentsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatInboxArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  tournamentIds: Array<Scalars['Int']['input']>;
};


export type QueryChatOrganizerThreadInfoArgs = {
  participantUserId: Scalars['Int']['input'];
  tournamentId: Scalars['Int']['input'];
};


export type QueryChatPlatformEnabledArgs = {
  platformId: Scalars['Int']['input'];
};


export type QueryChatRoomMemberStatesArgs = {
  roomId: Scalars['String']['input'];
};


export type QueryChatUnreadArgs = {
  tournamentIds: Array<Scalars['Int']['input']>;
};


export type QueryCheckDuprIdArgs = {
  duprId: Scalars['String']['input'];
};


export type QueryCheckSubscriptionArgs = {
  platformId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryCheckUserAsParentOrCoachArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubArgs = {
  filter?: InputMaybe<ListClubInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClubAdministratorArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubByMemberAndSportIdArgs = {
  memberId: Scalars['Int']['input'];
  sportId: Scalars['Int']['input'];
};


export type QueryClubCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubDetailsArgs = {
  id: Scalars['Int']['input'];
  isManagerOrDashboard?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryClubListArgs = {
  input?: InputMaybe<ClubListInput>;
};


export type QueryClubMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubMemberListArgs = {
  input: ClubMemberListFilterInput;
};


export type QueryClubMembersArgs = {
  clubName?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListClubMembers>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryClubMembersStatsArgs = {
  clubId: Scalars['Int']['input'];
};


export type QueryClubNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubServiceResourceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClubServiceResourcesArgs = {
  filter?: InputMaybe<ListClubServiceResourceInput>;
};


export type QueryClubsArgs = {
  filter?: InputMaybe<ListClubInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryClubsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryClubsBySportIdsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryClubsServicesArgs = {
  filter?: InputMaybe<ListClubServiceInput>;
};


export type QueryCourtArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCourtsArgs = {
  filter?: InputMaybe<ListCourtInput>;
  isShowHidden?: InputMaybe<Scalars['Boolean']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryCreateMatchesOnWprArgs = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  fileterWO?: InputMaybe<Scalars['JSONObject']['input']>;
  filter?: InputMaybe<ListMatchesInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchConflicts?: InputMaybe<Array<MatchesConflicts>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  selectedMatchesIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCurrentSubscriptionDetailsArgs = {
  platformId: Scalars['Int']['input'];
};


export type QueryDashboardPurchasedLicensesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  getUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDefaultTeamMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDefaultTeamMatchesArgs = {
  filter?: InputMaybe<ListDefaultTeamMatchInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryDeletedTournamentsArgs = {
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  startFrom?: InputMaybe<Scalars['String']['input']>;
  startTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDisciplineArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDisciplinesArgs = {
  filter?: InputMaybe<ListDisciplineInput>;
};


export type QueryDisplaySettingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDoublesH2HMatchHistoryArgs = {
  input: DoublesH2HMatchHistoryInput;
};


export type QueryDoublesH2HStatsArgs = {
  doubles: H2HDoubles;
  sportIds: Array<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDoublesH2HSummaryArgs = {
  doubles1: H2HDoubles;
  doubles2: H2HDoubles;
  sportIds: Array<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDrawArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawEntriesArgs = {
  filter?: InputMaybe<ListDrawEntryInput>;
};


export type QueryDrawEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryDrawsArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryDrawsDetailArgs = {
  filter?: InputMaybe<ListDrawInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEligibleTeamMembersArgs = {
  category?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListTeamMemberInput>;
  tournament?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryExportLeagueRankingsCsvUrlArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryExportParticipantsListArgs = {
  id: Scalars['Int']['input'];
  isEmailOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryExportTournamentTeamsCsvArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFactSheetsArgs = {
  filter?: InputMaybe<ListFactSheetInput>;
};


export type QueryFeaturedLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFeaturedTournamentsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  skipInactiveLeagueTournament?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFederationArgs = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationDataCountArgs = {
  filter?: InputMaybe<ListFederationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationDetailsArgs = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFederationLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationWithPlatformsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFederationsArgs = {
  arrayOfPlatform?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<ListFederationInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFederationsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryFetchAchievementsByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchAlbumByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchClubsBySportsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFetchGroupEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFetchLeaguesByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchMatchesEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFetchNewsByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchOnboardingDetailsArgs = {
  organizationPlatformId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchPartnersByTeamArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchRankingPointsByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchSponsorsByTeamArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryFetchTournamentsByDateArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFetchTournamentsByTeamIdArgs = {
  relations?: InputMaybe<Array<Scalars['String']['input']>>;
  teamId: Scalars['Int']['input'];
};


export type QueryFetchUserPlanArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryFetchUserRoleArgs = {
  clubId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryFindAllAlbumArgs = {
  filter?: InputMaybe<ListAlbumInput>;
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindAllOwnerNewsArgs = {
  filter?: InputMaybe<ListNewsInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindAllTeamMembersArgs = {
  filter?: InputMaybe<ListTeamMemberInput>;
};


export type QueryFindAllTournamentCategoryGroupArgs = {
  filter?: InputMaybe<ListTournamentCategoryGroupInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindAllUserClubWithClubMemberCountsArgs = {
  filter?: InputMaybe<ListClubMembers>;
};


export type QueryFindAndUpdateGroupMatchesScoreArgs = {
  filter?: InputMaybe<ListGroupMatchInput>;
};


export type QueryFindCaptainTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindFederationArgs = {
  filter?: InputMaybe<ListFederationInput>;
};


export type QueryFindGroupMatchesWithRoundsArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindPlatformAthletesArgs = {
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFindTournamentCategoryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFindTournamentsByDateArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryFindUserRequestsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindUserTournamentRoleArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryFormatBlockArgs = {
  id: Scalars['Int']['input'];
};


export type QueryFormatBlockStandingsArgs = {
  blockId: Scalars['Int']['input'];
  roundNumber: Scalars['Int']['input'];
};


export type QueryFormatBlocksArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  tournamentId: Scalars['Int']['input'];
};


export type QueryGetAllStripeProductsArgs = {
  connectedAccountId: Scalars['String']['input'];
};


export type QueryGetClubCoachMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetClubMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetCurrentRankingsArgs = {
  age?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
  playerType?: InputMaybe<Scalars['String']['input']>;
  rankingType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetFederationMetadataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetLeagueMemberStatsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetLeagueMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetLicensedAthletesArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  search: Scalars['String']['input'];
  shouldSearchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetNewsMetadataArgs = {
  slug: Scalars['String']['input'];
};


export type QueryGetPlatformCoachMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetPlatformMetadataArgs = {
  domain?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlatformStatsArgs = {
  platformId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryGetPlayerFideRankingArgs = {
  fideId: Scalars['String']['input'];
};


export type QueryGetPlayerIdByNameArgs = {
  birthDate?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlayerRankingsByPlayerIdArgs = {
  playerId: Scalars['String']['input'];
};


export type QueryGetPlayerRankingsByTennisIdArgs = {
  citizenship: Scalars['String']['input'];
  tennisId: Scalars['String']['input'];
};


export type QueryGetPlayerResultsArgs = {
  discipline?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  nationalCode?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetPlayerResultsByPlayerIdArgs = {
  discipline?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetRatingByDuprIdArgs = {
  duprId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetStripePlanArgs = {
  planId: Scalars['String']['input'];
};


export type QueryGetStripeProductArgs = {
  connectedAccountId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};


export type QueryGetTeamMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetThirdPartyUserDetailsArgs = {
  thirdPartyProviderId: Scalars['String']['input'];
  thirdPartyProviderName: ThirdPartyUserProfileConnectionType;
};


export type QueryGetTournamentMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetUserFcmTokenArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryGetUserMatchesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListMatchInput>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryGetUserMetaDataArgs = {
  id: Scalars['Float']['input'];
};


export type QueryGetUserPartnersArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetUserStatsArgs = {
  filters?: InputMaybe<ListTournamentInput>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGroupArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupEntriesArgs = {
  filter?: InputMaybe<ListGroupEntryInput>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryGroupEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupMatchesArgs = {
  filter?: InputMaybe<ListTMatchInput>;
};


export type QueryGroupMatches1Args = {
  filter?: InputMaybe<ListGroupMatchInput>;
};


export type QueryGroupTeamMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryGroupTeamMatch1Args = {
  id: Scalars['Int']['input'];
};


export type QueryGroupsArgs = {
  filter?: InputMaybe<ListGroupInput>;
};


export type QueryGroupsAndDrawsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryHasUserLikedAnnouncementArgs = {
  announcementId: Scalars['Int']['input'];
};


export type QueryHighlightsDataArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHomePageLeagueRankingArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryImageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryIncompleteOopMatchesArgs = {
  filter?: InputMaybe<ListMatchesInput>;
};


export type QueryInterestedTournamentsArgs = {
  input: InterestedTournamentsInput;
};


export type QueryLandingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingMembersArgs = {
  filter?: InputMaybe<CreateLandingMemberInput>;
};


export type QueryLandingPotmArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingPotmsArgs = {
  filter?: InputMaybe<CreateLandingPotmInput>;
};


export type QueryLandingRoadmapArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingRoadmapsArgs = {
  filter?: InputMaybe<CreateLandingRoadmapInput>;
};


export type QueryLandingSliderArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLandingSlidersArgs = {
  filter?: InputMaybe<CreateLandingSliderInput>;
};


export type QueryLandingsArgs = {
  filter?: InputMaybe<CreateLandingInput>;
};


export type QueryLatestLeagueRankingArgs = {
  filter?: InputMaybe<ListLeagueRankingInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueArgs = {
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeagueAthletesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeagueCategoriesArgs = {
  filter?: InputMaybe<ListLeagueCategoryInput>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeagueCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueDocumentsArgs = {
  filter?: InputMaybe<ListLeagueDocumentInput>;
};


export type QueryLeagueForRankingsArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueGeneralTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueLatestWinnersArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueMemberArgs = {
  id: Scalars['Int']['input'];
  leagueId?: InputMaybe<Scalars['Int']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueMemberRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueMembersArgs = {
  filter?: InputMaybe<ListLeagueMemberInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  leagueMemberRole?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  memberId?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueNewsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueOwnerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeaguePageLeagueRankingArgs = {
  leagueId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueRankingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueRankingsArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueRankingsCronCategoriesArgs = {
  leagueId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeagueRankingsCustomArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  isPage1?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeagueRankingsDateArgs = {
  filter?: InputMaybe<ListLeagueRankingInput>;
};


export type QueryLeagueRankingsHistoryArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueRankingInput>;
  isPage1?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeagueStatsArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryLeagueTournamentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLeagueTournamentsArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLeaguesArgs = {
  federationId?: InputMaybe<Scalars['Int']['input']>;
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  relations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryLeaguesForDashboardArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryLeaguesSortedByActiveTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLeaguesWithCountArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseLeagueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseListArgs = {
  input: LicenseListInput;
};


export type QueryLicenseQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLicenseQuestionsArgs = {
  listLicenseQuestionInput: ListLicenseQuestionInput;
};


export type QueryLicenseStatsArgs = {
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLicensedUsersArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLicensesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListLicenseInput>;
  isManagerOrDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLicensesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryListApiKeysArgs = {
  platformId: Scalars['Int']['input'];
};


export type QueryLiveStandingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiveStandingsArgs = {
  filter?: InputMaybe<ListLiveStandingsInput>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryLiveStandingsEntriesArgs = {
  filter?: InputMaybe<ListLiveStandingsEntryInput>;
};


export type QueryLiveStandingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLiveStreamingArgs = {
  filter?: InputMaybe<ListLiveStreamingInput>;
};


export type QueryLiveStreamingsArgs = {
  filter?: InputMaybe<ListLiveStreamingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryLivescoreEntitlementArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryLivescoreGrantsArgs = {
  subjectId: Scalars['Int']['input'];
  subjectType: LivescoreGrantSubject;
};


export type QueryLivescoreTabDataArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryLivescoreViewerContextArgs = {
  input: LivescoreViewerContextInput;
};


export type QueryMaintenanceArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMatchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchCalendarArgs = {
  input: MatchCalendarInput;
};


export type QueryMatchCalendarDayArgs = {
  input: MatchCalendarDayInput;
};


export type QueryMatchDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchListArgs = {
  input: MatchListInput;
};


export type QueryMatchProgressionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchProgressionsArgs = {
  filter?: InputMaybe<ListMatchProgressionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMatchScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchStatsArgs = {
  input: MatchStatsInput;
};


export type QueryMatchesArgs = {
  excludeCompletedWithMissingEntry?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ListTMatchInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMatchesEntriesArgs = {
  filter?: InputMaybe<ListMatchesEntryInput>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryMatchesEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMatchesOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryMatchesScoreArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMediaArgs = {
  id: Scalars['Int']['input'];
};


export type QueryMemberClubsArgs = {
  filter?: InputMaybe<ListClubInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMobileVersionArgs = {
  id: Scalars['Float']['input'];
};


export type QueryMyCareerArgs = {
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyTeamsArgs = {
  input: MyTeamsInput;
};


export type QueryNewsArgs = {
  slug: Scalars['String']['input'];
};


export type QueryOnboardingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationFedrationsArgs = {
  filter?: InputMaybe<ListOrganizationPlatformsInput>;
};


export type QueryOrganizationPlatformArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformByFieldsArgs = {
  platformId?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOrganizationPlatformMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryOrganizationPlatformMembersArgs = {
  filter?: InputMaybe<ListOrganizationPlatformMembersInput>;
};


export type QueryOrganizationPlatformsArgs = {
  filter?: InputMaybe<ListOrganizationPlatformsInput>;
  relations?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryOrganizerChatArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryOrganizerLeagueMembersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPadelLevelsMatchesExportCsvArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPadelLevelsMatchesExportUrlArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPairingArgs = {
  filter?: InputMaybe<ListPairingInput>;
  id: Scalars['Int']['input'];
};


export type QueryPairingEntriesArgs = {
  filter?: InputMaybe<ListPairingEntryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPairingEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPairingResultsArgs = {
  filter?: InputMaybe<ListPairingInput>;
  id: Scalars['Int']['input'];
};


export type QueryPairingsArgs = {
  filter?: InputMaybe<ListPairingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryParticipantsMetaDataArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPartnerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerConnectionRequestArgs = {
  acceptUrl: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  declineUrl: Scalars['String']['input'];
  receiverUserId: Scalars['Int']['input'];
  tournamentId: Scalars['Int']['input'];
  tournamentTeamMemberCategoryId: Scalars['Int']['input'];
};


export type QueryPartnerNewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchRequestArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPartnerSearchRequestsArgs = {
  filter?: InputMaybe<ListPartnerSearchRequestInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerSearchesArgs = {
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnersArgs = {
  filter?: InputMaybe<ListPartnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnersNewArgs = {
  filter: ListPartnerNewInput;
};


export type QueryPartnersPublicArgs = {
  filter: ListPartnerPublicInput;
};


export type QueryPdfGenerationForPairingArgs = {
  id: Scalars['String']['input'];
  pairingId?: InputMaybe<Scalars['String']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPendingProposedResultsArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlansArgs = {
  filter?: InputMaybe<ListPlanInput>;
};


export type QueryPlateformSportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformClubsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformCoachesArgs = {
  input?: InputMaybe<PlatformCoachFilterInput>;
};


export type QueryPlatformDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformDocumentNewArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformDocumentsArgs = {
  filter?: InputMaybe<ListPlatformDocumentInput>;
};


export type QueryPlatformDocumentsNewArgs = {
  filter: ListPlatformDocumentsNewInput;
};


export type QueryPlatformDocumentsPublicArgs = {
  filter: ListPlatformDocumentsNewInput;
};


export type QueryPlatformFeeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformLeagueCategoriesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryPlatformPageArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPlatformPagesArgs = {
  platformId?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPlatformPartnersArgs = {
  filter?: InputMaybe<ListPartnerInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformSettingArgs = {
  filter: ListPlatformSettingInput;
};


export type QueryPlatformSettingsArgs = {
  filter: ListPlatformSettingInput;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryPlatformSpecificUsersArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  searchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlatformSponsorsArgs = {
  filter?: InputMaybe<ListSponsorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformUsersArgs = {
  ageFrom?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['String']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  filter?: InputMaybe<ListLeagueInput>;
  gender?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nation?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryPlatformsArgs = {
  filter?: InputMaybe<ListPlatformInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlatformsByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryPlatformsFedrationsArgs = {
  filter?: InputMaybe<ListPlatformInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlayerH2HMatchHistoryArgs = {
  input: PlayerH2HMatchHistoryInput;
};


export type QueryPlayerH2HStatsArgs = {
  matchType: H2HMatchType;
  sportIds: Array<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPlayerH2HSummaryArgs = {
  matchType: H2HMatchType;
  player1Id: Scalars['Int']['input'];
  player2Id: Scalars['Int']['input'];
  sportIds: Array<Scalars['Int']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPostCategoriesArgs = {
  filter?: InputMaybe<ListPostCategoryInput>;
};


export type QueryPostCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPublicAthletesArgs = {
  input: PublicAthletesInput;
};


export type QueryPublicFeaturedTournamentsArgs = {
  input: PublicTournamentListInput;
};


export type QueryPublicFeaturedToursArgs = {
  input: PublicTourListInput;
};


export type QueryPublicFileUrlsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QueryPublicNewsListArgs = {
  input: PublicNewsListInput;
};


export type QueryPublicOrganizationsListArgs = {
  filter?: InputMaybe<ListPublicOrganizationsInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPublicPostBySlugArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


export type QueryPublicPostListArgs = {
  input: PublicPostListInput;
};


export type QueryPublicSmartSearchArgs = {
  input: PublicSmartSearchInput;
};


export type QueryPublicTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPublicTournamentListArgs = {
  input: PublicTournamentListInput;
};


export type QueryPublicToursListArgs = {
  input: PublicTourListInput;
};


export type QueryPublicUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPublicUserMatchesArgs = {
  input: PublicUserMatchesInput;
};


export type QueryPublicUserTeamsArgs = {
  input: PublicUserTeamsInput;
};


export type QueryPublicVenuesListArgs = {
  input: PublicVenuesListInput;
};


export type QueryPurchasedLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryPurchasedLicenseByUserArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasedLicensesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPurchasedLicensesInput>;
  getUsers?: InputMaybe<Scalars['Boolean']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPurchasedLicensesByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryRankingCategoryPointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingCategoryPointTypeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingCategoryPointsArgs = {
  filter?: InputMaybe<ListRankingCatgoryPointsInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRankingOfOrganizationArgs = {
  date: Scalars['String']['input'];
};


export type QueryRankingPointArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointRuleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRankingPointRulesArgs = {
  filter?: InputMaybe<ListRankingPointRuleInput>;
};


export type QueryRankingPointsArgs = {
  filter?: InputMaybe<ListRankingPointsInput>;
  tournamentCategoryId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRankingTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRegistrationCountArgs = {
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryRegistrationsCountByDateArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResourceServiceArgs = {
  id: Scalars['Int']['input'];
};


export type QueryResourceServicesArgs = {
  filter?: InputMaybe<ListResourceServiceInput>;
};


export type QueryRoleArgs = {
  id: Scalars['Int']['input'];
};


export type QueryRoundArgs = {
  id: Scalars['Int']['input'];
};


export type QueryScorerInviteContextArgs = {
  input: ScorerInviteContextInput;
};


export type QueryScorerInvitesArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QuerySearchCoachByEmailArgs = {
  email: Scalars['String']['input'];
};


export type QuerySearchFederationByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchLeaguesArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchLeaguesByTitleArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchTournamentsByTitleArgs = {
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySendInviteToLicensedAthleteArgs = {
  acceptUrl: Scalars['String']['input'];
  categoryId: Scalars['Int']['input'];
  declineUrl: Scalars['String']['input'];
  licensedAthleteEmail: Scalars['String']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  tournament: Scalars['Int']['input'];
  user: Scalars['Int']['input'];
};


export type QuerySendInviteToSignupAndTeamUpArgs = {
  acceptUrl: Scalars['String']['input'];
  declineUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  user: Scalars['Int']['input'];
};


export type QuerySendNotificationToParticipantArgs = {
  matchNotificationInput: MatchNotificationInput;
};


export type QuerySponsorArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySponsorsArgs = {
  filter?: InputMaybe<ListSponsorInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySportArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingEntriesMatricArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingEntriesMatricsArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
};


export type QuerySportFishingEntriesMatricsCountArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
};


export type QuerySportFishingEntriesMatricsForManagerArgs = {
  filter?: InputMaybe<ListSportFishingEntriesMatricInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingMatricArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingMatricsArgs = {
  filter?: InputMaybe<ListSportFishingMatricInput>;
};


export type QuerySportFishingMetricContextArgs = {
  id: Scalars['Float']['input'];
};


export type QuerySportFishingResultArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingResultEntriesArgs = {
  filter?: InputMaybe<ListSportFishingResultEntryInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingResultEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySportFishingResultsArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportFishingResultsForManagerArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
};


export type QuerySportFishingResultsForSingleEntryArgs = {
  filter?: InputMaybe<ListSportFishingResultInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySportListArgs = {
  input: SportListInput;
};


export type QuerySportsArgs = {
  filter?: InputMaybe<ListSportInput>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySportsWithTournamentCountArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryStatArgs = {
  id: Scalars['Int']['input'];
};


export type QueryStatsArgs = {
  federationId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
};


export type QueryStatsForOrganizationArgs = {
  filter?: InputMaybe<StatsForOrganizationFilterInput>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStoreWprUserArgs = {
  wprUserId: Scalars['Int']['input'];
};


export type QuerySubscriptionArgs = {
  id: Scalars['Int']['input'];
};


export type QuerySubscriptionsArgs = {
  filter?: InputMaybe<SubscriptionFilter>;
};


export type QueryTeamArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTeamsArgs = {
  filter?: InputMaybe<ListTeamInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTeamsBySportIdAndUserIdArgs = {
  sportId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryTemplateArgs = {
  id: Scalars['Int']['input'];
};


export type QueryThirdPartyLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryThirdPartyLicensesArgs = {
  filter?: InputMaybe<ListThirdPartyLicenseInput>;
};


export type QueryThirdPartyLicensesBySportIdArgs = {
  filter?: InputMaybe<ListThirdPartyLicenseInput>;
};


export type QueryTournamentArgs = {
  id: Scalars['ID']['input'];
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTournamentAchievementsByTeamIdArgs = {
  teamId: Scalars['Int']['input'];
};


export type QueryTournamentAllMatchesArgs = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  fileterWO?: InputMaybe<Scalars['JSONObject']['input']>;
  filter?: InputMaybe<ListMatchesInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchConflicts?: InputMaybe<Array<MatchesConflicts>>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentAllMatches1Args = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  matchConflicts?: InputMaybe<Array<MatchesConflicts>>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  viewType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentAnnouncementArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentAnnouncementsArgs = {
  filter: ListTournamentAnnouncementInput;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentCategoriesArgs = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentCategoryInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderField?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoriesWithPartnersCountArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoriesWithPartnersCountUpdatedArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentCategoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentCategoryLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentCategoryListArgs = {
  input?: InputMaybe<TournamentCategoryListInput>;
};


export type QueryTournamentChatArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentChatActivityArgs = {
  tournamentId: Scalars['Int']['input'];
};


export type QueryTournamentCountriesArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentDetailByIdArgs = {
  id: Scalars['Int']['input'];
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentDiscountArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentDiscountsArgs = {
  filter?: InputMaybe<ListTournamentDiscountInput>;
};


export type QueryTournamentDocumentArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentDocumentsArgs = {
  filter?: InputMaybe<ListTournamentDocumentInput>;
};


export type QueryTournamentDrawCategoriesArgs = {
  filter?: InputMaybe<ListDrawInput>;
};


export type QueryTournamentDrawsMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListDrawEntryInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentFactSheetArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentFactSheetsArgs = {
  filter?: InputMaybe<ListTournamentFactSheetInput>;
};


export type QueryTournamentGroupCategoriesArgs = {
  filter?: InputMaybe<ListGroupInput>;
};


export type QueryTournamentListStatsArgs = {
  input?: InputMaybe<TournamentListStatsInput>;
};


export type QueryTournamentMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentMatchesDatesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListMatchesInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentMatchesDates1Args = {
  courts?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  hideCompleteMatches?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryTournamentOrganizerArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentParticipantListArgs = {
  input: TournamentParticipantListInput;
};


export type QueryTournamentParticipantsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
};


export type QueryTournamentRankingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsArgs = {
  filter?: InputMaybe<ListTournamentRankingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentRankingsEntriesArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentRankingsEntryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsManArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRankingsWomanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRefereeArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationParticipantsArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  tournament: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationPaymentDetailsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationQuestionArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentRegistrationsArgs = {
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentRegistrationsForWebArgs = {
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentStatsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
};


export type QueryTournamentTeamListArgs = {
  input: TournamentTeamListInput;
};


export type QueryTournamentTeamMemberArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentTeamMembersArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  isUnique?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTournamentTeamMembersWithCountArgs = {
  endCreatedAt?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentTeamMembersInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startCreatedAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusArray?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryTournamentTopFivePlayersArgs = {
  categoryId?: InputMaybe<Scalars['Float']['input']>;
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
};


export type QueryTournamentVenueArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTournamentVenuesArgs = {
  filter?: InputMaybe<ListTournamentVenueInput>;
};


export type QueryTournamentVenuesForClubAdminArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTournamentsByUserIdArgs = {
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionHistoryArgs = {
  id: Scalars['Int']['input'];
};


export type QueryTransactionHistoryByUserArgs = {
  transactionType?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


export type QueryUserArgs = {
  query: FindUserInput;
  searchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
  showEntries?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserAchievementsArgs = {
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAllLeaguesArgs = {
  filter?: InputMaybe<ListLeagueInput>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAllMatchesArgs = {
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserAllTournamentsArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  showAllEntries?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserByIdArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserCoachArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserCoachesByUserIdAndSportIdArgs = {
  sportId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};


export type QueryUserEntriesTeamLicensesCountArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserLatestResultsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserLeaguePointsArgs = {
  filter?: InputMaybe<ListTournamentRankingsEntryInput>;
  rankingId: Scalars['Int']['input'];
};


export type QueryUserLicenseArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserLicensesArgs = {
  filter?: InputMaybe<ListUsersLicenseInput>;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryUserManagerRoleArgs = {
  platform?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserMatchesArgs = {
  input: PublicUserMatchesInput;
};


export type QueryUserParentsArgs = {
  filter?: InputMaybe<ListUserParentInput>;
};


export type QueryUserPartnerSearchCategoriesArgs = {
  email: Scalars['String']['input'];
  filter?: InputMaybe<ListCategorySettingInput>;
};


export type QueryUserPartnerSearchesArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPartnerSearchesUpdatedArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListPartnerSearchInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserPlanArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserProfileArgs = {
  league?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserRoleArgs = {
  platformId?: InputMaybe<Scalars['Float']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserSettingArgs = {
  filter: ListUserSettingInput;
};


export type QueryUserSettingsArgs = {
  filter: ListUserSettingInput;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
};


export type QueryUserSportArgs = {
  id: Scalars['Int']['input'];
};


export type QueryUserSportsArgs = {
  userId: Scalars['Int']['input'];
};


export type QueryUserThirdPartyLicensesArgs = {
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentCategoriesArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
};


export type QueryUserTournamentCategoriesOldArgs = {
  filter?: InputMaybe<ListCategorySettingInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentMatchesArgs = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  team?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentMatches1Args = {
  date?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListGroupMatchInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentRegistrationsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentRegistrationInput>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserTournamentsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUserTournamentsResultArgs = {
  filter?: InputMaybe<ListTournamentInput>;
  inProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  isUpcomingAndProgress?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  showAllEntries?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Array<Scalars['Int']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<ListUsersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  showDetailedInfo?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersByIdsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryUsersCountArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidLicensesForUsersArgs = {
  filter?: InputMaybe<ListLicenseInput>;
};


export type QueryValidTeamMembersArgs = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTeamInput>;
  id: Scalars['Int']['input'];
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryValidateLiveScoreCodeArgs = {
  code: Scalars['Float']['input'];
};


export type QueryValidateUserU10LicenseArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  updateUser?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVerifyPlatformAccessCodeArgs = {
  accessCode: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
};


export type QueryVideoMetadataArgs = {
  url: Scalars['String']['input'];
};

export type RankingCategoryPoint = {
  __typename?: 'RankingCategoryPoint';
  bracketType?: Maybe<Scalars['String']['output']>;
  bracketTypes?: Maybe<Array<RankingCategoryPointType>>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  numPlaces?: Maybe<Scalars['Float']['output']>;
  place?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  segment?: Maybe<Scalars['String']['output']>;
  segments?: Maybe<Array<Scalars['String']['output']>>;
  sortingPosition?: Maybe<Scalars['Float']['output']>;
};

export type RankingCategoryPointType = {
  __typename?: 'RankingCategoryPointType';
  bracketType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  rankingCategoryPoints?: Maybe<Array<RankingCategoryPoint>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RankingPoint = {
  __typename?: 'RankingPoint';
  createdAt: Scalars['DateTime']['output'];
  entries?: Maybe<Scalars['Float']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  groupStagePoints?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  name?: Maybe<Scalars['String']['output']>;
  place?: Maybe<Scalars['Float']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  rankingCategoryPoints?: Maybe<Array<RankingCategoryPoint>>;
  rankingPointRules?: Maybe<Array<RankingPointRule>>;
  tournamentCategory?: Maybe<Array<RankingPointCategory>>;
  updatedAt: Scalars['DateTime']['output'];
  zeroPointsIfNoMatchesWon?: Maybe<Scalars['Boolean']['output']>;
};

export type RankingPointCategory = {
  __typename?: 'RankingPointCategory';
  id: Scalars['Float']['output'];
  rankingPoint?: Maybe<RankingPoint>;
  tournamentCategory?: Maybe<TournamentCategory>;
};

export type RankingPointRule = {
  __typename?: 'RankingPointRule';
  coefficient?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  numberOfEntries?: Maybe<Scalars['String']['output']>;
  numberOfPlayers?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  sector?: Maybe<Scalars['String']['output']>;
  skillLevel?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<TournamentCategory>;
  type?: Maybe<Scalars['String']['output']>;
};

export type RankingTournamentCategory = {
  __typename?: 'RankingTournamentCategory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ReclassifyResultOutput = {
  __typename?: 'ReclassifyResultOutput';
  tournamentCategoriesScanned: Scalars['Int']['output'];
  tournamentCategoriesUpdated: Scalars['Int']['output'];
  tournamentsScanned: Scalars['Int']['output'];
  tournamentsUpdated: Scalars['Int']['output'];
};

/** Refresh rate options for cron scheduling */
export enum RefreshRate {
  Custom = 'CUSTOM',
  EveryMonth = 'EVERY_MONTH',
  EveryWeek = 'EVERY_WEEK'
}

/** Sub-national region (e.g. Latvian municipality, US state). Country-scoped — FE picker is narrowed by the tournament country. */
export enum Region {
  LvAdaziMunicipality = 'LV_ADAZI_MUNICIPALITY',
  LvAizkraukleMunicipality = 'LV_AIZKRAUKLE_MUNICIPALITY',
  LvAluksneMunicipality = 'LV_ALUKSNE_MUNICIPALITY',
  LvAugsdaugavaMunicipality = 'LV_AUGSDAUGAVA_MUNICIPALITY',
  LvBalviMunicipality = 'LV_BALVI_MUNICIPALITY',
  LvBauskaMunicipality = 'LV_BAUSKA_MUNICIPALITY',
  LvCesisMunicipality = 'LV_CESIS_MUNICIPALITY',
  LvDaugavpilsCity = 'LV_DAUGAVPILS_CITY',
  LvDienvidkurzemeMunicipality = 'LV_DIENVIDKURZEME_MUNICIPALITY',
  LvDobeleMunicipality = 'LV_DOBELE_MUNICIPALITY',
  LvGulbeneMunicipality = 'LV_GULBENE_MUNICIPALITY',
  LvJekabpilsCity = 'LV_JEKABPILS_CITY',
  LvJelgavaCity = 'LV_JELGAVA_CITY',
  LvJelgavaMunicipality = 'LV_JELGAVA_MUNICIPALITY',
  LvJurmalaCity = 'LV_JURMALA_CITY',
  LvKekavaMunicipality = 'LV_KEKAVA_MUNICIPALITY',
  LvKraslavaMunicipality = 'LV_KRASLAVA_MUNICIPALITY',
  LvKuldigaMunicipality = 'LV_KULDIGA_MUNICIPALITY',
  LvLiepajaCity = 'LV_LIEPAJA_CITY',
  LvLimbaziMunicipality = 'LV_LIMBAZI_MUNICIPALITY',
  LvLivaniMunicipality = 'LV_LIVANI_MUNICIPALITY',
  LvLudzaMunicipality = 'LV_LUDZA_MUNICIPALITY',
  LvMadonaMunicipality = 'LV_MADONA_MUNICIPALITY',
  LvMarupeMunicipality = 'LV_MARUPE_MUNICIPALITY',
  LvOgreMunicipality = 'LV_OGRE_MUNICIPALITY',
  LvOlaineMunicipality = 'LV_OLAINE_MUNICIPALITY',
  LvPreiliMunicipality = 'LV_PREILI_MUNICIPALITY',
  LvRezekneCity = 'LV_REZEKNE_CITY',
  LvRezekneMunicipality = 'LV_REZEKNE_MUNICIPALITY',
  LvRigaCity = 'LV_RIGA_CITY',
  LvRopaziMunicipality = 'LV_ROPAZI_MUNICIPALITY',
  LvSalaspilsMunicipality = 'LV_SALASPILS_MUNICIPALITY',
  LvSaldusMunicipality = 'LV_SALDUS_MUNICIPALITY',
  LvSaulkrastiMunicipality = 'LV_SAULKRASTI_MUNICIPALITY',
  LvSiguldaMunicipality = 'LV_SIGULDA_MUNICIPALITY',
  LvSmilteneMunicipality = 'LV_SMILTENE_MUNICIPALITY',
  LvTalsiMunicipality = 'LV_TALSI_MUNICIPALITY',
  LvTukumsMunicipality = 'LV_TUKUMS_MUNICIPALITY',
  LvValkaMunicipality = 'LV_VALKA_MUNICIPALITY',
  LvValmieraCity = 'LV_VALMIERA_CITY',
  LvVentspilsCity = 'LV_VENTSPILS_CITY',
  LvVentspilsMunicipality = 'LV_VENTSPILS_MUNICIPALITY'
}

/** The different segments of registration that can be updated */
export enum RegistrationSegment {
  DuprRankings = 'DUPR_RANKINGS',
  Rankings = 'RANKINGS',
  Seeding = 'SEEDING',
  Segment = 'SEGMENT',
  WprRankings = 'WPR_RANKINGS'
}

export type RejectProposedResultInput = {
  id: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveLicenseInput = {
  id: Scalars['Int']['input'];
  password: Scalars['String']['input'];
};

export type RemoveTournamentCategoriesInput = {
  tournamentCategoryGroupId: Scalars['Int']['input'];
  tournamentCategoryIds: Array<Scalars['Int']['input']>;
};

export type ReorderLiveStandingsEntriesInput = {
  entries: Array<EntryOrderInput>;
};

export type RequestPasswordResetOtpInput = {
  email: Scalars['String']['input'];
  platformId?: InputMaybe<Scalars['Int']['input']>;
};

export type RequestPasswordResetOtpResult = {
  __typename?: 'RequestPasswordResetOtpResult';
  success: Scalars['Boolean']['output'];
};

/** For Canada/Quebec: ALL = every required license needed; ANYONE = at least one required license */
export enum RequiredLicenseMatchMode {
  All = 'ALL',
  Anyone = 'ANYONE'
}

export type ResetPasswordWithTokenInput = {
  newPassword: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type ResetPasswordWithTokenResult = {
  __typename?: 'ResetPasswordWithTokenResult';
  message?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type ResetUserPasswordInput = {
  isLogoutFromAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  resetToken: Scalars['String']['input'];
};

export type ResolvedAthleteQuestionAnswer = {
  __typename?: 'ResolvedAthleteQuestionAnswer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  isAutoComputed: Scalars['Boolean']['output'];
  question: AthleteQuestion;
  sport?: Maybe<Sport>;
  updatedAt: Scalars['DateTime']['output'];
  value?: Maybe<Scalars['String']['output']>;
};

export type ResourceService = {
  __typename?: 'ResourceService';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Int']['output'];
  service?: Maybe<Scalars['String']['output']>;
  sport?: Maybe<Sport>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ResponseType = {
  __typename?: 'ResponseType';
  activePeriod: Scalars['String']['output'];
  addedBy?: Maybe<User>;
  additionalQuestions?: Maybe<Array<LicenseQuestion>>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  bankTransferDetails?: Maybe<Scalars['JSONObject']['output']>;
  basePrice?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  existingInLicensePaymentDataId?: Maybe<Scalars['Int']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  isBulkPurchase?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  license?: Maybe<License>;
  licenseStatus: LicenseStatus;
  message: Scalars['String']['output'];
  noOfLicense?: Maybe<Scalars['Float']['output']>;
  paid?: Maybe<Scalars['Float']['output']>;
  paidForLicenses?: Maybe<Array<License>>;
  paidForUserLicenses?: Maybe<Array<PurchasedLicensePaidForUser>>;
  paidForUsers?: Maybe<Array<User>>;
  paidTotal?: Maybe<Scalars['Float']['output']>;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  payment?: Maybe<PurchasedLicensePayment>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentIntentRelationId?: Maybe<Scalars['String']['output']>;
  paymentTransactionId?: Maybe<Scalars['String']['output']>;
  payment_status?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Platform>>;
  promo?: Maybe<Scalars['String']['output']>;
  proof?: Maybe<PurchasedLicenseProof>;
  proofFileUrl?: Maybe<Scalars['String']['output']>;
  proofUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Public id, e.g. plc_… */
  publicId: Scalars['String']['output'];
  purchasedInLicensePaymentDataId?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<ApprovalStatus>;
  stripeFee?: Maybe<Scalars['Float']['output']>;
  totalBasePrice?: Maybe<Scalars['Float']['output']>;
  totalGross?: Maybe<Scalars['Float']['output']>;
  totalNet?: Maybe<Scalars['Float']['output']>;
  totalPartnerFee?: Maybe<Scalars['Float']['output']>;
  totalStripeFee?: Maybe<Scalars['Float']['output']>;
  totalTournatedFee?: Maybe<Scalars['Float']['output']>;
  totalVatAmount?: Maybe<Scalars['Float']['output']>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  vatAmount?: Maybe<Scalars['Float']['output']>;
};

export type RevokeScorerInviteInput = {
  inviteId: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type RichTextBlock = PostBlock & {
  __typename?: 'RichTextBlock';
  id?: Maybe<Scalars['String']['output']>;
  /** Each entry is one paragraph of plain or lightly-formatted text. */
  paragraphs: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type Role = {
  __typename?: 'Role';
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Round = {
  __typename?: 'Round';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  matches?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

/** Signup source */
export enum Signup_Source {
  Admin = 'ADMIN',
  Manager = 'MANAGER',
  Mobile = 'MOBILE',
  Web = 'WEB'
}

/** Sort by */
export enum Sort_By {
  Dupr = 'DUPR',
  Points = 'POINTS',
  Rank = 'RANK',
  Ranking = 'RANKING',
  RegistrationDate = 'REGISTRATION_DATE',
  TotalScore = 'TOTAL_SCORE',
  Wpr = 'WPR'
}

/** Sort order */
export enum Sort_Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SanitizedUser = {
  __typename?: 'SanitizedUser';
  avatar?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cpcPoints?: Maybe<Scalars['String']['output']>;
  dupr?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  friends?: Maybe<Array<SanitizedUser>>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  maxwillPoints?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_armenian?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  platforms?: Maybe<Array<Platform>>;
  rank?: Maybe<Scalars['Float']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_armenian?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Validation>;
  wprData?: Maybe<WprData>;
};

export type ScorerInviteContext = {
  __typename?: 'ScorerInviteContext';
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  role: TournamentScorerInviteRole;
  tournamentEndDate?: Maybe<Scalars['DateTime']['output']>;
  tournamentId: Scalars['Int']['output'];
  tournamentStartDate?: Maybe<Scalars['DateTime']['output']>;
  tournamentTitle: Scalars['String']['output'];
};

export type ScorerInviteContextInput = {
  token: Scalars['String']['input'];
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

/** UI presets for invite expiry. CUSTOM requires expiresAt in the input. */
export enum ScorerInviteExpiryPreset {
  Custom = 'CUSTOM',
  D_3 = 'D_3',
  D_7 = 'D_7',
  D_30 = 'D_30',
  EndOfEventPlus_24H = 'END_OF_EVENT_PLUS_24H',
  H_24 = 'H_24'
}

export type ScorerInviteHeartbeatInput = {
  token: Scalars['String']['input'];
};

export type ScorerInviteWithLink = {
  __typename?: 'ScorerInviteWithLink';
  /** Whether the invite email was successfully handed off to the notifications service. False means the invite row + link are valid but the scorer did not receive an email — surface a warning and offer "Resend". */
  emailDelivered: Scalars['Boolean']['output'];
  invite: TournamentScorerInvite;
  link: Scalars['String']['output'];
};

export type SectionBlock = PostBlock & {
  __typename?: 'SectionBlock';
  id?: Maybe<Scalars['String']['output']>;
  /** Section heading. FE also uses this as the TOC label and slugifies it for the anchor. */
  title: Scalars['String']['output'];
};

export enum SectionLabel {
  Partners = 'PARTNERS',
  Sponsors = 'SPONSORS'
}

/** Initial seeding strategy */
export enum SeedingStrategy {
  Random = 'RANDOM',
  TopVsBottom = 'TOP_VS_BOTTOM'
}

/** Tournament segment type (Main Draw, Qualification, Consolation) */
export enum Segment {
  Consolation = 'CONSOLATION',
  Md = 'MD',
  Q = 'Q'
}

/** Service Fee calculation mode */
export enum ServiceFeeCalculationType {
  PerEntry = 'PER_ENTRY',
  PerPlayer = 'PER_PLAYER'
}

/** Possible type of a service */
export enum ServiceType {
  Booking = 'BOOKING',
  Entry = 'ENTRY',
  License = 'LICENSE'
}

export type ServicesCard = {
  __typename?: 'ServicesCard';
  /** Locale → label */
  description: Scalars['JSON']['output'];
  /** Tabler icon name or URL */
  icon: Scalars['String']['output'];
  /** Locale → label */
  title: Scalars['JSON']['output'];
};

export type ServicesSectionBlock = LandingBlock & {
  __typename?: 'ServicesSectionBlock';
  cards?: Maybe<Array<ServicesCard>>;
  id?: Maybe<Scalars['String']['output']>;
  /** Locale → text; optional section title */
  title?: Maybe<Scalars['JSON']['output']>;
};

export type SetLeagueLivescoreEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  /** League.id — the tour being granted/revoked. */
  leagueId: Scalars['Int']['input'];
};

export type SetOrganizerLivescoreEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  /** LeagueMember.id — the organizer being granted/revoked. */
  organizerId: Scalars['Int']['input'];
};

export type SetPlatformLivescoreEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  platformId: Scalars['Int']['input'];
};

export type SetTournamentLivescoreEnabledInput = {
  enabled: Scalars['Boolean']['input'];
  tournamentId: Scalars['Int']['input'];
};

export type SetTournamentLivescoreModeInput = {
  mode: LivescoreMode;
  tournamentId: Scalars['Int']['input'];
};

export type SingleImageBlock = PostBlock & {
  __typename?: 'SingleImageBlock';
  alt: Scalars['String']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
  width: SingleImageWidth;
};

export enum SingleImageWidth {
  Full = 'FULL',
  Normal = 'NORMAL',
  Wide = 'WIDE'
}

/** Skill level a tournament category targets */
export enum SkillLevel {
  Advanced = 'ADVANCED',
  Beginner = 'BEGINNER',
  Intermediate = 'INTERMEDIATE',
  LowerInter = 'LOWER_INTER',
  Open = 'OPEN',
  Pro = 'PRO'
}

export type SnsSubscription = {
  __typename?: 'SnsSubscription';
  createdAt: Scalars['DateTime']['output'];
  deviceType: Scalars['String']['output'];
  endpoint: Scalars['String']['output'];
  fcmToken: Scalars['String']['output'];
  id: Scalars['String']['output'];
  platform?: Maybe<Platform>;
  platformId?: Maybe<Scalars['Int']['output']>;
  subscriptionId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
};

export type SocialAuthCheckInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: SocialAuthProvider;
  providerId?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
};

export type SocialAuthCheckResult = {
  __typename?: 'SocialAuthCheckResult';
  providerData?: Maybe<SocialAuthProviderData>;
  status: SocialAuthStatus;
  user?: Maybe<SocialAuthExistingUser>;
};

export type SocialAuthExistingUser = {
  __typename?: 'SocialAuthExistingUser';
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Whether this account has a usable credential password set. */
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  /** Social providers already linked to this account. */
  linkedProviders: Array<SocialAuthProvider>;
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type SocialAuthLinkInput = {
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: SocialAuthProvider;
  providerId?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
};

export type SocialAuthLoginInput = {
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  provider: SocialAuthProvider;
  providerId?: InputMaybe<Scalars['String']['input']>;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
};

export enum SocialAuthProvider {
  Apple = 'APPLE',
  Eparaksts = 'EPARAKSTS',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  Wechat = 'WECHAT',
  WechatOfficial = 'WECHAT_OFFICIAL',
  WechatWeb = 'WECHAT_WEB',
  Wpr = 'WPR'
}

export type SocialAuthProviderData = {
  __typename?: 'SocialAuthProviderData';
  avatar?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailEditable: Scalars['Boolean']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  provider: SocialAuthProvider;
  providerId: Scalars['String']['output'];
  surname?: Maybe<Scalars['String']['output']>;
};

export type SocialAuthRegisterInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nation?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  provider: SocialAuthProvider;
  providerId?: InputMaybe<Scalars['String']['input']>;
  redirectURL?: InputMaybe<Scalars['String']['input']>;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  surname: Scalars['String']['input'];
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
};

export type SocialAuthRegisterResult = {
  __typename?: 'SocialAuthRegisterResult';
  accessToken?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status: SocialAuthRegisterStatus;
  userId?: Maybe<Scalars['Int']['output']>;
};

export enum SocialAuthRegisterStatus {
  EmailExists = 'EMAIL_EXISTS',
  Success = 'SUCCESS'
}

export enum SocialAuthStatus {
  EmailMatch = 'EMAIL_MATCH',
  ExistingUser = 'EXISTING_USER',
  NewUser = 'NEW_USER'
}

/** Social-media platform a social link points to. */
export enum SocialMediaType {
  Discord = 'DISCORD',
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  Linkedin = 'LINKEDIN',
  Tiktok = 'TIKTOK',
  Twitch = 'TWITCH',
  Youtube = 'YOUTUBE'
}

/** Ordered rules for sorting and ranking teams in standings */
export enum SortingRule {
  CoinFlip = 'COIN_FLIP',
  GamesPointsRatios = 'GAMES_POINTS_RATIOS',
  GameSetDifferential = 'GAME_SET_DIFFERENTIAL',
  HeadToHead = 'HEAD_TO_HEAD',
  InitialSeed = 'INITIAL_SEED',
  MatchesPlayed = 'MATCHES_PLAYED',
  OpponentMatchWinPercent = 'OPPONENT_MATCH_WIN_PERCENT',
  Points = 'POINTS',
  PointsDifference = 'POINTS_DIFFERENCE',
  SetRatios = 'SET_RATIOS',
  Wins = 'WINS'
}

export type Sponsor = {
  __typename?: 'Sponsor';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  ageRestriction?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  federation?: Maybe<Federation>;
  gender?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  league?: Maybe<League>;
  license?: Maybe<Scalars['String']['output']>;
  licenseRequired?: Maybe<Scalars['Boolean']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  priority?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sponsorText?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentsSum?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SponsorsSectionBlock = LandingBlock & {
  __typename?: 'SponsorsSectionBlock';
  id?: Maybe<Scalars['String']['output']>;
  sectionLabel?: Maybe<SectionLabel>;
};

export type Sport = {
  __typename?: 'Sport';
  abbreviation?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<Array<Discipline>>;
  displayDraws?: Maybe<Scalars['Boolean']['output']>;
  displayGroups?: Maybe<Scalars['Boolean']['output']>;
  displayListResults?: Maybe<Scalars['Boolean']['output']>;
  displayLiveStandings?: Maybe<Scalars['Boolean']['output']>;
  displayOrderPlay?: Maybe<Scalars['Boolean']['output']>;
  displayPendingResults?: Maybe<Scalars['Boolean']['output']>;
  displaySetting?: Maybe<Array<DisplaySetting>>;
  displayTournamentResults?: Maybe<Scalars['Boolean']['output']>;
  enableCourts?: Maybe<Scalars['Boolean']['output']>;
  enableDiscipline?: Maybe<Scalars['Boolean']['output']>;
  enableStages?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  isDisplayAthleteChessTitle?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  isEnablePairingStandings?: Maybe<Scalars['Boolean']['output']>;
  isEnablePairings?: Maybe<Scalars['Boolean']['output']>;
  isEnableRounds?: Maybe<Scalars['Boolean']['output']>;
  platforms?: Maybe<Array<PlateformSport>>;
  resourceTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  sportType?: Maybe<Scalars['String']['output']>;
  textBox?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingEntriesMatric = {
  __typename?: 'SportFishingEntriesMatric';
  categoryId?: Maybe<CategorySetting>;
  confirmAutomatically?: Maybe<Scalars['Boolean']['output']>;
  confirmedAt?: Maybe<Scalars['DateTime']['output']>;
  confirmedBy?: Maybe<User>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  id: Scalars['Float']['output'];
  matricResults?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['JSON']['output']>;
  metricContext?: Maybe<SportFishingMetricContext>;
  points?: Maybe<Scalars['Float']['output']>;
  rejectedAt?: Maybe<Scalars['DateTime']['output']>;
  rejectedBy?: Maybe<User>;
  result_counted?: Maybe<Scalars['String']['output']>;
  result_entered?: Maybe<Scalars['String']['output']>;
  sportFishingMatric?: Maybe<SportFishingMatric>;
  sportFishingResult?: Maybe<SportFishingResult>;
  sportFishingResultEntry?: Maybe<SportFishingResultEntry>;
  stage?: Maybe<Court>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  submittedBy?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingMatric = {
  __typename?: 'SportFishingMatric';
  categoryId?: Maybe<CategorySetting>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disableResultSubmissionByParticipant?: Maybe<Scalars['Boolean']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  limit?: Maybe<Scalars['Float']['output']>;
  matricResults?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['String']['output']>;
  metricContext?: Maybe<Array<SportFishingMetricContext>>;
  sortingPosition?: Maybe<Scalars['Float']['output']>;
  sportFishingResult?: Maybe<SportFishingResult>;
  stage?: Maybe<Court>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  unit?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingMetricContext = {
  __typename?: 'SportFishingMetricContext';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  matricsEntry: Array<SportFishingEntriesMatric>;
  metric: SportFishingMatric;
  stage: Court;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
};

export type SportFishingResult = {
  __typename?: 'SportFishingResult';
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['Float']['output']>;
  entries?: Maybe<Array<SportFishingResultEntry>>;
  id: Scalars['Float']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  matrics?: Maybe<Array<SportFishingMatric>>;
  segment?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<Court>;
  title?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type SportFishingResultEntry = {
  __typename?: 'SportFishingResultEntry';
  categoryId?: Maybe<CategorySetting>;
  confirmAutomatically?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  location?: Maybe<Scalars['String']['output']>;
  matrics?: Maybe<Array<SportFishingEntriesMatric>>;
  media?: Maybe<Scalars['String']['output']>;
  metric?: Maybe<SportFishingMatric>;
  points?: Maybe<Scalars['Float']['output']>;
  pointsRatio?: Maybe<Scalars['Float']['output']>;
  result?: Maybe<Scalars['Float']['output']>;
  setRatio?: Maybe<Scalars['Float']['output']>;
  sportFishingResult?: Maybe<SportFishingResult>;
  stage?: Maybe<Court>;
  status?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  weight?: Maybe<Scalars['Float']['output']>;
};

export type SportListInput = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  orderBy?: InputMaybe<SportListOrderBy>;
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export enum SportListOrderBy {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  SortingPositionAsc = 'SORTING_POSITION_ASC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type SportListResult = {
  __typename?: 'SportListResult';
  sports: Array<Sport>;
  total: Scalars['Int']['output'];
};

export type SportWithTournamentCount = {
  __typename?: 'SportWithTournamentCount';
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tournamentCount: Scalars['Int']['output'];
};

export type StandingDeDetails = {
  __typename?: 'StandingDeDetails';
  dupr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  rank?: Maybe<Scalars['String']['output']>;
  result: Scalars['Int']['output'];
  teamName?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<UserInfo>>;
  wpr?: Maybe<Scalars['Float']['output']>;
};

export type StandingUser = {
  __typename?: 'StandingUser';
  avatar?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  dupr?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  wpr?: Maybe<Scalars['Float']['output']>;
  wprConfidenceLevel?: Maybe<Scalars['String']['output']>;
};

export type Stat = {
  __typename?: 'Stat';
  /** Example field (placeholder) */
  exampleField: Scalars['Int']['output'];
};

export type StatItem = {
  __typename?: 'StatItem';
  /** Localized description */
  description: Array<LocalizedValue>;
  /** Stable client-generated id (sortable key) */
  id: Scalars['String']['output'];
  /** Plain-text value, e.g. "10K+" */
  value: Scalars['String']['output'];
};

export type StatsBlock = LandingBlock & {
  __typename?: 'StatsBlock';
  id?: Maybe<Scalars['String']['output']>;
  stats?: Maybe<Array<StatItem>>;
};

export type StatsForOrganizationFilterInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type StorageFile = {
  __typename?: 'StorageFile';
  accessLevel: Scalars['String']['output'];
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  fileType?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  size?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  uploadedBy?: Maybe<User>;
  uploadedById?: Maybe<Scalars['Float']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type StorageFileOutput = {
  __typename?: 'StorageFileOutput';
  id: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Supported streaming platforms */
export enum StreamingPlatform {
  Sporfie = 'SPORFIE',
  Youtube = 'YOUTUBE'
}

export type StripeAccount = {
  __typename?: 'StripeAccount';
  createdAt: Scalars['DateTime']['output'];
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ownerMappings?: Maybe<Array<StripeAccountLink>>;
  status: Scalars['String']['output'];
  stripeAccountId: Scalars['String']['output'];
  stripeAccountName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type StripeAccountLink = {
  __typename?: 'StripeAccountLink';
  createdAt: Scalars['DateTime']['output'];
  federation?: Maybe<Federation>;
  federationId?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  organizer?: Maybe<User>;
  organizerId?: Maybe<Scalars['Float']['output']>;
  platform?: Maybe<Platform>;
  platformId?: Maybe<Scalars['Float']['output']>;
  stripeAccount: StripeAccount;
  stripe_account_id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StripePayments = {
  __typename?: 'StripePayments';
  active?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  archive_registration_request_id?: Maybe<Scalars['Float']['output']>;
  createdTimestamp?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  livemode?: Maybe<Scalars['Boolean']['output']>;
  paymentIntent?: Maybe<Scalars['String']['output']>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  tournamentRegistration?: Maybe<TournamentRegistration>;
  tournamentRegistrationId?: Maybe<Scalars['Float']['output']>;
  user?: Maybe<User>;
  userEmail?: Maybe<Scalars['String']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  active?: Maybe<Scalars['Boolean']['output']>;
  default_price?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type SubmitBookingFormInput = {
  email: Scalars['String']['input'];
  forwardToEmail?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pageUrl: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
  topic: Scalars['String']['input'];
};

export type SubmitFormatMatchResultInput = {
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  matchId: Scalars['Int']['input'];
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  oopType?: InputMaybe<Scalars['String']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  replaceEntry1?: InputMaybe<Scalars['Int']['input']>;
  replaceEntry2?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type SubmitProposedResultInput = {
  matchId: Scalars['Int']['input'];
  /** Opaque match result payload; shape up to scoring platform. */
  payload: Scalars['JSONObject']['input'];
  /** Scorer invite JWT. */
  token: Scalars['String']['input'];
};

export type SubmitProposedResultPayload = {
  __typename?: 'SubmitProposedResultPayload';
  autoApproved: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency: Scalars['String']['output'];
  federationId: Federation;
  id: Scalars['Float']['output'];
  paymentMethod: Scalars['String']['output'];
  paymentStatus: Scalars['String']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  planName?: Maybe<Scalars['String']['output']>;
  platformId?: Maybe<Platform>;
  sports?: Maybe<Array<Sport>>;
  updatedAt: Scalars['DateTime']['output'];
  validFrom: Scalars['DateTime']['output'];
  validTo: Scalars['DateTime']['output'];
};

export type SubscriptionFilter = {
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeTo?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  package?: InputMaybe<Array<Scalars['String']['input']>>;
  paymentStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SubscriptionFilters = {
  __typename?: 'SubscriptionFilters';
  organizations?: Maybe<Array<ModifiedFedaration>>;
  packages?: Maybe<Array<StripeProduct>>;
  paymentStatus?: Maybe<Array<Scalars['String']['output']>>;
  sort: Array<Scalars['String']['output']>;
  sports?: Maybe<Array<ModifiedSport>>;
};

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  organizationDetails?: Maybe<Array<FederationSummary>>;
  subscriptions: Array<Subscription>;
  total: Scalars['Int']['output'];
};

export type SwapMatchEntriesInput = {
  entry1Type: Scalars['String']['input'];
  entry2Type: Scalars['String']['input'];
  match1Id: Scalars['Int']['input'];
  match2Id: Scalars['Int']['input'];
};

export type SwiperImage = {
  __typename?: 'SwiperImage';
  alt: Scalars['String']['output'];
  caption?: Maybe<Scalars['String']['output']>;
  src: Scalars['String']['output'];
};

export type TableBlock = PostBlock & {
  __typename?: 'TableBlock';
  caption?: Maybe<Scalars['String']['output']>;
  columns: Array<TableColumn>;
  id?: Maybe<Scalars['String']['output']>;
  /** Each row is a JSON-stringified object keyed by column.key. FE parses on render. Stored stringly to keep the union schema-safe — mixed-type cells stay flexible without a JSON scalar dependency on this field. */
  rows: Array<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TableColumn = {
  __typename?: 'TableColumn';
  /** Property key on each row object. */
  key: Scalars['String']['output'];
  /** Human-readable header label. */
  label: Scalars['String']['output'];
};

export type Team = {
  __typename?: 'Team';
  accessCode?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Federation>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageFile?: Maybe<StorageFileOutput>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  invitedMembers?: Maybe<Array<Scalars['String']['output']>>;
  joinedFrom?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<TeamMember>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use platforms instead */
  platform?: Maybe<Platform>;
  platforms?: Maybe<Array<Platform>>;
  sport?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  tiktokLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournamentsCount?: Maybe<Scalars['Int']['output']>;
  twitterLink?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/** Team formation strategy for ROTATING mode (RANDOM, STRONG_TOGETHER, STRONG_DELAYED) */
export enum TeamFormationStrategy {
  Random = 'RANDOM',
  StrongDelayed = 'STRONG_DELAYED',
  StrongTogether = 'STRONG_TOGETHER'
}

export type TeamMember = {
  __typename?: 'TeamMember';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  importBy?: Maybe<Scalars['Int']['output']>;
  member?: Maybe<User>;
  memberNr?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TeamMemberFeeBreakdown = {
  __typename?: 'TeamMemberFeeBreakdown';
  discountedOnlineFee: Scalars['Float']['output'];
  discountedOnsiteFee: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  onlineFee: Scalars['Float']['output'];
  onsiteFee: Scalars['Float']['output'];
  userId: Scalars['Int']['output'];
};

export type TeamMemberItem = {
  __typename?: 'TeamMemberItem';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  /** Stable client-generated id (sortable key) */
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Localized role/title */
  role: Array<LocalizedValue>;
};

export type TeamMemberRow = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  gender?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  memberNr?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname: Scalars['String']['input'];
  wprId?: InputMaybe<Scalars['String']['input']>;
};

export type TeamMembersBlock = LandingBlock & {
  __typename?: 'TeamMembersBlock';
  id?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<TeamMemberItem>>;
};

export type TeamResult = {
  __typename?: 'TeamResult';
  teams: Array<TeamWithTournamentCount>;
  total: Scalars['Int']['output'];
};

export type TeamWithTournamentCount = {
  __typename?: 'TeamWithTournamentCount';
  accessCode?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  discipline?: Maybe<Discipline>;
  email?: Maybe<Scalars['String']['output']>;
  facebookLink?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  image?: Maybe<Scalars['String']['output']>;
  instagramLink?: Maybe<Scalars['String']['output']>;
  invitedMembers?: Maybe<Array<Scalars['String']['output']>>;
  joinedFrom?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<TeamMember>>;
  phone?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  sport?: Maybe<Sport>;
  status?: Maybe<Scalars['String']['output']>;
  tiktokLink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tournamentCount: Scalars['Int']['output'];
  twitterLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type Template = {
  __typename?: 'Template';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  template?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Testimonial = {
  __typename?: 'Testimonial';
  authorAvatar?: Maybe<Scalars['String']['output']>;
  authorName: Scalars['String']['output'];
  authorTitle: Scalars['String']['output'];
  quote: Scalars['String']['output'];
};

export type TestimonialBlock = PostBlock & {
  __typename?: 'TestimonialBlock';
  id?: Maybe<Scalars['String']['output']>;
  testimonials: Array<Testimonial>;
};

export type ThirdPartyLicense = {
  __typename?: 'ThirdPartyLicense';
  endPointLink?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  isMakeLicenceMandatory?: Maybe<Scalars['Boolean']['output']>;
  isRequiredInUserProfile?: Maybe<Scalars['Boolean']['output']>;
  isRequiredInUserRegistration?: Maybe<Scalars['Boolean']['output']>;
  organizationAbbreviation?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  sports?: Maybe<Array<Sport>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** Third party user profile connection types */
export enum ThirdPartyUserProfileConnectionType {
  Atp = 'ATP',
  Dupr = 'DUPR',
  Fide = 'FIDE',
  FipPoints = 'FIP_POINTS',
  Fivb = 'FIVB',
  Ipin = 'IPIN',
  ItfPoints = 'ITF_POINTS',
  Te = 'TE',
  Uci = 'UCI',
  Wpr = 'WPR',
  Wta = 'WTA'
}

export enum TimeFormatPreference {
  H12 = 'H12',
  H24 = 'H24'
}

export type TopPlayersBlock = LandingBlock & {
  __typename?: 'TopPlayersBlock';
  categoryId?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  leagueId?: Maybe<Scalars['Int']['output']>;
};

/** The type of tour/league */
export enum TourType {
  Circuit = 'CIRCUIT',
  Festival = 'FESTIVAL',
  League = 'LEAGUE',
  Other = 'OTHER',
  Series = 'SERIES',
  Tour = 'TOUR'
}

export type Tournament = {
  __typename?: 'Tournament';
  Album?: Maybe<Array<Album>>;
  activeTournaments?: Maybe<Scalars['Float']['output']>;
  additionalQuestion?: Maybe<Array<AdditionalQuestion>>;
  additionalQuestion2?: Maybe<Scalars['String']['output']>;
  additionalReferee?: Maybe<Array<TournamentAdditionalReferee>>;
  address?: Maybe<Scalars['String']['output']>;
  /** Tournament location coordinates with latitude and longitude */
  addressCoordinates?: Maybe<Scalars['JSON']['output']>;
  allTournaments?: Maybe<Scalars['Float']['output']>;
  approvalStatus?: Maybe<Scalars['String']['output']>;
  approvedEntries?: Maybe<Scalars['Boolean']['output']>;
  approvedOrRejectedBy?: Maybe<User>;
  athletes?: Maybe<Scalars['Int']['output']>;
  autoConfirmEntries?: Maybe<Scalars['Boolean']['output']>;
  categorySettingsGroups?: Maybe<Array<CategorySettingsGroup>>;
  city?: Maybe<Scalars['String']['output']>;
  closeRegistration?: Maybe<Scalars['Boolean']['output']>;
  club?: Maybe<Club>;
  competitionLevel?: Maybe<CompetitionLevel>;
  competitionType: CompetitionType;
  contactUrl?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courts?: Maybe<Array<Court>>;
  coverPhoto?: Maybe<Scalars['String']['output']>;
  coverPhotoFile?: Maybe<StorageFile>;
  coverPhotoFileId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User>;
  currency?: Maybe<Scalars['String']['output']>;
  /** Optional custom URL used in place of the default hotel booking link shown near the tournament location */
  customHotelsLink?: Maybe<Scalars['String']['output']>;
  customInfoImage?: Maybe<Scalars['String']['output']>;
  customInfoImageFile?: Maybe<StorageFile>;
  customInfoImageFileId?: Maybe<Scalars['String']['output']>;
  customInfoMessage?: Maybe<Scalars['String']['output']>;
  customMatricesType: Array<CustomMatricesType>;
  customSuccessMessage?: Maybe<Scalars['String']['output']>;
  /** Tournament dates to hide from schedule */
  datesToHide?: Maybe<Scalars['JSON']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Array<TournamentDiscount>>;
  documents?: Maybe<Array<TournamentDocument>>;
  drawType: Array<DrawType>;
  draws?: Maybe<Array<Draw>>;
  enableLiveScoring?: Maybe<Scalars['Boolean']['output']>;
  enableLiveStream?: Maybe<Scalars['Boolean']['output']>;
  enablePracticeCourtsBooking?: Maybe<Scalars['Boolean']['output']>;
  enableTransferBooking?: Maybe<Scalars['Boolean']['output']>;
  enabledPushNotification?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  entryDeadline?: Maybe<Scalars['DateTime']['output']>;
  entryFee?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facts?: Maybe<Array<TournamentFactSheet>>;
  fideRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  groupType: Array<GroupType>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['Float']['output'];
  isCPCRequired?: Maybe<Scalars['Boolean']['output']>;
  isCustomMatricesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDrawsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDuprRatingEnabled?: Maybe<Scalars['Boolean']['output']>;
  isDuprRequired?: Maybe<Scalars['Boolean']['output']>;
  isFeatured?: Maybe<Scalars['Boolean']['output']>;
  isGroupsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isHideEntries?: Maybe<Scalars['Boolean']['output']>;
  isHideFromCalendar?: Maybe<Scalars['Boolean']['output']>;
  isListAndResultEnabled?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPartnerFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingPlatformFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingServiceFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingStripeFee?: Maybe<Scalars['Boolean']['output']>;
  isManagerPayingTournatedFee?: Maybe<Scalars['Boolean']['output']>;
  isMaxwillRequired?: Maybe<Scalars['Boolean']['output']>;
  isOrganizerRegEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPairingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPayForMyselfEnabled?: Maybe<Scalars['Boolean']['output']>;
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationEmailsEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprEntriesEnabled?: Maybe<Scalars['Boolean']['output']>;
  isWprRequired?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<LeagueTournament>;
  leagueType: LeagueType;
  license?: Maybe<Scalars['String']['output']>;
  listAndResultShowIndividualTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowPointsTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultShowTeamsTab?: Maybe<Scalars['Boolean']['output']>;
  listAndResultType: Array<ListAndResultType>;
  listStatus?: Maybe<Scalars['String']['output']>;
  /** 6-digit unique PIN for live score access */
  liveScoreAccessCode?: Maybe<Scalars['Float']['output']>;
  liveStandings?: Maybe<Array<LiveStanding>>;
  liveStreaming_sporfie_key?: Maybe<Scalars['String']['output']>;
  liveStreamings?: Maybe<Array<LiveStreaming>>;
  livescoreKeyVersion: Scalars['Int']['output'];
  livescoreMode: Scalars['String']['output'];
  livescoreViewerToken?: Maybe<Scalars['String']['output']>;
  livescoreViewerTokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  localRatedTournament?: Maybe<Scalars['Boolean']['output']>;
  loggedInUser?: Maybe<Scalars['Boolean']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  logoFile?: Maybe<StorageFile>;
  logoFileId?: Maybe<Scalars['String']['output']>;
  makePrivate?: Maybe<Scalars['Boolean']['output']>;
  matchesCount?: Maybe<Scalars['Int']['output']>;
  notifications?: Maybe<Array<Notification>>;
  notificationsAddress?: Maybe<Scalars['String']['output']>;
  onlinePayments?: Maybe<Scalars['Boolean']['output']>;
  onsiteEntryFee?: Maybe<Scalars['Float']['output']>;
  organizer?: Maybe<LeagueMember>;
  overRideShowOOP?: Maybe<Scalars['Boolean']['output']>;
  pairings?: Maybe<Array<Pairing>>;
  pairingsBlockType: Array<BlockType>;
  partnerSearch?: Maybe<Scalars['Boolean']['output']>;
  passedTournaments?: Maybe<Scalars['Float']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  paymentDiscounts?: Maybe<Array<PaymentDiscount>>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentQrCode?: Maybe<Scalars['String']['output']>;
  paymentType?: Maybe<Scalars['String']['output']>;
  platform?: Maybe<Platform>;
  poster?: Maybe<Scalars['String']['output']>;
  /** Public id, e.g. trn_8k3pq2r4n9v7t6mh. Use in URLs, webhooks, and external integrations. */
  publicId: Scalars['String']['output'];
  rankingsReleaseDate?: Maybe<Scalars['String']['output']>;
  referee?: Maybe<TournamentReferee>;
  region?: Maybe<Region>;
  registerLink?: Maybe<Scalars['String']['output']>;
  registeredUsersInTournament?: Maybe<Scalars['Boolean']['output']>;
  registrationRequestCount?: Maybe<Scalars['Int']['output']>;
  registrationRequests?: Maybe<Array<TournamentRegistration>>;
  registrationStartDate?: Maybe<Scalars['DateTime']['output']>;
  regulations?: Maybe<Scalars['String']['output']>;
  resourceTitle?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<Scalars['String']['output']>;
  showOOP?: Maybe<Scalars['Boolean']['output']>;
  showPairingsAndStandings?: Maybe<Scalars['Boolean']['output']>;
  showTournamentChessManagerCalendar?: Maybe<Scalars['Boolean']['output']>;
  sortOrder: Scalars['String']['output'];
  sortRequestBy: Scalars['String']['output'];
  sports?: Maybe<Array<Sport>>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  termsAndConditions?: Maybe<Scalars['String']['output']>;
  tier: TournamentTier;
  timeControl?: Maybe<Scalars['String']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tour?: Maybe<Scalars['String']['output']>;
  tournamentAddress?: Maybe<Scalars['String']['output']>;
  tournamentCategory?: Maybe<Array<CategorySetting>>;
  tournamentCategoryGroup?: Maybe<TournamentCategoryGroup>;
  tournamentDirector?: Maybe<Scalars['String']['output']>;
  tournamentRankings?: Maybe<Array<TournamentRanking>>;
  type?: Maybe<Scalars['String']['output']>;
  upcomingTournaments?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  venues?: Maybe<Array<TournamentVenue>>;
  videoUrl?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  withdrawlDeadline?: Maybe<Scalars['DateTime']['output']>;
};

export type TournamentAdditionalReferee = {
  __typename?: 'TournamentAdditionalReferee';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  referee?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentAnnouncement = {
  __typename?: 'TournamentAnnouncement';
  author?: Maybe<User>;
  categories?: Maybe<Array<CategorySetting>>;
  comments: Array<AnnouncementComment>;
  createdAt: Scalars['DateTime']['output'];
  emailNotification: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  isPublic: Scalars['Boolean']['output'];
  likes: Array<AnnouncementLike>;
  media?: Maybe<Array<Scalars['String']['output']>>;
  pushNotification: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  tournament: Tournament;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentCategory = {
  __typename?: 'TournamentCategory';
  ageFrom?: Maybe<Scalars['Float']['output']>;
  ageFromType?: Maybe<Scalars['String']['output']>;
  ageGroup?: Maybe<Scalars['String']['output']>;
  ageLimit?: Maybe<Scalars['Float']['output']>;
  ageTo?: Maybe<Scalars['Float']['output']>;
  ageToType?: Maybe<Scalars['String']['output']>;
  ageType?: Maybe<Scalars['String']['output']>;
  askSkillLevel?: Maybe<Scalars['Boolean']['output']>;
  captainRequired?: Maybe<Scalars['Boolean']['output']>;
  categoryEntries?: Maybe<Scalars['String']['output']>;
  categoryMen?: Maybe<Category>;
  categoryWomen?: Maybe<Category>;
  club?: Maybe<Club>;
  clubChampionship?: Maybe<Scalars['Boolean']['output']>;
  clubs?: Maybe<Array<Club>>;
  countIndividualTotal?: Maybe<Scalars['Boolean']['output']>;
  countPointOnMatchResult?: Maybe<Scalars['Boolean']['output']>;
  countTeamTotal?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  discipline?: Maybe<Discipline>;
  enableLicense?: Maybe<Scalars['Boolean']['output']>;
  enableMetrics?: Maybe<Scalars['Boolean']['output']>;
  /** For Canada/Quebec: ALL = every required license; ANYONE = at least one. USA/USPA unchanged. */
  externalLicense_RequiredMatchMode?: Maybe<RequiredLicenseMatchMode>;
  external_id?: Maybe<Scalars['Float']['output']>;
  gender: Scalars['String']['output'];
  id?: Maybe<Scalars['Float']['output']>;
  identifyTeamMember?: Maybe<Scalars['Boolean']['output']>;
  isAdvancedTeamEnabled?: Maybe<Scalars['Boolean']['output']>;
  isAllowed?: Maybe<Scalars['Boolean']['output']>;
  isClubRegistrationRequired?: Maybe<Scalars['Boolean']['output']>;
  isClubSelection?: Maybe<Scalars['Boolean']['output']>;
  isDisplayBirthYear?: Maybe<Scalars['Boolean']['output']>;
  isDisplayCity?: Maybe<Scalars['Boolean']['output']>;
  isDisplayClub?: Maybe<Scalars['Boolean']['output']>;
  isDisplayPoints?: Maybe<Scalars['Boolean']['output']>;
  isDisplayRank?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySeeds?: Maybe<Scalars['Boolean']['output']>;
  isDisplaySegments?: Maybe<Scalars['Boolean']['output']>;
  isMixedDoubles?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationWithoutPartnerAllowed?: Maybe<Scalars['Boolean']['output']>;
  isRegistrationWithoutPartnerCount?: Maybe<Scalars['Boolean']['output']>;
  isSpecificClubRequired?: Maybe<Scalars['Boolean']['output']>;
  isTeamSelection?: Maybe<Scalars['Boolean']['output']>;
  isTeamSelectionMendatory?: Maybe<Scalars['Boolean']['output']>;
  isTieBreakEnabled?: Maybe<Scalars['Boolean']['output']>;
  isU10Required?: Maybe<Scalars['Boolean']['output']>;
  isWithoutPartnerAllowed?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<LeagueTournamentCategory>;
  license?: Maybe<Array<TournamentCategoryLicense>>;
  maxAthletesToCount?: Maybe<Scalars['Float']['output']>;
  maxCPCPoints?: Maybe<Scalars['Float']['output']>;
  maxDUPRSkillLevel?: Maybe<Scalars['Float']['output']>;
  maxMaxwillPoints?: Maybe<Scalars['Float']['output']>;
  maxMembers?: Maybe<Scalars['Float']['output']>;
  maxPoints?: Maybe<Scalars['Float']['output']>;
  maxProjectedDUPRPoints?: Maybe<Scalars['Float']['output']>;
  maxProjectedMaxwillPoints?: Maybe<Scalars['Float']['output']>;
  maxReservists?: Maybe<Scalars['Float']['output']>;
  minAthletesToCount?: Maybe<Scalars['Float']['output']>;
  minCPCPoints?: Maybe<Scalars['Float']['output']>;
  minDUPRSkillLevel?: Maybe<Scalars['Float']['output']>;
  minMaxwillPoints?: Maybe<Scalars['Float']['output']>;
  minMembers?: Maybe<Scalars['Float']['output']>;
  minProjectedDUPRPoints?: Maybe<Scalars['Float']['output']>;
  minProjectedMaxwillPoints?: Maybe<Scalars['Float']['output']>;
  minReservists?: Maybe<Scalars['Float']['output']>;
  moveToSingles?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nationalTournament?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['String']['output']>;
  paymentCalculation?: Maybe<Array<PaymentCalculation>>;
  /** USPA licenses required for the tournament category */
  requiredUSPALicenses?: Maybe<Scalars['JSON']['output']>;
  reservistsRequired?: Maybe<Scalars['Boolean']['output']>;
  singleCategory?: Maybe<TournamentCategory>;
  skillLevel: SkillLevel;
  skills?: Maybe<Scalars['String']['output']>;
  skillsLevel?: Maybe<Scalars['String']['output']>;
  sortBy: Scalars['String']['output'];
  sortOrder: Scalars['String']['output'];
  sortingPosition?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Scalars['Float']['output']>;
  thirdPartyLicense?: Maybe<ThirdPartyLicense>;
  timeControl?: Maybe<Scalars['String']['output']>;
  tournamentCategoryGroups?: Maybe<TournamentCategoryGroup>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  wprMaxCompetitionRating?: Maybe<Scalars['Float']['output']>;
  wprMinCompetitionRating?: Maybe<Scalars['Float']['output']>;
  wprRatingType?: Maybe<Wpr_Rating_Type>;
  wprRequiredStatusRating?: Maybe<Scalars['String']['output']>;
};

export type TournamentCategoryGroup = {
  __typename?: 'TournamentCategoryGroup';
  id: Scalars['Float']['output'];
  league: League;
  name: Scalars['String']['output'];
  tournamentCategories: Array<TournamentCategory>;
};

export type TournamentCategoryLicense = {
  __typename?: 'TournamentCategoryLicense';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  license?: Maybe<License>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentCategoryListInput = {
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  limit?: Scalars['Int']['input'];
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Restrict to TournamentCategories linked to this tournament (via category_setting). Use this for the per-tournament category dropdown on the match calendar / list filters. */
  tournamentId?: InputMaybe<Scalars['Int']['input']>;
};

export type TournamentCategoryListResult = {
  __typename?: 'TournamentCategoryListResult';
  total: Scalars['Int']['output'];
  tournamentCategories: Array<TournamentCategory>;
};

export type TournamentChatActivityOutput = {
  __typename?: 'TournamentChatActivityOutput';
  /** When the most recent message was sent. */
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  /** Total messages across this tournament's chat rooms. */
  messageCount: Scalars['Int']['output'];
};

export type TournamentChatGroup = {
  __typename?: 'TournamentChatGroup';
  /** True once the tournament has ended (→ Past section) */
  archived: Scalars['Boolean']['output'];
  /** Rooms in this tournament the user may access */
  channels: Array<ChatChannelOutput>;
  /** Tournament end date */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  /** A member (auto/joined) vs just viewing it (opened from Discover) */
  joined: Scalars['Boolean']['output'];
  /** Most recent message time across the group rooms (for recency sorting) */
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  /** Group last message author name */
  lastMessageAuthor?: Maybe<Scalars['String']['output']>;
  /** Snippet of the group last message */
  lastMessageText?: Maybe<Scalars['String']['output']>;
  /** "City, Country" for the header subtitle */
  location?: Maybe<Scalars['String']['output']>;
  /** The caller's role in this tournament */
  role: TournamentChatRole;
  /** Tournament start date */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  tournamentId: Scalars['Int']['output'];
};

export type TournamentChatOutput = {
  __typename?: 'TournamentChatOutput';
  /** Rooms the caller may access */
  channels: Array<ChatChannelOutput>;
  /** Ably clientId (the platform user id) */
  clientId: Scalars['String']['output'];
  /** Room id of the tournament-wide "Main" room */
  mainChannelId: Scalars['String']['output'];
  /** The caller's role within this tournament */
  role: TournamentChatRole;
  /** Known chat members (staff + confirmed participants) for @mentions */
  roster: Array<ChatRosterEntryOutput>;
  /** Tournament id */
  tournamentId: Scalars['Int']['output'];
  /** Display name shown for the caller */
  userName: Scalars['String']['output'];
};

/** A user's role within a tournament chat */
export enum TournamentChatRole {
  Admin = 'ADMIN',
  Guest = 'GUEST',
  Organizer = 'ORGANIZER',
  Participant = 'PARTICIPANT',
  Referee = 'REFEREE'
}

export enum TournamentCompletionStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Upcoming = 'UPCOMING'
}

/** How dateRangeFrom/dateRangeTo match tournament dates. OVERLAP (default): tournaments running at any point in the window. CONTAINED: tournaments whose whole schedule fits inside the window. */
export enum TournamentDateRangeMode {
  Contained = 'CONTAINED',
  Overlap = 'OVERLAP'
}

export type TournamentDiscount = {
  __typename?: 'TournamentDiscount';
  categories?: Maybe<Array<TournamentCategory>>;
  /** Tournament location coordinates with latitude and longitude */
  categoryDiscounts?: Maybe<Array<Scalars['JSON']['output']>>;
  createdAt: Scalars['DateTime']['output'];
  discount?: Maybe<Scalars['Float']['output']>;
  discountCap?: Maybe<Scalars['Float']['output']>;
  discountExpireTime?: Maybe<Scalars['DateTime']['output']>;
  discountPer?: Maybe<Scalars['Float']['output']>;
  discountStartTime?: Maybe<Scalars['DateTime']['output']>;
  discountType?: Maybe<DiscountType>;
  id: Scalars['Float']['output'];
  isLimitCount?: Maybe<Scalars['Boolean']['output']>;
  isVTRD?: Maybe<Scalars['Boolean']['output']>;
  licences?: Maybe<Array<License>>;
  numberOfCategories?: Maybe<Scalars['Float']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
  totalCounts?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  usedCounts?: Maybe<Scalars['Float']['output']>;
};

export type TournamentDocument = {
  __typename?: 'TournamentDocument';
  createdAt: Scalars['DateTime']['output'];
  document?: Maybe<Scalars['String']['output']>;
  documentFile?: Maybe<StorageFile>;
  documentFileId?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
  section?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentFactSheet = {
  __typename?: 'TournamentFactSheet';
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  factSheet?: Maybe<FactSheet>;
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentList = {
  __typename?: 'TournamentList';
  activeTournaments?: Maybe<Scalars['Float']['output']>;
  allTournaments?: Maybe<Scalars['Float']['output']>;
  cancelledTournaments?: Maybe<Scalars['Float']['output']>;
  confirmedTournaments?: Maybe<Scalars['Float']['output']>;
  declinedTournaments?: Maybe<Scalars['Float']['output']>;
  deletedTournaments?: Maybe<Scalars['Float']['output']>;
  inactiveTournaments?: Maybe<Scalars['Float']['output']>;
  passedTournaments?: Maybe<Scalars['Float']['output']>;
  pendingTournaments?: Maybe<Scalars['Float']['output']>;
  postponedTournaments?: Maybe<Scalars['Float']['output']>;
  upcomingTournaments?: Maybe<Scalars['Float']['output']>;
};

export type TournamentListStats = {
  __typename?: 'TournamentListStats';
  approved: Scalars['Int']['output'];
  completed: Scalars['Int']['output'];
  declined: Scalars['Int']['output'];
  inProgress: Scalars['Int']['output'];
  pending: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  upcoming: Scalars['Int']['output'];
};

export type TournamentListStatsInput = {
  /** Inclusive lower bound on tournament activity. Matches tournaments whose end (or start, if no end) is on or after this instant. Pair with activeTo to filter "active on a given day" — FE should pass UTC instants pre-converted from the user-picked local day (start-of-day in user tz → UTC). */
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Inclusive upper bound on tournament activity. Matches tournaments whose start is on or before this instant. Pair with activeFrom to filter "active on a given day" — FE should pass UTC instants pre-converted from the user-picked local day (end-of-day in user tz → UTC, e.g. 23:59:59.999). */
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  competitionLevels?: InputMaybe<Array<CompetitionLevel>>;
  completionStatuses?: InputMaybe<Array<TournamentCompletionStatus>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtFrom?: InputMaybe<Scalars['DateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']['input']>;
  entriesFrom?: InputMaybe<Scalars['Int']['input']>;
  entriesPeriodFrom?: InputMaybe<Scalars['DateTime']['input']>;
  entriesPeriodTo?: InputMaybe<Scalars['DateTime']['input']>;
  entriesTo?: InputMaybe<Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leagueGeoScopes?: InputMaybe<Array<Scalars['String']['input']>>;
  leagueIds?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  organizerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  regions?: InputMaybe<Array<Region>>;
  sportIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  startDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  statuses?: InputMaybe<Array<Scalars['String']['input']>>;
  tiers?: InputMaybe<Array<TournamentTier>>;
};

export type TournamentName = {
  __typename?: 'TournamentName';
  id?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TournamentOrganizer = {
  __typename?: 'TournamentOrganizer';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type TournamentParticipant = {
  __typename?: 'TournamentParticipant';
  categories: Array<TournamentCategory>;
  clubs: Array<Club>;
  teams: Array<TournamentParticipantTeam>;
  user: User;
};

export type TournamentParticipantListInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  tournamentId: Scalars['Int']['input'];
};

export type TournamentParticipantListResult = {
  __typename?: 'TournamentParticipantListResult';
  participants: Array<User>;
  total: Scalars['Int']['output'];
};

export type TournamentParticipantTeam = {
  __typename?: 'TournamentParticipantTeam';
  team: Team;
  userTeamRole?: Maybe<Scalars['String']['output']>;
};

export type TournamentRanking = {
  __typename?: 'TournamentRanking';
  createdAt: Scalars['DateTime']['output'];
  draw?: Maybe<Draw>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isPublish?: Maybe<Scalars['Boolean']['output']>;
  league?: Maybe<League>;
  liveStanding?: Maybe<LiveStanding>;
  name?: Maybe<Scalars['String']['output']>;
  rankingPoint?: Maybe<RankingPoint>;
  rankings?: Maybe<Array<TournamentRankingsEntry>>;
  sportFishingResult?: Maybe<Scalars['Boolean']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsEntry = {
  __typename?: 'TournamentRankingsEntry';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  activeTo?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  entry?: Maybe<TournamentRegistration>;
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  place?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<TournamentRanking>;
  tournament?: Maybe<Tournament>;
  tournamentCategory?: Maybe<CategorySetting>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsMan = {
  __typename?: 'TournamentRankingsMan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRankingsResult = {
  __typename?: 'TournamentRankingsResult';
  total: Scalars['Int']['output'];
  tournamentRankings: Array<TournamentRanking>;
};

export type TournamentRankingsWoman = {
  __typename?: 'TournamentRankingsWoman';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  rankingCategory?: Maybe<Category>;
  tournamentCategory?: Maybe<TournamentCategory>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentReferee = {
  __typename?: 'TournamentReferee';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  referee?: Maybe<User>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentRegistration = {
  __typename?: 'TournamentRegistration';
  additionalFee?: Maybe<Scalars['Float']['output']>;
  additionalQuestions?: Maybe<Array<TournamentRegistrationQuestion>>;
  additionalSegment?: Maybe<Scalars['String']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  assignedSegment?: Maybe<Scalars['String']['output']>;
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  external_id?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  isAddedManually?: Maybe<Scalars['Boolean']['output']>;
  isWithoutPartner?: Maybe<Scalars['Boolean']['output']>;
  payForMyself?: Maybe<Scalars['Boolean']['output']>;
  paymentCalculation?: Maybe<PaymentCalculation>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  paymentStatus: PaymentStatus;
  paymentTransactions?: Maybe<Array<PaymentTransaction>>;
  rankType?: Maybe<Scalars['String']['output']>;
  registrationRequest?: Maybe<Scalars['Float']['output']>;
  request?: Maybe<Scalars['String']['output']>;
  seed?: Maybe<Scalars['Float']['output']>;
  segment?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  stripePayments?: Maybe<Array<StripePayments>>;
  team?: Maybe<Team>;
  termsAndConditions?: Maybe<Scalars['Boolean']['output']>;
  totalRank?: Maybe<Scalars['Float']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentId?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  users?: Maybe<Array<TournamentTeamMember>>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
};

export type TournamentRegistrationParticipant = {
  __typename?: 'TournamentRegistrationParticipant';
  category?: Maybe<TournamentCategory>;
  club?: Maybe<Club>;
  registrationId: Scalars['Int']['output'];
  team?: Maybe<Team>;
  user: User;
  userTeamRole?: Maybe<Scalars['String']['output']>;
};

export type TournamentRegistrationPaymentDetails = {
  __typename?: 'TournamentRegistrationPaymentDetails';
  paymentHistory?: Maybe<Array<StripePayments>>;
  registration: TournamentRegistration;
  users?: Maybe<Array<TournamentTeamMember>>;
};

export type TournamentRegistrationQuestion = {
  __typename?: 'TournamentRegistrationQuestion';
  amount?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  fieldType?: Maybe<Scalars['String']['output']>;
  file?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  question?: Maybe<AdditionalQuestion>;
  registrationRequest?: Maybe<TournamentRegistration>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type TournamentScorerInvite = {
  __typename?: 'TournamentScorerInvite';
  createdAt: Scalars['DateTime']['output'];
  /** User-agent seen on most recent open (audit only, not enforced). */
  deviceUserAgent?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  expiresAt: Scalars['DateTime']['output'];
  firstOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['Int']['output'];
  issuedAt: Scalars['DateTime']['output'];
  issuedBy?: Maybe<User>;
  issuedById: Scalars['Int']['output'];
  /** JWT ID — embedded in the signed token. */
  jti: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTime']['output']>;
  revokedAt?: Maybe<Scalars['DateTime']['output']>;
  role: TournamentScorerInviteRole;
  tournament?: Maybe<Tournament>;
  tournamentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** SCORER = enters scores, final results go to organizer for approval. SCORER_ADMIN = can also publish final results directly. */
export enum TournamentScorerInviteRole {
  Scorer = 'SCORER',
  ScorerAdmin = 'SCORER_ADMIN'
}

export type TournamentTeamListInput = {
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  limit?: Scalars['Int']['input'];
  /** 0-based: page=0 returns rows 0..limit-1, page=1 returns rows limit..2*limit-1, etc. */
  page?: Scalars['Int']['input'];
  tournamentId: Scalars['Int']['input'];
};

export type TournamentTeamListResult = {
  __typename?: 'TournamentTeamListResult';
  teams: Array<Team>;
  total: Scalars['Int']['output'];
};

export type TournamentTeamMember = {
  __typename?: 'TournamentTeamMember';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  blitzElo?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<CategorySetting>>;
  categoryId?: Maybe<CategorySetting>;
  createdAt: Scalars['DateTime']['output'];
  duprRating?: Maybe<Scalars['Float']['output']>;
  fideTitle?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  inviteEmailSentByUsers?: Maybe<Array<Scalars['Float']['output']>>;
  isDelete?: Maybe<Scalars['Boolean']['output']>;
  leagueRanking?: Maybe<LeagueRanking>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  points?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  rapidElo?: Maybe<Scalars['String']['output']>;
  registrationRequest?: Maybe<TournamentRegistration>;
  standardElo?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  team?: Maybe<Team>;
  team1DrawMatch?: Maybe<DrawEntry>;
  team1GroupMatch?: Maybe<GroupMatch>;
  team1Match?: Maybe<Match>;
  team2DrawMatch?: Maybe<DrawEntry>;
  team2GroupMatch?: Maybe<GroupMatch>;
  team2Match?: Maybe<Match>;
  teamDrawMatchWinner?: Maybe<DrawEntry>;
  teamGroupMatchWinner?: Maybe<GroupMatch>;
  teamWinner?: Maybe<Match>;
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  withdrawReason?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
  wprCompetitionRatingConfidence?: Maybe<Scalars['String']['output']>;
  wprCompetitionRatingConfidenceLevel?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['String']['output']>;
  wprSocialRatingConfidence?: Maybe<Scalars['String']['output']>;
  wprSocialRatingConfidenceLevel?: Maybe<Scalars['String']['output']>;
};

export type TournamentTeamMembersResult = {
  __typename?: 'TournamentTeamMembersResult';
  total: Scalars['Int']['output'];
  tournamentTeamMembers: Array<TournamentTeamMember>;
};

/** Selected wording for the `tournament` term. */
export enum TournamentTerm {
  Event = 'EVENT',
  Race = 'RACE',
  Tournament = 'TOURNAMENT'
}

/** Tournament prestige / sanctioning tier */
export enum TournamentTier {
  International = 'INTERNATIONAL',
  Local = 'LOCAL',
  National = 'NATIONAL',
  NotSet = 'NOT_SET',
  Regional = 'REGIONAL'
}

export type TournamentVenue = {
  __typename?: 'TournamentVenue';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  /** Venue location coordinates with latitude and longitude */
  coordinates?: Maybe<Scalars['JSON']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  courts?: Maybe<Array<Court>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  matches?: Maybe<Array<Match>>;
  state?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  tournament?: Maybe<Tournament>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TournamentVenueListResult = {
  __typename?: 'TournamentVenueListResult';
  total: Scalars['Int']['output'];
  venues: Array<TournamentVenue>;
};

export type TournamentsListBlock = LandingBlock & {
  __typename?: 'TournamentsListBlock';
  id?: Maybe<Scalars['String']['output']>;
  title?: Maybe<LocalizedText>;
};

export type TournamentsResult = {
  __typename?: 'TournamentsResult';
  total: Scalars['Int']['output'];
  tournaments: Array<Tournament>;
};

export type TransactionHistory = {
  __typename?: 'TransactionHistory';
  amount: Scalars['Float']['output'];
  amountReceived?: Maybe<Scalars['Float']['output']>;
  athletes?: Maybe<Scalars['Float']['output']>;
  bankTransferDetails?: Maybe<Scalars['JSONObject']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deductedAmount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['Float']['output'];
  league?: Maybe<League>;
  license?: Maybe<License>;
  organization?: Maybe<Federation>;
  organizer?: Maybe<User>;
  paidAmount: Scalars['Float']['output'];
  paidForUsers?: Maybe<Array<User>>;
  partnerFee?: Maybe<Scalars['Float']['output']>;
  paymentIntent?: Maybe<PaymentIntent>;
  paymentIntentId?: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  platform?: Maybe<Platform>;
  processingFee?: Maybe<Scalars['Float']['output']>;
  productType: Scalars['String']['output'];
  proofFileUrl?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  tournamentRegistration?: Maybe<TournamentRegistration>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  transactionType: Scalars['String']['output'];
  user: User;
};

export type TransactionHistoryCount = {
  __typename?: 'TransactionHistoryCount';
  data: Array<TransactionHistory>;
  totalCount: Scalars['Int']['output'];
};

/** Possible types of transaction */
export enum TransactionType {
  BankTransfer = 'BANK_TRANSFER',
  Cash = 'CASH',
  Free = 'FREE',
  OnlineTransfer = 'ONLINE_TRANSFER'
}

export type TransferPayment = {
  __typename?: 'TransferPayment';
  amount?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentTransaction?: Maybe<PaymentTransaction>;
  platform?: Maybe<Platform>;
  status: Scalars['String']['output'];
  stripeDescription?: Maybe<Scalars['String']['output']>;
  stripeDestinationAccountId?: Maybe<Scalars['String']['output']>;
  stripePaymentId?: Maybe<Scalars['String']['output']>;
  stripeTransferId?: Maybe<Scalars['String']['output']>;
  tournament?: Maybe<Tournament>;
  transferType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UnderageWtnPlayer = {
  __typename?: 'UnderageWTNPlayer';
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  nationalId?: Maybe<Scalars['String']['output']>;
  nationalityCode?: Maybe<Scalars['String']['output']>;
  nativeFamilyName?: Maybe<Scalars['String']['output']>;
  nativeGivenName?: Maybe<Scalars['String']['output']>;
  sex?: Maybe<Scalars['String']['output']>;
  tournamentId: Scalars['Int']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UnderageWtnPlayerMatch = {
  __typename?: 'UnderageWTNPlayerMatch';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  matchId: Scalars['Int']['output'];
  matchStatus?: Maybe<Scalars['String']['output']>;
  playerId: Scalars['Int']['output'];
  playerPosition?: Maybe<Scalars['Int']['output']>;
  providerMatchId?: Maybe<Scalars['String']['output']>;
  providerTournamentId?: Maybe<Scalars['String']['output']>;
  scoreString?: Maybe<Scalars['String']['output']>;
  side?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  tournamentEnd?: Maybe<Scalars['DateTime']['output']>;
  tournamentId: Scalars['Int']['output'];
  tournamentStart?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  winningSide?: Maybe<Scalars['String']['output']>;
};

export type UnlinkSocialAuthResult = {
  __typename?: 'UnlinkSocialAuthResult';
  remaining: MySignInMethodsResult;
  success: Scalars['Boolean']['output'];
};

export type UpdateAdditionalQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  askEachAthlete?: InputMaybe<Scalars['Boolean']['input']>;
  askOnlyOnce?: InputMaybe<Scalars['Boolean']['input']>;
  fieldOptions?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isHide?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateAlbumInput = {
  albumCustomEvent?: InputMaybe<Scalars['String']['input']>;
  albumTags?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  isAlbumPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['Upload']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAnnouncementCommentInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateAthleteInput = {
  athlete?: InputMaybe<Scalars['Int']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuthMethodInput = {
  id: Scalars['Int']['input'];
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<AuthMethodName>;
};

export type UpdateBannerInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  imageURLs?: InputMaybe<Array<Scalars['String']['input']>>;
  images?: InputMaybe<Array<Scalars['Upload']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBannerInputNew = {
  buttonLink?: InputMaybe<Scalars['String']['input']>;
  buttonText?: InputMaybe<Scalars['String']['input']>;
  headLine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<BannerRole>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<BannerStatus>;
  subHeadLine?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBulkBannerInputNew = {
  banners: Array<UpdateBannerInputNew>;
};

export type UpdateBulkBannerLegacyInput = {
  banners: Array<BulkBannerUpdateLegacyItem>;
};

export type UpdateBulkPartnerNewInput = {
  partners: Array<UpdatePartnerNewInput>;
};

export type UpdateBulkPlatformDocumentsInput = {
  platformDocuments: Array<UpdatePlatformDocumentInput>;
};

export type UpdateCategoryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Float']['input']>;
  ageLimitType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  countAllTournament?: InputMaybe<Scalars['Boolean']['input']>;
  countries?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  fixedPoints?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamRanking?: InputMaybe<Scalars['Boolean']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  licenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxTournaments?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onlyThirdPartyRanking?: InputMaybe<Scalars['Boolean']['input']>;
  penalty?: InputMaybe<Scalars['Boolean']['input']>;
  penaltyRule?: InputMaybe<Scalars['String']['input']>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  selectStage?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  specificTournament?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  timePeriod?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournaments?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  uniqueCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryRuleInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  enableMaxPointTotal?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  licenseSubtypes?: InputMaybe<Scalars['String']['input']>;
  maxPointTotal?: InputMaybe<Scalars['Int']['input']>;
  numberOfTournaments?: InputMaybe<Scalars['Int']['input']>;
  placeMultipliers?: InputMaybe<Array<PlaceMultiplierInput>>;
  sector?: InputMaybe<Scalars['String']['input']>;
  subRuleCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCategorySettingInput = {
  addMatchWonPoints?: InputMaybe<Scalars['Int']['input']>;
  addPointsScore?: InputMaybe<Scalars['Int']['input']>;
  addSetWonPoints?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['Int']['input']>;
  categorySettingId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  considerOnlyPaidRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  considerRequestsInLimits?: InputMaybe<Scalars['Boolean']['input']>;
  consolation?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  extraTime?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isAllowPlayerScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowRosterSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isPlayerScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isRosterAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreAutoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  isVATAmount?: InputMaybe<Scalars['Boolean']['input']>;
  mde?: InputMaybe<Scalars['Int']['input']>;
  mds?: InputMaybe<Scalars['Int']['input']>;
  mdwc?: InputMaybe<Scalars['Int']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  moveToSingle?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['String']['input']>;
  onsiteFee?: InputMaybe<Scalars['Int']['input']>;
  pairing?: InputMaybe<Scalars['String']['input']>;
  penaltyPoints?: InputMaybe<Scalars['Int']['input']>;
  pointsForLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsForTie?: InputMaybe<Scalars['Int']['input']>;
  pointsForWin?: InputMaybe<Scalars['Int']['input']>;
  qe?: InputMaybe<Scalars['Int']['input']>;
  qs?: InputMaybe<Scalars['Int']['input']>;
  qwc?: InputMaybe<Scalars['Int']['input']>;
  registrationLimit?: InputMaybe<Scalars['Int']['input']>;
  registrationStatus?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  service?: InputMaybe<Scalars['Int']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['Int']['input']>;
  timeAfterMove?: InputMaybe<Scalars['Int']['input']>;
  timePerMove?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  vatAmount?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateCategorySettingsGroupInput = {
  categorySetting?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCategoryTournamentInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClubAdministratorInput = {
  administrator?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateClubCoachInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  coach?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateClubInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubAdministrators?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubCoaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubMainAdministrator?: InputMaybe<Scalars['Int']['input']>;
  clubName?: InputMaybe<Scalars['String']['input']>;
  clubServices?: InputMaybe<Array<Scalars['Int']['input']>>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (fed_...) — alternative to numeric id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Monolith_ClubType>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubMemberInput = {
  approvedAt?: InputMaybe<Scalars['DateTime']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubNewsInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateClubServiceResourceInput = {
  ClubService?: InputMaybe<Scalars['Int']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  services?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClubsServiceInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  clubServiceResource?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  services?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCourtInput = {
  allowAttachingMediaContent?: InputMaybe<Scalars['Boolean']['input']>;
  allowParticipantsToAddResults?: InputMaybe<Scalars['Boolean']['input']>;
  attachmentsStatus?: InputMaybe<Scalars['String']['input']>;
  autoConfirmSubmittedResults?: InputMaybe<Scalars['Boolean']['input']>;
  bestResultsLimit?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  generalLimit?: InputMaybe<Scalars['Int']['input']>;
  hideOtherParticipantResults?: InputMaybe<Scalars['Boolean']['input']>;
  hideResultsType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  individualMetricLimit?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreamingLink?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requiredMediaToUploadResult?: InputMaybe<Scalars['Boolean']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submissionType?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  venue?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDefaultTeamMatchInput = {
  category?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisciplineInput = {
  disciplines?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  resultType?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDisplaySettingInput = {
  id: Scalars['Int']['input'];
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawEntryInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  looserId?: InputMaybe<Scalars['Int']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  qualWinner?: InputMaybe<Scalars['Boolean']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  consolationDrawEntries?: InputMaybe<Scalars['String']['input']>;
  consolationMainDraw?: InputMaybe<Scalars['Int']['input']>;
  drawEntries?: InputMaybe<Array<Scalars['Int']['input']>>;
  drawImage?: InputMaybe<Scalars['Upload']['input']>;
  endLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  entriesPosition?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  finalDraws?: InputMaybe<Scalars['Boolean']['input']>;
  genDraw?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  is24DoubleEliminator?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayParticipantsClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDistributeClubMembers?: InputMaybe<Scalars['Boolean']['input']>;
  isFirstMatchLosersToConsolationDraw?: InputMaybe<Scalars['Boolean']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  mainDraw?: InputMaybe<Scalars['Int']['input']>;
  numberOfEntries?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  qualWinners?: InputMaybe<Scalars['Int']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  startLiveStandings?: InputMaybe<Scalars['Int']['input']>;
  thirdPlaceDraw?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDrawScoreInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateFactSheetInput = {
  factSheets?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fieldTitle?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFederationLeagueInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFederationNewsInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  news?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateFormatBlockInput = {
  isAllowScoreSubmission?: InputMaybe<Scalars['Boolean']['input']>;
  isVisible?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalRounds?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupEntryInput = {
  external_id?: InputMaybe<Scalars['Float']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  place?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateGroupInput = {
  algoType?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  displayMatches?: InputMaybe<Scalars['Boolean']['input']>;
  displayPlayOrder?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groupId?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  naming?: InputMaybe<Scalars['String']['input']>;
  participantsAddScore?: InputMaybe<Scalars['Boolean']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  seeds?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  totalGroups?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupMatchInput = {
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  round?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['Int']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  tempScore?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateImageInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateLandingInput = {
  id: Scalars['Int']['input'];
  landingAbbr?: InputMaybe<Scalars['String']['input']>;
  landingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  landingCountry?: InputMaybe<Scalars['String']['input']>;
  landingCustomPlatform?: InputMaybe<Scalars['String']['input']>;
  landingHeadline?: InputMaybe<Scalars['String']['input']>;
  landingHeroLayout?: InputMaybe<Scalars['String']['input']>;
  landingLang?: InputMaybe<Scalars['String']['input']>;
  landingLayout?: InputMaybe<Scalars['String']['input']>;
  landingLocations?: InputMaybe<Scalars['String']['input']>;
  landingLogo?: InputMaybe<Scalars['String']['input']>;
  landingLogoDark?: InputMaybe<Scalars['String']['input']>;
  landingOrganizations?: InputMaybe<Scalars['String']['input']>;
  landingPrimary?: InputMaybe<Scalars['String']['input']>;
  landingPrimaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSecondaryColor?: InputMaybe<Scalars['String']['input']>;
  landingSubtitle?: InputMaybe<Scalars['String']['input']>;
  landingSupportedSports?: InputMaybe<Scalars['String']['input']>;
  landingTeamPages?: InputMaybe<Scalars['String']['input']>;
  landingTitle?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLandingMemberInput = {
  avatar?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  highlight?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  lang?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  show_on_pages?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  user_id?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLandingPotmInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  fullname?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  last_updated?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  picture?: InputMaybe<Scalars['String']['input']>;
  placement?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingRoadmapInput = {
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  item1?: InputMaybe<Scalars['String']['input']>;
  item2?: InputMaybe<Scalars['String']['input']>;
  item3?: InputMaybe<Scalars['String']['input']>;
  item4?: InputMaybe<Scalars['String']['input']>;
  item5?: InputMaybe<Scalars['String']['input']>;
  item6?: InputMaybe<Scalars['String']['input']>;
  item7?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  thumbnail?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandingSliderInput = {
  button?: InputMaybe<Scalars['String']['input']>;
  date_added?: InputMaybe<Scalars['String']['input']>;
  date_from?: InputMaybe<Scalars['String']['input']>;
  date_to?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platform_code?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  sorting?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLeagueCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isLeaguePage?: InputMaybe<Scalars['Boolean']['input']>;
  isRankings?: InputMaybe<Scalars['Boolean']['input']>;
  isTournamentCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueDocuments?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  allowUnregisteredPlayers?: InputMaybe<Scalars['Boolean']['input']>;
  bannerCover?: InputMaybe<Scalars['Upload']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  country_full_name?: InputMaybe<Scalars['String']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  factSheet?: InputMaybe<Array<Scalars['Int']['input']>>;
  federation?: InputMaybe<Scalars['Float']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric federation id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  globalCategoryLimitPerPlayer?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  instagram?: InputMaybe<Scalars['String']['input']>;
  isCustomFeeEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  leagueCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  license?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  members?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['Float']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  requireTournamentApproval?: InputMaybe<Scalars['Boolean']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
  socialLinks?: InputMaybe<Array<LeagueSocialLinkInput>>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tourType?: InputMaybe<TourType>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<LeagueGeoScope>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeagueMemberInput = {
  displayMember?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  member?: InputMaybe<Scalars['Int']['input']>;
  organizationEmail?: InputMaybe<Scalars['String']['input']>;
  organizationLogo?: InputMaybe<Scalars['Upload']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  organizationPhone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateLeagueMemberRoleInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  leagueMember?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueNewsInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  news?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueRankingInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rankingCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyPoints?: InputMaybe<Scalars['String']['input']>;
  tournaments?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueTournamentCategoryInput = {
  category?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLeagueTournamentInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLicenseInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  alternateTitle?: InputMaybe<Scalars['String']['input']>;
  billingCountry?: InputMaybe<Scalars['String']['input']>;
  cascadeLeagueDetach?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  englishTitle?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  fee?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isAllowedToPurchaseOnTournated?: InputMaybe<Scalars['Boolean']['input']>;
  isApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isAutoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isPlatformGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  isSendNotificationsToManager?: InputMaybe<Scalars['Boolean']['input']>;
  leagues?: InputMaybe<Array<Scalars['Int']['input']>>;
  licenseManager?: InputMaybe<Scalars['Int']['input']>;
  /** Optional override address for manager notifications. When set, EMAIL-channel notifications for this license route here instead of the license manager's account email. */
  managerContactEmail?: InputMaybe<Scalars['String']['input']>;
  nationality?: InputMaybe<Scalars['String']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLicenseLeagueInput = {
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLicenseQuestionInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  fileType?: InputMaybe<Scalars['String']['input']>;
  fileUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
  question?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLiveStandingInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  highlightFrom?: InputMaybe<Scalars['Float']['input']>;
  highlightTo?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  isDisplayPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayTeam?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLiveStandingsEntryInput = {
  entry?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupPlace?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  losingPoints?: InputMaybe<Scalars['Int']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  matchesPlayed?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerEntry?: InputMaybe<Scalars['Int']['input']>;
  pointDifference?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  pointsRatio?: InputMaybe<Scalars['Int']['input']>;
  setRatio?: InputMaybe<Scalars['Int']['input']>;
  setsLost?: InputMaybe<Scalars['Int']['input']>;
  setsWon?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  winningPoints?: InputMaybe<Scalars['Int']['input']>;
  wins?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateLiveStreamingInput = {
  companyKey?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  creationDate?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  externalEventID?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  location?: InputMaybe<LocationInput>;
  match?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  placeKey?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  thumbnailURL?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<StreamingPlatform>;
};

export type UpdateMatchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  adjustedScore?: InputMaybe<Scalars['String']['input']>;
  bracketType?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  conflict?: InputMaybe<Scalars['Boolean']['input']>;
  court?: InputMaybe<Scalars['Int']['input']>;
  courts?: InputMaybe<Array<Scalars['Int']['input']>>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  dateBackup?: InputMaybe<Scalars['String']['input']>;
  dateRangeMatchStatus?: InputMaybe<DateRangeMatchStatus>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  drawEntry1?: InputMaybe<Scalars['Int']['input']>;
  drawEntry2?: InputMaybe<Scalars['Int']['input']>;
  drawWinner?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1group?: InputMaybe<Scalars['String']['input']>;
  entry1groupId?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry1pig?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2group?: InputMaybe<Scalars['String']['input']>;
  entry2groupId?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  entry2pig?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  firstScoreSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  formatRound?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  groupEntry1?: InputMaybe<Scalars['Int']['input']>;
  groupEntry2?: InputMaybe<Scalars['Int']['input']>;
  groupWinner?: InputMaybe<Scalars['Int']['input']>;
  groupWinnerPartner?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isBye?: InputMaybe<Scalars['Boolean']['input']>;
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  isDoubleRoundRobin?: InputMaybe<Scalars['Boolean']['input']>;
  isEqualCourts?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  isMatchTie?: InputMaybe<Scalars['Boolean']['input']>;
  isScoreConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
  looserId?: InputMaybe<Scalars['Int']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchFor?: InputMaybe<Scalars['String']['input']>;
  matchIndex?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  matchType?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  nextSeedId?: InputMaybe<Scalars['Int']['input']>;
  nextTeam?: InputMaybe<Scalars['String']['input']>;
  notifyCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  notifyNext?: InputMaybe<Scalars['Boolean']['input']>;
  oldId?: InputMaybe<Scalars['Int']['input']>;
  oopRounds?: InputMaybe<Array<Scalars['Int']['input']>>;
  oopType?: InputMaybe<MatchOopType>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  pointsLoss?: InputMaybe<Scalars['Int']['input']>;
  pointsWon?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  qualWinner?: InputMaybe<Scalars['Boolean']['input']>;
  round?: InputMaybe<Scalars['String']['input']>;
  roundNumber?: InputMaybe<Scalars['Int']['input']>;
  rounds?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreActions?: InputMaybe<Array<MatchScoreActionInput>>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tokenExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  venues?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekNumber?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchProgressionInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<EntryType>;
  id: Scalars['Int']['input'];
  isByePossible?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  nextMatch?: InputMaybe<Scalars['Int']['input']>;
  previousMatch?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<MatchProgressionType>;
};

export type UpdateMatchScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  mainMatch?: InputMaybe<Scalars['Int']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team1Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  team2Entry?: InputMaybe<Array<Scalars['Int']['input']>>;
  teamMatchType?: InputMaybe<Scalars['String']['input']>;
  teamScore?: InputMaybe<Scalars['String']['input']>;
  teamWinner?: InputMaybe<Array<Scalars['Int']['input']>>;
  time?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchesEntryInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  entryType?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  formatBlock?: InputMaybe<Scalars['Int']['input']>;
  group?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  initialSeed?: InputMaybe<Scalars['Int']['input']>;
  isFormedPair?: InputMaybe<Scalars['Boolean']['input']>;
  pairingMode?: InputMaybe<Scalars['String']['input']>;
  partnerRegistration?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromPartner?: InputMaybe<Scalars['Int']['input']>;
  playerIndexFromRegistration?: InputMaybe<Scalars['Int']['input']>;
  pointDifference?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['Int']['input']>>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMatchesScoreInput = {
  courts?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry1partner?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  entry2partner?: InputMaybe<Scalars['Int']['input']>;
  groupEntry?: InputMaybe<Scalars['Int']['input']>;
  groupEntryPartner?: InputMaybe<Scalars['Int']['input']>;
  hideInOOP?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isMatchInProgress?: InputMaybe<Scalars['Boolean']['input']>;
  match?: InputMaybe<Scalars['Int']['input']>;
  matchStatus?: InputMaybe<Scalars['String']['input']>;
  round?: InputMaybe<Scalars['Float']['input']>;
  roundFormat?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  scoreType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  winner?: InputMaybe<Scalars['Int']['input']>;
  winnerPartner?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMediaInput = {
  album?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  photoCaption?: InputMaybe<Scalars['String']['input']>;
  photoLink?: InputMaybe<Scalars['Upload']['input']>;
  sort?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateNewsInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  clubNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  federationNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayLanding?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  leagueNews?: InputMaybe<Array<Scalars['Int']['input']>>;
  metaDesc?: InputMaybe<Scalars['String']['input']>;
  metaTags?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  postCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
  postText?: InputMaybe<Scalars['String']['input']>;
  ptiority?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sport?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  youtubeVideoLink?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOnboardingInput = {
  /** Example field (placeholder) */
  exampleField?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

export type UpdateOrganizationPlatformInput = {
  federation?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOrganizationPlatformMemberInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePairingEntryInput = {
  entry1?: InputMaybe<Scalars['Int']['input']>;
  entry2?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  pairing?: InputMaybe<Scalars['Int']['input']>;
  score?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePairingInput = {
  algo?: InputMaybe<Scalars['String']['input']>;
  hide?: InputMaybe<Scalars['Boolean']['input']>;
  hideStandings?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  removeDrawId?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  partners?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerNewInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Opaque public id (fed_...) — alternative to numeric federation id */
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  imageFileId?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerSearchInput = {
  acceptUrl?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  declineUrl?: InputMaybe<Scalars['String']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  partner?: InputMaybe<Scalars['Int']['input']>;
  partnerInformation?: InputMaybe<Scalars['String']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  selfInformation?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlanInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  monthlyDiscount?: InputMaybe<Scalars['String']['input']>;
  planType?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearlyDiscount?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlateformSportInput = {
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePlatformCoachInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  displayOnLandingPage?: InputMaybe<Scalars['Boolean']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformDocumentInput = {
  displayOn?: InputMaybe<Array<PlatformDocumentDisplayOn>>;
  documentFileId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sortingPositions?: InputMaybe<Array<PlatformDocumentSortingPositionInput>>;
};

export type UpdatePlatformFeeInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  feeMode?: InputMaybe<FeeMode>;
  feeType?: InputMaybe<FeeType>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMonetization?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (lge_...) — alternative to numeric league id */
  leaguePublicId?: InputMaybe<Scalars['String']['input']>;
  organizationPlatform?: InputMaybe<Scalars['Int']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMaxPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinFee?: InputMaybe<Scalars['Float']['input']>;
  partnerMinPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  rangeEnd?: InputMaybe<Scalars['Float']['input']>;
  rangeStart?: InputMaybe<Scalars['Float']['input']>;
  serviceType?: InputMaybe<ServiceType>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMaxPercentageFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedMinPercentageFee?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdatePlatformInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  alreadyDomain?: InputMaybe<Scalars['Boolean']['input']>;
  authMethods?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyEmail?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyPhone?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  darkEmblem?: InputMaybe<Scalars['Upload']['input']>;
  darkLogo?: InputMaybe<Scalars['Upload']['input']>;
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  description?: InputMaybe<Scalars['String']['input']>;
  disciplines?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Root-level documents. Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  documents?: InputMaybe<Array<DocumentInput>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Int']['input']>;
  favicon?: InputMaybe<Scalars['Upload']['input']>;
  /** Document folders (with nested documents). Sending either "documents" or "folders" replaces ALL existing documents AND folders of the platform (all-or-nothing). Omit both fields to leave them untouched. */
  folders?: InputMaybe<Array<DocumentFolderInput>>;
  fullAddress?: InputMaybe<Scalars['String']['input']>;
  graphicsForSmm?: InputMaybe<Scalars['Boolean']['input']>;
  groupedPlatformIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasOwnApp?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  isEnableMaintenance?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePrice?: InputMaybe<Scalars['Boolean']['input']>;
  isMobileAppSupported?: InputMaybe<Scalars['Boolean']['input']>;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  isVatFeeApplicable?: InputMaybe<Scalars['Boolean']['input']>;
  landingLink?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  licenseMemberships?: InputMaybe<Scalars['Boolean']['input']>;
  lightEmblem?: InputMaybe<Scalars['Upload']['input']>;
  lightLogo?: InputMaybe<Scalars['Upload']['input']>;
  liveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming?: InputMaybe<Scalars['Boolean']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  maintenanceDescription?: InputMaybe<Scalars['String']['input']>;
  maintenanceTitle?: InputMaybe<Scalars['String']['input']>;
  mobileApp?: InputMaybe<Scalars['Boolean']['input']>;
  navigation?: InputMaybe<Array<Scalars['JSON']['input']>>;
  needIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  needLanding?: InputMaybe<Scalars['Boolean']['input']>;
  onlineBookingCourts?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayment?: InputMaybe<Scalars['Boolean']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  ownAppLinks?: InputMaybe<OwnAppLinksInput>;
  owner?: InputMaybe<Scalars['Int']['input']>;
  partnerEntryFee?: InputMaybe<Scalars['Float']['input']>;
  partnerLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  passcode?: InputMaybe<Scalars['String']['input']>;
  platformLink?: InputMaybe<Scalars['String']['input']>;
  platformType?: InputMaybe<Scalars['String']['input']>;
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  promoteTournatedApp?: InputMaybe<Scalars['Boolean']['input']>;
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  secondaryColor?: InputMaybe<Scalars['String']['input']>;
  sendGridEmail?: InputMaybe<Scalars['String']['input']>;
  sendGridName?: InputMaybe<Scalars['String']['input']>;
  serviceProvider?: InputMaybe<Scalars['String']['input']>;
  signeeFullName?: InputMaybe<Scalars['String']['input']>;
  signeeRole?: InputMaybe<Scalars['String']['input']>;
  smm?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
  stripeAccountId?: InputMaybe<Scalars['String']['input']>;
  subDomain?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<Scalars['Int']['input']>;
  thirdPartyLicenses?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournatedEntryFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  tournatedLicenseFee?: InputMaybe<Scalars['Float']['input']>;
  uploadFile?: InputMaybe<Scalars['Upload']['input']>;
  vatFee?: InputMaybe<Scalars['Float']['input']>;
  yourRequest?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePlatformPageInput = {
  blocks?: InputMaybe<Array<Scalars['JSON']['input']>>;
  id: Scalars['Int']['input'];
  platform?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<PageSlug>;
};

export type UpdatePlatformSettingInput = {
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isEmailDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  mapProvider?: InputMaybe<MapProvider>;
  notificationFromEmail?: InputMaybe<Scalars['String']['input']>;
  paymentProvider?: InputMaybe<PaymentProvider>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  replaceDefaultBrandName?: InputMaybe<Scalars['Boolean']['input']>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
};

export type UpdatePostCategoryInput = {
  id: Scalars['Int']['input'];
  /** Category name */
  name?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  /** Opaque public id (plt_...) — alternative to numeric platform id */
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  /** Category slug */
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePostInput = {
  authorId?: InputMaybe<Scalars['Int']['input']>;
  /** Block payloads. Each must include a `__typename` matching one of the PostBlock variants. */
  blocks?: InputMaybe<Array<Scalars['JSON']['input']>>;
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  clubIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  coverImage?: InputMaybe<Scalars['String']['input']>;
  excerpt?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  /** BCP-47 code; combined with slug for uniqueness. */
  language?: InputMaybe<Scalars['String']['input']>;
  leagueIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Manually-added entity mentions. Merged with auto-extracted URL mentions, deduped on (type, entityId). */
  manualMentions?: InputMaybe<Array<PostMentionInput>>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  ogImage?: InputMaybe<Scalars['String']['input']>;
  /** Federations. */
  organizerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  /** When PUBLISHED. Defaults to now() on first publish if omitted. */
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PostStatus>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournamentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdatePurchasedLicenseInput = {
  addedBy?: InputMaybe<Scalars['Int']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  approvalStatus?: InputMaybe<ApprovalStatus>;
  basePrice?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  currentApprovalStatus?: InputMaybe<ApprovalStatus>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  noOfLicense?: InputMaybe<Scalars['Float']['input']>;
  paid?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentIntentId?: InputMaybe<Scalars['String']['input']>;
  payment_status?: InputMaybe<LicensePaymentStatus>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  proofFileUrl?: InputMaybe<Scalars['String']['input']>;
  proofUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  stripeFee?: InputMaybe<Scalars['Float']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  userData?: InputMaybe<CreateUserInput>;
};

export type UpdateRankingCategoryPointInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  bracketTypes?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  numPlaces?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  rankingCategoryPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  segment?: InputMaybe<Scalars['String']['input']>;
  segments?: InputMaybe<Array<Scalars['String']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRankingCategoryPointTypeInput = {
  bracketType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  rankingCategoryPoint?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRankingPointCategoryInput = {
  id: Scalars['Int']['input'];
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateRankingPointInput = {
  entries?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  rankingPoints?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  rules?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategory?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateRankingPointRuleInput = {
  coefficient?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  numberOfEntries?: InputMaybe<Scalars['String']['input']>;
  numberOfPlayers?: InputMaybe<Scalars['String']['input']>;
  operator?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  sector?: InputMaybe<Scalars['String']['input']>;
  skillLevel?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRankingTournamentCategoryInput = {
  id: Scalars['Int']['input'];
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateResourceServiceInput = {
  id: Scalars['Int']['input'];
  service?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoleInput = {
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRoundInput = {
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  matches?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSponsorInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  ageRestriction?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['Int']['input']>;
  federation?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  licenseRequired?: InputMaybe<Scalars['Boolean']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sponsorText?: InputMaybe<Scalars['String']['input']>;
  sponsors?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentsSum?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingEntriesMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  confirmedBy?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  existingMedia?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metricContext?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rejectedAt?: InputMaybe<Scalars['DateTime']['input']>;
  rejectedBy?: InputMaybe<Scalars['Int']['input']>;
  result_entered?: InputMaybe<Scalars['String']['input']>;
  sportFishingMatric?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResultEntry?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  submittedBy?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingMatricInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  disableResultSubmissionByParticipant?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  media?: InputMaybe<Scalars['Upload']['input']>;
  metrics?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stages?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportFishingResultEntryInput = {
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  confirmAutomatically?: InputMaybe<Scalars['Boolean']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  metric?: InputMaybe<Scalars['Float']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<Scalars['Float']['input']>;
  sorting?: InputMaybe<Scalars['String']['input']>;
  sportFishingResult?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSportFishingResultInput = {
  ResultEntry?: InputMaybe<Scalars['Int']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  place?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSportInput = {
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  displayDraws?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroups?: InputMaybe<Scalars['Boolean']['input']>;
  displayListResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayLiveStandings?: InputMaybe<Scalars['Boolean']['input']>;
  displayOrderPlay?: InputMaybe<Scalars['Boolean']['input']>;
  displayPendingResults?: InputMaybe<Scalars['Boolean']['input']>;
  displayTournamentResults?: InputMaybe<Scalars['Boolean']['input']>;
  enableCourts?: InputMaybe<Scalars['Boolean']['input']>;
  enableDiscipline?: InputMaybe<Scalars['Boolean']['input']>;
  enableStages?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['Upload']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  image?: InputMaybe<Scalars['Upload']['input']>;
  isDisplayAthleteChessTitle?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySegments?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairingStandings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnablePairings?: InputMaybe<Scalars['Boolean']['input']>;
  isEnableRounds?: InputMaybe<Scalars['Boolean']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  sportType?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  textBox?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSubscriptionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  paymentMethod?: InputMaybe<Payment_Method>;
  paymentStatus?: InputMaybe<Payment_Status>;
  plan?: InputMaybe<Scalars['String']['input']>;
  planName?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  validFrom?: InputMaybe<Scalars['DateTime']['input']>;
  validTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTeamMemberInput = {
  id: Scalars['Int']['input'];
  importBy?: InputMaybe<Scalars['Int']['input']>;
  member?: InputMaybe<Scalars['Int']['input']>;
  memberNr?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTemplateInput = {
  id: Scalars['Int']['input'];
  template?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateThirdPartyLicenseInput = {
  endPointLink?: InputMaybe<Scalars['String']['input']>;
  field?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isMakeLicenceMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserProfile?: InputMaybe<Scalars['Boolean']['input']>;
  isRequiredInUserRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  organizationAbbreviation?: InputMaybe<Scalars['String']['input']>;
  organizationName?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentAdditionalRefereeInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentAnnouncementInput = {
  author?: InputMaybe<Scalars['Int']['input']>;
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  emailNotification?: InputMaybe<Scalars['Boolean']['input']>;
  existingMedia?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['Int']['input'];
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Array<Scalars['Upload']['input']>>;
  pushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  viewUrl?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentCategoryGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateTournamentCategoryInput = {
  ageFrom?: InputMaybe<Scalars['Int']['input']>;
  ageFromType?: InputMaybe<Scalars['String']['input']>;
  ageGroup?: InputMaybe<Scalars['String']['input']>;
  ageLimit?: InputMaybe<Scalars['Int']['input']>;
  ageTo?: InputMaybe<Scalars['Int']['input']>;
  ageToType?: InputMaybe<Scalars['String']['input']>;
  ageType?: InputMaybe<Scalars['String']['input']>;
  askSkillLevel?: InputMaybe<Scalars['Boolean']['input']>;
  captainRequired?: InputMaybe<Scalars['Boolean']['input']>;
  categoryEntries?: InputMaybe<Scalars['String']['input']>;
  categoryMen?: InputMaybe<Scalars['Float']['input']>;
  categoryMenId?: InputMaybe<Scalars['Float']['input']>;
  categoryWomen?: InputMaybe<Scalars['Float']['input']>;
  categoryWomenId?: InputMaybe<Scalars['Float']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  clubChampionship?: InputMaybe<Scalars['Boolean']['input']>;
  clubs?: InputMaybe<Array<Scalars['Int']['input']>>;
  countIndividualTotal?: InputMaybe<Scalars['Boolean']['input']>;
  countPointOnMatchResult?: InputMaybe<Scalars['Boolean']['input']>;
  countTeamTotal?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  discipline?: InputMaybe<Scalars['Int']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableMetrics?: InputMaybe<Scalars['Boolean']['input']>;
  externalLicense_RequiredMatchMode?: InputMaybe<RequiredLicenseMatchMode>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  identifyTeamMember?: InputMaybe<Scalars['Boolean']['input']>;
  isAdvancedTeamEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isClubRegistrationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isClubSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayBirthYear?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayCity?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayClub?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayPoints?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplayRank?: InputMaybe<Scalars['Boolean']['input']>;
  isDisplaySeeds?: InputMaybe<Scalars['Boolean']['input']>;
  isMixedDoubles?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationWithoutPartnerCount?: InputMaybe<Scalars['Boolean']['input']>;
  isSpecificClubRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelection?: InputMaybe<Scalars['Boolean']['input']>;
  isTeamSelectionMendatory?: InputMaybe<Scalars['Boolean']['input']>;
  isTieBreakEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isU10Required?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartnerAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  license?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  maxCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  maxDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  maxMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  maxMembers?: InputMaybe<Scalars['Int']['input']>;
  maxPoints?: InputMaybe<Scalars['Int']['input']>;
  maxReservists?: InputMaybe<Scalars['Int']['input']>;
  minAthletesToCount?: InputMaybe<Scalars['Int']['input']>;
  minCPCPoints?: InputMaybe<Scalars['Float']['input']>;
  minDUPRSkillLevel?: InputMaybe<Scalars['Float']['input']>;
  minMaxwillPoints?: InputMaybe<Scalars['Float']['input']>;
  minMembers?: InputMaybe<Scalars['Int']['input']>;
  minReservists?: InputMaybe<Scalars['Int']['input']>;
  moveToSingles?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nationalTournament?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  requiredUSPALicenses?: InputMaybe<Array<Scalars['String']['input']>>;
  reservistsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  singleCategory?: InputMaybe<Scalars['Int']['input']>;
  skillLevel?: InputMaybe<SkillLevel>;
  skills?: InputMaybe<Scalars['String']['input']>;
  skillsLevel?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Sort_By>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortingPosition?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  thirdPartyLicense?: InputMaybe<Scalars['Int']['input']>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  tournamentCategories?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroups?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  wprMaxCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprMinCompetitionRating?: InputMaybe<Scalars['Float']['input']>;
  wprRatingType?: InputMaybe<Wpr_Rating_Type>;
  wprRequiredStatusRating?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentCategoryLicenseInput = {
  id: Scalars['Int']['input'];
  license?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentDiscountInput = {
  categories?: InputMaybe<Array<Scalars['Int']['input']>>;
  categoryDiscounts?: InputMaybe<Array<Scalars['JSON']['input']>>;
  discount?: InputMaybe<Scalars['Float']['input']>;
  discountCap?: InputMaybe<Scalars['Float']['input']>;
  discountExpireTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountPer?: InputMaybe<Scalars['Float']['input']>;
  discountStartTime?: InputMaybe<Scalars['DateTime']['input']>;
  discountType?: InputMaybe<DiscountType>;
  id: Scalars['Int']['input'];
  isLimitCount?: InputMaybe<Scalars['Boolean']['input']>;
  isVTRD?: InputMaybe<Scalars['Boolean']['input']>;
  licences?: InputMaybe<Array<Scalars['Int']['input']>>;
  numberOfCategories?: InputMaybe<Scalars['Int']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  totalCounts?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  usedCounts?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentDocumentInput = {
  document?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentFactSheetInput = {
  answer?: InputMaybe<Scalars['String']['input']>;
  factSheet?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentInput = {
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalQuestion2?: InputMaybe<Scalars['String']['input']>;
  additionalReferee?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Scalars['String']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
  approvalStatus?: InputMaybe<Scalars['String']['input']>;
  approvedEntries?: InputMaybe<Scalars['Boolean']['input']>;
  approvedOrRejectedBy?: InputMaybe<Scalars['Float']['input']>;
  autoConfirmEntries?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  closeRegistration?: InputMaybe<Scalars['Boolean']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  competitionLevel?: InputMaybe<CompetitionLevel>;
  competitionType?: InputMaybe<CompetitionType>;
  contactUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  coverPhoto?: InputMaybe<Scalars['Upload']['input']>;
  createdBy?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Optional custom URL used in place of the default hotel booking link shown near the tournament location */
  customHotelsLink?: InputMaybe<Scalars['String']['input']>;
  customInfoMessage?: InputMaybe<Scalars['String']['input']>;
  customMatricesType?: InputMaybe<Array<CustomMatricesType>>;
  customSuccessMessage?: InputMaybe<Scalars['String']['input']>;
  datesToHide?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  discounts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  drawType?: InputMaybe<Array<DrawType>>;
  enableLiveScoring?: InputMaybe<Scalars['Boolean']['input']>;
  enableLiveStream?: InputMaybe<Scalars['Boolean']['input']>;
  enablePracticeCourtsBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enableTransferBooking?: InputMaybe<Scalars['Boolean']['input']>;
  enabledPushNotification?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  endTime?: InputMaybe<Scalars['DateTime']['input']>;
  entryDeadline?: InputMaybe<Scalars['DateTime']['input']>;
  entryFee?: InputMaybe<Scalars['String']['input']>;
  events?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facts?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  fideRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<Array<GroupType>>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isCPCRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isCustomMatricesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDrawsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRatingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isDuprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  isGroupsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isHideEntries?: InputMaybe<Scalars['Boolean']['input']>;
  isHideFromCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  isListAndResultEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPartnerFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingPlatformFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingStripeFee?: InputMaybe<Scalars['Boolean']['input']>;
  isManagerPayingTournatedFee?: InputMaybe<Scalars['Boolean']['input']>;
  isMaxwillRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isOrganizerRegEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPairingsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPayForMyselfEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  isRegistrationEmailsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprEntriesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isWprRequired?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Float']['input']>;
  leagueType?: InputMaybe<LeagueType>;
  license?: InputMaybe<Scalars['String']['input']>;
  listAndResultShowIndividualTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowPointsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultShowTeamsTab?: InputMaybe<Scalars['Boolean']['input']>;
  listAndResultType?: InputMaybe<Array<ListAndResultType>>;
  liveScoreAccessCode?: InputMaybe<Scalars['Float']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
  localRatedTournament?: InputMaybe<Scalars['Boolean']['input']>;
  loggedInUser?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  makePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  notificationsAddress?: InputMaybe<Scalars['String']['input']>;
  onlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  onsiteEntryFee?: InputMaybe<Scalars['Float']['input']>;
  organizer?: InputMaybe<Scalars['Float']['input']>;
  pairingsBlockType?: InputMaybe<Array<BlockType>>;
  partnerSearch?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentQrCode?: InputMaybe<Scalars['Upload']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  poster?: InputMaybe<Scalars['Upload']['input']>;
  rankingsReleaseDate?: InputMaybe<Scalars['String']['input']>;
  referee?: InputMaybe<Scalars['Float']['input']>;
  refereeId?: InputMaybe<Scalars['Float']['input']>;
  region?: InputMaybe<Region>;
  registerLink?: InputMaybe<Scalars['String']['input']>;
  registeredUsersInTournament?: InputMaybe<Scalars['Boolean']['input']>;
  registrationStartDate?: InputMaybe<Scalars['DateTime']['input']>;
  regulations?: InputMaybe<Scalars['Upload']['input']>;
  resourceTitle?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['String']['input']>;
  showOOP?: InputMaybe<Scalars['Boolean']['input']>;
  showPairingsAndStandings?: InputMaybe<Scalars['Boolean']['input']>;
  showTournamentChessManagerCalendar?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Sort_Order>;
  sortRequestBy?: InputMaybe<Scalars['String']['input']>;
  sportFishing?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  startTime?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  termsAndConditions?: InputMaybe<Scalars['String']['input']>;
  tier?: InputMaybe<TournamentTier>;
  timeControl?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalCourts?: InputMaybe<Scalars['Int']['input']>;
  tour?: InputMaybe<Scalars['String']['input']>;
  tournamentAddress?: InputMaybe<Scalars['String']['input']>;
  tournamentCategory?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  tournamentCategoryGroup?: InputMaybe<Scalars['Float']['input']>;
  tournamentDirector?: InputMaybe<Scalars['String']['input']>;
  tournamentId?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  venues?: InputMaybe<Array<UpdateTournamentVenueInput>>;
  videoUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  withdrawlDeadline?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTournamentOrganizerInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingInput = {
  draw?: InputMaybe<Scalars['Int']['input']>;
  draws?: InputMaybe<Array<Scalars['Int']['input']>>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  groups?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  isPublish?: InputMaybe<Scalars['Boolean']['input']>;
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankingPoint?: InputMaybe<Scalars['Int']['input']>;
  rankings?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  sportFishingResult?: InputMaybe<Scalars['Boolean']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentRankingId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsEntryInput = {
  activeFrom?: InputMaybe<Scalars['DateTime']['input']>;
  activeTo?: InputMaybe<Scalars['DateTime']['input']>;
  draw?: InputMaybe<Scalars['Int']['input']>;
  entry?: InputMaybe<Scalars['Int']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  liveStanding?: InputMaybe<Scalars['Int']['input']>;
  place?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Scalars['Float']['input']>;
  ranking?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsManInput = {
  id: Scalars['Int']['input'];
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRankingsWomanInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  tournamentCategory?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRefereeInput = {
  id?: InputMaybe<Scalars['Float']['input']>;
  referee?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  isAddedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartner?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentIntent?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentRegistrationQuestionInput = {
  amount?: InputMaybe<Scalars['String']['input']>;
  answer?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['Int']['input'];
  question?: InputMaybe<Scalars['Int']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTournamentTeamMemberInput = {
  amountPaid?: InputMaybe<Scalars['Float']['input']>;
  blitzElo?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  duprRating?: InputMaybe<Scalars['Float']['input']>;
  fideTitle?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  isDelete?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  points?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  rapidElo?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequestType?: InputMaybe<Scalars['Int']['input']>;
  standardElo?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Float']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRatingConfidence?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRatingConfidenceLevel?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprSocialRatingConfidence?: InputMaybe<Scalars['String']['input']>;
  wprSocialRatingConfidenceLevel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTournamentVenueInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  club?: InputMaybe<Scalars['Int']['input']>;
  coordinates?: InputMaybe<Scalars['JSON']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  court?: InputMaybe<Array<Scalars['Int']['input']>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTransactionHistoryByPaymentIntentInput = {
  paymentIntentId: Scalars['String']['input'];
  paymentStatus: PaymentStatus;
};

export type UpdateTransactionHistoryInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  amountReceived?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deductedAmount?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['Int']['input'];
  league?: InputMaybe<Scalars['Int']['input']>;
  license?: InputMaybe<Scalars['Int']['input']>;
  organization?: InputMaybe<Scalars['Int']['input']>;
  organizer?: InputMaybe<Scalars['Int']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  partnerFee?: InputMaybe<Scalars['Float']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  processingFee?: InputMaybe<Scalars['Float']['input']>;
  productType?: InputMaybe<Products>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  tournamentRegistration?: InputMaybe<Scalars['Int']['input']>;
  tournatedFee?: InputMaybe<Scalars['Float']['input']>;
  transactionType?: InputMaybe<TransactionType>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserCoachInput = {
  coaches?: InputMaybe<Array<Scalars['Int']['input']>>;
  id: Scalars['Int']['input'];
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserInput = {
  LVID?: InputMaybe<Scalars['String']['input']>;
  about?: InputMaybe<Scalars['String']['input']>;
  addedById?: InputMaybe<Scalars['Float']['input']>;
  additionalUserRole?: InputMaybe<Scalars['String']['input']>;
  allow_online_payments?: InputMaybe<Scalars['String']['input']>;
  appleId?: InputMaybe<Scalars['String']['input']>;
  atpId?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['Upload']['input']>;
  avatarFileId?: InputMaybe<Scalars['String']['input']>;
  avatarLink?: InputMaybe<Scalars['String']['input']>;
  bonusPoints?: InputMaybe<Scalars['String']['input']>;
  bonusU12?: InputMaybe<Scalars['String']['input']>;
  bonusU14?: InputMaybe<Scalars['String']['input']>;
  bonusU16?: InputMaybe<Scalars['String']['input']>;
  bt_country?: InputMaybe<Scalars['String']['input']>;
  citizenship?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  clubRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  club_access?: InputMaybe<Scalars['Boolean']['input']>;
  coach_access?: InputMaybe<Scalars['Boolean']['input']>;
  confirm_code?: InputMaybe<Scalars['Float']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  cpcPoints?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  duprId?: InputMaybe<Scalars['String']['input']>;
  educationEndDate?: InputMaybe<Scalars['String']['input']>;
  educationStartDate?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  email_confirmed?: InputMaybe<Scalars['String']['input']>;
  eparakstsId?: InputMaybe<Scalars['String']['input']>;
  externalMembershipNumber?: InputMaybe<Scalars['String']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  fcm_token?: InputMaybe<Scalars['String']['input']>;
  federation?: InputMaybe<Scalars['String']['input']>;
  federationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  fft_licence?: InputMaybe<Scalars['String']['input']>;
  fideId?: InputMaybe<Scalars['String']['input']>;
  firebaseIdentityToken?: InputMaybe<Scalars['String']['input']>;
  fivb?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  googleId?: InputMaybe<Scalars['String']['input']>;
  gtw_points?: InputMaybe<Scalars['Float']['input']>;
  has_fisher_id?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  ipinId?: InputMaybe<Scalars['String']['input']>;
  is_includes_latin?: InputMaybe<Scalars['Boolean']['input']>;
  is_verified?: InputMaybe<Scalars['String']['input']>;
  israel_national_id?: InputMaybe<Scalars['String']['input']>;
  itf_points?: InputMaybe<Scalars['String']['input']>;
  joined?: InputMaybe<Scalars['String']['input']>;
  lastPasswordResetBy?: InputMaybe<Scalars['Float']['input']>;
  lastResetPassword?: InputMaybe<Scalars['String']['input']>;
  lastSelectedLeague?: InputMaybe<Scalars['Float']['input']>;
  lastSelectedTournament?: InputMaybe<Scalars['Float']['input']>;
  last_login?: InputMaybe<Scalars['String']['input']>;
  leagueId?: InputMaybe<Scalars['Float']['input']>;
  legalAddress?: InputMaybe<Scalars['String']['input']>;
  legalAddressSameAsPublic?: InputMaybe<Scalars['Boolean']['input']>;
  legalCity?: InputMaybe<Scalars['String']['input']>;
  legalCountry?: InputMaybe<Scalars['String']['input']>;
  legalPostalCode?: InputMaybe<Scalars['String']['input']>;
  linkedIn?: InputMaybe<Scalars['String']['input']>;
  locationCountry?: InputMaybe<Scalars['String']['input']>;
  ltsU10Id?: InputMaybe<Scalars['String']['input']>;
  maxwillPoints?: InputMaybe<Scalars['String']['input']>;
  middle_name?: InputMaybe<Scalars['String']['input']>;
  middle_name_passport?: InputMaybe<Scalars['String']['input']>;
  mobileOtp?: InputMaybe<Scalars['String']['input']>;
  mobileOtpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  mobileVerified?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_armenian?: InputMaybe<Scalars['String']['input']>;
  name_passport?: InputMaybe<Scalars['String']['input']>;
  nation?: InputMaybe<Scalars['String']['input']>;
  national_fisher_id?: InputMaybe<Scalars['String']['input']>;
  new_terms?: InputMaybe<Scalars['String']['input']>;
  no_fisher_id_doc?: InputMaybe<Scalars['Upload']['input']>;
  no_fisher_id_reason?: InputMaybe<Scalars['String']['input']>;
  notifications?: InputMaybe<Scalars['String']['input']>;
  oldEmail?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  organization_abbr?: InputMaybe<Scalars['String']['input']>;
  organization_allow_op?: InputMaybe<Scalars['String']['input']>;
  organization_avatar?: InputMaybe<Scalars['String']['input']>;
  organization_email?: InputMaybe<Scalars['String']['input']>;
  organization_full_name?: InputMaybe<Scalars['String']['input']>;
  organization_phon?: InputMaybe<Scalars['String']['input']>;
  organization_submitted?: InputMaybe<Scalars['String']['input']>;
  organization_type?: InputMaybe<OrganizationType>;
  otherPoints?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  otpExpiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  parent_access?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  pdlId?: InputMaybe<Scalars['String']['input']>;
  personalNumber?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
  platforms?: InputMaybe<Array<Scalars['Int']['input']>>;
  player?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  preferred_language?: InputMaybe<Scalars['String']['input']>;
  quiz?: InputMaybe<Scalars['Float']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
  representingCountry?: InputMaybe<Scalars['String']['input']>;
  resetRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reset_password?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['Int']['input']>>;
  show_age?: InputMaybe<Scalars['String']['input']>;
  signedupWith?: InputMaybe<Scalars['String']['input']>;
  signupPlatform?: InputMaybe<Scalars['Float']['input']>;
  signupSource?: InputMaybe<Signup_Source>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  stripe_private_key?: InputMaybe<Scalars['String']['input']>;
  stripe_public_key?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
  surname_armenian?: InputMaybe<Scalars['String']['input']>;
  surname_passport?: InputMaybe<Scalars['String']['input']>;
  teId?: InputMaybe<Scalars['String']['input']>;
  teU12Id?: InputMaybe<Scalars['String']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderId?: InputMaybe<Scalars['String']['input']>;
  thirdPartyProviderName?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  uciId?: InputMaybe<Scalars['String']['input']>;
  user_address?: InputMaybe<Scalars['String']['input']>;
  user_app_sport?: InputMaybe<Scalars['String']['input']>;
  user_at_level?: InputMaybe<Scalars['String']['input']>;
  user_club_id?: InputMaybe<Scalars['Float']['input']>;
  user_club_text?: InputMaybe<Scalars['String']['input']>;
  user_coach?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_device_token?: InputMaybe<Scalars['String']['input']>;
  user_device_type?: InputMaybe<Scalars['String']['input']>;
  user_ip?: InputMaybe<Scalars['String']['input']>;
  user_join_club?: InputMaybe<Scalars['String']['input']>;
  user_join_reason?: InputMaybe<Scalars['String']['input']>;
  user_national_id?: InputMaybe<Scalars['String']['input']>;
  user_national_id_2?: InputMaybe<Scalars['String']['input']>;
  user_national_med?: InputMaybe<Scalars['String']['input']>;
  user_parents?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_poster?: InputMaybe<Scalars['String']['input']>;
  user_social_token?: InputMaybe<Scalars['String']['input']>;
  user_social_type?: InputMaybe<Scalars['String']['input']>;
  user_sport?: InputMaybe<Scalars['String']['input']>;
  user_sports?: InputMaybe<Array<Scalars['Int']['input']>>;
  user_status?: InputMaybe<Scalars['String']['input']>;
  visitedNewOnboarding?: InputMaybe<Scalars['Boolean']['input']>;
  weChatUnionId?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  wechatId?: InputMaybe<Scalars['String']['input']>;
  wechatIdQrCode?: InputMaybe<Scalars['String']['input']>;
  wprCompetitionRating?: InputMaybe<Scalars['String']['input']>;
  wprPermissionCode?: InputMaybe<Scalars['String']['input']>;
  wprPlayerId?: InputMaybe<Scalars['String']['input']>;
  wprSocialRating?: InputMaybe<Scalars['String']['input']>;
  wprStatusRating?: InputMaybe<Scalars['String']['input']>;
  wprUserId?: InputMaybe<Scalars['String']['input']>;
  wprUsersUpdateBulk?: InputMaybe<Array<Scalars['Int']['input']>>;
  wtaId?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserLicenseInput = {
  id: Scalars['Int']['input'];
  license?: InputMaybe<Scalars['Int']['input']>;
  promo?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserParentInput = {
  id: Scalars['Int']['input'];
  parent?: InputMaybe<Scalars['Int']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserPasswordByAdminInput = {
  isLogoutFromAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

export type UpdateUserPlanInput = {
  id: Scalars['Int']['input'];
  plan?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserSettingInput = {
  dateFormatPreference?: InputMaybe<DateFormatPreference>;
  dmEmails?: InputMaybe<ChatDmEmails>;
  emailNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['Int']['input'];
  mentionEmails?: InputMaybe<Scalars['Boolean']['input']>;
  quietHoursEnd?: InputMaybe<Scalars['Int']['input']>;
  quietHoursStart?: InputMaybe<Scalars['Int']['input']>;
  timeFormatPreference?: InputMaybe<TimeFormatPreference>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserSportInput = {
  club?: InputMaybe<Scalars['Int']['input']>;
  customClub?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  platformCoach?: InputMaybe<Scalars['Int']['input']>;
  sport?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UserSportStatus>;
  team?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadTeamMembersInput = {
  accessCode?: InputMaybe<Scalars['String']['input']>;
  members: Array<TeamMemberRow>;
  notifyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  teamId: Scalars['Int']['input'];
};

export type UploadTeamMembersResponse = {
  __typename?: 'UploadTeamMembersResponse';
  members: Array<ImportedMember>;
  messages: Array<ImportMessage>;
  success: Scalars['Boolean']['output'];
};

export type UpsertAthleteQuestionAnswerInput = {
  athleteQuestionId: Scalars['Int']['input'];
  sportId?: InputMaybe<Scalars['Int']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UserRating = {
  __typename?: 'UserRating';
  id: number;
  userId: number;
  provider: any;
  wtnRating?: number | null;
  duprSinglesRating?: number | null;
  duprDoublesRating?: number | null;
  wprCompetitionRating?: string | null;
  wprSocialRating?: string | null;
  wprStatusRating?: string | null;
  wprCompetitionRatingConfidence?: string | null;
  wprSocialRatingConfidence?: string | null;
  wprCompetitionRatingConfidenceLevel?: string | null;
  wprSocialRatingConfidenceLevel?: string | null;
  cpcPoints?: string | null;
  maxwillPoints?: string | null;
  itfPoints?: string | null;
  metadata?: any | null;
  createdAt: any;
  updatedAt: any;
};

export type User = {
  __typename?: 'User';
  LVID?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  additionalUserRole?: Maybe<Scalars['String']['output']>;
  allow_online_payments?: Maybe<Scalars['String']['output']>;
  appleId?: Maybe<Scalars['String']['output']>;
  atpId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<StorageFile>;
  avatarFileId?: Maybe<Scalars['String']['output']>;
  bonusPoints?: Maybe<Scalars['String']['output']>;
  bonusU12?: Maybe<Scalars['String']['output']>;
  bonusU14?: Maybe<Scalars['String']['output']>;
  bonusU16?: Maybe<Scalars['String']['output']>;
  bt_country?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club_access?: Maybe<Scalars['Boolean']['output']>;
  coach_access?: Maybe<Scalars['Boolean']['output']>;
  confirm_code?: Maybe<Scalars['Float']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cpcPoints?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  duprId?: Maybe<Scalars['String']['output']>;
  duprRating?: Maybe<Scalars['String']['output']>;
  educationEndDate?: Maybe<Scalars['DateTime']['output']>;
  educationStartDate?: Maybe<Scalars['DateTime']['output']>;
  educationalInstitution?: Maybe<Club>;
  educationalInstitutionId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_confirmed?: Maybe<Scalars['String']['output']>;
  eparakstsId?: Maybe<Scalars['String']['output']>;
  externalMembershipNumber?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Scalars['String']['output']>;
  federations?: Maybe<Array<Federation>>;
  fft_licence?: Maybe<Scalars['String']['output']>;
  fideId?: Maybe<Scalars['String']['output']>;
  fivb?: Maybe<Scalars['String']['output']>;
  friends?: Maybe<Array<User>>;
  gender?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  gtw_points?: Maybe<Scalars['Float']['output']>;
  hasFinishedDashboardV3Tour?: Maybe<Scalars['Boolean']['output']>;
  has_fisher_id?: Maybe<Scalars['Boolean']['output']>;
  /** Internal numeric identifier. Prefer `publicId` for any new caller — the integer is exposed for backward compatibility only. */
  id?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  identity_verified_via?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  ipinId?: Maybe<Scalars['String']['output']>;
  isAuthenticationRequired?: Maybe<Scalars['Boolean']['output']>;
  isLeagueManager?: Maybe<Scalars['Boolean']['output']>;
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  is_verified?: Maybe<Scalars['String']['output']>;
  israel_national_id: Scalars['String']['output'];
  itf_points?: Maybe<Scalars['String']['output']>;
  joined?: Maybe<Scalars['String']['output']>;
  lastPasswordResetBy?: Maybe<User>;
  lastResetPassword?: Maybe<Scalars['DateTime']['output']>;
  lastSelectedLeague?: Maybe<Scalars['Float']['output']>;
  lastSelectedTournament?: Maybe<Scalars['Float']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  legalAddressSameAsPublic?: Maybe<Scalars['Boolean']['output']>;
  legalCity?: Maybe<Scalars['String']['output']>;
  legalCountry?: Maybe<Scalars['String']['output']>;
  legalPostalCode?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  ltsU10Id?: Maybe<Scalars['String']['output']>;
  maxwillPoints?: Maybe<Scalars['String']['output']>;
  member_of_plateforms?: Maybe<Array<OrganizationPlatformMember>>;
  middle_name?: Maybe<Scalars['String']['output']>;
  middle_name_passport?: Maybe<Scalars['String']['output']>;
  mobileOtp?: Maybe<Scalars['String']['output']>;
  mobileOtpExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  mobileVerified?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_armenian?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  national_fisher_id?: Maybe<Scalars['String']['output']>;
  new_terms?: Maybe<Scalars['String']['output']>;
  no_fisher_id_doc?: Maybe<Scalars['String']['output']>;
  no_fisher_id_reason?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['String']['output']>;
  oldEmail?: Maybe<Scalars['String']['output']>;
  organizationAvatarFile?: Maybe<StorageFile>;
  organizationAvatarFileId?: Maybe<Scalars['String']['output']>;
  organization_abbr?: Maybe<Scalars['String']['output']>;
  organization_allow_op?: Maybe<Scalars['String']['output']>;
  organization_avatar?: Maybe<Scalars['String']['output']>;
  organization_email?: Maybe<Scalars['String']['output']>;
  organization_full_name?: Maybe<Scalars['String']['output']>;
  organization_phone?: Maybe<Scalars['String']['output']>;
  organization_submitted?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<OrganizationType>;
  otherPoints?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otpExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  parent_access?: Maybe<Scalars['Boolean']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentTransactions?: Maybe<Array<PaymentIntent>>;
  pdlId?: Maybe<Scalars['String']['output']>;
  personalNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<UserPlan>>;
  platforms?: Maybe<Array<Platform>>;
  player?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  /** Stable, opaque public id, e.g. `usr_8k3pq2r4n9v7t6mh`. Lowercase Crockford base32, random (not time-sortable). Safe to use in URLs, webhooks, and external integrations. */
  publicId: Scalars['String']['output'];
  quiz?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  representingCountry?: Maybe<Scalars['String']['output']>;
  resetRequired?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sentNotifications?: Maybe<Array<Notification>>;
  sessions?: Maybe<Array<UserSession>>;
  show_age?: Maybe<Scalars['String']['output']>;
  signedupWith?: Maybe<Scalars['String']['output']>;
  signupPlatform?: Maybe<Platform>;
  signupSource?: Maybe<Signup_Source>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  stripe_payments?: Maybe<Array<StripePayments>>;
  stripe_private_key?: Maybe<Scalars['String']['output']>;
  stripe_public_key?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_armenian?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  teId?: Maybe<Scalars['String']['output']>;
  teU12Id?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiresIn?: Maybe<Scalars['Float']['output']>;
  /** Human-facing Tournated ID, e.g. `483920`. Optimised for support tickets, printed federation cards, and end-user URLs where a human reads the id out loud. */
  tournatedTag: Scalars['String']['output'];
  uciId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userDiscounts?: Maybe<Array<UserDiscount>>;
  userFees?: Maybe<Array<UserFee>>;
  userSetting?: Maybe<UserSetting>;
  user_address?: Maybe<Scalars['String']['output']>;
  user_app_sport?: Maybe<Scalars['String']['output']>;
  user_at_level?: Maybe<Scalars['String']['output']>;
  user_club_id?: Maybe<Club>;
  user_club_text?: Maybe<Scalars['String']['output']>;
  user_coach?: Maybe<Array<UserCoach>>;
  user_device_token?: Maybe<Scalars['String']['output']>;
  user_device_type?: Maybe<Scalars['String']['output']>;
  user_ip?: Maybe<Scalars['String']['output']>;
  user_join_club?: Maybe<Scalars['String']['output']>;
  user_join_reason?: Maybe<Scalars['String']['output']>;
  user_national_id?: Maybe<Scalars['String']['output']>;
  user_national_id_2?: Maybe<Scalars['String']['output']>;
  user_national_med?: Maybe<Scalars['String']['output']>;
  user_parents?: Maybe<Array<UserParent>>;
  user_poster?: Maybe<Scalars['String']['output']>;
  user_social_token?: Maybe<Scalars['String']['output']>;
  user_social_type?: Maybe<Scalars['String']['output']>;
  user_sport?: Maybe<Scalars['String']['output']>;
  user_sports?: Maybe<Array<UserSport>>;
  user_status?: Maybe<Scalars['String']['output']>;
  verified_national_id?: Maybe<Scalars['String']['output']>;
  visitedNewOnboarding?: Maybe<Scalars['Boolean']['output']>;
  weChatUnionId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wechatId?: Maybe<Scalars['String']['output']>;
  wechatIdQrCode?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
  wprPlayerId?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['String']['output']>;
  wprStatusRating?: Maybe<Scalars['String']['output']>;
  wprUserId?: Maybe<Scalars['String']['output']>;
  userRatings?: Maybe<Array<UserRating>>;
  wtaId?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type UserAuth = {
  __typename?: 'UserAuth';
  accessToken: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type UserClubAdministrator = {
  __typename?: 'UserClubAdministrator';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type UserClubWithCountAndStatus = {
  __typename?: 'UserClubWithCountAndStatus';
  clubAdministrator?: Maybe<UserClubAdministrator>;
  clubId?: Maybe<Scalars['Int']['output']>;
  clubName?: Maybe<Scalars['String']['output']>;
  memberCount?: Maybe<Scalars['Int']['output']>;
  pendingCount?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserCoach = {
  __typename?: 'UserCoach';
  coaches?: Maybe<Array<PlatformCoach>>;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserDetail = {
  __typename?: 'UserDetail';
  LVID?: Maybe<Scalars['String']['output']>;
  additionalUserRole?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  bt_country?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  itf_points?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  middle_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_armenian?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  organization_abbr?: Maybe<Scalars['String']['output']>;
  organization_allow_op?: Maybe<Scalars['String']['output']>;
  organization_avatar?: Maybe<Scalars['String']['output']>;
  organization_email?: Maybe<Scalars['String']['output']>;
  organization_full_name?: Maybe<Scalars['String']['output']>;
  organization_phone?: Maybe<Scalars['String']['output']>;
  organization_submitted?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  representingCountry?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_armenian?: Maybe<Scalars['String']['output']>;
  user_status?: Maybe<Scalars['String']['output']>;
};

export type UserDetailedInfo = {
  __typename?: 'UserDetailedInfo';
  LVID?: Maybe<Scalars['String']['output']>;
  about?: Maybe<Scalars['String']['output']>;
  accessToken?: Maybe<Scalars['String']['output']>;
  additionalUserRole?: Maybe<Scalars['String']['output']>;
  allow_online_payments?: Maybe<Scalars['String']['output']>;
  appleId?: Maybe<Scalars['String']['output']>;
  atpId?: Maybe<Scalars['String']['output']>;
  avatar?: Maybe<Scalars['String']['output']>;
  avatarFile?: Maybe<StorageFile>;
  avatarFileId?: Maybe<Scalars['String']['output']>;
  bonusPoints?: Maybe<Scalars['String']['output']>;
  bonusU12?: Maybe<Scalars['String']['output']>;
  bonusU14?: Maybe<Scalars['String']['output']>;
  bonusU16?: Maybe<Scalars['String']['output']>;
  bt_country?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  club_access?: Maybe<Scalars['Boolean']['output']>;
  coach_access?: Maybe<Scalars['Boolean']['output']>;
  confirm_code?: Maybe<Scalars['Float']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  cpcPoints?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  dob?: Maybe<Scalars['String']['output']>;
  duprId?: Maybe<Scalars['String']['output']>;
  duprRating?: Maybe<Scalars['String']['output']>;
  educationEndDate?: Maybe<Scalars['DateTime']['output']>;
  educationStartDate?: Maybe<Scalars['DateTime']['output']>;
  educationalInstitution?: Maybe<Club>;
  educationalInstitutionId?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email_confirmed?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Scalars['Float']['output']>;
  eparakstsId?: Maybe<Scalars['String']['output']>;
  externalMembershipNumber?: Maybe<Scalars['String']['output']>;
  external_id?: Maybe<Scalars['Float']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  facebookId?: Maybe<Scalars['String']['output']>;
  fcm_token?: Maybe<Scalars['String']['output']>;
  federation?: Maybe<Scalars['String']['output']>;
  federations?: Maybe<Array<Federation>>;
  fft_licence?: Maybe<Scalars['String']['output']>;
  fideId?: Maybe<Scalars['String']['output']>;
  fivb?: Maybe<Scalars['String']['output']>;
  friends?: Maybe<Array<User>>;
  gender?: Maybe<Scalars['String']['output']>;
  googleId?: Maybe<Scalars['String']['output']>;
  gtw_points?: Maybe<Scalars['Float']['output']>;
  hasFinishedDashboardV3Tour?: Maybe<Scalars['Boolean']['output']>;
  has_fisher_id?: Maybe<Scalars['Boolean']['output']>;
  /** Internal numeric identifier. Prefer `publicId` for any new caller — the integer is exposed for backward compatibility only. */
  id?: Maybe<Scalars['Int']['output']>;
  idToken?: Maybe<Scalars['String']['output']>;
  identity_verified_via?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  ipinId?: Maybe<Scalars['String']['output']>;
  isAuthenticationRequired?: Maybe<Scalars['Boolean']['output']>;
  isLeagueManager?: Maybe<Scalars['Boolean']['output']>;
  is_includes_latin?: Maybe<Scalars['Boolean']['output']>;
  is_verified?: Maybe<Scalars['String']['output']>;
  israel_national_id: Scalars['String']['output'];
  itf_points?: Maybe<Scalars['String']['output']>;
  joined?: Maybe<Scalars['String']['output']>;
  lastPasswordResetBy?: Maybe<User>;
  lastResetPassword?: Maybe<Scalars['DateTime']['output']>;
  lastSelectedLeague?: Maybe<Scalars['Float']['output']>;
  lastSelectedTournament?: Maybe<Scalars['Float']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  legalAddress?: Maybe<Scalars['String']['output']>;
  legalAddressSameAsPublic?: Maybe<Scalars['Boolean']['output']>;
  legalCity?: Maybe<Scalars['String']['output']>;
  legalCountry?: Maybe<Scalars['String']['output']>;
  legalPostalCode?: Maybe<Scalars['String']['output']>;
  linkedIn?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  ltsU10Id?: Maybe<Scalars['String']['output']>;
  maxwillPoints?: Maybe<Scalars['String']['output']>;
  member_of_plateforms?: Maybe<Array<OrganizationPlatformMember>>;
  middle_name?: Maybe<Scalars['String']['output']>;
  middle_name_passport?: Maybe<Scalars['String']['output']>;
  mobileOtp?: Maybe<Scalars['String']['output']>;
  mobileOtpExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  mobileVerified?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  name_armenian?: Maybe<Scalars['String']['output']>;
  name_passport?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  national_fisher_id?: Maybe<Scalars['String']['output']>;
  new_terms?: Maybe<Scalars['String']['output']>;
  no_fisher_id_doc?: Maybe<Scalars['String']['output']>;
  no_fisher_id_reason?: Maybe<Scalars['String']['output']>;
  notifications?: Maybe<Scalars['String']['output']>;
  oldEmail?: Maybe<Scalars['String']['output']>;
  organizationAvatarFile?: Maybe<StorageFile>;
  organizationAvatarFileId?: Maybe<Scalars['String']['output']>;
  organization_abbr?: Maybe<Scalars['String']['output']>;
  organization_allow_op?: Maybe<Scalars['String']['output']>;
  organization_avatar?: Maybe<Scalars['String']['output']>;
  organization_email?: Maybe<Scalars['String']['output']>;
  organization_full_name?: Maybe<Scalars['String']['output']>;
  organization_phone?: Maybe<Scalars['String']['output']>;
  organization_submitted?: Maybe<Scalars['String']['output']>;
  organization_type?: Maybe<OrganizationType>;
  otherPoints?: Maybe<Scalars['String']['output']>;
  otp?: Maybe<Scalars['String']['output']>;
  otpExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  parent_access?: Maybe<Scalars['Boolean']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  paymentIntents?: Maybe<Array<PaymentIntent>>;
  paymentTransactions?: Maybe<Array<PaymentIntent>>;
  pdlId?: Maybe<Scalars['String']['output']>;
  personalNumber?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  plans?: Maybe<Array<UserPlan>>;
  platforms?: Maybe<Array<Platform>>;
  player?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  preferred_language?: Maybe<Scalars['String']['output']>;
  /** Stable, opaque public id, e.g. `usr_8k3pq2r4n9v7t6mh`. Lowercase Crockford base32, random (not time-sortable). Safe to use in URLs, webhooks, and external integrations. */
  publicId: Scalars['String']['output'];
  quiz?: Maybe<Scalars['Float']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  representingCountry?: Maybe<Scalars['String']['output']>;
  resetRequired?: Maybe<Scalars['Boolean']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  sentNotifications?: Maybe<Array<Notification>>;
  sessions?: Maybe<Array<UserSession>>;
  show_age?: Maybe<Scalars['String']['output']>;
  signedupWith?: Maybe<Scalars['String']['output']>;
  signupPlatform?: Maybe<Platform>;
  signupSource?: Maybe<Signup_Source>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  stripeAccountId?: Maybe<Scalars['String']['output']>;
  stripeConnectOnboardingComplete?: Maybe<Scalars['Boolean']['output']>;
  stripe_payments?: Maybe<Array<StripePayments>>;
  stripe_private_key?: Maybe<Scalars['String']['output']>;
  stripe_public_key?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  surname_armenian?: Maybe<Scalars['String']['output']>;
  surname_passport?: Maybe<Scalars['String']['output']>;
  teId?: Maybe<Scalars['String']['output']>;
  teU12Id?: Maybe<Scalars['String']['output']>;
  terms?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenExpiresIn?: Maybe<Scalars['Float']['output']>;
  /** Human-facing Tournated ID, e.g. `483920`. Optimised for support tickets, printed federation cards, and end-user URLs where a human reads the id out loud. */
  tournatedTag: Scalars['String']['output'];
  uciId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userDiscounts?: Maybe<Array<UserDiscount>>;
  userFees?: Maybe<Array<UserFee>>;
  userSetting?: Maybe<UserSetting>;
  user_address?: Maybe<Scalars['String']['output']>;
  user_app_sport?: Maybe<Scalars['String']['output']>;
  user_at_level?: Maybe<Scalars['String']['output']>;
  user_club_id?: Maybe<Club>;
  user_club_text?: Maybe<Scalars['String']['output']>;
  user_coach?: Maybe<Array<UserCoach>>;
  user_device_token?: Maybe<Scalars['String']['output']>;
  user_device_type?: Maybe<Scalars['String']['output']>;
  user_ip?: Maybe<Scalars['String']['output']>;
  user_join_club?: Maybe<Scalars['String']['output']>;
  user_join_reason?: Maybe<Scalars['String']['output']>;
  user_national_id?: Maybe<Scalars['String']['output']>;
  user_national_id_2?: Maybe<Scalars['String']['output']>;
  user_national_med?: Maybe<Scalars['String']['output']>;
  user_parents?: Maybe<Array<UserParent>>;
  user_poster?: Maybe<Scalars['String']['output']>;
  user_social_token?: Maybe<Scalars['String']['output']>;
  user_social_type?: Maybe<Scalars['String']['output']>;
  user_sport?: Maybe<Scalars['String']['output']>;
  user_sports?: Maybe<Array<UserSport>>;
  user_status?: Maybe<Scalars['String']['output']>;
  verified_national_id?: Maybe<Scalars['String']['output']>;
  visitedNewOnboarding?: Maybe<Scalars['Boolean']['output']>;
  weChatUnionId?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  wechatId?: Maybe<Scalars['String']['output']>;
  wechatIdQrCode?: Maybe<Scalars['String']['output']>;
  wprCompetitionRating?: Maybe<Scalars['String']['output']>;
  wprPlayerId?: Maybe<Scalars['String']['output']>;
  wprSocialRating?: Maybe<Scalars['String']['output']>;
  wprStatusRating?: Maybe<Scalars['String']['output']>;
  wprUserId?: Maybe<Scalars['String']['output']>;
  wtaId?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type UserDiscount = {
  __typename?: 'UserDiscount';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  paymentCalculation?: Maybe<PaymentCalculation>;
  paymentDiscount?: Maybe<Array<PaymentDiscount>>;
  totalDiscountAmount?: Maybe<Scalars['Float']['output']>;
  totalDiscountPercentage?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserFee = {
  __typename?: 'UserFee';
  createdAt: Scalars['DateTime']['output'];
  entryFee?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  partnerFee?: Maybe<Scalars['Float']['output']>;
  paymentCalculation?: Maybe<PaymentCalculation>;
  paymentProcessorFee?: Maybe<Scalars['Float']['output']>;
  tournatedFee?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  vatAppliedOnTournatedFee?: Maybe<Scalars['Float']['output']>;
};

export type UserInfo = {
  __typename?: 'UserInfo';
  avatar?: Maybe<Scalars['String']['output']>;
  club?: Maybe<Club>;
  dob?: Maybe<Scalars['String']['output']>;
  dupr?: Maybe<Scalars['Float']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nation?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
  wpr?: Maybe<Scalars['Float']['output']>;
  wprConfidenceLevel?: Maybe<Scalars['String']['output']>;
};

export type UserLicense = {
  __typename?: 'UserLicense';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  license?: Maybe<License>;
  promo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserLicenseCalculationOutput = {
  __typename?: 'UserLicenseCalculationOutput';
  afterDiscountLicenseFee: Scalars['Float']['output'];
  id: Scalars['Float']['output'];
  licenseFee: Scalars['Float']['output'];
  licenseId: Scalars['Float']['output'];
  platformFee: Scalars['Float']['output'];
  promoDiscountAmount: Scalars['Float']['output'];
  stripeFee: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  vatAmount: Scalars['Float']['output'];
};

export type UserLoginResult = {
  __typename?: 'UserLoginResult';
  /** Bearer token for authenticated requests. Null unless `status` is SUCCESS. */
  accessToken?: Maybe<Scalars['String']['output']>;
  /** Apps this user is allowed to enter (`client`, `manager`, `dashboard`). `client` is always present; `manager` mirrors the `tournamentLogin` gate and `dashboard` mirrors the `adminLogin` gate. Advisory only — surfaced so the centralized ID portal can stop a user on the login form before they pick an app they definitely cannot access. Populated only when `status` is SUCCESS; null on OTP_REQUIRED. */
  allowedApps?: Maybe<Array<LoginApp>>;
  /** Outcome of the attempt. SUCCESS → `user` + `accessToken` are set. OTP_REQUIRED → a one-time code was emailed; call `verifyUserLoginOtp` with it. */
  status: UserLoginStatus;
  /** The authenticated user. Null until the attempt reaches SUCCESS (e.g. while OTP verification is still pending). */
  user?: Maybe<User>;
};

/** Outcome of a userLogin / verifyUserLoginOtp attempt. */
export enum UserLoginStatus {
  OtpRequired = 'OTP_REQUIRED',
  Success = 'SUCCESS'
}

export type UserLogout = {
  __typename?: 'UserLogout';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export enum UserMatchesOrderBy {
  DateAsc = 'DATE_ASC',
  DateDesc = 'DATE_DESC',
  MostRelevant = 'MOST_RELEVANT'
}

export enum UserMatchesTab {
  All = 'ALL',
  Completed = 'COMPLETED',
  Upcoming = 'UPCOMING'
}

export type UserParent = {
  __typename?: 'UserParent';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  parent?: Maybe<User>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserPlan = {
  __typename?: 'UserPlan';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['Float']['output'];
  plan?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export type UserRegistrationInput = {
  registrationId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};

export type UserSession = {
  __typename?: 'UserSession';
  createdAt: Scalars['DateTime']['output'];
  deviceInfo?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Float']['output']>;
  ipAddress?: Maybe<Scalars['String']['output']>;
  isActive: Scalars['Boolean']['output'];
  lastActivity?: Maybe<Scalars['DateTime']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['Float']['output'];
};

export type UserSetting = {
  __typename?: 'UserSetting';
  dateFormatPreference: DateFormatPreference;
  dmEmails: ChatDmEmails;
  emailNotifications: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  mentionEmails: Scalars['Boolean']['output'];
  quietHoursEnd?: Maybe<Scalars['Int']['output']>;
  quietHoursStart?: Maybe<Scalars['Int']['output']>;
  timeFormatPreference: TimeFormatPreference;
  user: User;
};

export type UserSport = {
  __typename?: 'UserSport';
  club?: Maybe<Club>;
  createdAt: Scalars['DateTime']['output'];
  customClub?: Maybe<Scalars['String']['output']>;
  id: Scalars['Float']['output'];
  platformCoach?: Maybe<PlatformCoach>;
  sport?: Maybe<Sport>;
  status?: Maybe<UserSportStatus>;
  team?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};

export enum UserSportStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type UserTournamentRegistrationsResult = {
  __typename?: 'UserTournamentRegistrationsResult';
  data: Array<TournamentRegistration>;
  total: Scalars['Int']['output'];
};

export type UsersResult = {
  __typename?: 'UsersResult';
  total: Scalars['Int']['output'];
  users: Array<UserDetailedInfo>;
};

export type Validation = {
  __typename?: 'Validation';
  activeLicenses?: Maybe<Array<Scalars['String']['output']>>;
  isFriend?: Maybe<Scalars['Boolean']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  missingLicenses?: Maybe<Array<MissingLicenses>>;
  statusCode?: Maybe<Scalars['String']['output']>;
};

/** Selected wording for the `venue` term. */
export enum VenueTerm {
  Member = 'MEMBER',
  Venue = 'VENUE'
}

export type VerifyPasswordResetOtpInput = {
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
};

export type VerifyPasswordResetOtpResult = {
  __typename?: 'VerifyPasswordResetOtpResult';
  attemptsRemaining?: Maybe<Scalars['Int']['output']>;
  resetToken?: Maybe<Scalars['String']['output']>;
  statusCode: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type VideoBlock = PostBlock & {
  __typename?: 'VideoBlock';
  id?: Maybe<Scalars['String']['output']>;
  provider: VideoProvider;
  title?: Maybe<Scalars['String']['output']>;
  /** Provider-specific video ID (not the full URL). FE constructs the embed URL. */
  videoId: Scalars['String']['output'];
};

export type VideoItem = {
  __typename?: 'VideoItem';
  /** ISO-8601 timestamp set when the video was added */
  addedAt: Scalars['String']['output'];
  /** Duration in seconds */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** Stable client-generated id (sortable key) */
  id: Scalars['String']['output'];
  /** ISO-8601 publish date from YouTube */
  publishedAt?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  /** Localized title */
  title: Array<LocalizedValue>;
  /** Original YouTube URL */
  url: Scalars['String']['output'];
  /** Parsed YouTube video id */
  videoId: Scalars['String']['output'];
};

export type VideoMetadata = {
  __typename?: 'VideoMetadata';
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  videoId: Scalars['String']['output'];
};

export enum VideoProvider {
  Vimeo = 'VIMEO',
  Youtube = 'YOUTUBE'
}

export type VideosBlock = LandingBlock & {
  __typename?: 'VideosBlock';
  id?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<VideoItem>>;
};

export type WprData = {
  __typename?: 'WPRData';
  clientUserID?: Maybe<Scalars['String']['output']>;
  competitionRating?: Maybe<Scalars['Float']['output']>;
  competitionRatingConfidence?: Maybe<Scalars['Float']['output']>;
  competitionRatingConfidenceLevel?: Maybe<Scalars['String']['output']>;
  competitionRatingStatus?: Maybe<Scalars['String']['output']>;
  countryIsoCode?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  playerId?: Maybe<Scalars['String']['output']>;
  socialRating?: Maybe<Scalars['Float']['output']>;
  socialRatingConfidence?: Maybe<Scalars['Float']['output']>;
  socialRatingConfidenceLevel?: Maybe<Scalars['String']['output']>;
  socialRatingStatus?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  statusRating?: Maybe<Scalars['String']['output']>;
  subscriptions?: Maybe<WprSubscriptionModal>;
};

export type WprSubscription = {
  __typename?: 'WPRSubscription';
  active?: Maybe<Scalars['Boolean']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type WprSubscriptionModal = {
  __typename?: 'WPRSubscriptionModal';
  PREMIUM?: Maybe<WprSubscription>;
  USPA?: Maybe<WprSubscription>;
  USPA_PREMIUM?: Maybe<WprSubscription>;
};

/** WPR rating type: competition or social */
export enum Wpr_Rating_Type {
  Competition = 'COMPETITION',
  Social = 'SOCIAL'
}

export type WebCreateTournamentRegistrationInput = {
  additionalFee?: InputMaybe<Scalars['Float']['input']>;
  additionalQuestion?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  additionalSegment?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  assignedSegment?: InputMaybe<Scalars['String']['input']>;
  bothPaymentMethod?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  csvFile?: InputMaybe<Scalars['Upload']['input']>;
  external_id?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['Float']['input']>;
  isAddedManually?: InputMaybe<Scalars['Boolean']['input']>;
  isWithoutPartner?: InputMaybe<Scalars['Boolean']['input']>;
  leagueRanking?: InputMaybe<Scalars['Int']['input']>;
  memberIds: Array<Scalars['Int']['input']>;
  partnerSearchId?: InputMaybe<Scalars['Int']['input']>;
  payForMyself?: InputMaybe<Scalars['Boolean']['input']>;
  paymentDone?: InputMaybe<Scalars['Boolean']['input']>;
  paymentIntent?: InputMaybe<Scalars['Int']['input']>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  proofOfPayment?: InputMaybe<Scalars['Upload']['input']>;
  rankType?: InputMaybe<Scalars['String']['input']>;
  registrationRequest?: InputMaybe<Scalars['Int']['input']>;
  registrationRequests?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  request?: InputMaybe<Scalars['String']['input']>;
  seed?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  team?: InputMaybe<Scalars['Int']['input']>;
  teamMembers?: InputMaybe<Array<Scalars['Int']['input']>>;
  termsAndConditions?: InputMaybe<Scalars['Boolean']['input']>;
  totalRank?: InputMaybe<Scalars['Int']['input']>;
  tournament?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Scalars['Int']['input']>;
  usersData?: InputMaybe<Array<Scalars['JSONObject']['input']>>;
  withdrawReason?: InputMaybe<Scalars['String']['input']>;
};

/** Winner of the match */
export enum Winner {
  Draw = 'DRAW',
  Team1 = 'TEAM1',
  Team2 = 'TEAM2'
}

export type AlbumFragment = { __typename?: 'Album', id: number, title?: string | null, thumbnail?: string | null, isSpecificTournament?: boolean | null, albumCustomEvent?: string | null, albumTags?: string | null, date?: string | null, createdAt: any, thumbnailFile?: { __typename?: 'StorageFile', id: string, url?: string | null } | null };

export type AlbumWithMediaFragment = { __typename?: 'Album', id: number, media?: Array<{ __typename?: 'Media', id: number }> | null };

export type AlbumWithCreatedByFragment = { __typename?: 'Album', id: number, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type AlbumWithLeagueFragment = { __typename?: 'Album', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null };

export type AlbumWithTournamentFragment = { __typename?: 'Album', id: number, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null };

export type AthleteFragment = { __typename?: 'Athlete', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type BannerFragment = { __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null };

export type BoardMemberFragment = { __typename?: 'BoardMember', id: number, name: string, surname: string, role: OrganizationMemberRole, email: string, phone?: string | null, logo?: string | null, logoFileId?: string | null };

export type BaseCategoryFragment = { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null };

export type CategoryRuleFragment = { __typename?: 'CategoryRule', id: number, sector?: string | null, tournamentCategories?: Array<{ __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null }> | null };

export type BaseClubFragment = { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type ClubWithCoachesFragment = { __typename?: 'Club', coaches?: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number }> | null }> | null };

export type ClubWithMembersCountFragment = { __typename?: 'Club', membersStats?: { __typename?: 'ClubMemberStats', total: number, approved: number, pending: number, declined: number } | null };

export type ClubWithPlatformsFragment = { __typename?: 'Club', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null };

export type ClubWithFederationFragment = { __typename?: 'Club', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null };

export type ClubWithTournamentsCountFragment = { __typename?: 'Club', tournamentsCount?: number | null };

export type ClubMemberFragment = { __typename?: 'ClubMember', id: number, status: string, createdAt: any, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type ClubMemberStatsFragment = { __typename?: 'ClubMemberStats', total: number, approved: number, pending: number, declined: number };

export type ClubServiceFragment = { __typename?: 'ClubService', id: number, services?: { __typename?: 'ResourceService', id: number, service?: string | null, type?: string | null } | null };

export type ClubServiceResourceFragment = { __typename?: 'ClubServiceResource', id: number, title?: string | null, type?: string | null, clubService?: { __typename?: 'ClubService', id: number, services?: { __typename?: 'ResourceService', id: number, service?: string | null, type?: string | null } | null } | null };

export type PlatformCoachFragment = { __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type PlatformCoachWithPlatformFragment = { __typename?: 'PlatformCoach', platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null };

export type PlatformCoachWithClubsFragment = { __typename?: 'PlatformCoach', clubs?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null };

export type PlatformCoachWithStudentsFragment = { __typename?: 'PlatformCoach', students?: Array<{ __typename?: 'UserCoach', id: number }> | null };

export type DisciplineFragment = { __typename?: 'Discipline', id: number, title?: string | null };

export type DocumentFragment = { __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null };

export type DocumentFolderFragment = { __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null };

export type FederationFragment = { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null };

export type FederationWithPaymentDetailsFragment = { __typename?: 'Federation', legalEntityType?: LegalEntityType | null, bankEnabled?: boolean | null, bankName?: string | null, bankIban?: string | null, bankAccountHolder?: string | null, bankCompanyRegistrationNumber?: string | null, bankVatNumber?: string | null, bankCountry?: string | null, bankCity?: string | null, bankAddress?: string | null, bankPostalCode?: string | null };

export type FederationWithLegalDetailsFragment = { __typename?: 'Federation', legalEntityType?: LegalEntityType | null, legalName?: string | null, personalIdentificationNumber?: string | null, legalSurname?: string | null, legalCountry?: string | null, legalEmail?: string | null, legalPhone?: string | null, legalCompanyName?: string | null, legalAddress?: string | null, signerName?: string | null, signerSurname?: string | null, signerRole?: string | null, signerEmail?: string | null, registrationNumber?: string | null, vatNumber?: string | null };

export type FederationWithManagersFragment = { __typename?: 'Federation', user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type FederationWithPlatformsFragment = { __typename?: 'Federation', platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> | null };

export type FederationWithPlatformsWithFeesFragment = { __typename?: 'Federation', platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null } | null }> | null };

export type FederationWithFeesFragment = { __typename?: 'Federation', platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number } | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null }> | null };

export type FederationWithBoardMembersFragment = { __typename?: 'Federation', boardMembers?: Array<{ __typename?: 'BoardMember', id: number, name: string, surname: string, role: OrganizationMemberRole, email: string, phone?: string | null, logo?: string | null, logoFileId?: string | null }> | null };

export type FederationWithClubMembersFragment = { __typename?: 'Federation', clubMembers?: Array<{ __typename?: 'FederationClubMember', id: number, title: string, contactName: string, contactSurname: string, contactEmail: string, contactPhone?: string | null, contactRole: OrganizationMemberRole, logo?: string | null, registrationNumber?: string | null, website?: string | null, country: string, city?: string | null, address?: string | null, postalCode?: string | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null }> | null };

export type FederationWithDocumentsFragment = { __typename?: 'Federation', documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null };

export type FederationClubMemberFragment = { __typename?: 'FederationClubMember', id: number, title: string, contactName: string, contactSurname: string, contactEmail: string, contactPhone?: string | null, contactRole: OrganizationMemberRole, logo?: string | null, registrationNumber?: string | null, website?: string | null, country: string, city?: string | null, address?: string | null, postalCode?: string | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type LeagueFragment = { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null };

export type LeagueWithSportsFragment = { __typename?: 'League', sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null };

export type LeagueWithPlatformsFragment = { __typename?: 'League', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null };

export type LeagueWithOwnerFragment = { __typename?: 'League', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } | null };

export type LeagueWithAthleteIdsFragment = { __typename?: 'League', athlete?: Array<{ __typename?: 'Athlete', id: number }> | null };

export type LeagueWithTournamentsCountFragment = { __typename?: 'League', tournamentsCount?: number | null };

export type LeagueWithSocialLinksFragment = { __typename?: 'League', id: number, socialLinks?: Array<{ __typename?: 'LeagueSocialLink', socialMediaType: SocialMediaType, url: string }> | null };

export type LeagueCategoryFragment = { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null, tournaments?: Array<{ __typename?: 'CategoryTournament', id: number }> | null, categoryRules?: Array<{ __typename?: 'CategoryRule', id: number, sector?: string | null, tournamentCategories?: Array<{ __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null }> | null }> | null, tournamentCategories?: Array<{ __typename?: 'RankingTournamentCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null }> | null } | null };

export type LeagueCategoryWithLeagueFragment = { __typename?: 'LeagueCategory', league?: { __typename?: 'League', id: number, title?: string | null } | null };

export type LeagueDocumentFragment = { __typename?: 'LeagueDocument', id: number, document?: string | null, sortingPosition?: number | null, name?: string | null, updatedAt: any, createdAt: any };

export type LeagueMemberFragment = { __typename?: 'LeagueMember', id: number, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, role?: Array<{ __typename?: 'LeagueMemberRole', id: number, role?: { __typename?: 'Role', id: number, name?: string | null } | null }> | null };

export type LeagueMemberWithLeagueFragment = { __typename?: 'LeagueMember', league?: { __typename?: 'League', id: number, title?: string | null } | null };

export type LeagueRankingFragment = { __typename?: 'LeagueRanking', id: number, createdAt: any, date?: string | null, updatedAt: any, isPublic?: boolean | null, points?: number | null, place?: number | null, tournaments?: number | null, thirdPartyPoints?: string | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null, userRatings?: Array<{ __typename?: 'UserRating', provider: any, wtnRating?: number | null, duprSinglesRating?: number | null, duprDoublesRating?: number | null, wprCompetitionRating?: string | null, wprSocialRating?: string | null }> | null } | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null, country?: string | null, email?: string | null, facebookLink?: string | null, instagramLink?: string | null, phone?: string | null, tiktokLink?: string | null, twitterLink?: string | null, website?: string | null, joinedFrom?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null } | null };

export type LicenseFragment = { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null };

export type LicenseWithSportsFragment = { __typename?: 'License', sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null };

export type LicenseWithLicenseManagerFragment = { __typename?: 'License', licenseManager?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type LicenseWithQuestionsFragment = { __typename?: 'License', additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null }> | null };

export type LicenseWithIssuedCountFragment = { __typename?: 'License', issuedCount?: number | null };

export type LicenseWithLeaguesFragment = { __typename?: 'License', leagues?: Array<{ __typename?: 'LicenseLeague', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null } | null }> | null };

export type LicenseWithFederationFragment = { __typename?: 'License', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null };

export type LicenseWithPlatformsFragment = { __typename?: 'License', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null };

export type LicenseQuestionFragment = { __typename?: 'LicenseQuestion', id: number, file?: string | null, answer?: string | null, fileType?: string | null, createdAt: any, updatedAt: any, question?: { __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null } | null };

export type ThirdPartyLicenseFragment = { __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null };

export type UpdateLicenseMutationVariables = Exact<{
  input: UpdateLicenseInput;
}>;


export type UpdateLicenseMutation = { __typename?: 'Mutation', updateLicense: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } };

export type BulkUpdateLicensesMutationVariables = Exact<{
  input: BulkUpdateLicenseInput;
}>;


export type BulkUpdateLicensesMutation = { __typename?: 'Mutation', bulkUpdateLicenses: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null }> };

export type MatchCalendarMatchFragment = { __typename?: 'MatchCalendarMatch', id: number, date?: any | null, time?: string | null, matchType?: MatchType | null, status?: MatchStatus | null, winnerSide?: number | null, sets?: Array<{ __typename?: 'MatchSetScore', set: number, side1?: number | null, side2?: number | null, side1Tiebreak?: number | null, side2Tiebreak?: number | null }> | null, finalScore?: { __typename?: 'MatchFinalScore', side1: number, side2: number } | null };

export type MatchCalendarMatchWithCourtFragment = { __typename?: 'MatchCalendarMatch', court?: { __typename?: 'Court', id: number, name?: string | null } | null };

export type MatchCalendarMatchWithCategoryFragment = { __typename?: 'MatchCalendarMatch', tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null } | null } | null };

export type MatchCalendarMatchWithEntriesFragment = { __typename?: 'MatchCalendarMatch', team1Entry: Array<{ __typename?: 'TournamentTeamMember', id: number, rank?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }>, team2Entry: Array<{ __typename?: 'TournamentTeamMember', id: number, rank?: number | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> };

export type MatchCalendarMatchWithTeamFragment = { __typename?: 'MatchCalendarMatch', team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, team1?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null, team2?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null } | null };

export type NewsFragment = { __typename?: 'News', id: number, title?: string | null, postText?: string | null, image?: string | null, slug?: string | null, date?: any | null, createdAt: any, author?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type NewsWithLeaguesFragment = { __typename?: 'News', leagueNews?: Array<{ __typename?: 'LeagueNews', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null }> | null };

export type OrganizationSubscriptionFragment = { __typename?: 'OrganizationSubscription', id: number, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, platform?: { __typename?: 'Platform', abbreviation?: string | null, isMobileAppSupported?: boolean | null, landingLink?: string | null, platformLink?: string | null, timeZone?: string | null, liveScoring?: boolean | null, currency?: string | null, description?: string | null, onlinePayments?: boolean | null, companyEmail?: string | null, companyName?: string | null, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, signeeRole?: string | null, signeeFullName?: string | null, alreadyDomain?: boolean | null, primaryColor?: string | null, secondaryColor?: string | null, yourRequest?: string | null, darkEmblem?: string | null, lightEmblem?: string | null, favicon?: string | null, serviceProvider?: string | null, liveStreaming?: boolean | null, onlineBookingCourts?: boolean | null, licenseMemberships?: boolean | null, onlinePayment?: boolean | null, needIntegration?: boolean | null, needLanding?: boolean | null, fullAddress?: string | null, registrationNumber?: string | null, domain?: string | null, mobileApp?: boolean | null, isEnablePrice?: boolean | null, smm?: boolean | null, tournatedEntryFee?: number | null, partnerEntryFee?: number | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, graphicsForSmm?: boolean | null, isEnableMaintenance?: boolean | null, passcode?: string | null, maintenanceDescription?: string | null, maintenanceTitle?: string | null, subDomain?: string | null, liveStreaming_sporfie_key?: string | null, accessCode?: string | null, id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, language?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, club?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, disciplines?: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> | null, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, rangeStart: number, rangeEnd: number, feeType: string, serviceType: string, feeMode: string, tournatedFee?: number | null, tournatedMinFee?: number | null, tournatedMaxFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, isMonetization?: boolean | null, isManagerPayingServiceFee?: boolean | null }> | null, platformSetting?: { __typename?: 'PlatformSetting', id: number, timeFormatPreference?: TimeFormatPreference | null, dateFormatPreference?: DateFormatPreference | null } | null, template?: { __typename?: 'Template', id: number } | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null } | null };

export type PartnerFragment = { __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null };

export type PlatformFeeFragment = { __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null };

export type BasePlatformFragment = { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null };

export type PlatformWithOwnerFragment = { __typename?: 'Platform', owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type PlatformWithSportsFragment = { __typename?: 'Platform', sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null };

export type PlatformWithFeesFragment = { __typename?: 'Platform', tournatedEntryFee?: number | null, tournatedLicenseFee?: number | null, partnerEntryFee?: number | null, partnerLicenseFee?: number | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null };

export type PlatformWithThirdPartyLicensesFragment = { __typename?: 'PlatformWithSubscription', id: number, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null };

export type PlatformFragment = { __typename?: 'Platform', abbreviation?: string | null, isMobileAppSupported?: boolean | null, landingLink?: string | null, platformLink?: string | null, timeZone?: string | null, liveScoring?: boolean | null, currency?: string | null, description?: string | null, onlinePayments?: boolean | null, companyEmail?: string | null, companyName?: string | null, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, signeeRole?: string | null, signeeFullName?: string | null, alreadyDomain?: boolean | null, primaryColor?: string | null, secondaryColor?: string | null, yourRequest?: string | null, darkEmblem?: string | null, lightEmblem?: string | null, favicon?: string | null, serviceProvider?: string | null, liveStreaming?: boolean | null, onlineBookingCourts?: boolean | null, licenseMemberships?: boolean | null, onlinePayment?: boolean | null, needIntegration?: boolean | null, needLanding?: boolean | null, fullAddress?: string | null, registrationNumber?: string | null, domain?: string | null, mobileApp?: boolean | null, isEnablePrice?: boolean | null, smm?: boolean | null, tournatedEntryFee?: number | null, partnerEntryFee?: number | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, graphicsForSmm?: boolean | null, isEnableMaintenance?: boolean | null, passcode?: string | null, maintenanceDescription?: string | null, maintenanceTitle?: string | null, subDomain?: string | null, liveStreaming_sporfie_key?: string | null, accessCode?: string | null, id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, language?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, club?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, disciplines?: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> | null, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, rangeStart: number, rangeEnd: number, feeType: string, serviceType: string, feeMode: string, tournatedFee?: number | null, tournatedMinFee?: number | null, tournatedMaxFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, isMonetization?: boolean | null, isManagerPayingServiceFee?: boolean | null }> | null, platformSetting?: { __typename?: 'PlatformSetting', id: number, timeFormatPreference?: TimeFormatPreference | null, dateFormatPreference?: DateFormatPreference | null } | null, template?: { __typename?: 'Template', id: number } | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null };

export type PlatformWithDocumentsFragment = { __typename?: 'Platform', documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null };

export type PlatformWithSubscriptionDocumentsFragment = { __typename?: 'PlatformWithSubscription', documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null };

export type PlatformDocumentFragment = { __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> };

export type PurchasedLicenseFragment = { __typename?: 'PurchasedLicense', id: number, paid?: number | null, startDate?: any | null, endDate?: any | null, currency?: string | null, type?: string | null, createdAt: any, licenseStatus: LicenseStatus, payment_status?: string | null, approvalStatus?: string | null, stripeFee?: number | null, paidTotal?: number | null, totalGross?: number | null, totalNet?: number | null, basePrice?: number | null, bankTransferDetails?: any | null, isBulkPurchase?: boolean | null, proof?: { __typename?: 'PurchasedLicenseProof', fileUrl?: string | null, isUploaded: boolean, uploadedAt?: any | null } | null, addedBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, license?: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, team?: string | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null } | null };

export type PurchasedLicenseWithLinkedLicensesFragment = { __typename?: 'PurchasedLicense', paidForUserLicenses?: Array<{ __typename?: 'PurchasedLicensePaidForUser', user: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null }, license: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } }> | null };

export type PurchasedLicenseWithQuestionsFragment = { __typename?: 'PurchasedLicense', additionalQuestions?: Array<{ __typename?: 'LicenseQuestion', id: number, file?: string | null, answer?: string | null, fileType?: string | null, createdAt: any, updatedAt: any, question?: { __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null } | null }> | null };

export type PurchasedLicenseWithPlatformsFragment = { __typename?: 'PurchasedLicense', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null };

export type PurchasedLicenseWithFederationFragment = { __typename?: 'PurchasedLicense', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null };

export type QuestionFragment = { __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null };

export type RankingCategoryPointFragment = { __typename?: 'RankingCategoryPoint', id: number, place?: string | null, points?: number | null, sortingPosition?: number | null, numPlaces?: number | null, segments?: Array<string> | null, bracketTypes?: Array<{ __typename?: 'RankingCategoryPointType', id: number, name?: string | null, bracketType?: string | null }> | null };

export type RankingPointFragment = { __typename?: 'RankingPoint', id: number, name?: string | null, place?: number | null, entries?: number | null, zeroPointsIfNoMatchesWon?: boolean | null, groupStagePoints?: boolean | null, priority?: string | null, points?: number | null, tournamentCategory?: Array<{ __typename?: 'RankingPointCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null }> | null, rankingPointRules?: Array<{ __typename?: 'RankingPointRule', id: number, sector?: string | null, coefficient?: number | null, type?: string | null, numberOfEntries?: string | null, operator?: string | null, skillLevel?: string | null, numberOfPlayers?: string | null, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null }> | null, rankingCategoryPoints?: Array<{ __typename?: 'RankingCategoryPoint', id: number, place?: string | null, points?: number | null, sortingPosition?: number | null, numPlaces?: number | null, segments?: Array<string> | null, bracketTypes?: Array<{ __typename?: 'RankingCategoryPointType', id: number, name?: string | null, bracketType?: string | null }> | null }> | null };

export type RankingPointRuleFragment = { __typename?: 'RankingPointRule', id: number, sector?: string | null, coefficient?: number | null, type?: string | null, numberOfEntries?: string | null, operator?: string | null, skillLevel?: string | null, numberOfPlayers?: string | null, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null };

export type SportFragment = { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null };

export type SportWithDisciplineFragment = { __typename?: 'Sport', id: number, discipline?: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> | null };

export type SubscriptionFragment = { __typename?: 'Subscription', id: number, planName?: string | null, createdAt: any, validFrom: any, validTo: any, paymentMethod: string, amount?: number | null, currency: string, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type SubscriptionWithPlatformFragment = { __typename?: 'Subscription', platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null };

export type TeamFragment = { __typename?: 'Team', id: number, title?: string | null, image?: string | null, country?: string | null, email?: string | null, facebookLink?: string | null, instagramLink?: string | null, phone?: string | null, tiktokLink?: string | null, twitterLink?: string | null, website?: string | null, joinedFrom?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null };

export type TeamWithClubFragment = { __typename?: 'Team', club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type TeamWithMembersFragment = { __typename?: 'Team', invitedMembers?: Array<string> | null, members?: Array<{ __typename?: 'TeamMember', id: number, role?: string | null, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null };

export type TeamWithTournamentCountFragment = { __typename?: 'Team', tournamentsCount?: number | null };

export type TeamWithFederationFragment = { __typename?: 'Team', federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null };

export type TeamWithPlatformsFragment = { __typename?: 'Team', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null };

export type TeamMemberFragment = { __typename?: 'TeamMember', id: number, role?: string | null, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type RankingTournamentCategoryFragment = { __typename?: 'RankingTournamentCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null };

export type TournamentFragment = { __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null };

export type TournamentWithSportsFragment = { __typename?: 'Tournament', sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null };

export type TournamentWithOrganizerFragment = { __typename?: 'Tournament', organizer?: { __typename?: 'LeagueMember', id: number, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, role?: Array<{ __typename?: 'LeagueMemberRole', id: number, role?: { __typename?: 'Role', id: number, name?: string | null } | null }> | null } | null };

export type TournamentWithCreatedByFragment = { __typename?: 'Tournament', createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type TournamentWithClubFragment = { __typename?: 'Tournament', club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type TournamentWithVenuesFragment = { __typename?: 'Tournament', venues?: Array<{ __typename?: 'TournamentVenue', id: number, title: string, city?: string | null, country?: string | null, address?: string | null }> | null };

export type TournamentWithLeagueFragment = { __typename?: 'Tournament', league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null } | null } | null };

export type TournamentWithCategoriesFragment = { __typename?: 'Tournament', tournamentCategory?: Array<{ __typename?: 'CategorySetting', category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null } | null }> | null };

export type TournamentCategoryFragment = { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null };

export type TournamentCategoryWithLeagueFragment = { __typename?: 'TournamentCategory', league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null };

export type TournamentCategoryWithDisciplineFragment = { __typename?: 'TournamentCategory', discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null };

export type TournamentCategoryLicenseFragment = { __typename?: 'TournamentCategoryLicense', id: number, license?: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } | null };

export type TournamentRankingFragment = { __typename?: 'TournamentRanking', id: number, name?: string | null, isPublish?: boolean | null, createdAt: any, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, startDate?: any | null, endDate?: any | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null } | null, rankings?: Array<{ __typename?: 'TournamentRankingsEntry', id: number, place?: string | null, points?: number | null, entry?: { __typename?: 'TournamentRegistration', id: number, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null } | null }> | null };

export type TournamentRankingsEntryFragment = { __typename?: 'TournamentRankingsEntry', id: number, place?: string | null, points?: number | null, entry?: { __typename?: 'TournamentRegistration', id: number, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null } | null };

export type TournamentStatsFragment = { __typename?: 'TournamentList', allTournaments?: number | null, passedTournaments?: number | null, upcomingTournaments?: number | null, activeTournaments?: number | null, confirmedTournaments?: number | null, pendingTournaments?: number | null, inactiveTournaments?: number | null, declinedTournaments?: number | null };

export type TournamentVenueFragment = { __typename?: 'TournamentVenue', id: number, title: string, city?: string | null, country?: string | null, address?: string | null };

export type TransactionFragment = { __typename?: 'TransactionHistory', id: number, createdAt: any, amount: number, paidAmount: number, currency?: string | null, productType: string, paymentStatus: string, transactionType: string, tournatedFee?: number | null, partnerFee?: number | null, processingFee?: number | null, user: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } };

export type TransactionWithPlatformFragment = { __typename?: 'TransactionHistory', platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null };

export type TransactionWithLicenseFragment = { __typename?: 'TransactionHistory', license?: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } | null };

export type TransactionWithTournamentFragment = { __typename?: 'TransactionHistory', tournament?: { __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null } | null };

export type BaseDetailedUserFragment = { __typename?: 'UserDetailedInfo', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, middle_name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, mobileVerified?: boolean | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, citizenship?: string | null, street?: string | null, user_club_text?: string | null, dob?: string | null, ipinId?: string | null, duprId?: string | null, teId?: string | null, ltsU10Id?: string | null, atpId?: string | null, wtaId?: string | null, fideId?: string | null, teU12Id?: string | null, bonusU14?: string | null, bonusU12?: string | null, bonusPoints?: string | null, itf_points?: string | null, fivb?: string | null, bonusU16?: string | null, otherPoints?: string | null, createdAt: any, wprUserId?: string | null, additionalUserRole?: string | null, entries?: number | null, paidAmount?: number | null, signupSource?: Signup_Source | null, wprPlayerId?: string | null, lastResetPassword?: any | null, email_confirmed?: string | null, user_national_id_2?: string | null, uciId?: string | null, postalCode?: string | null, legalAddress?: string | null, legalCity?: string | null, legalCountry?: string | null, legalPostalCode?: string | null, educationStartDate?: any | null, educationEndDate?: any | null, educationalInstitutionId?: number | null, legalAddressSameAsPublic?: boolean | null, educationalInstitution?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, lastPasswordResetBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null };

export type DetailedUserWithSportsFragment = { __typename?: 'UserDetailedInfo', user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null };

export type DetailedUserWithPlatformsFragment = { __typename?: 'UserDetailedInfo', platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, signupPlatform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null };

export type DetailedUserWithFederationsFragment = { __typename?: 'UserDetailedInfo', federations?: Array<{ __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null };

export type BaseUserFragment = { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null };

export type UserWithSportsFragment = { __typename?: 'User', user_sports?: Array<{ __typename?: 'UserSport', id: number, team?: string | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null };

export type UserWithMemberOfPlatformsFragment = { __typename?: 'User', id?: number | null, member_of_plateforms?: Array<{ __typename?: 'OrganizationPlatformMember', id: number, platform?: { __typename?: 'Platform', id: number } | null }> | null };

export type UserWithClubFragment = { __typename?: 'User', id?: number | null, user_club_id?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type VenueFragment = { __typename?: 'TournamentVenue', id: number, title: string, city?: string | null, address?: string | null, country?: string | null, state?: string | null, createdAt: any };

export type VenueWithTournamentFragment = { __typename?: 'TournamentVenue', tournament?: { __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null } | null } | null } | null };

export type VenueWithClubFragment = { __typename?: 'TournamentVenue', club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null };

export type AddAthleteMutationVariables = Exact<{
  league: Scalars['Int']['input'];
  athlete: Scalars['Int']['input'];
}>;


export type AddAthleteMutation = { __typename?: 'Mutation', createAthlete: { __typename?: 'Athlete', id: number } };

export type AddUserToPlatformMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
  platformId: Scalars['Int']['input'];
}>;


export type AddUserToPlatformMutation = { __typename?: 'Mutation', updateUsersPlatform: { __typename?: 'User', email?: string | null, name?: string | null } };

export type InitiateForgotPasswordFlowMutationVariables = Exact<{
  email: Scalars['String']['input'];
  redirectURL?: InputMaybe<Scalars['String']['input']>;
}>;


export type InitiateForgotPasswordFlowMutation = { __typename?: 'Mutation', forgetPassword: { __typename?: 'GeneralReturnType', success: boolean, statusCode?: string | null } };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', adminLogin: { __typename?: 'User', id?: number | null, isAuthenticationRequired?: boolean | null, accessToken?: string | null } };

export type LoginOtpMutationVariables = Exact<{
  email: Scalars['String']['input'];
  otp: Scalars['String']['input'];
}>;


export type LoginOtpMutation = { __typename?: 'Mutation', adminOTPVerification: { __typename?: 'User', id?: number | null, accessToken?: string | null } };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
  isLogoutFromAllDevices?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', forgotResetPassword: { __typename?: 'User', id?: number | null, name?: string | null, email?: string | null, accessToken?: string | null } };

export type CreateBannerMutationVariables = Exact<{
  input: CreateBannerInputNew;
}>;


export type CreateBannerMutation = { __typename?: 'Mutation', createBannerNew: { __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null } };

export type LegacyCreateBannerMutationVariables = Exact<{
  platformPublicId: Scalars['String']['input'];
  headLine: Scalars['String']['input'];
  subHeadLine: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  buttonLink: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  status: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
  addedBy?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LegacyCreateBannerMutation = { __typename?: 'Mutation', createBanner: { __typename?: 'Banner', id: number } };

export type LegacyUpdateBannerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  platformPublicId: Scalars['String']['input'];
  headLine: Scalars['String']['input'];
  subHeadLine: Scalars['String']['input'];
  buttonText: Scalars['String']['input'];
  buttonLink: Scalars['String']['input'];
  primaryColor: Scalars['String']['input'];
  status: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  images?: InputMaybe<Array<Scalars['Upload']['input']> | Scalars['Upload']['input']>;
  imageURLs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type LegacyUpdateBannerMutation = { __typename?: 'Mutation', updateBanner: { __typename?: 'Banner', id: number } };

export type RemoveBannerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveBannerMutation = { __typename?: 'Mutation', deleteBannerNew: { __typename?: 'DeleteOutput', id: number } };

export type UpdateBannerMutationVariables = Exact<{
  input: UpdateBannerInputNew;
}>;


export type UpdateBannerMutation = { __typename?: 'Mutation', updateBannerNew: { __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null } };

export type UpdateBulkBannerMutationVariables = Exact<{
  input: UpdateBulkBannerInputNew;
}>;


export type UpdateBulkBannerMutation = { __typename?: 'Mutation', updateBulkBannerNew: Array<{ __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null }> };

export type CreateClubMutationVariables = Exact<{
  clubName: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  clubCoaches: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  clubMainAdministrator: Scalars['Int']['input'];
  clubAdministrators: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  clubServices: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  createClubServiceResourceInput: Array<CreateClubServiceResourceInput> | CreateClubServiceResourceInput;
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type CreateClubMutation = { __typename?: 'Mutation', createClub: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } };

export type UpdateClubMutationVariables = Exact<{
  clubName: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['Upload']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  howToFindUs?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  instagramLink?: InputMaybe<Scalars['String']['input']>;
  facebookLink?: InputMaybe<Scalars['String']['input']>;
  twitterLink?: InputMaybe<Scalars['String']['input']>;
  tikTok?: InputMaybe<Scalars['String']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  clubMainAdministrator?: InputMaybe<Scalars['Int']['input']>;
  isAthleteClub?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isEnableEmail?: InputMaybe<Scalars['Boolean']['input']>;
  isAdminVerificationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  addressCoordinates?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type UpdateClubMutation = { __typename?: 'Mutation', updateClub: { __typename?: 'Club', id: number, status?: string | null } };

export type UpdateClubMemberMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateClubMemberMutation = { __typename?: 'Mutation', updateClubMember: { __typename?: 'ClubMember', id: number, status: string } };

export type UpdatePlatformCoachMutationVariables = Exact<{
  input: UpdatePlatformCoachInput;
}>;


export type UpdatePlatformCoachMutation = { __typename?: 'Mutation', updatePlatformCoach: { __typename?: 'PlatformCoach', id: number, status?: string | null } };

export type CreateLeagueMutationVariables = Exact<{
  createLeagueInput: CreateLeagueInput;
}>;


export type CreateLeagueMutation = { __typename?: 'Mutation', createLeague: { __typename?: 'League', title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, id: number, socialLinks?: Array<{ __typename?: 'LeagueSocialLink', socialMediaType: SocialMediaType, url: string }> | null } };

export type CreateLicenseMutationVariables = Exact<{
  input: CreateLicenseInput;
}>;


export type CreateLicenseMutation = { __typename?: 'Mutation', createLicense: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } };

export type CreatePageMutationVariables = Exact<{
  input: CreatePlatformPageInput;
}>;


export type CreatePageMutation = { __typename?: 'Mutation', createPlatformPage: { __typename?: 'PlatformPage', id: number, slug: PageSlug, blocks: Array<any> } };

export type CreatePlatformSettingMutationVariables = Exact<{
  input: CreatePlatformSettingInput;
}>;


export type CreatePlatformSettingMutation = { __typename?: 'Mutation', createPlatformSetting: { __typename?: 'PlatformSetting', id: number } };

export type CreatePostCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug: Scalars['String']['input'];
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePostCategoryMutation = { __typename?: 'Mutation', createPostCategory: { __typename?: 'PostCategory', id: number } };

export type DeletePurchasedLicenseMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePurchasedLicenseMutation = { __typename?: 'Mutation', removePurchasedLicense: { __typename?: 'PurchasedLicense', id: number } };

export type GetSubOrganizationsQueryVariables = Exact<{
  filter: ListOrganizationPlatformsInput;
}>;


export type GetSubOrganizationsQuery = { __typename?: 'Query', subOrganizations: Array<{ __typename?: 'OrganizationFederationPublicDto', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> | null } | null }> };

export type DeleteLicenseMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  input: RemoveLicenseInput;
}>;


export type DeleteLicenseMutation = { __typename?: 'Mutation', removeLicense: { __typename?: 'License', id: number } };

export type CreatePartnerMutationVariables = Exact<{
  input: CreatePartnerNewInput;
}>;


export type CreatePartnerMutation = { __typename?: 'Mutation', createPartnerNew: { __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null } };

export type DeletePartnerMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePartnerMutation = { __typename?: 'Mutation', deletePartnerNew: { __typename?: 'DeleteOutput', id: number } };

export type UpdateBulkPartnersMutationVariables = Exact<{
  input: UpdateBulkPartnerNewInput;
}>;


export type UpdateBulkPartnersMutation = { __typename?: 'Mutation', updateBulkPartnersNew: Array<{ __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null }> };

export type UpdatePartnerMutationVariables = Exact<{
  input: UpdatePartnerNewInput;
}>;


export type UpdatePartnerMutation = { __typename?: 'Mutation', updatePartnerNew: { __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null } };

export type CreatePlatformDocumentMutationVariables = Exact<{
  input: CreatePlatformDocumentInput;
}>;


export type CreatePlatformDocumentMutation = { __typename?: 'Mutation', createPlatformDocument: { __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> } };

export type DeletePlatformDocumentMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeletePlatformDocumentMutation = { __typename?: 'Mutation', deletePlatformDocument: { __typename?: 'DeleteOutput', id: number } };

export type UpdateBulkPlatformDocumentsMutationVariables = Exact<{
  input: UpdateBulkPlatformDocumentsInput;
}>;


export type UpdateBulkPlatformDocumentsMutation = { __typename?: 'Mutation', updateBulkPlatformDocuments: Array<{ __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> }> };

export type UpdatePlatformDocumentMutationVariables = Exact<{
  input: UpdatePlatformDocumentInput;
}>;


export type UpdatePlatformDocumentMutation = { __typename?: 'Mutation', updatePlatformDocument: { __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> } };

export type SetLeagueRankingsCronCategoriesMutationVariables = Exact<{
  leagueId: Scalars['Int']['input'];
  rankingCategoryIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
  refreshRate: RefreshRate;
  updateEvery?: InputMaybe<Scalars['String']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  customSchedule?: InputMaybe<Array<CustomScheduleItemInput> | CustomScheduleItemInput>;
}>;


export type SetLeagueRankingsCronCategoriesMutation = { __typename?: 'Mutation', setLeagueRankingsCronCategories: { __typename?: 'LeagueRankingsCron', id: number } };

export type ResetLeagueRankingsCronCategoriesMutationVariables = Exact<{
  leagueId: Scalars['Int']['input'];
}>;


export type ResetLeagueRankingsCronCategoriesMutation = { __typename?: 'Mutation', resetLeagueRankingsCronCategories: { __typename?: 'LeagueRankingsCron', id: number } };

export type RegenerateAccessCodeMutationVariables = Exact<{
  platformPublicId: Scalars['String']['input'];
}>;


export type RegenerateAccessCodeMutation = { __typename?: 'Mutation', regeneratePlatformAccessCode: { __typename?: 'Platform', id: number, accessCode?: string | null } };

export type RemoveAlbumByIdMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemoveAlbumByIdMutation = { __typename?: 'Mutation', removeAlbum: { __typename?: 'Album', id: number } };

export type RemovePostCategoryMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type RemovePostCategoryMutation = { __typename?: 'Mutation', removePostCategory: { __typename?: 'PostCategory', name: string } };

export type SendTeamInviteQueryVariables = Exact<{
  user: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  teamName?: InputMaybe<Scalars['String']['input']>;
  acceptUrl: Scalars['String']['input'];
  declineUrl: Scalars['String']['input'];
  platformId: Scalars['Int']['input'];
}>;


export type SendTeamInviteQuery = { __typename?: 'Query', sendInviteToSignupAndTeamUp: { __typename?: 'GeneralReturnType', message?: string | null, success: boolean } };

export type CopyTournamentMutationVariables = Exact<{
  title: Scalars['String']['input'];
  tournamentId: Scalars['Float']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  entryDeadline: Scalars['String']['input'];
  withdrawlDeadline: Scalars['String']['input'];
}>;


export type CopyTournamentMutation = { __typename?: 'Mutation', cloneTournament: { __typename?: 'Tournament', title?: string | null, id: number } };

export type CreateTournamentCategoryLicenseMutationVariables = Exact<{
  tournamentCategory: Scalars['Int']['input'];
  license: Scalars['Int']['input'];
}>;


export type CreateTournamentCategoryLicenseMutation = { __typename?: 'Mutation', createTournamentCategoryLicense: { __typename?: 'TournamentCategoryLicense', id: number } };


export type UpdateBulkPlatformFeeMutationVariables = Exact<{
  input: Array<UpdatePlatformFeeInput> | UpdatePlatformFeeInput;
}>;


export type UpdateBulkPlatformFeeMutation = { __typename?: 'Mutation', updateBulkPlatformFee: Array<{ __typename?: 'PlatformFee', id: number, currency?: string | null, rangeStart: number, rangeEnd: number, feeType: string, feeMode: string, serviceType: string, tournatedFee?: number | null, tournatedMinFee?: number | null, tournatedMaxFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, isMonetization?: boolean | null, isManagerPayingServiceFee?: boolean | null }> };

export type UpdateLeagueCustomFeesMutationVariables = Exact<{
  id?: InputMaybe<Scalars['Int']['input']>;
  publicId?: InputMaybe<Scalars['String']['input']>;
  customFee: Array<UpdatePlatformFeeInput> | UpdatePlatformFeeInput;
  isTournatedFeeVatEnable?: InputMaybe<Scalars['Boolean']['input']>;
  tournatedFeeVat?: InputMaybe<Scalars['Float']['input']>;
  isCustomFeeEnable?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateLeagueCustomFeesMutation = { __typename?: 'Mutation', updateLeageCustomFees: { __typename?: 'League', id: number, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, isCustomFeeEnable?: boolean | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, currency?: string | null, rangeStart: number, rangeEnd: number, feeType: string, feeMode: string, serviceType: string, tournatedFee?: number | null, tournatedMinFee?: number | null, tournatedMaxFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, isMonetization?: boolean | null, isManagerPayingServiceFee?: boolean | null }> | null } };

export type UpdateLeagueMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LeagueGeoScope>;
  abbreviation?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  abbreviationLogo?: InputMaybe<Scalars['Upload']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Scalars['Int']['input']>;
  discipline?: InputMaybe<Scalars['String']['input']>;
  enableRankings?: InputMaybe<Scalars['Boolean']['input']>;
  enableLicense?: InputMaybe<Scalars['Boolean']['input']>;
  enableOnlinePayments?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  allowUnregisteredPlayers?: InputMaybe<Scalars['Boolean']['input']>;
  requireTournamentApproval?: InputMaybe<Scalars['Boolean']['input']>;
  globalCategoryLimitPerPlayer?: InputMaybe<Scalars['Float']['input']>;
  bannerCover?: InputMaybe<Scalars['Upload']['input']>;
  liveStreaming_sporfie_key?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateLeagueMutation = { __typename?: 'Mutation', updateLeague: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, status?: string | null, email?: string | null, website?: string | null, phone?: string | null, instagram?: string | null, abbreviation?: string | null, priority?: string | null, discipline?: string | null, logo?: string | null, abbreviationLogo?: string | null, allowUnregisteredPlayers?: boolean | null, liveStreaming_sporfie_key?: string | null } };

export type UpdatePlatformDocumentsMutationVariables = Exact<{
  input: UpdatePlatformInput;
}>;


export type UpdatePlatformDocumentsMutation = { __typename?: 'Mutation', updatePlatform: { __typename?: 'Platform', id: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null } };

export type UpdatePageMutationVariables = Exact<{
  input: UpdatePlatformPageInput;
}>;


export type UpdatePageMutation = { __typename?: 'Mutation', updatePlatformPage: { __typename?: 'PlatformPage', id: number, slug: PageSlug, blocks: Array<any> } };

export type UpdatePlatformSettingMutationVariables = Exact<{
  input: UpdatePlatformSettingInput;
}>;


export type UpdatePlatformSettingMutation = { __typename?: 'Mutation', updatePlatformSetting: { __typename?: 'PlatformSetting', id: number } };

export type UpdatePostCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
}>;


export type UpdatePostCategoryMutation = { __typename?: 'Mutation', updatePostCategory: { __typename?: 'PostCategory', id: number } };

export type UpdatePurchasedLicenseMutationVariables = Exact<{
  input: UpdatePurchasedLicenseInput;
}>;


export type UpdatePurchasedLicenseMutation = { __typename?: 'Mutation', updatePurchasedLicense: { __typename?: 'PurchasedLicense', id: number } };

export type UpdateUserPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUserPasswordByAdmin: { __typename?: 'User', id?: number | null, email?: string | null } };

export type FinishDashboardV3TourMutationVariables = Exact<{ [key: string]: never; }>;


export type FinishDashboardV3TourMutation = { __typename?: 'Mutation', finishDashboardV3Tour: { __typename?: 'User', id?: number | null, hasFinishedDashboardV3Tour?: boolean | null } };

export type GetAdditionalQuestionsQueryVariables = Exact<{
  filter?: InputMaybe<ListAdditionalQuestionInput>;
}>;


export type GetAdditionalQuestionsQuery = { __typename?: 'Query', additionalQuestions: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, fieldType?: string | null, fieldOptions?: string | null, askEachAthlete?: boolean | null, isMandatory?: boolean | null, isHide?: boolean | null }> };

export type BannerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type BannerQuery = { __typename?: 'Query', banner: { __typename?: 'Banner', id: number, role?: string | null, headLine?: string | null, subHeadLine?: string | null, buttonText?: string | null, buttonLink?: string | null, primaryColor?: string | null, status?: string | null, images?: string | null, sortingPosition?: number | null, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } };

export type BannersQueryVariables = Exact<{
  filter: ListBannerInput;
}>;


export type BannersQuery = { __typename?: 'Query', banners: Array<{ __typename?: 'Banner', id: number, headLine?: string | null, subHeadLine?: string | null, buttonText?: string | null, buttonLink?: string | null, primaryColor?: string | null, status?: string | null, role?: string | null, images?: string | null, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> };

export type GetBannerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetBannerQuery = { __typename?: 'Query', bannerNew: { __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null } };

export type GetBannersQueryVariables = Exact<{
  filter: ListBannersNewInput;
}>;


export type GetBannersQuery = { __typename?: 'Query', bannersNew: Array<{ __typename?: 'BannerNew', id: number, headLine: string, subHeadLine?: string | null, buttonText: string, buttonLink: string, primaryColor: string, status: BannerStatus, roles: Array<BannerRole>, legacyImages: Array<string>, sortingPosition?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, imageFiles?: Array<{ __typename?: 'StorageFileOutput', id: string, url: string }> | null }> };

export type GetClubByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetClubByIdQuery = { __typename?: 'Query', clubById?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number }> | null }> | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } | null };

export type GetClubByIdLegacyQueryVariables = Exact<{
  publicId: Scalars['String']['input'];
}>;


export type GetClubByIdLegacyQuery = { __typename?: 'Query', club: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, members?: Array<{ __typename?: 'ClubMember', id: number, status: string, createdAt: any, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null, clubServices?: Array<{ __typename?: 'ClubService', id: number, services?: { __typename?: 'ResourceService', id: number, service?: string | null, type?: string | null } | null }> | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, coaches?: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number }> | null }> | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } };

export type GetClubMembersQueryVariables = Exact<{
  input: ClubMemberListFilterInput;
}>;


export type GetClubMembersQuery = { __typename?: 'Query', clubMemberList: { __typename?: 'ClubMemberResult', total: number, clubMembers: Array<{ __typename?: 'ClubMember', id: number, status: string, createdAt: any, userRole?: string | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type GetClubMembersStatsQueryVariables = Exact<{
  clubId: Scalars['Int']['input'];
}>;


export type GetClubMembersStatsQuery = { __typename?: 'Query', clubMembersStats: { __typename?: 'ClubMemberStats', total: number, approved: number, pending: number, declined: number } };

export type GetClubServiceResourcesQueryVariables = Exact<{
  club?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetClubServiceResourcesQuery = { __typename?: 'Query', clubServiceResources: Array<{ __typename?: 'ClubServiceResource', id: number, title?: string | null, type?: string | null, clubService?: { __typename?: 'ClubService', id: number, services?: { __typename?: 'ResourceService', id: number, service?: string | null, type?: string | null } | null } | null }> };

export type GetClubsQueryVariables = Exact<{
  input: ClubListInput;
}>;


export type GetClubsQuery = { __typename?: 'Query', clubList: { __typename?: 'ClubListResult', total: number, clubs: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, tournamentsCount?: number | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, membersStats?: { __typename?: 'ClubMemberStats', total: number, approved: number, pending: number, declined: number } | null }> } };

export type GetClubsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetClubsByIdsQuery = { __typename?: 'Query', clubsByIds: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> };

export type GetClubsOldQueryVariables = Exact<{
  page: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  sport?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListClubInput>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetClubsOldQuery = { __typename?: 'Query', clubs: any };

export type SearchClubsQueryVariables = Exact<{
  input: ClubListInput;
}>;


export type SearchClubsQuery = { __typename?: 'Query', clubList: { __typename?: 'ClubListResult', total: number, clubs: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type GetCoachesQueryVariables = Exact<{
  input?: InputMaybe<PlatformCoachFilterInput>;
}>;


export type GetCoachesQuery = { __typename?: 'Query', platformCoaches: { __typename?: 'PlatformCoachResult', total: number, platformCoaches: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, students?: Array<{ __typename?: 'UserCoach', id: number }> | null, clubs?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null }> } };

export type GetPlatformCoachesQueryVariables = Exact<{
  input?: InputMaybe<PlatformCoachFilterInput>;
}>;


export type GetPlatformCoachesQuery = { __typename?: 'Query', platformCoaches: { __typename?: 'PlatformCoachResult', total: number, platformCoaches: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, clubs?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null, students?: Array<{ __typename?: 'UserCoach', id: number }> | null }> } };

export type GetDisciplinesQueryVariables = Exact<{
  filter?: InputMaybe<ListDisciplineInput>;
}>;


export type GetDisciplinesQuery = { __typename?: 'Query', disciplines: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> };

export type GetAdditionalServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdditionalServicesQuery = { __typename?: 'Query', resourceServices: Array<{ __typename?: 'ResourceService', id: number, service?: string | null }> };

export type GetAllNewsQueryVariables = Exact<{
  filter?: InputMaybe<ListNewsInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAllNewsQuery = { __typename?: 'Query', allNews: { __typename?: 'NewsResult', total: number, news: Array<{ __typename?: 'News', id: number, title?: string | null, postText?: string | null, image?: string | null, slug?: string | null, date?: any | null, createdAt: any, platform?: { __typename?: 'Platform', title?: string | null, id: number, platformLink?: string | null } | null, federationNews?: Array<{ __typename?: 'FederationNews', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null } | null }> | null, leagueNews?: Array<{ __typename?: 'LeagueNews', id: number, league?: { __typename?: 'League', title?: string | null } | null }> | null, clubNews?: Array<{ __typename?: 'ClubNews', club?: { __typename?: 'Club', clubName?: string | null } | null }> | null, author?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, avatar?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type GetAllPlatformNamesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPlatformNamesQuery = { __typename?: 'Query', allPlatformsNames: Array<{ __typename?: 'Platform', publicId: string, id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, tournatedEntryFee?: number | null, partnerEntryFee?: number | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null }> };

export type GetAllTournamentNamesQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListTournamentInput>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  startFrom?: InputMaybe<Scalars['String']['input']>;
  startTo?: InputMaybe<Scalars['String']['input']>;
  createdAtFrom?: InputMaybe<Scalars['String']['input']>;
  createdAtTo?: InputMaybe<Scalars['String']['input']>;
  isDashboard?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAllTournamentNamesQuery = { __typename?: 'Query', allTournamentNames: any };

export type GetGalleriesListQueryVariables = Exact<{
  filter?: InputMaybe<ListAlbumInput>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetGalleriesListQuery = { __typename?: 'Query', findAllAlbum: { __typename?: 'Albums', total: number, albums: Array<{ __typename?: 'Album', id: number, title?: string | null, thumbnail?: string | null, isSpecificTournament?: boolean | null, albumCustomEvent?: string | null, albumTags?: string | null, date?: string | null, createdAt: any, thumbnailFile?: { __typename?: 'StorageFile', id: string, url?: string | null } | null, media?: Array<{ __typename?: 'Media', id: number }> | null, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, league?: { __typename?: 'League', id: number, title?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null } | null }> } };

export type GetLeagueDocumentsQueryVariables = Exact<{
  filter?: InputMaybe<ListLeagueDocumentInput>;
}>;


export type GetLeagueDocumentsQuery = { __typename?: 'Query', leagueDocuments: Array<{ __typename?: 'LeagueDocument', id: number, document?: string | null, sortingPosition?: number | null, name?: string | null, updatedAt: any, createdAt: any }> };

export type GetLicenseQuestionsQueryVariables = Exact<{
  purchasedLicense?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLicenseQuestionsQuery = { __typename?: 'Query', licenseQuestions: Array<{ __typename?: 'LicenseQuestion', id: number, file?: string | null, answer?: string | null, fileType?: string | null, createdAt: any, updatedAt: any, question?: { __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null } | null }> };

export type GetOrganizationFederationsQueryVariables = Exact<{
  filter: ListOrganizationPlatformsInput;
}>;


export type GetOrganizationFederationsQuery = { __typename?: 'Query', organizationFederations: Array<{ __typename?: 'OrganizationFederationPublicDto', id: number, federation?: { __typename?: 'Federation', publicId: string, id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> | null } | null }> };

export type GetOrganizationPlatformByIdQueryVariables = Exact<{
  platformPublicId: Scalars['String']['input'];
}>;


export type GetOrganizationPlatformByIdQuery = { __typename?: 'Query', organizationPlatformByFields: { __typename?: 'OrganizationSubscription', id: number, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, platform?: { __typename?: 'Platform', abbreviation?: string | null, isMobileAppSupported?: boolean | null, landingLink?: string | null, platformLink?: string | null, timeZone?: string | null, liveScoring?: boolean | null, currency?: string | null, description?: string | null, onlinePayments?: boolean | null, companyEmail?: string | null, companyName?: string | null, isTournatedFeeVatEnable?: boolean | null, tournatedFeeVat?: number | null, signeeRole?: string | null, signeeFullName?: string | null, alreadyDomain?: boolean | null, primaryColor?: string | null, secondaryColor?: string | null, yourRequest?: string | null, darkEmblem?: string | null, lightEmblem?: string | null, favicon?: string | null, serviceProvider?: string | null, liveStreaming?: boolean | null, onlineBookingCourts?: boolean | null, licenseMemberships?: boolean | null, onlinePayment?: boolean | null, needIntegration?: boolean | null, needLanding?: boolean | null, fullAddress?: string | null, registrationNumber?: string | null, domain?: string | null, mobileApp?: boolean | null, isEnablePrice?: boolean | null, smm?: boolean | null, tournatedEntryFee?: number | null, partnerEntryFee?: number | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, graphicsForSmm?: boolean | null, isEnableMaintenance?: boolean | null, passcode?: string | null, maintenanceDescription?: string | null, maintenanceTitle?: string | null, subDomain?: string | null, liveStreaming_sporfie_key?: string | null, accessCode?: string | null, id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, language?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, club?: Array<{ __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, disciplines?: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> | null, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, rangeStart: number, rangeEnd: number, feeType: string, serviceType: string, feeMode: string, tournatedFee?: number | null, tournatedMinFee?: number | null, tournatedMaxFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, isMonetization?: boolean | null, isManagerPayingServiceFee?: boolean | null }> | null, platformSetting?: { __typename?: 'PlatformSetting', id: number, timeFormatPreference?: TimeFormatPreference | null, dateFormatPreference?: DateFormatPreference | null } | null, template?: { __typename?: 'Template', id: number } | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null } | null } };

export type GetOrganizationsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListFederationInput>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrganizationsQuery = { __typename?: 'Query', federations: { __typename?: 'FederationResult', total: number, federations: Array<{ __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> } };

export type GetPlatformThirdPartyLicensesQueryVariables = Exact<{
  platformPublicId: Scalars['String']['input'];
}>;


export type GetPlatformThirdPartyLicensesQuery = { __typename?: 'Query', platform: { __typename?: 'PlatformWithSubscription', id: number, thirdPartyLicenses?: Array<{ __typename?: 'ThirdPartyLicense', id: number, title?: string | null, organizationName?: string | null, organizationAbbreviation?: string | null, type?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> | null } };

export type GetPlatformsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPlatformInput>;
}>;


export type GetPlatformsQuery = { __typename?: 'Query', platforms: { __typename?: 'PlatformsResult', total: number, platforms: Array<{ __typename?: 'Platform', id: number, country?: string | null, description?: string | null, language?: string | null, platformType?: string | null, status?: string | null, title?: string | null, currency?: string | null, coverPhoto?: string | null, lightLogo?: string | null, companyName?: string | null, companyEmail?: string | null, onlinePayments?: boolean | null, liveScoring?: boolean | null, organization?: Array<{ __typename?: 'OrganizationPlatform', id: number, federation?: { __typename?: 'Federation', organizationName?: string | null, id: number } | null }> | null, sports?: Array<{ __typename?: 'PlateformSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null } | null }> | null }> } };

export type PostCategoriesQueryVariables = Exact<{
  filter?: InputMaybe<ListPostCategoryInput>;
}>;


export type PostCategoriesQuery = { __typename?: 'Query', postCategories: Array<{ __typename?: 'PostCategory', id: number, name: string, slug: string, createdAt?: any | null, updatedAt?: any | null, platform?: { __typename?: 'Platform', id: number, title?: string | null } | null }> };

export type PostCategoryQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type PostCategoryQuery = { __typename?: 'Query', postCategory: { __typename?: 'PostCategory', id: number, name: string, slug: string } };

export type GetRankingPointsQueryVariables = Exact<{
  filter?: InputMaybe<ListRankingPointsInput>;
}>;


export type GetRankingPointsQuery = { __typename?: 'Query', rankingPoints: Array<{ __typename?: 'RankingPoint', id: number, name?: string | null, place?: number | null, entries?: number | null, zeroPointsIfNoMatchesWon?: boolean | null, groupStagePoints?: boolean | null, priority?: string | null, points?: number | null, tournamentCategory?: Array<{ __typename?: 'RankingPointCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null }> | null, rankingPointRules?: Array<{ __typename?: 'RankingPointRule', id: number, sector?: string | null, coefficient?: number | null, type?: string | null, numberOfEntries?: string | null, operator?: string | null, skillLevel?: string | null, numberOfPlayers?: string | null, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null }> | null, rankingCategoryPoints?: Array<{ __typename?: 'RankingCategoryPoint', id: number, place?: string | null, points?: number | null, sortingPosition?: number | null, numPlaces?: number | null, segments?: Array<string> | null, bracketTypes?: Array<{ __typename?: 'RankingCategoryPointType', id: number, name?: string | null, bracketType?: string | null }> | null }> | null }> };

export type GetServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServicesQuery = { __typename?: 'Query', resourceServices: Array<{ __typename?: 'ResourceService', id: number, service?: string | null }> };

export type GetSportsQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListSportInput>;
  ids?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type GetSportsQuery = { __typename?: 'Query', sports: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null, discipline?: Array<{ __typename?: 'Discipline', id: number, title?: string | null }> | null }> };

export type GetSubscriptionsQueryVariables = Exact<{
  filter?: InputMaybe<SubscriptionFilter>;
}>;


export type GetSubscriptionsQuery = { __typename?: 'Query', subscriptions: { __typename?: 'SubscriptionsResult', subscriptions: Array<{ __typename?: 'Subscription', id: number, planName?: string | null, createdAt: any, validFrom: any, validTo: any, paymentMethod: string, amount?: number | null, currency: string, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> } };

export type GetTransactionsQueryVariables = Exact<{
  tournament?: InputMaybe<Scalars['Float']['input']>;
  platform?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListTransactionHistory>;
  paymentTypes?: InputMaybe<Array<TransactionType> | TransactionType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', allTransactionHistory: { __typename?: 'TransactionHistoryCount', totalCount: number, data: Array<{ __typename?: 'TransactionHistory', id: number, createdAt: any, amount: number, paidAmount: number, currency?: string | null, productType: string, paymentStatus: string, transactionType: string, tournatedFee?: number | null, partnerFee?: number | null, processingFee?: number | null, user: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null }, license?: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null } | null, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null } | null }> } };

export type GetVenuesQueryVariables = Exact<{
  filter?: InputMaybe<ListTournamentVenueInput>;
}>;


export type GetVenuesQuery = { __typename?: 'Query', tournamentVenues: Array<{ __typename?: 'TournamentVenue', id: number, title: string, city?: string | null, address?: string | null, country?: string | null, state?: string | null, createdAt: any, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null } | null } | null } | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null }> };

export type ExportLeagueRankingsCsvUrlQueryVariables = Exact<{
  league?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  sports?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExportLeagueRankingsCsvUrlQuery = { __typename?: 'Query', exportLeagueRankingsCsvUrl: string };

export type GetAllLeagueNamesQueryVariables = Exact<{
  filter: ListLeagueInput;
}>;


export type GetAllLeagueNamesQuery = { __typename?: 'Query', allLeaguesNames: Array<{ __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, tournamentsCount?: number | null, athlete?: Array<{ __typename?: 'Athlete', id: number }> | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } | null }> };

export type GetLeagueRankingDatesQueryVariables = Exact<{
  league?: InputMaybe<Scalars['Int']['input']>;
  rankingCategory?: InputMaybe<Scalars['Int']['input']>;
  leaguePublicId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetLeagueRankingDatesQuery = { __typename?: 'Query', leagueRankingDates: Array<{ __typename?: 'LeagueRankingDate', date: string, rankingCategoryId?: number | null }> };

export type GetLeagueCategoriesQueryVariables = Exact<{
  filter: ListLeagueCategoryInput;
}>;


export type GetLeagueCategoriesQuery = { __typename?: 'Query', leagueCategories: Array<{ __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null, tournaments?: Array<{ __typename?: 'CategoryTournament', id: number }> | null, categoryRules?: Array<{ __typename?: 'CategoryRule', id: number, sector?: string | null, tournamentCategories?: Array<{ __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null }> | null }> | null, tournamentCategories?: Array<{ __typename?: 'RankingTournamentCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null }> | null } | null }> };

export type GetLeagueMembersQueryVariables = Exact<{
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueMemberInput>;
}>;


export type GetLeagueMembersQuery = { __typename?: 'Query', leagueMembers: Array<{ __typename?: 'LeagueMember', tournamentCount?: number | null, id: number, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, role?: Array<{ __typename?: 'LeagueMemberRole', id: number, role?: { __typename?: 'Role', id: number, name?: string | null } | null }> | null, league?: { __typename?: 'League', id: number, title?: string | null } | null }> };

export type GetLeagueMembersCountQueryVariables = Exact<{
  organization?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueMembersCountQuery = { __typename?: 'Query', leagueMembers: Array<{ __typename?: 'LeagueMember', id: number }> };

export type GetLeagueRankingsHistoryQueryVariables = Exact<{
  filter: ListLeagueRankingInput;
  country?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueRankingsHistoryQuery = { __typename?: 'Query', leagueRankingsHistory: { __typename?: 'LeagueRankingResult', total: number, rankings: Array<{ __typename?: 'LeagueRanking', id: number, createdAt: any, date?: string | null, updatedAt: any, isPublic?: boolean | null, points?: number | null, place?: number | null, tournaments?: number | null, thirdPartyPoints?: string | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null, country?: string | null, email?: string | null, facebookLink?: string | null, instagramLink?: string | null, phone?: string | null, tiktokLink?: string | null, twitterLink?: string | null, website?: string | null, joinedFrom?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null } | null }> } };

export type GetLeagueRankingsQueryVariables = Exact<{
  filter: ListLeagueRankingInput;
  country?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueRankingsQuery = { __typename?: 'Query', leagueRankingsCustom: { __typename?: 'LeagueRankingResult', total: number, rankings: Array<{ __typename?: 'LeagueRanking', id: number, createdAt: any, date?: string | null, updatedAt: any, isPublic?: boolean | null, points?: number | null, place?: number | null, tournaments?: number | null, thirdPartyPoints?: string | null, league?: { __typename?: 'League', id: number, title?: string | null, logo?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, team?: { __typename?: 'Team', id: number, title?: string | null, image?: string | null, country?: string | null, email?: string | null, facebookLink?: string | null, instagramLink?: string | null, phone?: string | null, tiktokLink?: string | null, twitterLink?: string | null, website?: string | null, joinedFrom?: string | null, createdAt: any, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null } | null }> } };

export type GetLeaguesQueryVariables = Exact<{
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
  relations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeaguesQuery = { __typename?: 'Query', leagues: Array<{ __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, tournamentsCount?: number | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } | null }> };

export type GetOrganizationLeagueCategoriesQueryVariables = Exact<{
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListLeagueCategoryInput>;
}>;


export type GetOrganizationLeagueCategoriesQuery = { __typename?: 'Query', leagueCategories: Array<{ __typename?: 'LeagueCategory', id: number, category?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null, tournaments?: Array<{ __typename?: 'CategoryTournament', id: number }> | null, categoryRules?: Array<{ __typename?: 'CategoryRule', id: number, sector?: string | null, tournamentCategories?: Array<{ __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null }> | null }> | null, tournamentCategories?: Array<{ __typename?: 'RankingTournamentCategory', id: number, tournamentCategory?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null, rankingCategory?: { __typename?: 'Category', id: number, name?: string | null, type?: string | null, gender?: string | null, uniqueCode?: string | null, maxTournaments?: number | null, activeFrom?: any | null, activeTo?: any | null, sort?: string | null, ageLimit?: number | null, ageLimitType?: string | null, selectStage?: string | null, countries?: string | null, timePeriod?: string | null, countAllTournament?: boolean | null, isTeamRanking?: boolean | null } | null }> | null } | null, league?: { __typename?: 'League', id: number, title?: string | null } | null }> };

export type GetLeagueMemberStatsQueryVariables = Exact<{
  organizationPublicId?: InputMaybe<Scalars['String']['input']>;
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLeagueMemberStatsQuery = { __typename?: 'Query', getLeagueMemberStats: { __typename?: 'LeagueMemberStats', total: number, organizer: number, manager: number, referee: number } };

export type GetOrganizerLeagueMembersQueryVariables = Exact<{
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrganizerLeagueMembersQuery = { __typename?: 'Query', organizerLeagueMembers: { __typename?: 'OrganizerLeagueUsersResult', total: number, users: Array<{ __typename?: 'UserDetail', id: number, name?: string | null, middle_name?: string | null, surname?: string | null, name_armenian?: string | null, surname_armenian?: string | null, is_includes_latin?: boolean | null, email?: string | null, LVID?: string | null, itf_points?: string | null, phone?: string | null, nation?: string | null, representingCountry?: string | null, country?: string | null, locationCountry?: string | null, role?: string | null, additionalUserRole?: string | null, avatar?: string | null, bt_country?: string | null, user_status?: string | null, organization_type?: string | null, organization_full_name?: string | null, organization_abbr?: string | null, organization_email?: string | null, organization_phone?: string | null, organization_avatar?: string | null, organization_submitted?: string | null, organization_allow_op?: string | null, stripeAccountId?: string | null, stripeConnectOnboardingComplete?: boolean | null }> } };

export type GetAllLicensesQueryVariables = Exact<{
  filter?: InputMaybe<ListLicenseInput>;
}>;


export type GetAllLicensesQuery = { __typename?: 'Query', licenses: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null }> | null }> };

export type GetLicenseQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetLicenseQuery = { __typename?: 'Query', licenseById: { __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, licenseManager?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, leagues?: Array<{ __typename?: 'LicenseLeague', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null } | null }> | null, additionalQuestions?: Array<{ __typename?: 'AdditionalQuestion', id: number, question?: string | null, answer?: string | null, fieldType?: string | null, fieldOptions?: string | null, isMandatory?: boolean | null, askEachAthlete?: boolean | null }> | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } };

export type GetLicensesQueryVariables = Exact<{
  input: LicenseListInput;
}>;


export type GetLicensesQuery = { __typename?: 'Query', licenseList: { __typename?: 'LicenseResult', total: number, licenses: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null, issuedCount?: number | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null }> } };

export type GetLicensesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetLicensesByIdsQuery = { __typename?: 'Query', licensesByIds: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null }> };

export type SearchLicensesQueryVariables = Exact<{
  input: LicenseListInput;
}>;


export type SearchLicensesQuery = { __typename?: 'Query', licenseList: { __typename?: 'LicenseResult', total: number, licenses: Array<{ __typename?: 'License', id: number, title?: string | null, fee?: number | null, currency?: string | null, duration?: string | null, status?: string | null, startDate?: any | null, englishTitle?: string | null, endDate?: any | null, gender?: string | null, type: LicenseType, partnerLicenseFee?: number | null, tournatedLicenseFee?: number | null, ageFrom?: number | null, isManagerPayingServiceFee?: boolean | null, isManagerPayingTournatedFee?: boolean | null, isManagerPayingPartnerFee?: boolean | null, isManagerPayingPlatformFee?: boolean | null, isManagerPayingStripeFee?: boolean | null, isSendNotificationsToManager?: boolean | null, isAutoRenew?: boolean | null, isApprovalRequired?: boolean | null, nationality?: string | null, ageFromType?: string | null, ageTo?: number | null, ageToType?: string | null }> } };

export type GetNewsQueryVariables = Exact<{
  filter?: InputMaybe<ListNewsInput>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetNewsQuery = { __typename?: 'Query', allNews: { __typename?: 'NewsResult', total: number, news: Array<{ __typename?: 'News', id: number, title?: string | null, postText?: string | null, image?: string | null, slug?: string | null, date?: any | null, createdAt: any, author?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, leagueNews?: Array<{ __typename?: 'LeagueNews', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null }> | null }> } };

export type FindOrganizationQueryVariables = Exact<{
  filter: ListFederationInput;
}>;


export type FindOrganizationQuery = { __typename?: 'Query', findFederation: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } };

export type GetFederationsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetFederationsByIdsQuery = { __typename?: 'Query', federationsByIds: Array<{ __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null }> };

export type GetOrganizationQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetOrganizationQuery = { __typename?: 'Query', federation: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, legalEntityType?: LegalEntityType | null, bankEnabled?: boolean | null, bankName?: string | null, bankIban?: string | null, bankAccountHolder?: string | null, bankCompanyRegistrationNumber?: string | null, bankVatNumber?: string | null, bankCountry?: string | null, bankCity?: string | null, bankAddress?: string | null, bankPostalCode?: string | null, legalName?: string | null, personalIdentificationNumber?: string | null, legalSurname?: string | null, legalCountry?: string | null, legalEmail?: string | null, legalPhone?: string | null, legalCompanyName?: string | null, legalAddress?: string | null, signerName?: string | null, signerSurname?: string | null, signerRole?: string | null, signerEmail?: string | null, registrationNumber?: string | null, vatNumber?: string | null, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, platforms?: Array<{ __typename?: 'OrganizationPlatform', id: number, platform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null, platformSetting?: { __typename?: 'PlatformSetting', id: number, timeFormatPreference?: TimeFormatPreference | null, dateFormatPreference?: DateFormatPreference | null } | null, owner?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, name?: string | null, surname?: string | null, avatar?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null } | null, customFee?: Array<{ __typename?: 'PlatformFee', id: number, tournatedFee?: number | null, tournatedMaxFee?: number | null, tournatedMinFee?: number | null, tournatedMinPercentageFee?: number | null, tournatedMaxPercentageFee?: number | null, partnerFee?: number | null, partnerMinFee?: number | null, partnerMaxFee?: number | null, partnerMinPercentageFee?: number | null, partnerMaxPercentageFee?: number | null, currency?: string | null, rangeStart: number, rangeEnd: number, serviceType: string, feeMode: string, feeType: string, isMonetization?: boolean | null }> | null }> | null, boardMembers?: Array<{ __typename?: 'BoardMember', id: number, name: string, surname: string, role: OrganizationMemberRole, email: string, phone?: string | null, logo?: string | null, logoFileId?: string | null }> | null, clubMembers?: Array<{ __typename?: 'FederationClubMember', id: number, title: string, contactName: string, contactSurname: string, contactEmail: string, contactPhone?: string | null, contactRole: OrganizationMemberRole, logo?: string | null, registrationNumber?: string | null, website?: string | null, country: string, city?: string | null, address?: string | null, postalCode?: string | null, club?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null }> | null, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null } };

export type GetPartnerQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPartnerQuery = { __typename?: 'Query', partnerNew: { __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null } };

export type GetPartnersQueryVariables = Exact<{
  filter: ListPartnerNewInput;
}>;


export type GetPartnersQuery = { __typename?: 'Query', partnersNew: Array<{ __typename?: 'PartnerNew', id: number, title: string, link?: string | null, legacyImage?: string | null, sponsorText?: string | null, activeFrom?: any | null, activeTo?: any | null, sortingPosition?: number | null, imageFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null }> };

export type GetPlatformQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPlatformQuery = { __typename?: 'Query', platform: { __typename?: 'PlatformWithSubscription', id: number, title?: string | null, companyEmail?: string | null, darkLogo?: string | null, lightLogo?: string | null, lightEmblem?: string | null, darkEmblem?: string | null, favicon?: string | null, primaryColor?: string | null } };

export type GetPlatformWithDocumentsQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPlatformWithDocumentsQuery = { __typename?: 'Query', platform: { __typename?: 'PlatformWithSubscription', id: number, title?: string | null, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null, documentFolders?: Array<{ __typename?: 'DocumentFolder', id: string, title: string, isPrivate: boolean, sortingPosition: number, documents?: Array<{ __typename?: 'Document', id: number, title?: string | null, description?: string | null, isPrivate: boolean, sortingPosition: number, folderId?: string | null, fileId?: string | null, url?: string | null, downloadUrl?: string | null, fileSize?: number | null, contentType?: string | null }> | null }> | null } };

export type GetPlatformsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetPlatformsByIdsQuery = { __typename?: 'Query', platformsByIds: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> };

export type SearchPlatformsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<ListPlatformInput>;
}>;


export type SearchPlatformsQuery = { __typename?: 'Query', platforms: { __typename?: 'PlatformsResult', total: number, platforms: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> } };

export type GetPlatformDocumentQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type GetPlatformDocumentQuery = { __typename?: 'Query', platformDocumentNew: { __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> } };

export type GetPlatformDocumentsQueryVariables = Exact<{
  filter: ListPlatformDocumentsNewInput;
}>;


export type GetPlatformDocumentsQuery = { __typename?: 'Query', platformDocumentsNew: Array<{ __typename?: 'PlatformDocumentNew', id: number, name: string, legacyDocumentUrl?: string | null, displayOn: Array<PlatformDocumentDisplayOn>, createdAt: any, updatedAt: any, documentFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sortingPositions: Array<{ __typename?: 'PlatformDocumentSortingPosition', displayOn: PlatformDocumentDisplayOn, position: number }> }> };

export type PublicFileUrlsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PublicFileUrlsQuery = { __typename?: 'Query', publicFileUrls: Array<{ __typename?: 'PublicFileUrl', id: string, url?: string | null }> };

export type GetLeagueRankingsCronCategoriesQueryVariables = Exact<{
  leagueId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetLeagueRankingsCronCategoriesQuery = { __typename?: 'Query', leagueRankingsCronCategories?: { __typename?: 'LeagueRankingsCron', leagueId?: number | null, rankingCategoryIds: Array<number>, refreshRate?: RefreshRate | null, updateEvery?: string | null, time?: string | null, customSchedule?: Array<{ __typename?: 'CustomScheduleItem', date: string, time: string }> | null } | null };

export type SearchCoachesQueryVariables = Exact<{
  input?: InputMaybe<PlatformCoachFilterInput>;
}>;


export type SearchCoachesQuery = { __typename?: 'Query', platformCoaches: { __typename?: 'PlatformCoachResult', total: number, platformCoaches: Array<{ __typename?: 'PlatformCoach', id: number, category?: string | null, dateFrom?: string | null, dateTo?: string | null, status?: string | null, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type SearchSportsQueryVariables = Exact<{
  input: SportListInput;
}>;


export type SearchSportsQuery = { __typename?: 'Query', sportList: { __typename?: 'SportListResult', total: number, sports: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> } };

export type GetDashboardPaymentStatsQueryVariables = Exact<{
  platform?: InputMaybe<Scalars['Int']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDashboardPaymentStatsQuery = { __typename?: 'Query', allStatsTransactionData: any };

export type GetDashboardStatsQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['Int']['input']>;
  federationId?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetDashboardStatsQuery = { __typename?: 'Query', allStatsData: any };

export type GetTeamLeaguesQueryVariables = Exact<{
  teamId: Scalars['Int']['input'];
}>;


export type GetTeamLeaguesQuery = { __typename?: 'Query', fetchLeaguesByTeamId: Array<{ __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null, owner?: { __typename?: 'LeagueOwner', id: number, federation?: { __typename?: 'Federation', id: number, organizationName?: string | null, organizationAbbreviation?: string | null, about?: string | null, contactEmail?: string | null, contactPhone?: string | null, website?: string | null, organizationType?: OrganizationType | null, country?: string | null, logo?: string | null, geographicScope?: GeographicScope | null, enableLicenses?: boolean | null, enableCertificates?: boolean | null, enableApplicationForms?: boolean | null, enableRankings?: boolean | null, status?: string | null, createdAt: any, updatedAt: any, logoFile?: { __typename?: 'StorageFileOutput', id: string, url: string } | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null } | null } | null }> };

export type GetTeamTournamentsQueryVariables = Exact<{
  teamId: Scalars['Int']['input'];
  relations?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetTeamTournamentsQuery = { __typename?: 'Query', fetchTournamentsByTeamId: Array<{ __typename?: 'Tournament', id: number, title?: string | null, status?: string | null, startDate?: any | null, endDate?: any | null, logo?: string | null, createdAt: any, address?: string | null, city?: string | null, country?: string | null, approvalStatus?: string | null, poster?: string | null, leagueType: LeagueType, registrationRequestCount?: number | null, matchesCount?: number | null, entryDeadline?: any | null, withdrawlDeadline?: any | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, organizer?: { __typename?: 'LeagueMember', id: number, member?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, role?: Array<{ __typename?: 'LeagueMemberRole', id: number, role?: { __typename?: 'Role', id: number, name?: string | null } | null }> | null } | null, createdBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, league?: { __typename?: 'LeagueTournament', id: number, league?: { __typename?: 'League', id: number, title?: string | null, type?: LeagueGeoScope | null, status?: string | null, email?: string | null, website?: string | null, logo?: string | null, abbreviation?: string | null, discipline?: string | null, requireTournamentApproval?: boolean | null, phone?: string | null, instagram?: string | null, country?: string | null, priority?: string | null, bannerCover?: string | null, enableRankings?: boolean | null, enableLicense?: boolean | null, enableOnlinePayments?: boolean | null, allowUnregisteredPlayers?: boolean | null, globalCategoryLimitPerPlayer?: number | null, abbreviationLogo?: string | null, sports?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null } | null } | null, venues?: Array<{ __typename?: 'TournamentVenue', id: number, title: string, city?: string | null, country?: string | null, address?: string | null }> | null, tournamentCategory?: Array<{ __typename?: 'CategorySetting', category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null } | null }> | null }> };

export type GetTournamentCategoriesQueryVariables = Exact<{
  federation?: InputMaybe<Scalars['Int']['input']>;
  federationPublicId?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ListTournamentCategoryInput>;
  orderField?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTournamentCategoriesQuery = { __typename?: 'Query', tournamentCategories: Array<{ __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null }> };

export type GetRankingCategoryPointTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRankingCategoryPointTypesQuery = { __typename?: 'Query', rankingCategoryPointTypes: Array<{ __typename?: 'RankingCategoryPointType', id: number, name?: string | null, bracketType?: string | null }> };

export type GetTournamentRankingsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter: ListTournamentRankingInput;
  tournamentName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTournamentRankingsQuery = { __typename?: 'Query', tournamentRankings: { __typename?: 'TournamentRankingsResult', total: number, tournamentRankings: Array<{ __typename?: 'TournamentRanking', id: number, name?: string | null, isPublish?: boolean | null, createdAt: any, tournament?: { __typename?: 'Tournament', id: number, title?: string | null, startDate?: any | null, endDate?: any | null } | null, tournamentCategory?: { __typename?: 'CategorySetting', id: number, category?: { __typename?: 'TournamentCategory', name: string, type: string, gender: string, order?: string | null, enableMetrics?: boolean | null, team?: number | null, isAllowed?: boolean | null, moveToSingles?: boolean | null, categoryEntries?: string | null, enableLicense?: boolean | null, status?: string | null, ageLimit?: number | null, ageType?: string | null, id?: number | null, sortingPosition?: number | null, requiredUSPALicenses?: any | null, wprRatingType?: Wpr_Rating_Type | null, league?: { __typename?: 'LeagueTournamentCategory', id: number, league?: { __typename?: 'League', id: number, title?: string | null } | null } | null, discipline?: { __typename?: 'Discipline', id: number, title?: string | null } | null } | null } | null, rankings?: Array<{ __typename?: 'TournamentRankingsEntry', id: number, place?: string | null, points?: number | null, entry?: { __typename?: 'TournamentRegistration', id: number, users?: Array<{ __typename?: 'TournamentTeamMember', id: number, user?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> | null } | null }> | null }> } };

export type GetTournamentStatsQueryVariables = Exact<{
  federationId?: InputMaybe<Scalars['Float']['input']>;
  filter?: InputMaybe<ListLeagueInput>;
}>;


export type GetTournamentStatsQuery = { __typename?: 'Query', stats: { __typename?: 'TournamentList', allTournaments?: number | null, passedTournaments?: number | null, upcomingTournaments?: number | null, activeTournaments?: number | null, confirmedTournaments?: number | null, pendingTournaments?: number | null, inactiveTournaments?: number | null, declinedTournaments?: number | null } };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', total: number, users: Array<{ __typename?: 'UserDetailedInfo', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, middle_name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, mobileVerified?: boolean | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, citizenship?: string | null, street?: string | null, user_club_text?: string | null, dob?: string | null, ipinId?: string | null, duprId?: string | null, teId?: string | null, ltsU10Id?: string | null, atpId?: string | null, wtaId?: string | null, fideId?: string | null, teU12Id?: string | null, bonusU14?: string | null, bonusU12?: string | null, bonusPoints?: string | null, itf_points?: string | null, fivb?: string | null, bonusU16?: string | null, otherPoints?: string | null, createdAt: any, wprUserId?: string | null, additionalUserRole?: string | null, entries?: number | null, paidAmount?: number | null, signupSource?: Signup_Source | null, wprPlayerId?: string | null, lastResetPassword?: any | null, email_confirmed?: string | null, user_national_id_2?: string | null, uciId?: string | null, postalCode?: string | null, legalAddress?: string | null, legalCity?: string | null, legalCountry?: string | null, legalPostalCode?: string | null, educationStartDate?: any | null, educationEndDate?: any | null, educationalInstitutionId?: number | null, legalAddressSameAsPublic?: boolean | null, educationalInstitution?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, lastPasswordResetBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type GetPlatformUsersQueryVariables = Exact<{
  filter?: InputMaybe<ListUsersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  platformId?: InputMaybe<Scalars['Float']['input']>;
}>;


export type GetPlatformUsersQuery = { __typename?: 'Query', platformSpecificUsers: { __typename?: 'UsersResult', total: number, users: Array<{ __typename?: 'UserDetailedInfo', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, middle_name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, mobileVerified?: boolean | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, citizenship?: string | null, street?: string | null, user_club_text?: string | null, dob?: string | null, ipinId?: string | null, duprId?: string | null, teId?: string | null, ltsU10Id?: string | null, atpId?: string | null, wtaId?: string | null, fideId?: string | null, teU12Id?: string | null, bonusU14?: string | null, bonusU12?: string | null, bonusPoints?: string | null, itf_points?: string | null, fivb?: string | null, bonusU16?: string | null, otherPoints?: string | null, createdAt: any, wprUserId?: string | null, additionalUserRole?: string | null, entries?: number | null, paidAmount?: number | null, signupSource?: Signup_Source | null, wprPlayerId?: string | null, lastResetPassword?: any | null, email_confirmed?: string | null, user_national_id_2?: string | null, uciId?: string | null, postalCode?: string | null, legalAddress?: string | null, legalCity?: string | null, legalCountry?: string | null, legalPostalCode?: string | null, educationStartDate?: any | null, educationEndDate?: any | null, educationalInstitutionId?: number | null, legalAddressSameAsPublic?: boolean | null, educationalInstitution?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, lastPasswordResetBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null }> } };

export type GetUserQueryVariables = Exact<{
  query: FindUserInput;
  searchInWprDB?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUserQuery = { __typename?: 'Query', user: { __typename?: 'UserDetailedInfo', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, middle_name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, mobileVerified?: boolean | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, citizenship?: string | null, street?: string | null, user_club_text?: string | null, dob?: string | null, ipinId?: string | null, duprId?: string | null, teId?: string | null, ltsU10Id?: string | null, atpId?: string | null, wtaId?: string | null, fideId?: string | null, teU12Id?: string | null, bonusU14?: string | null, bonusU12?: string | null, bonusPoints?: string | null, itf_points?: string | null, fivb?: string | null, bonusU16?: string | null, otherPoints?: string | null, createdAt: any, wprUserId?: string | null, additionalUserRole?: string | null, entries?: number | null, paidAmount?: number | null, signupSource?: Signup_Source | null, wprPlayerId?: string | null, lastResetPassword?: any | null, email_confirmed?: string | null, user_national_id_2?: string | null, uciId?: string | null, postalCode?: string | null, legalAddress?: string | null, legalCity?: string | null, legalCountry?: string | null, legalPostalCode?: string | null, educationStartDate?: any | null, educationEndDate?: any | null, educationalInstitutionId?: number | null, legalAddressSameAsPublic?: boolean | null, educationalInstitution?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, lastPasswordResetBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } };

export type GetUserPlatformRoleQueryVariables = Exact<{
  platformPublicId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUserPlatformRoleQuery = { __typename?: 'Query', userRole: string };

export type GetUserRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'Role', id: number, name?: string | null }> };

export type GetUsersByIdsQueryVariables = Exact<{
  ids: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type GetUsersByIdsQuery = { __typename?: 'Query', usersByIds: Array<{ __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null }> };

export type GetUsersOldQueryVariables = Exact<{
  filter?: InputMaybe<ListUsersInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showDetailedInfo?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUsersOldQuery = { __typename?: 'Query', users: { __typename?: 'UsersResult', total: number, users: Array<{ __typename?: 'UserDetailedInfo', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, middle_name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, mobileVerified?: boolean | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, citizenship?: string | null, street?: string | null, user_club_text?: string | null, dob?: string | null, ipinId?: string | null, duprId?: string | null, teId?: string | null, ltsU10Id?: string | null, atpId?: string | null, wtaId?: string | null, fideId?: string | null, teU12Id?: string | null, bonusU14?: string | null, bonusU12?: string | null, bonusPoints?: string | null, itf_points?: string | null, fivb?: string | null, bonusU16?: string | null, otherPoints?: string | null, createdAt: any, wprUserId?: string | null, additionalUserRole?: string | null, entries?: number | null, paidAmount?: number | null, signupSource?: Signup_Source | null, wprPlayerId?: string | null, lastResetPassword?: any | null, email_confirmed?: string | null, user_national_id_2?: string | null, uciId?: string | null, postalCode?: string | null, legalAddress?: string | null, legalCity?: string | null, legalCountry?: string | null, legalPostalCode?: string | null, educationStartDate?: any | null, educationEndDate?: any | null, educationalInstitutionId?: number | null, legalAddressSameAsPublic?: boolean | null, educationalInstitution?: { __typename?: 'Club', id: number, clubName?: string | null, contactEmail?: string | null, status?: string | null, logo?: string | null, city?: string | null, country?: string | null, state?: string | null, address?: string | null, addressCoordinates?: any | null, howToFindUs?: string | null, contactPhone?: string | null, instagramLink?: string | null, facebookLink?: string | null, twitterLink?: string | null, tikTok?: string | null, linkedin?: string | null, website?: string | null, type?: Monolith_ClubType | null, isAthleteClub?: boolean | null, description?: string | null, isEnableEmail?: boolean | null, isAdminVerificationRequired?: boolean | null, sports?: Array<{ __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null }> | null, clubMainAdministrator?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null } | null, lastPasswordResetBy?: { __typename?: 'User', id?: number | null, email?: string | null, avatar?: string | null, name?: string | null, surname?: string | null, instagram?: string | null, phone?: string | null, role?: string | null, resetRequired?: boolean | null, nation?: string | null, gender?: string | null, city?: string | null, country?: string | null, mobileVerified?: boolean | null, dob?: string | null, uciId?: string | null, additionalUserRole?: string | null, postalCode?: string | null, wprPlayerId?: string | null, wprUserId?: string | null } | null, user_sports?: Array<{ __typename?: 'UserSport', id: number, sport?: { __typename?: 'Sport', id: number, title?: string | null, icon?: string | null, abbreviation?: string | null, enableDiscipline?: boolean | null, enableCourts?: boolean | null, enableStages?: boolean | null, displayDraws?: boolean | null, displayGroups?: boolean | null, displayLiveStandings?: boolean | null, displayOrderPlay?: boolean | null, displayListResults?: boolean | null, displayPendingResults?: boolean | null, displayTournamentResults?: boolean | null, textBox?: string | null } | null }> | null, platforms?: Array<{ __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null }> | null, signupPlatform?: { __typename?: 'Platform', id: number, title?: string | null, platformType?: string | null, status?: string | null, country?: string | null, currency?: string | null, language?: string | null, platformLink?: string | null, uploadFile?: string | null, coverPhoto?: string | null, lightLogo?: string | null, darkLogo?: string | null, darkEmblem?: string | null, timeZone?: string | null, tournatedLicenseFee?: number | null, partnerLicenseFee?: number | null, favicon?: string | null, lightEmblem?: string | null, primaryColor?: string | null, platformSetting?: { __typename?: 'PlatformSetting', dateFormatPreference?: DateFormatPreference | null, id: number, timeFormatPreference?: TimeFormatPreference | null } | null } | null }> } };

export type VideoMetadataQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type VideoMetadataQuery = { __typename?: 'Query', videoMetadata?: { __typename?: 'VideoMetadata', videoId: string, title?: string | null, durationSeconds?: number | null, thumbnailUrl?: string | null, publishedAt?: string | null } | null };

export const AlbumFragmentDoc = gql`
    fragment album on Album {
  id
  title
  thumbnail
  thumbnailFile {
    id
    url
  }
  isSpecificTournament
  albumCustomEvent
  albumTags
  date
  createdAt
}
    `;
export const AlbumWithMediaFragmentDoc = gql`
    fragment albumWithMedia on Album {
  id
  media {
    id
  }
}
    `;
export const BaseUserFragmentDoc = gql`
    fragment baseUser on User {
  id
  email
  avatar
  name
  surname
  instagram
  phone
  role
  resetRequired
  nation
  gender
  city
  country
  mobileVerified
  dob
  uciId
  additionalUserRole
  postalCode
  wprPlayerId
  wprUserId
}
    `;
export const AlbumWithCreatedByFragmentDoc = gql`
    fragment albumWithCreatedBy on Album {
  id
  createdBy {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const AlbumWithLeagueFragmentDoc = gql`
    fragment albumWithLeague on Album {
  id
  league {
    id
    title
  }
}
    `;
export const AlbumWithTournamentFragmentDoc = gql`
    fragment albumWithTournament on Album {
  id
  tournament {
    id
    title
  }
}
    `;
export const AthleteFragmentDoc = gql`
    fragment athlete on Athlete {
  id
  user: athlete {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const SportFragmentDoc = gql`
    fragment sport on Sport {
  id
  title
  icon
  abbreviation
  enableDiscipline
  enableCourts
  enableStages
  displayDraws
  displayGroups
  displayLiveStandings
  displayOrderPlay
  displayListResults
  displayPendingResults
  displayTournamentResults
  textBox
}
    `;
export const BannerFragmentDoc = gql`
    fragment banner on BannerNew {
  id
  headLine
  subHeadLine
  buttonText
  buttonLink
  primaryColor
  status
  sports {
    ...sport
  }
  roles
  imageFiles {
    id
    url
  }
  legacyImages
  sortingPosition
}
    ${SportFragmentDoc}`;
export const PlatformCoachFragmentDoc = gql`
    fragment platformCoach on PlatformCoach {
  id
  category
  dateFrom
  dateTo
  status
  sport {
    ...sport
  }
  user {
    ...baseUser
  }
}
    ${SportFragmentDoc}
${BaseUserFragmentDoc}`;
export const PlatformCoachWithStudentsFragmentDoc = gql`
    fragment platformCoachWithStudents on PlatformCoach {
  students {
    id
  }
}
    `;
export const ClubWithCoachesFragmentDoc = gql`
    fragment clubWithCoaches on Club {
  coaches {
    ...platformCoach
    ...platformCoachWithStudents
  }
}
    ${PlatformCoachFragmentDoc}
${PlatformCoachWithStudentsFragmentDoc}`;
export const ClubMemberStatsFragmentDoc = gql`
    fragment clubMemberStats on ClubMemberStats {
  total
  approved
  pending
  declined
}
    `;
export const ClubWithMembersCountFragmentDoc = gql`
    fragment clubWithMembersCount on Club {
  membersStats {
    ...clubMemberStats
  }
}
    ${ClubMemberStatsFragmentDoc}`;
export const BasePlatformFragmentDoc = gql`
    fragment basePlatform on Platform {
  id
  title
  platformType
  status
  country
  currency
  language
  platformLink
  country
  uploadFile
  coverPhoto
  lightLogo
  darkLogo
  darkEmblem
  timeZone
  platformSetting {
    dateFormatPreference
    id
    timeFormatPreference
  }
  tournatedLicenseFee
  partnerLicenseFee
  favicon
  lightEmblem
  primaryColor
}
    `;
export const ClubWithPlatformsFragmentDoc = gql`
    fragment clubWithPlatforms on Club {
  platforms {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const FederationFragmentDoc = gql`
    fragment federation on Federation {
  id
  organizationName
  organizationAbbreviation
  about
  logoFile {
    id
    url
  }
  contactEmail
  contactPhone
  website
  organizationType
  country
  logo
  geographicScope
  sports {
    ...sport
  }
  enableLicenses
  enableCertificates
  enableApplicationForms
  enableRankings
  status
  createdAt
  updatedAt
}
    ${SportFragmentDoc}`;
export const ClubWithFederationFragmentDoc = gql`
    fragment clubWithFederation on Club {
  federation {
    ...federation
  }
}
    ${FederationFragmentDoc}`;
export const ClubWithTournamentsCountFragmentDoc = gql`
    fragment clubWithTournamentsCount on Club {
  tournamentsCount
}
    `;
export const ClubMemberFragmentDoc = gql`
    fragment clubMember on ClubMember {
  id
  status
  createdAt
  user {
    ...baseUser
  }
  userRole
}
    ${BaseUserFragmentDoc}`;
export const ClubServiceFragmentDoc = gql`
    fragment clubService on ClubService {
  id
  services {
    id
    service
    type
  }
}
    `;
export const ClubServiceResourceFragmentDoc = gql`
    fragment clubServiceResource on ClubServiceResource {
  id
  title
  type
  clubService {
    ...clubService
  }
}
    ${ClubServiceFragmentDoc}`;
export const PlatformCoachWithPlatformFragmentDoc = gql`
    fragment platformCoachWithPlatform on PlatformCoach {
  platform {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const BaseClubFragmentDoc = gql`
    fragment baseClub on Club {
  id
  clubName
  contactEmail
  status
  logo
  city
  country
  state
  address
  addressCoordinates
  contactEmail
  howToFindUs
  contactPhone
  instagramLink
  facebookLink
  twitterLink
  tikTok
  linkedin
  website
  type
  isAthleteClub
  description
  isEnableEmail
  sports {
    ...sport
  }
  isAdminVerificationRequired
  clubMainAdministrator {
    ...baseUser
  }
}
    ${SportFragmentDoc}
${BaseUserFragmentDoc}`;
export const PlatformCoachWithClubsFragmentDoc = gql`
    fragment platformCoachWithClubs on PlatformCoach {
  clubs {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export const FederationWithPaymentDetailsFragmentDoc = gql`
    fragment federationWithPaymentDetails on Federation {
  legalEntityType
  bankEnabled
  bankName
  bankIban
  bankAccountHolder
  bankCompanyRegistrationNumber
  bankVatNumber
  bankCountry
  bankCity
  bankAddress
  bankPostalCode
}
    `;
export const FederationWithLegalDetailsFragmentDoc = gql`
    fragment federationWithLegalDetails on Federation {
  legalEntityType
  legalName
  personalIdentificationNumber
  legalSurname
  legalCountry
  legalEmail
  legalPhone
  legalCompanyName
  legalAddress
  signerName
  signerSurname
  signerRole
  signerEmail
  registrationNumber
  vatNumber
}
    `;
export const FederationWithPlatformsFragmentDoc = gql`
    fragment federationWithPlatforms on Federation {
  platforms {
    id
    platform {
      ...basePlatform
    }
  }
}
    ${BasePlatformFragmentDoc}`;
export const FederationWithManagersFragmentDoc = gql`
    fragment federationWithManagers on Federation {
  user {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const PlatformWithOwnerFragmentDoc = gql`
    fragment platformWithOwner on Platform {
  owner {
    ...federation
    ...federationWithManagers
  }
}
    ${FederationFragmentDoc}
${FederationWithManagersFragmentDoc}`;
export const PlatformFeeFragmentDoc = gql`
    fragment platformFee on PlatformFee {
  id
  tournatedFee
  tournatedMaxFee
  tournatedMinFee
  tournatedMinPercentageFee
  tournatedMaxPercentageFee
  partnerFee
  partnerMinFee
  partnerMaxFee
  partnerMinPercentageFee
  partnerMaxPercentageFee
  currency
  rangeStart
  rangeEnd
  serviceType
  feeMode
  feeType
  isMonetization
}
    `;
export const FederationWithPlatformsWithFeesFragmentDoc = gql`
    fragment federationWithPlatformsWithFees on Federation {
  platforms {
    id
    platform {
      ...basePlatform
      ...platformWithOwner
      customFee {
        ...platformFee
      }
    }
  }
}
    ${BasePlatformFragmentDoc}
${PlatformWithOwnerFragmentDoc}
${PlatformFeeFragmentDoc}`;
export const FederationWithFeesFragmentDoc = gql`
    fragment federationWithFees on Federation {
  platforms {
    id
    platform {
      id
    }
    customFee {
      ...platformFee
    }
  }
}
    ${PlatformFeeFragmentDoc}`;
export const BoardMemberFragmentDoc = gql`
    fragment boardMember on BoardMember {
  id
  name
  surname
  role
  email
  phone
  logo
  logoFileId
}
    `;
export const FederationWithBoardMembersFragmentDoc = gql`
    fragment federationWithBoardMembers on Federation {
  boardMembers {
    ...boardMember
  }
}
    ${BoardMemberFragmentDoc}`;
export const FederationClubMemberFragmentDoc = gql`
    fragment federationClubMember on FederationClubMember {
  id
  title
  contactName
  contactSurname
  contactEmail
  contactPhone
  contactRole
  logo
  registrationNumber
  club {
    ...baseClub
  }
  website
  country
  city
  address
  postalCode
}
    ${BaseClubFragmentDoc}`;
export const FederationWithClubMembersFragmentDoc = gql`
    fragment federationWithClubMembers on Federation {
  clubMembers {
    ...federationClubMember
  }
}
    ${FederationClubMemberFragmentDoc}`;
export const FederationWithDocumentsFragmentDoc = gql`
    fragment federationWithDocuments on Federation {
  documents {
    id
    title
    description
    isPrivate
    sortingPosition
    folderId
    fileId
    url
    downloadUrl
    fileSize
    contentType
  }
  documentFolders {
    id
    title
    isPrivate
    sortingPosition
    documents {
      id
      title
      description
      isPrivate
      sortingPosition
      folderId
      fileId
      url
      downloadUrl
      fileSize
      contentType
    }
  }
}
    `;
export const LeagueWithPlatformsFragmentDoc = gql`
    fragment leagueWithPlatforms on League {
  platforms {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const LeagueWithOwnerFragmentDoc = gql`
    fragment leagueWithOwner on League {
  federation {
    ...federation
  }
  owner {
    id
    federation {
      ...federation
    }
  }
}
    ${FederationFragmentDoc}`;
export const LeagueWithAthleteIdsFragmentDoc = gql`
    fragment leagueWithAthleteIds on League {
  athlete {
    id
  }
}
    `;
export const LeagueWithTournamentsCountFragmentDoc = gql`
    fragment leagueWithTournamentsCount on League {
  tournamentsCount
}
    `;
export const LeagueWithSocialLinksFragmentDoc = gql`
    fragment leagueWithSocialLinks on League {
  id
  socialLinks {
    socialMediaType
    url
  }
}
    `;
export const BaseCategoryFragmentDoc = gql`
    fragment baseCategory on Category {
  id
  name
  type
  gender
  uniqueCode
  maxTournaments
  activeFrom
  activeTo
  sort
  ageLimit
  ageLimitType
  selectStage
  countries
  timePeriod
  countAllTournament
  isTeamRanking
}
    `;
export const TournamentCategoryFragmentDoc = gql`
    fragment tournamentCategory on TournamentCategory {
  name
  type
  gender
  order
  enableMetrics
  team
  isAllowed
  moveToSingles
  categoryEntries
  enableLicense
  status
  ageLimit
  ageType
  id
  sortingPosition
  requiredUSPALicenses
  wprRatingType
}
    `;
export const TournamentCategoryWithLeagueFragmentDoc = gql`
    fragment tournamentCategoryWithLeague on TournamentCategory {
  league {
    id
    league {
      id
      title
    }
  }
}
    `;
export const DisciplineFragmentDoc = gql`
    fragment discipline on Discipline {
  id
  title
}
    `;
export const TournamentCategoryWithDisciplineFragmentDoc = gql`
    fragment tournamentCategoryWithDiscipline on TournamentCategory {
  discipline {
    ...discipline
  }
}
    ${DisciplineFragmentDoc}`;
export const CategoryRuleFragmentDoc = gql`
    fragment categoryRule on CategoryRule {
  id
  sector
  tournamentCategories {
    ...tournamentCategory
    ...tournamentCategoryWithLeague
    ...tournamentCategoryWithDiscipline
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}`;
export const RankingTournamentCategoryFragmentDoc = gql`
    fragment rankingTournamentCategory on RankingTournamentCategory {
  id
  tournamentCategory {
    ...tournamentCategory
    ...tournamentCategoryWithLeague
    ...tournamentCategoryWithDiscipline
  }
  rankingCategory {
    ...baseCategory
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}
${BaseCategoryFragmentDoc}`;
export const LeagueCategoryFragmentDoc = gql`
    fragment leagueCategory on LeagueCategory {
  id
  category {
    ...baseCategory
    tournaments {
      id
    }
    categoryRules {
      ...categoryRule
    }
    tournamentCategories: tournamentCatgories {
      ...rankingTournamentCategory
    }
  }
}
    ${BaseCategoryFragmentDoc}
${CategoryRuleFragmentDoc}
${RankingTournamentCategoryFragmentDoc}`;
export const LeagueCategoryWithLeagueFragmentDoc = gql`
    fragment leagueCategoryWithLeague on LeagueCategory {
  league {
    id
    title
  }
}
    `;
export const LeagueDocumentFragmentDoc = gql`
    fragment leagueDocument on LeagueDocument {
  id
  document
  sortingPosition
  name
  updatedAt
  createdAt
}
    `;
export const LeagueMemberWithLeagueFragmentDoc = gql`
    fragment leagueMemberWithLeague on LeagueMember {
  league {
    id
    title
  }
}
    `;
export const TeamFragmentDoc = gql`
    fragment team on Team {
  id
  title
  image
  country
  email
  facebookLink
  instagramLink
  phone
  tiktokLink
  twitterLink
  website
  joinedFrom
  createdAt
  createdBy {
    ...baseUser
  }
  sport {
    ...sport
  }
  discipline {
    ...discipline
  }
}
    ${BaseUserFragmentDoc}
${SportFragmentDoc}
${DisciplineFragmentDoc}`;
export const LeagueRankingFragmentDoc = gql`
    fragment leagueRanking on LeagueRanking {
  id
  createdAt
  date
  updatedAt
  isPublic
  points
  place
  tournaments
  thirdPartyPoints
  league {
    id
    title
    logo
  }
  user {
    ...baseUser
    userRatings {
      provider
      wtnRating
      duprSinglesRating
      duprDoublesRating
      wprCompetitionRating
      wprSocialRating
    }
  }
  team {
    ...team
  }
  rankingCategory {
    id
    category {
      ...baseCategory
    }
  }
}
    ${BaseUserFragmentDoc}
${TeamFragmentDoc}
${BaseCategoryFragmentDoc}`;
export const LicenseWithSportsFragmentDoc = gql`
    fragment licenseWithSports on License {
  sports {
    ...sport
  }
}
    ${SportFragmentDoc}`;
export const LicenseWithLicenseManagerFragmentDoc = gql`
    fragment licenseWithLicenseManager on License {
  licenseManager {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const QuestionFragmentDoc = gql`
    fragment question on AdditionalQuestion {
  id
  question
  answer
  fieldType
  fieldOptions
  isMandatory
  askEachAthlete
}
    `;
export const LicenseWithQuestionsFragmentDoc = gql`
    fragment licenseWithQuestions on License {
  additionalQuestions {
    ...question
  }
}
    ${QuestionFragmentDoc}`;
export const LicenseWithIssuedCountFragmentDoc = gql`
    fragment licenseWithIssuedCount on License {
  issuedCount
}
    `;
export const LeagueFragmentDoc = gql`
    fragment league on League {
  id
  title
  type
  status
  email
  website
  logo
  abbreviation
  discipline
  requireTournamentApproval
  phone
  instagram
  country
  priority
  bannerCover
  enableRankings
  enableLicense
  enableOnlinePayments
  allowUnregisteredPlayers
  globalCategoryLimitPerPlayer
  bannerCover
  abbreviationLogo
}
    `;
export const LicenseWithLeaguesFragmentDoc = gql`
    fragment licenseWithLeagues on License {
  leagues {
    id
    league {
      ...league
    }
  }
}
    ${LeagueFragmentDoc}`;
export const LicenseWithFederationFragmentDoc = gql`
    fragment licenseWithFederation on License {
  federation {
    ...federation
  }
}
    ${FederationFragmentDoc}`;
export const LicenseWithPlatformsFragmentDoc = gql`
    fragment licenseWithPlatforms on License {
  platforms {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const MatchCalendarMatchFragmentDoc = gql`
    fragment matchCalendarMatch on MatchCalendarMatch {
  id
  date
  time
  matchType
  status
  winnerSide
  sets {
    set
    side1
    side2
    side1Tiebreak
    side2Tiebreak
  }
  finalScore {
    side1
    side2
  }
}
    `;
export const MatchCalendarMatchWithCourtFragmentDoc = gql`
    fragment matchCalendarMatchWithCourt on MatchCalendarMatch {
  court {
    id
    name
  }
}
    `;
export const MatchCalendarMatchWithCategoryFragmentDoc = gql`
    fragment matchCalendarMatchWithCategory on MatchCalendarMatch {
  tournamentCategory {
    id
    category {
      ...tournamentCategory
    }
  }
}
    ${TournamentCategoryFragmentDoc}`;
export const MatchCalendarMatchWithEntriesFragmentDoc = gql`
    fragment matchCalendarMatchWithEntries on MatchCalendarMatch {
  team1Entry {
    id
    rank
    user {
      ...baseUser
    }
  }
  team2Entry {
    id
    rank
    user {
      ...baseUser
    }
  }
}
    ${BaseUserFragmentDoc}`;
export const MatchCalendarMatchWithTeamFragmentDoc = gql`
    fragment matchCalendarMatchWithTeam on MatchCalendarMatch {
  team {
    id
    title
    image
  }
  team1 {
    id
    title
    image
  }
  team2 {
    id
    title
    image
  }
}
    `;
export const NewsFragmentDoc = gql`
    fragment news on News {
  id
  title
  postText
  image
  slug
  date
  createdAt
  author {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const NewsWithLeaguesFragmentDoc = gql`
    fragment newsWithLeagues on News {
  leagueNews {
    id
    league {
      id
      title
    }
  }
}
    `;
export const PlatformWithSportsFragmentDoc = gql`
    fragment platformWithSports on Platform {
  sports {
    id
    sport {
      ...sport
    }
  }
}
    ${SportFragmentDoc}`;
export const ThirdPartyLicenseFragmentDoc = gql`
    fragment thirdPartyLicense on ThirdPartyLicense {
  id
  title
  sports {
    ...sport
  }
  organizationName
  organizationAbbreviation
  type
}
    ${SportFragmentDoc}`;
export const PlatformFragmentDoc = gql`
    fragment platform on Platform {
  ...basePlatform
  ...platformWithSports
  club {
    ...baseClub
  }
  abbreviation
  isMobileAppSupported
  landingLink
  platformLink
  owner {
    ...federation
  }
  disciplines {
    ...discipline
  }
  thirdPartyLicenses {
    ...thirdPartyLicense
  }
  timeZone
  liveScoring
  currency
  description
  onlinePayments
  companyEmail
  companyName
  customFee {
    id
    rangeStart
    rangeEnd
    feeType
    serviceType
    feeMode
    tournatedFee
    tournatedMinFee
    tournatedMaxFee
    tournatedMinPercentageFee
    tournatedMaxPercentageFee
    partnerFee
    partnerMinFee
    partnerMaxFee
    partnerMinPercentageFee
    partnerMaxPercentageFee
    currency
    isMonetization
    isManagerPayingServiceFee
  }
  isTournatedFeeVatEnable
  tournatedFeeVat
  signeeRole
  signeeFullName
  timeZone
  alreadyDomain
  primaryColor
  secondaryColor
  yourRequest
  darkEmblem
  lightEmblem
  favicon
  serviceProvider
  liveStreaming
  onlineBookingCourts
  licenseMemberships
  onlinePayment
  needIntegration
  needLanding
  fullAddress
  registrationNumber
  domain
  mobileApp
  isEnablePrice
  smm
  tournatedEntryFee
  partnerEntryFee
  tournatedLicenseFee
  partnerLicenseFee
  graphicsForSmm
  isEnableMaintenance
  passcode
  maintenanceDescription
  maintenanceTitle
  subDomain
  liveStreaming_sporfie_key
  platformSetting {
    id
    timeFormatPreference
    dateFormatPreference
  }
  template {
    id
  }
  accessCode
}
    ${BasePlatformFragmentDoc}
${PlatformWithSportsFragmentDoc}
${BaseClubFragmentDoc}
${FederationFragmentDoc}
${DisciplineFragmentDoc}
${ThirdPartyLicenseFragmentDoc}`;
export const OrganizationSubscriptionFragmentDoc = gql`
    fragment organizationSubscription on OrganizationSubscription {
  id
  federation {
    ...federation
    ...federationWithManagers
  }
  isTournatedFeeVatEnable
  tournatedFeeVat
  platform {
    ...platform
  }
}
    ${FederationFragmentDoc}
${FederationWithManagersFragmentDoc}
${PlatformFragmentDoc}`;
export const PartnerFragmentDoc = gql`
    fragment partner on PartnerNew {
  id
  title
  link
  legacyImage
  imageFile {
    id
    url
  }
  sponsorText
  activeFrom
  activeTo
  sortingPosition
}
    `;
export const PlatformWithFeesFragmentDoc = gql`
    fragment platformWithFees on Platform {
  customFee {
    ...platformFee
  }
  tournatedEntryFee
  tournatedLicenseFee
  partnerEntryFee
  partnerLicenseFee
}
    ${PlatformFeeFragmentDoc}`;
export const PlatformWithThirdPartyLicensesFragmentDoc = gql`
    fragment platformWithThirdPartyLicenses on PlatformWithSubscription {
  id
  thirdPartyLicenses {
    ...thirdPartyLicense
  }
}
    ${ThirdPartyLicenseFragmentDoc}`;
export const DocumentFragmentDoc = gql`
    fragment document on Document {
  id
  title
  description
  isPrivate
  sortingPosition
  folderId
  fileId
  url
  downloadUrl
  fileSize
  contentType
}
    `;
export const DocumentFolderFragmentDoc = gql`
    fragment documentFolder on DocumentFolder {
  id
  title
  isPrivate
  sortingPosition
  documents {
    ...document
  }
}
    ${DocumentFragmentDoc}`;
export const PlatformWithDocumentsFragmentDoc = gql`
    fragment platformWithDocuments on Platform {
  documents {
    ...document
  }
  documentFolders {
    ...documentFolder
  }
}
    ${DocumentFragmentDoc}
${DocumentFolderFragmentDoc}`;
export const PlatformWithSubscriptionDocumentsFragmentDoc = gql`
    fragment platformWithSubscriptionDocuments on PlatformWithSubscription {
  documents {
    ...document
  }
  documentFolders {
    ...documentFolder
  }
}
    ${DocumentFragmentDoc}
${DocumentFolderFragmentDoc}`;
export const PlatformDocumentFragmentDoc = gql`
    fragment platformDocument on PlatformDocumentNew {
  id
  name
  legacyDocumentUrl
  documentFile {
    id
    url
  }
  displayOn
  sortingPositions {
    displayOn
    position
  }
  createdAt
  updatedAt
}
    `;
export const LicenseFragmentDoc = gql`
    fragment license on License {
  id
  title
  fee
  currency
  duration
  status
  startDate
  englishTitle
  endDate
  gender
  type
  partnerLicenseFee
  tournatedLicenseFee
  ageFrom
  isManagerPayingServiceFee
  isManagerPayingTournatedFee
  isManagerPayingPartnerFee
  isManagerPayingPlatformFee
  isManagerPayingStripeFee
  isSendNotificationsToManager
  isAutoRenew
  isApprovalRequired
  nationality
  ageFromType
  ageTo
  ageToType
}
    `;
export const UserWithSportsFragmentDoc = gql`
    fragment userWithSports on User {
  user_sports {
    id
    team
    club {
      ...baseClub
    }
    sport {
      ...sport
    }
  }
}
    ${BaseClubFragmentDoc}
${SportFragmentDoc}`;
export const PurchasedLicenseFragmentDoc = gql`
    fragment purchasedLicense on PurchasedLicense {
  id
  paid
  startDate
  endDate
  currency
  type
  createdAt
  licenseStatus
  payment_status
  approvalStatus
  stripeFee
  paidTotal
  totalGross
  totalNet
  proof {
    fileUrl
    isUploaded
    uploadedAt
  }
  addedBy {
    ...baseUser
  }
  license {
    ...license
  }
  basePrice
  user {
    ...baseUser
    ...userWithSports
  }
  bankTransferDetails
  isBulkPurchase
}
    ${BaseUserFragmentDoc}
${LicenseFragmentDoc}
${UserWithSportsFragmentDoc}`;
export const PurchasedLicenseWithLinkedLicensesFragmentDoc = gql`
    fragment purchasedLicenseWithLinkedLicenses on PurchasedLicense {
  paidForUserLicenses {
    user {
      ...baseUser
    }
    license {
      ...license
    }
  }
}
    ${BaseUserFragmentDoc}
${LicenseFragmentDoc}`;
export const LicenseQuestionFragmentDoc = gql`
    fragment licenseQuestion on LicenseQuestion {
  id
  question {
    ...question
  }
  file
  answer
  fileType
  createdAt
  updatedAt
}
    ${QuestionFragmentDoc}`;
export const PurchasedLicenseWithQuestionsFragmentDoc = gql`
    fragment purchasedLicenseWithQuestions on PurchasedLicense {
  additionalQuestions {
    ...licenseQuestion
  }
}
    ${LicenseQuestionFragmentDoc}`;
export const PurchasedLicenseWithPlatformsFragmentDoc = gql`
    fragment purchasedLicenseWithPlatforms on PurchasedLicense {
  platforms {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const PurchasedLicenseWithFederationFragmentDoc = gql`
    fragment purchasedLicenseWithFederation on PurchasedLicense {
  federation {
    ...federation
  }
}
    ${FederationFragmentDoc}`;
export const RankingPointRuleFragmentDoc = gql`
    fragment rankingPointRule on RankingPointRule {
  id
  sector
  coefficient
  type
  numberOfEntries
  operator
  skillLevel
  numberOfPlayers
  tournamentCategory {
    ...tournamentCategory
    ...tournamentCategoryWithLeague
    ...tournamentCategoryWithDiscipline
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}`;
export const RankingCategoryPointFragmentDoc = gql`
    fragment rankingCategoryPoint on RankingCategoryPoint {
  id
  place
  points
  sortingPosition
  numPlaces
  segments
  bracketTypes {
    id
    name
    bracketType
  }
}
    `;
export const RankingPointFragmentDoc = gql`
    fragment rankingPoint on RankingPoint {
  id
  name
  place
  entries
  zeroPointsIfNoMatchesWon
  groupStagePoints
  priority
  points
  tournamentCategory {
    id
    tournamentCategory {
      ...tournamentCategory
      ...tournamentCategoryWithLeague
      ...tournamentCategoryWithDiscipline
    }
  }
  rankingPointRules {
    ...rankingPointRule
  }
  rankingCategoryPoints {
    ...rankingCategoryPoint
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}
${RankingPointRuleFragmentDoc}
${RankingCategoryPointFragmentDoc}`;
export const SportWithDisciplineFragmentDoc = gql`
    fragment sportWithDiscipline on Sport {
  id
  discipline {
    ...discipline
  }
}
    ${DisciplineFragmentDoc}`;
export const SubscriptionFragmentDoc = gql`
    fragment subscription on Subscription {
  id
  planName
  createdAt
  validFrom
  validTo
  paymentMethod
  amount
  currency
  createdBy {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const SubscriptionWithPlatformFragmentDoc = gql`
    fragment subscriptionWithPlatform on Subscription {
  platform: platformId {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const TeamWithClubFragmentDoc = gql`
    fragment teamWithClub on Team {
  club {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export const TeamMemberFragmentDoc = gql`
    fragment teamMember on TeamMember {
  id
  member {
    ...baseUser
  }
  role
}
    ${BaseUserFragmentDoc}`;
export const TeamWithMembersFragmentDoc = gql`
    fragment teamWithMembers on Team {
  members {
    ...teamMember
  }
  invitedMembers
}
    ${TeamMemberFragmentDoc}`;
export const TeamWithTournamentCountFragmentDoc = gql`
    fragment teamWithTournamentCount on Team {
  tournamentsCount
}
    `;
export const TeamWithFederationFragmentDoc = gql`
    fragment teamWithFederation on Team {
  federation {
    ...federation
  }
}
    ${FederationFragmentDoc}`;
export const TeamWithPlatformsFragmentDoc = gql`
    fragment teamWithPlatforms on Team {
  platforms {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const TournamentWithSportsFragmentDoc = gql`
    fragment tournamentWithSports on Tournament {
  sports {
    ...sport
  }
}
    ${SportFragmentDoc}`;
export const LeagueMemberFragmentDoc = gql`
    fragment leagueMember on LeagueMember {
  id
  member {
    ...baseUser
  }
  role {
    id
    role {
      id
      name
    }
  }
}
    ${BaseUserFragmentDoc}`;
export const TournamentWithOrganizerFragmentDoc = gql`
    fragment tournamentWithOrganizer on Tournament {
  organizer {
    ...leagueMember
  }
}
    ${LeagueMemberFragmentDoc}`;
export const TournamentWithCreatedByFragmentDoc = gql`
    fragment tournamentWithCreatedBy on Tournament {
  createdBy {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const TournamentWithClubFragmentDoc = gql`
    fragment tournamentWithClub on Tournament {
  club {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export const TournamentVenueFragmentDoc = gql`
    fragment tournamentVenue on TournamentVenue {
  id
  title
  city
  country
  address
}
    `;
export const TournamentWithVenuesFragmentDoc = gql`
    fragment tournamentWithVenues on Tournament {
  venues {
    ...tournamentVenue
  }
}
    ${TournamentVenueFragmentDoc}`;
export const TournamentWithCategoriesFragmentDoc = gql`
    fragment tournamentWithCategories on Tournament {
  tournamentCategory {
    category {
      ...tournamentCategory
    }
  }
}
    ${TournamentCategoryFragmentDoc}`;
export const TournamentCategoryLicenseFragmentDoc = gql`
    fragment tournamentCategoryLicense on TournamentCategoryLicense {
  id
  license {
    ...license
  }
}
    ${LicenseFragmentDoc}`;
export const TournamentRankingsEntryFragmentDoc = gql`
    fragment tournamentRankingsEntry on TournamentRankingsEntry {
  id
  place
  points
  entry {
    id
    users {
      id
      user {
        ...baseUser
      }
    }
  }
}
    ${BaseUserFragmentDoc}`;
export const TournamentRankingFragmentDoc = gql`
    fragment tournamentRanking on TournamentRanking {
  id
  name
  isPublish
  createdAt
  tournament {
    id
    title
    startDate
    endDate
  }
  tournamentCategory {
    id
    category {
      ...tournamentCategory
      ...tournamentCategoryWithLeague
      ...tournamentCategoryWithDiscipline
    }
  }
  rankings {
    ...tournamentRankingsEntry
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}
${TournamentRankingsEntryFragmentDoc}`;
export const TournamentStatsFragmentDoc = gql`
    fragment tournamentStats on TournamentList {
  allTournaments
  passedTournaments
  upcomingTournaments
  activeTournaments
  confirmedTournaments
  pendingTournaments
  inactiveTournaments
  declinedTournaments
}
    `;
export const TransactionFragmentDoc = gql`
    fragment transaction on TransactionHistory {
  id
  createdAt
  user {
    ...baseUser
  }
  amount
  paidAmount
  currency
  productType
  paymentStatus
  transactionType
  tournatedFee
  partnerFee
  processingFee
}
    ${BaseUserFragmentDoc}`;
export const TransactionWithPlatformFragmentDoc = gql`
    fragment transactionWithPlatform on TransactionHistory {
  platform {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const TransactionWithLicenseFragmentDoc = gql`
    fragment transactionWithLicense on TransactionHistory {
  license {
    ...license
  }
}
    ${LicenseFragmentDoc}`;
export const TournamentFragmentDoc = gql`
    fragment tournament on Tournament {
  id
  title
  status
  startDate
  endDate
  logo
  createdAt
  address
  city
  country
  approvalStatus
  poster
  leagueType
  registrationRequestCount
  matchesCount
  entryDeadline
  withdrawlDeadline
}
    `;
export const TransactionWithTournamentFragmentDoc = gql`
    fragment transactionWithTournament on TransactionHistory {
  tournament {
    ...tournament
  }
}
    ${TournamentFragmentDoc}`;
export const BaseDetailedUserFragmentDoc = gql`
    fragment baseDetailedUser on UserDetailedInfo {
  id
  email
  avatar
  name
  middle_name
  surname
  instagram
  phone
  role
  mobileVerified
  resetRequired
  nation
  gender
  city
  country
  citizenship
  street
  user_club_text
  dob
  ipinId
  duprId
  teId
  ltsU10Id
  atpId
  gender
  wtaId
  fideId
  teU12Id
  bonusU14
  bonusU12
  bonusPoints
  itf_points
  fivb
  bonusU16
  otherPoints
  createdAt
  wprUserId
  additionalUserRole
  entries
  paidAmount
  signupSource
  wprPlayerId
  lastResetPassword
  email_confirmed
  user_national_id_2
  uciId
  postalCode
  legalAddress
  legalCity
  legalCountry
  legalPostalCode
  educationStartDate
  educationEndDate
  educationalInstitutionId
  educationalInstitution {
    ...baseClub
  }
  legalAddressSameAsPublic
  lastPasswordResetBy {
    ...baseUser
  }
}
    ${BaseClubFragmentDoc}
${BaseUserFragmentDoc}`;
export const DetailedUserWithSportsFragmentDoc = gql`
    fragment detailedUserWithSports on UserDetailedInfo {
  user_sports {
    id
    sport {
      ...sport
    }
  }
}
    ${SportFragmentDoc}`;
export const DetailedUserWithPlatformsFragmentDoc = gql`
    fragment detailedUserWithPlatforms on UserDetailedInfo {
  platforms {
    ...basePlatform
  }
  signupPlatform {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;
export const DetailedUserWithFederationsFragmentDoc = gql`
    fragment detailedUserWithFederations on UserDetailedInfo {
  federations {
    ...federation
  }
}
    ${FederationFragmentDoc}`;
export const UserWithMemberOfPlatformsFragmentDoc = gql`
    fragment userWithMemberOfPlatforms on User {
  id
  member_of_plateforms {
    id
    platform {
      id
    }
  }
}
    `;
export const UserWithClubFragmentDoc = gql`
    fragment userWithClub on User {
  id
  user_club_id {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export const VenueFragmentDoc = gql`
    fragment venue on TournamentVenue {
  id
  title
  city
  address
  country
  state
  createdAt
}
    `;
export const LeagueWithSportsFragmentDoc = gql`
    fragment leagueWithSports on League {
  sports {
    ...sport
  }
}
    ${SportFragmentDoc}`;
export const TournamentWithLeagueFragmentDoc = gql`
    fragment tournamentWithLeague on Tournament {
  league {
    id
    league {
      ...league
      ...leagueWithSports
    }
  }
}
    ${LeagueFragmentDoc}
${LeagueWithSportsFragmentDoc}`;
export const VenueWithTournamentFragmentDoc = gql`
    fragment venueWithTournament on TournamentVenue {
  tournament {
    ...tournament
    ...tournamentWithLeague
  }
}
    ${TournamentFragmentDoc}
${TournamentWithLeagueFragmentDoc}`;
export const VenueWithClubFragmentDoc = gql`
    fragment venueWithClub on TournamentVenue {
  club {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export const UpdateLicenseDocument = gql`
    mutation updateLicense($input: UpdateLicenseInput!) {
  updateLicense(updateLicenseInput: $input) {
    ...license
  }
}
    ${LicenseFragmentDoc}`;
export type UpdateLicenseMutationFn = Apollo.MutationFunction<UpdateLicenseMutation, UpdateLicenseMutationVariables>;

/**
 * __useUpdateLicenseMutation__
 *
 * To run a mutation, you first call `useUpdateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLicenseMutation, { data, loading, error }] = useUpdateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLicenseMutation, UpdateLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLicenseMutation, UpdateLicenseMutationVariables>(UpdateLicenseDocument, options);
      }
export type UpdateLicenseMutationHookResult = ReturnType<typeof useUpdateLicenseMutation>;
export type UpdateLicenseMutationResult = Apollo.MutationResult<UpdateLicenseMutation>;
export type UpdateLicenseMutationOptions = Apollo.BaseMutationOptions<UpdateLicenseMutation, UpdateLicenseMutationVariables>;
export const BulkUpdateLicensesDocument = gql`
    mutation bulkUpdateLicenses($input: BulkUpdateLicenseInput!) {
  bulkUpdateLicenses(input: $input) {
    ...license
  }
}
    ${LicenseFragmentDoc}`;
export type BulkUpdateLicensesMutationFn = Apollo.MutationFunction<BulkUpdateLicensesMutation, BulkUpdateLicensesMutationVariables>;

/**
 * __useBulkUpdateLicensesMutation__
 *
 * To run a mutation, you first call `useBulkUpdateLicensesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkUpdateLicensesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkUpdateLicensesMutation, { data, loading, error }] = useBulkUpdateLicensesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkUpdateLicensesMutation(baseOptions?: Apollo.MutationHookOptions<BulkUpdateLicensesMutation, BulkUpdateLicensesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkUpdateLicensesMutation, BulkUpdateLicensesMutationVariables>(BulkUpdateLicensesDocument, options);
      }
export type BulkUpdateLicensesMutationHookResult = ReturnType<typeof useBulkUpdateLicensesMutation>;
export type BulkUpdateLicensesMutationResult = Apollo.MutationResult<BulkUpdateLicensesMutation>;
export type BulkUpdateLicensesMutationOptions = Apollo.BaseMutationOptions<BulkUpdateLicensesMutation, BulkUpdateLicensesMutationVariables>;
export const AddAthleteDocument = gql`
    mutation addAthlete($league: Int!, $athlete: Int!) {
  createAthlete(createAthleteInput: {league: $league, athlete: $athlete}) {
    id
  }
}
    `;
export type AddAthleteMutationFn = Apollo.MutationFunction<AddAthleteMutation, AddAthleteMutationVariables>;

/**
 * __useAddAthleteMutation__
 *
 * To run a mutation, you first call `useAddAthleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAthleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAthleteMutation, { data, loading, error }] = useAddAthleteMutation({
 *   variables: {
 *      league: // value for 'league'
 *      athlete: // value for 'athlete'
 *   },
 * });
 */
export function useAddAthleteMutation(baseOptions?: Apollo.MutationHookOptions<AddAthleteMutation, AddAthleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAthleteMutation, AddAthleteMutationVariables>(AddAthleteDocument, options);
      }
export type AddAthleteMutationHookResult = ReturnType<typeof useAddAthleteMutation>;
export type AddAthleteMutationResult = Apollo.MutationResult<AddAthleteMutation>;
export type AddAthleteMutationOptions = Apollo.BaseMutationOptions<AddAthleteMutation, AddAthleteMutationVariables>;
export const AddUserToPlatformDocument = gql`
    mutation addUserToPlatform($userId: Int!, $platformId: Int!) {
  updateUsersPlatform(userId: $userId, platformId: $platformId) {
    email
    name
  }
}
    `;
export type AddUserToPlatformMutationFn = Apollo.MutationFunction<AddUserToPlatformMutation, AddUserToPlatformMutationVariables>;

/**
 * __useAddUserToPlatformMutation__
 *
 * To run a mutation, you first call `useAddUserToPlatformMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddUserToPlatformMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addUserToPlatformMutation, { data, loading, error }] = useAddUserToPlatformMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useAddUserToPlatformMutation(baseOptions?: Apollo.MutationHookOptions<AddUserToPlatformMutation, AddUserToPlatformMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddUserToPlatformMutation, AddUserToPlatformMutationVariables>(AddUserToPlatformDocument, options);
      }
export type AddUserToPlatformMutationHookResult = ReturnType<typeof useAddUserToPlatformMutation>;
export type AddUserToPlatformMutationResult = Apollo.MutationResult<AddUserToPlatformMutation>;
export type AddUserToPlatformMutationOptions = Apollo.BaseMutationOptions<AddUserToPlatformMutation, AddUserToPlatformMutationVariables>;
export const InitiateForgotPasswordFlowDocument = gql`
    mutation initiateForgotPasswordFlow($email: String!, $redirectURL: String) {
  forgetPassword(email: $email, redirectURL: $redirectURL) {
    success
    statusCode
  }
}
    `;
export type InitiateForgotPasswordFlowMutationFn = Apollo.MutationFunction<InitiateForgotPasswordFlowMutation, InitiateForgotPasswordFlowMutationVariables>;

/**
 * __useInitiateForgotPasswordFlowMutation__
 *
 * To run a mutation, you first call `useInitiateForgotPasswordFlowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateForgotPasswordFlowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateForgotPasswordFlowMutation, { data, loading, error }] = useInitiateForgotPasswordFlowMutation({
 *   variables: {
 *      email: // value for 'email'
 *      redirectURL: // value for 'redirectURL'
 *   },
 * });
 */
export function useInitiateForgotPasswordFlowMutation(baseOptions?: Apollo.MutationHookOptions<InitiateForgotPasswordFlowMutation, InitiateForgotPasswordFlowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateForgotPasswordFlowMutation, InitiateForgotPasswordFlowMutationVariables>(InitiateForgotPasswordFlowDocument, options);
      }
export type InitiateForgotPasswordFlowMutationHookResult = ReturnType<typeof useInitiateForgotPasswordFlowMutation>;
export type InitiateForgotPasswordFlowMutationResult = Apollo.MutationResult<InitiateForgotPasswordFlowMutation>;
export type InitiateForgotPasswordFlowMutationOptions = Apollo.BaseMutationOptions<InitiateForgotPasswordFlowMutation, InitiateForgotPasswordFlowMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  adminLogin(query: {email: $email, password: $password}) {
    id
    isAuthenticationRequired
    accessToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LoginOtpDocument = gql`
    mutation loginOtp($email: String!, $otp: String!) {
  adminOTPVerification(email: $email, otp: $otp) {
    id
    accessToken
  }
}
    `;
export type LoginOtpMutationFn = Apollo.MutationFunction<LoginOtpMutation, LoginOtpMutationVariables>;

/**
 * __useLoginOtpMutation__
 *
 * To run a mutation, you first call `useLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginOtpMutation, { data, loading, error }] = useLoginOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *      otp: // value for 'otp'
 *   },
 * });
 */
export function useLoginOtpMutation(baseOptions?: Apollo.MutationHookOptions<LoginOtpMutation, LoginOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginOtpMutation, LoginOtpMutationVariables>(LoginOtpDocument, options);
      }
export type LoginOtpMutationHookResult = ReturnType<typeof useLoginOtpMutation>;
export type LoginOtpMutationResult = Apollo.MutationResult<LoginOtpMutation>;
export type LoginOtpMutationOptions = Apollo.BaseMutationOptions<LoginOtpMutation, LoginOtpMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $password: String!, $isLogoutFromAllDevices: Boolean) {
  forgotResetPassword(
    input: {resetToken: $token, password: $password, isLogoutFromAllDevices: $isLogoutFromAllDevices}
  ) {
    id
    name
    email
    accessToken
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      isLogoutFromAllDevices: // value for 'isLogoutFromAllDevices'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CreateBannerDocument = gql`
    mutation createBanner($input: CreateBannerInputNew!) {
  createBannerNew(createBannerInput: $input) {
    ...banner
  }
}
    ${BannerFragmentDoc}`;
export type CreateBannerMutationFn = Apollo.MutationFunction<CreateBannerMutation, CreateBannerMutationVariables>;

/**
 * __useCreateBannerMutation__
 *
 * To run a mutation, you first call `useCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBannerMutation, { data, loading, error }] = useCreateBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBannerMutation(baseOptions?: Apollo.MutationHookOptions<CreateBannerMutation, CreateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBannerMutation, CreateBannerMutationVariables>(CreateBannerDocument, options);
      }
export type CreateBannerMutationHookResult = ReturnType<typeof useCreateBannerMutation>;
export type CreateBannerMutationResult = Apollo.MutationResult<CreateBannerMutation>;
export type CreateBannerMutationOptions = Apollo.BaseMutationOptions<CreateBannerMutation, CreateBannerMutationVariables>;
export const LegacyCreateBannerDocument = gql`
    mutation legacyCreateBanner($platformPublicId: String!, $headLine: String!, $subHeadLine: String!, $buttonText: String!, $buttonLink: String!, $primaryColor: String!, $status: String!, $role: String, $sports: [Int!], $images: [Upload!], $addedBy: Int) {
  createBanner(
    createBannerInput: {platformPublicId: $platformPublicId, headLine: $headLine, subHeadLine: $subHeadLine, buttonText: $buttonText, buttonLink: $buttonLink, primaryColor: $primaryColor, status: $status, role: $role, sports: $sports, images: $images, addedBy: $addedBy}
  ) {
    id
  }
}
    `;
export type LegacyCreateBannerMutationFn = Apollo.MutationFunction<LegacyCreateBannerMutation, LegacyCreateBannerMutationVariables>;

/**
 * __useLegacyCreateBannerMutation__
 *
 * To run a mutation, you first call `useLegacyCreateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLegacyCreateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [legacyCreateBannerMutation, { data, loading, error }] = useLegacyCreateBannerMutation({
 *   variables: {
 *      platformPublicId: // value for 'platformPublicId'
 *      headLine: // value for 'headLine'
 *      subHeadLine: // value for 'subHeadLine'
 *      buttonText: // value for 'buttonText'
 *      buttonLink: // value for 'buttonLink'
 *      primaryColor: // value for 'primaryColor'
 *      status: // value for 'status'
 *      role: // value for 'role'
 *      sports: // value for 'sports'
 *      images: // value for 'images'
 *      addedBy: // value for 'addedBy'
 *   },
 * });
 */
export function useLegacyCreateBannerMutation(baseOptions?: Apollo.MutationHookOptions<LegacyCreateBannerMutation, LegacyCreateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LegacyCreateBannerMutation, LegacyCreateBannerMutationVariables>(LegacyCreateBannerDocument, options);
      }
export type LegacyCreateBannerMutationHookResult = ReturnType<typeof useLegacyCreateBannerMutation>;
export type LegacyCreateBannerMutationResult = Apollo.MutationResult<LegacyCreateBannerMutation>;
export type LegacyCreateBannerMutationOptions = Apollo.BaseMutationOptions<LegacyCreateBannerMutation, LegacyCreateBannerMutationVariables>;
export const LegacyUpdateBannerDocument = gql`
    mutation legacyUpdateBanner($id: Int!, $platformPublicId: String!, $headLine: String!, $subHeadLine: String!, $buttonText: String!, $buttonLink: String!, $primaryColor: String!, $status: String!, $role: String, $sports: [Int!], $images: [Upload!], $imageURLs: [String!]) {
  updateBanner(
    updateBannerInput: {id: $id, platformPublicId: $platformPublicId, headLine: $headLine, subHeadLine: $subHeadLine, buttonText: $buttonText, buttonLink: $buttonLink, primaryColor: $primaryColor, status: $status, role: $role, sports: $sports, images: $images, imageURLs: $imageURLs}
  ) {
    id
  }
}
    `;
export type LegacyUpdateBannerMutationFn = Apollo.MutationFunction<LegacyUpdateBannerMutation, LegacyUpdateBannerMutationVariables>;

/**
 * __useLegacyUpdateBannerMutation__
 *
 * To run a mutation, you first call `useLegacyUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLegacyUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [legacyUpdateBannerMutation, { data, loading, error }] = useLegacyUpdateBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      platformPublicId: // value for 'platformPublicId'
 *      headLine: // value for 'headLine'
 *      subHeadLine: // value for 'subHeadLine'
 *      buttonText: // value for 'buttonText'
 *      buttonLink: // value for 'buttonLink'
 *      primaryColor: // value for 'primaryColor'
 *      status: // value for 'status'
 *      role: // value for 'role'
 *      sports: // value for 'sports'
 *      images: // value for 'images'
 *      imageURLs: // value for 'imageURLs'
 *   },
 * });
 */
export function useLegacyUpdateBannerMutation(baseOptions?: Apollo.MutationHookOptions<LegacyUpdateBannerMutation, LegacyUpdateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LegacyUpdateBannerMutation, LegacyUpdateBannerMutationVariables>(LegacyUpdateBannerDocument, options);
      }
export type LegacyUpdateBannerMutationHookResult = ReturnType<typeof useLegacyUpdateBannerMutation>;
export type LegacyUpdateBannerMutationResult = Apollo.MutationResult<LegacyUpdateBannerMutation>;
export type LegacyUpdateBannerMutationOptions = Apollo.BaseMutationOptions<LegacyUpdateBannerMutation, LegacyUpdateBannerMutationVariables>;
export const RemoveBannerDocument = gql`
    mutation removeBanner($id: Int!) {
  deleteBannerNew(id: $id) {
    id
  }
}
    `;
export type RemoveBannerMutationFn = Apollo.MutationFunction<RemoveBannerMutation, RemoveBannerMutationVariables>;

/**
 * __useRemoveBannerMutation__
 *
 * To run a mutation, you first call `useRemoveBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBannerMutation, { data, loading, error }] = useRemoveBannerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBannerMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBannerMutation, RemoveBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBannerMutation, RemoveBannerMutationVariables>(RemoveBannerDocument, options);
      }
export type RemoveBannerMutationHookResult = ReturnType<typeof useRemoveBannerMutation>;
export type RemoveBannerMutationResult = Apollo.MutationResult<RemoveBannerMutation>;
export type RemoveBannerMutationOptions = Apollo.BaseMutationOptions<RemoveBannerMutation, RemoveBannerMutationVariables>;
export const UpdateBannerDocument = gql`
    mutation updateBanner($input: UpdateBannerInputNew!) {
  updateBannerNew(updateBannerInput: $input) {
    ...banner
  }
}
    ${BannerFragmentDoc}`;
export type UpdateBannerMutationFn = Apollo.MutationFunction<UpdateBannerMutation, UpdateBannerMutationVariables>;

/**
 * __useUpdateBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBannerMutation, { data, loading, error }] = useUpdateBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBannerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBannerMutation, UpdateBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBannerMutation, UpdateBannerMutationVariables>(UpdateBannerDocument, options);
      }
export type UpdateBannerMutationHookResult = ReturnType<typeof useUpdateBannerMutation>;
export type UpdateBannerMutationResult = Apollo.MutationResult<UpdateBannerMutation>;
export type UpdateBannerMutationOptions = Apollo.BaseMutationOptions<UpdateBannerMutation, UpdateBannerMutationVariables>;
export const UpdateBulkBannerDocument = gql`
    mutation updateBulkBanner($input: UpdateBulkBannerInputNew!) {
  updateBulkBannerNew(updateBulkBannerInput: $input) {
    ...banner
  }
}
    ${BannerFragmentDoc}`;
export type UpdateBulkBannerMutationFn = Apollo.MutationFunction<UpdateBulkBannerMutation, UpdateBulkBannerMutationVariables>;

/**
 * __useUpdateBulkBannerMutation__
 *
 * To run a mutation, you first call `useUpdateBulkBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkBannerMutation, { data, loading, error }] = useUpdateBulkBannerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkBannerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkBannerMutation, UpdateBulkBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkBannerMutation, UpdateBulkBannerMutationVariables>(UpdateBulkBannerDocument, options);
      }
export type UpdateBulkBannerMutationHookResult = ReturnType<typeof useUpdateBulkBannerMutation>;
export type UpdateBulkBannerMutationResult = Apollo.MutationResult<UpdateBulkBannerMutation>;
export type UpdateBulkBannerMutationOptions = Apollo.BaseMutationOptions<UpdateBulkBannerMutation, UpdateBulkBannerMutationVariables>;
export const CreateClubDocument = gql`
    mutation createClub($clubName: String!, $address: String, $city: String, $state: String, $description: String, $logo: Upload, $contactEmail: String, $howToFindUs: String, $contactPhone: String, $country: String!, $instagramLink: String, $facebookLink: String, $twitterLink: String, $tikTok: String, $linkedin: String, $website: String, $clubCoaches: [Int!]!, $clubMainAdministrator: Int!, $clubAdministrators: [Int!]!, $clubServices: [Int!]!, $createClubServiceResourceInput: [CreateClubServiceResourceInput!]!, $federation: Int, $federationPublicId: String, $platformPublicId: String, $isAthleteClub: Boolean, $status: String, $isEnableEmail: Boolean, $isAdminVerificationRequired: Boolean, $sports: [Int!], $addressCoordinates: JSON) {
  createClub(
    createClubInput: {clubName: $clubName, address: $address, city: $city, state: $state, logo: $logo, howToFindUs: $howToFindUs, contactEmail: $contactEmail, contactPhone: $contactPhone, tikTok: $tikTok, country: $country, instagramLink: $instagramLink, facebookLink: $facebookLink, twitterLink: $twitterLink, linkedin: $linkedin, website: $website, clubCoaches: $clubCoaches, clubMainAdministrator: $clubMainAdministrator, clubAdministrators: $clubAdministrators, clubServices: $clubServices, federation: $federation, federationPublicId: $federationPublicId, platformPublicId: $platformPublicId, isAthleteClub: $isAthleteClub, status: $status, description: $description, isEnableEmail: $isEnableEmail, isAdminVerificationRequired: $isAdminVerificationRequired, sports: $sports, addressCoordinates: $addressCoordinates}
    createClubServiceResourceInput: $createClubServiceResourceInput
  ) {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;
export type CreateClubMutationFn = Apollo.MutationFunction<CreateClubMutation, CreateClubMutationVariables>;

/**
 * __useCreateClubMutation__
 *
 * To run a mutation, you first call `useCreateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClubMutation, { data, loading, error }] = useCreateClubMutation({
 *   variables: {
 *      clubName: // value for 'clubName'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      description: // value for 'description'
 *      logo: // value for 'logo'
 *      contactEmail: // value for 'contactEmail'
 *      howToFindUs: // value for 'howToFindUs'
 *      contactPhone: // value for 'contactPhone'
 *      country: // value for 'country'
 *      instagramLink: // value for 'instagramLink'
 *      facebookLink: // value for 'facebookLink'
 *      twitterLink: // value for 'twitterLink'
 *      tikTok: // value for 'tikTok'
 *      linkedin: // value for 'linkedin'
 *      website: // value for 'website'
 *      clubCoaches: // value for 'clubCoaches'
 *      clubMainAdministrator: // value for 'clubMainAdministrator'
 *      clubAdministrators: // value for 'clubAdministrators'
 *      clubServices: // value for 'clubServices'
 *      createClubServiceResourceInput: // value for 'createClubServiceResourceInput'
 *      federation: // value for 'federation'
 *      federationPublicId: // value for 'federationPublicId'
 *      platformPublicId: // value for 'platformPublicId'
 *      isAthleteClub: // value for 'isAthleteClub'
 *      status: // value for 'status'
 *      isEnableEmail: // value for 'isEnableEmail'
 *      isAdminVerificationRequired: // value for 'isAdminVerificationRequired'
 *      sports: // value for 'sports'
 *      addressCoordinates: // value for 'addressCoordinates'
 *   },
 * });
 */
export function useCreateClubMutation(baseOptions?: Apollo.MutationHookOptions<CreateClubMutation, CreateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClubMutation, CreateClubMutationVariables>(CreateClubDocument, options);
      }
export type CreateClubMutationHookResult = ReturnType<typeof useCreateClubMutation>;
export type CreateClubMutationResult = Apollo.MutationResult<CreateClubMutation>;
export type CreateClubMutationOptions = Apollo.BaseMutationOptions<CreateClubMutation, CreateClubMutationVariables>;
export const UpdateClubDocument = gql`
    mutation updateClub($clubName: String!, $address: String, $city: String, $state: String, $logo: Upload, $contactEmail: String, $howToFindUs: String, $contactPhone: String, $country: String!, $instagramLink: String, $facebookLink: String, $twitterLink: String, $tikTok: String, $linkedin: String, $website: String, $id: Int!, $federationPublicId: String, $platformPublicId: String, $clubMainAdministrator: Int, $isAthleteClub: Boolean, $status: String, $description: String, $isEnableEmail: Boolean, $isAdminVerificationRequired: Boolean, $sports: [Int!], $addressCoordinates: JSON) {
  updateClub(
    updateClubInput: {clubName: $clubName, address: $address, city: $city, state: $state, logo: $logo, howToFindUs: $howToFindUs, contactEmail: $contactEmail, contactPhone: $contactPhone, tikTok: $tikTok, country: $country, instagramLink: $instagramLink, facebookLink: $facebookLink, twitterLink: $twitterLink, linkedin: $linkedin, website: $website, id: $id, federationPublicId: $federationPublicId, platformPublicId: $platformPublicId, isAthleteClub: $isAthleteClub, clubMainAdministrator: $clubMainAdministrator, status: $status, description: $description, isEnableEmail: $isEnableEmail, isAdminVerificationRequired: $isAdminVerificationRequired, sports: $sports, addressCoordinates: $addressCoordinates}
  ) {
    id
    status
  }
}
    `;
export type UpdateClubMutationFn = Apollo.MutationFunction<UpdateClubMutation, UpdateClubMutationVariables>;

/**
 * __useUpdateClubMutation__
 *
 * To run a mutation, you first call `useUpdateClubMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubMutation, { data, loading, error }] = useUpdateClubMutation({
 *   variables: {
 *      clubName: // value for 'clubName'
 *      address: // value for 'address'
 *      city: // value for 'city'
 *      state: // value for 'state'
 *      logo: // value for 'logo'
 *      contactEmail: // value for 'contactEmail'
 *      howToFindUs: // value for 'howToFindUs'
 *      contactPhone: // value for 'contactPhone'
 *      country: // value for 'country'
 *      instagramLink: // value for 'instagramLink'
 *      facebookLink: // value for 'facebookLink'
 *      twitterLink: // value for 'twitterLink'
 *      tikTok: // value for 'tikTok'
 *      linkedin: // value for 'linkedin'
 *      website: // value for 'website'
 *      id: // value for 'id'
 *      federationPublicId: // value for 'federationPublicId'
 *      platformPublicId: // value for 'platformPublicId'
 *      clubMainAdministrator: // value for 'clubMainAdministrator'
 *      isAthleteClub: // value for 'isAthleteClub'
 *      status: // value for 'status'
 *      description: // value for 'description'
 *      isEnableEmail: // value for 'isEnableEmail'
 *      isAdminVerificationRequired: // value for 'isAdminVerificationRequired'
 *      sports: // value for 'sports'
 *      addressCoordinates: // value for 'addressCoordinates'
 *   },
 * });
 */
export function useUpdateClubMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubMutation, UpdateClubMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubMutation, UpdateClubMutationVariables>(UpdateClubDocument, options);
      }
export type UpdateClubMutationHookResult = ReturnType<typeof useUpdateClubMutation>;
export type UpdateClubMutationResult = Apollo.MutationResult<UpdateClubMutation>;
export type UpdateClubMutationOptions = Apollo.BaseMutationOptions<UpdateClubMutation, UpdateClubMutationVariables>;
export const UpdateClubMemberDocument = gql`
    mutation updateClubMember($id: Int!, $status: String) {
  updateClubMember(updateClubMemberInput: {id: $id, status: $status}) {
    id
    status
  }
}
    `;
export type UpdateClubMemberMutationFn = Apollo.MutationFunction<UpdateClubMemberMutation, UpdateClubMemberMutationVariables>;

/**
 * __useUpdateClubMemberMutation__
 *
 * To run a mutation, you first call `useUpdateClubMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClubMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClubMemberMutation, { data, loading, error }] = useUpdateClubMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateClubMemberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClubMemberMutation, UpdateClubMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClubMemberMutation, UpdateClubMemberMutationVariables>(UpdateClubMemberDocument, options);
      }
export type UpdateClubMemberMutationHookResult = ReturnType<typeof useUpdateClubMemberMutation>;
export type UpdateClubMemberMutationResult = Apollo.MutationResult<UpdateClubMemberMutation>;
export type UpdateClubMemberMutationOptions = Apollo.BaseMutationOptions<UpdateClubMemberMutation, UpdateClubMemberMutationVariables>;
export const UpdatePlatformCoachDocument = gql`
    mutation updatePlatformCoach($input: UpdatePlatformCoachInput!) {
  updatePlatformCoach(updatePlatformCoachInput: $input) {
    id
    status
  }
}
    `;
export type UpdatePlatformCoachMutationFn = Apollo.MutationFunction<UpdatePlatformCoachMutation, UpdatePlatformCoachMutationVariables>;

/**
 * __useUpdatePlatformCoachMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformCoachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformCoachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformCoachMutation, { data, loading, error }] = useUpdatePlatformCoachMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformCoachMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformCoachMutation, UpdatePlatformCoachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformCoachMutation, UpdatePlatformCoachMutationVariables>(UpdatePlatformCoachDocument, options);
      }
export type UpdatePlatformCoachMutationHookResult = ReturnType<typeof useUpdatePlatformCoachMutation>;
export type UpdatePlatformCoachMutationResult = Apollo.MutationResult<UpdatePlatformCoachMutation>;
export type UpdatePlatformCoachMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformCoachMutation, UpdatePlatformCoachMutationVariables>;
export const CreateLeagueDocument = gql`
    mutation createLeague($createLeagueInput: CreateLeagueInput!) {
  createLeague(createLeagueInput: $createLeagueInput) {
    title
    type
    status
    email
    website
    id
    ...leagueWithSocialLinks
  }
}
    ${LeagueWithSocialLinksFragmentDoc}`;
export type CreateLeagueMutationFn = Apollo.MutationFunction<CreateLeagueMutation, CreateLeagueMutationVariables>;

/**
 * __useCreateLeagueMutation__
 *
 * To run a mutation, you first call `useCreateLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeagueMutation, { data, loading, error }] = useCreateLeagueMutation({
 *   variables: {
 *      createLeagueInput: // value for 'createLeagueInput'
 *   },
 * });
 */
export function useCreateLeagueMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeagueMutation, CreateLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeagueMutation, CreateLeagueMutationVariables>(CreateLeagueDocument, options);
      }
export type CreateLeagueMutationHookResult = ReturnType<typeof useCreateLeagueMutation>;
export type CreateLeagueMutationResult = Apollo.MutationResult<CreateLeagueMutation>;
export type CreateLeagueMutationOptions = Apollo.BaseMutationOptions<CreateLeagueMutation, CreateLeagueMutationVariables>;
export const CreateLicenseDocument = gql`
    mutation createLicense($input: CreateLicenseInput!) {
  createLicense(createLicenseInput: $input) {
    ...license
  }
}
    ${LicenseFragmentDoc}`;
export type CreateLicenseMutationFn = Apollo.MutationFunction<CreateLicenseMutation, CreateLicenseMutationVariables>;

/**
 * __useCreateLicenseMutation__
 *
 * To run a mutation, you first call `useCreateLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLicenseMutation, { data, loading, error }] = useCreateLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLicenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateLicenseMutation, CreateLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLicenseMutation, CreateLicenseMutationVariables>(CreateLicenseDocument, options);
      }
export type CreateLicenseMutationHookResult = ReturnType<typeof useCreateLicenseMutation>;
export type CreateLicenseMutationResult = Apollo.MutationResult<CreateLicenseMutation>;
export type CreateLicenseMutationOptions = Apollo.BaseMutationOptions<CreateLicenseMutation, CreateLicenseMutationVariables>;
export const CreatePageDocument = gql`
    mutation CreatePage($input: CreatePlatformPageInput!) {
  createPlatformPage(createPlatformPageInput: $input) {
    id
    slug
    blocks
  }
}
    `;
export type CreatePageMutationFn = Apollo.MutationFunction<CreatePageMutation, CreatePageMutationVariables>;

/**
 * __useCreatePageMutation__
 *
 * To run a mutation, you first call `useCreatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPageMutation, { data, loading, error }] = useCreatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePageMutation(baseOptions?: Apollo.MutationHookOptions<CreatePageMutation, CreatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePageMutation, CreatePageMutationVariables>(CreatePageDocument, options);
      }
export type CreatePageMutationHookResult = ReturnType<typeof useCreatePageMutation>;
export type CreatePageMutationResult = Apollo.MutationResult<CreatePageMutation>;
export type CreatePageMutationOptions = Apollo.BaseMutationOptions<CreatePageMutation, CreatePageMutationVariables>;
export const CreatePlatformSettingDocument = gql`
    mutation createPlatformSetting($input: CreatePlatformSettingInput!) {
  createPlatformSetting(createPlatformSettingInput: $input) {
    id
  }
}
    `;
export type CreatePlatformSettingMutationFn = Apollo.MutationFunction<CreatePlatformSettingMutation, CreatePlatformSettingMutationVariables>;

/**
 * __useCreatePlatformSettingMutation__
 *
 * To run a mutation, you first call `useCreatePlatformSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformSettingMutation, { data, loading, error }] = useCreatePlatformSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlatformSettingMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlatformSettingMutation, CreatePlatformSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlatformSettingMutation, CreatePlatformSettingMutationVariables>(CreatePlatformSettingDocument, options);
      }
export type CreatePlatformSettingMutationHookResult = ReturnType<typeof useCreatePlatformSettingMutation>;
export type CreatePlatformSettingMutationResult = Apollo.MutationResult<CreatePlatformSettingMutation>;
export type CreatePlatformSettingMutationOptions = Apollo.BaseMutationOptions<CreatePlatformSettingMutation, CreatePlatformSettingMutationVariables>;
export const CreatePostCategoryDocument = gql`
    mutation createPostCategory($name: String!, $slug: String!, $platformPublicId: String) {
  createPostCategory(
    createPostCategoryInput: {name: $name, slug: $slug, platformPublicId: $platformPublicId}
  ) {
    id
  }
}
    `;
export type CreatePostCategoryMutationFn = Apollo.MutationFunction<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>;

/**
 * __useCreatePostCategoryMutation__
 *
 * To run a mutation, you first call `useCreatePostCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostCategoryMutation, { data, loading, error }] = useCreatePostCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      platformPublicId: // value for 'platformPublicId'
 *   },
 * });
 */
export function useCreatePostCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>(CreatePostCategoryDocument, options);
      }
export type CreatePostCategoryMutationHookResult = ReturnType<typeof useCreatePostCategoryMutation>;
export type CreatePostCategoryMutationResult = Apollo.MutationResult<CreatePostCategoryMutation>;
export type CreatePostCategoryMutationOptions = Apollo.BaseMutationOptions<CreatePostCategoryMutation, CreatePostCategoryMutationVariables>;
export const DeletePurchasedLicenseDocument = gql`
    mutation deletePurchasedLicense($id: Int!) {
  removePurchasedLicense(id: $id) {
    id
  }
}
    `;
export type DeletePurchasedLicenseMutationFn = Apollo.MutationFunction<DeletePurchasedLicenseMutation, DeletePurchasedLicenseMutationVariables>;

/**
 * __useDeletePurchasedLicenseMutation__
 *
 * To run a mutation, you first call `useDeletePurchasedLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePurchasedLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePurchasedLicenseMutation, { data, loading, error }] = useDeletePurchasedLicenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePurchasedLicenseMutation(baseOptions?: Apollo.MutationHookOptions<DeletePurchasedLicenseMutation, DeletePurchasedLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePurchasedLicenseMutation, DeletePurchasedLicenseMutationVariables>(DeletePurchasedLicenseDocument, options);
      }
export type DeletePurchasedLicenseMutationHookResult = ReturnType<typeof useDeletePurchasedLicenseMutation>;
export type DeletePurchasedLicenseMutationResult = Apollo.MutationResult<DeletePurchasedLicenseMutation>;
export type DeletePurchasedLicenseMutationOptions = Apollo.BaseMutationOptions<DeletePurchasedLicenseMutation, DeletePurchasedLicenseMutationVariables>;
export const GetSubOrganizationsDocument = gql`
    query getSubOrganizations($filter: ListOrganizationPlatformsInput!) {
  subOrganizations: organizationFedrations(filter: $filter) {
    id
    federation {
      ...federation
      ...federationWithManagers
      ...federationWithPlatforms
    }
  }
}
    ${FederationFragmentDoc}
${FederationWithManagersFragmentDoc}
${FederationWithPlatformsFragmentDoc}`;

/**
 * __useGetSubOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetSubOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubOrganizationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubOrganizationsQuery(baseOptions: Apollo.QueryHookOptions<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables> & ({ variables: GetSubOrganizationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>(GetSubOrganizationsDocument, options);
      }
export function useGetSubOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>(GetSubOrganizationsDocument, options);
        }
export function useGetSubOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>(GetSubOrganizationsDocument, options);
        }
export type GetSubOrganizationsQueryHookResult = ReturnType<typeof useGetSubOrganizationsQuery>;
export type GetSubOrganizationsLazyQueryHookResult = ReturnType<typeof useGetSubOrganizationsLazyQuery>;
export type GetSubOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetSubOrganizationsSuspenseQuery>;
export type GetSubOrganizationsQueryResult = Apollo.QueryResult<GetSubOrganizationsQuery, GetSubOrganizationsQueryVariables>;
export function refetchGetSubOrganizationsQuery(variables: GetSubOrganizationsQueryVariables) {
      return { query: GetSubOrganizationsDocument, variables: variables }
    }
export const DeleteLicenseDocument = gql`
    mutation deleteLicense($id: Int!, $input: RemoveLicenseInput!) {
  removeLicense(id: $id, input: $input) {
    id
  }
}
    `;
export type DeleteLicenseMutationFn = Apollo.MutationFunction<DeleteLicenseMutation, DeleteLicenseMutationVariables>;

/**
 * __useDeleteLicenseMutation__
 *
 * To run a mutation, you first call `useDeleteLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLicenseMutation, { data, loading, error }] = useDeleteLicenseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLicenseMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteLicenseMutation, DeleteLicenseMutationVariables>(DeleteLicenseDocument, options);
      }
export type DeleteLicenseMutationHookResult = ReturnType<typeof useDeleteLicenseMutation>;
export type DeleteLicenseMutationResult = Apollo.MutationResult<DeleteLicenseMutation>;
export type DeleteLicenseMutationOptions = Apollo.BaseMutationOptions<DeleteLicenseMutation, DeleteLicenseMutationVariables>;
export const CreatePartnerDocument = gql`
    mutation createPartner($input: CreatePartnerNewInput!) {
  createPartnerNew(input: $input) {
    ...partner
  }
}
    ${PartnerFragmentDoc}`;
export type CreatePartnerMutationFn = Apollo.MutationFunction<CreatePartnerMutation, CreatePartnerMutationVariables>;

/**
 * __useCreatePartnerMutation__
 *
 * To run a mutation, you first call `useCreatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerMutation, { data, loading, error }] = useCreatePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerMutation, CreatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerMutation, CreatePartnerMutationVariables>(CreatePartnerDocument, options);
      }
export type CreatePartnerMutationHookResult = ReturnType<typeof useCreatePartnerMutation>;
export type CreatePartnerMutationResult = Apollo.MutationResult<CreatePartnerMutation>;
export type CreatePartnerMutationOptions = Apollo.BaseMutationOptions<CreatePartnerMutation, CreatePartnerMutationVariables>;
export const DeletePartnerDocument = gql`
    mutation deletePartner($id: Int!) {
  deletePartnerNew(id: $id) {
    id
  }
}
    `;
export type DeletePartnerMutationFn = Apollo.MutationFunction<DeletePartnerMutation, DeletePartnerMutationVariables>;

/**
 * __useDeletePartnerMutation__
 *
 * To run a mutation, you first call `useDeletePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePartnerMutation, { data, loading, error }] = useDeletePartnerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePartnerMutation(baseOptions?: Apollo.MutationHookOptions<DeletePartnerMutation, DeletePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePartnerMutation, DeletePartnerMutationVariables>(DeletePartnerDocument, options);
      }
export type DeletePartnerMutationHookResult = ReturnType<typeof useDeletePartnerMutation>;
export type DeletePartnerMutationResult = Apollo.MutationResult<DeletePartnerMutation>;
export type DeletePartnerMutationOptions = Apollo.BaseMutationOptions<DeletePartnerMutation, DeletePartnerMutationVariables>;
export const UpdateBulkPartnersDocument = gql`
    mutation updateBulkPartners($input: UpdateBulkPartnerNewInput!) {
  updateBulkPartnersNew(input: $input) {
    ...partner
  }
}
    ${PartnerFragmentDoc}`;
export type UpdateBulkPartnersMutationFn = Apollo.MutationFunction<UpdateBulkPartnersMutation, UpdateBulkPartnersMutationVariables>;

/**
 * __useUpdateBulkPartnersMutation__
 *
 * To run a mutation, you first call `useUpdateBulkPartnersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkPartnersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkPartnersMutation, { data, loading, error }] = useUpdateBulkPartnersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkPartnersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkPartnersMutation, UpdateBulkPartnersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkPartnersMutation, UpdateBulkPartnersMutationVariables>(UpdateBulkPartnersDocument, options);
      }
export type UpdateBulkPartnersMutationHookResult = ReturnType<typeof useUpdateBulkPartnersMutation>;
export type UpdateBulkPartnersMutationResult = Apollo.MutationResult<UpdateBulkPartnersMutation>;
export type UpdateBulkPartnersMutationOptions = Apollo.BaseMutationOptions<UpdateBulkPartnersMutation, UpdateBulkPartnersMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation updatePartner($input: UpdatePartnerNewInput!) {
  updatePartnerNew(input: $input) {
    ...partner
  }
}
    ${PartnerFragmentDoc}`;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerMutation, UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const CreatePlatformDocumentDocument = gql`
    mutation createPlatformDocument($input: CreatePlatformDocumentInput!) {
  createPlatformDocument(input: $input) {
    ...platformDocument
  }
}
    ${PlatformDocumentFragmentDoc}`;
export type CreatePlatformDocumentMutationFn = Apollo.MutationFunction<CreatePlatformDocumentMutation, CreatePlatformDocumentMutationVariables>;

/**
 * __useCreatePlatformDocumentMutation__
 *
 * To run a mutation, you first call `useCreatePlatformDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlatformDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlatformDocumentMutation, { data, loading, error }] = useCreatePlatformDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlatformDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlatformDocumentMutation, CreatePlatformDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlatformDocumentMutation, CreatePlatformDocumentMutationVariables>(CreatePlatformDocumentDocument, options);
      }
export type CreatePlatformDocumentMutationHookResult = ReturnType<typeof useCreatePlatformDocumentMutation>;
export type CreatePlatformDocumentMutationResult = Apollo.MutationResult<CreatePlatformDocumentMutation>;
export type CreatePlatformDocumentMutationOptions = Apollo.BaseMutationOptions<CreatePlatformDocumentMutation, CreatePlatformDocumentMutationVariables>;
export const DeletePlatformDocumentDocument = gql`
    mutation deletePlatformDocument($id: Int!) {
  deletePlatformDocument(id: $id) {
    id
  }
}
    `;
export type DeletePlatformDocumentMutationFn = Apollo.MutationFunction<DeletePlatformDocumentMutation, DeletePlatformDocumentMutationVariables>;

/**
 * __useDeletePlatformDocumentMutation__
 *
 * To run a mutation, you first call `useDeletePlatformDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlatformDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlatformDocumentMutation, { data, loading, error }] = useDeletePlatformDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePlatformDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlatformDocumentMutation, DeletePlatformDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlatformDocumentMutation, DeletePlatformDocumentMutationVariables>(DeletePlatformDocumentDocument, options);
      }
export type DeletePlatformDocumentMutationHookResult = ReturnType<typeof useDeletePlatformDocumentMutation>;
export type DeletePlatformDocumentMutationResult = Apollo.MutationResult<DeletePlatformDocumentMutation>;
export type DeletePlatformDocumentMutationOptions = Apollo.BaseMutationOptions<DeletePlatformDocumentMutation, DeletePlatformDocumentMutationVariables>;
export const UpdateBulkPlatformDocumentsDocument = gql`
    mutation updateBulkPlatformDocuments($input: UpdateBulkPlatformDocumentsInput!) {
  updateBulkPlatformDocuments(input: $input) {
    ...platformDocument
  }
}
    ${PlatformDocumentFragmentDoc}`;
export type UpdateBulkPlatformDocumentsMutationFn = Apollo.MutationFunction<UpdateBulkPlatformDocumentsMutation, UpdateBulkPlatformDocumentsMutationVariables>;

/**
 * __useUpdateBulkPlatformDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdateBulkPlatformDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkPlatformDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkPlatformDocumentsMutation, { data, loading, error }] = useUpdateBulkPlatformDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkPlatformDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkPlatformDocumentsMutation, UpdateBulkPlatformDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkPlatformDocumentsMutation, UpdateBulkPlatformDocumentsMutationVariables>(UpdateBulkPlatformDocumentsDocument, options);
      }
export type UpdateBulkPlatformDocumentsMutationHookResult = ReturnType<typeof useUpdateBulkPlatformDocumentsMutation>;
export type UpdateBulkPlatformDocumentsMutationResult = Apollo.MutationResult<UpdateBulkPlatformDocumentsMutation>;
export type UpdateBulkPlatformDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdateBulkPlatformDocumentsMutation, UpdateBulkPlatformDocumentsMutationVariables>;
export const UpdatePlatformDocumentDocument = gql`
    mutation updatePlatformDocument($input: UpdatePlatformDocumentInput!) {
  updatePlatformDocument(input: $input) {
    ...platformDocument
  }
}
    ${PlatformDocumentFragmentDoc}`;
export type UpdatePlatformDocumentMutationFn = Apollo.MutationFunction<UpdatePlatformDocumentMutation, UpdatePlatformDocumentMutationVariables>;

/**
 * __useUpdatePlatformDocumentMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformDocumentMutation, { data, loading, error }] = useUpdatePlatformDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformDocumentMutation, UpdatePlatformDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformDocumentMutation, UpdatePlatformDocumentMutationVariables>(UpdatePlatformDocumentDocument, options);
      }
export type UpdatePlatformDocumentMutationHookResult = ReturnType<typeof useUpdatePlatformDocumentMutation>;
export type UpdatePlatformDocumentMutationResult = Apollo.MutationResult<UpdatePlatformDocumentMutation>;
export type UpdatePlatformDocumentMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformDocumentMutation, UpdatePlatformDocumentMutationVariables>;
export const SetLeagueRankingsCronCategoriesDocument = gql`
    mutation setLeagueRankingsCronCategories($leagueId: Int!, $rankingCategoryIds: [Int!]!, $refreshRate: RefreshRate!, $updateEvery: String, $time: String, $customSchedule: [CustomScheduleItemInput!]) {
  setLeagueRankingsCronCategories(
    leagueId: $leagueId
    rankingCategoryIds: $rankingCategoryIds
    refreshRate: $refreshRate
    updateEvery: $updateEvery
    time: $time
    customSchedule: $customSchedule
  ) {
    id
  }
}
    `;
export type SetLeagueRankingsCronCategoriesMutationFn = Apollo.MutationFunction<SetLeagueRankingsCronCategoriesMutation, SetLeagueRankingsCronCategoriesMutationVariables>;

/**
 * __useSetLeagueRankingsCronCategoriesMutation__
 *
 * To run a mutation, you first call `useSetLeagueRankingsCronCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLeagueRankingsCronCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLeagueRankingsCronCategoriesMutation, { data, loading, error }] = useSetLeagueRankingsCronCategoriesMutation({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *      rankingCategoryIds: // value for 'rankingCategoryIds'
 *      refreshRate: // value for 'refreshRate'
 *      updateEvery: // value for 'updateEvery'
 *      time: // value for 'time'
 *      customSchedule: // value for 'customSchedule'
 *   },
 * });
 */
export function useSetLeagueRankingsCronCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<SetLeagueRankingsCronCategoriesMutation, SetLeagueRankingsCronCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLeagueRankingsCronCategoriesMutation, SetLeagueRankingsCronCategoriesMutationVariables>(SetLeagueRankingsCronCategoriesDocument, options);
      }
export type SetLeagueRankingsCronCategoriesMutationHookResult = ReturnType<typeof useSetLeagueRankingsCronCategoriesMutation>;
export type SetLeagueRankingsCronCategoriesMutationResult = Apollo.MutationResult<SetLeagueRankingsCronCategoriesMutation>;
export type SetLeagueRankingsCronCategoriesMutationOptions = Apollo.BaseMutationOptions<SetLeagueRankingsCronCategoriesMutation, SetLeagueRankingsCronCategoriesMutationVariables>;
export const ResetLeagueRankingsCronCategoriesDocument = gql`
    mutation resetLeagueRankingsCronCategories($leagueId: Int!) {
  resetLeagueRankingsCronCategories(leagueId: $leagueId) {
    id
  }
}
    `;
export type ResetLeagueRankingsCronCategoriesMutationFn = Apollo.MutationFunction<ResetLeagueRankingsCronCategoriesMutation, ResetLeagueRankingsCronCategoriesMutationVariables>;

/**
 * __useResetLeagueRankingsCronCategoriesMutation__
 *
 * To run a mutation, you first call `useResetLeagueRankingsCronCategoriesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetLeagueRankingsCronCategoriesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetLeagueRankingsCronCategoriesMutation, { data, loading, error }] = useResetLeagueRankingsCronCategoriesMutation({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useResetLeagueRankingsCronCategoriesMutation(baseOptions?: Apollo.MutationHookOptions<ResetLeagueRankingsCronCategoriesMutation, ResetLeagueRankingsCronCategoriesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetLeagueRankingsCronCategoriesMutation, ResetLeagueRankingsCronCategoriesMutationVariables>(ResetLeagueRankingsCronCategoriesDocument, options);
      }
export type ResetLeagueRankingsCronCategoriesMutationHookResult = ReturnType<typeof useResetLeagueRankingsCronCategoriesMutation>;
export type ResetLeagueRankingsCronCategoriesMutationResult = Apollo.MutationResult<ResetLeagueRankingsCronCategoriesMutation>;
export type ResetLeagueRankingsCronCategoriesMutationOptions = Apollo.BaseMutationOptions<ResetLeagueRankingsCronCategoriesMutation, ResetLeagueRankingsCronCategoriesMutationVariables>;
export const RegenerateAccessCodeDocument = gql`
    mutation regenerateAccessCode($platformPublicId: String!) {
  regeneratePlatformAccessCode(platformPublicId: $platformPublicId) {
    id
    accessCode
  }
}
    `;
export type RegenerateAccessCodeMutationFn = Apollo.MutationFunction<RegenerateAccessCodeMutation, RegenerateAccessCodeMutationVariables>;

/**
 * __useRegenerateAccessCodeMutation__
 *
 * To run a mutation, you first call `useRegenerateAccessCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegenerateAccessCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [regenerateAccessCodeMutation, { data, loading, error }] = useRegenerateAccessCodeMutation({
 *   variables: {
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useRegenerateAccessCodeMutation(baseOptions?: Apollo.MutationHookOptions<RegenerateAccessCodeMutation, RegenerateAccessCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegenerateAccessCodeMutation, RegenerateAccessCodeMutationVariables>(RegenerateAccessCodeDocument, options);
      }
export type RegenerateAccessCodeMutationHookResult = ReturnType<typeof useRegenerateAccessCodeMutation>;
export type RegenerateAccessCodeMutationResult = Apollo.MutationResult<RegenerateAccessCodeMutation>;
export type RegenerateAccessCodeMutationOptions = Apollo.BaseMutationOptions<RegenerateAccessCodeMutation, RegenerateAccessCodeMutationVariables>;
export const RemoveAlbumByIdDocument = gql`
    mutation removeAlbumById($id: Int!) {
  removeAlbum(id: $id) {
    id
  }
}
    `;
export type RemoveAlbumByIdMutationFn = Apollo.MutationFunction<RemoveAlbumByIdMutation, RemoveAlbumByIdMutationVariables>;

/**
 * __useRemoveAlbumByIdMutation__
 *
 * To run a mutation, you first call `useRemoveAlbumByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAlbumByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAlbumByIdMutation, { data, loading, error }] = useRemoveAlbumByIdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAlbumByIdMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAlbumByIdMutation, RemoveAlbumByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAlbumByIdMutation, RemoveAlbumByIdMutationVariables>(RemoveAlbumByIdDocument, options);
      }
export type RemoveAlbumByIdMutationHookResult = ReturnType<typeof useRemoveAlbumByIdMutation>;
export type RemoveAlbumByIdMutationResult = Apollo.MutationResult<RemoveAlbumByIdMutation>;
export type RemoveAlbumByIdMutationOptions = Apollo.BaseMutationOptions<RemoveAlbumByIdMutation, RemoveAlbumByIdMutationVariables>;
export const RemovePostCategoryDocument = gql`
    mutation removePostCategory($id: Int!) {
  removePostCategory(id: $id) {
    name
  }
}
    `;
export type RemovePostCategoryMutationFn = Apollo.MutationFunction<RemovePostCategoryMutation, RemovePostCategoryMutationVariables>;

/**
 * __useRemovePostCategoryMutation__
 *
 * To run a mutation, you first call `useRemovePostCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemovePostCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removePostCategoryMutation, { data, loading, error }] = useRemovePostCategoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemovePostCategoryMutation(baseOptions?: Apollo.MutationHookOptions<RemovePostCategoryMutation, RemovePostCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemovePostCategoryMutation, RemovePostCategoryMutationVariables>(RemovePostCategoryDocument, options);
      }
export type RemovePostCategoryMutationHookResult = ReturnType<typeof useRemovePostCategoryMutation>;
export type RemovePostCategoryMutationResult = Apollo.MutationResult<RemovePostCategoryMutation>;
export type RemovePostCategoryMutationOptions = Apollo.BaseMutationOptions<RemovePostCategoryMutation, RemovePostCategoryMutationVariables>;
export const SendTeamInviteDocument = gql`
    query sendTeamInvite($user: Int!, $email: String!, $teamName: String, $acceptUrl: String!, $declineUrl: String!, $platformId: Int!) {
  sendInviteToSignupAndTeamUp(
    user: $user
    email: $email
    teamName: $teamName
    acceptUrl: $acceptUrl
    declineUrl: $declineUrl
    platformId: $platformId
  ) {
    message
    success
  }
}
    `;

/**
 * __useSendTeamInviteQuery__
 *
 * To run a query within a React component, call `useSendTeamInviteQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendTeamInviteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendTeamInviteQuery({
 *   variables: {
 *      user: // value for 'user'
 *      email: // value for 'email'
 *      teamName: // value for 'teamName'
 *      acceptUrl: // value for 'acceptUrl'
 *      declineUrl: // value for 'declineUrl'
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useSendTeamInviteQuery(baseOptions: Apollo.QueryHookOptions<SendTeamInviteQuery, SendTeamInviteQueryVariables> & ({ variables: SendTeamInviteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendTeamInviteQuery, SendTeamInviteQueryVariables>(SendTeamInviteDocument, options);
      }
export function useSendTeamInviteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendTeamInviteQuery, SendTeamInviteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendTeamInviteQuery, SendTeamInviteQueryVariables>(SendTeamInviteDocument, options);
        }
export function useSendTeamInviteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SendTeamInviteQuery, SendTeamInviteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SendTeamInviteQuery, SendTeamInviteQueryVariables>(SendTeamInviteDocument, options);
        }
export type SendTeamInviteQueryHookResult = ReturnType<typeof useSendTeamInviteQuery>;
export type SendTeamInviteLazyQueryHookResult = ReturnType<typeof useSendTeamInviteLazyQuery>;
export type SendTeamInviteSuspenseQueryHookResult = ReturnType<typeof useSendTeamInviteSuspenseQuery>;
export type SendTeamInviteQueryResult = Apollo.QueryResult<SendTeamInviteQuery, SendTeamInviteQueryVariables>;
export function refetchSendTeamInviteQuery(variables: SendTeamInviteQueryVariables) {
      return { query: SendTeamInviteDocument, variables: variables }
    }
export const CopyTournamentDocument = gql`
    mutation copyTournament($title: String!, $tournamentId: Float!, $startDate: String!, $endDate: String!, $entryDeadline: String!, $withdrawlDeadline: String!) {
  cloneTournament(
    title: $title
    tournamentId: $tournamentId
    startDate: $startDate
    endDate: $endDate
    entryDeadline: $entryDeadline
    withdrawlDeadline: $withdrawlDeadline
  ) {
    title
    id
  }
}
    `;
export type CopyTournamentMutationFn = Apollo.MutationFunction<CopyTournamentMutation, CopyTournamentMutationVariables>;

/**
 * __useCopyTournamentMutation__
 *
 * To run a mutation, you first call `useCopyTournamentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCopyTournamentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [copyTournamentMutation, { data, loading, error }] = useCopyTournamentMutation({
 *   variables: {
 *      title: // value for 'title'
 *      tournamentId: // value for 'tournamentId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      entryDeadline: // value for 'entryDeadline'
 *      withdrawlDeadline: // value for 'withdrawlDeadline'
 *   },
 * });
 */
export function useCopyTournamentMutation(baseOptions?: Apollo.MutationHookOptions<CopyTournamentMutation, CopyTournamentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CopyTournamentMutation, CopyTournamentMutationVariables>(CopyTournamentDocument, options);
      }
export type CopyTournamentMutationHookResult = ReturnType<typeof useCopyTournamentMutation>;
export type CopyTournamentMutationResult = Apollo.MutationResult<CopyTournamentMutation>;
export type CopyTournamentMutationOptions = Apollo.BaseMutationOptions<CopyTournamentMutation, CopyTournamentMutationVariables>;
export const CreateTournamentCategoryLicenseDocument = gql`
    mutation createTournamentCategoryLicense($tournamentCategory: Int!, $license: Int!) {
  createTournamentCategoryLicense(
    createTournamentCategoryLicenseInput: {tournamentCategory: $tournamentCategory, license: $license}
  ) {
    id
  }
}
    `;
export type CreateTournamentCategoryLicenseMutationFn = Apollo.MutationFunction<CreateTournamentCategoryLicenseMutation, CreateTournamentCategoryLicenseMutationVariables>;

/**
 * __useCreateTournamentCategoryLicenseMutation__
 *
 * To run a mutation, you first call `useCreateTournamentCategoryLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTournamentCategoryLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTournamentCategoryLicenseMutation, { data, loading, error }] = useCreateTournamentCategoryLicenseMutation({
 *   variables: {
 *      tournamentCategory: // value for 'tournamentCategory'
 *      license: // value for 'license'
 *   },
 * });
 */
export function useCreateTournamentCategoryLicenseMutation(baseOptions?: Apollo.MutationHookOptions<CreateTournamentCategoryLicenseMutation, CreateTournamentCategoryLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTournamentCategoryLicenseMutation, CreateTournamentCategoryLicenseMutationVariables>(CreateTournamentCategoryLicenseDocument, options);
      }
export type CreateTournamentCategoryLicenseMutationHookResult = ReturnType<typeof useCreateTournamentCategoryLicenseMutation>;
export type CreateTournamentCategoryLicenseMutationResult = Apollo.MutationResult<CreateTournamentCategoryLicenseMutation>;
export type CreateTournamentCategoryLicenseMutationOptions = Apollo.BaseMutationOptions<CreateTournamentCategoryLicenseMutation, CreateTournamentCategoryLicenseMutationVariables>;
export const UpdateBulkPlatformFeeDocument = gql`
    mutation UpdateBulkPlatformFee($input: [UpdatePlatformFeeInput!]!) {
  updateBulkPlatformFee(updatePlatformFeeInput: $input) {
    id
    currency
    rangeStart
    rangeEnd
    feeType
    feeMode
    serviceType
    tournatedFee
    tournatedMinFee
    tournatedMaxFee
    tournatedMinPercentageFee
    tournatedMaxPercentageFee
    partnerFee
    partnerMinFee
    partnerMaxFee
    partnerMinPercentageFee
    partnerMaxPercentageFee
    isMonetization
    isManagerPayingServiceFee
  }
}
    `;
export type UpdateBulkPlatformFeeMutationFn = Apollo.MutationFunction<UpdateBulkPlatformFeeMutation, UpdateBulkPlatformFeeMutationVariables>;

/**
 * __useUpdateBulkPlatformFeeMutation__
 *
 * To run a mutation, you first call `useUpdateBulkPlatformFeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBulkPlatformFeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBulkPlatformFeeMutation, { data, loading, error }] = useUpdateBulkPlatformFeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBulkPlatformFeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBulkPlatformFeeMutation, UpdateBulkPlatformFeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBulkPlatformFeeMutation, UpdateBulkPlatformFeeMutationVariables>(UpdateBulkPlatformFeeDocument, options);
      }
export type UpdateBulkPlatformFeeMutationHookResult = ReturnType<typeof useUpdateBulkPlatformFeeMutation>;
export type UpdateBulkPlatformFeeMutationResult = Apollo.MutationResult<UpdateBulkPlatformFeeMutation>;
export type UpdateBulkPlatformFeeMutationOptions = Apollo.BaseMutationOptions<UpdateBulkPlatformFeeMutation, UpdateBulkPlatformFeeMutationVariables>;
export const UpdateLeagueCustomFeesDocument = gql`
    mutation updateLeagueCustomFees($id: Int, $publicId: String, $customFee: [UpdatePlatformFeeInput!]!, $isTournatedFeeVatEnable: Boolean, $tournatedFeeVat: Float, $isCustomFeeEnable: Boolean) {
  updateLeageCustomFees(
    id: $id
    publicId: $publicId
    customFee: $customFee
    isTournatedFeeVatEnable: $isTournatedFeeVatEnable
    tournatedFeeVat: $tournatedFeeVat
    isCustomFeeEnable: $isCustomFeeEnable
  ) {
    id
    isTournatedFeeVatEnable
    tournatedFeeVat
    isCustomFeeEnable
    customFee {
      id
      currency
      rangeStart
      rangeEnd
      feeType
      feeMode
      serviceType
      tournatedFee
      tournatedMinFee
      tournatedMaxFee
      tournatedMinPercentageFee
      tournatedMaxPercentageFee
      partnerFee
      partnerMinFee
      partnerMaxFee
      partnerMinPercentageFee
      partnerMaxPercentageFee
      isMonetization
      isManagerPayingServiceFee
    }
  }
}
    `;
export type UpdateLeagueCustomFeesMutationFn = Apollo.MutationFunction<UpdateLeagueCustomFeesMutation, UpdateLeagueCustomFeesMutationVariables>;

/**
 * __useUpdateLeagueCustomFeesMutation__
 *
 * To run a mutation, you first call `useUpdateLeagueCustomFeesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeagueCustomFeesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeagueCustomFeesMutation, { data, loading, error }] = useUpdateLeagueCustomFeesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      customFee: // value for 'customFee'
 *      isTournatedFeeVatEnable: // value for 'isTournatedFeeVatEnable'
 *      tournatedFeeVat: // value for 'tournatedFeeVat'
 *      isCustomFeeEnable: // value for 'isCustomFeeEnable'
 *   },
 * });
 */
export function useUpdateLeagueCustomFeesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeagueCustomFeesMutation, UpdateLeagueCustomFeesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeagueCustomFeesMutation, UpdateLeagueCustomFeesMutationVariables>(UpdateLeagueCustomFeesDocument, options);
      }
export type UpdateLeagueCustomFeesMutationHookResult = ReturnType<typeof useUpdateLeagueCustomFeesMutation>;
export type UpdateLeagueCustomFeesMutationResult = Apollo.MutationResult<UpdateLeagueCustomFeesMutation>;
export type UpdateLeagueCustomFeesMutationOptions = Apollo.BaseMutationOptions<UpdateLeagueCustomFeesMutation, UpdateLeagueCustomFeesMutationVariables>;
export const UpdateLeagueDocument = gql`
    mutation updateLeague($id: Int!, $title: String, $type: LeagueGeoScope, $abbreviation: String, $priority: String, $abbreviationLogo: Upload, $platformPublicId: String, $sports: Int, $discipline: String, $enableRankings: Boolean, $enableLicense: Boolean, $enableOnlinePayments: Boolean, $status: String, $email: String, $website: String, $phone: String, $instagram: String, $country: String, $file: Upload, $federationPublicId: String, $isFeatured: Boolean, $allowUnregisteredPlayers: Boolean, $requireTournamentApproval: Boolean, $globalCategoryLimitPerPlayer: Float, $bannerCover: Upload, $liveStreaming_sporfie_key: String) {
  updateLeague(
    updateLeagueInput: {id: $id, title: $title, type: $type, abbreviation: $abbreviation, priority: $priority, abbreviationLogo: $abbreviationLogo, sports: $sports, discipline: $discipline, platformPublicId: $platformPublicId, enableRankings: $enableRankings, enableLicense: $enableLicense, enableOnlinePayments: $enableOnlinePayments, status: $status, email: $email, website: $website, phone: $phone, instagram: $instagram, logo: $file, country: $country, federationPublicId: $federationPublicId, isFeatured: $isFeatured, allowUnregisteredPlayers: $allowUnregisteredPlayers, requireTournamentApproval: $requireTournamentApproval, globalCategoryLimitPerPlayer: $globalCategoryLimitPerPlayer, bannerCover: $bannerCover, liveStreaming_sporfie_key: $liveStreaming_sporfie_key}
  ) {
    id
    title
    type
    enableRankings
    enableLicense
    enableOnlinePayments
    status
    email
    website
    phone
    instagram
    abbreviation
    priority
    discipline
    logo
    abbreviationLogo
    allowUnregisteredPlayers
    liveStreaming_sporfie_key
  }
}
    `;
export type UpdateLeagueMutationFn = Apollo.MutationFunction<UpdateLeagueMutation, UpdateLeagueMutationVariables>;

/**
 * __useUpdateLeagueMutation__
 *
 * To run a mutation, you first call `useUpdateLeagueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeagueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeagueMutation, { data, loading, error }] = useUpdateLeagueMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      abbreviation: // value for 'abbreviation'
 *      priority: // value for 'priority'
 *      abbreviationLogo: // value for 'abbreviationLogo'
 *      platformPublicId: // value for 'platformPublicId'
 *      sports: // value for 'sports'
 *      discipline: // value for 'discipline'
 *      enableRankings: // value for 'enableRankings'
 *      enableLicense: // value for 'enableLicense'
 *      enableOnlinePayments: // value for 'enableOnlinePayments'
 *      status: // value for 'status'
 *      email: // value for 'email'
 *      website: // value for 'website'
 *      phone: // value for 'phone'
 *      instagram: // value for 'instagram'
 *      country: // value for 'country'
 *      file: // value for 'file'
 *      federationPublicId: // value for 'federationPublicId'
 *      isFeatured: // value for 'isFeatured'
 *      allowUnregisteredPlayers: // value for 'allowUnregisteredPlayers'
 *      requireTournamentApproval: // value for 'requireTournamentApproval'
 *      globalCategoryLimitPerPlayer: // value for 'globalCategoryLimitPerPlayer'
 *      bannerCover: // value for 'bannerCover'
 *      liveStreaming_sporfie_key: // value for 'liveStreaming_sporfie_key'
 *   },
 * });
 */
export function useUpdateLeagueMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeagueMutation, UpdateLeagueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeagueMutation, UpdateLeagueMutationVariables>(UpdateLeagueDocument, options);
      }
export type UpdateLeagueMutationHookResult = ReturnType<typeof useUpdateLeagueMutation>;
export type UpdateLeagueMutationResult = Apollo.MutationResult<UpdateLeagueMutation>;
export type UpdateLeagueMutationOptions = Apollo.BaseMutationOptions<UpdateLeagueMutation, UpdateLeagueMutationVariables>;
export const UpdatePlatformDocumentsDocument = gql`
    mutation updatePlatformDocuments($input: UpdatePlatformInput!) {
  updatePlatform(updatePlatformInput: $input) {
    id
    ...platformWithDocuments
  }
}
    ${PlatformWithDocumentsFragmentDoc}`;
export type UpdatePlatformDocumentsMutationFn = Apollo.MutationFunction<UpdatePlatformDocumentsMutation, UpdatePlatformDocumentsMutationVariables>;

/**
 * __useUpdatePlatformDocumentsMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformDocumentsMutation, { data, loading, error }] = useUpdatePlatformDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformDocumentsMutation, UpdatePlatformDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformDocumentsMutation, UpdatePlatformDocumentsMutationVariables>(UpdatePlatformDocumentsDocument, options);
      }
export type UpdatePlatformDocumentsMutationHookResult = ReturnType<typeof useUpdatePlatformDocumentsMutation>;
export type UpdatePlatformDocumentsMutationResult = Apollo.MutationResult<UpdatePlatformDocumentsMutation>;
export type UpdatePlatformDocumentsMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformDocumentsMutation, UpdatePlatformDocumentsMutationVariables>;
export const UpdatePageDocument = gql`
    mutation UpdatePage($input: UpdatePlatformPageInput!) {
  updatePlatformPage(updatePlatformPageInput: $input) {
    id
    slug
    blocks
  }
}
    `;
export type UpdatePageMutationFn = Apollo.MutationFunction<UpdatePageMutation, UpdatePageMutationVariables>;

/**
 * __useUpdatePageMutation__
 *
 * To run a mutation, you first call `useUpdatePageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePageMutation, { data, loading, error }] = useUpdatePageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePageMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePageMutation, UpdatePageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePageMutation, UpdatePageMutationVariables>(UpdatePageDocument, options);
      }
export type UpdatePageMutationHookResult = ReturnType<typeof useUpdatePageMutation>;
export type UpdatePageMutationResult = Apollo.MutationResult<UpdatePageMutation>;
export type UpdatePageMutationOptions = Apollo.BaseMutationOptions<UpdatePageMutation, UpdatePageMutationVariables>;
export const UpdatePlatformSettingDocument = gql`
    mutation updatePlatformSetting($input: UpdatePlatformSettingInput!) {
  updatePlatformSetting(updatePlatformSettingInput: $input) {
    id
  }
}
    `;
export type UpdatePlatformSettingMutationFn = Apollo.MutationFunction<UpdatePlatformSettingMutation, UpdatePlatformSettingMutationVariables>;

/**
 * __useUpdatePlatformSettingMutation__
 *
 * To run a mutation, you first call `useUpdatePlatformSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlatformSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlatformSettingMutation, { data, loading, error }] = useUpdatePlatformSettingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlatformSettingMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlatformSettingMutation, UpdatePlatformSettingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlatformSettingMutation, UpdatePlatformSettingMutationVariables>(UpdatePlatformSettingDocument, options);
      }
export type UpdatePlatformSettingMutationHookResult = ReturnType<typeof useUpdatePlatformSettingMutation>;
export type UpdatePlatformSettingMutationResult = Apollo.MutationResult<UpdatePlatformSettingMutation>;
export type UpdatePlatformSettingMutationOptions = Apollo.BaseMutationOptions<UpdatePlatformSettingMutation, UpdatePlatformSettingMutationVariables>;
export const UpdatePostCategoryDocument = gql`
    mutation updatePostCategory($name: String!, $slug: String, $id: Int!) {
  updatePostCategory(updatePostCategoryInput: {name: $name, slug: $slug, id: $id}) {
    id
  }
}
    `;
export type UpdatePostCategoryMutationFn = Apollo.MutationFunction<UpdatePostCategoryMutation, UpdatePostCategoryMutationVariables>;

/**
 * __useUpdatePostCategoryMutation__
 *
 * To run a mutation, you first call `useUpdatePostCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePostCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePostCategoryMutation, { data, loading, error }] = useUpdatePostCategoryMutation({
 *   variables: {
 *      name: // value for 'name'
 *      slug: // value for 'slug'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdatePostCategoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePostCategoryMutation, UpdatePostCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePostCategoryMutation, UpdatePostCategoryMutationVariables>(UpdatePostCategoryDocument, options);
      }
export type UpdatePostCategoryMutationHookResult = ReturnType<typeof useUpdatePostCategoryMutation>;
export type UpdatePostCategoryMutationResult = Apollo.MutationResult<UpdatePostCategoryMutation>;
export type UpdatePostCategoryMutationOptions = Apollo.BaseMutationOptions<UpdatePostCategoryMutation, UpdatePostCategoryMutationVariables>;
export const UpdatePurchasedLicenseDocument = gql`
    mutation updatePurchasedLicense($input: UpdatePurchasedLicenseInput!) {
  updatePurchasedLicense(updatePurchasedLicenseInput: $input) {
    id
  }
}
    `;
export type UpdatePurchasedLicenseMutationFn = Apollo.MutationFunction<UpdatePurchasedLicenseMutation, UpdatePurchasedLicenseMutationVariables>;

/**
 * __useUpdatePurchasedLicenseMutation__
 *
 * To run a mutation, you first call `useUpdatePurchasedLicenseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePurchasedLicenseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePurchasedLicenseMutation, { data, loading, error }] = useUpdatePurchasedLicenseMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePurchasedLicenseMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePurchasedLicenseMutation, UpdatePurchasedLicenseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePurchasedLicenseMutation, UpdatePurchasedLicenseMutationVariables>(UpdatePurchasedLicenseDocument, options);
      }
export type UpdatePurchasedLicenseMutationHookResult = ReturnType<typeof useUpdatePurchasedLicenseMutation>;
export type UpdatePurchasedLicenseMutationResult = Apollo.MutationResult<UpdatePurchasedLicenseMutation>;
export type UpdatePurchasedLicenseMutationOptions = Apollo.BaseMutationOptions<UpdatePurchasedLicenseMutation, UpdatePurchasedLicenseMutationVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($password: String!, $userId: Int!) {
  updateUserPasswordByAdmin(input: {password: $password, userId: $userId}) {
    id
    email
  }
}
    `;
export type UpdateUserPasswordMutationFn = Apollo.MutationFunction<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;

/**
 * __useUpdateUserPasswordMutation__
 *
 * To run a mutation, you first call `useUpdateUserPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPasswordMutation, { data, loading, error }] = useUpdateUserPasswordMutation({
 *   variables: {
 *      password: // value for 'password'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpdateUserPasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordMutationHookResult = ReturnType<typeof useUpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<UpdateUserPasswordMutation>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const FinishDashboardV3TourDocument = gql`
    mutation finishDashboardV3Tour {
  finishDashboardV3Tour {
    id
    hasFinishedDashboardV3Tour
  }
}
    `;
export type FinishDashboardV3TourMutationFn = Apollo.MutationFunction<FinishDashboardV3TourMutation, FinishDashboardV3TourMutationVariables>;

/**
 * __useFinishDashboardV3TourMutation__
 *
 * To run a mutation, you first call `useFinishDashboardV3TourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFinishDashboardV3TourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [finishDashboardV3TourMutation, { data, loading, error }] = useFinishDashboardV3TourMutation({
 *   variables: {
 *   },
 * });
 */
export function useFinishDashboardV3TourMutation(baseOptions?: Apollo.MutationHookOptions<FinishDashboardV3TourMutation, FinishDashboardV3TourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FinishDashboardV3TourMutation, FinishDashboardV3TourMutationVariables>(FinishDashboardV3TourDocument, options);
      }
export type FinishDashboardV3TourMutationHookResult = ReturnType<typeof useFinishDashboardV3TourMutation>;
export type FinishDashboardV3TourMutationResult = Apollo.MutationResult<FinishDashboardV3TourMutation>;
export type FinishDashboardV3TourMutationOptions = Apollo.BaseMutationOptions<FinishDashboardV3TourMutation, FinishDashboardV3TourMutationVariables>;
export const GetAdditionalQuestionsDocument = gql`
    query getAdditionalQuestions($filter: ListAdditionalQuestionInput) {
  additionalQuestions(filter: $filter) {
    id
    question
    fieldType
    fieldOptions
    askEachAthlete
    isMandatory
    isHide
  }
}
    `;

/**
 * __useGetAdditionalQuestionsQuery__
 *
 * To run a query within a React component, call `useGetAdditionalQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalQuestionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdditionalQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>(GetAdditionalQuestionsDocument, options);
      }
export function useGetAdditionalQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>(GetAdditionalQuestionsDocument, options);
        }
export function useGetAdditionalQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>(GetAdditionalQuestionsDocument, options);
        }
export type GetAdditionalQuestionsQueryHookResult = ReturnType<typeof useGetAdditionalQuestionsQuery>;
export type GetAdditionalQuestionsLazyQueryHookResult = ReturnType<typeof useGetAdditionalQuestionsLazyQuery>;
export type GetAdditionalQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetAdditionalQuestionsSuspenseQuery>;
export type GetAdditionalQuestionsQueryResult = Apollo.QueryResult<GetAdditionalQuestionsQuery, GetAdditionalQuestionsQueryVariables>;
export function refetchGetAdditionalQuestionsQuery(variables?: GetAdditionalQuestionsQueryVariables) {
      return { query: GetAdditionalQuestionsDocument, variables: variables }
    }
export const BannerDocument = gql`
    query banner($id: Int!) {
  banner(id: $id) {
    id
    role
    platform {
      ...basePlatform
    }
    headLine
    subHeadLine
    buttonText
    buttonLink
    primaryColor
    status
    sports {
      ...sport
    }
    images
    sortingPosition
  }
}
    ${BasePlatformFragmentDoc}
${SportFragmentDoc}`;

/**
 * __useBannerQuery__
 *
 * To run a query within a React component, call `useBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBannerQuery(baseOptions: Apollo.QueryHookOptions<BannerQuery, BannerQueryVariables> & ({ variables: BannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
      }
export function useBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannerQuery, BannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
        }
export function useBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BannerQuery, BannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BannerQuery, BannerQueryVariables>(BannerDocument, options);
        }
export type BannerQueryHookResult = ReturnType<typeof useBannerQuery>;
export type BannerLazyQueryHookResult = ReturnType<typeof useBannerLazyQuery>;
export type BannerSuspenseQueryHookResult = ReturnType<typeof useBannerSuspenseQuery>;
export type BannerQueryResult = Apollo.QueryResult<BannerQuery, BannerQueryVariables>;
export function refetchBannerQuery(variables: BannerQueryVariables) {
      return { query: BannerDocument, variables: variables }
    }
export const BannersDocument = gql`
    query banners($filter: ListBannerInput!) {
  banners(filter: $filter) {
    id
    headLine
    subHeadLine
    buttonText
    buttonLink
    primaryColor
    status
    sports {
      ...sport
    }
    role
    images
    platform {
      ...basePlatform
    }
    sortingPosition
  }
}
    ${SportFragmentDoc}
${BasePlatformFragmentDoc}`;

/**
 * __useBannersQuery__
 *
 * To run a query within a React component, call `useBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBannersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBannersQuery(baseOptions: Apollo.QueryHookOptions<BannersQuery, BannersQueryVariables> & ({ variables: BannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BannersQuery, BannersQueryVariables>(BannersDocument, options);
      }
export function useBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BannersQuery, BannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BannersQuery, BannersQueryVariables>(BannersDocument, options);
        }
export function useBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BannersQuery, BannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BannersQuery, BannersQueryVariables>(BannersDocument, options);
        }
export type BannersQueryHookResult = ReturnType<typeof useBannersQuery>;
export type BannersLazyQueryHookResult = ReturnType<typeof useBannersLazyQuery>;
export type BannersSuspenseQueryHookResult = ReturnType<typeof useBannersSuspenseQuery>;
export type BannersQueryResult = Apollo.QueryResult<BannersQuery, BannersQueryVariables>;
export function refetchBannersQuery(variables: BannersQueryVariables) {
      return { query: BannersDocument, variables: variables }
    }
export const GetBannerDocument = gql`
    query getBanner($id: Int!) {
  bannerNew(id: $id) {
    ...banner
  }
}
    ${BannerFragmentDoc}`;

/**
 * __useGetBannerQuery__
 *
 * To run a query within a React component, call `useGetBannerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBannerQuery(baseOptions: Apollo.QueryHookOptions<GetBannerQuery, GetBannerQueryVariables> & ({ variables: GetBannerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
      }
export function useGetBannerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export function useGetBannerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannerQuery, GetBannerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannerQuery, GetBannerQueryVariables>(GetBannerDocument, options);
        }
export type GetBannerQueryHookResult = ReturnType<typeof useGetBannerQuery>;
export type GetBannerLazyQueryHookResult = ReturnType<typeof useGetBannerLazyQuery>;
export type GetBannerSuspenseQueryHookResult = ReturnType<typeof useGetBannerSuspenseQuery>;
export type GetBannerQueryResult = Apollo.QueryResult<GetBannerQuery, GetBannerQueryVariables>;
export function refetchGetBannerQuery(variables: GetBannerQueryVariables) {
      return { query: GetBannerDocument, variables: variables }
    }
export const GetBannersDocument = gql`
    query getBanners($filter: ListBannersNewInput!) {
  bannersNew(filter: $filter) {
    ...banner
  }
}
    ${BannerFragmentDoc}`;

/**
 * __useGetBannersQuery__
 *
 * To run a query within a React component, call `useGetBannersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBannersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBannersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetBannersQuery(baseOptions: Apollo.QueryHookOptions<GetBannersQuery, GetBannersQueryVariables> & ({ variables: GetBannersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
      }
export function useGetBannersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
        }
export function useGetBannersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBannersQuery, GetBannersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBannersQuery, GetBannersQueryVariables>(GetBannersDocument, options);
        }
export type GetBannersQueryHookResult = ReturnType<typeof useGetBannersQuery>;
export type GetBannersLazyQueryHookResult = ReturnType<typeof useGetBannersLazyQuery>;
export type GetBannersSuspenseQueryHookResult = ReturnType<typeof useGetBannersSuspenseQuery>;
export type GetBannersQueryResult = Apollo.QueryResult<GetBannersQuery, GetBannersQueryVariables>;
export function refetchGetBannersQuery(variables: GetBannersQueryVariables) {
      return { query: GetBannersDocument, variables: variables }
    }
export const GetClubByIdDocument = gql`
    query getClubById($id: Int!) {
  clubById(id: $id) {
    ...baseClub
    ...clubWithCoaches
    ...clubWithPlatforms
    ...clubWithFederation
  }
}
    ${BaseClubFragmentDoc}
${ClubWithCoachesFragmentDoc}
${ClubWithPlatformsFragmentDoc}
${ClubWithFederationFragmentDoc}`;

/**
 * __useGetClubByIdQuery__
 *
 * To run a query within a React component, call `useGetClubByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClubByIdQuery(baseOptions: Apollo.QueryHookOptions<GetClubByIdQuery, GetClubByIdQueryVariables> & ({ variables: GetClubByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubByIdQuery, GetClubByIdQueryVariables>(GetClubByIdDocument, options);
      }
export function useGetClubByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubByIdQuery, GetClubByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubByIdQuery, GetClubByIdQueryVariables>(GetClubByIdDocument, options);
        }
export function useGetClubByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubByIdQuery, GetClubByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubByIdQuery, GetClubByIdQueryVariables>(GetClubByIdDocument, options);
        }
export type GetClubByIdQueryHookResult = ReturnType<typeof useGetClubByIdQuery>;
export type GetClubByIdLazyQueryHookResult = ReturnType<typeof useGetClubByIdLazyQuery>;
export type GetClubByIdSuspenseQueryHookResult = ReturnType<typeof useGetClubByIdSuspenseQuery>;
export type GetClubByIdQueryResult = Apollo.QueryResult<GetClubByIdQuery, GetClubByIdQueryVariables>;
export function refetchGetClubByIdQuery(variables: GetClubByIdQueryVariables) {
      return { query: GetClubByIdDocument, variables: variables }
    }
export const GetClubByIdLegacyDocument = gql`
    query getClubByIdLegacy($publicId: String!) {
  club(publicId: $publicId) {
    ...baseClub
    ...clubWithCoaches
    ...clubWithFederation
    members {
      ...clubMember
    }
    platform {
      ...basePlatform
    }
    clubServices {
      ...clubService
    }
  }
}
    ${BaseClubFragmentDoc}
${ClubWithCoachesFragmentDoc}
${ClubWithFederationFragmentDoc}
${ClubMemberFragmentDoc}
${BasePlatformFragmentDoc}
${ClubServiceFragmentDoc}`;

/**
 * __useGetClubByIdLegacyQuery__
 *
 * To run a query within a React component, call `useGetClubByIdLegacyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubByIdLegacyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubByIdLegacyQuery({
 *   variables: {
 *      publicId: // value for 'publicId'
 *   },
 * });
 */
export function useGetClubByIdLegacyQuery(baseOptions: Apollo.QueryHookOptions<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables> & ({ variables: GetClubByIdLegacyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>(GetClubByIdLegacyDocument, options);
      }
export function useGetClubByIdLegacyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>(GetClubByIdLegacyDocument, options);
        }
export function useGetClubByIdLegacySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>(GetClubByIdLegacyDocument, options);
        }
export type GetClubByIdLegacyQueryHookResult = ReturnType<typeof useGetClubByIdLegacyQuery>;
export type GetClubByIdLegacyLazyQueryHookResult = ReturnType<typeof useGetClubByIdLegacyLazyQuery>;
export type GetClubByIdLegacySuspenseQueryHookResult = ReturnType<typeof useGetClubByIdLegacySuspenseQuery>;
export type GetClubByIdLegacyQueryResult = Apollo.QueryResult<GetClubByIdLegacyQuery, GetClubByIdLegacyQueryVariables>;
export function refetchGetClubByIdLegacyQuery(variables: GetClubByIdLegacyQueryVariables) {
      return { query: GetClubByIdLegacyDocument, variables: variables }
    }
export const GetClubMembersDocument = gql`
    query getClubMembers($input: ClubMemberListFilterInput!) {
  clubMemberList(input: $input) {
    clubMembers {
      ...clubMember
    }
    total
  }
}
    ${ClubMemberFragmentDoc}`;

/**
 * __useGetClubMembersQuery__
 *
 * To run a query within a React component, call `useGetClubMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMembersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClubMembersQuery(baseOptions: Apollo.QueryHookOptions<GetClubMembersQuery, GetClubMembersQueryVariables> & ({ variables: GetClubMembersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubMembersQuery, GetClubMembersQueryVariables>(GetClubMembersDocument, options);
      }
export function useGetClubMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubMembersQuery, GetClubMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubMembersQuery, GetClubMembersQueryVariables>(GetClubMembersDocument, options);
        }
export function useGetClubMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubMembersQuery, GetClubMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubMembersQuery, GetClubMembersQueryVariables>(GetClubMembersDocument, options);
        }
export type GetClubMembersQueryHookResult = ReturnType<typeof useGetClubMembersQuery>;
export type GetClubMembersLazyQueryHookResult = ReturnType<typeof useGetClubMembersLazyQuery>;
export type GetClubMembersSuspenseQueryHookResult = ReturnType<typeof useGetClubMembersSuspenseQuery>;
export type GetClubMembersQueryResult = Apollo.QueryResult<GetClubMembersQuery, GetClubMembersQueryVariables>;
export function refetchGetClubMembersQuery(variables: GetClubMembersQueryVariables) {
      return { query: GetClubMembersDocument, variables: variables }
    }
export const GetClubMembersStatsDocument = gql`
    query getClubMembersStats($clubId: Int!) {
  clubMembersStats(clubId: $clubId) {
    ...clubMemberStats
  }
}
    ${ClubMemberStatsFragmentDoc}`;

/**
 * __useGetClubMembersStatsQuery__
 *
 * To run a query within a React component, call `useGetClubMembersStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubMembersStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubMembersStatsQuery({
 *   variables: {
 *      clubId: // value for 'clubId'
 *   },
 * });
 */
export function useGetClubMembersStatsQuery(baseOptions: Apollo.QueryHookOptions<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables> & ({ variables: GetClubMembersStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>(GetClubMembersStatsDocument, options);
      }
export function useGetClubMembersStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>(GetClubMembersStatsDocument, options);
        }
export function useGetClubMembersStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>(GetClubMembersStatsDocument, options);
        }
export type GetClubMembersStatsQueryHookResult = ReturnType<typeof useGetClubMembersStatsQuery>;
export type GetClubMembersStatsLazyQueryHookResult = ReturnType<typeof useGetClubMembersStatsLazyQuery>;
export type GetClubMembersStatsSuspenseQueryHookResult = ReturnType<typeof useGetClubMembersStatsSuspenseQuery>;
export type GetClubMembersStatsQueryResult = Apollo.QueryResult<GetClubMembersStatsQuery, GetClubMembersStatsQueryVariables>;
export function refetchGetClubMembersStatsQuery(variables: GetClubMembersStatsQueryVariables) {
      return { query: GetClubMembersStatsDocument, variables: variables }
    }
export const GetClubServiceResourcesDocument = gql`
    query getClubServiceResources($club: Int) {
  clubServiceResources(filter: {club: $club}) {
    ...clubServiceResource
  }
}
    ${ClubServiceResourceFragmentDoc}`;

/**
 * __useGetClubServiceResourcesQuery__
 *
 * To run a query within a React component, call `useGetClubServiceResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubServiceResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubServiceResourcesQuery({
 *   variables: {
 *      club: // value for 'club'
 *   },
 * });
 */
export function useGetClubServiceResourcesQuery(baseOptions?: Apollo.QueryHookOptions<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>(GetClubServiceResourcesDocument, options);
      }
export function useGetClubServiceResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>(GetClubServiceResourcesDocument, options);
        }
export function useGetClubServiceResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>(GetClubServiceResourcesDocument, options);
        }
export type GetClubServiceResourcesQueryHookResult = ReturnType<typeof useGetClubServiceResourcesQuery>;
export type GetClubServiceResourcesLazyQueryHookResult = ReturnType<typeof useGetClubServiceResourcesLazyQuery>;
export type GetClubServiceResourcesSuspenseQueryHookResult = ReturnType<typeof useGetClubServiceResourcesSuspenseQuery>;
export type GetClubServiceResourcesQueryResult = Apollo.QueryResult<GetClubServiceResourcesQuery, GetClubServiceResourcesQueryVariables>;
export function refetchGetClubServiceResourcesQuery(variables?: GetClubServiceResourcesQueryVariables) {
      return { query: GetClubServiceResourcesDocument, variables: variables }
    }
export const GetClubsDocument = gql`
    query getClubs($input: ClubListInput!) {
  clubList(input: $input) {
    clubs {
      ...baseClub
      ...clubWithFederation
      ...clubWithPlatforms
      ...clubWithMembersCount
      ...clubWithTournamentsCount
    }
    total
  }
}
    ${BaseClubFragmentDoc}
${ClubWithFederationFragmentDoc}
${ClubWithPlatformsFragmentDoc}
${ClubWithMembersCountFragmentDoc}
${ClubWithTournamentsCountFragmentDoc}`;

/**
 * __useGetClubsQuery__
 *
 * To run a query within a React component, call `useGetClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClubsQuery(baseOptions: Apollo.QueryHookOptions<GetClubsQuery, GetClubsQueryVariables> & ({ variables: GetClubsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
      }
export function useGetClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubsQuery, GetClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
        }
export function useGetClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubsQuery, GetClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubsQuery, GetClubsQueryVariables>(GetClubsDocument, options);
        }
export type GetClubsQueryHookResult = ReturnType<typeof useGetClubsQuery>;
export type GetClubsLazyQueryHookResult = ReturnType<typeof useGetClubsLazyQuery>;
export type GetClubsSuspenseQueryHookResult = ReturnType<typeof useGetClubsSuspenseQuery>;
export type GetClubsQueryResult = Apollo.QueryResult<GetClubsQuery, GetClubsQueryVariables>;
export function refetchGetClubsQuery(variables: GetClubsQueryVariables) {
      return { query: GetClubsDocument, variables: variables }
    }
export const GetClubsByIdsDocument = gql`
    query getClubsByIds($ids: [Int!]!) {
  clubsByIds(ids: $ids) {
    ...baseClub
  }
}
    ${BaseClubFragmentDoc}`;

/**
 * __useGetClubsByIdsQuery__
 *
 * To run a query within a React component, call `useGetClubsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetClubsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetClubsByIdsQuery, GetClubsByIdsQueryVariables> & ({ variables: GetClubsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>(GetClubsByIdsDocument, options);
      }
export function useGetClubsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>(GetClubsByIdsDocument, options);
        }
export function useGetClubsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>(GetClubsByIdsDocument, options);
        }
export type GetClubsByIdsQueryHookResult = ReturnType<typeof useGetClubsByIdsQuery>;
export type GetClubsByIdsLazyQueryHookResult = ReturnType<typeof useGetClubsByIdsLazyQuery>;
export type GetClubsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetClubsByIdsSuspenseQuery>;
export type GetClubsByIdsQueryResult = Apollo.QueryResult<GetClubsByIdsQuery, GetClubsByIdsQueryVariables>;
export function refetchGetClubsByIdsQuery(variables: GetClubsByIdsQueryVariables) {
      return { query: GetClubsByIdsDocument, variables: variables }
    }
export const GetClubsOldDocument = gql`
    query getClubsOld($page: Int!, $limit: Int!, $sport: String, $filter: ListClubInput, $isManager: Boolean) {
  clubs(
    page: $page
    limit: $limit
    sport: $sport
    filter: $filter
    isManager: $isManager
  )
}
    `;

/**
 * __useGetClubsOldQuery__
 *
 * To run a query within a React component, call `useGetClubsOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClubsOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClubsOldQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      sport: // value for 'sport'
 *      filter: // value for 'filter'
 *      isManager: // value for 'isManager'
 *   },
 * });
 */
export function useGetClubsOldQuery(baseOptions: Apollo.QueryHookOptions<GetClubsOldQuery, GetClubsOldQueryVariables> & ({ variables: GetClubsOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClubsOldQuery, GetClubsOldQueryVariables>(GetClubsOldDocument, options);
      }
export function useGetClubsOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClubsOldQuery, GetClubsOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClubsOldQuery, GetClubsOldQueryVariables>(GetClubsOldDocument, options);
        }
export function useGetClubsOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClubsOldQuery, GetClubsOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClubsOldQuery, GetClubsOldQueryVariables>(GetClubsOldDocument, options);
        }
export type GetClubsOldQueryHookResult = ReturnType<typeof useGetClubsOldQuery>;
export type GetClubsOldLazyQueryHookResult = ReturnType<typeof useGetClubsOldLazyQuery>;
export type GetClubsOldSuspenseQueryHookResult = ReturnType<typeof useGetClubsOldSuspenseQuery>;
export type GetClubsOldQueryResult = Apollo.QueryResult<GetClubsOldQuery, GetClubsOldQueryVariables>;
export function refetchGetClubsOldQuery(variables: GetClubsOldQueryVariables) {
      return { query: GetClubsOldDocument, variables: variables }
    }
export const SearchClubsDocument = gql`
    query searchClubs($input: ClubListInput!) {
  clubList(input: $input) {
    clubs {
      ...baseClub
    }
    total
  }
}
    ${BaseClubFragmentDoc}`;

/**
 * __useSearchClubsQuery__
 *
 * To run a query within a React component, call `useSearchClubsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClubsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClubsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchClubsQuery(baseOptions: Apollo.QueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables> & ({ variables: SearchClubsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
      }
export function useSearchClubsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
        }
export function useSearchClubsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchClubsQuery, SearchClubsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchClubsQuery, SearchClubsQueryVariables>(SearchClubsDocument, options);
        }
export type SearchClubsQueryHookResult = ReturnType<typeof useSearchClubsQuery>;
export type SearchClubsLazyQueryHookResult = ReturnType<typeof useSearchClubsLazyQuery>;
export type SearchClubsSuspenseQueryHookResult = ReturnType<typeof useSearchClubsSuspenseQuery>;
export type SearchClubsQueryResult = Apollo.QueryResult<SearchClubsQuery, SearchClubsQueryVariables>;
export function refetchSearchClubsQuery(variables: SearchClubsQueryVariables) {
      return { query: SearchClubsDocument, variables: variables }
    }
export const GetCoachesDocument = gql`
    query getCoaches($input: PlatformCoachFilterInput) {
  platformCoaches(input: $input) {
    platformCoaches {
      ...platformCoach
      ...platformCoachWithStudents
      ...platformCoachWithClubs
    }
    total
  }
}
    ${PlatformCoachFragmentDoc}
${PlatformCoachWithStudentsFragmentDoc}
${PlatformCoachWithClubsFragmentDoc}`;

/**
 * __useGetCoachesQuery__
 *
 * To run a query within a React component, call `useGetCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoachesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetCoachesQuery, GetCoachesQueryVariables> & ({ variables: GetCoachesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCoachesQuery, GetCoachesQueryVariables>(GetCoachesDocument, options);
      }
export function useGetCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCoachesQuery, GetCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCoachesQuery, GetCoachesQueryVariables>(GetCoachesDocument, options);
        }
export function useGetCoachesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCoachesQuery, GetCoachesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCoachesQuery, GetCoachesQueryVariables>(GetCoachesDocument, options);
        }
export type GetCoachesQueryHookResult = ReturnType<typeof useGetCoachesQuery>;
export type GetCoachesLazyQueryHookResult = ReturnType<typeof useGetCoachesLazyQuery>;
export type GetCoachesSuspenseQueryHookResult = ReturnType<typeof useGetCoachesSuspenseQuery>;
export type GetCoachesQueryResult = Apollo.QueryResult<GetCoachesQuery, GetCoachesQueryVariables>;
export function refetchGetCoachesQuery(variables: GetCoachesQueryVariables) {
      return { query: GetCoachesDocument, variables: variables }
    }
export const GetPlatformCoachesDocument = gql`
    query getPlatformCoaches($input: PlatformCoachFilterInput) {
  platformCoaches(input: $input) {
    platformCoaches {
      ...platformCoach
      ...platformCoachWithClubs
      ...platformCoachWithStudents
    }
    total
  }
}
    ${PlatformCoachFragmentDoc}
${PlatformCoachWithClubsFragmentDoc}
${PlatformCoachWithStudentsFragmentDoc}`;

/**
 * __useGetPlatformCoachesQuery__
 *
 * To run a query within a React component, call `useGetPlatformCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformCoachesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlatformCoachesQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables> & ({ variables: GetPlatformCoachesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>(GetPlatformCoachesDocument, options);
      }
export function useGetPlatformCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>(GetPlatformCoachesDocument, options);
        }
export function useGetPlatformCoachesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>(GetPlatformCoachesDocument, options);
        }
export type GetPlatformCoachesQueryHookResult = ReturnType<typeof useGetPlatformCoachesQuery>;
export type GetPlatformCoachesLazyQueryHookResult = ReturnType<typeof useGetPlatformCoachesLazyQuery>;
export type GetPlatformCoachesSuspenseQueryHookResult = ReturnType<typeof useGetPlatformCoachesSuspenseQuery>;
export type GetPlatformCoachesQueryResult = Apollo.QueryResult<GetPlatformCoachesQuery, GetPlatformCoachesQueryVariables>;
export function refetchGetPlatformCoachesQuery(variables: GetPlatformCoachesQueryVariables) {
      return { query: GetPlatformCoachesDocument, variables: variables }
    }
export const GetDisciplinesDocument = gql`
    query getDisciplines($filter: ListDisciplineInput) {
  disciplines(filter: $filter) {
    ...discipline
  }
}
    ${DisciplineFragmentDoc}`;

/**
 * __useGetDisciplinesQuery__
 *
 * To run a query within a React component, call `useGetDisciplinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisciplinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisciplinesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetDisciplinesQuery(baseOptions?: Apollo.QueryHookOptions<GetDisciplinesQuery, GetDisciplinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisciplinesQuery, GetDisciplinesQueryVariables>(GetDisciplinesDocument, options);
      }
export function useGetDisciplinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisciplinesQuery, GetDisciplinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisciplinesQuery, GetDisciplinesQueryVariables>(GetDisciplinesDocument, options);
        }
export function useGetDisciplinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDisciplinesQuery, GetDisciplinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDisciplinesQuery, GetDisciplinesQueryVariables>(GetDisciplinesDocument, options);
        }
export type GetDisciplinesQueryHookResult = ReturnType<typeof useGetDisciplinesQuery>;
export type GetDisciplinesLazyQueryHookResult = ReturnType<typeof useGetDisciplinesLazyQuery>;
export type GetDisciplinesSuspenseQueryHookResult = ReturnType<typeof useGetDisciplinesSuspenseQuery>;
export type GetDisciplinesQueryResult = Apollo.QueryResult<GetDisciplinesQuery, GetDisciplinesQueryVariables>;
export function refetchGetDisciplinesQuery(variables?: GetDisciplinesQueryVariables) {
      return { query: GetDisciplinesDocument, variables: variables }
    }
export const GetAdditionalServicesDocument = gql`
    query getAdditionalServices {
  resourceServices(filter: {type: "additionalService"}) {
    id
    service
  }
}
    `;

/**
 * __useGetAdditionalServicesQuery__
 *
 * To run a query within a React component, call `useGetAdditionalServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdditionalServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>(GetAdditionalServicesDocument, options);
      }
export function useGetAdditionalServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>(GetAdditionalServicesDocument, options);
        }
export function useGetAdditionalServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>(GetAdditionalServicesDocument, options);
        }
export type GetAdditionalServicesQueryHookResult = ReturnType<typeof useGetAdditionalServicesQuery>;
export type GetAdditionalServicesLazyQueryHookResult = ReturnType<typeof useGetAdditionalServicesLazyQuery>;
export type GetAdditionalServicesSuspenseQueryHookResult = ReturnType<typeof useGetAdditionalServicesSuspenseQuery>;
export type GetAdditionalServicesQueryResult = Apollo.QueryResult<GetAdditionalServicesQuery, GetAdditionalServicesQueryVariables>;
export function refetchGetAdditionalServicesQuery(variables?: GetAdditionalServicesQueryVariables) {
      return { query: GetAdditionalServicesDocument, variables: variables }
    }
export const GetAllNewsDocument = gql`
    query getAllNews($filter: ListNewsInput, $sortBy: String) {
  allNews(filter: $filter, sortBy: $sortBy) {
    news {
      ...news
      platform {
        title
        id
        platformLink
      }
      federationNews {
        id
        federation {
          id
          organizationName
        }
      }
      leagueNews {
        id
        league {
          title
        }
      }
      clubNews {
        club {
          clubName
        }
      }
      author {
        id
        email
        name
        surname
      }
    }
    total
  }
}
    ${NewsFragmentDoc}`;

/**
 * __useGetAllNewsQuery__
 *
 * To run a query within a React component, call `useGetAllNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllNewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetAllNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
      }
export function useGetAllNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
        }
export function useGetAllNewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllNewsQuery, GetAllNewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllNewsQuery, GetAllNewsQueryVariables>(GetAllNewsDocument, options);
        }
export type GetAllNewsQueryHookResult = ReturnType<typeof useGetAllNewsQuery>;
export type GetAllNewsLazyQueryHookResult = ReturnType<typeof useGetAllNewsLazyQuery>;
export type GetAllNewsSuspenseQueryHookResult = ReturnType<typeof useGetAllNewsSuspenseQuery>;
export type GetAllNewsQueryResult = Apollo.QueryResult<GetAllNewsQuery, GetAllNewsQueryVariables>;
export function refetchGetAllNewsQuery(variables?: GetAllNewsQueryVariables) {
      return { query: GetAllNewsDocument, variables: variables }
    }
export const GetAllPlatformNamesDocument = gql`
    query getAllPlatformNames {
  allPlatformsNames {
    publicId
    ...basePlatform
    ...platformWithOwner
    ...platformWithFees
    ...platformWithSports
  }
}
    ${BasePlatformFragmentDoc}
${PlatformWithOwnerFragmentDoc}
${PlatformWithFeesFragmentDoc}
${PlatformWithSportsFragmentDoc}`;

/**
 * __useGetAllPlatformNamesQuery__
 *
 * To run a query within a React component, call `useGetAllPlatformNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllPlatformNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllPlatformNamesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllPlatformNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>(GetAllPlatformNamesDocument, options);
      }
export function useGetAllPlatformNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>(GetAllPlatformNamesDocument, options);
        }
export function useGetAllPlatformNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>(GetAllPlatformNamesDocument, options);
        }
export type GetAllPlatformNamesQueryHookResult = ReturnType<typeof useGetAllPlatformNamesQuery>;
export type GetAllPlatformNamesLazyQueryHookResult = ReturnType<typeof useGetAllPlatformNamesLazyQuery>;
export type GetAllPlatformNamesSuspenseQueryHookResult = ReturnType<typeof useGetAllPlatformNamesSuspenseQuery>;
export type GetAllPlatformNamesQueryResult = Apollo.QueryResult<GetAllPlatformNamesQuery, GetAllPlatformNamesQueryVariables>;
export function refetchGetAllPlatformNamesQuery(variables?: GetAllPlatformNamesQueryVariables) {
      return { query: GetAllPlatformNamesDocument, variables: variables }
    }
export const GetAllTournamentNamesDocument = gql`
    query getAllTournamentNames($page: Int, $limit: Int, $filter: ListTournamentInput, $platformPublicId: String, $sports: [Int!], $organizationPublicId: String, $startFrom: String, $startTo: String, $createdAtFrom: String, $createdAtTo: String, $isDashboard: Boolean) {
  allTournamentNames(
    page: $page
    limit: $limit
    filter: $filter
    platformPublicId: $platformPublicId
    sports: $sports
    organizationPublicId: $organizationPublicId
    startFrom: $startFrom
    startTo: $startTo
    createdAtFrom: $createdAtFrom
    createdAtTo: $createdAtTo
    isDashboard: $isDashboard
  )
}
    `;

/**
 * __useGetAllTournamentNamesQuery__
 *
 * To run a query within a React component, call `useGetAllTournamentNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllTournamentNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllTournamentNamesQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      platformPublicId: // value for 'platformPublicId'
 *      sports: // value for 'sports'
 *      organizationPublicId: // value for 'organizationPublicId'
 *      startFrom: // value for 'startFrom'
 *      startTo: // value for 'startTo'
 *      createdAtFrom: // value for 'createdAtFrom'
 *      createdAtTo: // value for 'createdAtTo'
 *      isDashboard: // value for 'isDashboard'
 *   },
 * });
 */
export function useGetAllTournamentNamesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>(GetAllTournamentNamesDocument, options);
      }
export function useGetAllTournamentNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>(GetAllTournamentNamesDocument, options);
        }
export function useGetAllTournamentNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>(GetAllTournamentNamesDocument, options);
        }
export type GetAllTournamentNamesQueryHookResult = ReturnType<typeof useGetAllTournamentNamesQuery>;
export type GetAllTournamentNamesLazyQueryHookResult = ReturnType<typeof useGetAllTournamentNamesLazyQuery>;
export type GetAllTournamentNamesSuspenseQueryHookResult = ReturnType<typeof useGetAllTournamentNamesSuspenseQuery>;
export type GetAllTournamentNamesQueryResult = Apollo.QueryResult<GetAllTournamentNamesQuery, GetAllTournamentNamesQueryVariables>;
export function refetchGetAllTournamentNamesQuery(variables?: GetAllTournamentNamesQueryVariables) {
      return { query: GetAllTournamentNamesDocument, variables: variables }
    }
export const GetGalleriesListDocument = gql`
    query getGalleriesList($filter: ListAlbumInput, $platformPublicId: String, $organizationPublicId: String, $page: Int, $limit: Int) {
  findAllAlbum(
    filter: $filter
    platformPublicId: $platformPublicId
    organizationPublicId: $organizationPublicId
    page: $page
    limit: $limit
  ) {
    albums {
      ...album
      ...albumWithMedia
      ...albumWithCreatedBy
      ...albumWithLeague
      ...albumWithTournament
    }
    total
  }
}
    ${AlbumFragmentDoc}
${AlbumWithMediaFragmentDoc}
${AlbumWithCreatedByFragmentDoc}
${AlbumWithLeagueFragmentDoc}
${AlbumWithTournamentFragmentDoc}`;

/**
 * __useGetGalleriesListQuery__
 *
 * To run a query within a React component, call `useGetGalleriesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGalleriesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGalleriesListQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      platformPublicId: // value for 'platformPublicId'
 *      organizationPublicId: // value for 'organizationPublicId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetGalleriesListQuery(baseOptions?: Apollo.QueryHookOptions<GetGalleriesListQuery, GetGalleriesListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGalleriesListQuery, GetGalleriesListQueryVariables>(GetGalleriesListDocument, options);
      }
export function useGetGalleriesListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGalleriesListQuery, GetGalleriesListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGalleriesListQuery, GetGalleriesListQueryVariables>(GetGalleriesListDocument, options);
        }
export function useGetGalleriesListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetGalleriesListQuery, GetGalleriesListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetGalleriesListQuery, GetGalleriesListQueryVariables>(GetGalleriesListDocument, options);
        }
export type GetGalleriesListQueryHookResult = ReturnType<typeof useGetGalleriesListQuery>;
export type GetGalleriesListLazyQueryHookResult = ReturnType<typeof useGetGalleriesListLazyQuery>;
export type GetGalleriesListSuspenseQueryHookResult = ReturnType<typeof useGetGalleriesListSuspenseQuery>;
export type GetGalleriesListQueryResult = Apollo.QueryResult<GetGalleriesListQuery, GetGalleriesListQueryVariables>;
export function refetchGetGalleriesListQuery(variables?: GetGalleriesListQueryVariables) {
      return { query: GetGalleriesListDocument, variables: variables }
    }
export const GetLeagueDocumentsDocument = gql`
    query getLeagueDocuments($filter: ListLeagueDocumentInput) {
  leagueDocuments(filter: $filter) {
    ...leagueDocument
  }
}
    ${LeagueDocumentFragmentDoc}`;

/**
 * __useGetLeagueDocumentsQuery__
 *
 * To run a query within a React component, call `useGetLeagueDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLeagueDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>(GetLeagueDocumentsDocument, options);
      }
export function useGetLeagueDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>(GetLeagueDocumentsDocument, options);
        }
export function useGetLeagueDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>(GetLeagueDocumentsDocument, options);
        }
export type GetLeagueDocumentsQueryHookResult = ReturnType<typeof useGetLeagueDocumentsQuery>;
export type GetLeagueDocumentsLazyQueryHookResult = ReturnType<typeof useGetLeagueDocumentsLazyQuery>;
export type GetLeagueDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetLeagueDocumentsSuspenseQuery>;
export type GetLeagueDocumentsQueryResult = Apollo.QueryResult<GetLeagueDocumentsQuery, GetLeagueDocumentsQueryVariables>;
export function refetchGetLeagueDocumentsQuery(variables?: GetLeagueDocumentsQueryVariables) {
      return { query: GetLeagueDocumentsDocument, variables: variables }
    }
export const GetLicenseQuestionsDocument = gql`
    query getLicenseQuestions($purchasedLicense: Int) {
  licenseQuestions(
    listLicenseQuestionInput: {purchasedLicense: $purchasedLicense}
  ) {
    ...licenseQuestion
  }
}
    ${LicenseQuestionFragmentDoc}`;

/**
 * __useGetLicenseQuestionsQuery__
 *
 * To run a query within a React component, call `useGetLicenseQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseQuestionsQuery({
 *   variables: {
 *      purchasedLicense: // value for 'purchasedLicense'
 *   },
 * });
 */
export function useGetLicenseQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>(GetLicenseQuestionsDocument, options);
      }
export function useGetLicenseQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>(GetLicenseQuestionsDocument, options);
        }
export function useGetLicenseQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>(GetLicenseQuestionsDocument, options);
        }
export type GetLicenseQuestionsQueryHookResult = ReturnType<typeof useGetLicenseQuestionsQuery>;
export type GetLicenseQuestionsLazyQueryHookResult = ReturnType<typeof useGetLicenseQuestionsLazyQuery>;
export type GetLicenseQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetLicenseQuestionsSuspenseQuery>;
export type GetLicenseQuestionsQueryResult = Apollo.QueryResult<GetLicenseQuestionsQuery, GetLicenseQuestionsQueryVariables>;
export function refetchGetLicenseQuestionsQuery(variables?: GetLicenseQuestionsQueryVariables) {
      return { query: GetLicenseQuestionsDocument, variables: variables }
    }
export const GetOrganizationFederationsDocument = gql`
    query getOrganizationFederations($filter: ListOrganizationPlatformsInput!) {
  organizationFederations: organizationFedrations(filter: $filter) {
    id
    federation {
      publicId
      ...federation
      ...federationWithManagers
      ...federationWithPlatforms
    }
  }
}
    ${FederationFragmentDoc}
${FederationWithManagersFragmentDoc}
${FederationWithPlatformsFragmentDoc}`;

/**
 * __useGetOrganizationFederationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationFederationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationFederationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationFederationsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationFederationsQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables> & ({ variables: GetOrganizationFederationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>(GetOrganizationFederationsDocument, options);
      }
export function useGetOrganizationFederationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>(GetOrganizationFederationsDocument, options);
        }
export function useGetOrganizationFederationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>(GetOrganizationFederationsDocument, options);
        }
export type GetOrganizationFederationsQueryHookResult = ReturnType<typeof useGetOrganizationFederationsQuery>;
export type GetOrganizationFederationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationFederationsLazyQuery>;
export type GetOrganizationFederationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationFederationsSuspenseQuery>;
export type GetOrganizationFederationsQueryResult = Apollo.QueryResult<GetOrganizationFederationsQuery, GetOrganizationFederationsQueryVariables>;
export function refetchGetOrganizationFederationsQuery(variables: GetOrganizationFederationsQueryVariables) {
      return { query: GetOrganizationFederationsDocument, variables: variables }
    }
export const GetOrganizationPlatformByIdDocument = gql`
    query getOrganizationPlatformById($platformPublicId: String!) {
  organizationPlatformByFields(platformPublicId: $platformPublicId) {
    ...organizationSubscription
  }
}
    ${OrganizationSubscriptionFragmentDoc}`;

/**
 * __useGetOrganizationPlatformByIdQuery__
 *
 * To run a query within a React component, call `useGetOrganizationPlatformByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationPlatformByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationPlatformByIdQuery({
 *   variables: {
 *      platformPublicId: // value for 'platformPublicId'
 *   },
 * });
 */
export function useGetOrganizationPlatformByIdQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables> & ({ variables: GetOrganizationPlatformByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>(GetOrganizationPlatformByIdDocument, options);
      }
export function useGetOrganizationPlatformByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>(GetOrganizationPlatformByIdDocument, options);
        }
export function useGetOrganizationPlatformByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>(GetOrganizationPlatformByIdDocument, options);
        }
export type GetOrganizationPlatformByIdQueryHookResult = ReturnType<typeof useGetOrganizationPlatformByIdQuery>;
export type GetOrganizationPlatformByIdLazyQueryHookResult = ReturnType<typeof useGetOrganizationPlatformByIdLazyQuery>;
export type GetOrganizationPlatformByIdSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationPlatformByIdSuspenseQuery>;
export type GetOrganizationPlatformByIdQueryResult = Apollo.QueryResult<GetOrganizationPlatformByIdQuery, GetOrganizationPlatformByIdQueryVariables>;
export function refetchGetOrganizationPlatformByIdQuery(variables: GetOrganizationPlatformByIdQueryVariables) {
      return { query: GetOrganizationPlatformByIdDocument, variables: variables }
    }
export const GetOrganizationsDocument = gql`
    query getOrganizations($page: Int, $limit: Int, $filter: ListFederationInput, $platform: Int) {
  federations(page: $page, limit: $limit, filter: $filter, platform: $platform) {
    federations {
      ...federation
    }
    total
  }
}
    ${FederationFragmentDoc}`;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export function refetchGetOrganizationsQuery(variables?: GetOrganizationsQueryVariables) {
      return { query: GetOrganizationsDocument, variables: variables }
    }
export const GetPlatformThirdPartyLicensesDocument = gql`
    query getPlatformThirdPartyLicenses($platformPublicId: String!) {
  platform(publicId: $platformPublicId) {
    id
    thirdPartyLicenses {
      ...thirdPartyLicense
    }
  }
}
    ${ThirdPartyLicenseFragmentDoc}`;

/**
 * __useGetPlatformThirdPartyLicensesQuery__
 *
 * To run a query within a React component, call `useGetPlatformThirdPartyLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformThirdPartyLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformThirdPartyLicensesQuery({
 *   variables: {
 *      platformPublicId: // value for 'platformPublicId'
 *   },
 * });
 */
export function useGetPlatformThirdPartyLicensesQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables> & ({ variables: GetPlatformThirdPartyLicensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>(GetPlatformThirdPartyLicensesDocument, options);
      }
export function useGetPlatformThirdPartyLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>(GetPlatformThirdPartyLicensesDocument, options);
        }
export function useGetPlatformThirdPartyLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>(GetPlatformThirdPartyLicensesDocument, options);
        }
export type GetPlatformThirdPartyLicensesQueryHookResult = ReturnType<typeof useGetPlatformThirdPartyLicensesQuery>;
export type GetPlatformThirdPartyLicensesLazyQueryHookResult = ReturnType<typeof useGetPlatformThirdPartyLicensesLazyQuery>;
export type GetPlatformThirdPartyLicensesSuspenseQueryHookResult = ReturnType<typeof useGetPlatformThirdPartyLicensesSuspenseQuery>;
export type GetPlatformThirdPartyLicensesQueryResult = Apollo.QueryResult<GetPlatformThirdPartyLicensesQuery, GetPlatformThirdPartyLicensesQueryVariables>;
export function refetchGetPlatformThirdPartyLicensesQuery(variables: GetPlatformThirdPartyLicensesQueryVariables) {
      return { query: GetPlatformThirdPartyLicensesDocument, variables: variables }
    }
export const GetPlatformsDocument = gql`
    query getPlatforms($page: Int, $limit: Int, $filter: ListPlatformInput) {
  platforms(page: $page, limit: $limit, filter: $filter) {
    platforms {
      id
      organization {
        id
        federation {
          organizationName
          id
        }
      }
      country
      description
      language
      platformType
      status
      title
      currency
      sports {
        id
        sport {
          id
          title
          icon
        }
      }
      language
      country
      coverPhoto
      lightLogo
      companyName
      companyEmail
      onlinePayments
      liveScoring
    }
    total
  }
}
    `;

/**
 * __useGetPlatformsQuery__
 *
 * To run a query within a React component, call `useGetPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
      }
export function useGetPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
        }
export function useGetPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformsQuery, GetPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformsQuery, GetPlatformsQueryVariables>(GetPlatformsDocument, options);
        }
export type GetPlatformsQueryHookResult = ReturnType<typeof useGetPlatformsQuery>;
export type GetPlatformsLazyQueryHookResult = ReturnType<typeof useGetPlatformsLazyQuery>;
export type GetPlatformsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformsSuspenseQuery>;
export type GetPlatformsQueryResult = Apollo.QueryResult<GetPlatformsQuery, GetPlatformsQueryVariables>;
export function refetchGetPlatformsQuery(variables?: GetPlatformsQueryVariables) {
      return { query: GetPlatformsDocument, variables: variables }
    }
export const PostCategoriesDocument = gql`
    query postCategories($filter: ListPostCategoryInput) {
  postCategories(filter: $filter) {
    id
    name
    slug
    platform {
      id
      title
    }
    createdAt
    updatedAt
  }
}
    `;

/**
 * __usePostCategoriesQuery__
 *
 * To run a query within a React component, call `usePostCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePostCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
      }
export function usePostCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
        }
export function usePostCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostCategoriesQuery, PostCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostCategoriesQuery, PostCategoriesQueryVariables>(PostCategoriesDocument, options);
        }
export type PostCategoriesQueryHookResult = ReturnType<typeof usePostCategoriesQuery>;
export type PostCategoriesLazyQueryHookResult = ReturnType<typeof usePostCategoriesLazyQuery>;
export type PostCategoriesSuspenseQueryHookResult = ReturnType<typeof usePostCategoriesSuspenseQuery>;
export type PostCategoriesQueryResult = Apollo.QueryResult<PostCategoriesQuery, PostCategoriesQueryVariables>;
export function refetchPostCategoriesQuery(variables?: PostCategoriesQueryVariables) {
      return { query: PostCategoriesDocument, variables: variables }
    }
export const PostCategoryDocument = gql`
    query postCategory($id: Int!) {
  postCategory(id: $id) {
    id
    name
    slug
  }
}
    `;

/**
 * __usePostCategoryQuery__
 *
 * To run a query within a React component, call `usePostCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCategoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostCategoryQuery(baseOptions: Apollo.QueryHookOptions<PostCategoryQuery, PostCategoryQueryVariables> & ({ variables: PostCategoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCategoryQuery, PostCategoryQueryVariables>(PostCategoryDocument, options);
      }
export function usePostCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCategoryQuery, PostCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCategoryQuery, PostCategoryQueryVariables>(PostCategoryDocument, options);
        }
export function usePostCategorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostCategoryQuery, PostCategoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostCategoryQuery, PostCategoryQueryVariables>(PostCategoryDocument, options);
        }
export type PostCategoryQueryHookResult = ReturnType<typeof usePostCategoryQuery>;
export type PostCategoryLazyQueryHookResult = ReturnType<typeof usePostCategoryLazyQuery>;
export type PostCategorySuspenseQueryHookResult = ReturnType<typeof usePostCategorySuspenseQuery>;
export type PostCategoryQueryResult = Apollo.QueryResult<PostCategoryQuery, PostCategoryQueryVariables>;
export function refetchPostCategoryQuery(variables: PostCategoryQueryVariables) {
      return { query: PostCategoryDocument, variables: variables }
    }
export const GetRankingPointsDocument = gql`
    query getRankingPoints($filter: ListRankingPointsInput) {
  rankingPoints(filter: $filter) {
    ...rankingPoint
  }
}
    ${RankingPointFragmentDoc}`;

/**
 * __useGetRankingPointsQuery__
 *
 * To run a query within a React component, call `useGetRankingPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankingPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankingPointsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetRankingPointsQuery(baseOptions?: Apollo.QueryHookOptions<GetRankingPointsQuery, GetRankingPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankingPointsQuery, GetRankingPointsQueryVariables>(GetRankingPointsDocument, options);
      }
export function useGetRankingPointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankingPointsQuery, GetRankingPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankingPointsQuery, GetRankingPointsQueryVariables>(GetRankingPointsDocument, options);
        }
export function useGetRankingPointsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRankingPointsQuery, GetRankingPointsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRankingPointsQuery, GetRankingPointsQueryVariables>(GetRankingPointsDocument, options);
        }
export type GetRankingPointsQueryHookResult = ReturnType<typeof useGetRankingPointsQuery>;
export type GetRankingPointsLazyQueryHookResult = ReturnType<typeof useGetRankingPointsLazyQuery>;
export type GetRankingPointsSuspenseQueryHookResult = ReturnType<typeof useGetRankingPointsSuspenseQuery>;
export type GetRankingPointsQueryResult = Apollo.QueryResult<GetRankingPointsQuery, GetRankingPointsQueryVariables>;
export function refetchGetRankingPointsQuery(variables?: GetRankingPointsQueryVariables) {
      return { query: GetRankingPointsDocument, variables: variables }
    }
export const GetServicesDocument = gql`
    query getServices {
  resourceServices(filter: {type: "simpleService"}) {
    id
    service
  }
}
    `;

/**
 * __useGetServicesQuery__
 *
 * To run a query within a React component, call `useGetServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServicesQuery(baseOptions?: Apollo.QueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
      }
export function useGetServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
        }
export function useGetServicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServicesQuery, GetServicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServicesQuery, GetServicesQueryVariables>(GetServicesDocument, options);
        }
export type GetServicesQueryHookResult = ReturnType<typeof useGetServicesQuery>;
export type GetServicesLazyQueryHookResult = ReturnType<typeof useGetServicesLazyQuery>;
export type GetServicesSuspenseQueryHookResult = ReturnType<typeof useGetServicesSuspenseQuery>;
export type GetServicesQueryResult = Apollo.QueryResult<GetServicesQuery, GetServicesQueryVariables>;
export function refetchGetServicesQuery(variables?: GetServicesQueryVariables) {
      return { query: GetServicesDocument, variables: variables }
    }
export const GetSportsDocument = gql`
    query getSports($platform: Int, $platformPublicId: String, $filter: ListSportInput, $ids: [Int!]) {
  sports(
    platform: $platform
    platformPublicId: $platformPublicId
    filter: $filter
    ids: $ids
  ) {
    ...sport
    ...sportWithDiscipline
  }
}
    ${SportFragmentDoc}
${SportWithDisciplineFragmentDoc}`;

/**
 * __useGetSportsQuery__
 *
 * To run a query within a React component, call `useGetSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSportsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      platformPublicId: // value for 'platformPublicId'
 *      filter: // value for 'filter'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetSportsQuery(baseOptions?: Apollo.QueryHookOptions<GetSportsQuery, GetSportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSportsQuery, GetSportsQueryVariables>(GetSportsDocument, options);
      }
export function useGetSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSportsQuery, GetSportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSportsQuery, GetSportsQueryVariables>(GetSportsDocument, options);
        }
export function useGetSportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSportsQuery, GetSportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSportsQuery, GetSportsQueryVariables>(GetSportsDocument, options);
        }
export type GetSportsQueryHookResult = ReturnType<typeof useGetSportsQuery>;
export type GetSportsLazyQueryHookResult = ReturnType<typeof useGetSportsLazyQuery>;
export type GetSportsSuspenseQueryHookResult = ReturnType<typeof useGetSportsSuspenseQuery>;
export type GetSportsQueryResult = Apollo.QueryResult<GetSportsQuery, GetSportsQueryVariables>;
export function refetchGetSportsQuery(variables?: GetSportsQueryVariables) {
      return { query: GetSportsDocument, variables: variables }
    }
export const GetSubscriptionsDocument = gql`
    query getSubscriptions($filter: SubscriptionFilter) {
  subscriptions(filter: $filter) {
    subscriptions {
      ...subscription
      ...subscriptionWithPlatform
    }
  }
}
    ${SubscriptionFragmentDoc}
${SubscriptionWithPlatformFragmentDoc}`;

/**
 * __useGetSubscriptionsQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
      }
export function useGetSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export function useGetSubscriptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>(GetSubscriptionsDocument, options);
        }
export type GetSubscriptionsQueryHookResult = ReturnType<typeof useGetSubscriptionsQuery>;
export type GetSubscriptionsLazyQueryHookResult = ReturnType<typeof useGetSubscriptionsLazyQuery>;
export type GetSubscriptionsSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionsSuspenseQuery>;
export type GetSubscriptionsQueryResult = Apollo.QueryResult<GetSubscriptionsQuery, GetSubscriptionsQueryVariables>;
export function refetchGetSubscriptionsQuery(variables?: GetSubscriptionsQueryVariables) {
      return { query: GetSubscriptionsDocument, variables: variables }
    }
export const GetTransactionsDocument = gql`
    query getTransactions($tournament: Float, $platform: Float, $filter: ListTransactionHistory, $paymentTypes: [TransactionType!], $page: Int, $limit: Int, $search: String) {
  allTransactionHistory(
    tournament: $tournament
    platform: $platform
    filter: $filter
    paymentTypes: $paymentTypes
    page: $page
    limit: $limit
    search: $search
  ) {
    data {
      ...transaction
      ...transactionWithLicense
      ...transactionWithTournament
    }
    totalCount
  }
}
    ${TransactionFragmentDoc}
${TransactionWithLicenseFragmentDoc}
${TransactionWithTournamentFragmentDoc}`;

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      tournament: // value for 'tournament'
 *      platform: // value for 'platform'
 *      filter: // value for 'filter'
 *      paymentTypes: // value for 'paymentTypes'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export function useGetTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = Apollo.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export function refetchGetTransactionsQuery(variables?: GetTransactionsQueryVariables) {
      return { query: GetTransactionsDocument, variables: variables }
    }
export const GetVenuesDocument = gql`
    query getVenues($filter: ListTournamentVenueInput) {
  tournamentVenues(filter: $filter) {
    ...venue
    ...venueWithTournament
    ...venueWithClub
  }
}
    ${VenueFragmentDoc}
${VenueWithTournamentFragmentDoc}
${VenueWithClubFragmentDoc}`;

/**
 * __useGetVenuesQuery__
 *
 * To run a query within a React component, call `useGetVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVenuesQuery(baseOptions?: Apollo.QueryHookOptions<GetVenuesQuery, GetVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuesQuery, GetVenuesQueryVariables>(GetVenuesDocument, options);
      }
export function useGetVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuesQuery, GetVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuesQuery, GetVenuesQueryVariables>(GetVenuesDocument, options);
        }
export function useGetVenuesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVenuesQuery, GetVenuesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVenuesQuery, GetVenuesQueryVariables>(GetVenuesDocument, options);
        }
export type GetVenuesQueryHookResult = ReturnType<typeof useGetVenuesQuery>;
export type GetVenuesLazyQueryHookResult = ReturnType<typeof useGetVenuesLazyQuery>;
export type GetVenuesSuspenseQueryHookResult = ReturnType<typeof useGetVenuesSuspenseQuery>;
export type GetVenuesQueryResult = Apollo.QueryResult<GetVenuesQuery, GetVenuesQueryVariables>;
export function refetchGetVenuesQuery(variables?: GetVenuesQueryVariables) {
      return { query: GetVenuesDocument, variables: variables }
    }
export const ExportLeagueRankingsCsvUrlDocument = gql`
    query exportLeagueRankingsCsvUrl($league: Int, $date: String, $rankingCategory: Int, $country: String, $platform: Int, $sports: [Int!], $keyword: String, $leaguePublicId: ID) {
  exportLeagueRankingsCsvUrl(
    league: $league
    date: $date
    rankingCategory: $rankingCategory
    country: $country
    platform: $platform
    sports: $sports
    keyword: $keyword
    leaguePublicId: $leaguePublicId
  )
}
    `;

/**
 * __useExportLeagueRankingsCsvUrlQuery__
 *
 * To run a query within a React component, call `useExportLeagueRankingsCsvUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportLeagueRankingsCsvUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportLeagueRankingsCsvUrlQuery({
 *   variables: {
 *      league: // value for 'league'
 *      date: // value for 'date'
 *      rankingCategory: // value for 'rankingCategory'
 *      country: // value for 'country'
 *      platform: // value for 'platform'
 *      sports: // value for 'sports'
 *      keyword: // value for 'keyword'
 *   },
 * });
 */
export function useExportLeagueRankingsCsvUrlQuery(baseOptions: Apollo.QueryHookOptions<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables> & ({ variables: ExportLeagueRankingsCsvUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>(ExportLeagueRankingsCsvUrlDocument, options);
      }
export function useExportLeagueRankingsCsvUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>(ExportLeagueRankingsCsvUrlDocument, options);
        }
export function useExportLeagueRankingsCsvUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>(ExportLeagueRankingsCsvUrlDocument, options);
        }
export type ExportLeagueRankingsCsvUrlQueryHookResult = ReturnType<typeof useExportLeagueRankingsCsvUrlQuery>;
export type ExportLeagueRankingsCsvUrlLazyQueryHookResult = ReturnType<typeof useExportLeagueRankingsCsvUrlLazyQuery>;
export type ExportLeagueRankingsCsvUrlSuspenseQueryHookResult = ReturnType<typeof useExportLeagueRankingsCsvUrlSuspenseQuery>;
export type ExportLeagueRankingsCsvUrlQueryResult = Apollo.QueryResult<ExportLeagueRankingsCsvUrlQuery, ExportLeagueRankingsCsvUrlQueryVariables>;
export function refetchExportLeagueRankingsCsvUrlQuery(variables: ExportLeagueRankingsCsvUrlQueryVariables) {
      return { query: ExportLeagueRankingsCsvUrlDocument, variables: variables }
    }
export const GetAllLeagueNamesDocument = gql`
    query getAllLeagueNames($filter: ListLeagueInput!) {
  allLeaguesNames(filter: $filter) {
    ...league
    ...leagueWithAthleteIds
    ...leagueWithSports
    ...leagueWithPlatforms
    ...leagueWithOwner
    ...leagueWithTournamentsCount
  }
}
    ${LeagueFragmentDoc}
${LeagueWithAthleteIdsFragmentDoc}
${LeagueWithSportsFragmentDoc}
${LeagueWithPlatformsFragmentDoc}
${LeagueWithOwnerFragmentDoc}
${LeagueWithTournamentsCountFragmentDoc}`;

/**
 * __useGetAllLeagueNamesQuery__
 *
 * To run a query within a React component, call `useGetAllLeagueNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLeagueNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLeagueNamesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllLeagueNamesQuery(baseOptions: Apollo.QueryHookOptions<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables> & ({ variables: GetAllLeagueNamesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>(GetAllLeagueNamesDocument, options);
      }
export function useGetAllLeagueNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>(GetAllLeagueNamesDocument, options);
        }
export function useGetAllLeagueNamesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>(GetAllLeagueNamesDocument, options);
        }
export type GetAllLeagueNamesQueryHookResult = ReturnType<typeof useGetAllLeagueNamesQuery>;
export type GetAllLeagueNamesLazyQueryHookResult = ReturnType<typeof useGetAllLeagueNamesLazyQuery>;
export type GetAllLeagueNamesSuspenseQueryHookResult = ReturnType<typeof useGetAllLeagueNamesSuspenseQuery>;
export type GetAllLeagueNamesQueryResult = Apollo.QueryResult<GetAllLeagueNamesQuery, GetAllLeagueNamesQueryVariables>;
export function refetchGetAllLeagueNamesQuery(variables: GetAllLeagueNamesQueryVariables) {
      return { query: GetAllLeagueNamesDocument, variables: variables }
    }
export const GetLeagueRankingDatesDocument = gql`
    query getLeagueRankingDates($league: Int, $rankingCategory: Int, $leaguePublicId: ID) {
  leagueRankingDates(
    league: $league
    rankingCategory: $rankingCategory
    leaguePublicId: $leaguePublicId
  ) {
    date
    rankingCategoryId
  }
}
    `;

/**
 * __useGetLeagueRankingDatesQuery__
 *
 * To run a query within a React component, call `useGetLeagueRankingDatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueRankingDatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueRankingDatesQuery({
 *   variables: {
 *      league: // value for 'league'
 *      rankingCategory: // value for 'rankingCategory'
 *   },
 * });
 */
export function useGetLeagueRankingDatesQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables> & ({ variables: GetLeagueRankingDatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>(GetLeagueRankingDatesDocument, options);
      }
export function useGetLeagueRankingDatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>(GetLeagueRankingDatesDocument, options);
        }
export function useGetLeagueRankingDatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>(GetLeagueRankingDatesDocument, options);
        }
export type GetLeagueRankingDatesQueryHookResult = ReturnType<typeof useGetLeagueRankingDatesQuery>;
export type GetLeagueRankingDatesLazyQueryHookResult = ReturnType<typeof useGetLeagueRankingDatesLazyQuery>;
export type GetLeagueRankingDatesSuspenseQueryHookResult = ReturnType<typeof useGetLeagueRankingDatesSuspenseQuery>;
export type GetLeagueRankingDatesQueryResult = Apollo.QueryResult<GetLeagueRankingDatesQuery, GetLeagueRankingDatesQueryVariables>;
export function refetchGetLeagueRankingDatesQuery(variables: GetLeagueRankingDatesQueryVariables) {
      return { query: GetLeagueRankingDatesDocument, variables: variables }
    }
export const GetLeagueCategoriesDocument = gql`
    query getLeagueCategories($filter: ListLeagueCategoryInput!) {
  leagueCategories(filter: $filter) {
    ...leagueCategory
  }
}
    ${LeagueCategoryFragmentDoc}`;

/**
 * __useGetLeagueCategoriesQuery__
 *
 * To run a query within a React component, call `useGetLeagueCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueCategoriesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLeagueCategoriesQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables> & ({ variables: GetLeagueCategoriesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>(GetLeagueCategoriesDocument, options);
      }
export function useGetLeagueCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>(GetLeagueCategoriesDocument, options);
        }
export function useGetLeagueCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>(GetLeagueCategoriesDocument, options);
        }
export type GetLeagueCategoriesQueryHookResult = ReturnType<typeof useGetLeagueCategoriesQuery>;
export type GetLeagueCategoriesLazyQueryHookResult = ReturnType<typeof useGetLeagueCategoriesLazyQuery>;
export type GetLeagueCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetLeagueCategoriesSuspenseQuery>;
export type GetLeagueCategoriesQueryResult = Apollo.QueryResult<GetLeagueCategoriesQuery, GetLeagueCategoriesQueryVariables>;
export function refetchGetLeagueCategoriesQuery(variables: GetLeagueCategoriesQueryVariables) {
      return { query: GetLeagueCategoriesDocument, variables: variables }
    }
export const GetLeagueMembersDocument = gql`
    query getLeagueMembers($organizationPublicId: String, $platformPublicId: String, $filter: ListLeagueMemberInput) {
  leagueMembers(
    organizationPublicId: $organizationPublicId
    platformPublicId: $platformPublicId
    filter: $filter
  ) {
    ...leagueMember
    tournamentCount
    ...leagueMemberWithLeague
  }
}
    ${LeagueMemberFragmentDoc}
${LeagueMemberWithLeagueFragmentDoc}`;

/**
 * __useGetLeagueMembersQuery__
 *
 * To run a query within a React component, call `useGetLeagueMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMembersQuery({
 *   variables: {
 *      organizationPublicId: // value for 'organizationPublicId'
 *      platformPublicId: // value for 'platformPublicId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetLeagueMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>(GetLeagueMembersDocument, options);
      }
export function useGetLeagueMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>(GetLeagueMembersDocument, options);
        }
export function useGetLeagueMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>(GetLeagueMembersDocument, options);
        }
export type GetLeagueMembersQueryHookResult = ReturnType<typeof useGetLeagueMembersQuery>;
export type GetLeagueMembersLazyQueryHookResult = ReturnType<typeof useGetLeagueMembersLazyQuery>;
export type GetLeagueMembersSuspenseQueryHookResult = ReturnType<typeof useGetLeagueMembersSuspenseQuery>;
export type GetLeagueMembersQueryResult = Apollo.QueryResult<GetLeagueMembersQuery, GetLeagueMembersQueryVariables>;
export function refetchGetLeagueMembersQuery(variables?: GetLeagueMembersQueryVariables) {
      return { query: GetLeagueMembersDocument, variables: variables }
    }
export const GetLeagueMembersCountDocument = gql`
    query getLeagueMembersCount($organization: Int, $platform: Int) {
  leagueMembers(organization: $organization, platform: $platform) {
    id
  }
}
    `;

/**
 * __useGetLeagueMembersCountQuery__
 *
 * To run a query within a React component, call `useGetLeagueMembersCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMembersCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMembersCountQuery({
 *   variables: {
 *      organization: // value for 'organization'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useGetLeagueMembersCountQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>(GetLeagueMembersCountDocument, options);
      }
export function useGetLeagueMembersCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>(GetLeagueMembersCountDocument, options);
        }
export function useGetLeagueMembersCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>(GetLeagueMembersCountDocument, options);
        }
export type GetLeagueMembersCountQueryHookResult = ReturnType<typeof useGetLeagueMembersCountQuery>;
export type GetLeagueMembersCountLazyQueryHookResult = ReturnType<typeof useGetLeagueMembersCountLazyQuery>;
export type GetLeagueMembersCountSuspenseQueryHookResult = ReturnType<typeof useGetLeagueMembersCountSuspenseQuery>;
export type GetLeagueMembersCountQueryResult = Apollo.QueryResult<GetLeagueMembersCountQuery, GetLeagueMembersCountQueryVariables>;
export function refetchGetLeagueMembersCountQuery(variables?: GetLeagueMembersCountQueryVariables) {
      return { query: GetLeagueMembersCountDocument, variables: variables }
    }
export const GetLeagueRankingsHistoryDocument = gql`
    query getLeagueRankingsHistory($filter: ListLeagueRankingInput!, $country: String, $page: Int, $limit: Int) {
  leagueRankingsHistory(
    country: $country
    filter: $filter
    page: $page
    limit: $limit
  ) {
    rankings {
      ...leagueRanking
    }
    total
  }
}
    ${LeagueRankingFragmentDoc}`;

/**
 * __useGetLeagueRankingsHistoryQuery__
 *
 * To run a query within a React component, call `useGetLeagueRankingsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueRankingsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueRankingsHistoryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      country: // value for 'country'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLeagueRankingsHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables> & ({ variables: GetLeagueRankingsHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>(GetLeagueRankingsHistoryDocument, options);
      }
export function useGetLeagueRankingsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>(GetLeagueRankingsHistoryDocument, options);
        }
export function useGetLeagueRankingsHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>(GetLeagueRankingsHistoryDocument, options);
        }
export type GetLeagueRankingsHistoryQueryHookResult = ReturnType<typeof useGetLeagueRankingsHistoryQuery>;
export type GetLeagueRankingsHistoryLazyQueryHookResult = ReturnType<typeof useGetLeagueRankingsHistoryLazyQuery>;
export type GetLeagueRankingsHistorySuspenseQueryHookResult = ReturnType<typeof useGetLeagueRankingsHistorySuspenseQuery>;
export type GetLeagueRankingsHistoryQueryResult = Apollo.QueryResult<GetLeagueRankingsHistoryQuery, GetLeagueRankingsHistoryQueryVariables>;
export function refetchGetLeagueRankingsHistoryQuery(variables: GetLeagueRankingsHistoryQueryVariables) {
      return { query: GetLeagueRankingsHistoryDocument, variables: variables }
    }
export const GetLeagueRankingsDocument = gql`
    query getLeagueRankings($filter: ListLeagueRankingInput!, $country: String, $page: Int, $limit: Int) {
  leagueRankingsCustom(
    country: $country
    filter: $filter
    page: $page
    limit: $limit
  ) {
    rankings {
      ...leagueRanking
    }
    total
  }
}
    ${LeagueRankingFragmentDoc}`;

/**
 * __useGetLeagueRankingsQuery__
 *
 * To run a query within a React component, call `useGetLeagueRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueRankingsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      country: // value for 'country'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetLeagueRankingsQuery(baseOptions: Apollo.QueryHookOptions<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables> & ({ variables: GetLeagueRankingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>(GetLeagueRankingsDocument, options);
      }
export function useGetLeagueRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>(GetLeagueRankingsDocument, options);
        }
export function useGetLeagueRankingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>(GetLeagueRankingsDocument, options);
        }
export type GetLeagueRankingsQueryHookResult = ReturnType<typeof useGetLeagueRankingsQuery>;
export type GetLeagueRankingsLazyQueryHookResult = ReturnType<typeof useGetLeagueRankingsLazyQuery>;
export type GetLeagueRankingsSuspenseQueryHookResult = ReturnType<typeof useGetLeagueRankingsSuspenseQuery>;
export type GetLeagueRankingsQueryResult = Apollo.QueryResult<GetLeagueRankingsQuery, GetLeagueRankingsQueryVariables>;
export function refetchGetLeagueRankingsQuery(variables: GetLeagueRankingsQueryVariables) {
      return { query: GetLeagueRankingsDocument, variables: variables }
    }
export const GetLeaguesDocument = gql`
    query getLeagues($federationPublicId: String, $filter: ListLeagueInput, $relations: [String!], $limit: Int, $page: Int) {
  leagues(
    federationPublicId: $federationPublicId
    filter: $filter
    relations: $relations
    limit: $limit
    page: $page
  ) {
    ...league
    ...leagueWithSports
    ...leagueWithPlatforms
    ...leagueWithOwner
    ...leagueWithTournamentsCount
  }
}
    ${LeagueFragmentDoc}
${LeagueWithSportsFragmentDoc}
${LeagueWithPlatformsFragmentDoc}
${LeagueWithOwnerFragmentDoc}
${LeagueWithTournamentsCountFragmentDoc}`;

/**
 * __useGetLeaguesQuery__
 *
 * To run a query within a React component, call `useGetLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeaguesQuery({
 *   variables: {
 *      federationPublicId: // value for 'federationPublicId'
 *      filter: // value for 'filter'
 *      relations: // value for 'relations'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetLeaguesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeaguesQuery, GetLeaguesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeaguesQuery, GetLeaguesQueryVariables>(GetLeaguesDocument, options);
      }
export function useGetLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeaguesQuery, GetLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeaguesQuery, GetLeaguesQueryVariables>(GetLeaguesDocument, options);
        }
export function useGetLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeaguesQuery, GetLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeaguesQuery, GetLeaguesQueryVariables>(GetLeaguesDocument, options);
        }
export type GetLeaguesQueryHookResult = ReturnType<typeof useGetLeaguesQuery>;
export type GetLeaguesLazyQueryHookResult = ReturnType<typeof useGetLeaguesLazyQuery>;
export type GetLeaguesSuspenseQueryHookResult = ReturnType<typeof useGetLeaguesSuspenseQuery>;
export type GetLeaguesQueryResult = Apollo.QueryResult<GetLeaguesQuery, GetLeaguesQueryVariables>;
export function refetchGetLeaguesQuery(variables?: GetLeaguesQueryVariables) {
      return { query: GetLeaguesDocument, variables: variables }
    }
export const GetOrganizationLeagueCategoriesDocument = gql`
    query getOrganizationLeagueCategories($organizationPublicId: String, $filter: ListLeagueCategoryInput) {
  leagueCategories(organizationPublicId: $organizationPublicId, filter: $filter) {
    ...leagueCategory
    ...leagueCategoryWithLeague
  }
}
    ${LeagueCategoryFragmentDoc}
${LeagueCategoryWithLeagueFragmentDoc}`;

/**
 * __useGetOrganizationLeagueCategoriesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationLeagueCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationLeagueCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationLeagueCategoriesQuery({
 *   variables: {
 *      organizationPublicId: // value for 'organizationPublicId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOrganizationLeagueCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>(GetOrganizationLeagueCategoriesDocument, options);
      }
export function useGetOrganizationLeagueCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>(GetOrganizationLeagueCategoriesDocument, options);
        }
export function useGetOrganizationLeagueCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>(GetOrganizationLeagueCategoriesDocument, options);
        }
export type GetOrganizationLeagueCategoriesQueryHookResult = ReturnType<typeof useGetOrganizationLeagueCategoriesQuery>;
export type GetOrganizationLeagueCategoriesLazyQueryHookResult = ReturnType<typeof useGetOrganizationLeagueCategoriesLazyQuery>;
export type GetOrganizationLeagueCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationLeagueCategoriesSuspenseQuery>;
export type GetOrganizationLeagueCategoriesQueryResult = Apollo.QueryResult<GetOrganizationLeagueCategoriesQuery, GetOrganizationLeagueCategoriesQueryVariables>;
export function refetchGetOrganizationLeagueCategoriesQuery(variables?: GetOrganizationLeagueCategoriesQueryVariables) {
      return { query: GetOrganizationLeagueCategoriesDocument, variables: variables }
    }
export const GetLeagueMemberStatsDocument = gql`
    query getLeagueMemberStats($organizationPublicId: String, $platformPublicId: String) {
  getLeagueMemberStats(
    organizationPublicId: $organizationPublicId
    platformPublicId: $platformPublicId
  ) {
    total
    organizer
    manager
    referee
  }
}
    `;

/**
 * __useGetLeagueMemberStatsQuery__
 *
 * To run a query within a React component, call `useGetLeagueMemberStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueMemberStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueMemberStatsQuery({
 *   variables: {
 *      organizationPublicId: // value for 'organizationPublicId'
 *      platformPublicId: // value for 'platformPublicId'
 *   },
 * });
 */
export function useGetLeagueMemberStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>(GetLeagueMemberStatsDocument, options);
      }
export function useGetLeagueMemberStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>(GetLeagueMemberStatsDocument, options);
        }
export function useGetLeagueMemberStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>(GetLeagueMemberStatsDocument, options);
        }
export type GetLeagueMemberStatsQueryHookResult = ReturnType<typeof useGetLeagueMemberStatsQuery>;
export type GetLeagueMemberStatsLazyQueryHookResult = ReturnType<typeof useGetLeagueMemberStatsLazyQuery>;
export type GetLeagueMemberStatsSuspenseQueryHookResult = ReturnType<typeof useGetLeagueMemberStatsSuspenseQuery>;
export type GetLeagueMemberStatsQueryResult = Apollo.QueryResult<GetLeagueMemberStatsQuery, GetLeagueMemberStatsQueryVariables>;
export function refetchGetLeagueMemberStatsQuery(variables?: GetLeagueMemberStatsQueryVariables) {
      return { query: GetLeagueMemberStatsDocument, variables: variables }
    }
export const GetOrganizerLeagueMembersDocument = gql`
    query GetOrganizerLeagueMembers($platformPublicId: String, $page: Int, $limit: Int, $search: String) {
  organizerLeagueMembers(
    platformPublicId: $platformPublicId
    page: $page
    limit: $limit
    search: $search
  ) {
    total
    users {
      id
      name
      middle_name
      surname
      name_armenian
      surname_armenian
      is_includes_latin
      email
      LVID
      itf_points
      phone
      nation
      representingCountry
      country
      locationCountry
      role
      additionalUserRole
      avatar
      bt_country
      user_status
      organization_type
      organization_full_name
      organization_abbr
      organization_email
      organization_phone
      organization_avatar
      organization_submitted
      organization_allow_op
      stripeAccountId
      stripeConnectOnboardingComplete
    }
  }
}
    `;

/**
 * __useGetOrganizerLeagueMembersQuery__
 *
 * To run a query within a React component, call `useGetOrganizerLeagueMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizerLeagueMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizerLeagueMembersQuery({
 *   variables: {
 *      platformPublicId: // value for 'platformPublicId'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetOrganizerLeagueMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>(GetOrganizerLeagueMembersDocument, options);
      }
export function useGetOrganizerLeagueMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>(GetOrganizerLeagueMembersDocument, options);
        }
export function useGetOrganizerLeagueMembersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>(GetOrganizerLeagueMembersDocument, options);
        }
export type GetOrganizerLeagueMembersQueryHookResult = ReturnType<typeof useGetOrganizerLeagueMembersQuery>;
export type GetOrganizerLeagueMembersLazyQueryHookResult = ReturnType<typeof useGetOrganizerLeagueMembersLazyQuery>;
export type GetOrganizerLeagueMembersSuspenseQueryHookResult = ReturnType<typeof useGetOrganizerLeagueMembersSuspenseQuery>;
export type GetOrganizerLeagueMembersQueryResult = Apollo.QueryResult<GetOrganizerLeagueMembersQuery, GetOrganizerLeagueMembersQueryVariables>;
export function refetchGetOrganizerLeagueMembersQuery(variables?: GetOrganizerLeagueMembersQueryVariables) {
      return { query: GetOrganizerLeagueMembersDocument, variables: variables }
    }
export const GetAllLicensesDocument = gql`
    query getAllLicenses($filter: ListLicenseInput) {
  licenses(filter: $filter, isManagerOrDashboard: true) {
    ...license
    ...licenseWithQuestions
  }
}
    ${LicenseFragmentDoc}
${LicenseWithQuestionsFragmentDoc}`;

/**
 * __useGetAllLicensesQuery__
 *
 * To run a query within a React component, call `useGetAllLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllLicensesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAllLicensesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllLicensesQuery, GetAllLicensesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllLicensesQuery, GetAllLicensesQueryVariables>(GetAllLicensesDocument, options);
      }
export function useGetAllLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllLicensesQuery, GetAllLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllLicensesQuery, GetAllLicensesQueryVariables>(GetAllLicensesDocument, options);
        }
export function useGetAllLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllLicensesQuery, GetAllLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllLicensesQuery, GetAllLicensesQueryVariables>(GetAllLicensesDocument, options);
        }
export type GetAllLicensesQueryHookResult = ReturnType<typeof useGetAllLicensesQuery>;
export type GetAllLicensesLazyQueryHookResult = ReturnType<typeof useGetAllLicensesLazyQuery>;
export type GetAllLicensesSuspenseQueryHookResult = ReturnType<typeof useGetAllLicensesSuspenseQuery>;
export type GetAllLicensesQueryResult = Apollo.QueryResult<GetAllLicensesQuery, GetAllLicensesQueryVariables>;
export function refetchGetAllLicensesQuery(variables?: GetAllLicensesQueryVariables) {
      return { query: GetAllLicensesDocument, variables: variables }
    }
export const GetLicenseDocument = gql`
    query getLicense($id: Int!) {
  licenseById(id: $id) {
    ...license
    ...licenseWithSports
    ...licenseWithLicenseManager
    ...licenseWithLeagues
    ...licenseWithQuestions
    ...licenseWithFederation
  }
}
    ${LicenseFragmentDoc}
${LicenseWithSportsFragmentDoc}
${LicenseWithLicenseManagerFragmentDoc}
${LicenseWithLeaguesFragmentDoc}
${LicenseWithQuestionsFragmentDoc}
${LicenseWithFederationFragmentDoc}`;

/**
 * __useGetLicenseQuery__
 *
 * To run a query within a React component, call `useGetLicenseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicenseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicenseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLicenseQuery(baseOptions: Apollo.QueryHookOptions<GetLicenseQuery, GetLicenseQueryVariables> & ({ variables: GetLicenseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLicenseQuery, GetLicenseQueryVariables>(GetLicenseDocument, options);
      }
export function useGetLicenseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLicenseQuery, GetLicenseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLicenseQuery, GetLicenseQueryVariables>(GetLicenseDocument, options);
        }
export function useGetLicenseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLicenseQuery, GetLicenseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLicenseQuery, GetLicenseQueryVariables>(GetLicenseDocument, options);
        }
export type GetLicenseQueryHookResult = ReturnType<typeof useGetLicenseQuery>;
export type GetLicenseLazyQueryHookResult = ReturnType<typeof useGetLicenseLazyQuery>;
export type GetLicenseSuspenseQueryHookResult = ReturnType<typeof useGetLicenseSuspenseQuery>;
export type GetLicenseQueryResult = Apollo.QueryResult<GetLicenseQuery, GetLicenseQueryVariables>;
export function refetchGetLicenseQuery(variables: GetLicenseQueryVariables) {
      return { query: GetLicenseDocument, variables: variables }
    }
export const GetLicensesDocument = gql`
    query getLicenses($input: LicenseListInput!) {
  licenseList(input: $input) {
    licenses {
      ...license
      ...licenseWithIssuedCount
      ...licenseWithFederation
      ...licenseWithPlatforms
    }
    total
  }
}
    ${LicenseFragmentDoc}
${LicenseWithIssuedCountFragmentDoc}
${LicenseWithFederationFragmentDoc}
${LicenseWithPlatformsFragmentDoc}`;

/**
 * __useGetLicensesQuery__
 *
 * To run a query within a React component, call `useGetLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicensesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLicensesQuery(baseOptions: Apollo.QueryHookOptions<GetLicensesQuery, GetLicensesQueryVariables> & ({ variables: GetLicensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLicensesQuery, GetLicensesQueryVariables>(GetLicensesDocument, options);
      }
export function useGetLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLicensesQuery, GetLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLicensesQuery, GetLicensesQueryVariables>(GetLicensesDocument, options);
        }
export function useGetLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLicensesQuery, GetLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLicensesQuery, GetLicensesQueryVariables>(GetLicensesDocument, options);
        }
export type GetLicensesQueryHookResult = ReturnType<typeof useGetLicensesQuery>;
export type GetLicensesLazyQueryHookResult = ReturnType<typeof useGetLicensesLazyQuery>;
export type GetLicensesSuspenseQueryHookResult = ReturnType<typeof useGetLicensesSuspenseQuery>;
export type GetLicensesQueryResult = Apollo.QueryResult<GetLicensesQuery, GetLicensesQueryVariables>;
export function refetchGetLicensesQuery(variables: GetLicensesQueryVariables) {
      return { query: GetLicensesDocument, variables: variables }
    }
export const GetLicensesByIdsDocument = gql`
    query getLicensesByIds($ids: [Int!]!) {
  licensesByIds(ids: $ids) {
    ...license
  }
}
    ${LicenseFragmentDoc}`;

/**
 * __useGetLicensesByIdsQuery__
 *
 * To run a query within a React component, call `useGetLicensesByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLicensesByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLicensesByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetLicensesByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables> & ({ variables: GetLicensesByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>(GetLicensesByIdsDocument, options);
      }
export function useGetLicensesByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>(GetLicensesByIdsDocument, options);
        }
export function useGetLicensesByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>(GetLicensesByIdsDocument, options);
        }
export type GetLicensesByIdsQueryHookResult = ReturnType<typeof useGetLicensesByIdsQuery>;
export type GetLicensesByIdsLazyQueryHookResult = ReturnType<typeof useGetLicensesByIdsLazyQuery>;
export type GetLicensesByIdsSuspenseQueryHookResult = ReturnType<typeof useGetLicensesByIdsSuspenseQuery>;
export type GetLicensesByIdsQueryResult = Apollo.QueryResult<GetLicensesByIdsQuery, GetLicensesByIdsQueryVariables>;
export function refetchGetLicensesByIdsQuery(variables: GetLicensesByIdsQueryVariables) {
      return { query: GetLicensesByIdsDocument, variables: variables }
    }
export const SearchLicensesDocument = gql`
    query searchLicenses($input: LicenseListInput!) {
  licenseList(input: $input) {
    licenses {
      ...license
    }
    total
  }
}
    ${LicenseFragmentDoc}`;

/**
 * __useSearchLicensesQuery__
 *
 * To run a query within a React component, call `useSearchLicensesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLicensesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLicensesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchLicensesQuery(baseOptions: Apollo.QueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables> & ({ variables: SearchLicensesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
      }
export function useSearchLicensesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
        }
export function useSearchLicensesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchLicensesQuery, SearchLicensesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchLicensesQuery, SearchLicensesQueryVariables>(SearchLicensesDocument, options);
        }
export type SearchLicensesQueryHookResult = ReturnType<typeof useSearchLicensesQuery>;
export type SearchLicensesLazyQueryHookResult = ReturnType<typeof useSearchLicensesLazyQuery>;
export type SearchLicensesSuspenseQueryHookResult = ReturnType<typeof useSearchLicensesSuspenseQuery>;
export type SearchLicensesQueryResult = Apollo.QueryResult<SearchLicensesQuery, SearchLicensesQueryVariables>;
export function refetchSearchLicensesQuery(variables: SearchLicensesQueryVariables) {
      return { query: SearchLicensesDocument, variables: variables }
    }
export const GetNewsDocument = gql`
    query getNews($filter: ListNewsInput, $sortBy: String) {
  allNews(filter: $filter, sortBy: $sortBy) {
    news {
      ...news
      ...newsWithLeagues
    }
    total
  }
}
    ${NewsFragmentDoc}
${NewsWithLeaguesFragmentDoc}`;

/**
 * __useGetNewsQuery__
 *
 * To run a query within a React component, call `useGetNewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetNewsQuery(baseOptions?: Apollo.QueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
      }
export function useGetNewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
        }
export function useGetNewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewsQuery, GetNewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNewsQuery, GetNewsQueryVariables>(GetNewsDocument, options);
        }
export type GetNewsQueryHookResult = ReturnType<typeof useGetNewsQuery>;
export type GetNewsLazyQueryHookResult = ReturnType<typeof useGetNewsLazyQuery>;
export type GetNewsSuspenseQueryHookResult = ReturnType<typeof useGetNewsSuspenseQuery>;
export type GetNewsQueryResult = Apollo.QueryResult<GetNewsQuery, GetNewsQueryVariables>;
export function refetchGetNewsQuery(variables?: GetNewsQueryVariables) {
      return { query: GetNewsDocument, variables: variables }
    }
export const FindOrganizationDocument = gql`
    query findOrganization($filter: ListFederationInput!) {
  findFederation(filter: $filter) {
    ...federation
  }
}
    ${FederationFragmentDoc}`;

/**
 * __useFindOrganizationQuery__
 *
 * To run a query within a React component, call `useFindOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindOrganizationQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFindOrganizationQuery(baseOptions: Apollo.QueryHookOptions<FindOrganizationQuery, FindOrganizationQueryVariables> & ({ variables: FindOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindOrganizationQuery, FindOrganizationQueryVariables>(FindOrganizationDocument, options);
      }
export function useFindOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindOrganizationQuery, FindOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindOrganizationQuery, FindOrganizationQueryVariables>(FindOrganizationDocument, options);
        }
export function useFindOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindOrganizationQuery, FindOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindOrganizationQuery, FindOrganizationQueryVariables>(FindOrganizationDocument, options);
        }
export type FindOrganizationQueryHookResult = ReturnType<typeof useFindOrganizationQuery>;
export type FindOrganizationLazyQueryHookResult = ReturnType<typeof useFindOrganizationLazyQuery>;
export type FindOrganizationSuspenseQueryHookResult = ReturnType<typeof useFindOrganizationSuspenseQuery>;
export type FindOrganizationQueryResult = Apollo.QueryResult<FindOrganizationQuery, FindOrganizationQueryVariables>;
export function refetchFindOrganizationQuery(variables: FindOrganizationQueryVariables) {
      return { query: FindOrganizationDocument, variables: variables }
    }
export const GetFederationsByIdsDocument = gql`
    query getFederationsByIds($ids: [Int!]!) {
  federationsByIds(ids: $ids) {
    ...federation
  }
}
    ${FederationFragmentDoc}`;

/**
 * __useGetFederationsByIdsQuery__
 *
 * To run a query within a React component, call `useGetFederationsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFederationsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFederationsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetFederationsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables> & ({ variables: GetFederationsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>(GetFederationsByIdsDocument, options);
      }
export function useGetFederationsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>(GetFederationsByIdsDocument, options);
        }
export function useGetFederationsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>(GetFederationsByIdsDocument, options);
        }
export type GetFederationsByIdsQueryHookResult = ReturnType<typeof useGetFederationsByIdsQuery>;
export type GetFederationsByIdsLazyQueryHookResult = ReturnType<typeof useGetFederationsByIdsLazyQuery>;
export type GetFederationsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetFederationsByIdsSuspenseQuery>;
export type GetFederationsByIdsQueryResult = Apollo.QueryResult<GetFederationsByIdsQuery, GetFederationsByIdsQueryVariables>;
export function refetchGetFederationsByIdsQuery(variables: GetFederationsByIdsQueryVariables) {
      return { query: GetFederationsByIdsDocument, variables: variables }
    }
export const GetOrganizationDocument = gql`
    query getOrganization($id: Int!) {
  federation(id: $id) {
    ...federation
    ...federationWithManagers
    ...federationWithPlatformsWithFees
    ...federationWithFees
    ...federationWithBoardMembers
    ...federationWithClubMembers
    ...federationWithPaymentDetails
    ...federationWithLegalDetails
    ...federationWithDocuments
  }
}
    ${FederationFragmentDoc}
${FederationWithManagersFragmentDoc}
${FederationWithPlatformsWithFeesFragmentDoc}
${FederationWithFeesFragmentDoc}
${FederationWithBoardMembersFragmentDoc}
${FederationWithClubMembersFragmentDoc}
${FederationWithPaymentDetailsFragmentDoc}
${FederationWithLegalDetailsFragmentDoc}
${FederationWithDocumentsFragmentDoc}`;

/**
 * __useGetOrganizationQuery__
 *
 * To run a query within a React component, call `useGetOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOrganizationQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables> & ({ variables: GetOrganizationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
      }
export function useGetOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export function useGetOrganizationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrganizationQuery, GetOrganizationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationQuery, GetOrganizationQueryVariables>(GetOrganizationDocument, options);
        }
export type GetOrganizationQueryHookResult = ReturnType<typeof useGetOrganizationQuery>;
export type GetOrganizationLazyQueryHookResult = ReturnType<typeof useGetOrganizationLazyQuery>;
export type GetOrganizationSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationSuspenseQuery>;
export type GetOrganizationQueryResult = Apollo.QueryResult<GetOrganizationQuery, GetOrganizationQueryVariables>;
export function refetchGetOrganizationQuery(variables: GetOrganizationQueryVariables) {
      return { query: GetOrganizationDocument, variables: variables }
    }
export const GetPartnerDocument = gql`
    query getPartner($id: Int!) {
  partnerNew(id: $id) {
    ...partner
  }
}
    ${PartnerFragmentDoc}`;

/**
 * __useGetPartnerQuery__
 *
 * To run a query within a React component, call `useGetPartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPartnerQuery(baseOptions: Apollo.QueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables> & ({ variables: GetPartnerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
      }
export function useGetPartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
        }
export function useGetPartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnerQuery, GetPartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnerQuery, GetPartnerQueryVariables>(GetPartnerDocument, options);
        }
export type GetPartnerQueryHookResult = ReturnType<typeof useGetPartnerQuery>;
export type GetPartnerLazyQueryHookResult = ReturnType<typeof useGetPartnerLazyQuery>;
export type GetPartnerSuspenseQueryHookResult = ReturnType<typeof useGetPartnerSuspenseQuery>;
export type GetPartnerQueryResult = Apollo.QueryResult<GetPartnerQuery, GetPartnerQueryVariables>;
export function refetchGetPartnerQuery(variables: GetPartnerQueryVariables) {
      return { query: GetPartnerDocument, variables: variables }
    }
export const GetPartnersDocument = gql`
    query getPartners($filter: ListPartnerNewInput!) {
  partnersNew(filter: $filter) {
    ...partner
  }
}
    ${PartnerFragmentDoc}`;

/**
 * __useGetPartnersQuery__
 *
 * To run a query within a React component, call `useGetPartnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartnersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPartnersQuery(baseOptions: Apollo.QueryHookOptions<GetPartnersQuery, GetPartnersQueryVariables> & ({ variables: GetPartnersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartnersQuery, GetPartnersQueryVariables>(GetPartnersDocument, options);
      }
export function useGetPartnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartnersQuery, GetPartnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartnersQuery, GetPartnersQueryVariables>(GetPartnersDocument, options);
        }
export function useGetPartnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartnersQuery, GetPartnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartnersQuery, GetPartnersQueryVariables>(GetPartnersDocument, options);
        }
export type GetPartnersQueryHookResult = ReturnType<typeof useGetPartnersQuery>;
export type GetPartnersLazyQueryHookResult = ReturnType<typeof useGetPartnersLazyQuery>;
export type GetPartnersSuspenseQueryHookResult = ReturnType<typeof useGetPartnersSuspenseQuery>;
export type GetPartnersQueryResult = Apollo.QueryResult<GetPartnersQuery, GetPartnersQueryVariables>;
export function refetchGetPartnersQuery(variables: GetPartnersQueryVariables) {
      return { query: GetPartnersDocument, variables: variables }
    }
export const GetPlatformDocument = gql`
    query getPlatform($id: Int!) {
  platform(id: $id, isClient: false) {
    id
    title
    companyEmail
    darkLogo
    lightLogo
    lightEmblem
    darkEmblem
    favicon
    primaryColor
  }
}
    `;

/**
 * __useGetPlatformQuery__
 *
 * To run a query within a React component, call `useGetPlatformQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlatformQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformQuery, GetPlatformQueryVariables> & ({ variables: GetPlatformQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformQuery, GetPlatformQueryVariables>(GetPlatformDocument, options);
      }
export function useGetPlatformLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformQuery, GetPlatformQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformQuery, GetPlatformQueryVariables>(GetPlatformDocument, options);
        }
export function useGetPlatformSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformQuery, GetPlatformQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformQuery, GetPlatformQueryVariables>(GetPlatformDocument, options);
        }
export type GetPlatformQueryHookResult = ReturnType<typeof useGetPlatformQuery>;
export type GetPlatformLazyQueryHookResult = ReturnType<typeof useGetPlatformLazyQuery>;
export type GetPlatformSuspenseQueryHookResult = ReturnType<typeof useGetPlatformSuspenseQuery>;
export type GetPlatformQueryResult = Apollo.QueryResult<GetPlatformQuery, GetPlatformQueryVariables>;
export function refetchGetPlatformQuery(variables: GetPlatformQueryVariables) {
      return { query: GetPlatformDocument, variables: variables }
    }
export const GetPlatformWithDocumentsDocument = gql`
    query getPlatformWithDocuments($id: Int!) {
  platform(id: $id, isClient: false) {
    id
    title
    ...platformWithSubscriptionDocuments
  }
}
    ${PlatformWithSubscriptionDocumentsFragmentDoc}`;

/**
 * __useGetPlatformWithDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPlatformWithDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformWithDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformWithDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlatformWithDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables> & ({ variables: GetPlatformWithDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>(GetPlatformWithDocumentsDocument, options);
      }
export function useGetPlatformWithDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>(GetPlatformWithDocumentsDocument, options);
        }
export function useGetPlatformWithDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>(GetPlatformWithDocumentsDocument, options);
        }
export type GetPlatformWithDocumentsQueryHookResult = ReturnType<typeof useGetPlatformWithDocumentsQuery>;
export type GetPlatformWithDocumentsLazyQueryHookResult = ReturnType<typeof useGetPlatformWithDocumentsLazyQuery>;
export type GetPlatformWithDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformWithDocumentsSuspenseQuery>;
export type GetPlatformWithDocumentsQueryResult = Apollo.QueryResult<GetPlatformWithDocumentsQuery, GetPlatformWithDocumentsQueryVariables>;
export function refetchGetPlatformWithDocumentsQuery(variables: GetPlatformWithDocumentsQueryVariables) {
      return { query: GetPlatformWithDocumentsDocument, variables: variables }
    }
export const GetPlatformsByIdsDocument = gql`
    query getPlatformsByIds($ids: [Int!]!) {
  platformsByIds(ids: $ids) {
    ...basePlatform
  }
}
    ${BasePlatformFragmentDoc}`;

/**
 * __useGetPlatformsByIdsQuery__
 *
 * To run a query within a React component, call `useGetPlatformsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetPlatformsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables> & ({ variables: GetPlatformsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>(GetPlatformsByIdsDocument, options);
      }
export function useGetPlatformsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>(GetPlatformsByIdsDocument, options);
        }
export function useGetPlatformsByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>(GetPlatformsByIdsDocument, options);
        }
export type GetPlatformsByIdsQueryHookResult = ReturnType<typeof useGetPlatformsByIdsQuery>;
export type GetPlatformsByIdsLazyQueryHookResult = ReturnType<typeof useGetPlatformsByIdsLazyQuery>;
export type GetPlatformsByIdsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformsByIdsSuspenseQuery>;
export type GetPlatformsByIdsQueryResult = Apollo.QueryResult<GetPlatformsByIdsQuery, GetPlatformsByIdsQueryVariables>;
export function refetchGetPlatformsByIdsQuery(variables: GetPlatformsByIdsQueryVariables) {
      return { query: GetPlatformsByIdsDocument, variables: variables }
    }
export const SearchPlatformsDocument = gql`
    query searchPlatforms($page: Int, $limit: Int, $filter: ListPlatformInput) {
  platforms(page: $page, limit: $limit, filter: $filter) {
    platforms {
      ...basePlatform
    }
    total
  }
}
    ${BasePlatformFragmentDoc}`;

/**
 * __useSearchPlatformsQuery__
 *
 * To run a query within a React component, call `useSearchPlatformsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPlatformsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPlatformsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchPlatformsQuery(baseOptions?: Apollo.QueryHookOptions<SearchPlatformsQuery, SearchPlatformsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPlatformsQuery, SearchPlatformsQueryVariables>(SearchPlatformsDocument, options);
      }
export function useSearchPlatformsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPlatformsQuery, SearchPlatformsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPlatformsQuery, SearchPlatformsQueryVariables>(SearchPlatformsDocument, options);
        }
export function useSearchPlatformsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchPlatformsQuery, SearchPlatformsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchPlatformsQuery, SearchPlatformsQueryVariables>(SearchPlatformsDocument, options);
        }
export type SearchPlatformsQueryHookResult = ReturnType<typeof useSearchPlatformsQuery>;
export type SearchPlatformsLazyQueryHookResult = ReturnType<typeof useSearchPlatformsLazyQuery>;
export type SearchPlatformsSuspenseQueryHookResult = ReturnType<typeof useSearchPlatformsSuspenseQuery>;
export type SearchPlatformsQueryResult = Apollo.QueryResult<SearchPlatformsQuery, SearchPlatformsQueryVariables>;
export function refetchSearchPlatformsQuery(variables?: SearchPlatformsQueryVariables) {
      return { query: SearchPlatformsDocument, variables: variables }
    }
export const GetPlatformDocumentDocument = gql`
    query getPlatformDocument($id: Int!) {
  platformDocumentNew(id: $id) {
    ...platformDocument
  }
}
    ${PlatformDocumentFragmentDoc}`;

/**
 * __useGetPlatformDocumentQuery__
 *
 * To run a query within a React component, call `useGetPlatformDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlatformDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables> & ({ variables: GetPlatformDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>(GetPlatformDocumentDocument, options);
      }
export function useGetPlatformDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>(GetPlatformDocumentDocument, options);
        }
export function useGetPlatformDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>(GetPlatformDocumentDocument, options);
        }
export type GetPlatformDocumentQueryHookResult = ReturnType<typeof useGetPlatformDocumentQuery>;
export type GetPlatformDocumentLazyQueryHookResult = ReturnType<typeof useGetPlatformDocumentLazyQuery>;
export type GetPlatformDocumentSuspenseQueryHookResult = ReturnType<typeof useGetPlatformDocumentSuspenseQuery>;
export type GetPlatformDocumentQueryResult = Apollo.QueryResult<GetPlatformDocumentQuery, GetPlatformDocumentQueryVariables>;
export function refetchGetPlatformDocumentQuery(variables: GetPlatformDocumentQueryVariables) {
      return { query: GetPlatformDocumentDocument, variables: variables }
    }
export const GetPlatformDocumentsDocument = gql`
    query getPlatformDocuments($filter: ListPlatformDocumentsNewInput!) {
  platformDocumentsNew(filter: $filter) {
    ...platformDocument
  }
}
    ${PlatformDocumentFragmentDoc}`;

/**
 * __useGetPlatformDocumentsQuery__
 *
 * To run a query within a React component, call `useGetPlatformDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformDocumentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetPlatformDocumentsQuery(baseOptions: Apollo.QueryHookOptions<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables> & ({ variables: GetPlatformDocumentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>(GetPlatformDocumentsDocument, options);
      }
export function useGetPlatformDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>(GetPlatformDocumentsDocument, options);
        }
export function useGetPlatformDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>(GetPlatformDocumentsDocument, options);
        }
export type GetPlatformDocumentsQueryHookResult = ReturnType<typeof useGetPlatformDocumentsQuery>;
export type GetPlatformDocumentsLazyQueryHookResult = ReturnType<typeof useGetPlatformDocumentsLazyQuery>;
export type GetPlatformDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetPlatformDocumentsSuspenseQuery>;
export type GetPlatformDocumentsQueryResult = Apollo.QueryResult<GetPlatformDocumentsQuery, GetPlatformDocumentsQueryVariables>;
export function refetchGetPlatformDocumentsQuery(variables: GetPlatformDocumentsQueryVariables) {
      return { query: GetPlatformDocumentsDocument, variables: variables }
    }
export const PublicFileUrlsDocument = gql`
    query PublicFileUrls($ids: [String!]!) {
  publicFileUrls(ids: $ids) {
    id
    url
  }
}
    `;

/**
 * __usePublicFileUrlsQuery__
 *
 * To run a query within a React component, call `usePublicFileUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicFileUrlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicFileUrlsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function usePublicFileUrlsQuery(baseOptions: Apollo.QueryHookOptions<PublicFileUrlsQuery, PublicFileUrlsQueryVariables> & ({ variables: PublicFileUrlsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>(PublicFileUrlsDocument, options);
      }
export function usePublicFileUrlsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>(PublicFileUrlsDocument, options);
        }
export function usePublicFileUrlsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>(PublicFileUrlsDocument, options);
        }
export type PublicFileUrlsQueryHookResult = ReturnType<typeof usePublicFileUrlsQuery>;
export type PublicFileUrlsLazyQueryHookResult = ReturnType<typeof usePublicFileUrlsLazyQuery>;
export type PublicFileUrlsSuspenseQueryHookResult = ReturnType<typeof usePublicFileUrlsSuspenseQuery>;
export type PublicFileUrlsQueryResult = Apollo.QueryResult<PublicFileUrlsQuery, PublicFileUrlsQueryVariables>;
export function refetchPublicFileUrlsQuery(variables: PublicFileUrlsQueryVariables) {
      return { query: PublicFileUrlsDocument, variables: variables }
    }
export const GetLeagueRankingsCronCategoriesDocument = gql`
    query getLeagueRankingsCronCategories($leagueId: Int) {
  leagueRankingsCronCategories(leagueId: $leagueId) {
    leagueId
    rankingCategoryIds
    refreshRate
    updateEvery
    time
    customSchedule {
      date
      time
    }
  }
}
    `;

/**
 * __useGetLeagueRankingsCronCategoriesQuery__
 *
 * To run a query within a React component, call `useGetLeagueRankingsCronCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLeagueRankingsCronCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLeagueRankingsCronCategoriesQuery({
 *   variables: {
 *      leagueId: // value for 'leagueId'
 *   },
 * });
 */
export function useGetLeagueRankingsCronCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>(GetLeagueRankingsCronCategoriesDocument, options);
      }
export function useGetLeagueRankingsCronCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>(GetLeagueRankingsCronCategoriesDocument, options);
        }
export function useGetLeagueRankingsCronCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>(GetLeagueRankingsCronCategoriesDocument, options);
        }
export type GetLeagueRankingsCronCategoriesQueryHookResult = ReturnType<typeof useGetLeagueRankingsCronCategoriesQuery>;
export type GetLeagueRankingsCronCategoriesLazyQueryHookResult = ReturnType<typeof useGetLeagueRankingsCronCategoriesLazyQuery>;
export type GetLeagueRankingsCronCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetLeagueRankingsCronCategoriesSuspenseQuery>;
export type GetLeagueRankingsCronCategoriesQueryResult = Apollo.QueryResult<GetLeagueRankingsCronCategoriesQuery, GetLeagueRankingsCronCategoriesQueryVariables>;
export function refetchGetLeagueRankingsCronCategoriesQuery(variables?: GetLeagueRankingsCronCategoriesQueryVariables) {
      return { query: GetLeagueRankingsCronCategoriesDocument, variables: variables }
    }
export const SearchCoachesDocument = gql`
    query searchCoaches($input: PlatformCoachFilterInput) {
  platformCoaches(input: $input) {
    platformCoaches {
      ...platformCoach
    }
    total
  }
}
    ${PlatformCoachFragmentDoc}`;

/**
 * __useSearchCoachesQuery__
 *
 * To run a query within a React component, call `useSearchCoachesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCoachesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCoachesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchCoachesQuery(baseOptions: Apollo.QueryHookOptions<SearchCoachesQuery, SearchCoachesQueryVariables> & ({ variables: SearchCoachesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCoachesQuery, SearchCoachesQueryVariables>(SearchCoachesDocument, options);
      }
export function useSearchCoachesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCoachesQuery, SearchCoachesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCoachesQuery, SearchCoachesQueryVariables>(SearchCoachesDocument, options);
        }
export function useSearchCoachesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCoachesQuery, SearchCoachesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCoachesQuery, SearchCoachesQueryVariables>(SearchCoachesDocument, options);
        }
export type SearchCoachesQueryHookResult = ReturnType<typeof useSearchCoachesQuery>;
export type SearchCoachesLazyQueryHookResult = ReturnType<typeof useSearchCoachesLazyQuery>;
export type SearchCoachesSuspenseQueryHookResult = ReturnType<typeof useSearchCoachesSuspenseQuery>;
export type SearchCoachesQueryResult = Apollo.QueryResult<SearchCoachesQuery, SearchCoachesQueryVariables>;
export function refetchSearchCoachesQuery(variables: SearchCoachesQueryVariables) {
      return { query: SearchCoachesDocument, variables: variables }
    }
export const SearchSportsDocument = gql`
    query searchSports($input: SportListInput!) {
  sportList(input: $input) {
    sports {
      ...sport
    }
    total
  }
}
    ${SportFragmentDoc}`;

/**
 * __useSearchSportsQuery__
 *
 * To run a query within a React component, call `useSearchSportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSportsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchSportsQuery(baseOptions: Apollo.QueryHookOptions<SearchSportsQuery, SearchSportsQueryVariables> & ({ variables: SearchSportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSportsQuery, SearchSportsQueryVariables>(SearchSportsDocument, options);
      }
export function useSearchSportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSportsQuery, SearchSportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSportsQuery, SearchSportsQueryVariables>(SearchSportsDocument, options);
        }
export function useSearchSportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchSportsQuery, SearchSportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchSportsQuery, SearchSportsQueryVariables>(SearchSportsDocument, options);
        }
export type SearchSportsQueryHookResult = ReturnType<typeof useSearchSportsQuery>;
export type SearchSportsLazyQueryHookResult = ReturnType<typeof useSearchSportsLazyQuery>;
export type SearchSportsSuspenseQueryHookResult = ReturnType<typeof useSearchSportsSuspenseQuery>;
export type SearchSportsQueryResult = Apollo.QueryResult<SearchSportsQuery, SearchSportsQueryVariables>;
export function refetchSearchSportsQuery(variables: SearchSportsQueryVariables) {
      return { query: SearchSportsDocument, variables: variables }
    }
export const GetDashboardPaymentStatsDocument = gql`
    query getDashboardPaymentStats($platform: Int, $federationId: Int, $startDate: String, $endDate: String, $currency: String) {
  allStatsTransactionData(
    platform: $platform
    federationId: $federationId
    endDate: $endDate
    startDate: $startDate
    currency: $currency
  )
}
    `;

/**
 * __useGetDashboardPaymentStatsQuery__
 *
 * To run a query within a React component, call `useGetDashboardPaymentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardPaymentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardPaymentStatsQuery({
 *   variables: {
 *      platform: // value for 'platform'
 *      federationId: // value for 'federationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetDashboardPaymentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>(GetDashboardPaymentStatsDocument, options);
      }
export function useGetDashboardPaymentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>(GetDashboardPaymentStatsDocument, options);
        }
export function useGetDashboardPaymentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>(GetDashboardPaymentStatsDocument, options);
        }
export type GetDashboardPaymentStatsQueryHookResult = ReturnType<typeof useGetDashboardPaymentStatsQuery>;
export type GetDashboardPaymentStatsLazyQueryHookResult = ReturnType<typeof useGetDashboardPaymentStatsLazyQuery>;
export type GetDashboardPaymentStatsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardPaymentStatsSuspenseQuery>;
export type GetDashboardPaymentStatsQueryResult = Apollo.QueryResult<GetDashboardPaymentStatsQuery, GetDashboardPaymentStatsQueryVariables>;
export function refetchGetDashboardPaymentStatsQuery(variables?: GetDashboardPaymentStatsQueryVariables) {
      return { query: GetDashboardPaymentStatsDocument, variables: variables }
    }
export const GetDashboardStatsDocument = gql`
    query getDashboardStats($date: String, $platform: Int, $federationId: Int, $startDate: String, $endDate: String) {
  allStatsData(
    date: $date
    platform: $platform
    federationId: $federationId
    endDate: $endDate
    startDate: $startDate
  )
}
    `;

/**
 * __useGetDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardStatsQuery({
 *   variables: {
 *      date: // value for 'date'
 *      platform: // value for 'platform'
 *      federationId: // value for 'federationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetDashboardStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
      }
export function useGetDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
        }
export function useGetDashboardStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>(GetDashboardStatsDocument, options);
        }
export type GetDashboardStatsQueryHookResult = ReturnType<typeof useGetDashboardStatsQuery>;
export type GetDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetDashboardStatsLazyQuery>;
export type GetDashboardStatsSuspenseQueryHookResult = ReturnType<typeof useGetDashboardStatsSuspenseQuery>;
export type GetDashboardStatsQueryResult = Apollo.QueryResult<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>;
export function refetchGetDashboardStatsQuery(variables?: GetDashboardStatsQueryVariables) {
      return { query: GetDashboardStatsDocument, variables: variables }
    }
export const GetTeamLeaguesDocument = gql`
    query getTeamLeagues($teamId: Int!) {
  fetchLeaguesByTeamId(teamId: $teamId) {
    ...league
    ...leagueWithOwner
  }
}
    ${LeagueFragmentDoc}
${LeagueWithOwnerFragmentDoc}`;

/**
 * __useGetTeamLeaguesQuery__
 *
 * To run a query within a React component, call `useGetTeamLeaguesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamLeaguesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamLeaguesQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useGetTeamLeaguesQuery(baseOptions: Apollo.QueryHookOptions<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables> & ({ variables: GetTeamLeaguesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>(GetTeamLeaguesDocument, options);
      }
export function useGetTeamLeaguesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>(GetTeamLeaguesDocument, options);
        }
export function useGetTeamLeaguesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>(GetTeamLeaguesDocument, options);
        }
export type GetTeamLeaguesQueryHookResult = ReturnType<typeof useGetTeamLeaguesQuery>;
export type GetTeamLeaguesLazyQueryHookResult = ReturnType<typeof useGetTeamLeaguesLazyQuery>;
export type GetTeamLeaguesSuspenseQueryHookResult = ReturnType<typeof useGetTeamLeaguesSuspenseQuery>;
export type GetTeamLeaguesQueryResult = Apollo.QueryResult<GetTeamLeaguesQuery, GetTeamLeaguesQueryVariables>;
export function refetchGetTeamLeaguesQuery(variables: GetTeamLeaguesQueryVariables) {
      return { query: GetTeamLeaguesDocument, variables: variables }
    }
export const GetTeamTournamentsDocument = gql`
    query getTeamTournaments($teamId: Int!, $relations: [String!]) {
  fetchTournamentsByTeamId(teamId: $teamId, relations: $relations) {
    ...tournament
    ...tournamentWithSports
    ...tournamentWithOrganizer
    ...tournamentWithCreatedBy
    ...tournamentWithLeague
    ...tournamentWithVenues
    ...tournamentWithCategories
  }
}
    ${TournamentFragmentDoc}
${TournamentWithSportsFragmentDoc}
${TournamentWithOrganizerFragmentDoc}
${TournamentWithCreatedByFragmentDoc}
${TournamentWithLeagueFragmentDoc}
${TournamentWithVenuesFragmentDoc}
${TournamentWithCategoriesFragmentDoc}`;

/**
 * __useGetTeamTournamentsQuery__
 *
 * To run a query within a React component, call `useGetTeamTournamentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamTournamentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamTournamentsQuery({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      relations: // value for 'relations'
 *   },
 * });
 */
export function useGetTeamTournamentsQuery(baseOptions: Apollo.QueryHookOptions<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables> & ({ variables: GetTeamTournamentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>(GetTeamTournamentsDocument, options);
      }
export function useGetTeamTournamentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>(GetTeamTournamentsDocument, options);
        }
export function useGetTeamTournamentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>(GetTeamTournamentsDocument, options);
        }
export type GetTeamTournamentsQueryHookResult = ReturnType<typeof useGetTeamTournamentsQuery>;
export type GetTeamTournamentsLazyQueryHookResult = ReturnType<typeof useGetTeamTournamentsLazyQuery>;
export type GetTeamTournamentsSuspenseQueryHookResult = ReturnType<typeof useGetTeamTournamentsSuspenseQuery>;
export type GetTeamTournamentsQueryResult = Apollo.QueryResult<GetTeamTournamentsQuery, GetTeamTournamentsQueryVariables>;
export function refetchGetTeamTournamentsQuery(variables: GetTeamTournamentsQueryVariables) {
      return { query: GetTeamTournamentsDocument, variables: variables }
    }
export const GetTournamentCategoriesDocument = gql`
    query GetTournamentCategories($federation: Int, $federationPublicId: String, $filter: ListTournamentCategoryInput, $orderField: String) {
  tournamentCategories(
    federation: $federation
    federationPublicId: $federationPublicId
    filter: $filter
    orderField: $orderField
  ) {
    ...tournamentCategory
    ...tournamentCategoryWithLeague
    ...tournamentCategoryWithDiscipline
  }
}
    ${TournamentCategoryFragmentDoc}
${TournamentCategoryWithLeagueFragmentDoc}
${TournamentCategoryWithDisciplineFragmentDoc}`;

/**
 * __useGetTournamentCategoriesQuery__
 *
 * To run a query within a React component, call `useGetTournamentCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentCategoriesQuery({
 *   variables: {
 *      federation: // value for 'federation'
 *      federationPublicId: // value for 'federationPublicId'
 *      filter: // value for 'filter'
 *      orderField: // value for 'orderField'
 *   },
 * });
 */
export function useGetTournamentCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>(GetTournamentCategoriesDocument, options);
      }
export function useGetTournamentCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>(GetTournamentCategoriesDocument, options);
        }
export function useGetTournamentCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>(GetTournamentCategoriesDocument, options);
        }
export type GetTournamentCategoriesQueryHookResult = ReturnType<typeof useGetTournamentCategoriesQuery>;
export type GetTournamentCategoriesLazyQueryHookResult = ReturnType<typeof useGetTournamentCategoriesLazyQuery>;
export type GetTournamentCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetTournamentCategoriesSuspenseQuery>;
export type GetTournamentCategoriesQueryResult = Apollo.QueryResult<GetTournamentCategoriesQuery, GetTournamentCategoriesQueryVariables>;
export function refetchGetTournamentCategoriesQuery(variables?: GetTournamentCategoriesQueryVariables) {
      return { query: GetTournamentCategoriesDocument, variables: variables }
    }
export const GetRankingCategoryPointTypesDocument = gql`
    query getRankingCategoryPointTypes {
  rankingCategoryPointTypes {
    id
    name
    bracketType
  }
}
    `;

/**
 * __useGetRankingCategoryPointTypesQuery__
 *
 * To run a query within a React component, call `useGetRankingCategoryPointTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRankingCategoryPointTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRankingCategoryPointTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRankingCategoryPointTypesQuery(baseOptions?: Apollo.QueryHookOptions<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>(GetRankingCategoryPointTypesDocument, options);
      }
export function useGetRankingCategoryPointTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>(GetRankingCategoryPointTypesDocument, options);
        }
export function useGetRankingCategoryPointTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>(GetRankingCategoryPointTypesDocument, options);
        }
export type GetRankingCategoryPointTypesQueryHookResult = ReturnType<typeof useGetRankingCategoryPointTypesQuery>;
export type GetRankingCategoryPointTypesLazyQueryHookResult = ReturnType<typeof useGetRankingCategoryPointTypesLazyQuery>;
export type GetRankingCategoryPointTypesSuspenseQueryHookResult = ReturnType<typeof useGetRankingCategoryPointTypesSuspenseQuery>;
export type GetRankingCategoryPointTypesQueryResult = Apollo.QueryResult<GetRankingCategoryPointTypesQuery, GetRankingCategoryPointTypesQueryVariables>;
export function refetchGetRankingCategoryPointTypesQuery(variables?: GetRankingCategoryPointTypesQueryVariables) {
      return { query: GetRankingCategoryPointTypesDocument, variables: variables }
    }
export const GetTournamentRankingsDocument = gql`
    query getTournamentRankings($page: Int, $limit: Int, $filter: ListTournamentRankingInput!, $tournamentName: String) {
  tournamentRankings(
    page: $page
    limit: $limit
    filter: $filter
    tournamentName: $tournamentName
  ) {
    tournamentRankings {
      ...tournamentRanking
    }
    total
  }
}
    ${TournamentRankingFragmentDoc}`;

/**
 * __useGetTournamentRankingsQuery__
 *
 * To run a query within a React component, call `useGetTournamentRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentRankingsQuery({
 *   variables: {
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      tournamentName: // value for 'tournamentName'
 *   },
 * });
 */
export function useGetTournamentRankingsQuery(baseOptions: Apollo.QueryHookOptions<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables> & ({ variables: GetTournamentRankingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>(GetTournamentRankingsDocument, options);
      }
export function useGetTournamentRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>(GetTournamentRankingsDocument, options);
        }
export function useGetTournamentRankingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>(GetTournamentRankingsDocument, options);
        }
export type GetTournamentRankingsQueryHookResult = ReturnType<typeof useGetTournamentRankingsQuery>;
export type GetTournamentRankingsLazyQueryHookResult = ReturnType<typeof useGetTournamentRankingsLazyQuery>;
export type GetTournamentRankingsSuspenseQueryHookResult = ReturnType<typeof useGetTournamentRankingsSuspenseQuery>;
export type GetTournamentRankingsQueryResult = Apollo.QueryResult<GetTournamentRankingsQuery, GetTournamentRankingsQueryVariables>;
export function refetchGetTournamentRankingsQuery(variables: GetTournamentRankingsQueryVariables) {
      return { query: GetTournamentRankingsDocument, variables: variables }
    }
export const GetTournamentStatsDocument = gql`
    query getTournamentStats($federationId: Float, $filter: ListLeagueInput) {
  stats(federationId: $federationId, filter: $filter) {
    ...tournamentStats
  }
}
    ${TournamentStatsFragmentDoc}`;

/**
 * __useGetTournamentStatsQuery__
 *
 * To run a query within a React component, call `useGetTournamentStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTournamentStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTournamentStatsQuery({
 *   variables: {
 *      federationId: // value for 'federationId'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTournamentStatsQuery(baseOptions?: Apollo.QueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
      }
export function useGetTournamentStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
        }
export function useGetTournamentStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>(GetTournamentStatsDocument, options);
        }
export type GetTournamentStatsQueryHookResult = ReturnType<typeof useGetTournamentStatsQuery>;
export type GetTournamentStatsLazyQueryHookResult = ReturnType<typeof useGetTournamentStatsLazyQuery>;
export type GetTournamentStatsSuspenseQueryHookResult = ReturnType<typeof useGetTournamentStatsSuspenseQuery>;
export type GetTournamentStatsQueryResult = Apollo.QueryResult<GetTournamentStatsQuery, GetTournamentStatsQueryVariables>;
export function refetchGetTournamentStatsQuery(variables?: GetTournamentStatsQueryVariables) {
      return { query: GetTournamentStatsDocument, variables: variables }
    }
export const GetAllUsersDocument = gql`
    query getAllUsers {
  users {
    users {
      ...baseDetailedUser
    }
    total
  }
}
    ${BaseDetailedUserFragmentDoc}`;

/**
 * __useGetAllUsersQuery__
 *
 * To run a query within a React component, call `useGetAllUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
      }
export function useGetAllUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export function useGetAllUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllUsersQuery, GetAllUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllUsersQuery, GetAllUsersQueryVariables>(GetAllUsersDocument, options);
        }
export type GetAllUsersQueryHookResult = ReturnType<typeof useGetAllUsersQuery>;
export type GetAllUsersLazyQueryHookResult = ReturnType<typeof useGetAllUsersLazyQuery>;
export type GetAllUsersSuspenseQueryHookResult = ReturnType<typeof useGetAllUsersSuspenseQuery>;
export type GetAllUsersQueryResult = Apollo.QueryResult<GetAllUsersQuery, GetAllUsersQueryVariables>;
export function refetchGetAllUsersQuery(variables?: GetAllUsersQueryVariables) {
      return { query: GetAllUsersDocument, variables: variables }
    }
export const GetPlatformUsersDocument = gql`
    query getPlatformUsers($filter: ListUsersInput, $page: Int, $limit: Int, $platformId: Float) {
  platformSpecificUsers(
    page: $page
    limit: $limit
    filter: $filter
    platformId: $platformId
  ) {
    users {
      ...baseDetailedUser
    }
    total
  }
}
    ${BaseDetailedUserFragmentDoc}`;

/**
 * __useGetPlatformUsersQuery__
 *
 * To run a query within a React component, call `useGetPlatformUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlatformUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlatformUsersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      platformId: // value for 'platformId'
 *   },
 * });
 */
export function useGetPlatformUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>(GetPlatformUsersDocument, options);
      }
export function useGetPlatformUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>(GetPlatformUsersDocument, options);
        }
export function useGetPlatformUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>(GetPlatformUsersDocument, options);
        }
export type GetPlatformUsersQueryHookResult = ReturnType<typeof useGetPlatformUsersQuery>;
export type GetPlatformUsersLazyQueryHookResult = ReturnType<typeof useGetPlatformUsersLazyQuery>;
export type GetPlatformUsersSuspenseQueryHookResult = ReturnType<typeof useGetPlatformUsersSuspenseQuery>;
export type GetPlatformUsersQueryResult = Apollo.QueryResult<GetPlatformUsersQuery, GetPlatformUsersQueryVariables>;
export function refetchGetPlatformUsersQuery(variables?: GetPlatformUsersQueryVariables) {
      return { query: GetPlatformUsersDocument, variables: variables }
    }
export const GetUserDocument = gql`
    query getUser($query: FindUserInput!, $searchInWprDB: Boolean) {
  user(query: $query, searchInWprDB: $searchInWprDB) {
    ...baseDetailedUser
  }
}
    ${BaseDetailedUserFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      query: // value for 'query'
 *      searchInWprDB: // value for 'searchInWprDB'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export function refetchGetUserQuery(variables: GetUserQueryVariables) {
      return { query: GetUserDocument, variables: variables }
    }
export const GetUserPlatformRoleDocument = gql`
    query getUserPlatformRole($platformPublicId: String) {
  userRole(platformPublicId: $platformPublicId)
}
    `;

/**
 * __useGetUserPlatformRoleQuery__
 *
 * To run a query within a React component, call `useGetUserPlatformRoleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPlatformRoleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPlatformRoleQuery({
 *   variables: {
 *      platformPublicId: // value for 'platformPublicId'
 *   },
 * });
 */
export function useGetUserPlatformRoleQuery(baseOptions?: Apollo.QueryHookOptions<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>(GetUserPlatformRoleDocument, options);
      }
export function useGetUserPlatformRoleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>(GetUserPlatformRoleDocument, options);
        }
export function useGetUserPlatformRoleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>(GetUserPlatformRoleDocument, options);
        }
export type GetUserPlatformRoleQueryHookResult = ReturnType<typeof useGetUserPlatformRoleQuery>;
export type GetUserPlatformRoleLazyQueryHookResult = ReturnType<typeof useGetUserPlatformRoleLazyQuery>;
export type GetUserPlatformRoleSuspenseQueryHookResult = ReturnType<typeof useGetUserPlatformRoleSuspenseQuery>;
export type GetUserPlatformRoleQueryResult = Apollo.QueryResult<GetUserPlatformRoleQuery, GetUserPlatformRoleQueryVariables>;
export function refetchGetUserPlatformRoleQuery(variables?: GetUserPlatformRoleQueryVariables) {
      return { query: GetUserPlatformRoleDocument, variables: variables }
    }
export const GetUserRolesDocument = gql`
    query getUserRoles {
  userRoles {
    id
    name
  }
}
    `;

/**
 * __useGetUserRolesQuery__
 *
 * To run a query within a React component, call `useGetUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
      }
export function useGetUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export function useGetUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserRolesQuery, GetUserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserRolesQuery, GetUserRolesQueryVariables>(GetUserRolesDocument, options);
        }
export type GetUserRolesQueryHookResult = ReturnType<typeof useGetUserRolesQuery>;
export type GetUserRolesLazyQueryHookResult = ReturnType<typeof useGetUserRolesLazyQuery>;
export type GetUserRolesSuspenseQueryHookResult = ReturnType<typeof useGetUserRolesSuspenseQuery>;
export type GetUserRolesQueryResult = Apollo.QueryResult<GetUserRolesQuery, GetUserRolesQueryVariables>;
export function refetchGetUserRolesQuery(variables?: GetUserRolesQueryVariables) {
      return { query: GetUserRolesDocument, variables: variables }
    }
export const GetUsersByIdsDocument = gql`
    query getUsersByIds($ids: [Int!]!) {
  usersByIds(ids: $ids) {
    ...baseUser
  }
}
    ${BaseUserFragmentDoc}`;

/**
 * __useGetUsersByIdsQuery__
 *
 * To run a query within a React component, call `useGetUsersByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetUsersByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables> & ({ variables: GetUsersByIdsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
      }
export function useGetUsersByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
        }
export function useGetUsersByIdsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>(GetUsersByIdsDocument, options);
        }
export type GetUsersByIdsQueryHookResult = ReturnType<typeof useGetUsersByIdsQuery>;
export type GetUsersByIdsLazyQueryHookResult = ReturnType<typeof useGetUsersByIdsLazyQuery>;
export type GetUsersByIdsSuspenseQueryHookResult = ReturnType<typeof useGetUsersByIdsSuspenseQuery>;
export type GetUsersByIdsQueryResult = Apollo.QueryResult<GetUsersByIdsQuery, GetUsersByIdsQueryVariables>;
export function refetchGetUsersByIdsQuery(variables: GetUsersByIdsQueryVariables) {
      return { query: GetUsersByIdsDocument, variables: variables }
    }
export const GetUsersOldDocument = gql`
    query getUsersOld($filter: ListUsersInput, $page: Int, $limit: Int, $showDetailedInfo: Boolean) {
  users(
    page: $page
    limit: $limit
    filter: $filter
    showDetailedInfo: $showDetailedInfo
  ) {
    users {
      ...baseDetailedUser
      ...detailedUserWithSports
      ...detailedUserWithPlatforms
    }
    total
  }
}
    ${BaseDetailedUserFragmentDoc}
${DetailedUserWithSportsFragmentDoc}
${DetailedUserWithPlatformsFragmentDoc}`;

/**
 * __useGetUsersOldQuery__
 *
 * To run a query within a React component, call `useGetUsersOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersOldQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *      limit: // value for 'limit'
 *      showDetailedInfo: // value for 'showDetailedInfo'
 *   },
 * });
 */
export function useGetUsersOldQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersOldQuery, GetUsersOldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersOldQuery, GetUsersOldQueryVariables>(GetUsersOldDocument, options);
      }
export function useGetUsersOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersOldQuery, GetUsersOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersOldQuery, GetUsersOldQueryVariables>(GetUsersOldDocument, options);
        }
export function useGetUsersOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersOldQuery, GetUsersOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersOldQuery, GetUsersOldQueryVariables>(GetUsersOldDocument, options);
        }
export type GetUsersOldQueryHookResult = ReturnType<typeof useGetUsersOldQuery>;
export type GetUsersOldLazyQueryHookResult = ReturnType<typeof useGetUsersOldLazyQuery>;
export type GetUsersOldSuspenseQueryHookResult = ReturnType<typeof useGetUsersOldSuspenseQuery>;
export type GetUsersOldQueryResult = Apollo.QueryResult<GetUsersOldQuery, GetUsersOldQueryVariables>;
export function refetchGetUsersOldQuery(variables?: GetUsersOldQueryVariables) {
      return { query: GetUsersOldDocument, variables: variables }
    }
export const VideoMetadataDocument = gql`
    query VideoMetadata($url: String!) {
  videoMetadata(url: $url) {
    videoId
    title
    durationSeconds
    thumbnailUrl
    publishedAt
  }
}
    `;

/**
 * __useVideoMetadataQuery__
 *
 * To run a query within a React component, call `useVideoMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useVideoMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVideoMetadataQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useVideoMetadataQuery(baseOptions: Apollo.QueryHookOptions<VideoMetadataQuery, VideoMetadataQueryVariables> & ({ variables: VideoMetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VideoMetadataQuery, VideoMetadataQueryVariables>(VideoMetadataDocument, options);
      }
export function useVideoMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VideoMetadataQuery, VideoMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VideoMetadataQuery, VideoMetadataQueryVariables>(VideoMetadataDocument, options);
        }
export function useVideoMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VideoMetadataQuery, VideoMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VideoMetadataQuery, VideoMetadataQueryVariables>(VideoMetadataDocument, options);
        }
export type VideoMetadataQueryHookResult = ReturnType<typeof useVideoMetadataQuery>;
export type VideoMetadataLazyQueryHookResult = ReturnType<typeof useVideoMetadataLazyQuery>;
export type VideoMetadataSuspenseQueryHookResult = ReturnType<typeof useVideoMetadataSuspenseQuery>;
export type VideoMetadataQueryResult = Apollo.QueryResult<VideoMetadataQuery, VideoMetadataQueryVariables>;
export function refetchVideoMetadataQuery(variables: VideoMetadataQueryVariables) {
      return { query: VideoMetadataDocument, variables: variables }
    }
